/* eslint-disable */

export const iconsDb = [
  {
    id: "lucide:AArrowDown", 
    tags: ["lucide", "arrow", "down"], 
    source: "lucide", 
    name: "AArrowDown",
  }, 
  {
    id: "lucide:AArrowUp", 
    tags: ["lucide", "arrow", "up"], 
    source: "lucide", 
    name: "AArrowUp",
  }, 
  {
    id: "lucide:ALargeSmall", 
    tags: ["lucide", "large", "small"], 
    source: "lucide", 
    name: "ALargeSmall",
  }, 
  {
    id: "lucide:Accessibility", 
    tags: ["lucide", "accessibility"], 
    source: "lucide", 
    name: "Accessibility",
  }, 
  {
    id: "lucide:Activity", 
    tags: ["lucide", "activity"], 
    source: "lucide", 
    name: "Activity",
  }, 
  {
    id: "lucide:ActivitySquare", 
    tags: ["lucide", "activity", "square"], 
    source: "lucide", 
    name: "ActivitySquare",
  }, 
  {
    id: "lucide:AirVent", 
    tags: ["lucide", "air", "vent"], 
    source: "lucide", 
    name: "AirVent",
  }, 
  {
    id: "lucide:Airplay", 
    tags: ["lucide", "airplay"], 
    source: "lucide", 
    name: "Airplay",
  }, 
  {
    id: "lucide:AlarmCheck", 
    tags: ["lucide", "alarm", "check"], 
    source: "lucide", 
    name: "AlarmCheck",
  }, 
  {
    id: "lucide:AlarmClock", 
    tags: ["lucide", "alarm", "clock"], 
    source: "lucide", 
    name: "AlarmClock",
  }, 
  {
    id: "lucide:AlarmClockCheck", 
    tags: ["lucide", "alarm", "clock", "check"], 
    source: "lucide", 
    name: "AlarmClockCheck",
  }, 
  {
    id: "lucide:AlarmClockMinus", 
    tags: ["lucide", "alarm", "clock", "minus"], 
    source: "lucide", 
    name: "AlarmClockMinus",
  }, 
  {
    id: "lucide:AlarmClockOff", 
    tags: ["lucide", "alarm", "clock", "off"], 
    source: "lucide", 
    name: "AlarmClockOff",
  }, 
  {
    id: "lucide:AlarmClockPlus", 
    tags: ["lucide", "alarm", "clock", "plus"], 
    source: "lucide", 
    name: "AlarmClockPlus",
  }, 
  {
    id: "lucide:AlarmMinus", 
    tags: ["lucide", "alarm", "minus"], 
    source: "lucide", 
    name: "AlarmMinus",
  }, 
  {
    id: "lucide:AlarmPlus", 
    tags: ["lucide", "alarm", "plus"], 
    source: "lucide", 
    name: "AlarmPlus",
  }, 
  {
    id: "lucide:AlarmSmoke", 
    tags: ["lucide", "alarm", "smoke"], 
    source: "lucide", 
    name: "AlarmSmoke",
  }, 
  {
    id: "lucide:Album", 
    tags: ["lucide", "album"], 
    source: "lucide", 
    name: "Album",
  }, 
  {
    id: "lucide:AlertCircle", 
    tags: ["lucide", "alert", "circle"], 
    source: "lucide", 
    name: "AlertCircle",
  }, 
  {
    id: "lucide:AlertOctagon", 
    tags: ["lucide", "alert", "octagon"], 
    source: "lucide", 
    name: "AlertOctagon",
  }, 
  {
    id: "lucide:AlertTriangle", 
    tags: ["lucide", "alert", "triangle"], 
    source: "lucide", 
    name: "AlertTriangle",
  }, 
  {
    id: "lucide:AlignCenter", 
    tags: ["lucide", "align", "center"], 
    source: "lucide", 
    name: "AlignCenter",
  }, 
  {
    id: "lucide:AlignCenterHorizontal", 
    tags: ["lucide", "align", "center", "horizontal"], 
    source: "lucide", 
    name: "AlignCenterHorizontal",
  }, 
  {
    id: "lucide:AlignCenterVertical", 
    tags: ["lucide", "align", "center", "vertical"], 
    source: "lucide", 
    name: "AlignCenterVertical",
  }, 
  {
    id: "lucide:AlignEndHorizontal", 
    tags: ["lucide", "align", "end", "horizontal"], 
    source: "lucide", 
    name: "AlignEndHorizontal",
  }, 
  {
    id: "lucide:AlignEndVertical", 
    tags: ["lucide", "align", "end", "vertical"], 
    source: "lucide", 
    name: "AlignEndVertical",
  }, 
  {
    id: "lucide:AlignHorizontalDistributeCenter", 
    tags: ["lucide", "align", "horizontal", "distribute", "center"], 
    source: "lucide", 
    name: "AlignHorizontalDistributeCenter",
  }, 
  {
    id: "lucide:AlignHorizontalDistributeEnd", 
    tags: ["lucide", "align", "horizontal", "distribute", "end"], 
    source: "lucide", 
    name: "AlignHorizontalDistributeEnd",
  }, 
  {
    id: "lucide:AlignHorizontalDistributeStart", 
    tags: ["lucide", "align", "horizontal", "distribute", "start"], 
    source: "lucide", 
    name: "AlignHorizontalDistributeStart",
  }, 
  {
    id: "lucide:AlignHorizontalJustifyCenter", 
    tags: ["lucide", "align", "horizontal", "justify", "center"], 
    source: "lucide", 
    name: "AlignHorizontalJustifyCenter",
  }, 
  {
    id: "lucide:AlignHorizontalJustifyEnd", 
    tags: ["lucide", "align", "horizontal", "justify", "end"], 
    source: "lucide", 
    name: "AlignHorizontalJustifyEnd",
  }, 
  {
    id: "lucide:AlignHorizontalJustifyStart", 
    tags: ["lucide", "align", "horizontal", "justify", "start"], 
    source: "lucide", 
    name: "AlignHorizontalJustifyStart",
  }, 
  {
    id: "lucide:AlignHorizontalSpaceAround", 
    tags: ["lucide", "align", "horizontal", "space", "around"], 
    source: "lucide", 
    name: "AlignHorizontalSpaceAround",
  }, 
  {
    id: "lucide:AlignHorizontalSpaceBetween", 
    tags: ["lucide", "align", "horizontal", "space", "between"], 
    source: "lucide", 
    name: "AlignHorizontalSpaceBetween",
  }, 
  {
    id: "lucide:AlignJustify", 
    tags: ["lucide", "align", "justify"], 
    source: "lucide", 
    name: "AlignJustify",
  }, 
  {
    id: "lucide:AlignLeft", 
    tags: ["lucide", "align", "left"], 
    source: "lucide", 
    name: "AlignLeft",
  }, 
  {
    id: "lucide:AlignRight", 
    tags: ["lucide", "align", "right"], 
    source: "lucide", 
    name: "AlignRight",
  }, 
  {
    id: "lucide:AlignStartHorizontal", 
    tags: ["lucide", "align", "start", "horizontal"], 
    source: "lucide", 
    name: "AlignStartHorizontal",
  }, 
  {
    id: "lucide:AlignStartVertical", 
    tags: ["lucide", "align", "start", "vertical"], 
    source: "lucide", 
    name: "AlignStartVertical",
  }, 
  {
    id: "lucide:AlignVerticalDistributeCenter", 
    tags: ["lucide", "align", "vertical", "distribute", "center"], 
    source: "lucide", 
    name: "AlignVerticalDistributeCenter",
  }, 
  {
    id: "lucide:AlignVerticalDistributeEnd", 
    tags: ["lucide", "align", "vertical", "distribute", "end"], 
    source: "lucide", 
    name: "AlignVerticalDistributeEnd",
  }, 
  {
    id: "lucide:AlignVerticalDistributeStart", 
    tags: ["lucide", "align", "vertical", "distribute", "start"], 
    source: "lucide", 
    name: "AlignVerticalDistributeStart",
  }, 
  {
    id: "lucide:AlignVerticalJustifyCenter", 
    tags: ["lucide", "align", "vertical", "justify", "center"], 
    source: "lucide", 
    name: "AlignVerticalJustifyCenter",
  }, 
  {
    id: "lucide:AlignVerticalJustifyEnd", 
    tags: ["lucide", "align", "vertical", "justify", "end"], 
    source: "lucide", 
    name: "AlignVerticalJustifyEnd",
  }, 
  {
    id: "lucide:AlignVerticalJustifyStart", 
    tags: ["lucide", "align", "vertical", "justify", "start"], 
    source: "lucide", 
    name: "AlignVerticalJustifyStart",
  }, 
  {
    id: "lucide:AlignVerticalSpaceAround", 
    tags: ["lucide", "align", "vertical", "space", "around"], 
    source: "lucide", 
    name: "AlignVerticalSpaceAround",
  }, 
  {
    id: "lucide:AlignVerticalSpaceBetween", 
    tags: ["lucide", "align", "vertical", "space", "between"], 
    source: "lucide", 
    name: "AlignVerticalSpaceBetween",
  }, 
  {
    id: "lucide:Ambulance", 
    tags: ["lucide", "ambulance"], 
    source: "lucide", 
    name: "Ambulance",
  }, 
  {
    id: "lucide:Ampersand", 
    tags: ["lucide", "ampersand"], 
    source: "lucide", 
    name: "Ampersand",
  }, 
  {
    id: "lucide:Ampersands", 
    tags: ["lucide", "ampersands"], 
    source: "lucide", 
    name: "Ampersands",
  }, 
  {
    id: "lucide:Amphora", 
    tags: ["lucide", "amphora"], 
    source: "lucide", 
    name: "Amphora",
  }, 
  {
    id: "lucide:Anchor", 
    tags: ["lucide", "anchor"], 
    source: "lucide", 
    name: "Anchor",
  }, 
  {
    id: "lucide:Angry", 
    tags: ["lucide", "angry"], 
    source: "lucide", 
    name: "Angry",
  }, 
  {
    id: "lucide:Annoyed", 
    tags: ["lucide", "annoyed"], 
    source: "lucide", 
    name: "Annoyed",
  }, 
  {
    id: "lucide:Antenna", 
    tags: ["lucide", "antenna"], 
    source: "lucide", 
    name: "Antenna",
  }, 
  {
    id: "lucide:Anvil", 
    tags: ["lucide", "anvil"], 
    source: "lucide", 
    name: "Anvil",
  }, 
  {
    id: "lucide:Aperture", 
    tags: ["lucide", "aperture"], 
    source: "lucide", 
    name: "Aperture",
  }, 
  {
    id: "lucide:AppWindow", 
    tags: ["lucide", "app", "window"], 
    source: "lucide", 
    name: "AppWindow",
  }, 
  {
    id: "lucide:AppWindowMac", 
    tags: ["lucide", "app", "window", "mac"], 
    source: "lucide", 
    name: "AppWindowMac",
  }, 
  {
    id: "lucide:Apple", 
    tags: ["lucide", "apple"], 
    source: "lucide", 
    name: "Apple",
  }, 
  {
    id: "lucide:Archive", 
    tags: ["lucide", "archive"], 
    source: "lucide", 
    name: "Archive",
  }, 
  {
    id: "lucide:ArchiveRestore", 
    tags: ["lucide", "archive", "restore"], 
    source: "lucide", 
    name: "ArchiveRestore",
  }, 
  {
    id: "lucide:ArchiveX", 
    tags: ["lucide", "archive"], 
    source: "lucide", 
    name: "ArchiveX",
  }, 
  {
    id: "lucide:AreaChart", 
    tags: ["lucide", "area", "chart"], 
    source: "lucide", 
    name: "AreaChart",
  }, 
  {
    id: "lucide:Armchair", 
    tags: ["lucide", "armchair"], 
    source: "lucide", 
    name: "Armchair",
  }, 
  {
    id: "lucide:ArrowBigDown", 
    tags: ["lucide", "arrow", "big", "down"], 
    source: "lucide", 
    name: "ArrowBigDown",
  }, 
  {
    id: "lucide:ArrowBigDownDash", 
    tags: ["lucide", "arrow", "big", "down", "dash"], 
    source: "lucide", 
    name: "ArrowBigDownDash",
  }, 
  {
    id: "lucide:ArrowBigLeft", 
    tags: ["lucide", "arrow", "big", "left"], 
    source: "lucide", 
    name: "ArrowBigLeft",
  }, 
  {
    id: "lucide:ArrowBigLeftDash", 
    tags: ["lucide", "arrow", "big", "left", "dash"], 
    source: "lucide", 
    name: "ArrowBigLeftDash",
  }, 
  {
    id: "lucide:ArrowBigRight", 
    tags: ["lucide", "arrow", "big", "right"], 
    source: "lucide", 
    name: "ArrowBigRight",
  }, 
  {
    id: "lucide:ArrowBigRightDash", 
    tags: ["lucide", "arrow", "big", "right", "dash"], 
    source: "lucide", 
    name: "ArrowBigRightDash",
  }, 
  {
    id: "lucide:ArrowBigUp", 
    tags: ["lucide", "arrow", "big", "up"], 
    source: "lucide", 
    name: "ArrowBigUp",
  }, 
  {
    id: "lucide:ArrowBigUpDash", 
    tags: ["lucide", "arrow", "big", "up", "dash"], 
    source: "lucide", 
    name: "ArrowBigUpDash",
  }, 
  {
    id: "lucide:ArrowDown", 
    tags: ["lucide", "arrow", "down"], 
    source: "lucide", 
    name: "ArrowDown",
  }, 
  {
    id: "lucide:ArrowDown01", 
    tags: ["lucide", "arrow", "down"], 
    source: "lucide", 
    name: "ArrowDown01",
  }, 
  {
    id: "lucide:ArrowDown10", 
    tags: ["lucide", "arrow", "down"], 
    source: "lucide", 
    name: "ArrowDown10",
  }, 
  {
    id: "lucide:ArrowDownAz", 
    tags: ["lucide", "arrow", "down", "az"], 
    source: "lucide", 
    name: "ArrowDownAz",
  }, 
  {
    id: "lucide:ArrowDownCircle", 
    tags: ["lucide", "arrow", "down", "circle"], 
    source: "lucide", 
    name: "ArrowDownCircle",
  }, 
  {
    id: "lucide:ArrowDownFromLine", 
    tags: ["lucide", "arrow", "down", "from", "line"], 
    source: "lucide", 
    name: "ArrowDownFromLine",
  }, 
  {
    id: "lucide:ArrowDownLeft", 
    tags: ["lucide", "arrow", "down", "left"], 
    source: "lucide", 
    name: "ArrowDownLeft",
  }, 
  {
    id: "lucide:ArrowDownLeftFromCircle", 
    tags: ["lucide", "arrow", "down", "left", "from", "circle"], 
    source: "lucide", 
    name: "ArrowDownLeftFromCircle",
  }, 
  {
    id: "lucide:ArrowDownLeftFromSquare", 
    tags: ["lucide", "arrow", "down", "left", "from", "square"], 
    source: "lucide", 
    name: "ArrowDownLeftFromSquare",
  }, 
  {
    id: "lucide:ArrowDownLeftSquare", 
    tags: ["lucide", "arrow", "down", "left", "square"], 
    source: "lucide", 
    name: "ArrowDownLeftSquare",
  }, 
  {
    id: "lucide:ArrowDownNarrowWide", 
    tags: ["lucide", "arrow", "down", "narrow", "wide"], 
    source: "lucide", 
    name: "ArrowDownNarrowWide",
  }, 
  {
    id: "lucide:ArrowDownRight", 
    tags: ["lucide", "arrow", "down", "right"], 
    source: "lucide", 
    name: "ArrowDownRight",
  }, 
  {
    id: "lucide:ArrowDownRightFromCircle", 
    tags: ["lucide", "arrow", "down", "right", "from", "circle"], 
    source: "lucide", 
    name: "ArrowDownRightFromCircle",
  }, 
  {
    id: "lucide:ArrowDownRightFromSquare", 
    tags: ["lucide", "arrow", "down", "right", "from", "square"], 
    source: "lucide", 
    name: "ArrowDownRightFromSquare",
  }, 
  {
    id: "lucide:ArrowDownRightSquare", 
    tags: ["lucide", "arrow", "down", "right", "square"], 
    source: "lucide", 
    name: "ArrowDownRightSquare",
  }, 
  {
    id: "lucide:ArrowDownSquare", 
    tags: ["lucide", "arrow", "down", "square"], 
    source: "lucide", 
    name: "ArrowDownSquare",
  }, 
  {
    id: "lucide:ArrowDownToDot", 
    tags: ["lucide", "arrow", "down", "to", "dot"], 
    source: "lucide", 
    name: "ArrowDownToDot",
  }, 
  {
    id: "lucide:ArrowDownToLine", 
    tags: ["lucide", "arrow", "down", "to", "line"], 
    source: "lucide", 
    name: "ArrowDownToLine",
  }, 
  {
    id: "lucide:ArrowDownUp", 
    tags: ["lucide", "arrow", "down", "up"], 
    source: "lucide", 
    name: "ArrowDownUp",
  }, 
  {
    id: "lucide:ArrowDownWideNarrow", 
    tags: ["lucide", "arrow", "down", "wide", "narrow"], 
    source: "lucide", 
    name: "ArrowDownWideNarrow",
  }, 
  {
    id: "lucide:ArrowDownZa", 
    tags: ["lucide", "arrow", "down", "za"], 
    source: "lucide", 
    name: "ArrowDownZa",
  }, 
  {
    id: "lucide:ArrowLeft", 
    tags: ["lucide", "arrow", "left"], 
    source: "lucide", 
    name: "ArrowLeft",
  }, 
  {
    id: "lucide:ArrowLeftCircle", 
    tags: ["lucide", "arrow", "left", "circle"], 
    source: "lucide", 
    name: "ArrowLeftCircle",
  }, 
  {
    id: "lucide:ArrowLeftFromLine", 
    tags: ["lucide", "arrow", "left", "from", "line"], 
    source: "lucide", 
    name: "ArrowLeftFromLine",
  }, 
  {
    id: "lucide:ArrowLeftRight", 
    tags: ["lucide", "arrow", "left", "right"], 
    source: "lucide", 
    name: "ArrowLeftRight",
  }, 
  {
    id: "lucide:ArrowLeftSquare", 
    tags: ["lucide", "arrow", "left", "square"], 
    source: "lucide", 
    name: "ArrowLeftSquare",
  }, 
  {
    id: "lucide:ArrowLeftToLine", 
    tags: ["lucide", "arrow", "left", "to", "line"], 
    source: "lucide", 
    name: "ArrowLeftToLine",
  }, 
  {
    id: "lucide:ArrowRight", 
    tags: ["lucide", "arrow", "right"], 
    source: "lucide", 
    name: "ArrowRight",
  }, 
  {
    id: "lucide:ArrowRightCircle", 
    tags: ["lucide", "arrow", "right", "circle"], 
    source: "lucide", 
    name: "ArrowRightCircle",
  }, 
  {
    id: "lucide:ArrowRightFromLine", 
    tags: ["lucide", "arrow", "right", "from", "line"], 
    source: "lucide", 
    name: "ArrowRightFromLine",
  }, 
  {
    id: "lucide:ArrowRightLeft", 
    tags: ["lucide", "arrow", "right", "left"], 
    source: "lucide", 
    name: "ArrowRightLeft",
  }, 
  {
    id: "lucide:ArrowRightSquare", 
    tags: ["lucide", "arrow", "right", "square"], 
    source: "lucide", 
    name: "ArrowRightSquare",
  }, 
  {
    id: "lucide:ArrowRightToLine", 
    tags: ["lucide", "arrow", "right", "to", "line"], 
    source: "lucide", 
    name: "ArrowRightToLine",
  }, 
  {
    id: "lucide:ArrowUp", 
    tags: ["lucide", "arrow", "up"], 
    source: "lucide", 
    name: "ArrowUp",
  }, 
  {
    id: "lucide:ArrowUp01", 
    tags: ["lucide", "arrow", "up"], 
    source: "lucide", 
    name: "ArrowUp01",
  }, 
  {
    id: "lucide:ArrowUp10", 
    tags: ["lucide", "arrow", "up"], 
    source: "lucide", 
    name: "ArrowUp10",
  }, 
  {
    id: "lucide:ArrowUpAz", 
    tags: ["lucide", "arrow", "up", "az"], 
    source: "lucide", 
    name: "ArrowUpAz",
  }, 
  {
    id: "lucide:ArrowUpCircle", 
    tags: ["lucide", "arrow", "up", "circle"], 
    source: "lucide", 
    name: "ArrowUpCircle",
  }, 
  {
    id: "lucide:ArrowUpDown", 
    tags: ["lucide", "arrow", "up", "down"], 
    source: "lucide", 
    name: "ArrowUpDown",
  }, 
  {
    id: "lucide:ArrowUpFromDot", 
    tags: ["lucide", "arrow", "up", "from", "dot"], 
    source: "lucide", 
    name: "ArrowUpFromDot",
  }, 
  {
    id: "lucide:ArrowUpFromLine", 
    tags: ["lucide", "arrow", "up", "from", "line"], 
    source: "lucide", 
    name: "ArrowUpFromLine",
  }, 
  {
    id: "lucide:ArrowUpLeft", 
    tags: ["lucide", "arrow", "up", "left"], 
    source: "lucide", 
    name: "ArrowUpLeft",
  }, 
  {
    id: "lucide:ArrowUpLeftFromCircle", 
    tags: ["lucide", "arrow", "up", "left", "from", "circle"], 
    source: "lucide", 
    name: "ArrowUpLeftFromCircle",
  }, 
  {
    id: "lucide:ArrowUpLeftFromSquare", 
    tags: ["lucide", "arrow", "up", "left", "from", "square"], 
    source: "lucide", 
    name: "ArrowUpLeftFromSquare",
  }, 
  {
    id: "lucide:ArrowUpLeftSquare", 
    tags: ["lucide", "arrow", "up", "left", "square"], 
    source: "lucide", 
    name: "ArrowUpLeftSquare",
  }, 
  {
    id: "lucide:ArrowUpNarrowWide", 
    tags: ["lucide", "arrow", "up", "narrow", "wide"], 
    source: "lucide", 
    name: "ArrowUpNarrowWide",
  }, 
  {
    id: "lucide:ArrowUpRight", 
    tags: ["lucide", "arrow", "up", "right"], 
    source: "lucide", 
    name: "ArrowUpRight",
  }, 
  {
    id: "lucide:ArrowUpRightFromCircle", 
    tags: ["lucide", "arrow", "up", "right", "from", "circle"], 
    source: "lucide", 
    name: "ArrowUpRightFromCircle",
  }, 
  {
    id: "lucide:ArrowUpRightFromSquare", 
    tags: ["lucide", "arrow", "up", "right", "from", "square"], 
    source: "lucide", 
    name: "ArrowUpRightFromSquare",
  }, 
  {
    id: "lucide:ArrowUpRightSquare", 
    tags: ["lucide", "arrow", "up", "right", "square"], 
    source: "lucide", 
    name: "ArrowUpRightSquare",
  }, 
  {
    id: "lucide:ArrowUpSquare", 
    tags: ["lucide", "arrow", "up", "square"], 
    source: "lucide", 
    name: "ArrowUpSquare",
  }, 
  {
    id: "lucide:ArrowUpToLine", 
    tags: ["lucide", "arrow", "up", "to", "line"], 
    source: "lucide", 
    name: "ArrowUpToLine",
  }, 
  {
    id: "lucide:ArrowUpWideNarrow", 
    tags: ["lucide", "arrow", "up", "wide", "narrow"], 
    source: "lucide", 
    name: "ArrowUpWideNarrow",
  }, 
  {
    id: "lucide:ArrowUpZa", 
    tags: ["lucide", "arrow", "up", "za"], 
    source: "lucide", 
    name: "ArrowUpZa",
  }, 
  {
    id: "lucide:ArrowsUpFromLine", 
    tags: ["lucide", "arrows", "up", "from", "line"], 
    source: "lucide", 
    name: "ArrowsUpFromLine",
  }, 
  {
    id: "lucide:Asterisk", 
    tags: ["lucide", "asterisk"], 
    source: "lucide", 
    name: "Asterisk",
  }, 
  {
    id: "lucide:AsteriskSquare", 
    tags: ["lucide", "asterisk", "square"], 
    source: "lucide", 
    name: "AsteriskSquare",
  }, 
  {
    id: "lucide:AtSign", 
    tags: ["lucide", "at", "sign"], 
    source: "lucide", 
    name: "AtSign",
  }, 
  {
    id: "lucide:Atom", 
    tags: ["lucide", "atom"], 
    source: "lucide", 
    name: "Atom",
  }, 
  {
    id: "lucide:AudioLines", 
    tags: ["lucide", "audio", "lines"], 
    source: "lucide", 
    name: "AudioLines",
  }, 
  {
    id: "lucide:AudioWaveform", 
    tags: ["lucide", "audio", "waveform"], 
    source: "lucide", 
    name: "AudioWaveform",
  }, 
  {
    id: "lucide:Award", 
    tags: ["lucide", "award"], 
    source: "lucide", 
    name: "Award",
  }, 
  {
    id: "lucide:Axe", 
    tags: ["lucide", "axe"], 
    source: "lucide", 
    name: "Axe",
  }, 
  {
    id: "lucide:Axis3d", 
    tags: ["lucide", "axis"], 
    source: "lucide", 
    name: "Axis3d",
  }, 
  {
    id: "lucide:Baby", 
    tags: ["lucide", "baby"], 
    source: "lucide", 
    name: "Baby",
  }, 
  {
    id: "lucide:Backpack", 
    tags: ["lucide", "backpack"], 
    source: "lucide", 
    name: "Backpack",
  }, 
  {
    id: "lucide:Badge", 
    tags: ["lucide", "badge"], 
    source: "lucide", 
    name: "Badge",
  }, 
  {
    id: "lucide:BadgeAlert", 
    tags: ["lucide", "badge", "alert"], 
    source: "lucide", 
    name: "BadgeAlert",
  }, 
  {
    id: "lucide:BadgeCent", 
    tags: ["lucide", "badge", "cent"], 
    source: "lucide", 
    name: "BadgeCent",
  }, 
  {
    id: "lucide:BadgeCheck", 
    tags: ["lucide", "badge", "check"], 
    source: "lucide", 
    name: "BadgeCheck",
  }, 
  {
    id: "lucide:BadgeDollarSign", 
    tags: ["lucide", "badge", "dollar", "sign"], 
    source: "lucide", 
    name: "BadgeDollarSign",
  }, 
  {
    id: "lucide:BadgeEuro", 
    tags: ["lucide", "badge", "euro"], 
    source: "lucide", 
    name: "BadgeEuro",
  }, 
  {
    id: "lucide:BadgeHelp", 
    tags: ["lucide", "badge", "help"], 
    source: "lucide", 
    name: "BadgeHelp",
  }, 
  {
    id: "lucide:BadgeIndianRupee", 
    tags: ["lucide", "badge", "indian", "rupee"], 
    source: "lucide", 
    name: "BadgeIndianRupee",
  }, 
  {
    id: "lucide:BadgeInfo", 
    tags: ["lucide", "badge", "info"], 
    source: "lucide", 
    name: "BadgeInfo",
  }, 
  {
    id: "lucide:BadgeJapaneseYen", 
    tags: ["lucide", "badge", "japanese", "yen"], 
    source: "lucide", 
    name: "BadgeJapaneseYen",
  }, 
  {
    id: "lucide:BadgeMinus", 
    tags: ["lucide", "badge", "minus"], 
    source: "lucide", 
    name: "BadgeMinus",
  }, 
  {
    id: "lucide:BadgePercent", 
    tags: ["lucide", "badge", "percent"], 
    source: "lucide", 
    name: "BadgePercent",
  }, 
  {
    id: "lucide:BadgePlus", 
    tags: ["lucide", "badge", "plus"], 
    source: "lucide", 
    name: "BadgePlus",
  }, 
  {
    id: "lucide:BadgePoundSterling", 
    tags: ["lucide", "badge", "pound", "sterling"], 
    source: "lucide", 
    name: "BadgePoundSterling",
  }, 
  {
    id: "lucide:BadgeRussianRuble", 
    tags: ["lucide", "badge", "russian", "ruble"], 
    source: "lucide", 
    name: "BadgeRussianRuble",
  }, 
  {
    id: "lucide:BadgeSwissFranc", 
    tags: ["lucide", "badge", "swiss", "franc"], 
    source: "lucide", 
    name: "BadgeSwissFranc",
  }, 
  {
    id: "lucide:BadgeX", 
    tags: ["lucide", "badge"], 
    source: "lucide", 
    name: "BadgeX",
  }, 
  {
    id: "lucide:BaggageClaim", 
    tags: ["lucide", "baggage", "claim"], 
    source: "lucide", 
    name: "BaggageClaim",
  }, 
  {
    id: "lucide:Ban", 
    tags: ["lucide", "ban"], 
    source: "lucide", 
    name: "Ban",
  }, 
  {
    id: "lucide:Banana", 
    tags: ["lucide", "banana"], 
    source: "lucide", 
    name: "Banana",
  }, 
  {
    id: "lucide:Bandage", 
    tags: ["lucide", "bandage"], 
    source: "lucide", 
    name: "Bandage",
  }, 
  {
    id: "lucide:Banknote", 
    tags: ["lucide", "banknote"], 
    source: "lucide", 
    name: "Banknote",
  }, 
  {
    id: "lucide:BarChart", 
    tags: ["lucide", "bar", "chart"], 
    source: "lucide", 
    name: "BarChart",
  }, 
  {
    id: "lucide:BarChart2", 
    tags: ["lucide", "bar", "chart"], 
    source: "lucide", 
    name: "BarChart2",
  }, 
  {
    id: "lucide:BarChart3", 
    tags: ["lucide", "bar", "chart"], 
    source: "lucide", 
    name: "BarChart3",
  }, 
  {
    id: "lucide:BarChart4", 
    tags: ["lucide", "bar", "chart"], 
    source: "lucide", 
    name: "BarChart4",
  }, 
  {
    id: "lucide:BarChartBig", 
    tags: ["lucide", "bar", "chart", "big"], 
    source: "lucide", 
    name: "BarChartBig",
  }, 
  {
    id: "lucide:BarChartHorizontal", 
    tags: ["lucide", "bar", "chart", "horizontal"], 
    source: "lucide", 
    name: "BarChartHorizontal",
  }, 
  {
    id: "lucide:BarChartHorizontalBig", 
    tags: ["lucide", "bar", "chart", "horizontal", "big"], 
    source: "lucide", 
    name: "BarChartHorizontalBig",
  }, 
  {
    id: "lucide:Barcode", 
    tags: ["lucide", "barcode"], 
    source: "lucide", 
    name: "Barcode",
  }, 
  {
    id: "lucide:Baseline", 
    tags: ["lucide", "baseline"], 
    source: "lucide", 
    name: "Baseline",
  }, 
  {
    id: "lucide:Bath", 
    tags: ["lucide", "bath"], 
    source: "lucide", 
    name: "Bath",
  }, 
  {
    id: "lucide:Battery", 
    tags: ["lucide", "battery"], 
    source: "lucide", 
    name: "Battery",
  }, 
  {
    id: "lucide:BatteryCharging", 
    tags: ["lucide", "battery", "charging"], 
    source: "lucide", 
    name: "BatteryCharging",
  }, 
  {
    id: "lucide:BatteryFull", 
    tags: ["lucide", "battery", "full"], 
    source: "lucide", 
    name: "BatteryFull",
  }, 
  {
    id: "lucide:BatteryLow", 
    tags: ["lucide", "battery", "low"], 
    source: "lucide", 
    name: "BatteryLow",
  }, 
  {
    id: "lucide:BatteryMedium", 
    tags: ["lucide", "battery", "medium"], 
    source: "lucide", 
    name: "BatteryMedium",
  }, 
  {
    id: "lucide:BatteryPlus", 
    tags: ["lucide", "battery", "plus"], 
    source: "lucide", 
    name: "BatteryPlus",
  }, 
  {
    id: "lucide:BatteryWarning", 
    tags: ["lucide", "battery", "warning"], 
    source: "lucide", 
    name: "BatteryWarning",
  }, 
  {
    id: "lucide:Beaker", 
    tags: ["lucide", "beaker"], 
    source: "lucide", 
    name: "Beaker",
  }, 
  {
    id: "lucide:Bean", 
    tags: ["lucide", "bean"], 
    source: "lucide", 
    name: "Bean",
  }, 
  {
    id: "lucide:BeanOff", 
    tags: ["lucide", "bean", "off"], 
    source: "lucide", 
    name: "BeanOff",
  }, 
  {
    id: "lucide:Bed", 
    tags: ["lucide", "bed"], 
    source: "lucide", 
    name: "Bed",
  }, 
  {
    id: "lucide:BedDouble", 
    tags: ["lucide", "bed", "double"], 
    source: "lucide", 
    name: "BedDouble",
  }, 
  {
    id: "lucide:BedSingle", 
    tags: ["lucide", "bed", "single"], 
    source: "lucide", 
    name: "BedSingle",
  }, 
  {
    id: "lucide:Beef", 
    tags: ["lucide", "beef"], 
    source: "lucide", 
    name: "Beef",
  }, 
  {
    id: "lucide:Beer", 
    tags: ["lucide", "beer"], 
    source: "lucide", 
    name: "Beer",
  }, 
  {
    id: "lucide:BeerOff", 
    tags: ["lucide", "beer", "off"], 
    source: "lucide", 
    name: "BeerOff",
  }, 
  {
    id: "lucide:Bell", 
    tags: ["lucide", "bell"], 
    source: "lucide", 
    name: "Bell",
  }, 
  {
    id: "lucide:BellDot", 
    tags: ["lucide", "bell", "dot"], 
    source: "lucide", 
    name: "BellDot",
  }, 
  {
    id: "lucide:BellElectric", 
    tags: ["lucide", "bell", "electric"], 
    source: "lucide", 
    name: "BellElectric",
  }, 
  {
    id: "lucide:BellMinus", 
    tags: ["lucide", "bell", "minus"], 
    source: "lucide", 
    name: "BellMinus",
  }, 
  {
    id: "lucide:BellOff", 
    tags: ["lucide", "bell", "off"], 
    source: "lucide", 
    name: "BellOff",
  }, 
  {
    id: "lucide:BellPlus", 
    tags: ["lucide", "bell", "plus"], 
    source: "lucide", 
    name: "BellPlus",
  }, 
  {
    id: "lucide:BellRing", 
    tags: ["lucide", "bell", "ring"], 
    source: "lucide", 
    name: "BellRing",
  }, 
  {
    id: "lucide:BetweenHorizonalEnd", 
    tags: ["lucide", "between", "horizonal", "end"], 
    source: "lucide", 
    name: "BetweenHorizonalEnd",
  }, 
  {
    id: "lucide:BetweenHorizonalStart", 
    tags: ["lucide", "between", "horizonal", "start"], 
    source: "lucide", 
    name: "BetweenHorizonalStart",
  }, 
  {
    id: "lucide:BetweenHorizontalEnd", 
    tags: ["lucide", "between", "horizontal", "end"], 
    source: "lucide", 
    name: "BetweenHorizontalEnd",
  }, 
  {
    id: "lucide:BetweenHorizontalStart", 
    tags: ["lucide", "between", "horizontal", "start"], 
    source: "lucide", 
    name: "BetweenHorizontalStart",
  }, 
  {
    id: "lucide:BetweenVerticalEnd", 
    tags: ["lucide", "between", "vertical", "end"], 
    source: "lucide", 
    name: "BetweenVerticalEnd",
  }, 
  {
    id: "lucide:BetweenVerticalStart", 
    tags: ["lucide", "between", "vertical", "start"], 
    source: "lucide", 
    name: "BetweenVerticalStart",
  }, 
  {
    id: "lucide:BicepsFlexed", 
    tags: ["lucide", "biceps", "flexed"], 
    source: "lucide", 
    name: "BicepsFlexed",
  }, 
  {
    id: "lucide:Bike", 
    tags: ["lucide", "bike"], 
    source: "lucide", 
    name: "Bike",
  }, 
  {
    id: "lucide:Binary", 
    tags: ["lucide", "binary"], 
    source: "lucide", 
    name: "Binary",
  }, 
  {
    id: "lucide:Binoculars", 
    tags: ["lucide", "binoculars"], 
    source: "lucide", 
    name: "Binoculars",
  }, 
  {
    id: "lucide:Biohazard", 
    tags: ["lucide", "biohazard"], 
    source: "lucide", 
    name: "Biohazard",
  }, 
  {
    id: "lucide:Bird", 
    tags: ["lucide", "bird"], 
    source: "lucide", 
    name: "Bird",
  }, 
  {
    id: "lucide:Bitcoin", 
    tags: ["lucide", "bitcoin"], 
    source: "lucide", 
    name: "Bitcoin",
  }, 
  {
    id: "lucide:Blend", 
    tags: ["lucide", "blend"], 
    source: "lucide", 
    name: "Blend",
  }, 
  {
    id: "lucide:Blinds", 
    tags: ["lucide", "blinds"], 
    source: "lucide", 
    name: "Blinds",
  }, 
  {
    id: "lucide:Blocks", 
    tags: ["lucide", "blocks"], 
    source: "lucide", 
    name: "Blocks",
  }, 
  {
    id: "lucide:Bluetooth", 
    tags: ["lucide", "bluetooth"], 
    source: "lucide", 
    name: "Bluetooth",
  }, 
  {
    id: "lucide:BluetoothConnected", 
    tags: ["lucide", "bluetooth", "connected"], 
    source: "lucide", 
    name: "BluetoothConnected",
  }, 
  {
    id: "lucide:BluetoothOff", 
    tags: ["lucide", "bluetooth", "off"], 
    source: "lucide", 
    name: "BluetoothOff",
  }, 
  {
    id: "lucide:BluetoothSearching", 
    tags: ["lucide", "bluetooth", "searching"], 
    source: "lucide", 
    name: "BluetoothSearching",
  }, 
  {
    id: "lucide:Bold", 
    tags: ["lucide", "bold"], 
    source: "lucide", 
    name: "Bold",
  }, 
  {
    id: "lucide:Bolt", 
    tags: ["lucide", "bolt"], 
    source: "lucide", 
    name: "Bolt",
  }, 
  {
    id: "lucide:Bomb", 
    tags: ["lucide", "bomb"], 
    source: "lucide", 
    name: "Bomb",
  }, 
  {
    id: "lucide:Bone", 
    tags: ["lucide", "bone"], 
    source: "lucide", 
    name: "Bone",
  }, 
  {
    id: "lucide:Book", 
    tags: ["lucide", "book"], 
    source: "lucide", 
    name: "Book",
  }, 
  {
    id: "lucide:BookA", 
    tags: ["lucide", "book"], 
    source: "lucide", 
    name: "BookA",
  }, 
  {
    id: "lucide:BookAudio", 
    tags: ["lucide", "book", "audio"], 
    source: "lucide", 
    name: "BookAudio",
  }, 
  {
    id: "lucide:BookCheck", 
    tags: ["lucide", "book", "check"], 
    source: "lucide", 
    name: "BookCheck",
  }, 
  {
    id: "lucide:BookCopy", 
    tags: ["lucide", "book", "copy"], 
    source: "lucide", 
    name: "BookCopy",
  }, 
  {
    id: "lucide:BookDashed", 
    tags: ["lucide", "book", "dashed"], 
    source: "lucide", 
    name: "BookDashed",
  }, 
  {
    id: "lucide:BookDown", 
    tags: ["lucide", "book", "down"], 
    source: "lucide", 
    name: "BookDown",
  }, 
  {
    id: "lucide:BookHeadphones", 
    tags: ["lucide", "book", "headphones"], 
    source: "lucide", 
    name: "BookHeadphones",
  }, 
  {
    id: "lucide:BookHeart", 
    tags: ["lucide", "book", "heart"], 
    source: "lucide", 
    name: "BookHeart",
  }, 
  {
    id: "lucide:BookImage", 
    tags: ["lucide", "book", "image"], 
    source: "lucide", 
    name: "BookImage",
  }, 
  {
    id: "lucide:BookKey", 
    tags: ["lucide", "book", "key"], 
    source: "lucide", 
    name: "BookKey",
  }, 
  {
    id: "lucide:BookLock", 
    tags: ["lucide", "book", "lock"], 
    source: "lucide", 
    name: "BookLock",
  }, 
  {
    id: "lucide:BookMarked", 
    tags: ["lucide", "book", "marked"], 
    source: "lucide", 
    name: "BookMarked",
  }, 
  {
    id: "lucide:BookMinus", 
    tags: ["lucide", "book", "minus"], 
    source: "lucide", 
    name: "BookMinus",
  }, 
  {
    id: "lucide:BookOpen", 
    tags: ["lucide", "book", "open"], 
    source: "lucide", 
    name: "BookOpen",
  }, 
  {
    id: "lucide:BookOpenCheck", 
    tags: ["lucide", "book", "open", "check"], 
    source: "lucide", 
    name: "BookOpenCheck",
  }, 
  {
    id: "lucide:BookOpenText", 
    tags: ["lucide", "book", "open", "text"], 
    source: "lucide", 
    name: "BookOpenText",
  }, 
  {
    id: "lucide:BookPlus", 
    tags: ["lucide", "book", "plus"], 
    source: "lucide", 
    name: "BookPlus",
  }, 
  {
    id: "lucide:BookTemplate", 
    tags: ["lucide", "book", "template"], 
    source: "lucide", 
    name: "BookTemplate",
  }, 
  {
    id: "lucide:BookText", 
    tags: ["lucide", "book", "text"], 
    source: "lucide", 
    name: "BookText",
  }, 
  {
    id: "lucide:BookType", 
    tags: ["lucide", "book", "type"], 
    source: "lucide", 
    name: "BookType",
  }, 
  {
    id: "lucide:BookUp", 
    tags: ["lucide", "book", "up"], 
    source: "lucide", 
    name: "BookUp",
  }, 
  {
    id: "lucide:BookUp2", 
    tags: ["lucide", "book", "up"], 
    source: "lucide", 
    name: "BookUp2",
  }, 
  {
    id: "lucide:BookUser", 
    tags: ["lucide", "book", "user"], 
    source: "lucide", 
    name: "BookUser",
  }, 
  {
    id: "lucide:BookX", 
    tags: ["lucide", "book"], 
    source: "lucide", 
    name: "BookX",
  }, 
  {
    id: "lucide:Bookmark", 
    tags: ["lucide", "bookmark"], 
    source: "lucide", 
    name: "Bookmark",
  }, 
  {
    id: "lucide:BookmarkCheck", 
    tags: ["lucide", "bookmark", "check"], 
    source: "lucide", 
    name: "BookmarkCheck",
  }, 
  {
    id: "lucide:BookmarkMinus", 
    tags: ["lucide", "bookmark", "minus"], 
    source: "lucide", 
    name: "BookmarkMinus",
  }, 
  {
    id: "lucide:BookmarkPlus", 
    tags: ["lucide", "bookmark", "plus"], 
    source: "lucide", 
    name: "BookmarkPlus",
  }, 
  {
    id: "lucide:BookmarkX", 
    tags: ["lucide", "bookmark"], 
    source: "lucide", 
    name: "BookmarkX",
  }, 
  {
    id: "lucide:BoomBox", 
    tags: ["lucide", "boom", "box"], 
    source: "lucide", 
    name: "BoomBox",
  }, 
  {
    id: "lucide:Bot", 
    tags: ["lucide", "bot"], 
    source: "lucide", 
    name: "Bot",
  }, 
  {
    id: "lucide:BotMessageSquare", 
    tags: ["lucide", "bot", "message", "square"], 
    source: "lucide", 
    name: "BotMessageSquare",
  }, 
  {
    id: "lucide:BotOff", 
    tags: ["lucide", "bot", "off"], 
    source: "lucide", 
    name: "BotOff",
  }, 
  {
    id: "lucide:Box", 
    tags: ["lucide", "box"], 
    source: "lucide", 
    name: "Box",
  }, 
  {
    id: "lucide:BoxSelect", 
    tags: ["lucide", "box", "select"], 
    source: "lucide", 
    name: "BoxSelect",
  }, 
  {
    id: "lucide:Boxes", 
    tags: ["lucide", "boxes"], 
    source: "lucide", 
    name: "Boxes",
  }, 
  {
    id: "lucide:Braces", 
    tags: ["lucide", "braces"], 
    source: "lucide", 
    name: "Braces",
  }, 
  {
    id: "lucide:Brackets", 
    tags: ["lucide", "brackets"], 
    source: "lucide", 
    name: "Brackets",
  }, 
  {
    id: "lucide:Brain", 
    tags: ["lucide", "brain"], 
    source: "lucide", 
    name: "Brain",
  }, 
  {
    id: "lucide:BrainCircuit", 
    tags: ["lucide", "brain", "circuit"], 
    source: "lucide", 
    name: "BrainCircuit",
  }, 
  {
    id: "lucide:BrainCog", 
    tags: ["lucide", "brain", "cog"], 
    source: "lucide", 
    name: "BrainCog",
  }, 
  {
    id: "lucide:BrickWall", 
    tags: ["lucide", "brick", "wall"], 
    source: "lucide", 
    name: "BrickWall",
  }, 
  {
    id: "lucide:Briefcase", 
    tags: ["lucide", "briefcase"], 
    source: "lucide", 
    name: "Briefcase",
  }, 
  {
    id: "lucide:BriefcaseBusiness", 
    tags: ["lucide", "briefcase", "business"], 
    source: "lucide", 
    name: "BriefcaseBusiness",
  }, 
  {
    id: "lucide:BriefcaseConveyorBelt", 
    tags: ["lucide", "briefcase", "conveyor", "belt"], 
    source: "lucide", 
    name: "BriefcaseConveyorBelt",
  }, 
  {
    id: "lucide:BriefcaseMedical", 
    tags: ["lucide", "briefcase", "medical"], 
    source: "lucide", 
    name: "BriefcaseMedical",
  }, 
  {
    id: "lucide:BringToFront", 
    tags: ["lucide", "bring", "to", "front"], 
    source: "lucide", 
    name: "BringToFront",
  }, 
  {
    id: "lucide:Brush", 
    tags: ["lucide", "brush"], 
    source: "lucide", 
    name: "Brush",
  }, 
  {
    id: "lucide:Bug", 
    tags: ["lucide", "bug"], 
    source: "lucide", 
    name: "Bug",
  }, 
  {
    id: "lucide:BugOff", 
    tags: ["lucide", "bug", "off"], 
    source: "lucide", 
    name: "BugOff",
  }, 
  {
    id: "lucide:BugPlay", 
    tags: ["lucide", "bug", "play"], 
    source: "lucide", 
    name: "BugPlay",
  }, 
  {
    id: "lucide:Building", 
    tags: ["lucide", "building"], 
    source: "lucide", 
    name: "Building",
  }, 
  {
    id: "lucide:Building2", 
    tags: ["lucide", "building"], 
    source: "lucide", 
    name: "Building2",
  }, 
  {
    id: "lucide:Bus", 
    tags: ["lucide", "bus"], 
    source: "lucide", 
    name: "Bus",
  }, 
  {
    id: "lucide:BusFront", 
    tags: ["lucide", "bus", "front"], 
    source: "lucide", 
    name: "BusFront",
  }, 
  {
    id: "lucide:Cable", 
    tags: ["lucide", "cable"], 
    source: "lucide", 
    name: "Cable",
  }, 
  {
    id: "lucide:CableCar", 
    tags: ["lucide", "cable", "car"], 
    source: "lucide", 
    name: "CableCar",
  }, 
  {
    id: "lucide:Cake", 
    tags: ["lucide", "cake"], 
    source: "lucide", 
    name: "Cake",
  }, 
  {
    id: "lucide:CakeSlice", 
    tags: ["lucide", "cake", "slice"], 
    source: "lucide", 
    name: "CakeSlice",
  }, 
  {
    id: "lucide:Calculator", 
    tags: ["lucide", "calculator"], 
    source: "lucide", 
    name: "Calculator",
  }, 
  {
    id: "lucide:Calendar", 
    tags: ["lucide", "calendar"], 
    source: "lucide", 
    name: "Calendar",
  }, 
  {
    id: "lucide:Calendar1", 
    tags: ["lucide", "calendar"], 
    source: "lucide", 
    name: "Calendar1",
  }, 
  {
    id: "lucide:CalendarArrowDown", 
    tags: ["lucide", "calendar", "arrow", "down"], 
    source: "lucide", 
    name: "CalendarArrowDown",
  }, 
  {
    id: "lucide:CalendarArrowUp", 
    tags: ["lucide", "calendar", "arrow", "up"], 
    source: "lucide", 
    name: "CalendarArrowUp",
  }, 
  {
    id: "lucide:CalendarCheck", 
    tags: ["lucide", "calendar", "check"], 
    source: "lucide", 
    name: "CalendarCheck",
  }, 
  {
    id: "lucide:CalendarCheck2", 
    tags: ["lucide", "calendar", "check"], 
    source: "lucide", 
    name: "CalendarCheck2",
  }, 
  {
    id: "lucide:CalendarClock", 
    tags: ["lucide", "calendar", "clock"], 
    source: "lucide", 
    name: "CalendarClock",
  }, 
  {
    id: "lucide:CalendarCog", 
    tags: ["lucide", "calendar", "cog"], 
    source: "lucide", 
    name: "CalendarCog",
  }, 
  {
    id: "lucide:CalendarDays", 
    tags: ["lucide", "calendar", "days"], 
    source: "lucide", 
    name: "CalendarDays",
  }, 
  {
    id: "lucide:CalendarFold", 
    tags: ["lucide", "calendar", "fold"], 
    source: "lucide", 
    name: "CalendarFold",
  }, 
  {
    id: "lucide:CalendarHeart", 
    tags: ["lucide", "calendar", "heart"], 
    source: "lucide", 
    name: "CalendarHeart",
  }, 
  {
    id: "lucide:CalendarMinus", 
    tags: ["lucide", "calendar", "minus"], 
    source: "lucide", 
    name: "CalendarMinus",
  }, 
  {
    id: "lucide:CalendarMinus2", 
    tags: ["lucide", "calendar", "minus"], 
    source: "lucide", 
    name: "CalendarMinus2",
  }, 
  {
    id: "lucide:CalendarOff", 
    tags: ["lucide", "calendar", "off"], 
    source: "lucide", 
    name: "CalendarOff",
  }, 
  {
    id: "lucide:CalendarPlus", 
    tags: ["lucide", "calendar", "plus"], 
    source: "lucide", 
    name: "CalendarPlus",
  }, 
  {
    id: "lucide:CalendarPlus2", 
    tags: ["lucide", "calendar", "plus"], 
    source: "lucide", 
    name: "CalendarPlus2",
  }, 
  {
    id: "lucide:CalendarRange", 
    tags: ["lucide", "calendar", "range"], 
    source: "lucide", 
    name: "CalendarRange",
  }, 
  {
    id: "lucide:CalendarSearch", 
    tags: ["lucide", "calendar", "search"], 
    source: "lucide", 
    name: "CalendarSearch",
  }, 
  {
    id: "lucide:CalendarSync", 
    tags: ["lucide", "calendar", "sync"], 
    source: "lucide", 
    name: "CalendarSync",
  }, 
  {
    id: "lucide:CalendarX", 
    tags: ["lucide", "calendar"], 
    source: "lucide", 
    name: "CalendarX",
  }, 
  {
    id: "lucide:CalendarX2", 
    tags: ["lucide", "calendar"], 
    source: "lucide", 
    name: "CalendarX2",
  }, 
  {
    id: "lucide:Camera", 
    tags: ["lucide", "camera"], 
    source: "lucide", 
    name: "Camera",
  }, 
  {
    id: "lucide:CameraOff", 
    tags: ["lucide", "camera", "off"], 
    source: "lucide", 
    name: "CameraOff",
  }, 
  {
    id: "lucide:CandlestickChart", 
    tags: ["lucide", "candlestick", "chart"], 
    source: "lucide", 
    name: "CandlestickChart",
  }, 
  {
    id: "lucide:Candy", 
    tags: ["lucide", "candy"], 
    source: "lucide", 
    name: "Candy",
  }, 
  {
    id: "lucide:CandyCane", 
    tags: ["lucide", "candy", "cane"], 
    source: "lucide", 
    name: "CandyCane",
  }, 
  {
    id: "lucide:CandyOff", 
    tags: ["lucide", "candy", "off"], 
    source: "lucide", 
    name: "CandyOff",
  }, 
  {
    id: "lucide:Cannabis", 
    tags: ["lucide", "cannabis"], 
    source: "lucide", 
    name: "Cannabis",
  }, 
  {
    id: "lucide:Captions", 
    tags: ["lucide", "captions"], 
    source: "lucide", 
    name: "Captions",
  }, 
  {
    id: "lucide:CaptionsOff", 
    tags: ["lucide", "captions", "off"], 
    source: "lucide", 
    name: "CaptionsOff",
  }, 
  {
    id: "lucide:Car", 
    tags: ["lucide", "car"], 
    source: "lucide", 
    name: "Car",
  }, 
  {
    id: "lucide:CarFront", 
    tags: ["lucide", "car", "front"], 
    source: "lucide", 
    name: "CarFront",
  }, 
  {
    id: "lucide:CarTaxiFront", 
    tags: ["lucide", "car", "taxi", "front"], 
    source: "lucide", 
    name: "CarTaxiFront",
  }, 
  {
    id: "lucide:Caravan", 
    tags: ["lucide", "caravan"], 
    source: "lucide", 
    name: "Caravan",
  }, 
  {
    id: "lucide:Carrot", 
    tags: ["lucide", "carrot"], 
    source: "lucide", 
    name: "Carrot",
  }, 
  {
    id: "lucide:CaseLower", 
    tags: ["lucide", "case", "lower"], 
    source: "lucide", 
    name: "CaseLower",
  }, 
  {
    id: "lucide:CaseSensitive", 
    tags: ["lucide", "case", "sensitive"], 
    source: "lucide", 
    name: "CaseSensitive",
  }, 
  {
    id: "lucide:CaseUpper", 
    tags: ["lucide", "case", "upper"], 
    source: "lucide", 
    name: "CaseUpper",
  }, 
  {
    id: "lucide:CassetteTape", 
    tags: ["lucide", "cassette", "tape"], 
    source: "lucide", 
    name: "CassetteTape",
  }, 
  {
    id: "lucide:Cast", 
    tags: ["lucide", "cast"], 
    source: "lucide", 
    name: "Cast",
  }, 
  {
    id: "lucide:Castle", 
    tags: ["lucide", "castle"], 
    source: "lucide", 
    name: "Castle",
  }, 
  {
    id: "lucide:Cat", 
    tags: ["lucide", "cat"], 
    source: "lucide", 
    name: "Cat",
  }, 
  {
    id: "lucide:Cctv", 
    tags: ["lucide", "cctv"], 
    source: "lucide", 
    name: "Cctv",
  }, 
  {
    id: "lucide:ChartArea", 
    tags: ["lucide", "chart", "area"], 
    source: "lucide", 
    name: "ChartArea",
  }, 
  {
    id: "lucide:ChartBar", 
    tags: ["lucide", "chart", "bar"], 
    source: "lucide", 
    name: "ChartBar",
  }, 
  {
    id: "lucide:ChartBarBig", 
    tags: ["lucide", "chart", "bar", "big"], 
    source: "lucide", 
    name: "ChartBarBig",
  }, 
  {
    id: "lucide:ChartBarDecreasing", 
    tags: ["lucide", "chart", "bar", "decreasing"], 
    source: "lucide", 
    name: "ChartBarDecreasing",
  }, 
  {
    id: "lucide:ChartBarIncreasing", 
    tags: ["lucide", "chart", "bar", "increasing"], 
    source: "lucide", 
    name: "ChartBarIncreasing",
  }, 
  {
    id: "lucide:ChartBarStacked", 
    tags: ["lucide", "chart", "bar", "stacked"], 
    source: "lucide", 
    name: "ChartBarStacked",
  }, 
  {
    id: "lucide:ChartCandlestick", 
    tags: ["lucide", "chart", "candlestick"], 
    source: "lucide", 
    name: "ChartCandlestick",
  }, 
  {
    id: "lucide:ChartColumn", 
    tags: ["lucide", "chart", "column"], 
    source: "lucide", 
    name: "ChartColumn",
  }, 
  {
    id: "lucide:ChartColumnBig", 
    tags: ["lucide", "chart", "column", "big"], 
    source: "lucide", 
    name: "ChartColumnBig",
  }, 
  {
    id: "lucide:ChartColumnDecreasing", 
    tags: ["lucide", "chart", "column", "decreasing"], 
    source: "lucide", 
    name: "ChartColumnDecreasing",
  }, 
  {
    id: "lucide:ChartColumnIncreasing", 
    tags: ["lucide", "chart", "column", "increasing"], 
    source: "lucide", 
    name: "ChartColumnIncreasing",
  }, 
  {
    id: "lucide:ChartColumnStacked", 
    tags: ["lucide", "chart", "column", "stacked"], 
    source: "lucide", 
    name: "ChartColumnStacked",
  }, 
  {
    id: "lucide:ChartGantt", 
    tags: ["lucide", "chart", "gantt"], 
    source: "lucide", 
    name: "ChartGantt",
  }, 
  {
    id: "lucide:ChartLine", 
    tags: ["lucide", "chart", "line"], 
    source: "lucide", 
    name: "ChartLine",
  }, 
  {
    id: "lucide:ChartNetwork", 
    tags: ["lucide", "chart", "network"], 
    source: "lucide", 
    name: "ChartNetwork",
  }, 
  {
    id: "lucide:ChartNoAxesColumn", 
    tags: ["lucide", "chart", "no", "axes", "column"], 
    source: "lucide", 
    name: "ChartNoAxesColumn",
  }, 
  {
    id: "lucide:ChartNoAxesColumnDecreasing", 
    tags: ["lucide", "chart", "no", "axes", "column", "decreasing"], 
    source: "lucide", 
    name: "ChartNoAxesColumnDecreasing",
  }, 
  {
    id: "lucide:ChartNoAxesColumnIncreasing", 
    tags: ["lucide", "chart", "no", "axes", "column", "increasing"], 
    source: "lucide", 
    name: "ChartNoAxesColumnIncreasing",
  }, 
  {
    id: "lucide:ChartNoAxesCombined", 
    tags: ["lucide", "chart", "no", "axes", "combined"], 
    source: "lucide", 
    name: "ChartNoAxesCombined",
  }, 
  {
    id: "lucide:ChartNoAxesGantt", 
    tags: ["lucide", "chart", "no", "axes", "gantt"], 
    source: "lucide", 
    name: "ChartNoAxesGantt",
  }, 
  {
    id: "lucide:ChartPie", 
    tags: ["lucide", "chart", "pie"], 
    source: "lucide", 
    name: "ChartPie",
  }, 
  {
    id: "lucide:ChartScatter", 
    tags: ["lucide", "chart", "scatter"], 
    source: "lucide", 
    name: "ChartScatter",
  }, 
  {
    id: "lucide:ChartSpline", 
    tags: ["lucide", "chart", "spline"], 
    source: "lucide", 
    name: "ChartSpline",
  }, 
  {
    id: "lucide:Check", 
    tags: ["lucide", "check"], 
    source: "lucide", 
    name: "Check",
  }, 
  {
    id: "lucide:CheckCheck", 
    tags: ["lucide", "check", "check"], 
    source: "lucide", 
    name: "CheckCheck",
  }, 
  {
    id: "lucide:CheckCircle", 
    tags: ["lucide", "check", "circle"], 
    source: "lucide", 
    name: "CheckCircle",
  }, 
  {
    id: "lucide:CheckCircle2", 
    tags: ["lucide", "check", "circle"], 
    source: "lucide", 
    name: "CheckCircle2",
  }, 
  {
    id: "lucide:CheckSquare", 
    tags: ["lucide", "check", "square"], 
    source: "lucide", 
    name: "CheckSquare",
  }, 
  {
    id: "lucide:CheckSquare2", 
    tags: ["lucide", "check", "square"], 
    source: "lucide", 
    name: "CheckSquare2",
  }, 
  {
    id: "lucide:ChefHat", 
    tags: ["lucide", "chef", "hat"], 
    source: "lucide", 
    name: "ChefHat",
  }, 
  {
    id: "lucide:Cherry", 
    tags: ["lucide", "cherry"], 
    source: "lucide", 
    name: "Cherry",
  }, 
  {
    id: "lucide:ChevronDown", 
    tags: ["lucide", "chevron", "down"], 
    source: "lucide", 
    name: "ChevronDown",
  }, 
  {
    id: "lucide:ChevronDownCircle", 
    tags: ["lucide", "chevron", "down", "circle"], 
    source: "lucide", 
    name: "ChevronDownCircle",
  }, 
  {
    id: "lucide:ChevronDownSquare", 
    tags: ["lucide", "chevron", "down", "square"], 
    source: "lucide", 
    name: "ChevronDownSquare",
  }, 
  {
    id: "lucide:ChevronFirst", 
    tags: ["lucide", "chevron", "first"], 
    source: "lucide", 
    name: "ChevronFirst",
  }, 
  {
    id: "lucide:ChevronLast", 
    tags: ["lucide", "chevron", "last"], 
    source: "lucide", 
    name: "ChevronLast",
  }, 
  {
    id: "lucide:ChevronLeft", 
    tags: ["lucide", "chevron", "left"], 
    source: "lucide", 
    name: "ChevronLeft",
  }, 
  {
    id: "lucide:ChevronLeftCircle", 
    tags: ["lucide", "chevron", "left", "circle"], 
    source: "lucide", 
    name: "ChevronLeftCircle",
  }, 
  {
    id: "lucide:ChevronLeftSquare", 
    tags: ["lucide", "chevron", "left", "square"], 
    source: "lucide", 
    name: "ChevronLeftSquare",
  }, 
  {
    id: "lucide:ChevronRight", 
    tags: ["lucide", "chevron", "right"], 
    source: "lucide", 
    name: "ChevronRight",
  }, 
  {
    id: "lucide:ChevronRightCircle", 
    tags: ["lucide", "chevron", "right", "circle"], 
    source: "lucide", 
    name: "ChevronRightCircle",
  }, 
  {
    id: "lucide:ChevronRightSquare", 
    tags: ["lucide", "chevron", "right", "square"], 
    source: "lucide", 
    name: "ChevronRightSquare",
  }, 
  {
    id: "lucide:ChevronUp", 
    tags: ["lucide", "chevron", "up"], 
    source: "lucide", 
    name: "ChevronUp",
  }, 
  {
    id: "lucide:ChevronUpCircle", 
    tags: ["lucide", "chevron", "up", "circle"], 
    source: "lucide", 
    name: "ChevronUpCircle",
  }, 
  {
    id: "lucide:ChevronUpSquare", 
    tags: ["lucide", "chevron", "up", "square"], 
    source: "lucide", 
    name: "ChevronUpSquare",
  }, 
  {
    id: "lucide:ChevronsDown", 
    tags: ["lucide", "chevrons", "down"], 
    source: "lucide", 
    name: "ChevronsDown",
  }, 
  {
    id: "lucide:ChevronsDownUp", 
    tags: ["lucide", "chevrons", "down", "up"], 
    source: "lucide", 
    name: "ChevronsDownUp",
  }, 
  {
    id: "lucide:ChevronsLeft", 
    tags: ["lucide", "chevrons", "left"], 
    source: "lucide", 
    name: "ChevronsLeft",
  }, 
  {
    id: "lucide:ChevronsLeftRight", 
    tags: ["lucide", "chevrons", "left", "right"], 
    source: "lucide", 
    name: "ChevronsLeftRight",
  }, 
  {
    id: "lucide:ChevronsLeftRightEllipsis", 
    tags: ["lucide", "chevrons", "left", "right", "ellipsis"], 
    source: "lucide", 
    name: "ChevronsLeftRightEllipsis",
  }, 
  {
    id: "lucide:ChevronsRight", 
    tags: ["lucide", "chevrons", "right"], 
    source: "lucide", 
    name: "ChevronsRight",
  }, 
  {
    id: "lucide:ChevronsRightLeft", 
    tags: ["lucide", "chevrons", "right", "left"], 
    source: "lucide", 
    name: "ChevronsRightLeft",
  }, 
  {
    id: "lucide:ChevronsUp", 
    tags: ["lucide", "chevrons", "up"], 
    source: "lucide", 
    name: "ChevronsUp",
  }, 
  {
    id: "lucide:ChevronsUpDown", 
    tags: ["lucide", "chevrons", "up", "down"], 
    source: "lucide", 
    name: "ChevronsUpDown",
  }, 
  {
    id: "lucide:Chrome", 
    tags: ["lucide", "chrome"], 
    source: "lucide", 
    name: "Chrome",
  }, 
  {
    id: "lucide:Church", 
    tags: ["lucide", "church"], 
    source: "lucide", 
    name: "Church",
  }, 
  {
    id: "lucide:Cigarette", 
    tags: ["lucide", "cigarette"], 
    source: "lucide", 
    name: "Cigarette",
  }, 
  {
    id: "lucide:CigaretteOff", 
    tags: ["lucide", "cigarette", "off"], 
    source: "lucide", 
    name: "CigaretteOff",
  }, 
  {
    id: "lucide:Circle", 
    tags: ["lucide", "circle"], 
    source: "lucide", 
    name: "Circle",
  }, 
  {
    id: "lucide:CircleAlert", 
    tags: ["lucide", "circle", "alert"], 
    source: "lucide", 
    name: "CircleAlert",
  }, 
  {
    id: "lucide:CircleArrowDown", 
    tags: ["lucide", "circle", "arrow", "down"], 
    source: "lucide", 
    name: "CircleArrowDown",
  }, 
  {
    id: "lucide:CircleArrowLeft", 
    tags: ["lucide", "circle", "arrow", "left"], 
    source: "lucide", 
    name: "CircleArrowLeft",
  }, 
  {
    id: "lucide:CircleArrowOutDownLeft", 
    tags: ["lucide", "circle", "arrow", "out", "down", "left"], 
    source: "lucide", 
    name: "CircleArrowOutDownLeft",
  }, 
  {
    id: "lucide:CircleArrowOutDownRight", 
    tags: ["lucide", "circle", "arrow", "out", "down", "right"], 
    source: "lucide", 
    name: "CircleArrowOutDownRight",
  }, 
  {
    id: "lucide:CircleArrowOutUpLeft", 
    tags: ["lucide", "circle", "arrow", "out", "up", "left"], 
    source: "lucide", 
    name: "CircleArrowOutUpLeft",
  }, 
  {
    id: "lucide:CircleArrowOutUpRight", 
    tags: ["lucide", "circle", "arrow", "out", "up", "right"], 
    source: "lucide", 
    name: "CircleArrowOutUpRight",
  }, 
  {
    id: "lucide:CircleArrowRight", 
    tags: ["lucide", "circle", "arrow", "right"], 
    source: "lucide", 
    name: "CircleArrowRight",
  }, 
  {
    id: "lucide:CircleArrowUp", 
    tags: ["lucide", "circle", "arrow", "up"], 
    source: "lucide", 
    name: "CircleArrowUp",
  }, 
  {
    id: "lucide:CircleCheck", 
    tags: ["lucide", "circle", "check"], 
    source: "lucide", 
    name: "CircleCheck",
  }, 
  {
    id: "lucide:CircleCheckBig", 
    tags: ["lucide", "circle", "check", "big"], 
    source: "lucide", 
    name: "CircleCheckBig",
  }, 
  {
    id: "lucide:CircleChevronDown", 
    tags: ["lucide", "circle", "chevron", "down"], 
    source: "lucide", 
    name: "CircleChevronDown",
  }, 
  {
    id: "lucide:CircleChevronLeft", 
    tags: ["lucide", "circle", "chevron", "left"], 
    source: "lucide", 
    name: "CircleChevronLeft",
  }, 
  {
    id: "lucide:CircleChevronRight", 
    tags: ["lucide", "circle", "chevron", "right"], 
    source: "lucide", 
    name: "CircleChevronRight",
  }, 
  {
    id: "lucide:CircleChevronUp", 
    tags: ["lucide", "circle", "chevron", "up"], 
    source: "lucide", 
    name: "CircleChevronUp",
  }, 
  {
    id: "lucide:CircleDashed", 
    tags: ["lucide", "circle", "dashed"], 
    source: "lucide", 
    name: "CircleDashed",
  }, 
  {
    id: "lucide:CircleDivide", 
    tags: ["lucide", "circle", "divide"], 
    source: "lucide", 
    name: "CircleDivide",
  }, 
  {
    id: "lucide:CircleDollarSign", 
    tags: ["lucide", "circle", "dollar", "sign"], 
    source: "lucide", 
    name: "CircleDollarSign",
  }, 
  {
    id: "lucide:CircleDot", 
    tags: ["lucide", "circle", "dot"], 
    source: "lucide", 
    name: "CircleDot",
  }, 
  {
    id: "lucide:CircleDotDashed", 
    tags: ["lucide", "circle", "dot", "dashed"], 
    source: "lucide", 
    name: "CircleDotDashed",
  }, 
  {
    id: "lucide:CircleEllipsis", 
    tags: ["lucide", "circle", "ellipsis"], 
    source: "lucide", 
    name: "CircleEllipsis",
  }, 
  {
    id: "lucide:CircleEqual", 
    tags: ["lucide", "circle", "equal"], 
    source: "lucide", 
    name: "CircleEqual",
  }, 
  {
    id: "lucide:CircleFadingArrowUp", 
    tags: ["lucide", "circle", "fading", "arrow", "up"], 
    source: "lucide", 
    name: "CircleFadingArrowUp",
  }, 
  {
    id: "lucide:CircleFadingPlus", 
    tags: ["lucide", "circle", "fading", "plus"], 
    source: "lucide", 
    name: "CircleFadingPlus",
  }, 
  {
    id: "lucide:CircleGauge", 
    tags: ["lucide", "circle", "gauge"], 
    source: "lucide", 
    name: "CircleGauge",
  }, 
  {
    id: "lucide:CircleHelp", 
    tags: ["lucide", "circle", "help"], 
    source: "lucide", 
    name: "CircleHelp",
  }, 
  {
    id: "lucide:CircleMinus", 
    tags: ["lucide", "circle", "minus"], 
    source: "lucide", 
    name: "CircleMinus",
  }, 
  {
    id: "lucide:CircleOff", 
    tags: ["lucide", "circle", "off"], 
    source: "lucide", 
    name: "CircleOff",
  }, 
  {
    id: "lucide:CircleParking", 
    tags: ["lucide", "circle", "parking"], 
    source: "lucide", 
    name: "CircleParking",
  }, 
  {
    id: "lucide:CircleParkingOff", 
    tags: ["lucide", "circle", "parking", "off"], 
    source: "lucide", 
    name: "CircleParkingOff",
  }, 
  {
    id: "lucide:CirclePause", 
    tags: ["lucide", "circle", "pause"], 
    source: "lucide", 
    name: "CirclePause",
  }, 
  {
    id: "lucide:CirclePercent", 
    tags: ["lucide", "circle", "percent"], 
    source: "lucide", 
    name: "CirclePercent",
  }, 
  {
    id: "lucide:CirclePlay", 
    tags: ["lucide", "circle", "play"], 
    source: "lucide", 
    name: "CirclePlay",
  }, 
  {
    id: "lucide:CirclePlus", 
    tags: ["lucide", "circle", "plus"], 
    source: "lucide", 
    name: "CirclePlus",
  }, 
  {
    id: "lucide:CirclePower", 
    tags: ["lucide", "circle", "power"], 
    source: "lucide", 
    name: "CirclePower",
  }, 
  {
    id: "lucide:CircleSlash", 
    tags: ["lucide", "circle", "slash"], 
    source: "lucide", 
    name: "CircleSlash",
  }, 
  {
    id: "lucide:CircleSlash2", 
    tags: ["lucide", "circle", "slash"], 
    source: "lucide", 
    name: "CircleSlash2",
  }, 
  {
    id: "lucide:CircleSlashed", 
    tags: ["lucide", "circle", "slashed"], 
    source: "lucide", 
    name: "CircleSlashed",
  }, 
  {
    id: "lucide:CircleStop", 
    tags: ["lucide", "circle", "stop"], 
    source: "lucide", 
    name: "CircleStop",
  }, 
  {
    id: "lucide:CircleUser", 
    tags: ["lucide", "circle", "user"], 
    source: "lucide", 
    name: "CircleUser",
  }, 
  {
    id: "lucide:CircleUserRound", 
    tags: ["lucide", "circle", "user", "round"], 
    source: "lucide", 
    name: "CircleUserRound",
  }, 
  {
    id: "lucide:CircleX", 
    tags: ["lucide", "circle"], 
    source: "lucide", 
    name: "CircleX",
  }, 
  {
    id: "lucide:CircuitBoard", 
    tags: ["lucide", "circuit", "board"], 
    source: "lucide", 
    name: "CircuitBoard",
  }, 
  {
    id: "lucide:Citrus", 
    tags: ["lucide", "citrus"], 
    source: "lucide", 
    name: "Citrus",
  }, 
  {
    id: "lucide:Clapperboard", 
    tags: ["lucide", "clapperboard"], 
    source: "lucide", 
    name: "Clapperboard",
  }, 
  {
    id: "lucide:Clipboard", 
    tags: ["lucide", "clipboard"], 
    source: "lucide", 
    name: "Clipboard",
  }, 
  {
    id: "lucide:ClipboardCheck", 
    tags: ["lucide", "clipboard", "check"], 
    source: "lucide", 
    name: "ClipboardCheck",
  }, 
  {
    id: "lucide:ClipboardCopy", 
    tags: ["lucide", "clipboard", "copy"], 
    source: "lucide", 
    name: "ClipboardCopy",
  }, 
  {
    id: "lucide:ClipboardEdit", 
    tags: ["lucide", "clipboard", "edit"], 
    source: "lucide", 
    name: "ClipboardEdit",
  }, 
  {
    id: "lucide:ClipboardList", 
    tags: ["lucide", "clipboard", "list"], 
    source: "lucide", 
    name: "ClipboardList",
  }, 
  {
    id: "lucide:ClipboardMinus", 
    tags: ["lucide", "clipboard", "minus"], 
    source: "lucide", 
    name: "ClipboardMinus",
  }, 
  {
    id: "lucide:ClipboardPaste", 
    tags: ["lucide", "clipboard", "paste"], 
    source: "lucide", 
    name: "ClipboardPaste",
  }, 
  {
    id: "lucide:ClipboardPen", 
    tags: ["lucide", "clipboard", "pen"], 
    source: "lucide", 
    name: "ClipboardPen",
  }, 
  {
    id: "lucide:ClipboardPenLine", 
    tags: ["lucide", "clipboard", "pen", "line"], 
    source: "lucide", 
    name: "ClipboardPenLine",
  }, 
  {
    id: "lucide:ClipboardPlus", 
    tags: ["lucide", "clipboard", "plus"], 
    source: "lucide", 
    name: "ClipboardPlus",
  }, 
  {
    id: "lucide:ClipboardSignature", 
    tags: ["lucide", "clipboard", "signature"], 
    source: "lucide", 
    name: "ClipboardSignature",
  }, 
  {
    id: "lucide:ClipboardType", 
    tags: ["lucide", "clipboard", "type"], 
    source: "lucide", 
    name: "ClipboardType",
  }, 
  {
    id: "lucide:ClipboardX", 
    tags: ["lucide", "clipboard"], 
    source: "lucide", 
    name: "ClipboardX",
  }, 
  {
    id: "lucide:Clock", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock",
  }, 
  {
    id: "lucide:Clock1", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock1",
  }, 
  {
    id: "lucide:Clock10", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock10",
  }, 
  {
    id: "lucide:Clock11", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock11",
  }, 
  {
    id: "lucide:Clock12", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock12",
  }, 
  {
    id: "lucide:Clock2", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock2",
  }, 
  {
    id: "lucide:Clock3", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock3",
  }, 
  {
    id: "lucide:Clock4", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock4",
  }, 
  {
    id: "lucide:Clock5", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock5",
  }, 
  {
    id: "lucide:Clock6", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock6",
  }, 
  {
    id: "lucide:Clock7", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock7",
  }, 
  {
    id: "lucide:Clock8", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock8",
  }, 
  {
    id: "lucide:Clock9", 
    tags: ["lucide", "clock"], 
    source: "lucide", 
    name: "Clock9",
  }, 
  {
    id: "lucide:ClockAlert", 
    tags: ["lucide", "clock", "alert"], 
    source: "lucide", 
    name: "ClockAlert",
  }, 
  {
    id: "lucide:ClockArrowDown", 
    tags: ["lucide", "clock", "arrow", "down"], 
    source: "lucide", 
    name: "ClockArrowDown",
  }, 
  {
    id: "lucide:ClockArrowUp", 
    tags: ["lucide", "clock", "arrow", "up"], 
    source: "lucide", 
    name: "ClockArrowUp",
  }, 
  {
    id: "lucide:Cloud", 
    tags: ["lucide", "cloud"], 
    source: "lucide", 
    name: "Cloud",
  }, 
  {
    id: "lucide:CloudAlert", 
    tags: ["lucide", "cloud", "alert"], 
    source: "lucide", 
    name: "CloudAlert",
  }, 
  {
    id: "lucide:CloudCog", 
    tags: ["lucide", "cloud", "cog"], 
    source: "lucide", 
    name: "CloudCog",
  }, 
  {
    id: "lucide:CloudDownload", 
    tags: ["lucide", "cloud", "download"], 
    source: "lucide", 
    name: "CloudDownload",
  }, 
  {
    id: "lucide:CloudDrizzle", 
    tags: ["lucide", "cloud", "drizzle"], 
    source: "lucide", 
    name: "CloudDrizzle",
  }, 
  {
    id: "lucide:CloudFog", 
    tags: ["lucide", "cloud", "fog"], 
    source: "lucide", 
    name: "CloudFog",
  }, 
  {
    id: "lucide:CloudHail", 
    tags: ["lucide", "cloud", "hail"], 
    source: "lucide", 
    name: "CloudHail",
  }, 
  {
    id: "lucide:CloudLightning", 
    tags: ["lucide", "cloud", "lightning"], 
    source: "lucide", 
    name: "CloudLightning",
  }, 
  {
    id: "lucide:CloudMoon", 
    tags: ["lucide", "cloud", "moon"], 
    source: "lucide", 
    name: "CloudMoon",
  }, 
  {
    id: "lucide:CloudMoonRain", 
    tags: ["lucide", "cloud", "moon", "rain"], 
    source: "lucide", 
    name: "CloudMoonRain",
  }, 
  {
    id: "lucide:CloudOff", 
    tags: ["lucide", "cloud", "off"], 
    source: "lucide", 
    name: "CloudOff",
  }, 
  {
    id: "lucide:CloudRain", 
    tags: ["lucide", "cloud", "rain"], 
    source: "lucide", 
    name: "CloudRain",
  }, 
  {
    id: "lucide:CloudRainWind", 
    tags: ["lucide", "cloud", "rain", "wind"], 
    source: "lucide", 
    name: "CloudRainWind",
  }, 
  {
    id: "lucide:CloudSnow", 
    tags: ["lucide", "cloud", "snow"], 
    source: "lucide", 
    name: "CloudSnow",
  }, 
  {
    id: "lucide:CloudSun", 
    tags: ["lucide", "cloud", "sun"], 
    source: "lucide", 
    name: "CloudSun",
  }, 
  {
    id: "lucide:CloudSunRain", 
    tags: ["lucide", "cloud", "sun", "rain"], 
    source: "lucide", 
    name: "CloudSunRain",
  }, 
  {
    id: "lucide:CloudUpload", 
    tags: ["lucide", "cloud", "upload"], 
    source: "lucide", 
    name: "CloudUpload",
  }, 
  {
    id: "lucide:Cloudy", 
    tags: ["lucide", "cloudy"], 
    source: "lucide", 
    name: "Cloudy",
  }, 
  {
    id: "lucide:Clover", 
    tags: ["lucide", "clover"], 
    source: "lucide", 
    name: "Clover",
  }, 
  {
    id: "lucide:Club", 
    tags: ["lucide", "club"], 
    source: "lucide", 
    name: "Club",
  }, 
  {
    id: "lucide:Code", 
    tags: ["lucide", "code"], 
    source: "lucide", 
    name: "Code",
  }, 
  {
    id: "lucide:Code2", 
    tags: ["lucide", "code"], 
    source: "lucide", 
    name: "Code2",
  }, 
  {
    id: "lucide:CodeSquare", 
    tags: ["lucide", "code", "square"], 
    source: "lucide", 
    name: "CodeSquare",
  }, 
  {
    id: "lucide:CodeXml", 
    tags: ["lucide", "code", "xml"], 
    source: "lucide", 
    name: "CodeXml",
  }, 
  {
    id: "lucide:Codepen", 
    tags: ["lucide", "codepen"], 
    source: "lucide", 
    name: "Codepen",
  }, 
  {
    id: "lucide:Codesandbox", 
    tags: ["lucide", "codesandbox"], 
    source: "lucide", 
    name: "Codesandbox",
  }, 
  {
    id: "lucide:Coffee", 
    tags: ["lucide", "coffee"], 
    source: "lucide", 
    name: "Coffee",
  }, 
  {
    id: "lucide:Cog", 
    tags: ["lucide", "cog"], 
    source: "lucide", 
    name: "Cog",
  }, 
  {
    id: "lucide:Coins", 
    tags: ["lucide", "coins"], 
    source: "lucide", 
    name: "Coins",
  }, 
  {
    id: "lucide:Columns", 
    tags: ["lucide", "columns"], 
    source: "lucide", 
    name: "Columns",
  }, 
  {
    id: "lucide:Columns2", 
    tags: ["lucide", "columns"], 
    source: "lucide", 
    name: "Columns2",
  }, 
  {
    id: "lucide:Columns3", 
    tags: ["lucide", "columns"], 
    source: "lucide", 
    name: "Columns3",
  }, 
  {
    id: "lucide:Columns4", 
    tags: ["lucide", "columns"], 
    source: "lucide", 
    name: "Columns4",
  }, 
  {
    id: "lucide:Combine", 
    tags: ["lucide", "combine"], 
    source: "lucide", 
    name: "Combine",
  }, 
  {
    id: "lucide:Command", 
    tags: ["lucide", "command"], 
    source: "lucide", 
    name: "Command",
  }, 
  {
    id: "lucide:Compass", 
    tags: ["lucide", "compass"], 
    source: "lucide", 
    name: "Compass",
  }, 
  {
    id: "lucide:Component", 
    tags: ["lucide", "component"], 
    source: "lucide", 
    name: "Component",
  }, 
  {
    id: "lucide:Computer", 
    tags: ["lucide", "computer"], 
    source: "lucide", 
    name: "Computer",
  }, 
  {
    id: "lucide:ConciergeBell", 
    tags: ["lucide", "concierge", "bell"], 
    source: "lucide", 
    name: "ConciergeBell",
  }, 
  {
    id: "lucide:Cone", 
    tags: ["lucide", "cone"], 
    source: "lucide", 
    name: "Cone",
  }, 
  {
    id: "lucide:Construction", 
    tags: ["lucide", "construction"], 
    source: "lucide", 
    name: "Construction",
  }, 
  {
    id: "lucide:Contact", 
    tags: ["lucide", "contact"], 
    source: "lucide", 
    name: "Contact",
  }, 
  {
    id: "lucide:Contact2", 
    tags: ["lucide", "contact"], 
    source: "lucide", 
    name: "Contact2",
  }, 
  {
    id: "lucide:ContactRound", 
    tags: ["lucide", "contact", "round"], 
    source: "lucide", 
    name: "ContactRound",
  }, 
  {
    id: "lucide:Container", 
    tags: ["lucide", "container"], 
    source: "lucide", 
    name: "Container",
  }, 
  {
    id: "lucide:Contrast", 
    tags: ["lucide", "contrast"], 
    source: "lucide", 
    name: "Contrast",
  }, 
  {
    id: "lucide:Cookie", 
    tags: ["lucide", "cookie"], 
    source: "lucide", 
    name: "Cookie",
  }, 
  {
    id: "lucide:CookingPot", 
    tags: ["lucide", "cooking", "pot"], 
    source: "lucide", 
    name: "CookingPot",
  }, 
  {
    id: "lucide:Copy", 
    tags: ["lucide", "copy"], 
    source: "lucide", 
    name: "Copy",
  }, 
  {
    id: "lucide:CopyCheck", 
    tags: ["lucide", "copy", "check"], 
    source: "lucide", 
    name: "CopyCheck",
  }, 
  {
    id: "lucide:CopyMinus", 
    tags: ["lucide", "copy", "minus"], 
    source: "lucide", 
    name: "CopyMinus",
  }, 
  {
    id: "lucide:CopyPlus", 
    tags: ["lucide", "copy", "plus"], 
    source: "lucide", 
    name: "CopyPlus",
  }, 
  {
    id: "lucide:CopySlash", 
    tags: ["lucide", "copy", "slash"], 
    source: "lucide", 
    name: "CopySlash",
  }, 
  {
    id: "lucide:CopyX", 
    tags: ["lucide", "copy"], 
    source: "lucide", 
    name: "CopyX",
  }, 
  {
    id: "lucide:Copyleft", 
    tags: ["lucide", "copyleft"], 
    source: "lucide", 
    name: "Copyleft",
  }, 
  {
    id: "lucide:Copyright", 
    tags: ["lucide", "copyright"], 
    source: "lucide", 
    name: "Copyright",
  }, 
  {
    id: "lucide:CornerDownLeft", 
    tags: ["lucide", "corner", "down", "left"], 
    source: "lucide", 
    name: "CornerDownLeft",
  }, 
  {
    id: "lucide:CornerDownRight", 
    tags: ["lucide", "corner", "down", "right"], 
    source: "lucide", 
    name: "CornerDownRight",
  }, 
  {
    id: "lucide:CornerLeftDown", 
    tags: ["lucide", "corner", "left", "down"], 
    source: "lucide", 
    name: "CornerLeftDown",
  }, 
  {
    id: "lucide:CornerLeftUp", 
    tags: ["lucide", "corner", "left", "up"], 
    source: "lucide", 
    name: "CornerLeftUp",
  }, 
  {
    id: "lucide:CornerRightDown", 
    tags: ["lucide", "corner", "right", "down"], 
    source: "lucide", 
    name: "CornerRightDown",
  }, 
  {
    id: "lucide:CornerRightUp", 
    tags: ["lucide", "corner", "right", "up"], 
    source: "lucide", 
    name: "CornerRightUp",
  }, 
  {
    id: "lucide:CornerUpLeft", 
    tags: ["lucide", "corner", "up", "left"], 
    source: "lucide", 
    name: "CornerUpLeft",
  }, 
  {
    id: "lucide:CornerUpRight", 
    tags: ["lucide", "corner", "up", "right"], 
    source: "lucide", 
    name: "CornerUpRight",
  }, 
  {
    id: "lucide:Cpu", 
    tags: ["lucide", "cpu"], 
    source: "lucide", 
    name: "Cpu",
  }, 
  {
    id: "lucide:CreativeCommons", 
    tags: ["lucide", "creative", "commons"], 
    source: "lucide", 
    name: "CreativeCommons",
  }, 
  {
    id: "lucide:CreditCard", 
    tags: ["lucide", "credit", "card"], 
    source: "lucide", 
    name: "CreditCard",
  }, 
  {
    id: "lucide:Croissant", 
    tags: ["lucide", "croissant"], 
    source: "lucide", 
    name: "Croissant",
  }, 
  {
    id: "lucide:Crop", 
    tags: ["lucide", "crop"], 
    source: "lucide", 
    name: "Crop",
  }, 
  {
    id: "lucide:Cross", 
    tags: ["lucide", "cross"], 
    source: "lucide", 
    name: "Cross",
  }, 
  {
    id: "lucide:Crosshair", 
    tags: ["lucide", "crosshair"], 
    source: "lucide", 
    name: "Crosshair",
  }, 
  {
    id: "lucide:Crown", 
    tags: ["lucide", "crown"], 
    source: "lucide", 
    name: "Crown",
  }, 
  {
    id: "lucide:Cuboid", 
    tags: ["lucide", "cuboid"], 
    source: "lucide", 
    name: "Cuboid",
  }, 
  {
    id: "lucide:CupSoda", 
    tags: ["lucide", "cup", "soda"], 
    source: "lucide", 
    name: "CupSoda",
  }, 
  {
    id: "lucide:CurlyBraces", 
    tags: ["lucide", "curly", "braces"], 
    source: "lucide", 
    name: "CurlyBraces",
  }, 
  {
    id: "lucide:Currency", 
    tags: ["lucide", "currency"], 
    source: "lucide", 
    name: "Currency",
  }, 
  {
    id: "lucide:Cylinder", 
    tags: ["lucide", "cylinder"], 
    source: "lucide", 
    name: "Cylinder",
  }, 
  {
    id: "lucide:Dam", 
    tags: ["lucide", "dam"], 
    source: "lucide", 
    name: "Dam",
  }, 
  {
    id: "lucide:Database", 
    tags: ["lucide", "database"], 
    source: "lucide", 
    name: "Database",
  }, 
  {
    id: "lucide:DatabaseBackup", 
    tags: ["lucide", "database", "backup"], 
    source: "lucide", 
    name: "DatabaseBackup",
  }, 
  {
    id: "lucide:DatabaseZap", 
    tags: ["lucide", "database", "zap"], 
    source: "lucide", 
    name: "DatabaseZap",
  }, 
  {
    id: "lucide:Delete", 
    tags: ["lucide", "delete"], 
    source: "lucide", 
    name: "Delete",
  }, 
  {
    id: "lucide:Dessert", 
    tags: ["lucide", "dessert"], 
    source: "lucide", 
    name: "Dessert",
  }, 
  {
    id: "lucide:Diameter", 
    tags: ["lucide", "diameter"], 
    source: "lucide", 
    name: "Diameter",
  }, 
  {
    id: "lucide:Diamond", 
    tags: ["lucide", "diamond"], 
    source: "lucide", 
    name: "Diamond",
  }, 
  {
    id: "lucide:DiamondMinus", 
    tags: ["lucide", "diamond", "minus"], 
    source: "lucide", 
    name: "DiamondMinus",
  }, 
  {
    id: "lucide:DiamondPercent", 
    tags: ["lucide", "diamond", "percent"], 
    source: "lucide", 
    name: "DiamondPercent",
  }, 
  {
    id: "lucide:DiamondPlus", 
    tags: ["lucide", "diamond", "plus"], 
    source: "lucide", 
    name: "DiamondPlus",
  }, 
  {
    id: "lucide:Dice1", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice1",
  }, 
  {
    id: "lucide:Dice2", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice2",
  }, 
  {
    id: "lucide:Dice3", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice3",
  }, 
  {
    id: "lucide:Dice4", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice4",
  }, 
  {
    id: "lucide:Dice5", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice5",
  }, 
  {
    id: "lucide:Dice6", 
    tags: ["lucide", "dice"], 
    source: "lucide", 
    name: "Dice6",
  }, 
  {
    id: "lucide:Dices", 
    tags: ["lucide", "dices"], 
    source: "lucide", 
    name: "Dices",
  }, 
  {
    id: "lucide:Diff", 
    tags: ["lucide", "diff"], 
    source: "lucide", 
    name: "Diff",
  }, 
  {
    id: "lucide:Disc", 
    tags: ["lucide", "disc"], 
    source: "lucide", 
    name: "Disc",
  }, 
  {
    id: "lucide:Disc2", 
    tags: ["lucide", "disc"], 
    source: "lucide", 
    name: "Disc2",
  }, 
  {
    id: "lucide:Disc3", 
    tags: ["lucide", "disc"], 
    source: "lucide", 
    name: "Disc3",
  }, 
  {
    id: "lucide:DiscAlbum", 
    tags: ["lucide", "disc", "album"], 
    source: "lucide", 
    name: "DiscAlbum",
  }, 
  {
    id: "lucide:Divide", 
    tags: ["lucide", "divide"], 
    source: "lucide", 
    name: "Divide",
  }, 
  {
    id: "lucide:DivideCircle", 
    tags: ["lucide", "divide", "circle"], 
    source: "lucide", 
    name: "DivideCircle",
  }, 
  {
    id: "lucide:DivideSquare", 
    tags: ["lucide", "divide", "square"], 
    source: "lucide", 
    name: "DivideSquare",
  }, 
  {
    id: "lucide:Dna", 
    tags: ["lucide", "dna"], 
    source: "lucide", 
    name: "Dna",
  }, 
  {
    id: "lucide:DnaOff", 
    tags: ["lucide", "dna", "off"], 
    source: "lucide", 
    name: "DnaOff",
  }, 
  {
    id: "lucide:Dock", 
    tags: ["lucide", "dock"], 
    source: "lucide", 
    name: "Dock",
  }, 
  {
    id: "lucide:Dog", 
    tags: ["lucide", "dog"], 
    source: "lucide", 
    name: "Dog",
  }, 
  {
    id: "lucide:DollarSign", 
    tags: ["lucide", "dollar", "sign"], 
    source: "lucide", 
    name: "DollarSign",
  }, 
  {
    id: "lucide:Donut", 
    tags: ["lucide", "donut"], 
    source: "lucide", 
    name: "Donut",
  }, 
  {
    id: "lucide:DoorClosed", 
    tags: ["lucide", "door", "closed"], 
    source: "lucide", 
    name: "DoorClosed",
  }, 
  {
    id: "lucide:DoorOpen", 
    tags: ["lucide", "door", "open"], 
    source: "lucide", 
    name: "DoorOpen",
  }, 
  {
    id: "lucide:Dot", 
    tags: ["lucide", "dot"], 
    source: "lucide", 
    name: "Dot",
  }, 
  {
    id: "lucide:DotSquare", 
    tags: ["lucide", "dot", "square"], 
    source: "lucide", 
    name: "DotSquare",
  }, 
  {
    id: "lucide:Download", 
    tags: ["lucide", "download"], 
    source: "lucide", 
    name: "Download",
  }, 
  {
    id: "lucide:DownloadCloud", 
    tags: ["lucide", "download", "cloud"], 
    source: "lucide", 
    name: "DownloadCloud",
  }, 
  {
    id: "lucide:DraftingCompass", 
    tags: ["lucide", "drafting", "compass"], 
    source: "lucide", 
    name: "DraftingCompass",
  }, 
  {
    id: "lucide:Drama", 
    tags: ["lucide", "drama"], 
    source: "lucide", 
    name: "Drama",
  }, 
  {
    id: "lucide:Dribbble", 
    tags: ["lucide", "dribbble"], 
    source: "lucide", 
    name: "Dribbble",
  }, 
  {
    id: "lucide:Drill", 
    tags: ["lucide", "drill"], 
    source: "lucide", 
    name: "Drill",
  }, 
  {
    id: "lucide:Droplet", 
    tags: ["lucide", "droplet"], 
    source: "lucide", 
    name: "Droplet",
  }, 
  {
    id: "lucide:DropletOff", 
    tags: ["lucide", "droplet", "off"], 
    source: "lucide", 
    name: "DropletOff",
  }, 
  {
    id: "lucide:Droplets", 
    tags: ["lucide", "droplets"], 
    source: "lucide", 
    name: "Droplets",
  }, 
  {
    id: "lucide:Drum", 
    tags: ["lucide", "drum"], 
    source: "lucide", 
    name: "Drum",
  }, 
  {
    id: "lucide:Drumstick", 
    tags: ["lucide", "drumstick"], 
    source: "lucide", 
    name: "Drumstick",
  }, 
  {
    id: "lucide:Dumbbell", 
    tags: ["lucide", "dumbbell"], 
    source: "lucide", 
    name: "Dumbbell",
  }, 
  {
    id: "lucide:Ear", 
    tags: ["lucide", "ear"], 
    source: "lucide", 
    name: "Ear",
  }, 
  {
    id: "lucide:EarOff", 
    tags: ["lucide", "ear", "off"], 
    source: "lucide", 
    name: "EarOff",
  }, 
  {
    id: "lucide:Earth", 
    tags: ["lucide", "earth"], 
    source: "lucide", 
    name: "Earth",
  }, 
  {
    id: "lucide:EarthLock", 
    tags: ["lucide", "earth", "lock"], 
    source: "lucide", 
    name: "EarthLock",
  }, 
  {
    id: "lucide:Eclipse", 
    tags: ["lucide", "eclipse"], 
    source: "lucide", 
    name: "Eclipse",
  }, 
  {
    id: "lucide:Edit", 
    tags: ["lucide", "edit"], 
    source: "lucide", 
    name: "Edit",
  }, 
  {
    id: "lucide:Edit2", 
    tags: ["lucide", "edit"], 
    source: "lucide", 
    name: "Edit2",
  }, 
  {
    id: "lucide:Edit3", 
    tags: ["lucide", "edit"], 
    source: "lucide", 
    name: "Edit3",
  }, 
  {
    id: "lucide:Egg", 
    tags: ["lucide", "egg"], 
    source: "lucide", 
    name: "Egg",
  }, 
  {
    id: "lucide:EggFried", 
    tags: ["lucide", "egg", "fried"], 
    source: "lucide", 
    name: "EggFried",
  }, 
  {
    id: "lucide:EggOff", 
    tags: ["lucide", "egg", "off"], 
    source: "lucide", 
    name: "EggOff",
  }, 
  {
    id: "lucide:Ellipsis", 
    tags: ["lucide", "ellipsis"], 
    source: "lucide", 
    name: "Ellipsis",
  }, 
  {
    id: "lucide:EllipsisVertical", 
    tags: ["lucide", "ellipsis", "vertical"], 
    source: "lucide", 
    name: "EllipsisVertical",
  }, 
  {
    id: "lucide:Equal", 
    tags: ["lucide", "equal"], 
    source: "lucide", 
    name: "Equal",
  }, 
  {
    id: "lucide:EqualApproximately", 
    tags: ["lucide", "equal", "approximately"], 
    source: "lucide", 
    name: "EqualApproximately",
  }, 
  {
    id: "lucide:EqualNot", 
    tags: ["lucide", "equal", "not"], 
    source: "lucide", 
    name: "EqualNot",
  }, 
  {
    id: "lucide:EqualSquare", 
    tags: ["lucide", "equal", "square"], 
    source: "lucide", 
    name: "EqualSquare",
  }, 
  {
    id: "lucide:Eraser", 
    tags: ["lucide", "eraser"], 
    source: "lucide", 
    name: "Eraser",
  }, 
  {
    id: "lucide:EthernetPort", 
    tags: ["lucide", "ethernet", "port"], 
    source: "lucide", 
    name: "EthernetPort",
  }, 
  {
    id: "lucide:Euro", 
    tags: ["lucide", "euro"], 
    source: "lucide", 
    name: "Euro",
  }, 
  {
    id: "lucide:Expand", 
    tags: ["lucide", "expand"], 
    source: "lucide", 
    name: "Expand",
  }, 
  {
    id: "lucide:ExternalLink", 
    tags: ["lucide", "external", "link"], 
    source: "lucide", 
    name: "ExternalLink",
  }, 
  {
    id: "lucide:Eye", 
    tags: ["lucide", "eye"], 
    source: "lucide", 
    name: "Eye",
  }, 
  {
    id: "lucide:EyeClosed", 
    tags: ["lucide", "eye", "closed"], 
    source: "lucide", 
    name: "EyeClosed",
  }, 
  {
    id: "lucide:EyeOff", 
    tags: ["lucide", "eye", "off"], 
    source: "lucide", 
    name: "EyeOff",
  }, 
  {
    id: "lucide:Facebook", 
    tags: ["lucide", "facebook"], 
    source: "lucide", 
    name: "Facebook",
  }, 
  {
    id: "lucide:Factory", 
    tags: ["lucide", "factory"], 
    source: "lucide", 
    name: "Factory",
  }, 
  {
    id: "lucide:Fan", 
    tags: ["lucide", "fan"], 
    source: "lucide", 
    name: "Fan",
  }, 
  {
    id: "lucide:FastForward", 
    tags: ["lucide", "fast", "forward"], 
    source: "lucide", 
    name: "FastForward",
  }, 
  {
    id: "lucide:Feather", 
    tags: ["lucide", "feather"], 
    source: "lucide", 
    name: "Feather",
  }, 
  {
    id: "lucide:Fence", 
    tags: ["lucide", "fence"], 
    source: "lucide", 
    name: "Fence",
  }, 
  {
    id: "lucide:FerrisWheel", 
    tags: ["lucide", "ferris", "wheel"], 
    source: "lucide", 
    name: "FerrisWheel",
  }, 
  {
    id: "lucide:Figma", 
    tags: ["lucide", "figma"], 
    source: "lucide", 
    name: "Figma",
  }, 
  {
    id: "lucide:File", 
    tags: ["lucide", "file"], 
    source: "lucide", 
    name: "File",
  }, 
  {
    id: "lucide:FileArchive", 
    tags: ["lucide", "file", "archive"], 
    source: "lucide", 
    name: "FileArchive",
  }, 
  {
    id: "lucide:FileAudio", 
    tags: ["lucide", "file", "audio"], 
    source: "lucide", 
    name: "FileAudio",
  }, 
  {
    id: "lucide:FileAudio2", 
    tags: ["lucide", "file", "audio"], 
    source: "lucide", 
    name: "FileAudio2",
  }, 
  {
    id: "lucide:FileAxis3d", 
    tags: ["lucide", "file", "axis"], 
    source: "lucide", 
    name: "FileAxis3d",
  }, 
  {
    id: "lucide:FileBadge", 
    tags: ["lucide", "file", "badge"], 
    source: "lucide", 
    name: "FileBadge",
  }, 
  {
    id: "lucide:FileBadge2", 
    tags: ["lucide", "file", "badge"], 
    source: "lucide", 
    name: "FileBadge2",
  }, 
  {
    id: "lucide:FileBarChart", 
    tags: ["lucide", "file", "bar", "chart"], 
    source: "lucide", 
    name: "FileBarChart",
  }, 
  {
    id: "lucide:FileBarChart2", 
    tags: ["lucide", "file", "bar", "chart"], 
    source: "lucide", 
    name: "FileBarChart2",
  }, 
  {
    id: "lucide:FileBox", 
    tags: ["lucide", "file", "box"], 
    source: "lucide", 
    name: "FileBox",
  }, 
  {
    id: "lucide:FileChartColumn", 
    tags: ["lucide", "file", "chart", "column"], 
    source: "lucide", 
    name: "FileChartColumn",
  }, 
  {
    id: "lucide:FileChartColumnIncreasing", 
    tags: ["lucide", "file", "chart", "column", "increasing"], 
    source: "lucide", 
    name: "FileChartColumnIncreasing",
  }, 
  {
    id: "lucide:FileChartLine", 
    tags: ["lucide", "file", "chart", "line"], 
    source: "lucide", 
    name: "FileChartLine",
  }, 
  {
    id: "lucide:FileChartPie", 
    tags: ["lucide", "file", "chart", "pie"], 
    source: "lucide", 
    name: "FileChartPie",
  }, 
  {
    id: "lucide:FileCheck", 
    tags: ["lucide", "file", "check"], 
    source: "lucide", 
    name: "FileCheck",
  }, 
  {
    id: "lucide:FileCheck2", 
    tags: ["lucide", "file", "check"], 
    source: "lucide", 
    name: "FileCheck2",
  }, 
  {
    id: "lucide:FileClock", 
    tags: ["lucide", "file", "clock"], 
    source: "lucide", 
    name: "FileClock",
  }, 
  {
    id: "lucide:FileCode", 
    tags: ["lucide", "file", "code"], 
    source: "lucide", 
    name: "FileCode",
  }, 
  {
    id: "lucide:FileCode2", 
    tags: ["lucide", "file", "code"], 
    source: "lucide", 
    name: "FileCode2",
  }, 
  {
    id: "lucide:FileCog", 
    tags: ["lucide", "file", "cog"], 
    source: "lucide", 
    name: "FileCog",
  }, 
  {
    id: "lucide:FileCog2", 
    tags: ["lucide", "file", "cog"], 
    source: "lucide", 
    name: "FileCog2",
  }, 
  {
    id: "lucide:FileDiff", 
    tags: ["lucide", "file", "diff"], 
    source: "lucide", 
    name: "FileDiff",
  }, 
  {
    id: "lucide:FileDigit", 
    tags: ["lucide", "file", "digit"], 
    source: "lucide", 
    name: "FileDigit",
  }, 
  {
    id: "lucide:FileDown", 
    tags: ["lucide", "file", "down"], 
    source: "lucide", 
    name: "FileDown",
  }, 
  {
    id: "lucide:FileEdit", 
    tags: ["lucide", "file", "edit"], 
    source: "lucide", 
    name: "FileEdit",
  }, 
  {
    id: "lucide:FileHeart", 
    tags: ["lucide", "file", "heart"], 
    source: "lucide", 
    name: "FileHeart",
  }, 
  {
    id: "lucide:FileImage", 
    tags: ["lucide", "file", "image"], 
    source: "lucide", 
    name: "FileImage",
  }, 
  {
    id: "lucide:FileInput", 
    tags: ["lucide", "file", "input"], 
    source: "lucide", 
    name: "FileInput",
  }, 
  {
    id: "lucide:FileJson", 
    tags: ["lucide", "file", "json"], 
    source: "lucide", 
    name: "FileJson",
  }, 
  {
    id: "lucide:FileJson2", 
    tags: ["lucide", "file", "json"], 
    source: "lucide", 
    name: "FileJson2",
  }, 
  {
    id: "lucide:FileKey", 
    tags: ["lucide", "file", "key"], 
    source: "lucide", 
    name: "FileKey",
  }, 
  {
    id: "lucide:FileKey2", 
    tags: ["lucide", "file", "key"], 
    source: "lucide", 
    name: "FileKey2",
  }, 
  {
    id: "lucide:FileLineChart", 
    tags: ["lucide", "file", "line", "chart"], 
    source: "lucide", 
    name: "FileLineChart",
  }, 
  {
    id: "lucide:FileLock", 
    tags: ["lucide", "file", "lock"], 
    source: "lucide", 
    name: "FileLock",
  }, 
  {
    id: "lucide:FileLock2", 
    tags: ["lucide", "file", "lock"], 
    source: "lucide", 
    name: "FileLock2",
  }, 
  {
    id: "lucide:FileMinus", 
    tags: ["lucide", "file", "minus"], 
    source: "lucide", 
    name: "FileMinus",
  }, 
  {
    id: "lucide:FileMinus2", 
    tags: ["lucide", "file", "minus"], 
    source: "lucide", 
    name: "FileMinus2",
  }, 
  {
    id: "lucide:FileMusic", 
    tags: ["lucide", "file", "music"], 
    source: "lucide", 
    name: "FileMusic",
  }, 
  {
    id: "lucide:FileOutput", 
    tags: ["lucide", "file", "output"], 
    source: "lucide", 
    name: "FileOutput",
  }, 
  {
    id: "lucide:FilePen", 
    tags: ["lucide", "file", "pen"], 
    source: "lucide", 
    name: "FilePen",
  }, 
  {
    id: "lucide:FilePenLine", 
    tags: ["lucide", "file", "pen", "line"], 
    source: "lucide", 
    name: "FilePenLine",
  }, 
  {
    id: "lucide:FilePieChart", 
    tags: ["lucide", "file", "pie", "chart"], 
    source: "lucide", 
    name: "FilePieChart",
  }, 
  {
    id: "lucide:FilePlus", 
    tags: ["lucide", "file", "plus"], 
    source: "lucide", 
    name: "FilePlus",
  }, 
  {
    id: "lucide:FilePlus2", 
    tags: ["lucide", "file", "plus"], 
    source: "lucide", 
    name: "FilePlus2",
  }, 
  {
    id: "lucide:FileQuestion", 
    tags: ["lucide", "file", "question"], 
    source: "lucide", 
    name: "FileQuestion",
  }, 
  {
    id: "lucide:FileScan", 
    tags: ["lucide", "file", "scan"], 
    source: "lucide", 
    name: "FileScan",
  }, 
  {
    id: "lucide:FileSearch", 
    tags: ["lucide", "file", "search"], 
    source: "lucide", 
    name: "FileSearch",
  }, 
  {
    id: "lucide:FileSearch2", 
    tags: ["lucide", "file", "search"], 
    source: "lucide", 
    name: "FileSearch2",
  }, 
  {
    id: "lucide:FileSignature", 
    tags: ["lucide", "file", "signature"], 
    source: "lucide", 
    name: "FileSignature",
  }, 
  {
    id: "lucide:FileSliders", 
    tags: ["lucide", "file", "sliders"], 
    source: "lucide", 
    name: "FileSliders",
  }, 
  {
    id: "lucide:FileSpreadsheet", 
    tags: ["lucide", "file", "spreadsheet"], 
    source: "lucide", 
    name: "FileSpreadsheet",
  }, 
  {
    id: "lucide:FileStack", 
    tags: ["lucide", "file", "stack"], 
    source: "lucide", 
    name: "FileStack",
  }, 
  {
    id: "lucide:FileSymlink", 
    tags: ["lucide", "file", "symlink"], 
    source: "lucide", 
    name: "FileSymlink",
  }, 
  {
    id: "lucide:FileTerminal", 
    tags: ["lucide", "file", "terminal"], 
    source: "lucide", 
    name: "FileTerminal",
  }, 
  {
    id: "lucide:FileText", 
    tags: ["lucide", "file", "text"], 
    source: "lucide", 
    name: "FileText",
  }, 
  {
    id: "lucide:FileType", 
    tags: ["lucide", "file", "type"], 
    source: "lucide", 
    name: "FileType",
  }, 
  {
    id: "lucide:FileType2", 
    tags: ["lucide", "file", "type"], 
    source: "lucide", 
    name: "FileType2",
  }, 
  {
    id: "lucide:FileUp", 
    tags: ["lucide", "file", "up"], 
    source: "lucide", 
    name: "FileUp",
  }, 
  {
    id: "lucide:FileUser", 
    tags: ["lucide", "file", "user"], 
    source: "lucide", 
    name: "FileUser",
  }, 
  {
    id: "lucide:FileVideo", 
    tags: ["lucide", "file", "video"], 
    source: "lucide", 
    name: "FileVideo",
  }, 
  {
    id: "lucide:FileVideo2", 
    tags: ["lucide", "file", "video"], 
    source: "lucide", 
    name: "FileVideo2",
  }, 
  {
    id: "lucide:FileVolume", 
    tags: ["lucide", "file", "volume"], 
    source: "lucide", 
    name: "FileVolume",
  }, 
  {
    id: "lucide:FileVolume2", 
    tags: ["lucide", "file", "volume"], 
    source: "lucide", 
    name: "FileVolume2",
  }, 
  {
    id: "lucide:FileWarning", 
    tags: ["lucide", "file", "warning"], 
    source: "lucide", 
    name: "FileWarning",
  }, 
  {
    id: "lucide:FileX", 
    tags: ["lucide", "file"], 
    source: "lucide", 
    name: "FileX",
  }, 
  {
    id: "lucide:FileX2", 
    tags: ["lucide", "file"], 
    source: "lucide", 
    name: "FileX2",
  }, 
  {
    id: "lucide:Files", 
    tags: ["lucide", "files"], 
    source: "lucide", 
    name: "Files",
  }, 
  {
    id: "lucide:Film", 
    tags: ["lucide", "film"], 
    source: "lucide", 
    name: "Film",
  }, 
  {
    id: "lucide:Filter", 
    tags: ["lucide", "filter"], 
    source: "lucide", 
    name: "Filter",
  }, 
  {
    id: "lucide:FilterX", 
    tags: ["lucide", "filter"], 
    source: "lucide", 
    name: "FilterX",
  }, 
  {
    id: "lucide:Fingerprint", 
    tags: ["lucide", "fingerprint"], 
    source: "lucide", 
    name: "Fingerprint",
  }, 
  {
    id: "lucide:FireExtinguisher", 
    tags: ["lucide", "fire", "extinguisher"], 
    source: "lucide", 
    name: "FireExtinguisher",
  }, 
  {
    id: "lucide:Fish", 
    tags: ["lucide", "fish"], 
    source: "lucide", 
    name: "Fish",
  }, 
  {
    id: "lucide:FishOff", 
    tags: ["lucide", "fish", "off"], 
    source: "lucide", 
    name: "FishOff",
  }, 
  {
    id: "lucide:FishSymbol", 
    tags: ["lucide", "fish", "symbol"], 
    source: "lucide", 
    name: "FishSymbol",
  }, 
  {
    id: "lucide:Flag", 
    tags: ["lucide", "flag"], 
    source: "lucide", 
    name: "Flag",
  }, 
  {
    id: "lucide:FlagOff", 
    tags: ["lucide", "flag", "off"], 
    source: "lucide", 
    name: "FlagOff",
  }, 
  {
    id: "lucide:FlagTriangleLeft", 
    tags: ["lucide", "flag", "triangle", "left"], 
    source: "lucide", 
    name: "FlagTriangleLeft",
  }, 
  {
    id: "lucide:FlagTriangleRight", 
    tags: ["lucide", "flag", "triangle", "right"], 
    source: "lucide", 
    name: "FlagTriangleRight",
  }, 
  {
    id: "lucide:Flame", 
    tags: ["lucide", "flame"], 
    source: "lucide", 
    name: "Flame",
  }, 
  {
    id: "lucide:FlameKindling", 
    tags: ["lucide", "flame", "kindling"], 
    source: "lucide", 
    name: "FlameKindling",
  }, 
  {
    id: "lucide:Flashlight", 
    tags: ["lucide", "flashlight"], 
    source: "lucide", 
    name: "Flashlight",
  }, 
  {
    id: "lucide:FlashlightOff", 
    tags: ["lucide", "flashlight", "off"], 
    source: "lucide", 
    name: "FlashlightOff",
  }, 
  {
    id: "lucide:FlaskConical", 
    tags: ["lucide", "flask", "conical"], 
    source: "lucide", 
    name: "FlaskConical",
  }, 
  {
    id: "lucide:FlaskConicalOff", 
    tags: ["lucide", "flask", "conical", "off"], 
    source: "lucide", 
    name: "FlaskConicalOff",
  }, 
  {
    id: "lucide:FlaskRound", 
    tags: ["lucide", "flask", "round"], 
    source: "lucide", 
    name: "FlaskRound",
  }, 
  {
    id: "lucide:FlipHorizontal", 
    tags: ["lucide", "flip", "horizontal"], 
    source: "lucide", 
    name: "FlipHorizontal",
  }, 
  {
    id: "lucide:FlipHorizontal2", 
    tags: ["lucide", "flip", "horizontal"], 
    source: "lucide", 
    name: "FlipHorizontal2",
  }, 
  {
    id: "lucide:FlipVertical", 
    tags: ["lucide", "flip", "vertical"], 
    source: "lucide", 
    name: "FlipVertical",
  }, 
  {
    id: "lucide:FlipVertical2", 
    tags: ["lucide", "flip", "vertical"], 
    source: "lucide", 
    name: "FlipVertical2",
  }, 
  {
    id: "lucide:Flower", 
    tags: ["lucide", "flower"], 
    source: "lucide", 
    name: "Flower",
  }, 
  {
    id: "lucide:Flower2", 
    tags: ["lucide", "flower"], 
    source: "lucide", 
    name: "Flower2",
  }, 
  {
    id: "lucide:Focus", 
    tags: ["lucide", "focus"], 
    source: "lucide", 
    name: "Focus",
  }, 
  {
    id: "lucide:FoldHorizontal", 
    tags: ["lucide", "fold", "horizontal"], 
    source: "lucide", 
    name: "FoldHorizontal",
  }, 
  {
    id: "lucide:FoldVertical", 
    tags: ["lucide", "fold", "vertical"], 
    source: "lucide", 
    name: "FoldVertical",
  }, 
  {
    id: "lucide:Folder", 
    tags: ["lucide", "folder"], 
    source: "lucide", 
    name: "Folder",
  }, 
  {
    id: "lucide:FolderArchive", 
    tags: ["lucide", "folder", "archive"], 
    source: "lucide", 
    name: "FolderArchive",
  }, 
  {
    id: "lucide:FolderCheck", 
    tags: ["lucide", "folder", "check"], 
    source: "lucide", 
    name: "FolderCheck",
  }, 
  {
    id: "lucide:FolderClock", 
    tags: ["lucide", "folder", "clock"], 
    source: "lucide", 
    name: "FolderClock",
  }, 
  {
    id: "lucide:FolderClosed", 
    tags: ["lucide", "folder", "closed"], 
    source: "lucide", 
    name: "FolderClosed",
  }, 
  {
    id: "lucide:FolderCode", 
    tags: ["lucide", "folder", "code"], 
    source: "lucide", 
    name: "FolderCode",
  }, 
  {
    id: "lucide:FolderCog", 
    tags: ["lucide", "folder", "cog"], 
    source: "lucide", 
    name: "FolderCog",
  }, 
  {
    id: "lucide:FolderCog2", 
    tags: ["lucide", "folder", "cog"], 
    source: "lucide", 
    name: "FolderCog2",
  }, 
  {
    id: "lucide:FolderDot", 
    tags: ["lucide", "folder", "dot"], 
    source: "lucide", 
    name: "FolderDot",
  }, 
  {
    id: "lucide:FolderDown", 
    tags: ["lucide", "folder", "down"], 
    source: "lucide", 
    name: "FolderDown",
  }, 
  {
    id: "lucide:FolderEdit", 
    tags: ["lucide", "folder", "edit"], 
    source: "lucide", 
    name: "FolderEdit",
  }, 
  {
    id: "lucide:FolderGit", 
    tags: ["lucide", "folder", "git"], 
    source: "lucide", 
    name: "FolderGit",
  }, 
  {
    id: "lucide:FolderGit2", 
    tags: ["lucide", "folder", "git"], 
    source: "lucide", 
    name: "FolderGit2",
  }, 
  {
    id: "lucide:FolderHeart", 
    tags: ["lucide", "folder", "heart"], 
    source: "lucide", 
    name: "FolderHeart",
  }, 
  {
    id: "lucide:FolderInput", 
    tags: ["lucide", "folder", "input"], 
    source: "lucide", 
    name: "FolderInput",
  }, 
  {
    id: "lucide:FolderKanban", 
    tags: ["lucide", "folder", "kanban"], 
    source: "lucide", 
    name: "FolderKanban",
  }, 
  {
    id: "lucide:FolderKey", 
    tags: ["lucide", "folder", "key"], 
    source: "lucide", 
    name: "FolderKey",
  }, 
  {
    id: "lucide:FolderLock", 
    tags: ["lucide", "folder", "lock"], 
    source: "lucide", 
    name: "FolderLock",
  }, 
  {
    id: "lucide:FolderMinus", 
    tags: ["lucide", "folder", "minus"], 
    source: "lucide", 
    name: "FolderMinus",
  }, 
  {
    id: "lucide:FolderOpen", 
    tags: ["lucide", "folder", "open"], 
    source: "lucide", 
    name: "FolderOpen",
  }, 
  {
    id: "lucide:FolderOpenDot", 
    tags: ["lucide", "folder", "open", "dot"], 
    source: "lucide", 
    name: "FolderOpenDot",
  }, 
  {
    id: "lucide:FolderOutput", 
    tags: ["lucide", "folder", "output"], 
    source: "lucide", 
    name: "FolderOutput",
  }, 
  {
    id: "lucide:FolderPen", 
    tags: ["lucide", "folder", "pen"], 
    source: "lucide", 
    name: "FolderPen",
  }, 
  {
    id: "lucide:FolderPlus", 
    tags: ["lucide", "folder", "plus"], 
    source: "lucide", 
    name: "FolderPlus",
  }, 
  {
    id: "lucide:FolderRoot", 
    tags: ["lucide", "folder", "root"], 
    source: "lucide", 
    name: "FolderRoot",
  }, 
  {
    id: "lucide:FolderSearch", 
    tags: ["lucide", "folder", "search"], 
    source: "lucide", 
    name: "FolderSearch",
  }, 
  {
    id: "lucide:FolderSearch2", 
    tags: ["lucide", "folder", "search"], 
    source: "lucide", 
    name: "FolderSearch2",
  }, 
  {
    id: "lucide:FolderSymlink", 
    tags: ["lucide", "folder", "symlink"], 
    source: "lucide", 
    name: "FolderSymlink",
  }, 
  {
    id: "lucide:FolderSync", 
    tags: ["lucide", "folder", "sync"], 
    source: "lucide", 
    name: "FolderSync",
  }, 
  {
    id: "lucide:FolderTree", 
    tags: ["lucide", "folder", "tree"], 
    source: "lucide", 
    name: "FolderTree",
  }, 
  {
    id: "lucide:FolderUp", 
    tags: ["lucide", "folder", "up"], 
    source: "lucide", 
    name: "FolderUp",
  }, 
  {
    id: "lucide:FolderX", 
    tags: ["lucide", "folder"], 
    source: "lucide", 
    name: "FolderX",
  }, 
  {
    id: "lucide:Folders", 
    tags: ["lucide", "folders"], 
    source: "lucide", 
    name: "Folders",
  }, 
  {
    id: "lucide:Footprints", 
    tags: ["lucide", "footprints"], 
    source: "lucide", 
    name: "Footprints",
  }, 
  {
    id: "lucide:ForkKnife", 
    tags: ["lucide", "fork", "knife"], 
    source: "lucide", 
    name: "ForkKnife",
  }, 
  {
    id: "lucide:ForkKnifeCrossed", 
    tags: ["lucide", "fork", "knife", "crossed"], 
    source: "lucide", 
    name: "ForkKnifeCrossed",
  }, 
  {
    id: "lucide:Forklift", 
    tags: ["lucide", "forklift"], 
    source: "lucide", 
    name: "Forklift",
  }, 
  {
    id: "lucide:FormInput", 
    tags: ["lucide", "form", "input"], 
    source: "lucide", 
    name: "FormInput",
  }, 
  {
    id: "lucide:Forward", 
    tags: ["lucide", "forward"], 
    source: "lucide", 
    name: "Forward",
  }, 
  {
    id: "lucide:Frame", 
    tags: ["lucide", "frame"], 
    source: "lucide", 
    name: "Frame",
  }, 
  {
    id: "lucide:Framer", 
    tags: ["lucide", "framer"], 
    source: "lucide", 
    name: "Framer",
  }, 
  {
    id: "lucide:Frown", 
    tags: ["lucide", "frown"], 
    source: "lucide", 
    name: "Frown",
  }, 
  {
    id: "lucide:Fuel", 
    tags: ["lucide", "fuel"], 
    source: "lucide", 
    name: "Fuel",
  }, 
  {
    id: "lucide:Fullscreen", 
    tags: ["lucide", "fullscreen"], 
    source: "lucide", 
    name: "Fullscreen",
  }, 
  {
    id: "lucide:FunctionSquare", 
    tags: ["lucide", "function", "square"], 
    source: "lucide", 
    name: "FunctionSquare",
  }, 
  {
    id: "lucide:GalleryHorizontal", 
    tags: ["lucide", "gallery", "horizontal"], 
    source: "lucide", 
    name: "GalleryHorizontal",
  }, 
  {
    id: "lucide:GalleryHorizontalEnd", 
    tags: ["lucide", "gallery", "horizontal", "end"], 
    source: "lucide", 
    name: "GalleryHorizontalEnd",
  }, 
  {
    id: "lucide:GalleryThumbnails", 
    tags: ["lucide", "gallery", "thumbnails"], 
    source: "lucide", 
    name: "GalleryThumbnails",
  }, 
  {
    id: "lucide:GalleryVertical", 
    tags: ["lucide", "gallery", "vertical"], 
    source: "lucide", 
    name: "GalleryVertical",
  }, 
  {
    id: "lucide:GalleryVerticalEnd", 
    tags: ["lucide", "gallery", "vertical", "end"], 
    source: "lucide", 
    name: "GalleryVerticalEnd",
  }, 
  {
    id: "lucide:Gamepad", 
    tags: ["lucide", "gamepad"], 
    source: "lucide", 
    name: "Gamepad",
  }, 
  {
    id: "lucide:Gamepad2", 
    tags: ["lucide", "gamepad"], 
    source: "lucide", 
    name: "Gamepad2",
  }, 
  {
    id: "lucide:GanttChart", 
    tags: ["lucide", "gantt", "chart"], 
    source: "lucide", 
    name: "GanttChart",
  }, 
  {
    id: "lucide:GanttChartSquare", 
    tags: ["lucide", "gantt", "chart", "square"], 
    source: "lucide", 
    name: "GanttChartSquare",
  }, 
  {
    id: "lucide:Gauge", 
    tags: ["lucide", "gauge"], 
    source: "lucide", 
    name: "Gauge",
  }, 
  {
    id: "lucide:GaugeCircle", 
    tags: ["lucide", "gauge", "circle"], 
    source: "lucide", 
    name: "GaugeCircle",
  }, 
  {
    id: "lucide:Gavel", 
    tags: ["lucide", "gavel"], 
    source: "lucide", 
    name: "Gavel",
  }, 
  {
    id: "lucide:Gem", 
    tags: ["lucide", "gem"], 
    source: "lucide", 
    name: "Gem",
  }, 
  {
    id: "lucide:Ghost", 
    tags: ["lucide", "ghost"], 
    source: "lucide", 
    name: "Ghost",
  }, 
  {
    id: "lucide:Gift", 
    tags: ["lucide", "gift"], 
    source: "lucide", 
    name: "Gift",
  }, 
  {
    id: "lucide:GitBranch", 
    tags: ["lucide", "git", "branch"], 
    source: "lucide", 
    name: "GitBranch",
  }, 
  {
    id: "lucide:GitBranchPlus", 
    tags: ["lucide", "git", "branch", "plus"], 
    source: "lucide", 
    name: "GitBranchPlus",
  }, 
  {
    id: "lucide:GitCommit", 
    tags: ["lucide", "git", "commit"], 
    source: "lucide", 
    name: "GitCommit",
  }, 
  {
    id: "lucide:GitCommitHorizontal", 
    tags: ["lucide", "git", "commit", "horizontal"], 
    source: "lucide", 
    name: "GitCommitHorizontal",
  }, 
  {
    id: "lucide:GitCommitVertical", 
    tags: ["lucide", "git", "commit", "vertical"], 
    source: "lucide", 
    name: "GitCommitVertical",
  }, 
  {
    id: "lucide:GitCompare", 
    tags: ["lucide", "git", "compare"], 
    source: "lucide", 
    name: "GitCompare",
  }, 
  {
    id: "lucide:GitCompareArrows", 
    tags: ["lucide", "git", "compare", "arrows"], 
    source: "lucide", 
    name: "GitCompareArrows",
  }, 
  {
    id: "lucide:GitFork", 
    tags: ["lucide", "git", "fork"], 
    source: "lucide", 
    name: "GitFork",
  }, 
  {
    id: "lucide:GitGraph", 
    tags: ["lucide", "git", "graph"], 
    source: "lucide", 
    name: "GitGraph",
  }, 
  {
    id: "lucide:GitMerge", 
    tags: ["lucide", "git", "merge"], 
    source: "lucide", 
    name: "GitMerge",
  }, 
  {
    id: "lucide:GitPullRequest", 
    tags: ["lucide", "git", "pull", "request"], 
    source: "lucide", 
    name: "GitPullRequest",
  }, 
  {
    id: "lucide:GitPullRequestArrow", 
    tags: ["lucide", "git", "pull", "request", "arrow"], 
    source: "lucide", 
    name: "GitPullRequestArrow",
  }, 
  {
    id: "lucide:GitPullRequestClosed", 
    tags: ["lucide", "git", "pull", "request", "closed"], 
    source: "lucide", 
    name: "GitPullRequestClosed",
  }, 
  {
    id: "lucide:GitPullRequestCreate", 
    tags: ["lucide", "git", "pull", "request", "create"], 
    source: "lucide", 
    name: "GitPullRequestCreate",
  }, 
  {
    id: "lucide:GitPullRequestCreateArrow", 
    tags: ["lucide", "git", "pull", "request", "create", "arrow"], 
    source: "lucide", 
    name: "GitPullRequestCreateArrow",
  }, 
  {
    id: "lucide:GitPullRequestDraft", 
    tags: ["lucide", "git", "pull", "request", "draft"], 
    source: "lucide", 
    name: "GitPullRequestDraft",
  }, 
  {
    id: "lucide:Github", 
    tags: ["lucide", "github"], 
    source: "lucide", 
    name: "Github",
  }, 
  {
    id: "lucide:Gitlab", 
    tags: ["lucide", "gitlab"], 
    source: "lucide", 
    name: "Gitlab",
  }, 
  {
    id: "lucide:GlassWater", 
    tags: ["lucide", "glass", "water"], 
    source: "lucide", 
    name: "GlassWater",
  }, 
  {
    id: "lucide:Glasses", 
    tags: ["lucide", "glasses"], 
    source: "lucide", 
    name: "Glasses",
  }, 
  {
    id: "lucide:Globe", 
    tags: ["lucide", "globe"], 
    source: "lucide", 
    name: "Globe",
  }, 
  {
    id: "lucide:Globe2", 
    tags: ["lucide", "globe"], 
    source: "lucide", 
    name: "Globe2",
  }, 
  {
    id: "lucide:GlobeLock", 
    tags: ["lucide", "globe", "lock"], 
    source: "lucide", 
    name: "GlobeLock",
  }, 
  {
    id: "lucide:Goal", 
    tags: ["lucide", "goal"], 
    source: "lucide", 
    name: "Goal",
  }, 
  {
    id: "lucide:Grab", 
    tags: ["lucide", "grab"], 
    source: "lucide", 
    name: "Grab",
  }, 
  {
    id: "lucide:GraduationCap", 
    tags: ["lucide", "graduation", "cap"], 
    source: "lucide", 
    name: "GraduationCap",
  }, 
  {
    id: "lucide:Grape", 
    tags: ["lucide", "grape"], 
    source: "lucide", 
    name: "Grape",
  }, 
  {
    id: "lucide:Grid", 
    tags: ["lucide", "grid"], 
    source: "lucide", 
    name: "Grid",
  }, 
  {
    id: "lucide:Grid2x2", 
    tags: ["lucide", "grid"], 
    source: "lucide", 
    name: "Grid2x2",
  }, 
  {
    id: "lucide:Grid2x2Check", 
    tags: ["lucide", "grid", "check"], 
    source: "lucide", 
    name: "Grid2x2Check",
  }, 
  {
    id: "lucide:Grid2x2Plus", 
    tags: ["lucide", "grid", "plus"], 
    source: "lucide", 
    name: "Grid2x2Plus",
  }, 
  {
    id: "lucide:Grid2x2X", 
    tags: ["lucide", "grid"], 
    source: "lucide", 
    name: "Grid2x2X",
  }, 
  {
    id: "lucide:Grid3x3", 
    tags: ["lucide", "grid"], 
    source: "lucide", 
    name: "Grid3x3",
  }, 
  {
    id: "lucide:Grip", 
    tags: ["lucide", "grip"], 
    source: "lucide", 
    name: "Grip",
  }, 
  {
    id: "lucide:GripHorizontal", 
    tags: ["lucide", "grip", "horizontal"], 
    source: "lucide", 
    name: "GripHorizontal",
  }, 
  {
    id: "lucide:GripVertical", 
    tags: ["lucide", "grip", "vertical"], 
    source: "lucide", 
    name: "GripVertical",
  }, 
  {
    id: "lucide:Group", 
    tags: ["lucide", "group"], 
    source: "lucide", 
    name: "Group",
  }, 
  {
    id: "lucide:Guitar", 
    tags: ["lucide", "guitar"], 
    source: "lucide", 
    name: "Guitar",
  }, 
  {
    id: "lucide:Ham", 
    tags: ["lucide", "ham"], 
    source: "lucide", 
    name: "Ham",
  }, 
  {
    id: "lucide:Hammer", 
    tags: ["lucide", "hammer"], 
    source: "lucide", 
    name: "Hammer",
  }, 
  {
    id: "lucide:Hand", 
    tags: ["lucide", "hand"], 
    source: "lucide", 
    name: "Hand",
  }, 
  {
    id: "lucide:HandCoins", 
    tags: ["lucide", "hand", "coins"], 
    source: "lucide", 
    name: "HandCoins",
  }, 
  {
    id: "lucide:HandHeart", 
    tags: ["lucide", "hand", "heart"], 
    source: "lucide", 
    name: "HandHeart",
  }, 
  {
    id: "lucide:HandHelping", 
    tags: ["lucide", "hand", "helping"], 
    source: "lucide", 
    name: "HandHelping",
  }, 
  {
    id: "lucide:HandMetal", 
    tags: ["lucide", "hand", "metal"], 
    source: "lucide", 
    name: "HandMetal",
  }, 
  {
    id: "lucide:HandPlatter", 
    tags: ["lucide", "hand", "platter"], 
    source: "lucide", 
    name: "HandPlatter",
  }, 
  {
    id: "lucide:Handshake", 
    tags: ["lucide", "handshake"], 
    source: "lucide", 
    name: "Handshake",
  }, 
  {
    id: "lucide:HardDrive", 
    tags: ["lucide", "hard", "drive"], 
    source: "lucide", 
    name: "HardDrive",
  }, 
  {
    id: "lucide:HardDriveDownload", 
    tags: ["lucide", "hard", "drive", "download"], 
    source: "lucide", 
    name: "HardDriveDownload",
  }, 
  {
    id: "lucide:HardDriveUpload", 
    tags: ["lucide", "hard", "drive", "upload"], 
    source: "lucide", 
    name: "HardDriveUpload",
  }, 
  {
    id: "lucide:HardHat", 
    tags: ["lucide", "hard", "hat"], 
    source: "lucide", 
    name: "HardHat",
  }, 
  {
    id: "lucide:Hash", 
    tags: ["lucide", "hash"], 
    source: "lucide", 
    name: "Hash",
  }, 
  {
    id: "lucide:Haze", 
    tags: ["lucide", "haze"], 
    source: "lucide", 
    name: "Haze",
  }, 
  {
    id: "lucide:HdmiPort", 
    tags: ["lucide", "hdmi", "port"], 
    source: "lucide", 
    name: "HdmiPort",
  }, 
  {
    id: "lucide:Heading", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading",
  }, 
  {
    id: "lucide:Heading1", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading1",
  }, 
  {
    id: "lucide:Heading2", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading2",
  }, 
  {
    id: "lucide:Heading3", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading3",
  }, 
  {
    id: "lucide:Heading4", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading4",
  }, 
  {
    id: "lucide:Heading5", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading5",
  }, 
  {
    id: "lucide:Heading6", 
    tags: ["lucide", "heading"], 
    source: "lucide", 
    name: "Heading6",
  }, 
  {
    id: "lucide:HeadphoneOff", 
    tags: ["lucide", "headphone", "off"], 
    source: "lucide", 
    name: "HeadphoneOff",
  }, 
  {
    id: "lucide:Headphones", 
    tags: ["lucide", "headphones"], 
    source: "lucide", 
    name: "Headphones",
  }, 
  {
    id: "lucide:Headset", 
    tags: ["lucide", "headset"], 
    source: "lucide", 
    name: "Headset",
  }, 
  {
    id: "lucide:Heart", 
    tags: ["lucide", "heart"], 
    source: "lucide", 
    name: "Heart",
  }, 
  {
    id: "lucide:HeartCrack", 
    tags: ["lucide", "heart", "crack"], 
    source: "lucide", 
    name: "HeartCrack",
  }, 
  {
    id: "lucide:HeartHandshake", 
    tags: ["lucide", "heart", "handshake"], 
    source: "lucide", 
    name: "HeartHandshake",
  }, 
  {
    id: "lucide:HeartOff", 
    tags: ["lucide", "heart", "off"], 
    source: "lucide", 
    name: "HeartOff",
  }, 
  {
    id: "lucide:HeartPulse", 
    tags: ["lucide", "heart", "pulse"], 
    source: "lucide", 
    name: "HeartPulse",
  }, 
  {
    id: "lucide:Heater", 
    tags: ["lucide", "heater"], 
    source: "lucide", 
    name: "Heater",
  }, 
  {
    id: "lucide:HelpCircle", 
    tags: ["lucide", "help", "circle"], 
    source: "lucide", 
    name: "HelpCircle",
  }, 
  {
    id: "lucide:HelpingHand", 
    tags: ["lucide", "helping", "hand"], 
    source: "lucide", 
    name: "HelpingHand",
  }, 
  {
    id: "lucide:Hexagon", 
    tags: ["lucide", "hexagon"], 
    source: "lucide", 
    name: "Hexagon",
  }, 
  {
    id: "lucide:Highlighter", 
    tags: ["lucide", "highlighter"], 
    source: "lucide", 
    name: "Highlighter",
  }, 
  {
    id: "lucide:History", 
    tags: ["lucide", "history"], 
    source: "lucide", 
    name: "History",
  }, 
  {
    id: "lucide:Home", 
    tags: ["lucide", "home"], 
    source: "lucide", 
    name: "Home",
  }, 
  {
    id: "lucide:Hop", 
    tags: ["lucide", "hop"], 
    source: "lucide", 
    name: "Hop",
  }, 
  {
    id: "lucide:HopOff", 
    tags: ["lucide", "hop", "off"], 
    source: "lucide", 
    name: "HopOff",
  }, 
  {
    id: "lucide:Hospital", 
    tags: ["lucide", "hospital"], 
    source: "lucide", 
    name: "Hospital",
  }, 
  {
    id: "lucide:Hotel", 
    tags: ["lucide", "hotel"], 
    source: "lucide", 
    name: "Hotel",
  }, 
  {
    id: "lucide:Hourglass", 
    tags: ["lucide", "hourglass"], 
    source: "lucide", 
    name: "Hourglass",
  }, 
  {
    id: "lucide:House", 
    tags: ["lucide", "house"], 
    source: "lucide", 
    name: "House",
  }, 
  {
    id: "lucide:HousePlug", 
    tags: ["lucide", "house", "plug"], 
    source: "lucide", 
    name: "HousePlug",
  }, 
  {
    id: "lucide:HousePlus", 
    tags: ["lucide", "house", "plus"], 
    source: "lucide", 
    name: "HousePlus",
  }, 
  {
    id: "lucide:HouseWifi", 
    tags: ["lucide", "house", "wifi"], 
    source: "lucide", 
    name: "HouseWifi",
  }, 
  {
    id: "lucide:IceCream", 
    tags: ["lucide", "ice", "cream"], 
    source: "lucide", 
    name: "IceCream",
  }, 
  {
    id: "lucide:IceCream2", 
    tags: ["lucide", "ice", "cream"], 
    source: "lucide", 
    name: "IceCream2",
  }, 
  {
    id: "lucide:IceCreamBowl", 
    tags: ["lucide", "ice", "cream", "bowl"], 
    source: "lucide", 
    name: "IceCreamBowl",
  }, 
  {
    id: "lucide:IceCreamCone", 
    tags: ["lucide", "ice", "cream", "cone"], 
    source: "lucide", 
    name: "IceCreamCone",
  }, 
  {
    id: "lucide:IdCard", 
    tags: ["lucide", "id", "card"], 
    source: "lucide", 
    name: "IdCard",
  }, 
  {
    id: "lucide:Image", 
    tags: ["lucide", "image"], 
    source: "lucide", 
    name: "Image",
  }, 
  {
    id: "lucide:ImageDown", 
    tags: ["lucide", "image", "down"], 
    source: "lucide", 
    name: "ImageDown",
  }, 
  {
    id: "lucide:ImageMinus", 
    tags: ["lucide", "image", "minus"], 
    source: "lucide", 
    name: "ImageMinus",
  }, 
  {
    id: "lucide:ImageOff", 
    tags: ["lucide", "image", "off"], 
    source: "lucide", 
    name: "ImageOff",
  }, 
  {
    id: "lucide:ImagePlay", 
    tags: ["lucide", "image", "play"], 
    source: "lucide", 
    name: "ImagePlay",
  }, 
  {
    id: "lucide:ImagePlus", 
    tags: ["lucide", "image", "plus"], 
    source: "lucide", 
    name: "ImagePlus",
  }, 
  {
    id: "lucide:ImageUp", 
    tags: ["lucide", "image", "up"], 
    source: "lucide", 
    name: "ImageUp",
  }, 
  {
    id: "lucide:ImageUpscale", 
    tags: ["lucide", "image", "upscale"], 
    source: "lucide", 
    name: "ImageUpscale",
  }, 
  {
    id: "lucide:Images", 
    tags: ["lucide", "images"], 
    source: "lucide", 
    name: "Images",
  }, 
  {
    id: "lucide:Import", 
    tags: ["lucide", "import"], 
    source: "lucide", 
    name: "Import",
  }, 
  {
    id: "lucide:Inbox", 
    tags: ["lucide", "inbox"], 
    source: "lucide", 
    name: "Inbox",
  }, 
  {
    id: "lucide:Indent", 
    tags: ["lucide", "indent"], 
    source: "lucide", 
    name: "Indent",
  }, 
  {
    id: "lucide:IndentDecrease", 
    tags: ["lucide", "indent", "decrease"], 
    source: "lucide", 
    name: "IndentDecrease",
  }, 
  {
    id: "lucide:IndentIncrease", 
    tags: ["lucide", "indent", "increase"], 
    source: "lucide", 
    name: "IndentIncrease",
  }, 
  {
    id: "lucide:IndianRupee", 
    tags: ["lucide", "indian", "rupee"], 
    source: "lucide", 
    name: "IndianRupee",
  }, 
  {
    id: "lucide:Infinity", 
    tags: ["lucide", "infinity"], 
    source: "lucide", 
    name: "Infinity",
  }, 
  {
    id: "lucide:Info", 
    tags: ["lucide", "info"], 
    source: "lucide", 
    name: "Info",
  }, 
  {
    id: "lucide:Inspect", 
    tags: ["lucide", "inspect"], 
    source: "lucide", 
    name: "Inspect",
  }, 
  {
    id: "lucide:InspectionPanel", 
    tags: ["lucide", "inspection", "panel"], 
    source: "lucide", 
    name: "InspectionPanel",
  }, 
  {
    id: "lucide:Instagram", 
    tags: ["lucide", "instagram"], 
    source: "lucide", 
    name: "Instagram",
  }, 
  {
    id: "lucide:Italic", 
    tags: ["lucide", "italic"], 
    source: "lucide", 
    name: "Italic",
  }, 
  {
    id: "lucide:IterationCcw", 
    tags: ["lucide", "iteration", "ccw"], 
    source: "lucide", 
    name: "IterationCcw",
  }, 
  {
    id: "lucide:IterationCw", 
    tags: ["lucide", "iteration", "cw"], 
    source: "lucide", 
    name: "IterationCw",
  }, 
  {
    id: "lucide:JapaneseYen", 
    tags: ["lucide", "japanese", "yen"], 
    source: "lucide", 
    name: "JapaneseYen",
  }, 
  {
    id: "lucide:Joystick", 
    tags: ["lucide", "joystick"], 
    source: "lucide", 
    name: "Joystick",
  }, 
  {
    id: "lucide:Kanban", 
    tags: ["lucide", "kanban"], 
    source: "lucide", 
    name: "Kanban",
  }, 
  {
    id: "lucide:KanbanSquare", 
    tags: ["lucide", "kanban", "square"], 
    source: "lucide", 
    name: "KanbanSquare",
  }, 
  {
    id: "lucide:KanbanSquareDashed", 
    tags: ["lucide", "kanban", "square", "dashed"], 
    source: "lucide", 
    name: "KanbanSquareDashed",
  }, 
  {
    id: "lucide:Key", 
    tags: ["lucide", "key"], 
    source: "lucide", 
    name: "Key",
  }, 
  {
    id: "lucide:KeyRound", 
    tags: ["lucide", "key", "round"], 
    source: "lucide", 
    name: "KeyRound",
  }, 
  {
    id: "lucide:KeySquare", 
    tags: ["lucide", "key", "square"], 
    source: "lucide", 
    name: "KeySquare",
  }, 
  {
    id: "lucide:Keyboard", 
    tags: ["lucide", "keyboard"], 
    source: "lucide", 
    name: "Keyboard",
  }, 
  {
    id: "lucide:KeyboardMusic", 
    tags: ["lucide", "keyboard", "music"], 
    source: "lucide", 
    name: "KeyboardMusic",
  }, 
  {
    id: "lucide:KeyboardOff", 
    tags: ["lucide", "keyboard", "off"], 
    source: "lucide", 
    name: "KeyboardOff",
  }, 
  {
    id: "lucide:Lamp", 
    tags: ["lucide", "lamp"], 
    source: "lucide", 
    name: "Lamp",
  }, 
  {
    id: "lucide:LampCeiling", 
    tags: ["lucide", "lamp", "ceiling"], 
    source: "lucide", 
    name: "LampCeiling",
  }, 
  {
    id: "lucide:LampDesk", 
    tags: ["lucide", "lamp", "desk"], 
    source: "lucide", 
    name: "LampDesk",
  }, 
  {
    id: "lucide:LampFloor", 
    tags: ["lucide", "lamp", "floor"], 
    source: "lucide", 
    name: "LampFloor",
  }, 
  {
    id: "lucide:LampWallDown", 
    tags: ["lucide", "lamp", "wall", "down"], 
    source: "lucide", 
    name: "LampWallDown",
  }, 
  {
    id: "lucide:LampWallUp", 
    tags: ["lucide", "lamp", "wall", "up"], 
    source: "lucide", 
    name: "LampWallUp",
  }, 
  {
    id: "lucide:LandPlot", 
    tags: ["lucide", "land", "plot"], 
    source: "lucide", 
    name: "LandPlot",
  }, 
  {
    id: "lucide:Landmark", 
    tags: ["lucide", "landmark"], 
    source: "lucide", 
    name: "Landmark",
  }, 
  {
    id: "lucide:Languages", 
    tags: ["lucide", "languages"], 
    source: "lucide", 
    name: "Languages",
  }, 
  {
    id: "lucide:Laptop", 
    tags: ["lucide", "laptop"], 
    source: "lucide", 
    name: "Laptop",
  }, 
  {
    id: "lucide:Laptop2", 
    tags: ["lucide", "laptop"], 
    source: "lucide", 
    name: "Laptop2",
  }, 
  {
    id: "lucide:LaptopMinimal", 
    tags: ["lucide", "laptop", "minimal"], 
    source: "lucide", 
    name: "LaptopMinimal",
  }, 
  {
    id: "lucide:LaptopMinimalCheck", 
    tags: ["lucide", "laptop", "minimal", "check"], 
    source: "lucide", 
    name: "LaptopMinimalCheck",
  }, 
  {
    id: "lucide:Lasso", 
    tags: ["lucide", "lasso"], 
    source: "lucide", 
    name: "Lasso",
  }, 
  {
    id: "lucide:LassoSelect", 
    tags: ["lucide", "lasso", "select"], 
    source: "lucide", 
    name: "LassoSelect",
  }, 
  {
    id: "lucide:Laugh", 
    tags: ["lucide", "laugh"], 
    source: "lucide", 
    name: "Laugh",
  }, 
  {
    id: "lucide:Layers", 
    tags: ["lucide", "layers"], 
    source: "lucide", 
    name: "Layers",
  }, 
  {
    id: "lucide:Layers2", 
    tags: ["lucide", "layers"], 
    source: "lucide", 
    name: "Layers2",
  }, 
  {
    id: "lucide:Layers3", 
    tags: ["lucide", "layers"], 
    source: "lucide", 
    name: "Layers3",
  }, 
  {
    id: "lucide:Layout", 
    tags: ["lucide", "layout"], 
    source: "lucide", 
    name: "Layout",
  }, 
  {
    id: "lucide:LayoutDashboard", 
    tags: ["lucide", "layout", "dashboard"], 
    source: "lucide", 
    name: "LayoutDashboard",
  }, 
  {
    id: "lucide:LayoutGrid", 
    tags: ["lucide", "layout", "grid"], 
    source: "lucide", 
    name: "LayoutGrid",
  }, 
  {
    id: "lucide:LayoutList", 
    tags: ["lucide", "layout", "list"], 
    source: "lucide", 
    name: "LayoutList",
  }, 
  {
    id: "lucide:LayoutPanelLeft", 
    tags: ["lucide", "layout", "panel", "left"], 
    source: "lucide", 
    name: "LayoutPanelLeft",
  }, 
  {
    id: "lucide:LayoutPanelTop", 
    tags: ["lucide", "layout", "panel", "top"], 
    source: "lucide", 
    name: "LayoutPanelTop",
  }, 
  {
    id: "lucide:LayoutTemplate", 
    tags: ["lucide", "layout", "template"], 
    source: "lucide", 
    name: "LayoutTemplate",
  }, 
  {
    id: "lucide:Leaf", 
    tags: ["lucide", "leaf"], 
    source: "lucide", 
    name: "Leaf",
  }, 
  {
    id: "lucide:LeafyGreen", 
    tags: ["lucide", "leafy", "green"], 
    source: "lucide", 
    name: "LeafyGreen",
  }, 
  {
    id: "lucide:Lectern", 
    tags: ["lucide", "lectern"], 
    source: "lucide", 
    name: "Lectern",
  }, 
  {
    id: "lucide:LetterText", 
    tags: ["lucide", "letter", "text"], 
    source: "lucide", 
    name: "LetterText",
  }, 
  {
    id: "lucide:Library", 
    tags: ["lucide", "library"], 
    source: "lucide", 
    name: "Library",
  }, 
  {
    id: "lucide:LibraryBig", 
    tags: ["lucide", "library", "big"], 
    source: "lucide", 
    name: "LibraryBig",
  }, 
  {
    id: "lucide:LibrarySquare", 
    tags: ["lucide", "library", "square"], 
    source: "lucide", 
    name: "LibrarySquare",
  }, 
  {
    id: "lucide:LifeBuoy", 
    tags: ["lucide", "life", "buoy"], 
    source: "lucide", 
    name: "LifeBuoy",
  }, 
  {
    id: "lucide:Ligature", 
    tags: ["lucide", "ligature"], 
    source: "lucide", 
    name: "Ligature",
  }, 
  {
    id: "lucide:Lightbulb", 
    tags: ["lucide", "lightbulb"], 
    source: "lucide", 
    name: "Lightbulb",
  }, 
  {
    id: "lucide:LightbulbOff", 
    tags: ["lucide", "lightbulb", "off"], 
    source: "lucide", 
    name: "LightbulbOff",
  }, 
  {
    id: "lucide:LineChart", 
    tags: ["lucide", "line", "chart"], 
    source: "lucide", 
    name: "LineChart",
  }, 
  {
    id: "lucide:Link", 
    tags: ["lucide", "link"], 
    source: "lucide", 
    name: "Link",
  }, 
  {
    id: "lucide:Link2", 
    tags: ["lucide", "link"], 
    source: "lucide", 
    name: "Link2",
  }, 
  {
    id: "lucide:Link2Off", 
    tags: ["lucide", "link", "off"], 
    source: "lucide", 
    name: "Link2Off",
  }, 
  {
    id: "lucide:Linkedin", 
    tags: ["lucide", "linkedin"], 
    source: "lucide", 
    name: "Linkedin",
  }, 
  {
    id: "lucide:List", 
    tags: ["lucide", "list"], 
    source: "lucide", 
    name: "List",
  }, 
  {
    id: "lucide:ListCheck", 
    tags: ["lucide", "list", "check"], 
    source: "lucide", 
    name: "ListCheck",
  }, 
  {
    id: "lucide:ListChecks", 
    tags: ["lucide", "list", "checks"], 
    source: "lucide", 
    name: "ListChecks",
  }, 
  {
    id: "lucide:ListCollapse", 
    tags: ["lucide", "list", "collapse"], 
    source: "lucide", 
    name: "ListCollapse",
  }, 
  {
    id: "lucide:ListEnd", 
    tags: ["lucide", "list", "end"], 
    source: "lucide", 
    name: "ListEnd",
  }, 
  {
    id: "lucide:ListFilter", 
    tags: ["lucide", "list", "filter"], 
    source: "lucide", 
    name: "ListFilter",
  }, 
  {
    id: "lucide:ListFilterPlus", 
    tags: ["lucide", "list", "filter", "plus"], 
    source: "lucide", 
    name: "ListFilterPlus",
  }, 
  {
    id: "lucide:ListMinus", 
    tags: ["lucide", "list", "minus"], 
    source: "lucide", 
    name: "ListMinus",
  }, 
  {
    id: "lucide:ListMusic", 
    tags: ["lucide", "list", "music"], 
    source: "lucide", 
    name: "ListMusic",
  }, 
  {
    id: "lucide:ListOrdered", 
    tags: ["lucide", "list", "ordered"], 
    source: "lucide", 
    name: "ListOrdered",
  }, 
  {
    id: "lucide:ListPlus", 
    tags: ["lucide", "list", "plus"], 
    source: "lucide", 
    name: "ListPlus",
  }, 
  {
    id: "lucide:ListRestart", 
    tags: ["lucide", "list", "restart"], 
    source: "lucide", 
    name: "ListRestart",
  }, 
  {
    id: "lucide:ListStart", 
    tags: ["lucide", "list", "start"], 
    source: "lucide", 
    name: "ListStart",
  }, 
  {
    id: "lucide:ListTodo", 
    tags: ["lucide", "list", "todo"], 
    source: "lucide", 
    name: "ListTodo",
  }, 
  {
    id: "lucide:ListTree", 
    tags: ["lucide", "list", "tree"], 
    source: "lucide", 
    name: "ListTree",
  }, 
  {
    id: "lucide:ListVideo", 
    tags: ["lucide", "list", "video"], 
    source: "lucide", 
    name: "ListVideo",
  }, 
  {
    id: "lucide:ListX", 
    tags: ["lucide", "list"], 
    source: "lucide", 
    name: "ListX",
  }, 
  {
    id: "lucide:Loader", 
    tags: ["lucide", "loader"], 
    source: "lucide", 
    name: "Loader",
  }, 
  {
    id: "lucide:Loader2", 
    tags: ["lucide", "loader"], 
    source: "lucide", 
    name: "Loader2",
  }, 
  {
    id: "lucide:LoaderCircle", 
    tags: ["lucide", "loader", "circle"], 
    source: "lucide", 
    name: "LoaderCircle",
  }, 
  {
    id: "lucide:LoaderPinwheel", 
    tags: ["lucide", "loader", "pinwheel"], 
    source: "lucide", 
    name: "LoaderPinwheel",
  }, 
  {
    id: "lucide:Locate", 
    tags: ["lucide", "locate"], 
    source: "lucide", 
    name: "Locate",
  }, 
  {
    id: "lucide:LocateFixed", 
    tags: ["lucide", "locate", "fixed"], 
    source: "lucide", 
    name: "LocateFixed",
  }, 
  {
    id: "lucide:LocateOff", 
    tags: ["lucide", "locate", "off"], 
    source: "lucide", 
    name: "LocateOff",
  }, 
  {
    id: "lucide:Lock", 
    tags: ["lucide", "lock"], 
    source: "lucide", 
    name: "Lock",
  }, 
  {
    id: "lucide:LockKeyhole", 
    tags: ["lucide", "lock", "keyhole"], 
    source: "lucide", 
    name: "LockKeyhole",
  }, 
  {
    id: "lucide:LockKeyholeOpen", 
    tags: ["lucide", "lock", "keyhole", "open"], 
    source: "lucide", 
    name: "LockKeyholeOpen",
  }, 
  {
    id: "lucide:LockOpen", 
    tags: ["lucide", "lock", "open"], 
    source: "lucide", 
    name: "LockOpen",
  }, 
  {
    id: "lucide:LogIn", 
    tags: ["lucide", "log", "in"], 
    source: "lucide", 
    name: "LogIn",
  }, 
  {
    id: "lucide:LogOut", 
    tags: ["lucide", "log", "out"], 
    source: "lucide", 
    name: "LogOut",
  }, 
  {
    id: "lucide:Logs", 
    tags: ["lucide", "logs"], 
    source: "lucide", 
    name: "Logs",
  }, 
  {
    id: "lucide:Lollipop", 
    tags: ["lucide", "lollipop"], 
    source: "lucide", 
    name: "Lollipop",
  }, 
  {
    id: "lucide:Luggage", 
    tags: ["lucide", "luggage"], 
    source: "lucide", 
    name: "Luggage",
  }, 
  {
    id: "lucide:MSquare", 
    tags: ["lucide", "square"], 
    source: "lucide", 
    name: "MSquare",
  }, 
  {
    id: "lucide:Magnet", 
    tags: ["lucide", "magnet"], 
    source: "lucide", 
    name: "Magnet",
  }, 
  {
    id: "lucide:Mail", 
    tags: ["lucide", "mail"], 
    source: "lucide", 
    name: "Mail",
  }, 
  {
    id: "lucide:MailCheck", 
    tags: ["lucide", "mail", "check"], 
    source: "lucide", 
    name: "MailCheck",
  }, 
  {
    id: "lucide:MailMinus", 
    tags: ["lucide", "mail", "minus"], 
    source: "lucide", 
    name: "MailMinus",
  }, 
  {
    id: "lucide:MailOpen", 
    tags: ["lucide", "mail", "open"], 
    source: "lucide", 
    name: "MailOpen",
  }, 
  {
    id: "lucide:MailPlus", 
    tags: ["lucide", "mail", "plus"], 
    source: "lucide", 
    name: "MailPlus",
  }, 
  {
    id: "lucide:MailQuestion", 
    tags: ["lucide", "mail", "question"], 
    source: "lucide", 
    name: "MailQuestion",
  }, 
  {
    id: "lucide:MailSearch", 
    tags: ["lucide", "mail", "search"], 
    source: "lucide", 
    name: "MailSearch",
  }, 
  {
    id: "lucide:MailWarning", 
    tags: ["lucide", "mail", "warning"], 
    source: "lucide", 
    name: "MailWarning",
  }, 
  {
    id: "lucide:MailX", 
    tags: ["lucide", "mail"], 
    source: "lucide", 
    name: "MailX",
  }, 
  {
    id: "lucide:Mailbox", 
    tags: ["lucide", "mailbox"], 
    source: "lucide", 
    name: "Mailbox",
  }, 
  {
    id: "lucide:Mails", 
    tags: ["lucide", "mails"], 
    source: "lucide", 
    name: "Mails",
  }, 
  {
    id: "lucide:Map", 
    tags: ["lucide", "map"], 
    source: "lucide", 
    name: "Map",
  }, 
  {
    id: "lucide:MapPin", 
    tags: ["lucide", "map", "pin"], 
    source: "lucide", 
    name: "MapPin",
  }, 
  {
    id: "lucide:MapPinCheck", 
    tags: ["lucide", "map", "pin", "check"], 
    source: "lucide", 
    name: "MapPinCheck",
  }, 
  {
    id: "lucide:MapPinCheckInside", 
    tags: ["lucide", "map", "pin", "check", "inside"], 
    source: "lucide", 
    name: "MapPinCheckInside",
  }, 
  {
    id: "lucide:MapPinHouse", 
    tags: ["lucide", "map", "pin", "house"], 
    source: "lucide", 
    name: "MapPinHouse",
  }, 
  {
    id: "lucide:MapPinMinus", 
    tags: ["lucide", "map", "pin", "minus"], 
    source: "lucide", 
    name: "MapPinMinus",
  }, 
  {
    id: "lucide:MapPinMinusInside", 
    tags: ["lucide", "map", "pin", "minus", "inside"], 
    source: "lucide", 
    name: "MapPinMinusInside",
  }, 
  {
    id: "lucide:MapPinOff", 
    tags: ["lucide", "map", "pin", "off"], 
    source: "lucide", 
    name: "MapPinOff",
  }, 
  {
    id: "lucide:MapPinPlus", 
    tags: ["lucide", "map", "pin", "plus"], 
    source: "lucide", 
    name: "MapPinPlus",
  }, 
  {
    id: "lucide:MapPinPlusInside", 
    tags: ["lucide", "map", "pin", "plus", "inside"], 
    source: "lucide", 
    name: "MapPinPlusInside",
  }, 
  {
    id: "lucide:MapPinX", 
    tags: ["lucide", "map", "pin"], 
    source: "lucide", 
    name: "MapPinX",
  }, 
  {
    id: "lucide:MapPinXInside", 
    tags: ["lucide", "map", "pin", "inside"], 
    source: "lucide", 
    name: "MapPinXInside",
  }, 
  {
    id: "lucide:MapPinned", 
    tags: ["lucide", "map", "pinned"], 
    source: "lucide", 
    name: "MapPinned",
  }, 
  {
    id: "lucide:MapPlus", 
    tags: ["lucide", "map", "plus"], 
    source: "lucide", 
    name: "MapPlus",
  }, 
  {
    id: "lucide:Martini", 
    tags: ["lucide", "martini"], 
    source: "lucide", 
    name: "Martini",
  }, 
  {
    id: "lucide:Maximize", 
    tags: ["lucide", "maximize"], 
    source: "lucide", 
    name: "Maximize",
  }, 
  {
    id: "lucide:Maximize2", 
    tags: ["lucide", "maximize"], 
    source: "lucide", 
    name: "Maximize2",
  }, 
  {
    id: "lucide:Medal", 
    tags: ["lucide", "medal"], 
    source: "lucide", 
    name: "Medal",
  }, 
  {
    id: "lucide:Megaphone", 
    tags: ["lucide", "megaphone"], 
    source: "lucide", 
    name: "Megaphone",
  }, 
  {
    id: "lucide:MegaphoneOff", 
    tags: ["lucide", "megaphone", "off"], 
    source: "lucide", 
    name: "MegaphoneOff",
  }, 
  {
    id: "lucide:Meh", 
    tags: ["lucide", "meh"], 
    source: "lucide", 
    name: "Meh",
  }, 
  {
    id: "lucide:MemoryStick", 
    tags: ["lucide", "memory", "stick"], 
    source: "lucide", 
    name: "MemoryStick",
  }, 
  {
    id: "lucide:Menu", 
    tags: ["lucide", "menu"], 
    source: "lucide", 
    name: "Menu",
  }, 
  {
    id: "lucide:MenuSquare", 
    tags: ["lucide", "menu", "square"], 
    source: "lucide", 
    name: "MenuSquare",
  }, 
  {
    id: "lucide:Merge", 
    tags: ["lucide", "merge"], 
    source: "lucide", 
    name: "Merge",
  }, 
  {
    id: "lucide:MessageCircle", 
    tags: ["lucide", "message", "circle"], 
    source: "lucide", 
    name: "MessageCircle",
  }, 
  {
    id: "lucide:MessageCircleCode", 
    tags: ["lucide", "message", "circle", "code"], 
    source: "lucide", 
    name: "MessageCircleCode",
  }, 
  {
    id: "lucide:MessageCircleDashed", 
    tags: ["lucide", "message", "circle", "dashed"], 
    source: "lucide", 
    name: "MessageCircleDashed",
  }, 
  {
    id: "lucide:MessageCircleHeart", 
    tags: ["lucide", "message", "circle", "heart"], 
    source: "lucide", 
    name: "MessageCircleHeart",
  }, 
  {
    id: "lucide:MessageCircleMore", 
    tags: ["lucide", "message", "circle", "more"], 
    source: "lucide", 
    name: "MessageCircleMore",
  }, 
  {
    id: "lucide:MessageCircleOff", 
    tags: ["lucide", "message", "circle", "off"], 
    source: "lucide", 
    name: "MessageCircleOff",
  }, 
  {
    id: "lucide:MessageCirclePlus", 
    tags: ["lucide", "message", "circle", "plus"], 
    source: "lucide", 
    name: "MessageCirclePlus",
  }, 
  {
    id: "lucide:MessageCircleQuestion", 
    tags: ["lucide", "message", "circle", "question"], 
    source: "lucide", 
    name: "MessageCircleQuestion",
  }, 
  {
    id: "lucide:MessageCircleReply", 
    tags: ["lucide", "message", "circle", "reply"], 
    source: "lucide", 
    name: "MessageCircleReply",
  }, 
  {
    id: "lucide:MessageCircleWarning", 
    tags: ["lucide", "message", "circle", "warning"], 
    source: "lucide", 
    name: "MessageCircleWarning",
  }, 
  {
    id: "lucide:MessageCircleX", 
    tags: ["lucide", "message", "circle"], 
    source: "lucide", 
    name: "MessageCircleX",
  }, 
  {
    id: "lucide:MessageSquare", 
    tags: ["lucide", "message", "square"], 
    source: "lucide", 
    name: "MessageSquare",
  }, 
  {
    id: "lucide:MessageSquareCode", 
    tags: ["lucide", "message", "square", "code"], 
    source: "lucide", 
    name: "MessageSquareCode",
  }, 
  {
    id: "lucide:MessageSquareDashed", 
    tags: ["lucide", "message", "square", "dashed"], 
    source: "lucide", 
    name: "MessageSquareDashed",
  }, 
  {
    id: "lucide:MessageSquareDiff", 
    tags: ["lucide", "message", "square", "diff"], 
    source: "lucide", 
    name: "MessageSquareDiff",
  }, 
  {
    id: "lucide:MessageSquareDot", 
    tags: ["lucide", "message", "square", "dot"], 
    source: "lucide", 
    name: "MessageSquareDot",
  }, 
  {
    id: "lucide:MessageSquareHeart", 
    tags: ["lucide", "message", "square", "heart"], 
    source: "lucide", 
    name: "MessageSquareHeart",
  }, 
  {
    id: "lucide:MessageSquareLock", 
    tags: ["lucide", "message", "square", "lock"], 
    source: "lucide", 
    name: "MessageSquareLock",
  }, 
  {
    id: "lucide:MessageSquareMore", 
    tags: ["lucide", "message", "square", "more"], 
    source: "lucide", 
    name: "MessageSquareMore",
  }, 
  {
    id: "lucide:MessageSquareOff", 
    tags: ["lucide", "message", "square", "off"], 
    source: "lucide", 
    name: "MessageSquareOff",
  }, 
  {
    id: "lucide:MessageSquarePlus", 
    tags: ["lucide", "message", "square", "plus"], 
    source: "lucide", 
    name: "MessageSquarePlus",
  }, 
  {
    id: "lucide:MessageSquareQuote", 
    tags: ["lucide", "message", "square", "quote"], 
    source: "lucide", 
    name: "MessageSquareQuote",
  }, 
  {
    id: "lucide:MessageSquareReply", 
    tags: ["lucide", "message", "square", "reply"], 
    source: "lucide", 
    name: "MessageSquareReply",
  }, 
  {
    id: "lucide:MessageSquareShare", 
    tags: ["lucide", "message", "square", "share"], 
    source: "lucide", 
    name: "MessageSquareShare",
  }, 
  {
    id: "lucide:MessageSquareText", 
    tags: ["lucide", "message", "square", "text"], 
    source: "lucide", 
    name: "MessageSquareText",
  }, 
  {
    id: "lucide:MessageSquareWarning", 
    tags: ["lucide", "message", "square", "warning"], 
    source: "lucide", 
    name: "MessageSquareWarning",
  }, 
  {
    id: "lucide:MessageSquareX", 
    tags: ["lucide", "message", "square"], 
    source: "lucide", 
    name: "MessageSquareX",
  }, 
  {
    id: "lucide:MessagesSquare", 
    tags: ["lucide", "messages", "square"], 
    source: "lucide", 
    name: "MessagesSquare",
  }, 
  {
    id: "lucide:Mic", 
    tags: ["lucide", "mic"], 
    source: "lucide", 
    name: "Mic",
  }, 
  {
    id: "lucide:Mic2", 
    tags: ["lucide", "mic"], 
    source: "lucide", 
    name: "Mic2",
  }, 
  {
    id: "lucide:MicOff", 
    tags: ["lucide", "mic", "off"], 
    source: "lucide", 
    name: "MicOff",
  }, 
  {
    id: "lucide:MicVocal", 
    tags: ["lucide", "mic", "vocal"], 
    source: "lucide", 
    name: "MicVocal",
  }, 
  {
    id: "lucide:Microchip", 
    tags: ["lucide", "microchip"], 
    source: "lucide", 
    name: "Microchip",
  }, 
  {
    id: "lucide:Microscope", 
    tags: ["lucide", "microscope"], 
    source: "lucide", 
    name: "Microscope",
  }, 
  {
    id: "lucide:Microwave", 
    tags: ["lucide", "microwave"], 
    source: "lucide", 
    name: "Microwave",
  }, 
  {
    id: "lucide:Milestone", 
    tags: ["lucide", "milestone"], 
    source: "lucide", 
    name: "Milestone",
  }, 
  {
    id: "lucide:Milk", 
    tags: ["lucide", "milk"], 
    source: "lucide", 
    name: "Milk",
  }, 
  {
    id: "lucide:MilkOff", 
    tags: ["lucide", "milk", "off"], 
    source: "lucide", 
    name: "MilkOff",
  }, 
  {
    id: "lucide:Minimize", 
    tags: ["lucide", "minimize"], 
    source: "lucide", 
    name: "Minimize",
  }, 
  {
    id: "lucide:Minimize2", 
    tags: ["lucide", "minimize"], 
    source: "lucide", 
    name: "Minimize2",
  }, 
  {
    id: "lucide:Minus", 
    tags: ["lucide", "minus"], 
    source: "lucide", 
    name: "Minus",
  }, 
  {
    id: "lucide:MinusCircle", 
    tags: ["lucide", "minus", "circle"], 
    source: "lucide", 
    name: "MinusCircle",
  }, 
  {
    id: "lucide:MinusSquare", 
    tags: ["lucide", "minus", "square"], 
    source: "lucide", 
    name: "MinusSquare",
  }, 
  {
    id: "lucide:Monitor", 
    tags: ["lucide", "monitor"], 
    source: "lucide", 
    name: "Monitor",
  }, 
  {
    id: "lucide:MonitorCheck", 
    tags: ["lucide", "monitor", "check"], 
    source: "lucide", 
    name: "MonitorCheck",
  }, 
  {
    id: "lucide:MonitorCog", 
    tags: ["lucide", "monitor", "cog"], 
    source: "lucide", 
    name: "MonitorCog",
  }, 
  {
    id: "lucide:MonitorDot", 
    tags: ["lucide", "monitor", "dot"], 
    source: "lucide", 
    name: "MonitorDot",
  }, 
  {
    id: "lucide:MonitorDown", 
    tags: ["lucide", "monitor", "down"], 
    source: "lucide", 
    name: "MonitorDown",
  }, 
  {
    id: "lucide:MonitorOff", 
    tags: ["lucide", "monitor", "off"], 
    source: "lucide", 
    name: "MonitorOff",
  }, 
  {
    id: "lucide:MonitorPause", 
    tags: ["lucide", "monitor", "pause"], 
    source: "lucide", 
    name: "MonitorPause",
  }, 
  {
    id: "lucide:MonitorPlay", 
    tags: ["lucide", "monitor", "play"], 
    source: "lucide", 
    name: "MonitorPlay",
  }, 
  {
    id: "lucide:MonitorSmartphone", 
    tags: ["lucide", "monitor", "smartphone"], 
    source: "lucide", 
    name: "MonitorSmartphone",
  }, 
  {
    id: "lucide:MonitorSpeaker", 
    tags: ["lucide", "monitor", "speaker"], 
    source: "lucide", 
    name: "MonitorSpeaker",
  }, 
  {
    id: "lucide:MonitorStop", 
    tags: ["lucide", "monitor", "stop"], 
    source: "lucide", 
    name: "MonitorStop",
  }, 
  {
    id: "lucide:MonitorUp", 
    tags: ["lucide", "monitor", "up"], 
    source: "lucide", 
    name: "MonitorUp",
  }, 
  {
    id: "lucide:MonitorX", 
    tags: ["lucide", "monitor"], 
    source: "lucide", 
    name: "MonitorX",
  }, 
  {
    id: "lucide:Moon", 
    tags: ["lucide", "moon"], 
    source: "lucide", 
    name: "Moon",
  }, 
  {
    id: "lucide:MoonStar", 
    tags: ["lucide", "moon", "star"], 
    source: "lucide", 
    name: "MoonStar",
  }, 
  {
    id: "lucide:MoreHorizontal", 
    tags: ["lucide", "more", "horizontal"], 
    source: "lucide", 
    name: "MoreHorizontal",
  }, 
  {
    id: "lucide:MoreVertical", 
    tags: ["lucide", "more", "vertical"], 
    source: "lucide", 
    name: "MoreVertical",
  }, 
  {
    id: "lucide:Mountain", 
    tags: ["lucide", "mountain"], 
    source: "lucide", 
    name: "Mountain",
  }, 
  {
    id: "lucide:MountainSnow", 
    tags: ["lucide", "mountain", "snow"], 
    source: "lucide", 
    name: "MountainSnow",
  }, 
  {
    id: "lucide:Mouse", 
    tags: ["lucide", "mouse"], 
    source: "lucide", 
    name: "Mouse",
  }, 
  {
    id: "lucide:MouseOff", 
    tags: ["lucide", "mouse", "off"], 
    source: "lucide", 
    name: "MouseOff",
  }, 
  {
    id: "lucide:MousePointer", 
    tags: ["lucide", "mouse", "pointer"], 
    source: "lucide", 
    name: "MousePointer",
  }, 
  {
    id: "lucide:MousePointer2", 
    tags: ["lucide", "mouse", "pointer"], 
    source: "lucide", 
    name: "MousePointer2",
  }, 
  {
    id: "lucide:MousePointerBan", 
    tags: ["lucide", "mouse", "pointer", "ban"], 
    source: "lucide", 
    name: "MousePointerBan",
  }, 
  {
    id: "lucide:MousePointerClick", 
    tags: ["lucide", "mouse", "pointer", "click"], 
    source: "lucide", 
    name: "MousePointerClick",
  }, 
  {
    id: "lucide:MousePointerSquareDashed", 
    tags: ["lucide", "mouse", "pointer", "square", "dashed"], 
    source: "lucide", 
    name: "MousePointerSquareDashed",
  }, 
  {
    id: "lucide:Move", 
    tags: ["lucide", "move"], 
    source: "lucide", 
    name: "Move",
  }, 
  {
    id: "lucide:Move3d", 
    tags: ["lucide", "move"], 
    source: "lucide", 
    name: "Move3d",
  }, 
  {
    id: "lucide:MoveDiagonal", 
    tags: ["lucide", "move", "diagonal"], 
    source: "lucide", 
    name: "MoveDiagonal",
  }, 
  {
    id: "lucide:MoveDiagonal2", 
    tags: ["lucide", "move", "diagonal"], 
    source: "lucide", 
    name: "MoveDiagonal2",
  }, 
  {
    id: "lucide:MoveDown", 
    tags: ["lucide", "move", "down"], 
    source: "lucide", 
    name: "MoveDown",
  }, 
  {
    id: "lucide:MoveDownLeft", 
    tags: ["lucide", "move", "down", "left"], 
    source: "lucide", 
    name: "MoveDownLeft",
  }, 
  {
    id: "lucide:MoveDownRight", 
    tags: ["lucide", "move", "down", "right"], 
    source: "lucide", 
    name: "MoveDownRight",
  }, 
  {
    id: "lucide:MoveHorizontal", 
    tags: ["lucide", "move", "horizontal"], 
    source: "lucide", 
    name: "MoveHorizontal",
  }, 
  {
    id: "lucide:MoveLeft", 
    tags: ["lucide", "move", "left"], 
    source: "lucide", 
    name: "MoveLeft",
  }, 
  {
    id: "lucide:MoveRight", 
    tags: ["lucide", "move", "right"], 
    source: "lucide", 
    name: "MoveRight",
  }, 
  {
    id: "lucide:MoveUp", 
    tags: ["lucide", "move", "up"], 
    source: "lucide", 
    name: "MoveUp",
  }, 
  {
    id: "lucide:MoveUpLeft", 
    tags: ["lucide", "move", "up", "left"], 
    source: "lucide", 
    name: "MoveUpLeft",
  }, 
  {
    id: "lucide:MoveUpRight", 
    tags: ["lucide", "move", "up", "right"], 
    source: "lucide", 
    name: "MoveUpRight",
  }, 
  {
    id: "lucide:MoveVertical", 
    tags: ["lucide", "move", "vertical"], 
    source: "lucide", 
    name: "MoveVertical",
  }, 
  {
    id: "lucide:Music", 
    tags: ["lucide", "music"], 
    source: "lucide", 
    name: "Music",
  }, 
  {
    id: "lucide:Music2", 
    tags: ["lucide", "music"], 
    source: "lucide", 
    name: "Music2",
  }, 
  {
    id: "lucide:Music3", 
    tags: ["lucide", "music"], 
    source: "lucide", 
    name: "Music3",
  }, 
  {
    id: "lucide:Music4", 
    tags: ["lucide", "music"], 
    source: "lucide", 
    name: "Music4",
  }, 
  {
    id: "lucide:Navigation", 
    tags: ["lucide", "navigation"], 
    source: "lucide", 
    name: "Navigation",
  }, 
  {
    id: "lucide:Navigation2", 
    tags: ["lucide", "navigation"], 
    source: "lucide", 
    name: "Navigation2",
  }, 
  {
    id: "lucide:Navigation2Off", 
    tags: ["lucide", "navigation", "off"], 
    source: "lucide", 
    name: "Navigation2Off",
  }, 
  {
    id: "lucide:NavigationOff", 
    tags: ["lucide", "navigation", "off"], 
    source: "lucide", 
    name: "NavigationOff",
  }, 
  {
    id: "lucide:Network", 
    tags: ["lucide", "network"], 
    source: "lucide", 
    name: "Network",
  }, 
  {
    id: "lucide:Newspaper", 
    tags: ["lucide", "newspaper"], 
    source: "lucide", 
    name: "Newspaper",
  }, 
  {
    id: "lucide:Nfc", 
    tags: ["lucide", "nfc"], 
    source: "lucide", 
    name: "Nfc",
  }, 
  {
    id: "lucide:Notebook", 
    tags: ["lucide", "notebook"], 
    source: "lucide", 
    name: "Notebook",
  }, 
  {
    id: "lucide:NotebookPen", 
    tags: ["lucide", "notebook", "pen"], 
    source: "lucide", 
    name: "NotebookPen",
  }, 
  {
    id: "lucide:NotebookTabs", 
    tags: ["lucide", "notebook", "tabs"], 
    source: "lucide", 
    name: "NotebookTabs",
  }, 
  {
    id: "lucide:NotebookText", 
    tags: ["lucide", "notebook", "text"], 
    source: "lucide", 
    name: "NotebookText",
  }, 
  {
    id: "lucide:NotepadText", 
    tags: ["lucide", "notepad", "text"], 
    source: "lucide", 
    name: "NotepadText",
  }, 
  {
    id: "lucide:NotepadTextDashed", 
    tags: ["lucide", "notepad", "text", "dashed"], 
    source: "lucide", 
    name: "NotepadTextDashed",
  }, 
  {
    id: "lucide:Nut", 
    tags: ["lucide", "nut"], 
    source: "lucide", 
    name: "Nut",
  }, 
  {
    id: "lucide:NutOff", 
    tags: ["lucide", "nut", "off"], 
    source: "lucide", 
    name: "NutOff",
  }, 
  {
    id: "lucide:Octagon", 
    tags: ["lucide", "octagon"], 
    source: "lucide", 
    name: "Octagon",
  }, 
  {
    id: "lucide:OctagonAlert", 
    tags: ["lucide", "octagon", "alert"], 
    source: "lucide", 
    name: "OctagonAlert",
  }, 
  {
    id: "lucide:OctagonMinus", 
    tags: ["lucide", "octagon", "minus"], 
    source: "lucide", 
    name: "OctagonMinus",
  }, 
  {
    id: "lucide:OctagonPause", 
    tags: ["lucide", "octagon", "pause"], 
    source: "lucide", 
    name: "OctagonPause",
  }, 
  {
    id: "lucide:OctagonX", 
    tags: ["lucide", "octagon"], 
    source: "lucide", 
    name: "OctagonX",
  }, 
  {
    id: "lucide:Omega", 
    tags: ["lucide", "omega"], 
    source: "lucide", 
    name: "Omega",
  }, 
  {
    id: "lucide:Option", 
    tags: ["lucide", "option"], 
    source: "lucide", 
    name: "Option",
  }, 
  {
    id: "lucide:Orbit", 
    tags: ["lucide", "orbit"], 
    source: "lucide", 
    name: "Orbit",
  }, 
  {
    id: "lucide:Origami", 
    tags: ["lucide", "origami"], 
    source: "lucide", 
    name: "Origami",
  }, 
  {
    id: "lucide:Outdent", 
    tags: ["lucide", "outdent"], 
    source: "lucide", 
    name: "Outdent",
  }, 
  {
    id: "lucide:Package", 
    tags: ["lucide", "package"], 
    source: "lucide", 
    name: "Package",
  }, 
  {
    id: "lucide:Package2", 
    tags: ["lucide", "package"], 
    source: "lucide", 
    name: "Package2",
  }, 
  {
    id: "lucide:PackageCheck", 
    tags: ["lucide", "package", "check"], 
    source: "lucide", 
    name: "PackageCheck",
  }, 
  {
    id: "lucide:PackageMinus", 
    tags: ["lucide", "package", "minus"], 
    source: "lucide", 
    name: "PackageMinus",
  }, 
  {
    id: "lucide:PackageOpen", 
    tags: ["lucide", "package", "open"], 
    source: "lucide", 
    name: "PackageOpen",
  }, 
  {
    id: "lucide:PackagePlus", 
    tags: ["lucide", "package", "plus"], 
    source: "lucide", 
    name: "PackagePlus",
  }, 
  {
    id: "lucide:PackageSearch", 
    tags: ["lucide", "package", "search"], 
    source: "lucide", 
    name: "PackageSearch",
  }, 
  {
    id: "lucide:PackageX", 
    tags: ["lucide", "package"], 
    source: "lucide", 
    name: "PackageX",
  }, 
  {
    id: "lucide:PaintBucket", 
    tags: ["lucide", "paint", "bucket"], 
    source: "lucide", 
    name: "PaintBucket",
  }, 
  {
    id: "lucide:PaintRoller", 
    tags: ["lucide", "paint", "roller"], 
    source: "lucide", 
    name: "PaintRoller",
  }, 
  {
    id: "lucide:Paintbrush", 
    tags: ["lucide", "paintbrush"], 
    source: "lucide", 
    name: "Paintbrush",
  }, 
  {
    id: "lucide:Paintbrush2", 
    tags: ["lucide", "paintbrush"], 
    source: "lucide", 
    name: "Paintbrush2",
  }, 
  {
    id: "lucide:PaintbrushVertical", 
    tags: ["lucide", "paintbrush", "vertical"], 
    source: "lucide", 
    name: "PaintbrushVertical",
  }, 
  {
    id: "lucide:Palette", 
    tags: ["lucide", "palette"], 
    source: "lucide", 
    name: "Palette",
  }, 
  {
    id: "lucide:Palmtree", 
    tags: ["lucide", "palmtree"], 
    source: "lucide", 
    name: "Palmtree",
  }, 
  {
    id: "lucide:PanelBottom", 
    tags: ["lucide", "panel", "bottom"], 
    source: "lucide", 
    name: "PanelBottom",
  }, 
  {
    id: "lucide:PanelBottomClose", 
    tags: ["lucide", "panel", "bottom", "close"], 
    source: "lucide", 
    name: "PanelBottomClose",
  }, 
  {
    id: "lucide:PanelBottomDashed", 
    tags: ["lucide", "panel", "bottom", "dashed"], 
    source: "lucide", 
    name: "PanelBottomDashed",
  }, 
  {
    id: "lucide:PanelBottomInactive", 
    tags: ["lucide", "panel", "bottom", "inactive"], 
    source: "lucide", 
    name: "PanelBottomInactive",
  }, 
  {
    id: "lucide:PanelBottomOpen", 
    tags: ["lucide", "panel", "bottom", "open"], 
    source: "lucide", 
    name: "PanelBottomOpen",
  }, 
  {
    id: "lucide:PanelLeft", 
    tags: ["lucide", "panel", "left"], 
    source: "lucide", 
    name: "PanelLeft",
  }, 
  {
    id: "lucide:PanelLeftClose", 
    tags: ["lucide", "panel", "left", "close"], 
    source: "lucide", 
    name: "PanelLeftClose",
  }, 
  {
    id: "lucide:PanelLeftDashed", 
    tags: ["lucide", "panel", "left", "dashed"], 
    source: "lucide", 
    name: "PanelLeftDashed",
  }, 
  {
    id: "lucide:PanelLeftInactive", 
    tags: ["lucide", "panel", "left", "inactive"], 
    source: "lucide", 
    name: "PanelLeftInactive",
  }, 
  {
    id: "lucide:PanelLeftOpen", 
    tags: ["lucide", "panel", "left", "open"], 
    source: "lucide", 
    name: "PanelLeftOpen",
  }, 
  {
    id: "lucide:PanelRight", 
    tags: ["lucide", "panel", "right"], 
    source: "lucide", 
    name: "PanelRight",
  }, 
  {
    id: "lucide:PanelRightClose", 
    tags: ["lucide", "panel", "right", "close"], 
    source: "lucide", 
    name: "PanelRightClose",
  }, 
  {
    id: "lucide:PanelRightDashed", 
    tags: ["lucide", "panel", "right", "dashed"], 
    source: "lucide", 
    name: "PanelRightDashed",
  }, 
  {
    id: "lucide:PanelRightInactive", 
    tags: ["lucide", "panel", "right", "inactive"], 
    source: "lucide", 
    name: "PanelRightInactive",
  }, 
  {
    id: "lucide:PanelRightOpen", 
    tags: ["lucide", "panel", "right", "open"], 
    source: "lucide", 
    name: "PanelRightOpen",
  }, 
  {
    id: "lucide:PanelTop", 
    tags: ["lucide", "panel", "top"], 
    source: "lucide", 
    name: "PanelTop",
  }, 
  {
    id: "lucide:PanelTopClose", 
    tags: ["lucide", "panel", "top", "close"], 
    source: "lucide", 
    name: "PanelTopClose",
  }, 
  {
    id: "lucide:PanelTopDashed", 
    tags: ["lucide", "panel", "top", "dashed"], 
    source: "lucide", 
    name: "PanelTopDashed",
  }, 
  {
    id: "lucide:PanelTopInactive", 
    tags: ["lucide", "panel", "top", "inactive"], 
    source: "lucide", 
    name: "PanelTopInactive",
  }, 
  {
    id: "lucide:PanelTopOpen", 
    tags: ["lucide", "panel", "top", "open"], 
    source: "lucide", 
    name: "PanelTopOpen",
  }, 
  {
    id: "lucide:PanelsLeftBottom", 
    tags: ["lucide", "panels", "left", "bottom"], 
    source: "lucide", 
    name: "PanelsLeftBottom",
  }, 
  {
    id: "lucide:PanelsLeftRight", 
    tags: ["lucide", "panels", "left", "right"], 
    source: "lucide", 
    name: "PanelsLeftRight",
  }, 
  {
    id: "lucide:PanelsRightBottom", 
    tags: ["lucide", "panels", "right", "bottom"], 
    source: "lucide", 
    name: "PanelsRightBottom",
  }, 
  {
    id: "lucide:PanelsTopBottom", 
    tags: ["lucide", "panels", "top", "bottom"], 
    source: "lucide", 
    name: "PanelsTopBottom",
  }, 
  {
    id: "lucide:PanelsTopLeft", 
    tags: ["lucide", "panels", "top", "left"], 
    source: "lucide", 
    name: "PanelsTopLeft",
  }, 
  {
    id: "lucide:Paperclip", 
    tags: ["lucide", "paperclip"], 
    source: "lucide", 
    name: "Paperclip",
  }, 
  {
    id: "lucide:Parentheses", 
    tags: ["lucide", "parentheses"], 
    source: "lucide", 
    name: "Parentheses",
  }, 
  {
    id: "lucide:ParkingCircle", 
    tags: ["lucide", "parking", "circle"], 
    source: "lucide", 
    name: "ParkingCircle",
  }, 
  {
    id: "lucide:ParkingCircleOff", 
    tags: ["lucide", "parking", "circle", "off"], 
    source: "lucide", 
    name: "ParkingCircleOff",
  }, 
  {
    id: "lucide:ParkingMeter", 
    tags: ["lucide", "parking", "meter"], 
    source: "lucide", 
    name: "ParkingMeter",
  }, 
  {
    id: "lucide:ParkingSquare", 
    tags: ["lucide", "parking", "square"], 
    source: "lucide", 
    name: "ParkingSquare",
  }, 
  {
    id: "lucide:ParkingSquareOff", 
    tags: ["lucide", "parking", "square", "off"], 
    source: "lucide", 
    name: "ParkingSquareOff",
  }, 
  {
    id: "lucide:PartyPopper", 
    tags: ["lucide", "party", "popper"], 
    source: "lucide", 
    name: "PartyPopper",
  }, 
  {
    id: "lucide:Pause", 
    tags: ["lucide", "pause"], 
    source: "lucide", 
    name: "Pause",
  }, 
  {
    id: "lucide:PauseCircle", 
    tags: ["lucide", "pause", "circle"], 
    source: "lucide", 
    name: "PauseCircle",
  }, 
  {
    id: "lucide:PauseOctagon", 
    tags: ["lucide", "pause", "octagon"], 
    source: "lucide", 
    name: "PauseOctagon",
  }, 
  {
    id: "lucide:PawPrint", 
    tags: ["lucide", "paw", "print"], 
    source: "lucide", 
    name: "PawPrint",
  }, 
  {
    id: "lucide:PcCase", 
    tags: ["lucide", "pc", "case"], 
    source: "lucide", 
    name: "PcCase",
  }, 
  {
    id: "lucide:Pen", 
    tags: ["lucide", "pen"], 
    source: "lucide", 
    name: "Pen",
  }, 
  {
    id: "lucide:PenBox", 
    tags: ["lucide", "pen", "box"], 
    source: "lucide", 
    name: "PenBox",
  }, 
  {
    id: "lucide:PenLine", 
    tags: ["lucide", "pen", "line"], 
    source: "lucide", 
    name: "PenLine",
  }, 
  {
    id: "lucide:PenOff", 
    tags: ["lucide", "pen", "off"], 
    source: "lucide", 
    name: "PenOff",
  }, 
  {
    id: "lucide:PenSquare", 
    tags: ["lucide", "pen", "square"], 
    source: "lucide", 
    name: "PenSquare",
  }, 
  {
    id: "lucide:PenTool", 
    tags: ["lucide", "pen", "tool"], 
    source: "lucide", 
    name: "PenTool",
  }, 
  {
    id: "lucide:Pencil", 
    tags: ["lucide", "pencil"], 
    source: "lucide", 
    name: "Pencil",
  }, 
  {
    id: "lucide:PencilLine", 
    tags: ["lucide", "pencil", "line"], 
    source: "lucide", 
    name: "PencilLine",
  }, 
  {
    id: "lucide:PencilOff", 
    tags: ["lucide", "pencil", "off"], 
    source: "lucide", 
    name: "PencilOff",
  }, 
  {
    id: "lucide:PencilRuler", 
    tags: ["lucide", "pencil", "ruler"], 
    source: "lucide", 
    name: "PencilRuler",
  }, 
  {
    id: "lucide:Pentagon", 
    tags: ["lucide", "pentagon"], 
    source: "lucide", 
    name: "Pentagon",
  }, 
  {
    id: "lucide:Percent", 
    tags: ["lucide", "percent"], 
    source: "lucide", 
    name: "Percent",
  }, 
  {
    id: "lucide:PercentCircle", 
    tags: ["lucide", "percent", "circle"], 
    source: "lucide", 
    name: "PercentCircle",
  }, 
  {
    id: "lucide:PercentDiamond", 
    tags: ["lucide", "percent", "diamond"], 
    source: "lucide", 
    name: "PercentDiamond",
  }, 
  {
    id: "lucide:PercentSquare", 
    tags: ["lucide", "percent", "square"], 
    source: "lucide", 
    name: "PercentSquare",
  }, 
  {
    id: "lucide:PersonStanding", 
    tags: ["lucide", "person", "standing"], 
    source: "lucide", 
    name: "PersonStanding",
  }, 
  {
    id: "lucide:PhilippinePeso", 
    tags: ["lucide", "philippine", "peso"], 
    source: "lucide", 
    name: "PhilippinePeso",
  }, 
  {
    id: "lucide:Phone", 
    tags: ["lucide", "phone"], 
    source: "lucide", 
    name: "Phone",
  }, 
  {
    id: "lucide:PhoneCall", 
    tags: ["lucide", "phone", "call"], 
    source: "lucide", 
    name: "PhoneCall",
  }, 
  {
    id: "lucide:PhoneForwarded", 
    tags: ["lucide", "phone", "forwarded"], 
    source: "lucide", 
    name: "PhoneForwarded",
  }, 
  {
    id: "lucide:PhoneIncoming", 
    tags: ["lucide", "phone", "incoming"], 
    source: "lucide", 
    name: "PhoneIncoming",
  }, 
  {
    id: "lucide:PhoneMissed", 
    tags: ["lucide", "phone", "missed"], 
    source: "lucide", 
    name: "PhoneMissed",
  }, 
  {
    id: "lucide:PhoneOff", 
    tags: ["lucide", "phone", "off"], 
    source: "lucide", 
    name: "PhoneOff",
  }, 
  {
    id: "lucide:PhoneOutgoing", 
    tags: ["lucide", "phone", "outgoing"], 
    source: "lucide", 
    name: "PhoneOutgoing",
  }, 
  {
    id: "lucide:Pi", 
    tags: ["lucide", "pi"], 
    source: "lucide", 
    name: "Pi",
  }, 
  {
    id: "lucide:PiSquare", 
    tags: ["lucide", "pi", "square"], 
    source: "lucide", 
    name: "PiSquare",
  }, 
  {
    id: "lucide:Piano", 
    tags: ["lucide", "piano"], 
    source: "lucide", 
    name: "Piano",
  }, 
  {
    id: "lucide:Pickaxe", 
    tags: ["lucide", "pickaxe"], 
    source: "lucide", 
    name: "Pickaxe",
  }, 
  {
    id: "lucide:PictureInPicture", 
    tags: ["lucide", "picture", "in", "picture"], 
    source: "lucide", 
    name: "PictureInPicture",
  }, 
  {
    id: "lucide:PictureInPicture2", 
    tags: ["lucide", "picture", "in", "picture"], 
    source: "lucide", 
    name: "PictureInPicture2",
  }, 
  {
    id: "lucide:PieChart", 
    tags: ["lucide", "pie", "chart"], 
    source: "lucide", 
    name: "PieChart",
  }, 
  {
    id: "lucide:PiggyBank", 
    tags: ["lucide", "piggy", "bank"], 
    source: "lucide", 
    name: "PiggyBank",
  }, 
  {
    id: "lucide:Pilcrow", 
    tags: ["lucide", "pilcrow"], 
    source: "lucide", 
    name: "Pilcrow",
  }, 
  {
    id: "lucide:PilcrowLeft", 
    tags: ["lucide", "pilcrow", "left"], 
    source: "lucide", 
    name: "PilcrowLeft",
  }, 
  {
    id: "lucide:PilcrowRight", 
    tags: ["lucide", "pilcrow", "right"], 
    source: "lucide", 
    name: "PilcrowRight",
  }, 
  {
    id: "lucide:PilcrowSquare", 
    tags: ["lucide", "pilcrow", "square"], 
    source: "lucide", 
    name: "PilcrowSquare",
  }, 
  {
    id: "lucide:Pill", 
    tags: ["lucide", "pill"], 
    source: "lucide", 
    name: "Pill",
  }, 
  {
    id: "lucide:PillBottle", 
    tags: ["lucide", "pill", "bottle"], 
    source: "lucide", 
    name: "PillBottle",
  }, 
  {
    id: "lucide:Pin", 
    tags: ["lucide", "pin"], 
    source: "lucide", 
    name: "Pin",
  }, 
  {
    id: "lucide:PinOff", 
    tags: ["lucide", "pin", "off"], 
    source: "lucide", 
    name: "PinOff",
  }, 
  {
    id: "lucide:Pipette", 
    tags: ["lucide", "pipette"], 
    source: "lucide", 
    name: "Pipette",
  }, 
  {
    id: "lucide:Pizza", 
    tags: ["lucide", "pizza"], 
    source: "lucide", 
    name: "Pizza",
  }, 
  {
    id: "lucide:Plane", 
    tags: ["lucide", "plane"], 
    source: "lucide", 
    name: "Plane",
  }, 
  {
    id: "lucide:PlaneLanding", 
    tags: ["lucide", "plane", "landing"], 
    source: "lucide", 
    name: "PlaneLanding",
  }, 
  {
    id: "lucide:PlaneTakeoff", 
    tags: ["lucide", "plane", "takeoff"], 
    source: "lucide", 
    name: "PlaneTakeoff",
  }, 
  {
    id: "lucide:Play", 
    tags: ["lucide", "play"], 
    source: "lucide", 
    name: "Play",
  }, 
  {
    id: "lucide:PlayCircle", 
    tags: ["lucide", "play", "circle"], 
    source: "lucide", 
    name: "PlayCircle",
  }, 
  {
    id: "lucide:PlaySquare", 
    tags: ["lucide", "play", "square"], 
    source: "lucide", 
    name: "PlaySquare",
  }, 
  {
    id: "lucide:Plug", 
    tags: ["lucide", "plug"], 
    source: "lucide", 
    name: "Plug",
  }, 
  {
    id: "lucide:Plug2", 
    tags: ["lucide", "plug"], 
    source: "lucide", 
    name: "Plug2",
  }, 
  {
    id: "lucide:PlugZap", 
    tags: ["lucide", "plug", "zap"], 
    source: "lucide", 
    name: "PlugZap",
  }, 
  {
    id: "lucide:PlugZap2", 
    tags: ["lucide", "plug", "zap"], 
    source: "lucide", 
    name: "PlugZap2",
  }, 
  {
    id: "lucide:Plus", 
    tags: ["lucide", "plus"], 
    source: "lucide", 
    name: "Plus",
  }, 
  {
    id: "lucide:PlusCircle", 
    tags: ["lucide", "plus", "circle"], 
    source: "lucide", 
    name: "PlusCircle",
  }, 
  {
    id: "lucide:PlusSquare", 
    tags: ["lucide", "plus", "square"], 
    source: "lucide", 
    name: "PlusSquare",
  }, 
  {
    id: "lucide:Pocket", 
    tags: ["lucide", "pocket"], 
    source: "lucide", 
    name: "Pocket",
  }, 
  {
    id: "lucide:PocketKnife", 
    tags: ["lucide", "pocket", "knife"], 
    source: "lucide", 
    name: "PocketKnife",
  }, 
  {
    id: "lucide:Podcast", 
    tags: ["lucide", "podcast"], 
    source: "lucide", 
    name: "Podcast",
  }, 
  {
    id: "lucide:Pointer", 
    tags: ["lucide", "pointer"], 
    source: "lucide", 
    name: "Pointer",
  }, 
  {
    id: "lucide:PointerOff", 
    tags: ["lucide", "pointer", "off"], 
    source: "lucide", 
    name: "PointerOff",
  }, 
  {
    id: "lucide:Popcorn", 
    tags: ["lucide", "popcorn"], 
    source: "lucide", 
    name: "Popcorn",
  }, 
  {
    id: "lucide:Popsicle", 
    tags: ["lucide", "popsicle"], 
    source: "lucide", 
    name: "Popsicle",
  }, 
  {
    id: "lucide:PoundSterling", 
    tags: ["lucide", "pound", "sterling"], 
    source: "lucide", 
    name: "PoundSterling",
  }, 
  {
    id: "lucide:Power", 
    tags: ["lucide", "power"], 
    source: "lucide", 
    name: "Power",
  }, 
  {
    id: "lucide:PowerCircle", 
    tags: ["lucide", "power", "circle"], 
    source: "lucide", 
    name: "PowerCircle",
  }, 
  {
    id: "lucide:PowerOff", 
    tags: ["lucide", "power", "off"], 
    source: "lucide", 
    name: "PowerOff",
  }, 
  {
    id: "lucide:PowerSquare", 
    tags: ["lucide", "power", "square"], 
    source: "lucide", 
    name: "PowerSquare",
  }, 
  {
    id: "lucide:Presentation", 
    tags: ["lucide", "presentation"], 
    source: "lucide", 
    name: "Presentation",
  }, 
  {
    id: "lucide:Printer", 
    tags: ["lucide", "printer"], 
    source: "lucide", 
    name: "Printer",
  }, 
  {
    id: "lucide:PrinterCheck", 
    tags: ["lucide", "printer", "check"], 
    source: "lucide", 
    name: "PrinterCheck",
  }, 
  {
    id: "lucide:Projector", 
    tags: ["lucide", "projector"], 
    source: "lucide", 
    name: "Projector",
  }, 
  {
    id: "lucide:Proportions", 
    tags: ["lucide", "proportions"], 
    source: "lucide", 
    name: "Proportions",
  }, 
  {
    id: "lucide:Puzzle", 
    tags: ["lucide", "puzzle"], 
    source: "lucide", 
    name: "Puzzle",
  }, 
  {
    id: "lucide:Pyramid", 
    tags: ["lucide", "pyramid"], 
    source: "lucide", 
    name: "Pyramid",
  }, 
  {
    id: "lucide:QrCode", 
    tags: ["lucide", "qr", "code"], 
    source: "lucide", 
    name: "QrCode",
  }, 
  {
    id: "lucide:Quote", 
    tags: ["lucide", "quote"], 
    source: "lucide", 
    name: "Quote",
  }, 
  {
    id: "lucide:Rabbit", 
    tags: ["lucide", "rabbit"], 
    source: "lucide", 
    name: "Rabbit",
  }, 
  {
    id: "lucide:Radar", 
    tags: ["lucide", "radar"], 
    source: "lucide", 
    name: "Radar",
  }, 
  {
    id: "lucide:Radiation", 
    tags: ["lucide", "radiation"], 
    source: "lucide", 
    name: "Radiation",
  }, 
  {
    id: "lucide:Radical", 
    tags: ["lucide", "radical"], 
    source: "lucide", 
    name: "Radical",
  }, 
  {
    id: "lucide:Radio", 
    tags: ["lucide", "radio"], 
    source: "lucide", 
    name: "Radio",
  }, 
  {
    id: "lucide:RadioReceiver", 
    tags: ["lucide", "radio", "receiver"], 
    source: "lucide", 
    name: "RadioReceiver",
  }, 
  {
    id: "lucide:RadioTower", 
    tags: ["lucide", "radio", "tower"], 
    source: "lucide", 
    name: "RadioTower",
  }, 
  {
    id: "lucide:Radius", 
    tags: ["lucide", "radius"], 
    source: "lucide", 
    name: "Radius",
  }, 
  {
    id: "lucide:RailSymbol", 
    tags: ["lucide", "rail", "symbol"], 
    source: "lucide", 
    name: "RailSymbol",
  }, 
  {
    id: "lucide:Rainbow", 
    tags: ["lucide", "rainbow"], 
    source: "lucide", 
    name: "Rainbow",
  }, 
  {
    id: "lucide:Rat", 
    tags: ["lucide", "rat"], 
    source: "lucide", 
    name: "Rat",
  }, 
  {
    id: "lucide:Ratio", 
    tags: ["lucide", "ratio"], 
    source: "lucide", 
    name: "Ratio",
  }, 
  {
    id: "lucide:Receipt", 
    tags: ["lucide", "receipt"], 
    source: "lucide", 
    name: "Receipt",
  }, 
  {
    id: "lucide:ReceiptCent", 
    tags: ["lucide", "receipt", "cent"], 
    source: "lucide", 
    name: "ReceiptCent",
  }, 
  {
    id: "lucide:ReceiptEuro", 
    tags: ["lucide", "receipt", "euro"], 
    source: "lucide", 
    name: "ReceiptEuro",
  }, 
  {
    id: "lucide:ReceiptIndianRupee", 
    tags: ["lucide", "receipt", "indian", "rupee"], 
    source: "lucide", 
    name: "ReceiptIndianRupee",
  }, 
  {
    id: "lucide:ReceiptJapaneseYen", 
    tags: ["lucide", "receipt", "japanese", "yen"], 
    source: "lucide", 
    name: "ReceiptJapaneseYen",
  }, 
  {
    id: "lucide:ReceiptPoundSterling", 
    tags: ["lucide", "receipt", "pound", "sterling"], 
    source: "lucide", 
    name: "ReceiptPoundSterling",
  }, 
  {
    id: "lucide:ReceiptRussianRuble", 
    tags: ["lucide", "receipt", "russian", "ruble"], 
    source: "lucide", 
    name: "ReceiptRussianRuble",
  }, 
  {
    id: "lucide:ReceiptSwissFranc", 
    tags: ["lucide", "receipt", "swiss", "franc"], 
    source: "lucide", 
    name: "ReceiptSwissFranc",
  }, 
  {
    id: "lucide:ReceiptText", 
    tags: ["lucide", "receipt", "text"], 
    source: "lucide", 
    name: "ReceiptText",
  }, 
  {
    id: "lucide:RectangleEllipsis", 
    tags: ["lucide", "rectangle", "ellipsis"], 
    source: "lucide", 
    name: "RectangleEllipsis",
  }, 
  {
    id: "lucide:RectangleHorizontal", 
    tags: ["lucide", "rectangle", "horizontal"], 
    source: "lucide", 
    name: "RectangleHorizontal",
  }, 
  {
    id: "lucide:RectangleVertical", 
    tags: ["lucide", "rectangle", "vertical"], 
    source: "lucide", 
    name: "RectangleVertical",
  }, 
  {
    id: "lucide:Recycle", 
    tags: ["lucide", "recycle"], 
    source: "lucide", 
    name: "Recycle",
  }, 
  {
    id: "lucide:Redo", 
    tags: ["lucide", "redo"], 
    source: "lucide", 
    name: "Redo",
  }, 
  {
    id: "lucide:Redo2", 
    tags: ["lucide", "redo"], 
    source: "lucide", 
    name: "Redo2",
  }, 
  {
    id: "lucide:RedoDot", 
    tags: ["lucide", "redo", "dot"], 
    source: "lucide", 
    name: "RedoDot",
  }, 
  {
    id: "lucide:RefreshCcw", 
    tags: ["lucide", "refresh", "ccw"], 
    source: "lucide", 
    name: "RefreshCcw",
  }, 
  {
    id: "lucide:RefreshCcwDot", 
    tags: ["lucide", "refresh", "ccw", "dot"], 
    source: "lucide", 
    name: "RefreshCcwDot",
  }, 
  {
    id: "lucide:RefreshCw", 
    tags: ["lucide", "refresh", "cw"], 
    source: "lucide", 
    name: "RefreshCw",
  }, 
  {
    id: "lucide:RefreshCwOff", 
    tags: ["lucide", "refresh", "cw", "off"], 
    source: "lucide", 
    name: "RefreshCwOff",
  }, 
  {
    id: "lucide:Refrigerator", 
    tags: ["lucide", "refrigerator"], 
    source: "lucide", 
    name: "Refrigerator",
  }, 
  {
    id: "lucide:Regex", 
    tags: ["lucide", "regex"], 
    source: "lucide", 
    name: "Regex",
  }, 
  {
    id: "lucide:RemoveFormatting", 
    tags: ["lucide", "remove", "formatting"], 
    source: "lucide", 
    name: "RemoveFormatting",
  }, 
  {
    id: "lucide:Repeat", 
    tags: ["lucide", "repeat"], 
    source: "lucide", 
    name: "Repeat",
  }, 
  {
    id: "lucide:Repeat1", 
    tags: ["lucide", "repeat"], 
    source: "lucide", 
    name: "Repeat1",
  }, 
  {
    id: "lucide:Repeat2", 
    tags: ["lucide", "repeat"], 
    source: "lucide", 
    name: "Repeat2",
  }, 
  {
    id: "lucide:Replace", 
    tags: ["lucide", "replace"], 
    source: "lucide", 
    name: "Replace",
  }, 
  {
    id: "lucide:ReplaceAll", 
    tags: ["lucide", "replace", "all"], 
    source: "lucide", 
    name: "ReplaceAll",
  }, 
  {
    id: "lucide:Reply", 
    tags: ["lucide", "reply"], 
    source: "lucide", 
    name: "Reply",
  }, 
  {
    id: "lucide:ReplyAll", 
    tags: ["lucide", "reply", "all"], 
    source: "lucide", 
    name: "ReplyAll",
  }, 
  {
    id: "lucide:Rewind", 
    tags: ["lucide", "rewind"], 
    source: "lucide", 
    name: "Rewind",
  }, 
  {
    id: "lucide:Ribbon", 
    tags: ["lucide", "ribbon"], 
    source: "lucide", 
    name: "Ribbon",
  }, 
  {
    id: "lucide:Rocket", 
    tags: ["lucide", "rocket"], 
    source: "lucide", 
    name: "Rocket",
  }, 
  {
    id: "lucide:RockingChair", 
    tags: ["lucide", "rocking", "chair"], 
    source: "lucide", 
    name: "RockingChair",
  }, 
  {
    id: "lucide:RollerCoaster", 
    tags: ["lucide", "roller", "coaster"], 
    source: "lucide", 
    name: "RollerCoaster",
  }, 
  {
    id: "lucide:Rotate3d", 
    tags: ["lucide", "rotate"], 
    source: "lucide", 
    name: "Rotate3d",
  }, 
  {
    id: "lucide:RotateCcw", 
    tags: ["lucide", "rotate", "ccw"], 
    source: "lucide", 
    name: "RotateCcw",
  }, 
  {
    id: "lucide:RotateCcwSquare", 
    tags: ["lucide", "rotate", "ccw", "square"], 
    source: "lucide", 
    name: "RotateCcwSquare",
  }, 
  {
    id: "lucide:RotateCw", 
    tags: ["lucide", "rotate", "cw"], 
    source: "lucide", 
    name: "RotateCw",
  }, 
  {
    id: "lucide:RotateCwSquare", 
    tags: ["lucide", "rotate", "cw", "square"], 
    source: "lucide", 
    name: "RotateCwSquare",
  }, 
  {
    id: "lucide:Route", 
    tags: ["lucide", "route"], 
    source: "lucide", 
    name: "Route",
  }, 
  {
    id: "lucide:RouteOff", 
    tags: ["lucide", "route", "off"], 
    source: "lucide", 
    name: "RouteOff",
  }, 
  {
    id: "lucide:Router", 
    tags: ["lucide", "router"], 
    source: "lucide", 
    name: "Router",
  }, 
  {
    id: "lucide:Rows", 
    tags: ["lucide", "rows"], 
    source: "lucide", 
    name: "Rows",
  }, 
  {
    id: "lucide:Rows2", 
    tags: ["lucide", "rows"], 
    source: "lucide", 
    name: "Rows2",
  }, 
  {
    id: "lucide:Rows3", 
    tags: ["lucide", "rows"], 
    source: "lucide", 
    name: "Rows3",
  }, 
  {
    id: "lucide:Rows4", 
    tags: ["lucide", "rows"], 
    source: "lucide", 
    name: "Rows4",
  }, 
  {
    id: "lucide:Rss", 
    tags: ["lucide", "rss"], 
    source: "lucide", 
    name: "Rss",
  }, 
  {
    id: "lucide:Ruler", 
    tags: ["lucide", "ruler"], 
    source: "lucide", 
    name: "Ruler",
  }, 
  {
    id: "lucide:RussianRuble", 
    tags: ["lucide", "russian", "ruble"], 
    source: "lucide", 
    name: "RussianRuble",
  }, 
  {
    id: "lucide:Sailboat", 
    tags: ["lucide", "sailboat"], 
    source: "lucide", 
    name: "Sailboat",
  }, 
  {
    id: "lucide:Salad", 
    tags: ["lucide", "salad"], 
    source: "lucide", 
    name: "Salad",
  }, 
  {
    id: "lucide:Sandwich", 
    tags: ["lucide", "sandwich"], 
    source: "lucide", 
    name: "Sandwich",
  }, 
  {
    id: "lucide:Satellite", 
    tags: ["lucide", "satellite"], 
    source: "lucide", 
    name: "Satellite",
  }, 
  {
    id: "lucide:SatelliteDish", 
    tags: ["lucide", "satellite", "dish"], 
    source: "lucide", 
    name: "SatelliteDish",
  }, 
  {
    id: "lucide:Save", 
    tags: ["lucide", "save"], 
    source: "lucide", 
    name: "Save",
  }, 
  {
    id: "lucide:SaveAll", 
    tags: ["lucide", "save", "all"], 
    source: "lucide", 
    name: "SaveAll",
  }, 
  {
    id: "lucide:SaveOff", 
    tags: ["lucide", "save", "off"], 
    source: "lucide", 
    name: "SaveOff",
  }, 
  {
    id: "lucide:Scale", 
    tags: ["lucide", "scale"], 
    source: "lucide", 
    name: "Scale",
  }, 
  {
    id: "lucide:Scale3d", 
    tags: ["lucide", "scale"], 
    source: "lucide", 
    name: "Scale3d",
  }, 
  {
    id: "lucide:Scaling", 
    tags: ["lucide", "scaling"], 
    source: "lucide", 
    name: "Scaling",
  }, 
  {
    id: "lucide:Scan", 
    tags: ["lucide", "scan"], 
    source: "lucide", 
    name: "Scan",
  }, 
  {
    id: "lucide:ScanBarcode", 
    tags: ["lucide", "scan", "barcode"], 
    source: "lucide", 
    name: "ScanBarcode",
  }, 
  {
    id: "lucide:ScanEye", 
    tags: ["lucide", "scan", "eye"], 
    source: "lucide", 
    name: "ScanEye",
  }, 
  {
    id: "lucide:ScanFace", 
    tags: ["lucide", "scan", "face"], 
    source: "lucide", 
    name: "ScanFace",
  }, 
  {
    id: "lucide:ScanHeart", 
    tags: ["lucide", "scan", "heart"], 
    source: "lucide", 
    name: "ScanHeart",
  }, 
  {
    id: "lucide:ScanLine", 
    tags: ["lucide", "scan", "line"], 
    source: "lucide", 
    name: "ScanLine",
  }, 
  {
    id: "lucide:ScanQrCode", 
    tags: ["lucide", "scan", "qr", "code"], 
    source: "lucide", 
    name: "ScanQrCode",
  }, 
  {
    id: "lucide:ScanSearch", 
    tags: ["lucide", "scan", "search"], 
    source: "lucide", 
    name: "ScanSearch",
  }, 
  {
    id: "lucide:ScanText", 
    tags: ["lucide", "scan", "text"], 
    source: "lucide", 
    name: "ScanText",
  }, 
  {
    id: "lucide:ScatterChart", 
    tags: ["lucide", "scatter", "chart"], 
    source: "lucide", 
    name: "ScatterChart",
  }, 
  {
    id: "lucide:School", 
    tags: ["lucide", "school"], 
    source: "lucide", 
    name: "School",
  }, 
  {
    id: "lucide:School2", 
    tags: ["lucide", "school"], 
    source: "lucide", 
    name: "School2",
  }, 
  {
    id: "lucide:Scissors", 
    tags: ["lucide", "scissors"], 
    source: "lucide", 
    name: "Scissors",
  }, 
  {
    id: "lucide:ScissorsLineDashed", 
    tags: ["lucide", "scissors", "line", "dashed"], 
    source: "lucide", 
    name: "ScissorsLineDashed",
  }, 
  {
    id: "lucide:ScissorsSquare", 
    tags: ["lucide", "scissors", "square"], 
    source: "lucide", 
    name: "ScissorsSquare",
  }, 
  {
    id: "lucide:ScissorsSquareDashedBottom", 
    tags: ["lucide", "scissors", "square", "dashed", "bottom"], 
    source: "lucide", 
    name: "ScissorsSquareDashedBottom",
  }, 
  {
    id: "lucide:ScreenShare", 
    tags: ["lucide", "screen", "share"], 
    source: "lucide", 
    name: "ScreenShare",
  }, 
  {
    id: "lucide:ScreenShareOff", 
    tags: ["lucide", "screen", "share", "off"], 
    source: "lucide", 
    name: "ScreenShareOff",
  }, 
  {
    id: "lucide:Scroll", 
    tags: ["lucide", "scroll"], 
    source: "lucide", 
    name: "Scroll",
  }, 
  {
    id: "lucide:ScrollText", 
    tags: ["lucide", "scroll", "text"], 
    source: "lucide", 
    name: "ScrollText",
  }, 
  {
    id: "lucide:Search", 
    tags: ["lucide", "search"], 
    source: "lucide", 
    name: "Search",
  }, 
  {
    id: "lucide:SearchCheck", 
    tags: ["lucide", "search", "check"], 
    source: "lucide", 
    name: "SearchCheck",
  }, 
  {
    id: "lucide:SearchCode", 
    tags: ["lucide", "search", "code"], 
    source: "lucide", 
    name: "SearchCode",
  }, 
  {
    id: "lucide:SearchSlash", 
    tags: ["lucide", "search", "slash"], 
    source: "lucide", 
    name: "SearchSlash",
  }, 
  {
    id: "lucide:SearchX", 
    tags: ["lucide", "search"], 
    source: "lucide", 
    name: "SearchX",
  }, 
  {
    id: "lucide:Section", 
    tags: ["lucide", "section"], 
    source: "lucide", 
    name: "Section",
  }, 
  {
    id: "lucide:Send", 
    tags: ["lucide", "send"], 
    source: "lucide", 
    name: "Send",
  }, 
  {
    id: "lucide:SendHorizonal", 
    tags: ["lucide", "send", "horizonal"], 
    source: "lucide", 
    name: "SendHorizonal",
  }, 
  {
    id: "lucide:SendHorizontal", 
    tags: ["lucide", "send", "horizontal"], 
    source: "lucide", 
    name: "SendHorizontal",
  }, 
  {
    id: "lucide:SendToBack", 
    tags: ["lucide", "send", "to", "back"], 
    source: "lucide", 
    name: "SendToBack",
  }, 
  {
    id: "lucide:SeparatorHorizontal", 
    tags: ["lucide", "separator", "horizontal"], 
    source: "lucide", 
    name: "SeparatorHorizontal",
  }, 
  {
    id: "lucide:SeparatorVertical", 
    tags: ["lucide", "separator", "vertical"], 
    source: "lucide", 
    name: "SeparatorVertical",
  }, 
  {
    id: "lucide:Server", 
    tags: ["lucide", "server"], 
    source: "lucide", 
    name: "Server",
  }, 
  {
    id: "lucide:ServerCog", 
    tags: ["lucide", "server", "cog"], 
    source: "lucide", 
    name: "ServerCog",
  }, 
  {
    id: "lucide:ServerCrash", 
    tags: ["lucide", "server", "crash"], 
    source: "lucide", 
    name: "ServerCrash",
  }, 
  {
    id: "lucide:ServerOff", 
    tags: ["lucide", "server", "off"], 
    source: "lucide", 
    name: "ServerOff",
  }, 
  {
    id: "lucide:Settings", 
    tags: ["lucide", "settings"], 
    source: "lucide", 
    name: "Settings",
  }, 
  {
    id: "lucide:Settings2", 
    tags: ["lucide", "settings"], 
    source: "lucide", 
    name: "Settings2",
  }, 
  {
    id: "lucide:Shapes", 
    tags: ["lucide", "shapes"], 
    source: "lucide", 
    name: "Shapes",
  }, 
  {
    id: "lucide:Share", 
    tags: ["lucide", "share"], 
    source: "lucide", 
    name: "Share",
  }, 
  {
    id: "lucide:Share2", 
    tags: ["lucide", "share"], 
    source: "lucide", 
    name: "Share2",
  }, 
  {
    id: "lucide:Sheet", 
    tags: ["lucide", "sheet"], 
    source: "lucide", 
    name: "Sheet",
  }, 
  {
    id: "lucide:Shell", 
    tags: ["lucide", "shell"], 
    source: "lucide", 
    name: "Shell",
  }, 
  {
    id: "lucide:Shield", 
    tags: ["lucide", "shield"], 
    source: "lucide", 
    name: "Shield",
  }, 
  {
    id: "lucide:ShieldAlert", 
    tags: ["lucide", "shield", "alert"], 
    source: "lucide", 
    name: "ShieldAlert",
  }, 
  {
    id: "lucide:ShieldBan", 
    tags: ["lucide", "shield", "ban"], 
    source: "lucide", 
    name: "ShieldBan",
  }, 
  {
    id: "lucide:ShieldCheck", 
    tags: ["lucide", "shield", "check"], 
    source: "lucide", 
    name: "ShieldCheck",
  }, 
  {
    id: "lucide:ShieldClose", 
    tags: ["lucide", "shield", "close"], 
    source: "lucide", 
    name: "ShieldClose",
  }, 
  {
    id: "lucide:ShieldEllipsis", 
    tags: ["lucide", "shield", "ellipsis"], 
    source: "lucide", 
    name: "ShieldEllipsis",
  }, 
  {
    id: "lucide:ShieldHalf", 
    tags: ["lucide", "shield", "half"], 
    source: "lucide", 
    name: "ShieldHalf",
  }, 
  {
    id: "lucide:ShieldMinus", 
    tags: ["lucide", "shield", "minus"], 
    source: "lucide", 
    name: "ShieldMinus",
  }, 
  {
    id: "lucide:ShieldOff", 
    tags: ["lucide", "shield", "off"], 
    source: "lucide", 
    name: "ShieldOff",
  }, 
  {
    id: "lucide:ShieldPlus", 
    tags: ["lucide", "shield", "plus"], 
    source: "lucide", 
    name: "ShieldPlus",
  }, 
  {
    id: "lucide:ShieldQuestion", 
    tags: ["lucide", "shield", "question"], 
    source: "lucide", 
    name: "ShieldQuestion",
  }, 
  {
    id: "lucide:ShieldX", 
    tags: ["lucide", "shield"], 
    source: "lucide", 
    name: "ShieldX",
  }, 
  {
    id: "lucide:Ship", 
    tags: ["lucide", "ship"], 
    source: "lucide", 
    name: "Ship",
  }, 
  {
    id: "lucide:ShipWheel", 
    tags: ["lucide", "ship", "wheel"], 
    source: "lucide", 
    name: "ShipWheel",
  }, 
  {
    id: "lucide:Shirt", 
    tags: ["lucide", "shirt"], 
    source: "lucide", 
    name: "Shirt",
  }, 
  {
    id: "lucide:ShoppingBag", 
    tags: ["lucide", "shopping", "bag"], 
    source: "lucide", 
    name: "ShoppingBag",
  }, 
  {
    id: "lucide:ShoppingBasket", 
    tags: ["lucide", "shopping", "basket"], 
    source: "lucide", 
    name: "ShoppingBasket",
  }, 
  {
    id: "lucide:ShoppingCart", 
    tags: ["lucide", "shopping", "cart"], 
    source: "lucide", 
    name: "ShoppingCart",
  }, 
  {
    id: "lucide:Shovel", 
    tags: ["lucide", "shovel"], 
    source: "lucide", 
    name: "Shovel",
  }, 
  {
    id: "lucide:ShowerHead", 
    tags: ["lucide", "shower", "head"], 
    source: "lucide", 
    name: "ShowerHead",
  }, 
  {
    id: "lucide:Shrink", 
    tags: ["lucide", "shrink"], 
    source: "lucide", 
    name: "Shrink",
  }, 
  {
    id: "lucide:Shrub", 
    tags: ["lucide", "shrub"], 
    source: "lucide", 
    name: "Shrub",
  }, 
  {
    id: "lucide:Shuffle", 
    tags: ["lucide", "shuffle"], 
    source: "lucide", 
    name: "Shuffle",
  }, 
  {
    id: "lucide:Sidebar", 
    tags: ["lucide", "sidebar"], 
    source: "lucide", 
    name: "Sidebar",
  }, 
  {
    id: "lucide:SidebarClose", 
    tags: ["lucide", "sidebar", "close"], 
    source: "lucide", 
    name: "SidebarClose",
  }, 
  {
    id: "lucide:SidebarOpen", 
    tags: ["lucide", "sidebar", "open"], 
    source: "lucide", 
    name: "SidebarOpen",
  }, 
  {
    id: "lucide:Sigma", 
    tags: ["lucide", "sigma"], 
    source: "lucide", 
    name: "Sigma",
  }, 
  {
    id: "lucide:SigmaSquare", 
    tags: ["lucide", "sigma", "square"], 
    source: "lucide", 
    name: "SigmaSquare",
  }, 
  {
    id: "lucide:Signal", 
    tags: ["lucide", "signal"], 
    source: "lucide", 
    name: "Signal",
  }, 
  {
    id: "lucide:SignalHigh", 
    tags: ["lucide", "signal", "high"], 
    source: "lucide", 
    name: "SignalHigh",
  }, 
  {
    id: "lucide:SignalLow", 
    tags: ["lucide", "signal", "low"], 
    source: "lucide", 
    name: "SignalLow",
  }, 
  {
    id: "lucide:SignalMedium", 
    tags: ["lucide", "signal", "medium"], 
    source: "lucide", 
    name: "SignalMedium",
  }, 
  {
    id: "lucide:SignalZero", 
    tags: ["lucide", "signal", "zero"], 
    source: "lucide", 
    name: "SignalZero",
  }, 
  {
    id: "lucide:Signature", 
    tags: ["lucide", "signature"], 
    source: "lucide", 
    name: "Signature",
  }, 
  {
    id: "lucide:Signpost", 
    tags: ["lucide", "signpost"], 
    source: "lucide", 
    name: "Signpost",
  }, 
  {
    id: "lucide:SignpostBig", 
    tags: ["lucide", "signpost", "big"], 
    source: "lucide", 
    name: "SignpostBig",
  }, 
  {
    id: "lucide:Siren", 
    tags: ["lucide", "siren"], 
    source: "lucide", 
    name: "Siren",
  }, 
  {
    id: "lucide:SkipBack", 
    tags: ["lucide", "skip", "back"], 
    source: "lucide", 
    name: "SkipBack",
  }, 
  {
    id: "lucide:SkipForward", 
    tags: ["lucide", "skip", "forward"], 
    source: "lucide", 
    name: "SkipForward",
  }, 
  {
    id: "lucide:Skull", 
    tags: ["lucide", "skull"], 
    source: "lucide", 
    name: "Skull",
  }, 
  {
    id: "lucide:Slack", 
    tags: ["lucide", "slack"], 
    source: "lucide", 
    name: "Slack",
  }, 
  {
    id: "lucide:Slash", 
    tags: ["lucide", "slash"], 
    source: "lucide", 
    name: "Slash",
  }, 
  {
    id: "lucide:SlashSquare", 
    tags: ["lucide", "slash", "square"], 
    source: "lucide", 
    name: "SlashSquare",
  }, 
  {
    id: "lucide:Slice", 
    tags: ["lucide", "slice"], 
    source: "lucide", 
    name: "Slice",
  }, 
  {
    id: "lucide:Sliders", 
    tags: ["lucide", "sliders"], 
    source: "lucide", 
    name: "Sliders",
  }, 
  {
    id: "lucide:SlidersHorizontal", 
    tags: ["lucide", "sliders", "horizontal"], 
    source: "lucide", 
    name: "SlidersHorizontal",
  }, 
  {
    id: "lucide:SlidersVertical", 
    tags: ["lucide", "sliders", "vertical"], 
    source: "lucide", 
    name: "SlidersVertical",
  }, 
  {
    id: "lucide:Smartphone", 
    tags: ["lucide", "smartphone"], 
    source: "lucide", 
    name: "Smartphone",
  }, 
  {
    id: "lucide:SmartphoneCharging", 
    tags: ["lucide", "smartphone", "charging"], 
    source: "lucide", 
    name: "SmartphoneCharging",
  }, 
  {
    id: "lucide:SmartphoneNfc", 
    tags: ["lucide", "smartphone", "nfc"], 
    source: "lucide", 
    name: "SmartphoneNfc",
  }, 
  {
    id: "lucide:Smile", 
    tags: ["lucide", "smile"], 
    source: "lucide", 
    name: "Smile",
  }, 
  {
    id: "lucide:SmilePlus", 
    tags: ["lucide", "smile", "plus"], 
    source: "lucide", 
    name: "SmilePlus",
  }, 
  {
    id: "lucide:Snail", 
    tags: ["lucide", "snail"], 
    source: "lucide", 
    name: "Snail",
  }, 
  {
    id: "lucide:Snowflake", 
    tags: ["lucide", "snowflake"], 
    source: "lucide", 
    name: "Snowflake",
  }, 
  {
    id: "lucide:Sofa", 
    tags: ["lucide", "sofa"], 
    source: "lucide", 
    name: "Sofa",
  }, 
  {
    id: "lucide:SortAsc", 
    tags: ["lucide", "sort", "asc"], 
    source: "lucide", 
    name: "SortAsc",
  }, 
  {
    id: "lucide:SortDesc", 
    tags: ["lucide", "sort", "desc"], 
    source: "lucide", 
    name: "SortDesc",
  }, 
  {
    id: "lucide:Soup", 
    tags: ["lucide", "soup"], 
    source: "lucide", 
    name: "Soup",
  }, 
  {
    id: "lucide:Space", 
    tags: ["lucide", "space"], 
    source: "lucide", 
    name: "Space",
  }, 
  {
    id: "lucide:Spade", 
    tags: ["lucide", "spade"], 
    source: "lucide", 
    name: "Spade",
  }, 
  {
    id: "lucide:Sparkle", 
    tags: ["lucide", "sparkle"], 
    source: "lucide", 
    name: "Sparkle",
  }, 
  {
    id: "lucide:Sparkles", 
    tags: ["lucide", "sparkles"], 
    source: "lucide", 
    name: "Sparkles",
  }, 
  {
    id: "lucide:Speaker", 
    tags: ["lucide", "speaker"], 
    source: "lucide", 
    name: "Speaker",
  }, 
  {
    id: "lucide:Speech", 
    tags: ["lucide", "speech"], 
    source: "lucide", 
    name: "Speech",
  }, 
  {
    id: "lucide:SpellCheck", 
    tags: ["lucide", "spell", "check"], 
    source: "lucide", 
    name: "SpellCheck",
  }, 
  {
    id: "lucide:SpellCheck2", 
    tags: ["lucide", "spell", "check"], 
    source: "lucide", 
    name: "SpellCheck2",
  }, 
  {
    id: "lucide:Spline", 
    tags: ["lucide", "spline"], 
    source: "lucide", 
    name: "Spline",
  }, 
  {
    id: "lucide:Split", 
    tags: ["lucide", "split"], 
    source: "lucide", 
    name: "Split",
  }, 
  {
    id: "lucide:SplitSquareHorizontal", 
    tags: ["lucide", "split", "square", "horizontal"], 
    source: "lucide", 
    name: "SplitSquareHorizontal",
  }, 
  {
    id: "lucide:SplitSquareVertical", 
    tags: ["lucide", "split", "square", "vertical"], 
    source: "lucide", 
    name: "SplitSquareVertical",
  }, 
  {
    id: "lucide:SprayCan", 
    tags: ["lucide", "spray", "can"], 
    source: "lucide", 
    name: "SprayCan",
  }, 
  {
    id: "lucide:Sprout", 
    tags: ["lucide", "sprout"], 
    source: "lucide", 
    name: "Sprout",
  }, 
  {
    id: "lucide:Square", 
    tags: ["lucide", "square"], 
    source: "lucide", 
    name: "Square",
  }, 
  {
    id: "lucide:SquareActivity", 
    tags: ["lucide", "square", "activity"], 
    source: "lucide", 
    name: "SquareActivity",
  }, 
  {
    id: "lucide:SquareArrowDown", 
    tags: ["lucide", "square", "arrow", "down"], 
    source: "lucide", 
    name: "SquareArrowDown",
  }, 
  {
    id: "lucide:SquareArrowDownLeft", 
    tags: ["lucide", "square", "arrow", "down", "left"], 
    source: "lucide", 
    name: "SquareArrowDownLeft",
  }, 
  {
    id: "lucide:SquareArrowDownRight", 
    tags: ["lucide", "square", "arrow", "down", "right"], 
    source: "lucide", 
    name: "SquareArrowDownRight",
  }, 
  {
    id: "lucide:SquareArrowLeft", 
    tags: ["lucide", "square", "arrow", "left"], 
    source: "lucide", 
    name: "SquareArrowLeft",
  }, 
  {
    id: "lucide:SquareArrowOutDownLeft", 
    tags: ["lucide", "square", "arrow", "out", "down", "left"], 
    source: "lucide", 
    name: "SquareArrowOutDownLeft",
  }, 
  {
    id: "lucide:SquareArrowOutDownRight", 
    tags: ["lucide", "square", "arrow", "out", "down", "right"], 
    source: "lucide", 
    name: "SquareArrowOutDownRight",
  }, 
  {
    id: "lucide:SquareArrowOutUpLeft", 
    tags: ["lucide", "square", "arrow", "out", "up", "left"], 
    source: "lucide", 
    name: "SquareArrowOutUpLeft",
  }, 
  {
    id: "lucide:SquareArrowOutUpRight", 
    tags: ["lucide", "square", "arrow", "out", "up", "right"], 
    source: "lucide", 
    name: "SquareArrowOutUpRight",
  }, 
  {
    id: "lucide:SquareArrowRight", 
    tags: ["lucide", "square", "arrow", "right"], 
    source: "lucide", 
    name: "SquareArrowRight",
  }, 
  {
    id: "lucide:SquareArrowUp", 
    tags: ["lucide", "square", "arrow", "up"], 
    source: "lucide", 
    name: "SquareArrowUp",
  }, 
  {
    id: "lucide:SquareArrowUpLeft", 
    tags: ["lucide", "square", "arrow", "up", "left"], 
    source: "lucide", 
    name: "SquareArrowUpLeft",
  }, 
  {
    id: "lucide:SquareArrowUpRight", 
    tags: ["lucide", "square", "arrow", "up", "right"], 
    source: "lucide", 
    name: "SquareArrowUpRight",
  }, 
  {
    id: "lucide:SquareAsterisk", 
    tags: ["lucide", "square", "asterisk"], 
    source: "lucide", 
    name: "SquareAsterisk",
  }, 
  {
    id: "lucide:SquareBottomDashedScissors", 
    tags: ["lucide", "square", "bottom", "dashed", "scissors"], 
    source: "lucide", 
    name: "SquareBottomDashedScissors",
  }, 
  {
    id: "lucide:SquareChartGantt", 
    tags: ["lucide", "square", "chart", "gantt"], 
    source: "lucide", 
    name: "SquareChartGantt",
  }, 
  {
    id: "lucide:SquareCheck", 
    tags: ["lucide", "square", "check"], 
    source: "lucide", 
    name: "SquareCheck",
  }, 
  {
    id: "lucide:SquareCheckBig", 
    tags: ["lucide", "square", "check", "big"], 
    source: "lucide", 
    name: "SquareCheckBig",
  }, 
  {
    id: "lucide:SquareChevronDown", 
    tags: ["lucide", "square", "chevron", "down"], 
    source: "lucide", 
    name: "SquareChevronDown",
  }, 
  {
    id: "lucide:SquareChevronLeft", 
    tags: ["lucide", "square", "chevron", "left"], 
    source: "lucide", 
    name: "SquareChevronLeft",
  }, 
  {
    id: "lucide:SquareChevronRight", 
    tags: ["lucide", "square", "chevron", "right"], 
    source: "lucide", 
    name: "SquareChevronRight",
  }, 
  {
    id: "lucide:SquareChevronUp", 
    tags: ["lucide", "square", "chevron", "up"], 
    source: "lucide", 
    name: "SquareChevronUp",
  }, 
  {
    id: "lucide:SquareCode", 
    tags: ["lucide", "square", "code"], 
    source: "lucide", 
    name: "SquareCode",
  }, 
  {
    id: "lucide:SquareDashed", 
    tags: ["lucide", "square", "dashed"], 
    source: "lucide", 
    name: "SquareDashed",
  }, 
  {
    id: "lucide:SquareDashedBottom", 
    tags: ["lucide", "square", "dashed", "bottom"], 
    source: "lucide", 
    name: "SquareDashedBottom",
  }, 
  {
    id: "lucide:SquareDashedBottomCode", 
    tags: ["lucide", "square", "dashed", "bottom", "code"], 
    source: "lucide", 
    name: "SquareDashedBottomCode",
  }, 
  {
    id: "lucide:SquareDashedKanban", 
    tags: ["lucide", "square", "dashed", "kanban"], 
    source: "lucide", 
    name: "SquareDashedKanban",
  }, 
  {
    id: "lucide:SquareDashedMousePointer", 
    tags: ["lucide", "square", "dashed", "mouse", "pointer"], 
    source: "lucide", 
    name: "SquareDashedMousePointer",
  }, 
  {
    id: "lucide:SquareDivide", 
    tags: ["lucide", "square", "divide"], 
    source: "lucide", 
    name: "SquareDivide",
  }, 
  {
    id: "lucide:SquareDot", 
    tags: ["lucide", "square", "dot"], 
    source: "lucide", 
    name: "SquareDot",
  }, 
  {
    id: "lucide:SquareEqual", 
    tags: ["lucide", "square", "equal"], 
    source: "lucide", 
    name: "SquareEqual",
  }, 
  {
    id: "lucide:SquareFunction", 
    tags: ["lucide", "square", "function"], 
    source: "lucide", 
    name: "SquareFunction",
  }, 
  {
    id: "lucide:SquareGanttChart", 
    tags: ["lucide", "square", "gantt", "chart"], 
    source: "lucide", 
    name: "SquareGanttChart",
  }, 
  {
    id: "lucide:SquareKanban", 
    tags: ["lucide", "square", "kanban"], 
    source: "lucide", 
    name: "SquareKanban",
  }, 
  {
    id: "lucide:SquareLibrary", 
    tags: ["lucide", "square", "library"], 
    source: "lucide", 
    name: "SquareLibrary",
  }, 
  {
    id: "lucide:SquareM", 
    tags: ["lucide", "square"], 
    source: "lucide", 
    name: "SquareM",
  }, 
  {
    id: "lucide:SquareMenu", 
    tags: ["lucide", "square", "menu"], 
    source: "lucide", 
    name: "SquareMenu",
  }, 
  {
    id: "lucide:SquareMinus", 
    tags: ["lucide", "square", "minus"], 
    source: "lucide", 
    name: "SquareMinus",
  }, 
  {
    id: "lucide:SquareMousePointer", 
    tags: ["lucide", "square", "mouse", "pointer"], 
    source: "lucide", 
    name: "SquareMousePointer",
  }, 
  {
    id: "lucide:SquareParking", 
    tags: ["lucide", "square", "parking"], 
    source: "lucide", 
    name: "SquareParking",
  }, 
  {
    id: "lucide:SquareParkingOff", 
    tags: ["lucide", "square", "parking", "off"], 
    source: "lucide", 
    name: "SquareParkingOff",
  }, 
  {
    id: "lucide:SquarePen", 
    tags: ["lucide", "square", "pen"], 
    source: "lucide", 
    name: "SquarePen",
  }, 
  {
    id: "lucide:SquarePercent", 
    tags: ["lucide", "square", "percent"], 
    source: "lucide", 
    name: "SquarePercent",
  }, 
  {
    id: "lucide:SquarePi", 
    tags: ["lucide", "square", "pi"], 
    source: "lucide", 
    name: "SquarePi",
  }, 
  {
    id: "lucide:SquarePilcrow", 
    tags: ["lucide", "square", "pilcrow"], 
    source: "lucide", 
    name: "SquarePilcrow",
  }, 
  {
    id: "lucide:SquarePlay", 
    tags: ["lucide", "square", "play"], 
    source: "lucide", 
    name: "SquarePlay",
  }, 
  {
    id: "lucide:SquarePlus", 
    tags: ["lucide", "square", "plus"], 
    source: "lucide", 
    name: "SquarePlus",
  }, 
  {
    id: "lucide:SquarePower", 
    tags: ["lucide", "square", "power"], 
    source: "lucide", 
    name: "SquarePower",
  }, 
  {
    id: "lucide:SquareRadical", 
    tags: ["lucide", "square", "radical"], 
    source: "lucide", 
    name: "SquareRadical",
  }, 
  {
    id: "lucide:SquareScissors", 
    tags: ["lucide", "square", "scissors"], 
    source: "lucide", 
    name: "SquareScissors",
  }, 
  {
    id: "lucide:SquareSigma", 
    tags: ["lucide", "square", "sigma"], 
    source: "lucide", 
    name: "SquareSigma",
  }, 
  {
    id: "lucide:SquareSlash", 
    tags: ["lucide", "square", "slash"], 
    source: "lucide", 
    name: "SquareSlash",
  }, 
  {
    id: "lucide:SquareSplitHorizontal", 
    tags: ["lucide", "square", "split", "horizontal"], 
    source: "lucide", 
    name: "SquareSplitHorizontal",
  }, 
  {
    id: "lucide:SquareSplitVertical", 
    tags: ["lucide", "square", "split", "vertical"], 
    source: "lucide", 
    name: "SquareSplitVertical",
  }, 
  {
    id: "lucide:SquareSquare", 
    tags: ["lucide", "square", "square"], 
    source: "lucide", 
    name: "SquareSquare",
  }, 
  {
    id: "lucide:SquareStack", 
    tags: ["lucide", "square", "stack"], 
    source: "lucide", 
    name: "SquareStack",
  }, 
  {
    id: "lucide:SquareTerminal", 
    tags: ["lucide", "square", "terminal"], 
    source: "lucide", 
    name: "SquareTerminal",
  }, 
  {
    id: "lucide:SquareUser", 
    tags: ["lucide", "square", "user"], 
    source: "lucide", 
    name: "SquareUser",
  }, 
  {
    id: "lucide:SquareUserRound", 
    tags: ["lucide", "square", "user", "round"], 
    source: "lucide", 
    name: "SquareUserRound",
  }, 
  {
    id: "lucide:SquareX", 
    tags: ["lucide", "square"], 
    source: "lucide", 
    name: "SquareX",
  }, 
  {
    id: "lucide:Squircle", 
    tags: ["lucide", "squircle"], 
    source: "lucide", 
    name: "Squircle",
  }, 
  {
    id: "lucide:Squirrel", 
    tags: ["lucide", "squirrel"], 
    source: "lucide", 
    name: "Squirrel",
  }, 
  {
    id: "lucide:Stamp", 
    tags: ["lucide", "stamp"], 
    source: "lucide", 
    name: "Stamp",
  }, 
  {
    id: "lucide:Star", 
    tags: ["lucide", "star"], 
    source: "lucide", 
    name: "Star",
  }, 
  {
    id: "lucide:StarHalf", 
    tags: ["lucide", "star", "half"], 
    source: "lucide", 
    name: "StarHalf",
  }, 
  {
    id: "lucide:StarOff", 
    tags: ["lucide", "star", "off"], 
    source: "lucide", 
    name: "StarOff",
  }, 
  {
    id: "lucide:Stars", 
    tags: ["lucide", "stars"], 
    source: "lucide", 
    name: "Stars",
  }, 
  {
    id: "lucide:StepBack", 
    tags: ["lucide", "step", "back"], 
    source: "lucide", 
    name: "StepBack",
  }, 
  {
    id: "lucide:StepForward", 
    tags: ["lucide", "step", "forward"], 
    source: "lucide", 
    name: "StepForward",
  }, 
  {
    id: "lucide:Stethoscope", 
    tags: ["lucide", "stethoscope"], 
    source: "lucide", 
    name: "Stethoscope",
  }, 
  {
    id: "lucide:Sticker", 
    tags: ["lucide", "sticker"], 
    source: "lucide", 
    name: "Sticker",
  }, 
  {
    id: "lucide:StickyNote", 
    tags: ["lucide", "sticky", "note"], 
    source: "lucide", 
    name: "StickyNote",
  }, 
  {
    id: "lucide:StopCircle", 
    tags: ["lucide", "stop", "circle"], 
    source: "lucide", 
    name: "StopCircle",
  }, 
  {
    id: "lucide:Store", 
    tags: ["lucide", "store"], 
    source: "lucide", 
    name: "Store",
  }, 
  {
    id: "lucide:StretchHorizontal", 
    tags: ["lucide", "stretch", "horizontal"], 
    source: "lucide", 
    name: "StretchHorizontal",
  }, 
  {
    id: "lucide:StretchVertical", 
    tags: ["lucide", "stretch", "vertical"], 
    source: "lucide", 
    name: "StretchVertical",
  }, 
  {
    id: "lucide:Strikethrough", 
    tags: ["lucide", "strikethrough"], 
    source: "lucide", 
    name: "Strikethrough",
  }, 
  {
    id: "lucide:Subscript", 
    tags: ["lucide", "subscript"], 
    source: "lucide", 
    name: "Subscript",
  }, 
  {
    id: "lucide:Subtitles", 
    tags: ["lucide", "subtitles"], 
    source: "lucide", 
    name: "Subtitles",
  }, 
  {
    id: "lucide:Sun", 
    tags: ["lucide", "sun"], 
    source: "lucide", 
    name: "Sun",
  }, 
  {
    id: "lucide:SunDim", 
    tags: ["lucide", "sun", "dim"], 
    source: "lucide", 
    name: "SunDim",
  }, 
  {
    id: "lucide:SunMedium", 
    tags: ["lucide", "sun", "medium"], 
    source: "lucide", 
    name: "SunMedium",
  }, 
  {
    id: "lucide:SunMoon", 
    tags: ["lucide", "sun", "moon"], 
    source: "lucide", 
    name: "SunMoon",
  }, 
  {
    id: "lucide:SunSnow", 
    tags: ["lucide", "sun", "snow"], 
    source: "lucide", 
    name: "SunSnow",
  }, 
  {
    id: "lucide:Sunrise", 
    tags: ["lucide", "sunrise"], 
    source: "lucide", 
    name: "Sunrise",
  }, 
  {
    id: "lucide:Sunset", 
    tags: ["lucide", "sunset"], 
    source: "lucide", 
    name: "Sunset",
  }, 
  {
    id: "lucide:Superscript", 
    tags: ["lucide", "superscript"], 
    source: "lucide", 
    name: "Superscript",
  }, 
  {
    id: "lucide:SwatchBook", 
    tags: ["lucide", "swatch", "book"], 
    source: "lucide", 
    name: "SwatchBook",
  }, 
  {
    id: "lucide:SwissFranc", 
    tags: ["lucide", "swiss", "franc"], 
    source: "lucide", 
    name: "SwissFranc",
  }, 
  {
    id: "lucide:SwitchCamera", 
    tags: ["lucide", "switch", "camera"], 
    source: "lucide", 
    name: "SwitchCamera",
  }, 
  {
    id: "lucide:Sword", 
    tags: ["lucide", "sword"], 
    source: "lucide", 
    name: "Sword",
  }, 
  {
    id: "lucide:Swords", 
    tags: ["lucide", "swords"], 
    source: "lucide", 
    name: "Swords",
  }, 
  {
    id: "lucide:Syringe", 
    tags: ["lucide", "syringe"], 
    source: "lucide", 
    name: "Syringe",
  }, 
  {
    id: "lucide:Table", 
    tags: ["lucide", "table"], 
    source: "lucide", 
    name: "Table",
  }, 
  {
    id: "lucide:Table2", 
    tags: ["lucide", "table"], 
    source: "lucide", 
    name: "Table2",
  }, 
  {
    id: "lucide:TableCellsMerge", 
    tags: ["lucide", "table", "cells", "merge"], 
    source: "lucide", 
    name: "TableCellsMerge",
  }, 
  {
    id: "lucide:TableCellsSplit", 
    tags: ["lucide", "table", "cells", "split"], 
    source: "lucide", 
    name: "TableCellsSplit",
  }, 
  {
    id: "lucide:TableColumnsSplit", 
    tags: ["lucide", "table", "columns", "split"], 
    source: "lucide", 
    name: "TableColumnsSplit",
  }, 
  {
    id: "lucide:TableOfContents", 
    tags: ["lucide", "table", "of", "contents"], 
    source: "lucide", 
    name: "TableOfContents",
  }, 
  {
    id: "lucide:TableProperties", 
    tags: ["lucide", "table", "properties"], 
    source: "lucide", 
    name: "TableProperties",
  }, 
  {
    id: "lucide:TableRowsSplit", 
    tags: ["lucide", "table", "rows", "split"], 
    source: "lucide", 
    name: "TableRowsSplit",
  }, 
  {
    id: "lucide:Tablet", 
    tags: ["lucide", "tablet"], 
    source: "lucide", 
    name: "Tablet",
  }, 
  {
    id: "lucide:TabletSmartphone", 
    tags: ["lucide", "tablet", "smartphone"], 
    source: "lucide", 
    name: "TabletSmartphone",
  }, 
  {
    id: "lucide:Tablets", 
    tags: ["lucide", "tablets"], 
    source: "lucide", 
    name: "Tablets",
  }, 
  {
    id: "lucide:Tag", 
    tags: ["lucide", "tag"], 
    source: "lucide", 
    name: "Tag",
  }, 
  {
    id: "lucide:Tags", 
    tags: ["lucide", "tags"], 
    source: "lucide", 
    name: "Tags",
  }, 
  {
    id: "lucide:Tally1", 
    tags: ["lucide", "tally"], 
    source: "lucide", 
    name: "Tally1",
  }, 
  {
    id: "lucide:Tally2", 
    tags: ["lucide", "tally"], 
    source: "lucide", 
    name: "Tally2",
  }, 
  {
    id: "lucide:Tally3", 
    tags: ["lucide", "tally"], 
    source: "lucide", 
    name: "Tally3",
  }, 
  {
    id: "lucide:Tally4", 
    tags: ["lucide", "tally"], 
    source: "lucide", 
    name: "Tally4",
  }, 
  {
    id: "lucide:Tally5", 
    tags: ["lucide", "tally"], 
    source: "lucide", 
    name: "Tally5",
  }, 
  {
    id: "lucide:Tangent", 
    tags: ["lucide", "tangent"], 
    source: "lucide", 
    name: "Tangent",
  }, 
  {
    id: "lucide:Target", 
    tags: ["lucide", "target"], 
    source: "lucide", 
    name: "Target",
  }, 
  {
    id: "lucide:Telescope", 
    tags: ["lucide", "telescope"], 
    source: "lucide", 
    name: "Telescope",
  }, 
  {
    id: "lucide:Tent", 
    tags: ["lucide", "tent"], 
    source: "lucide", 
    name: "Tent",
  }, 
  {
    id: "lucide:TentTree", 
    tags: ["lucide", "tent", "tree"], 
    source: "lucide", 
    name: "TentTree",
  }, 
  {
    id: "lucide:Terminal", 
    tags: ["lucide", "terminal"], 
    source: "lucide", 
    name: "Terminal",
  }, 
  {
    id: "lucide:TerminalSquare", 
    tags: ["lucide", "terminal", "square"], 
    source: "lucide", 
    name: "TerminalSquare",
  }, 
  {
    id: "lucide:TestTube", 
    tags: ["lucide", "test", "tube"], 
    source: "lucide", 
    name: "TestTube",
  }, 
  {
    id: "lucide:TestTube2", 
    tags: ["lucide", "test", "tube"], 
    source: "lucide", 
    name: "TestTube2",
  }, 
  {
    id: "lucide:TestTubeDiagonal", 
    tags: ["lucide", "test", "tube", "diagonal"], 
    source: "lucide", 
    name: "TestTubeDiagonal",
  }, 
  {
    id: "lucide:TestTubes", 
    tags: ["lucide", "test", "tubes"], 
    source: "lucide", 
    name: "TestTubes",
  }, 
  {
    id: "lucide:Text", 
    tags: ["lucide", "text"], 
    source: "lucide", 
    name: "Text",
  }, 
  {
    id: "lucide:TextCursor", 
    tags: ["lucide", "text", "cursor"], 
    source: "lucide", 
    name: "TextCursor",
  }, 
  {
    id: "lucide:TextCursorInput", 
    tags: ["lucide", "text", "cursor", "input"], 
    source: "lucide", 
    name: "TextCursorInput",
  }, 
  {
    id: "lucide:TextQuote", 
    tags: ["lucide", "text", "quote"], 
    source: "lucide", 
    name: "TextQuote",
  }, 
  {
    id: "lucide:TextSearch", 
    tags: ["lucide", "text", "search"], 
    source: "lucide", 
    name: "TextSearch",
  }, 
  {
    id: "lucide:TextSelect", 
    tags: ["lucide", "text", "select"], 
    source: "lucide", 
    name: "TextSelect",
  }, 
  {
    id: "lucide:TextSelection", 
    tags: ["lucide", "text", "selection"], 
    source: "lucide", 
    name: "TextSelection",
  }, 
  {
    id: "lucide:Theater", 
    tags: ["lucide", "theater"], 
    source: "lucide", 
    name: "Theater",
  }, 
  {
    id: "lucide:Thermometer", 
    tags: ["lucide", "thermometer"], 
    source: "lucide", 
    name: "Thermometer",
  }, 
  {
    id: "lucide:ThermometerSnowflake", 
    tags: ["lucide", "thermometer", "snowflake"], 
    source: "lucide", 
    name: "ThermometerSnowflake",
  }, 
  {
    id: "lucide:ThermometerSun", 
    tags: ["lucide", "thermometer", "sun"], 
    source: "lucide", 
    name: "ThermometerSun",
  }, 
  {
    id: "lucide:ThumbsDown", 
    tags: ["lucide", "thumbs", "down"], 
    source: "lucide", 
    name: "ThumbsDown",
  }, 
  {
    id: "lucide:ThumbsUp", 
    tags: ["lucide", "thumbs", "up"], 
    source: "lucide", 
    name: "ThumbsUp",
  }, 
  {
    id: "lucide:Ticket", 
    tags: ["lucide", "ticket"], 
    source: "lucide", 
    name: "Ticket",
  }, 
  {
    id: "lucide:TicketCheck", 
    tags: ["lucide", "ticket", "check"], 
    source: "lucide", 
    name: "TicketCheck",
  }, 
  {
    id: "lucide:TicketMinus", 
    tags: ["lucide", "ticket", "minus"], 
    source: "lucide", 
    name: "TicketMinus",
  }, 
  {
    id: "lucide:TicketPercent", 
    tags: ["lucide", "ticket", "percent"], 
    source: "lucide", 
    name: "TicketPercent",
  }, 
  {
    id: "lucide:TicketPlus", 
    tags: ["lucide", "ticket", "plus"], 
    source: "lucide", 
    name: "TicketPlus",
  }, 
  {
    id: "lucide:TicketSlash", 
    tags: ["lucide", "ticket", "slash"], 
    source: "lucide", 
    name: "TicketSlash",
  }, 
  {
    id: "lucide:TicketX", 
    tags: ["lucide", "ticket"], 
    source: "lucide", 
    name: "TicketX",
  }, 
  {
    id: "lucide:Tickets", 
    tags: ["lucide", "tickets"], 
    source: "lucide", 
    name: "Tickets",
  }, 
  {
    id: "lucide:TicketsPlane", 
    tags: ["lucide", "tickets", "plane"], 
    source: "lucide", 
    name: "TicketsPlane",
  }, 
  {
    id: "lucide:Timer", 
    tags: ["lucide", "timer"], 
    source: "lucide", 
    name: "Timer",
  }, 
  {
    id: "lucide:TimerOff", 
    tags: ["lucide", "timer", "off"], 
    source: "lucide", 
    name: "TimerOff",
  }, 
  {
    id: "lucide:TimerReset", 
    tags: ["lucide", "timer", "reset"], 
    source: "lucide", 
    name: "TimerReset",
  }, 
  {
    id: "lucide:ToggleLeft", 
    tags: ["lucide", "toggle", "left"], 
    source: "lucide", 
    name: "ToggleLeft",
  }, 
  {
    id: "lucide:ToggleRight", 
    tags: ["lucide", "toggle", "right"], 
    source: "lucide", 
    name: "ToggleRight",
  }, 
  {
    id: "lucide:Toilet", 
    tags: ["lucide", "toilet"], 
    source: "lucide", 
    name: "Toilet",
  }, 
  {
    id: "lucide:Tornado", 
    tags: ["lucide", "tornado"], 
    source: "lucide", 
    name: "Tornado",
  }, 
  {
    id: "lucide:Torus", 
    tags: ["lucide", "torus"], 
    source: "lucide", 
    name: "Torus",
  }, 
  {
    id: "lucide:Touchpad", 
    tags: ["lucide", "touchpad"], 
    source: "lucide", 
    name: "Touchpad",
  }, 
  {
    id: "lucide:TouchpadOff", 
    tags: ["lucide", "touchpad", "off"], 
    source: "lucide", 
    name: "TouchpadOff",
  }, 
  {
    id: "lucide:TowerControl", 
    tags: ["lucide", "tower", "control"], 
    source: "lucide", 
    name: "TowerControl",
  }, 
  {
    id: "lucide:ToyBrick", 
    tags: ["lucide", "toy", "brick"], 
    source: "lucide", 
    name: "ToyBrick",
  }, 
  {
    id: "lucide:Tractor", 
    tags: ["lucide", "tractor"], 
    source: "lucide", 
    name: "Tractor",
  }, 
  {
    id: "lucide:TrafficCone", 
    tags: ["lucide", "traffic", "cone"], 
    source: "lucide", 
    name: "TrafficCone",
  }, 
  {
    id: "lucide:Train", 
    tags: ["lucide", "train"], 
    source: "lucide", 
    name: "Train",
  }, 
  {
    id: "lucide:TrainFront", 
    tags: ["lucide", "train", "front"], 
    source: "lucide", 
    name: "TrainFront",
  }, 
  {
    id: "lucide:TrainFrontTunnel", 
    tags: ["lucide", "train", "front", "tunnel"], 
    source: "lucide", 
    name: "TrainFrontTunnel",
  }, 
  {
    id: "lucide:TrainTrack", 
    tags: ["lucide", "train", "track"], 
    source: "lucide", 
    name: "TrainTrack",
  }, 
  {
    id: "lucide:TramFront", 
    tags: ["lucide", "tram", "front"], 
    source: "lucide", 
    name: "TramFront",
  }, 
  {
    id: "lucide:Trash", 
    tags: ["lucide", "trash"], 
    source: "lucide", 
    name: "Trash",
  }, 
  {
    id: "lucide:Trash2", 
    tags: ["lucide", "trash"], 
    source: "lucide", 
    name: "Trash2",
  }, 
  {
    id: "lucide:TreeDeciduous", 
    tags: ["lucide", "tree", "deciduous"], 
    source: "lucide", 
    name: "TreeDeciduous",
  }, 
  {
    id: "lucide:TreePalm", 
    tags: ["lucide", "tree", "palm"], 
    source: "lucide", 
    name: "TreePalm",
  }, 
  {
    id: "lucide:TreePine", 
    tags: ["lucide", "tree", "pine"], 
    source: "lucide", 
    name: "TreePine",
  }, 
  {
    id: "lucide:Trees", 
    tags: ["lucide", "trees"], 
    source: "lucide", 
    name: "Trees",
  }, 
  {
    id: "lucide:Trello", 
    tags: ["lucide", "trello"], 
    source: "lucide", 
    name: "Trello",
  }, 
  {
    id: "lucide:TrendingDown", 
    tags: ["lucide", "trending", "down"], 
    source: "lucide", 
    name: "TrendingDown",
  }, 
  {
    id: "lucide:TrendingUp", 
    tags: ["lucide", "trending", "up"], 
    source: "lucide", 
    name: "TrendingUp",
  }, 
  {
    id: "lucide:TrendingUpDown", 
    tags: ["lucide", "trending", "up", "down"], 
    source: "lucide", 
    name: "TrendingUpDown",
  }, 
  {
    id: "lucide:Triangle", 
    tags: ["lucide", "triangle"], 
    source: "lucide", 
    name: "Triangle",
  }, 
  {
    id: "lucide:TriangleAlert", 
    tags: ["lucide", "triangle", "alert"], 
    source: "lucide", 
    name: "TriangleAlert",
  }, 
  {
    id: "lucide:TriangleDashed", 
    tags: ["lucide", "triangle", "dashed"], 
    source: "lucide", 
    name: "TriangleDashed",
  }, 
  {
    id: "lucide:TriangleRight", 
    tags: ["lucide", "triangle", "right"], 
    source: "lucide", 
    name: "TriangleRight",
  }, 
  {
    id: "lucide:Trophy", 
    tags: ["lucide", "trophy"], 
    source: "lucide", 
    name: "Trophy",
  }, 
  {
    id: "lucide:Truck", 
    tags: ["lucide", "truck"], 
    source: "lucide", 
    name: "Truck",
  }, 
  {
    id: "lucide:Turtle", 
    tags: ["lucide", "turtle"], 
    source: "lucide", 
    name: "Turtle",
  }, 
  {
    id: "lucide:Tv", 
    tags: ["lucide", "tv"], 
    source: "lucide", 
    name: "Tv",
  }, 
  {
    id: "lucide:Tv2", 
    tags: ["lucide", "tv"], 
    source: "lucide", 
    name: "Tv2",
  }, 
  {
    id: "lucide:TvMinimal", 
    tags: ["lucide", "tv", "minimal"], 
    source: "lucide", 
    name: "TvMinimal",
  }, 
  {
    id: "lucide:TvMinimalPlay", 
    tags: ["lucide", "tv", "minimal", "play"], 
    source: "lucide", 
    name: "TvMinimalPlay",
  }, 
  {
    id: "lucide:Twitch", 
    tags: ["lucide", "twitch"], 
    source: "lucide", 
    name: "Twitch",
  }, 
  {
    id: "lucide:Twitter", 
    tags: ["lucide", "twitter"], 
    source: "lucide", 
    name: "Twitter",
  }, 
  {
    id: "lucide:Type", 
    tags: ["lucide", "type"], 
    source: "lucide", 
    name: "Type",
  }, 
  {
    id: "lucide:TypeOutline", 
    tags: ["lucide", "type", "outline"], 
    source: "lucide", 
    name: "TypeOutline",
  }, 
  {
    id: "lucide:Umbrella", 
    tags: ["lucide", "umbrella"], 
    source: "lucide", 
    name: "Umbrella",
  }, 
  {
    id: "lucide:UmbrellaOff", 
    tags: ["lucide", "umbrella", "off"], 
    source: "lucide", 
    name: "UmbrellaOff",
  }, 
  {
    id: "lucide:Underline", 
    tags: ["lucide", "underline"], 
    source: "lucide", 
    name: "Underline",
  }, 
  {
    id: "lucide:Undo", 
    tags: ["lucide", "undo"], 
    source: "lucide", 
    name: "Undo",
  }, 
  {
    id: "lucide:Undo2", 
    tags: ["lucide", "undo"], 
    source: "lucide", 
    name: "Undo2",
  }, 
  {
    id: "lucide:UndoDot", 
    tags: ["lucide", "undo", "dot"], 
    source: "lucide", 
    name: "UndoDot",
  }, 
  {
    id: "lucide:UnfoldHorizontal", 
    tags: ["lucide", "unfold", "horizontal"], 
    source: "lucide", 
    name: "UnfoldHorizontal",
  }, 
  {
    id: "lucide:UnfoldVertical", 
    tags: ["lucide", "unfold", "vertical"], 
    source: "lucide", 
    name: "UnfoldVertical",
  }, 
  {
    id: "lucide:Ungroup", 
    tags: ["lucide", "ungroup"], 
    source: "lucide", 
    name: "Ungroup",
  }, 
  {
    id: "lucide:University", 
    tags: ["lucide", "university"], 
    source: "lucide", 
    name: "University",
  }, 
  {
    id: "lucide:Unlink", 
    tags: ["lucide", "unlink"], 
    source: "lucide", 
    name: "Unlink",
  }, 
  {
    id: "lucide:Unlink2", 
    tags: ["lucide", "unlink"], 
    source: "lucide", 
    name: "Unlink2",
  }, 
  {
    id: "lucide:Unlock", 
    tags: ["lucide", "unlock"], 
    source: "lucide", 
    name: "Unlock",
  }, 
  {
    id: "lucide:UnlockKeyhole", 
    tags: ["lucide", "unlock", "keyhole"], 
    source: "lucide", 
    name: "UnlockKeyhole",
  }, 
  {
    id: "lucide:Unplug", 
    tags: ["lucide", "unplug"], 
    source: "lucide", 
    name: "Unplug",
  }, 
  {
    id: "lucide:Upload", 
    tags: ["lucide", "upload"], 
    source: "lucide", 
    name: "Upload",
  }, 
  {
    id: "lucide:UploadCloud", 
    tags: ["lucide", "upload", "cloud"], 
    source: "lucide", 
    name: "UploadCloud",
  }, 
  {
    id: "lucide:Usb", 
    tags: ["lucide", "usb"], 
    source: "lucide", 
    name: "Usb",
  }, 
  {
    id: "lucide:User", 
    tags: ["lucide", "user"], 
    source: "lucide", 
    name: "User",
  }, 
  {
    id: "lucide:User2", 
    tags: ["lucide", "user"], 
    source: "lucide", 
    name: "User2",
  }, 
  {
    id: "lucide:UserCheck", 
    tags: ["lucide", "user", "check"], 
    source: "lucide", 
    name: "UserCheck",
  }, 
  {
    id: "lucide:UserCheck2", 
    tags: ["lucide", "user", "check"], 
    source: "lucide", 
    name: "UserCheck2",
  }, 
  {
    id: "lucide:UserCircle", 
    tags: ["lucide", "user", "circle"], 
    source: "lucide", 
    name: "UserCircle",
  }, 
  {
    id: "lucide:UserCircle2", 
    tags: ["lucide", "user", "circle"], 
    source: "lucide", 
    name: "UserCircle2",
  }, 
  {
    id: "lucide:UserCog", 
    tags: ["lucide", "user", "cog"], 
    source: "lucide", 
    name: "UserCog",
  }, 
  {
    id: "lucide:UserCog2", 
    tags: ["lucide", "user", "cog"], 
    source: "lucide", 
    name: "UserCog2",
  }, 
  {
    id: "lucide:UserMinus", 
    tags: ["lucide", "user", "minus"], 
    source: "lucide", 
    name: "UserMinus",
  }, 
  {
    id: "lucide:UserMinus2", 
    tags: ["lucide", "user", "minus"], 
    source: "lucide", 
    name: "UserMinus2",
  }, 
  {
    id: "lucide:UserPen", 
    tags: ["lucide", "user", "pen"], 
    source: "lucide", 
    name: "UserPen",
  }, 
  {
    id: "lucide:UserPlus", 
    tags: ["lucide", "user", "plus"], 
    source: "lucide", 
    name: "UserPlus",
  }, 
  {
    id: "lucide:UserPlus2", 
    tags: ["lucide", "user", "plus"], 
    source: "lucide", 
    name: "UserPlus2",
  }, 
  {
    id: "lucide:UserRound", 
    tags: ["lucide", "user", "round"], 
    source: "lucide", 
    name: "UserRound",
  }, 
  {
    id: "lucide:UserRoundCheck", 
    tags: ["lucide", "user", "round", "check"], 
    source: "lucide", 
    name: "UserRoundCheck",
  }, 
  {
    id: "lucide:UserRoundCog", 
    tags: ["lucide", "user", "round", "cog"], 
    source: "lucide", 
    name: "UserRoundCog",
  }, 
  {
    id: "lucide:UserRoundMinus", 
    tags: ["lucide", "user", "round", "minus"], 
    source: "lucide", 
    name: "UserRoundMinus",
  }, 
  {
    id: "lucide:UserRoundPen", 
    tags: ["lucide", "user", "round", "pen"], 
    source: "lucide", 
    name: "UserRoundPen",
  }, 
  {
    id: "lucide:UserRoundPlus", 
    tags: ["lucide", "user", "round", "plus"], 
    source: "lucide", 
    name: "UserRoundPlus",
  }, 
  {
    id: "lucide:UserRoundSearch", 
    tags: ["lucide", "user", "round", "search"], 
    source: "lucide", 
    name: "UserRoundSearch",
  }, 
  {
    id: "lucide:UserRoundX", 
    tags: ["lucide", "user", "round"], 
    source: "lucide", 
    name: "UserRoundX",
  }, 
  {
    id: "lucide:UserSearch", 
    tags: ["lucide", "user", "search"], 
    source: "lucide", 
    name: "UserSearch",
  }, 
  {
    id: "lucide:UserSquare", 
    tags: ["lucide", "user", "square"], 
    source: "lucide", 
    name: "UserSquare",
  }, 
  {
    id: "lucide:UserSquare2", 
    tags: ["lucide", "user", "square"], 
    source: "lucide", 
    name: "UserSquare2",
  }, 
  {
    id: "lucide:UserX", 
    tags: ["lucide", "user"], 
    source: "lucide", 
    name: "UserX",
  }, 
  {
    id: "lucide:UserX2", 
    tags: ["lucide", "user"], 
    source: "lucide", 
    name: "UserX2",
  }, 
  {
    id: "lucide:Users", 
    tags: ["lucide", "users"], 
    source: "lucide", 
    name: "Users",
  }, 
  {
    id: "lucide:Users2", 
    tags: ["lucide", "users"], 
    source: "lucide", 
    name: "Users2",
  }, 
  {
    id: "lucide:UsersRound", 
    tags: ["lucide", "users", "round"], 
    source: "lucide", 
    name: "UsersRound",
  }, 
  {
    id: "lucide:Utensils", 
    tags: ["lucide", "utensils"], 
    source: "lucide", 
    name: "Utensils",
  }, 
  {
    id: "lucide:UtensilsCrossed", 
    tags: ["lucide", "utensils", "crossed"], 
    source: "lucide", 
    name: "UtensilsCrossed",
  }, 
  {
    id: "lucide:UtilityPole", 
    tags: ["lucide", "utility", "pole"], 
    source: "lucide", 
    name: "UtilityPole",
  }, 
  {
    id: "lucide:Variable", 
    tags: ["lucide", "variable"], 
    source: "lucide", 
    name: "Variable",
  }, 
  {
    id: "lucide:Vault", 
    tags: ["lucide", "vault"], 
    source: "lucide", 
    name: "Vault",
  }, 
  {
    id: "lucide:Vegan", 
    tags: ["lucide", "vegan"], 
    source: "lucide", 
    name: "Vegan",
  }, 
  {
    id: "lucide:VenetianMask", 
    tags: ["lucide", "venetian", "mask"], 
    source: "lucide", 
    name: "VenetianMask",
  }, 
  {
    id: "lucide:Verified", 
    tags: ["lucide", "verified"], 
    source: "lucide", 
    name: "Verified",
  }, 
  {
    id: "lucide:Vibrate", 
    tags: ["lucide", "vibrate"], 
    source: "lucide", 
    name: "Vibrate",
  }, 
  {
    id: "lucide:VibrateOff", 
    tags: ["lucide", "vibrate", "off"], 
    source: "lucide", 
    name: "VibrateOff",
  }, 
  {
    id: "lucide:Video", 
    tags: ["lucide", "video"], 
    source: "lucide", 
    name: "Video",
  }, 
  {
    id: "lucide:VideoOff", 
    tags: ["lucide", "video", "off"], 
    source: "lucide", 
    name: "VideoOff",
  }, 
  {
    id: "lucide:Videotape", 
    tags: ["lucide", "videotape"], 
    source: "lucide", 
    name: "Videotape",
  }, 
  {
    id: "lucide:View", 
    tags: ["lucide", "view"], 
    source: "lucide", 
    name: "View",
  }, 
  {
    id: "lucide:Voicemail", 
    tags: ["lucide", "voicemail"], 
    source: "lucide", 
    name: "Voicemail",
  }, 
  {
    id: "lucide:Volleyball", 
    tags: ["lucide", "volleyball"], 
    source: "lucide", 
    name: "Volleyball",
  }, 
  {
    id: "lucide:Volume", 
    tags: ["lucide", "volume"], 
    source: "lucide", 
    name: "Volume",
  }, 
  {
    id: "lucide:Volume1", 
    tags: ["lucide", "volume"], 
    source: "lucide", 
    name: "Volume1",
  }, 
  {
    id: "lucide:Volume2", 
    tags: ["lucide", "volume"], 
    source: "lucide", 
    name: "Volume2",
  }, 
  {
    id: "lucide:VolumeOff", 
    tags: ["lucide", "volume", "off"], 
    source: "lucide", 
    name: "VolumeOff",
  }, 
  {
    id: "lucide:VolumeX", 
    tags: ["lucide", "volume"], 
    source: "lucide", 
    name: "VolumeX",
  }, 
  {
    id: "lucide:Vote", 
    tags: ["lucide", "vote"], 
    source: "lucide", 
    name: "Vote",
  }, 
  {
    id: "lucide:Wallet", 
    tags: ["lucide", "wallet"], 
    source: "lucide", 
    name: "Wallet",
  }, 
  {
    id: "lucide:Wallet2", 
    tags: ["lucide", "wallet"], 
    source: "lucide", 
    name: "Wallet2",
  }, 
  {
    id: "lucide:WalletCards", 
    tags: ["lucide", "wallet", "cards"], 
    source: "lucide", 
    name: "WalletCards",
  }, 
  {
    id: "lucide:WalletMinimal", 
    tags: ["lucide", "wallet", "minimal"], 
    source: "lucide", 
    name: "WalletMinimal",
  }, 
  {
    id: "lucide:Wallpaper", 
    tags: ["lucide", "wallpaper"], 
    source: "lucide", 
    name: "Wallpaper",
  }, 
  {
    id: "lucide:Wand", 
    tags: ["lucide", "wand"], 
    source: "lucide", 
    name: "Wand",
  }, 
  {
    id: "lucide:Wand2", 
    tags: ["lucide", "wand"], 
    source: "lucide", 
    name: "Wand2",
  }, 
  {
    id: "lucide:WandSparkles", 
    tags: ["lucide", "wand", "sparkles"], 
    source: "lucide", 
    name: "WandSparkles",
  }, 
  {
    id: "lucide:Warehouse", 
    tags: ["lucide", "warehouse"], 
    source: "lucide", 
    name: "Warehouse",
  }, 
  {
    id: "lucide:WashingMachine", 
    tags: ["lucide", "washing", "machine"], 
    source: "lucide", 
    name: "WashingMachine",
  }, 
  {
    id: "lucide:Watch", 
    tags: ["lucide", "watch"], 
    source: "lucide", 
    name: "Watch",
  }, 
  {
    id: "lucide:Waves", 
    tags: ["lucide", "waves"], 
    source: "lucide", 
    name: "Waves",
  }, 
  {
    id: "lucide:WavesLadder", 
    tags: ["lucide", "waves", "ladder"], 
    source: "lucide", 
    name: "WavesLadder",
  }, 
  {
    id: "lucide:Waypoints", 
    tags: ["lucide", "waypoints"], 
    source: "lucide", 
    name: "Waypoints",
  }, 
  {
    id: "lucide:Webcam", 
    tags: ["lucide", "webcam"], 
    source: "lucide", 
    name: "Webcam",
  }, 
  {
    id: "lucide:Webhook", 
    tags: ["lucide", "webhook"], 
    source: "lucide", 
    name: "Webhook",
  }, 
  {
    id: "lucide:WebhookOff", 
    tags: ["lucide", "webhook", "off"], 
    source: "lucide", 
    name: "WebhookOff",
  }, 
  {
    id: "lucide:Weight", 
    tags: ["lucide", "weight"], 
    source: "lucide", 
    name: "Weight",
  }, 
  {
    id: "lucide:Wheat", 
    tags: ["lucide", "wheat"], 
    source: "lucide", 
    name: "Wheat",
  }, 
  {
    id: "lucide:WheatOff", 
    tags: ["lucide", "wheat", "off"], 
    source: "lucide", 
    name: "WheatOff",
  }, 
  {
    id: "lucide:WholeWord", 
    tags: ["lucide", "whole", "word"], 
    source: "lucide", 
    name: "WholeWord",
  }, 
  {
    id: "lucide:Wifi", 
    tags: ["lucide", "wifi"], 
    source: "lucide", 
    name: "Wifi",
  }, 
  {
    id: "lucide:WifiHigh", 
    tags: ["lucide", "wifi", "high"], 
    source: "lucide", 
    name: "WifiHigh",
  }, 
  {
    id: "lucide:WifiLow", 
    tags: ["lucide", "wifi", "low"], 
    source: "lucide", 
    name: "WifiLow",
  }, 
  {
    id: "lucide:WifiOff", 
    tags: ["lucide", "wifi", "off"], 
    source: "lucide", 
    name: "WifiOff",
  }, 
  {
    id: "lucide:WifiZero", 
    tags: ["lucide", "wifi", "zero"], 
    source: "lucide", 
    name: "WifiZero",
  }, 
  {
    id: "lucide:Wind", 
    tags: ["lucide", "wind"], 
    source: "lucide", 
    name: "Wind",
  }, 
  {
    id: "lucide:WindArrowDown", 
    tags: ["lucide", "wind", "arrow", "down"], 
    source: "lucide", 
    name: "WindArrowDown",
  }, 
  {
    id: "lucide:Wine", 
    tags: ["lucide", "wine"], 
    source: "lucide", 
    name: "Wine",
  }, 
  {
    id: "lucide:WineOff", 
    tags: ["lucide", "wine", "off"], 
    source: "lucide", 
    name: "WineOff",
  }, 
  {
    id: "lucide:Workflow", 
    tags: ["lucide", "workflow"], 
    source: "lucide", 
    name: "Workflow",
  }, 
  {
    id: "lucide:Worm", 
    tags: ["lucide", "worm"], 
    source: "lucide", 
    name: "Worm",
  }, 
  {
    id: "lucide:WrapText", 
    tags: ["lucide", "wrap", "text"], 
    source: "lucide", 
    name: "WrapText",
  }, 
  {
    id: "lucide:Wrench", 
    tags: ["lucide", "wrench"], 
    source: "lucide", 
    name: "Wrench",
  }, 
  {
    id: "lucide:X", 
    tags: ["lucide"], 
    source: "lucide", 
    name: "X",
  }, 
  {
    id: "lucide:XCircle", 
    tags: ["lucide", "circle"], 
    source: "lucide", 
    name: "XCircle",
  }, 
  {
    id: "lucide:XOctagon", 
    tags: ["lucide", "octagon"], 
    source: "lucide", 
    name: "XOctagon",
  }, 
  {
    id: "lucide:XSquare", 
    tags: ["lucide", "square"], 
    source: "lucide", 
    name: "XSquare",
  }, 
  {
    id: "lucide:Youtube", 
    tags: ["lucide", "youtube"], 
    source: "lucide", 
    name: "Youtube",
  }, 
  {
    id: "lucide:Zap", 
    tags: ["lucide", "zap"], 
    source: "lucide", 
    name: "Zap",
  }, 
  {
    id: "lucide:ZapOff", 
    tags: ["lucide", "zap", "off"], 
    source: "lucide", 
    name: "ZapOff",
  }, 
  {
    id: "lucide:ZoomIn", 
    tags: ["lucide", "zoom", "in"], 
    source: "lucide", 
    name: "ZoomIn",
  }, 
  {
    id: "lucide:ZoomOut", 
    tags: ["lucide", "zoom", "out"], 
    source: "lucide", 
    name: "ZoomOut",
  }, 
  {
    id: "atlas:Abacus", 
    tags: ["atlas", "abacus"], 
    source: "atlas", 
    name: "Abacus",
  }, 
  {
    id: "atlas:Account", 
    tags: ["atlas", "account"], 
    source: "atlas", 
    name: "Account",
  }, 
  {
    id: "atlas:AccountArrows", 
    tags: ["atlas", "account", "arrows"], 
    source: "atlas", 
    name: "AccountArrows",
  }, 
  {
    id: "atlas:AccountCircleArrowsLeftRight", 
    tags: ["atlas", "account", "circle", "arrows", "left", "right"], 
    source: "atlas", 
    name: "AccountCircleArrowsLeftRight",
  }, 
  {
    id: "atlas:AccountPresentation", 
    tags: ["atlas", "account", "presentation"], 
    source: "atlas", 
    name: "AccountPresentation",
  }, 
  {
    id: "atlas:AccountUserFlag", 
    tags: ["atlas", "account", "user", "flag"], 
    source: "atlas", 
    name: "AccountUserFlag",
  }, 
  {
    id: "atlas:AccountWebsite", 
    tags: ["atlas", "account", "website"], 
    source: "atlas", 
    name: "AccountWebsite",
  }, 
  {
    id: "atlas:AccountsArrowsTransfer", 
    tags: ["atlas", "accounts", "arrows", "transfer"], 
    source: "atlas", 
    name: "AccountsArrowsTransfer",
  }, 
  {
    id: "atlas:AccountsGroupPeople", 
    tags: ["atlas", "accounts", "group", "people"], 
    source: "atlas", 
    name: "AccountsGroupPeople",
  }, 
  {
    id: "atlas:AccountsGroupStarRating", 
    tags: ["atlas", "accounts", "group", "star", "rating"], 
    source: "atlas", 
    name: "AccountsGroupStarRating",
  }, 
  {
    id: "atlas:AccountsTransferArrows", 
    tags: ["atlas", "accounts", "transfer", "arrows"], 
    source: "atlas", 
    name: "AccountsTransferArrows",
  }, 
  {
    id: "atlas:Acorn", 
    tags: ["atlas", "acorn"], 
    source: "atlas", 
    name: "Acorn",
  }, 
  {
    id: "atlas:AddChat", 
    tags: ["atlas", "add", "chat"], 
    source: "atlas", 
    name: "AddChat",
  }, 
  {
    id: "atlas:AddChats", 
    tags: ["atlas", "add", "chats"], 
    source: "atlas", 
    name: "AddChats",
  }, 
  {
    id: "atlas:AddComment", 
    tags: ["atlas", "add", "comment"], 
    source: "atlas", 
    name: "AddComment",
  }, 
  {
    id: "atlas:AddComments", 
    tags: ["atlas", "add", "comments"], 
    source: "atlas", 
    name: "AddComments",
  }, 
  {
    id: "atlas:AddFolder", 
    tags: ["atlas", "add", "folder"], 
    source: "atlas", 
    name: "AddFolder",
  }, 
  {
    id: "atlas:AddMessage", 
    tags: ["atlas", "add", "message"], 
    source: "atlas", 
    name: "AddMessage",
  }, 
  {
    id: "atlas:AddMessages", 
    tags: ["atlas", "add", "messages"], 
    source: "atlas", 
    name: "AddMessages",
  }, 
  {
    id: "atlas:Adult18", 
    tags: ["atlas", "adult"], 
    source: "atlas", 
    name: "Adult18",
  }, 
  {
    id: "atlas:Aeroplane", 
    tags: ["atlas", "aeroplane"], 
    source: "atlas", 
    name: "Aeroplane",
  }, 
  {
    id: "atlas:AgreementArrowIncrease", 
    tags: ["atlas", "agreement", "arrow", "increase"], 
    source: "atlas", 
    name: "AgreementArrowIncrease",
  }, 
  {
    id: "atlas:AirConditioner", 
    tags: ["atlas", "air", "conditioner"], 
    source: "atlas", 
    name: "AirConditioner",
  }, 
  {
    id: "atlas:Airline", 
    tags: ["atlas", "airline"], 
    source: "atlas", 
    name: "Airline",
  }, 
  {
    id: "atlas:AirlineTicket", 
    tags: ["atlas", "airline", "ticket"], 
    source: "atlas", 
    name: "AirlineTicket",
  }, 
  {
    id: "atlas:Airplane", 
    tags: ["atlas", "airplane"], 
    source: "atlas", 
    name: "Airplane",
  }, 
  {
    id: "atlas:Airpods", 
    tags: ["atlas", "airpods"], 
    source: "atlas", 
    name: "Airpods",
  }, 
  {
    id: "atlas:AlarmClock", 
    tags: ["atlas", "alarm", "clock"], 
    source: "atlas", 
    name: "AlarmClock",
  }, 
  {
    id: "atlas:AlertFolder", 
    tags: ["atlas", "alert", "folder"], 
    source: "atlas", 
    name: "AlertFolder",
  }, 
  {
    id: "atlas:AlignCenter", 
    tags: ["atlas", "align", "center"], 
    source: "atlas", 
    name: "AlignCenter",
  }, 
  {
    id: "atlas:AlignDown", 
    tags: ["atlas", "align", "down"], 
    source: "atlas", 
    name: "AlignDown",
  }, 
  {
    id: "atlas:AlignIndentRight", 
    tags: ["atlas", "align", "indent", "right"], 
    source: "atlas", 
    name: "AlignIndentRight",
  }, 
  {
    id: "atlas:AlignJustifyDown", 
    tags: ["atlas", "align", "justify", "down"], 
    source: "atlas", 
    name: "AlignJustifyDown",
  }, 
  {
    id: "atlas:AlignJustifyUp", 
    tags: ["atlas", "align", "justify", "up"], 
    source: "atlas", 
    name: "AlignJustifyUp",
  }, 
  {
    id: "atlas:AlignLeft", 
    tags: ["atlas", "align", "left"], 
    source: "atlas", 
    name: "AlignLeft",
  }, 
  {
    id: "atlas:AlignLeftIndent", 
    tags: ["atlas", "align", "left", "indent"], 
    source: "atlas", 
    name: "AlignLeftIndent",
  }, 
  {
    id: "atlas:AlignRight", 
    tags: ["atlas", "align", "right"], 
    source: "atlas", 
    name: "AlignRight",
  }, 
  {
    id: "atlas:Ambulance", 
    tags: ["atlas", "ambulance"], 
    source: "atlas", 
    name: "Ambulance",
  }, 
  {
    id: "atlas:AmbulanceMedical", 
    tags: ["atlas", "ambulance", "medical"], 
    source: "atlas", 
    name: "AmbulanceMedical",
  }, 
  {
    id: "atlas:Anchor", 
    tags: ["atlas", "anchor"], 
    source: "atlas", 
    name: "Anchor",
  }, 
  {
    id: "atlas:AnchorTransform", 
    tags: ["atlas", "anchor", "transform"], 
    source: "atlas", 
    name: "AnchorTransform",
  }, 
  {
    id: "atlas:Android", 
    tags: ["atlas", "android"], 
    source: "atlas", 
    name: "Android",
  }, 
  {
    id: "atlas:Angel", 
    tags: ["atlas", "angel"], 
    source: "atlas", 
    name: "Angel",
  }, 
  {
    id: "atlas:AngelHeart", 
    tags: ["atlas", "angel", "heart"], 
    source: "atlas", 
    name: "AngelHeart",
  }, 
  {
    id: "atlas:Antlers", 
    tags: ["atlas", "antlers"], 
    source: "atlas", 
    name: "Antlers",
  }, 
  {
    id: "atlas:ApartmentBuilding", 
    tags: ["atlas", "apartment", "building"], 
    source: "atlas", 
    name: "ApartmentBuilding",
  }, 
  {
    id: "atlas:ApartmentBuildings", 
    tags: ["atlas", "apartment", "buildings"], 
    source: "atlas", 
    name: "ApartmentBuildings",
  }, 
  {
    id: "atlas:ApartmentsBuilding", 
    tags: ["atlas", "apartments", "building"], 
    source: "atlas", 
    name: "ApartmentsBuilding",
  }, 
  {
    id: "atlas:ArcTriomph", 
    tags: ["atlas", "arc", "triomph"], 
    source: "atlas", 
    name: "ArcTriomph",
  }, 
  {
    id: "atlas:ArcheryBowArrow", 
    tags: ["atlas", "archery", "bow", "arrow"], 
    source: "atlas", 
    name: "ArcheryBowArrow",
  }, 
  {
    id: "atlas:ArcheryTarget", 
    tags: ["atlas", "archery", "target"], 
    source: "atlas", 
    name: "ArcheryTarget",
  }, 
  {
    id: "atlas:ArchiveMusic", 
    tags: ["atlas", "archive", "music"], 
    source: "atlas", 
    name: "ArchiveMusic",
  }, 
  {
    id: "atlas:Armchair", 
    tags: ["atlas", "armchair"], 
    source: "atlas", 
    name: "Armchair",
  }, 
  {
    id: "atlas:Arrow360", 
    tags: ["atlas", "arrow"], 
    source: "atlas", 
    name: "Arrow360",
  }, 
  {
    id: "atlas:ArrowDown", 
    tags: ["atlas", "arrow", "down"], 
    source: "atlas", 
    name: "ArrowDown",
  }, 
  {
    id: "atlas:ArrowDownChart", 
    tags: ["atlas", "arrow", "down", "chart"], 
    source: "atlas", 
    name: "ArrowDownChart",
  }, 
  {
    id: "atlas:ArrowDownChartDecrease", 
    tags: ["atlas", "arrow", "down", "chart", "decrease"], 
    source: "atlas", 
    name: "ArrowDownChartDecrease",
  }, 
  {
    id: "atlas:ArrowDownCircle", 
    tags: ["atlas", "arrow", "down", "circle"], 
    source: "atlas", 
    name: "ArrowDownCircle",
  }, 
  {
    id: "atlas:ArrowDownCloud", 
    tags: ["atlas", "arrow", "down", "cloud"], 
    source: "atlas", 
    name: "ArrowDownCloud",
  }, 
  {
    id: "atlas:ArrowDownEnvelope", 
    tags: ["atlas", "arrow", "down", "envelope"], 
    source: "atlas", 
    name: "ArrowDownEnvelope",
  }, 
  {
    id: "atlas:ArrowDownFolder", 
    tags: ["atlas", "arrow", "down", "folder"], 
    source: "atlas", 
    name: "ArrowDownFolder",
  }, 
  {
    id: "atlas:ArrowDownGraph", 
    tags: ["atlas", "arrow", "down", "graph"], 
    source: "atlas", 
    name: "ArrowDownGraph",
  }, 
  {
    id: "atlas:ArrowDownHome", 
    tags: ["atlas", "arrow", "down", "home"], 
    source: "atlas", 
    name: "ArrowDownHome",
  }, 
  {
    id: "atlas:ArrowDownLeft", 
    tags: ["atlas", "arrow", "down", "left"], 
    source: "atlas", 
    name: "ArrowDownLeft",
  }, 
  {
    id: "atlas:ArrowDownLeftCircle", 
    tags: ["atlas", "arrow", "down", "left", "circle"], 
    source: "atlas", 
    name: "ArrowDownLeftCircle",
  }, 
  {
    id: "atlas:ArrowDownLine", 
    tags: ["atlas", "arrow", "down", "line"], 
    source: "atlas", 
    name: "ArrowDownLine",
  }, 
  {
    id: "atlas:ArrowDownLineChat", 
    tags: ["atlas", "arrow", "down", "line", "chat"], 
    source: "atlas", 
    name: "ArrowDownLineChat",
  }, 
  {
    id: "atlas:ArrowDownLineMessage", 
    tags: ["atlas", "arrow", "down", "line", "message"], 
    source: "atlas", 
    name: "ArrowDownLineMessage",
  }, 
  {
    id: "atlas:ArrowDownPage", 
    tags: ["atlas", "arrow", "down", "page"], 
    source: "atlas", 
    name: "ArrowDownPage",
  }, 
  {
    id: "atlas:ArrowDownPapertray", 
    tags: ["atlas", "arrow", "down", "papertray"], 
    source: "atlas", 
    name: "ArrowDownPapertray",
  }, 
  {
    id: "atlas:ArrowDownRight", 
    tags: ["atlas", "arrow", "down", "right"], 
    source: "atlas", 
    name: "ArrowDownRight",
  }, 
  {
    id: "atlas:ArrowDownRightCircle", 
    tags: ["atlas", "arrow", "down", "right", "circle"], 
    source: "atlas", 
    name: "ArrowDownRightCircle",
  }, 
  {
    id: "atlas:ArrowDownShield", 
    tags: ["atlas", "arrow", "down", "shield"], 
    source: "atlas", 
    name: "ArrowDownShield",
  }, 
  {
    id: "atlas:ArrowDownShoppingCart", 
    tags: ["atlas", "arrow", "down", "shopping", "cart"], 
    source: "atlas", 
    name: "ArrowDownShoppingCart",
  }, 
  {
    id: "atlas:ArrowDownToBracket", 
    tags: ["atlas", "arrow", "down", "to", "bracket"], 
    source: "atlas", 
    name: "ArrowDownToBracket",
  }, 
  {
    id: "atlas:ArrowDownToSquare", 
    tags: ["atlas", "arrow", "down", "to", "square"], 
    source: "atlas", 
    name: "ArrowDownToSquare",
  }, 
  {
    id: "atlas:ArrowDownTrolley", 
    tags: ["atlas", "arrow", "down", "trolley"], 
    source: "atlas", 
    name: "ArrowDownTrolley",
  }, 
  {
    id: "atlas:ArrowDownwardGroup", 
    tags: ["atlas", "arrow", "downward", "group"], 
    source: "atlas", 
    name: "ArrowDownwardGroup",
  }, 
  {
    id: "atlas:ArrowDownwardHandshake", 
    tags: ["atlas", "arrow", "downward", "handshake"], 
    source: "atlas", 
    name: "ArrowDownwardHandshake",
  }, 
  {
    id: "atlas:ArrowLeft", 
    tags: ["atlas", "arrow", "left"], 
    source: "atlas", 
    name: "ArrowLeft",
  }, 
  {
    id: "atlas:ArrowLeftChat", 
    tags: ["atlas", "arrow", "left", "chat"], 
    source: "atlas", 
    name: "ArrowLeftChat",
  }, 
  {
    id: "atlas:ArrowLeftCircle", 
    tags: ["atlas", "arrow", "left", "circle"], 
    source: "atlas", 
    name: "ArrowLeftCircle",
  }, 
  {
    id: "atlas:ArrowLeftLine", 
    tags: ["atlas", "arrow", "left", "line"], 
    source: "atlas", 
    name: "ArrowLeftLine",
  }, 
  {
    id: "atlas:ArrowLeftMessage", 
    tags: ["atlas", "arrow", "left", "message"], 
    source: "atlas", 
    name: "ArrowLeftMessage",
  }, 
  {
    id: "atlas:ArrowMeetingUp", 
    tags: ["atlas", "arrow", "meeting", "up"], 
    source: "atlas", 
    name: "ArrowMeetingUp",
  }, 
  {
    id: "atlas:ArrowMoveCorners", 
    tags: ["atlas", "arrow", "move", "corners"], 
    source: "atlas", 
    name: "ArrowMoveCorners",
  }, 
  {
    id: "atlas:ArrowReturn", 
    tags: ["atlas", "arrow", "return"], 
    source: "atlas", 
    name: "ArrowReturn",
  }, 
  {
    id: "atlas:ArrowRight", 
    tags: ["atlas", "arrow", "right"], 
    source: "atlas", 
    name: "ArrowRight",
  }, 
  {
    id: "atlas:ArrowRightChat", 
    tags: ["atlas", "arrow", "right", "chat"], 
    source: "atlas", 
    name: "ArrowRightChat",
  }, 
  {
    id: "atlas:ArrowRightCircle", 
    tags: ["atlas", "arrow", "right", "circle"], 
    source: "atlas", 
    name: "ArrowRightCircle",
  }, 
  {
    id: "atlas:ArrowRightLine", 
    tags: ["atlas", "arrow", "right", "line"], 
    source: "atlas", 
    name: "ArrowRightLine",
  }, 
  {
    id: "atlas:ArrowRightMessage", 
    tags: ["atlas", "arrow", "right", "message"], 
    source: "atlas", 
    name: "ArrowRightMessage",
  }, 
  {
    id: "atlas:ArrowUpBill", 
    tags: ["atlas", "arrow", "up", "bill"], 
    source: "atlas", 
    name: "ArrowUpBill",
  }, 
  {
    id: "atlas:ArrowUpChart", 
    tags: ["atlas", "arrow", "up", "chart"], 
    source: "atlas", 
    name: "ArrowUpChart",
  }, 
  {
    id: "atlas:ArrowUpCircle", 
    tags: ["atlas", "arrow", "up", "circle"], 
    source: "atlas", 
    name: "ArrowUpCircle",
  }, 
  {
    id: "atlas:ArrowUpCloud", 
    tags: ["atlas", "arrow", "up", "cloud"], 
    source: "atlas", 
    name: "ArrowUpCloud",
  }, 
  {
    id: "atlas:ArrowUpDownHouse", 
    tags: ["atlas", "arrow", "up", "down", "house"], 
    source: "atlas", 
    name: "ArrowUpDownHouse",
  }, 
  {
    id: "atlas:ArrowUpEnvelope", 
    tags: ["atlas", "arrow", "up", "envelope"], 
    source: "atlas", 
    name: "ArrowUpEnvelope",
  }, 
  {
    id: "atlas:ArrowUpFromSquare", 
    tags: ["atlas", "arrow", "up", "from", "square"], 
    source: "atlas", 
    name: "ArrowUpFromSquare",
  }, 
  {
    id: "atlas:ArrowUpGraph", 
    tags: ["atlas", "arrow", "up", "graph"], 
    source: "atlas", 
    name: "ArrowUpGraph",
  }, 
  {
    id: "atlas:ArrowUpGraphIncrease", 
    tags: ["atlas", "arrow", "up", "graph", "increase"], 
    source: "atlas", 
    name: "ArrowUpGraphIncrease",
  }, 
  {
    id: "atlas:ArrowUpHouse", 
    tags: ["atlas", "arrow", "up", "house"], 
    source: "atlas", 
    name: "ArrowUpHouse",
  }, 
  {
    id: "atlas:ArrowUpLeftCircle", 
    tags: ["atlas", "arrow", "up", "left", "circle"], 
    source: "atlas", 
    name: "ArrowUpLeftCircle",
  }, 
  {
    id: "atlas:ArrowUpLine", 
    tags: ["atlas", "arrow", "up", "line"], 
    source: "atlas", 
    name: "ArrowUpLine",
  }, 
  {
    id: "atlas:ArrowUpLineChat", 
    tags: ["atlas", "arrow", "up", "line", "chat"], 
    source: "atlas", 
    name: "ArrowUpLineChat",
  }, 
  {
    id: "atlas:ArrowUpLineMessage", 
    tags: ["atlas", "arrow", "up", "line", "message"], 
    source: "atlas", 
    name: "ArrowUpLineMessage",
  }, 
  {
    id: "atlas:ArrowUpPackage", 
    tags: ["atlas", "arrow", "up", "package"], 
    source: "atlas", 
    name: "ArrowUpPackage",
  }, 
  {
    id: "atlas:ArrowUpPapertray", 
    tags: ["atlas", "arrow", "up", "papertray"], 
    source: "atlas", 
    name: "ArrowUpPapertray",
  }, 
  {
    id: "atlas:ArrowUpRightCircle", 
    tags: ["atlas", "arrow", "up", "right", "circle"], 
    source: "atlas", 
    name: "ArrowUpRightCircle",
  }, 
  {
    id: "atlas:ArrowUpShield", 
    tags: ["atlas", "arrow", "up", "shield"], 
    source: "atlas", 
    name: "ArrowUpShield",
  }, 
  {
    id: "atlas:ArrowUpShoppingCart", 
    tags: ["atlas", "arrow", "up", "shopping", "cart"], 
    source: "atlas", 
    name: "ArrowUpShoppingCart",
  }, 
  {
    id: "atlas:ArrowUpStairsStar", 
    tags: ["atlas", "arrow", "up", "stairs", "star"], 
    source: "atlas", 
    name: "ArrowUpStairsStar",
  }, 
  {
    id: "atlas:ArrowUpTrolley", 
    tags: ["atlas", "arrow", "up", "trolley"], 
    source: "atlas", 
    name: "ArrowUpTrolley",
  }, 
  {
    id: "atlas:ArrowUpwardGroup", 
    tags: ["atlas", "arrow", "upward", "group"], 
    source: "atlas", 
    name: "ArrowUpwardGroup",
  }, 
  {
    id: "atlas:ArrowUpwardHandshake", 
    tags: ["atlas", "arrow", "upward", "handshake"], 
    source: "atlas", 
    name: "ArrowUpwardHandshake",
  }, 
  {
    id: "atlas:ArrowZoomOut", 
    tags: ["atlas", "arrow", "zoom", "out"], 
    source: "atlas", 
    name: "ArrowZoomOut",
  }, 
  {
    id: "atlas:Arrows360", 
    tags: ["atlas", "arrows"], 
    source: "atlas", 
    name: "Arrows360",
  }, 
  {
    id: "atlas:ArrowsCornersMove", 
    tags: ["atlas", "arrows", "corners", "move"], 
    source: "atlas", 
    name: "ArrowsCornersMove",
  }, 
  {
    id: "atlas:ArrowsDotsRotate", 
    tags: ["atlas", "arrows", "dots", "rotate"], 
    source: "atlas", 
    name: "ArrowsDotsRotate",
  }, 
  {
    id: "atlas:ArrowsHouse", 
    tags: ["atlas", "arrows", "house"], 
    source: "atlas", 
    name: "ArrowsHouse",
  }, 
  {
    id: "atlas:ArrowsLineMeet", 
    tags: ["atlas", "arrows", "line", "meet"], 
    source: "atlas", 
    name: "ArrowsLineMeet",
  }, 
  {
    id: "atlas:ArrowsMeetUpDownLine", 
    tags: ["atlas", "arrows", "meet", "up", "down", "line"], 
    source: "atlas", 
    name: "ArrowsMeetUpDownLine",
  }, 
  {
    id: "atlas:ArrowsMove", 
    tags: ["atlas", "arrows", "move"], 
    source: "atlas", 
    name: "ArrowsMove",
  }, 
  {
    id: "atlas:ArrowsMoveNavigate", 
    tags: ["atlas", "arrows", "move", "navigate"], 
    source: "atlas", 
    name: "ArrowsMoveNavigate",
  }, 
  {
    id: "atlas:ArrowsRecycle", 
    tags: ["atlas", "arrows", "recycle"], 
    source: "atlas", 
    name: "ArrowsRecycle",
  }, 
  {
    id: "atlas:ArrowsRotatingRight", 
    tags: ["atlas", "arrows", "rotating", "right"], 
    source: "atlas", 
    name: "ArrowsRotatingRight",
  }, 
  {
    id: "atlas:ArrowsSplitLeftRight", 
    tags: ["atlas", "arrows", "split", "left", "right"], 
    source: "atlas", 
    name: "ArrowsSplitLeftRight",
  }, 
  {
    id: "atlas:ArrowsUpRightDownLeft", 
    tags: ["atlas", "arrows", "up", "right", "down", "left"], 
    source: "atlas", 
    name: "ArrowsUpRightDownLeft",
  }, 
  {
    id: "atlas:ArrowsUser", 
    tags: ["atlas", "arrows", "user"], 
    source: "atlas", 
    name: "ArrowsUser",
  }, 
  {
    id: "atlas:Artboard", 
    tags: ["atlas", "artboard"], 
    source: "atlas", 
    name: "Artboard",
  }, 
  {
    id: "atlas:ArtboardDuplicate", 
    tags: ["atlas", "artboard", "duplicate"], 
    source: "atlas", 
    name: "ArtboardDuplicate",
  }, 
  {
    id: "atlas:Artboards", 
    tags: ["atlas", "artboards"], 
    source: "atlas", 
    name: "Artboards",
  }, 
  {
    id: "atlas:AsiaGate", 
    tags: ["atlas", "asia", "gate"], 
    source: "atlas", 
    name: "AsiaGate",
  }, 
  {
    id: "atlas:AsianBuilding", 
    tags: ["atlas", "asian", "building"], 
    source: "atlas", 
    name: "AsianBuilding",
  }, 
  {
    id: "atlas:AsianGate", 
    tags: ["atlas", "asian", "gate"], 
    source: "atlas", 
    name: "AsianGate",
  }, 
  {
    id: "atlas:AsianPagoda", 
    tags: ["atlas", "asian", "pagoda"], 
    source: "atlas", 
    name: "AsianPagoda",
  }, 
  {
    id: "atlas:AudioAlbum", 
    tags: ["atlas", "audio", "album"], 
    source: "atlas", 
    name: "AudioAlbum",
  }, 
  {
    id: "atlas:AudioCassette", 
    tags: ["atlas", "audio", "cassette"], 
    source: "atlas", 
    name: "AudioCassette",
  }, 
  {
    id: "atlas:AudioCd", 
    tags: ["atlas", "audio", "cd"], 
    source: "atlas", 
    name: "AudioCd",
  }, 
  {
    id: "atlas:AudioChat", 
    tags: ["atlas", "audio", "chat"], 
    source: "atlas", 
    name: "AudioChat",
  }, 
  {
    id: "atlas:AudioHeadphones", 
    tags: ["atlas", "audio", "headphones"], 
    source: "atlas", 
    name: "AudioHeadphones",
  }, 
  {
    id: "atlas:AudioMessage", 
    tags: ["atlas", "audio", "message"], 
    source: "atlas", 
    name: "AudioMessage",
  }, 
  {
    id: "atlas:AudioMicrophone", 
    tags: ["atlas", "audio", "microphone"], 
    source: "atlas", 
    name: "AudioMicrophone",
  }, 
  {
    id: "atlas:AudioPlayer", 
    tags: ["atlas", "audio", "player"], 
    source: "atlas", 
    name: "AudioPlayer",
  }, 
  {
    id: "atlas:AudioSpeaker", 
    tags: ["atlas", "audio", "speaker"], 
    source: "atlas", 
    name: "AudioSpeaker",
  }, 
  {
    id: "atlas:AudioWave", 
    tags: ["atlas", "audio", "wave"], 
    source: "atlas", 
    name: "AudioWave",
  }, 
  {
    id: "atlas:AudioWebsite", 
    tags: ["atlas", "audio", "website"], 
    source: "atlas", 
    name: "AudioWebsite",
  }, 
  {
    id: "atlas:Avocado", 
    tags: ["atlas", "avocado"], 
    source: "atlas", 
    name: "Avocado",
  }, 
  {
    id: "atlas:AvoidArrows", 
    tags: ["atlas", "avoid", "arrows"], 
    source: "atlas", 
    name: "AvoidArrows",
  }, 
  {
    id: "atlas:Axe", 
    tags: ["atlas", "axe"], 
    source: "atlas", 
    name: "Axe",
  }, 
  {
    id: "atlas:B", 
    tags: ["atlas"], 
    source: "atlas", 
    name: "B",
  }, 
  {
    id: "atlas:Back", 
    tags: ["atlas", "back"], 
    source: "atlas", 
    name: "Back",
  }, 
  {
    id: "atlas:BackVr", 
    tags: ["atlas", "back", "vr"], 
    source: "atlas", 
    name: "BackVr",
  }, 
  {
    id: "atlas:Backpack", 
    tags: ["atlas", "backpack"], 
    source: "atlas", 
    name: "Backpack",
  }, 
  {
    id: "atlas:BackpackLuggage", 
    tags: ["atlas", "backpack", "luggage"], 
    source: "atlas", 
    name: "BackpackLuggage",
  }, 
  {
    id: "atlas:Backward", 
    tags: ["atlas", "backward"], 
    source: "atlas", 
    name: "Backward",
  }, 
  {
    id: "atlas:BackwardBridgePose", 
    tags: ["atlas", "backward", "bridge", "pose"], 
    source: "atlas", 
    name: "BackwardBridgePose",
  }, 
  {
    id: "atlas:Bacon", 
    tags: ["atlas", "bacon"], 
    source: "atlas", 
    name: "Bacon",
  }, 
  {
    id: "atlas:Bacteria", 
    tags: ["atlas", "bacteria"], 
    source: "atlas", 
    name: "Bacteria",
  }, 
  {
    id: "atlas:BacteriaOrganism", 
    tags: ["atlas", "bacteria", "organism"], 
    source: "atlas", 
    name: "BacteriaOrganism",
  }, 
  {
    id: "atlas:BacteriaView", 
    tags: ["atlas", "bacteria", "view"], 
    source: "atlas", 
    name: "BacteriaView",
  }, 
  {
    id: "atlas:BadmintonShuttle", 
    tags: ["atlas", "badminton", "shuttle"], 
    source: "atlas", 
    name: "BadmintonShuttle",
  }, 
  {
    id: "atlas:Bag", 
    tags: ["atlas", "bag"], 
    source: "atlas", 
    name: "Bag",
  }, 
  {
    id: "atlas:Baggage", 
    tags: ["atlas", "baggage"], 
    source: "atlas", 
    name: "Baggage",
  }, 
  {
    id: "atlas:BaggageTrolley", 
    tags: ["atlas", "baggage", "trolley"], 
    source: "atlas", 
    name: "BaggageTrolley",
  }, 
  {
    id: "atlas:BalanceBall", 
    tags: ["atlas", "balance", "ball"], 
    source: "atlas", 
    name: "BalanceBall",
  }, 
  {
    id: "atlas:BalanceBeam", 
    tags: ["atlas", "balance", "beam"], 
    source: "atlas", 
    name: "BalanceBeam",
  }, 
  {
    id: "atlas:BalanceBeams", 
    tags: ["atlas", "balance", "beams"], 
    source: "atlas", 
    name: "BalanceBeams",
  }, 
  {
    id: "atlas:BalanceRings", 
    tags: ["atlas", "balance", "rings"], 
    source: "atlas", 
    name: "BalanceRings",
  }, 
  {
    id: "atlas:Balcony", 
    tags: ["atlas", "balcony"], 
    source: "atlas", 
    name: "Balcony",
  }, 
  {
    id: "atlas:BalconyWindow", 
    tags: ["atlas", "balcony", "window"], 
    source: "atlas", 
    name: "BalconyWindow",
  }, 
  {
    id: "atlas:Ball", 
    tags: ["atlas", "ball"], 
    source: "atlas", 
    name: "Ball",
  }, 
  {
    id: "atlas:BallOrnament", 
    tags: ["atlas", "ball", "ornament"], 
    source: "atlas", 
    name: "BallOrnament",
  }, 
  {
    id: "atlas:Banana", 
    tags: ["atlas", "banana"], 
    source: "atlas", 
    name: "Banana",
  }, 
  {
    id: "atlas:Bandage", 
    tags: ["atlas", "bandage"], 
    source: "atlas", 
    name: "Bandage",
  }, 
  {
    id: "atlas:Bandages", 
    tags: ["atlas", "bandages"], 
    source: "atlas", 
    name: "Bandages",
  }, 
  {
    id: "atlas:BarChart", 
    tags: ["atlas", "bar", "chart"], 
    source: "atlas", 
    name: "BarChart",
  }, 
  {
    id: "atlas:BarChartMagnifyingGlass", 
    tags: ["atlas", "bar", "chart", "magnifying", "glass"], 
    source: "atlas", 
    name: "BarChartMagnifyingGlass",
  }, 
  {
    id: "atlas:BarGraph", 
    tags: ["atlas", "bar", "graph"], 
    source: "atlas", 
    name: "BarGraph",
  }, 
  {
    id: "atlas:BarStools", 
    tags: ["atlas", "bar", "stools"], 
    source: "atlas", 
    name: "BarStools",
  }, 
  {
    id: "atlas:Barbeque", 
    tags: ["atlas", "barbeque"], 
    source: "atlas", 
    name: "Barbeque",
  }, 
  {
    id: "atlas:BarbequeGrill", 
    tags: ["atlas", "barbeque", "grill"], 
    source: "atlas", 
    name: "BarbequeGrill",
  }, 
  {
    id: "atlas:Barcode", 
    tags: ["atlas", "barcode"], 
    source: "atlas", 
    name: "Barcode",
  }, 
  {
    id: "atlas:Barn", 
    tags: ["atlas", "barn"], 
    source: "atlas", 
    name: "Barn",
  }, 
  {
    id: "atlas:Barrel", 
    tags: ["atlas", "barrel"], 
    source: "atlas", 
    name: "Barrel",
  }, 
  {
    id: "atlas:Baseball", 
    tags: ["atlas", "baseball"], 
    source: "atlas", 
    name: "Baseball",
  }, 
  {
    id: "atlas:BaseballBat", 
    tags: ["atlas", "baseball", "bat"], 
    source: "atlas", 
    name: "BaseballBat",
  }, 
  {
    id: "atlas:Basket", 
    tags: ["atlas", "basket"], 
    source: "atlas", 
    name: "Basket",
  }, 
  {
    id: "atlas:Basketball", 
    tags: ["atlas", "basketball"], 
    source: "atlas", 
    name: "Basketball",
  }, 
  {
    id: "atlas:BasketballNet", 
    tags: ["atlas", "basketball", "net"], 
    source: "atlas", 
    name: "BasketballNet",
  }, 
  {
    id: "atlas:BatBall", 
    tags: ["atlas", "bat", "ball"], 
    source: "atlas", 
    name: "BatBall",
  }, 
  {
    id: "atlas:Bathrobe", 
    tags: ["atlas", "bathrobe"], 
    source: "atlas", 
    name: "Bathrobe",
  }, 
  {
    id: "atlas:Bathtub", 
    tags: ["atlas", "bathtub"], 
    source: "atlas", 
    name: "Bathtub",
  }, 
  {
    id: "atlas:BathtubShower", 
    tags: ["atlas", "bathtub", "shower"], 
    source: "atlas", 
    name: "BathtubShower",
  }, 
  {
    id: "atlas:BeachBall", 
    tags: ["atlas", "beach", "ball"], 
    source: "atlas", 
    name: "BeachBall",
  }, 
  {
    id: "atlas:BeachHoliday", 
    tags: ["atlas", "beach", "holiday"], 
    source: "atlas", 
    name: "BeachHoliday",
  }, 
  {
    id: "atlas:BeachLounge", 
    tags: ["atlas", "beach", "lounge"], 
    source: "atlas", 
    name: "BeachLounge",
  }, 
  {
    id: "atlas:Bed", 
    tags: ["atlas", "bed"], 
    source: "atlas", 
    name: "Bed",
  }, 
  {
    id: "atlas:BedFurniture", 
    tags: ["atlas", "bed", "furniture"], 
    source: "atlas", 
    name: "BedFurniture",
  }, 
  {
    id: "atlas:BedSleep", 
    tags: ["atlas", "bed", "sleep"], 
    source: "atlas", 
    name: "BedSleep",
  }, 
  {
    id: "atlas:Beer", 
    tags: ["atlas", "beer"], 
    source: "atlas", 
    name: "Beer",
  }, 
  {
    id: "atlas:BeerFoamDrink", 
    tags: ["atlas", "beer", "foam", "drink"], 
    source: "atlas", 
    name: "BeerFoamDrink",
  }, 
  {
    id: "atlas:Behance", 
    tags: ["atlas", "behance"], 
    source: "atlas", 
    name: "Behance",
  }, 
  {
    id: "atlas:Bell", 
    tags: ["atlas", "bell"], 
    source: "atlas", 
    name: "Bell",
  }, 
  {
    id: "atlas:BellBow", 
    tags: ["atlas", "bell", "bow"], 
    source: "atlas", 
    name: "BellBow",
  }, 
  {
    id: "atlas:BellCheck", 
    tags: ["atlas", "bell", "check"], 
    source: "atlas", 
    name: "BellCheck",
  }, 
  {
    id: "atlas:BellDash", 
    tags: ["atlas", "bell", "dash"], 
    source: "atlas", 
    name: "BellDash",
  }, 
  {
    id: "atlas:BellDots", 
    tags: ["atlas", "bell", "dots"], 
    source: "atlas", 
    name: "BellDots",
  }, 
  {
    id: "atlas:BellMinus", 
    tags: ["atlas", "bell", "minus"], 
    source: "atlas", 
    name: "BellMinus",
  }, 
  {
    id: "atlas:BellMobile", 
    tags: ["atlas", "bell", "mobile"], 
    source: "atlas", 
    name: "BellMobile",
  }, 
  {
    id: "atlas:BellPlus", 
    tags: ["atlas", "bell", "plus"], 
    source: "atlas", 
    name: "BellPlus",
  }, 
  {
    id: "atlas:BellReminder", 
    tags: ["atlas", "bell", "reminder"], 
    source: "atlas", 
    name: "BellReminder",
  }, 
  {
    id: "atlas:BellXmark", 
    tags: ["atlas", "bell", "xmark"], 
    source: "atlas", 
    name: "BellXmark",
  }, 
  {
    id: "atlas:Berries", 
    tags: ["atlas", "berries"], 
    source: "atlas", 
    name: "Berries",
  }, 
  {
    id: "atlas:BerriesOrganicLeaf", 
    tags: ["atlas", "berries", "organic", "leaf"], 
    source: "atlas", 
    name: "BerriesOrganicLeaf",
  }, 
  {
    id: "atlas:Bible", 
    tags: ["atlas", "bible"], 
    source: "atlas", 
    name: "Bible",
  }, 
  {
    id: "atlas:BibleBook", 
    tags: ["atlas", "bible", "book"], 
    source: "atlas", 
    name: "BibleBook",
  }, 
  {
    id: "atlas:Bicycle", 
    tags: ["atlas", "bicycle"], 
    source: "atlas", 
    name: "Bicycle",
  }, 
  {
    id: "atlas:BigBen", 
    tags: ["atlas", "big", "ben"], 
    source: "atlas", 
    name: "BigBen",
  }, 
  {
    id: "atlas:Bike", 
    tags: ["atlas", "bike"], 
    source: "atlas", 
    name: "Bike",
  }, 
  {
    id: "atlas:BikeBicycle", 
    tags: ["atlas", "bike", "bicycle"], 
    source: "atlas", 
    name: "BikeBicycle",
  }, 
  {
    id: "atlas:Bikini", 
    tags: ["atlas", "bikini"], 
    source: "atlas", 
    name: "Bikini",
  }, 
  {
    id: "atlas:Billboard", 
    tags: ["atlas", "billboard"], 
    source: "atlas", 
    name: "Billboard",
  }, 
  {
    id: "atlas:BilliardCueBalls", 
    tags: ["atlas", "billiard", "cue", "balls"], 
    source: "atlas", 
    name: "BilliardCueBalls",
  }, 
  {
    id: "atlas:Binoculars", 
    tags: ["atlas", "binoculars"], 
    source: "atlas", 
    name: "Binoculars",
  }, 
  {
    id: "atlas:BirdFountain", 
    tags: ["atlas", "bird", "fountain"], 
    source: "atlas", 
    name: "BirdFountain",
  }, 
  {
    id: "atlas:Bitcoin", 
    tags: ["atlas", "bitcoin"], 
    source: "atlas", 
    name: "Bitcoin",
  }, 
  {
    id: "atlas:BitcoinCircle", 
    tags: ["atlas", "bitcoin", "circle"], 
    source: "atlas", 
    name: "BitcoinCircle",
  }, 
  {
    id: "atlas:BlankFolder", 
    tags: ["atlas", "blank", "folder"], 
    source: "atlas", 
    name: "BlankFolder",
  }, 
  {
    id: "atlas:Block", 
    tags: ["atlas", "block"], 
    source: "atlas", 
    name: "Block",
  }, 
  {
    id: "atlas:BlockChat", 
    tags: ["atlas", "block", "chat"], 
    source: "atlas", 
    name: "BlockChat",
  }, 
  {
    id: "atlas:BlockClipboard", 
    tags: ["atlas", "block", "clipboard"], 
    source: "atlas", 
    name: "BlockClipboard",
  }, 
  {
    id: "atlas:BlockEnvelope", 
    tags: ["atlas", "block", "envelope"], 
    source: "atlas", 
    name: "BlockEnvelope",
  }, 
  {
    id: "atlas:BlockFile", 
    tags: ["atlas", "block", "file"], 
    source: "atlas", 
    name: "BlockFile",
  }, 
  {
    id: "atlas:BlockFolder", 
    tags: ["atlas", "block", "folder"], 
    source: "atlas", 
    name: "BlockFolder",
  }, 
  {
    id: "atlas:BlockMessage", 
    tags: ["atlas", "block", "message"], 
    source: "atlas", 
    name: "BlockMessage",
  }, 
  {
    id: "atlas:BlockProhibited", 
    tags: ["atlas", "block", "prohibited"], 
    source: "atlas", 
    name: "BlockProhibited",
  }, 
  {
    id: "atlas:BlockShield", 
    tags: ["atlas", "block", "shield"], 
    source: "atlas", 
    name: "BlockShield",
  }, 
  {
    id: "atlas:BlockWebsite", 
    tags: ["atlas", "block", "website"], 
    source: "atlas", 
    name: "BlockWebsite",
  }, 
  {
    id: "atlas:BlogWebsite", 
    tags: ["atlas", "blog", "website"], 
    source: "atlas", 
    name: "BlogWebsite",
  }, 
  {
    id: "atlas:Blogger", 
    tags: ["atlas", "blogger"], 
    source: "atlas", 
    name: "Blogger",
  }, 
  {
    id: "atlas:BloodDrip", 
    tags: ["atlas", "blood", "drip"], 
    source: "atlas", 
    name: "BloodDrip",
  }, 
  {
    id: "atlas:BloodPressure", 
    tags: ["atlas", "blood", "pressure"], 
    source: "atlas", 
    name: "BloodPressure",
  }, 
  {
    id: "atlas:Blueprint", 
    tags: ["atlas", "blueprint"], 
    source: "atlas", 
    name: "Blueprint",
  }, 
  {
    id: "atlas:BlueprintPaper", 
    tags: ["atlas", "blueprint", "paper"], 
    source: "atlas", 
    name: "BlueprintPaper",
  }, 
  {
    id: "atlas:BoatPose", 
    tags: ["atlas", "boat", "pose"], 
    source: "atlas", 
    name: "BoatPose",
  }, 
  {
    id: "atlas:BoiledEgg", 
    tags: ["atlas", "boiled", "egg"], 
    source: "atlas", 
    name: "BoiledEgg",
  }, 
  {
    id: "atlas:Bold", 
    tags: ["atlas", "bold"], 
    source: "atlas", 
    name: "Bold",
  }, 
  {
    id: "atlas:Bolt", 
    tags: ["atlas", "bolt"], 
    source: "atlas", 
    name: "Bolt",
  }, 
  {
    id: "atlas:Bomb", 
    tags: ["atlas", "bomb"], 
    source: "atlas", 
    name: "Bomb",
  }, 
  {
    id: "atlas:Bone", 
    tags: ["atlas", "bone"], 
    source: "atlas", 
    name: "Bone",
  }, 
  {
    id: "atlas:BoneJoint", 
    tags: ["atlas", "bone", "joint"], 
    source: "atlas", 
    name: "BoneJoint",
  }, 
  {
    id: "atlas:Book", 
    tags: ["atlas", "book"], 
    source: "atlas", 
    name: "Book",
  }, 
  {
    id: "atlas:BookmarkEnvelope", 
    tags: ["atlas", "bookmark", "envelope"], 
    source: "atlas", 
    name: "BookmarkEnvelope",
  }, 
  {
    id: "atlas:BookmarkStar", 
    tags: ["atlas", "bookmark", "star"], 
    source: "atlas", 
    name: "BookmarkStar",
  }, 
  {
    id: "atlas:Bookshelf", 
    tags: ["atlas", "bookshelf"], 
    source: "atlas", 
    name: "Bookshelf",
  }, 
  {
    id: "atlas:BookshelfBooks", 
    tags: ["atlas", "bookshelf", "books"], 
    source: "atlas", 
    name: "BookshelfBooks",
  }, 
  {
    id: "atlas:BookshelfLibrary", 
    tags: ["atlas", "bookshelf", "library"], 
    source: "atlas", 
    name: "BookshelfLibrary",
  }, 
  {
    id: "atlas:Boot", 
    tags: ["atlas", "boot"], 
    source: "atlas", 
    name: "Boot",
  }, 
  {
    id: "atlas:BootShoeFootwear", 
    tags: ["atlas", "boot", "shoe", "footwear"], 
    source: "atlas", 
    name: "BootShoeFootwear",
  }, 
  {
    id: "atlas:BottleGlass", 
    tags: ["atlas", "bottle", "glass"], 
    source: "atlas", 
    name: "BottleGlass",
  }, 
  {
    id: "atlas:BottleSpoon", 
    tags: ["atlas", "bottle", "spoon"], 
    source: "atlas", 
    name: "BottleSpoon",
  }, 
  {
    id: "atlas:BowArrowHeart", 
    tags: ["atlas", "bow", "arrow", "heart"], 
    source: "atlas", 
    name: "BowArrowHeart",
  }, 
  {
    id: "atlas:BowPose", 
    tags: ["atlas", "bow", "pose"], 
    source: "atlas", 
    name: "BowPose",
  }, 
  {
    id: "atlas:BowlingBall", 
    tags: ["atlas", "bowling", "ball"], 
    source: "atlas", 
    name: "BowlingBall",
  }, 
  {
    id: "atlas:BowlingPin", 
    tags: ["atlas", "bowling", "pin"], 
    source: "atlas", 
    name: "BowlingPin",
  }, 
  {
    id: "atlas:BoxFiling", 
    tags: ["atlas", "box", "filing"], 
    source: "atlas", 
    name: "BoxFiling",
  }, 
  {
    id: "atlas:BoxingBag", 
    tags: ["atlas", "boxing", "bag"], 
    source: "atlas", 
    name: "BoxingBag",
  }, 
  {
    id: "atlas:BoxingBall", 
    tags: ["atlas", "boxing", "ball"], 
    source: "atlas", 
    name: "BoxingBall",
  }, 
  {
    id: "atlas:BoxingGlove", 
    tags: ["atlas", "boxing", "glove"], 
    source: "atlas", 
    name: "BoxingGlove",
  }, 
  {
    id: "atlas:Brain", 
    tags: ["atlas", "brain"], 
    source: "atlas", 
    name: "Brain",
  }, 
  {
    id: "atlas:BrandenburgGate", 
    tags: ["atlas", "brandenburg", "gate"], 
    source: "atlas", 
    name: "BrandenburgGate",
  }, 
  {
    id: "atlas:BreadLoaf", 
    tags: ["atlas", "bread", "loaf"], 
    source: "atlas", 
    name: "BreadLoaf",
  }, 
  {
    id: "atlas:Breasts", 
    tags: ["atlas", "breasts"], 
    source: "atlas", 
    name: "Breasts",
  }, 
  {
    id: "atlas:Bridge", 
    tags: ["atlas", "bridge"], 
    source: "atlas", 
    name: "Bridge",
  }, 
  {
    id: "atlas:BridgeTower", 
    tags: ["atlas", "bridge", "tower"], 
    source: "atlas", 
    name: "BridgeTower",
  }, 
  {
    id: "atlas:BridgeYogaPose", 
    tags: ["atlas", "bridge", "yoga", "pose"], 
    source: "atlas", 
    name: "BridgeYogaPose",
  }, 
  {
    id: "atlas:Broadcast", 
    tags: ["atlas", "broadcast"], 
    source: "atlas", 
    name: "Broadcast",
  }, 
  {
    id: "atlas:BrokenFile", 
    tags: ["atlas", "broken", "file"], 
    source: "atlas", 
    name: "BrokenFile",
  }, 
  {
    id: "atlas:BrokenFolder", 
    tags: ["atlas", "broken", "folder"], 
    source: "atlas", 
    name: "BrokenFolder",
  }, 
  {
    id: "atlas:BrokenHeart", 
    tags: ["atlas", "broken", "heart"], 
    source: "atlas", 
    name: "BrokenHeart",
  }, 
  {
    id: "atlas:Brush", 
    tags: ["atlas", "brush"], 
    source: "atlas", 
    name: "Brush",
  }, 
  {
    id: "atlas:BrushTool", 
    tags: ["atlas", "brush", "tool"], 
    source: "atlas", 
    name: "BrushTool",
  }, 
  {
    id: "atlas:BugClipboard", 
    tags: ["atlas", "bug", "clipboard"], 
    source: "atlas", 
    name: "BugClipboard",
  }, 
  {
    id: "atlas:BugCloud", 
    tags: ["atlas", "bug", "cloud"], 
    source: "atlas", 
    name: "BugCloud",
  }, 
  {
    id: "atlas:BugEnvelope", 
    tags: ["atlas", "bug", "envelope"], 
    source: "atlas", 
    name: "BugEnvelope",
  }, 
  {
    id: "atlas:BugFile", 
    tags: ["atlas", "bug", "file"], 
    source: "atlas", 
    name: "BugFile",
  }, 
  {
    id: "atlas:BugInsect", 
    tags: ["atlas", "bug", "insect"], 
    source: "atlas", 
    name: "BugInsect",
  }, 
  {
    id: "atlas:BugLaptop", 
    tags: ["atlas", "bug", "laptop"], 
    source: "atlas", 
    name: "BugLaptop",
  }, 
  {
    id: "atlas:BugMonitor", 
    tags: ["atlas", "bug", "monitor"], 
    source: "atlas", 
    name: "BugMonitor",
  }, 
  {
    id: "atlas:BuildWall", 
    tags: ["atlas", "build", "wall"], 
    source: "atlas", 
    name: "BuildWall",
  }, 
  {
    id: "atlas:Building", 
    tags: ["atlas", "building"], 
    source: "atlas", 
    name: "Building",
  }, 
  {
    id: "atlas:BuildingAsian", 
    tags: ["atlas", "building", "asian"], 
    source: "atlas", 
    name: "BuildingAsian",
  }, 
  {
    id: "atlas:BuildingChurch", 
    tags: ["atlas", "building", "church"], 
    source: "atlas", 
    name: "BuildingChurch",
  }, 
  {
    id: "atlas:BuildingChurchReligion", 
    tags: ["atlas", "building", "church", "religion"], 
    source: "atlas", 
    name: "BuildingChurchReligion",
  }, 
  {
    id: "atlas:BuildingColumn", 
    tags: ["atlas", "building", "column"], 
    source: "atlas", 
    name: "BuildingColumn",
  }, 
  {
    id: "atlas:BuildingConstruction", 
    tags: ["atlas", "building", "construction"], 
    source: "atlas", 
    name: "BuildingConstruction",
  }, 
  {
    id: "atlas:Bulldozer", 
    tags: ["atlas", "bulldozer"], 
    source: "atlas", 
    name: "Bulldozer",
  }, 
  {
    id: "atlas:BulletTrain", 
    tags: ["atlas", "bullet", "train"], 
    source: "atlas", 
    name: "BulletTrain",
  }, 
  {
    id: "atlas:Bullhorn", 
    tags: ["atlas", "bullhorn"], 
    source: "atlas", 
    name: "Bullhorn",
  }, 
  {
    id: "atlas:BullhornMegaphone", 
    tags: ["atlas", "bullhorn", "megaphone"], 
    source: "atlas", 
    name: "BullhornMegaphone",
  }, 
  {
    id: "atlas:Bunkbeds", 
    tags: ["atlas", "bunkbeds"], 
    source: "atlas", 
    name: "Bunkbeds",
  }, 
  {
    id: "atlas:BurjElArab", 
    tags: ["atlas", "burj", "el", "arab"], 
    source: "atlas", 
    name: "BurjElArab",
  }, 
  {
    id: "atlas:Bus", 
    tags: ["atlas", "bus"], 
    source: "atlas", 
    name: "Bus",
  }, 
  {
    id: "atlas:BusFront", 
    tags: ["atlas", "bus", "front"], 
    source: "atlas", 
    name: "BusFront",
  }, 
  {
    id: "atlas:BusTransportation", 
    tags: ["atlas", "bus", "transportation"], 
    source: "atlas", 
    name: "BusTransportation",
  }, 
  {
    id: "atlas:BusVehicle", 
    tags: ["atlas", "bus", "vehicle"], 
    source: "atlas", 
    name: "BusVehicle",
  }, 
  {
    id: "atlas:BusinessBriefcase", 
    tags: ["atlas", "business", "briefcase"], 
    source: "atlas", 
    name: "BusinessBriefcase",
  }, 
  {
    id: "atlas:BusinessMan", 
    tags: ["atlas", "business", "man"], 
    source: "atlas", 
    name: "BusinessMan",
  }, 
  {
    id: "atlas:BusinessMeeting", 
    tags: ["atlas", "business", "meeting"], 
    source: "atlas", 
    name: "BusinessMeeting",
  }, 
  {
    id: "atlas:BusinessSuitcase", 
    tags: ["atlas", "business", "suitcase"], 
    source: "atlas", 
    name: "BusinessSuitcase",
  }, 
  {
    id: "atlas:BusinessWoman", 
    tags: ["atlas", "business", "woman"], 
    source: "atlas", 
    name: "BusinessWoman",
  }, 
  {
    id: "atlas:Butt", 
    tags: ["atlas", "butt"], 
    source: "atlas", 
    name: "Butt",
  }, 
  {
    id: "atlas:Cabin", 
    tags: ["atlas", "cabin"], 
    source: "atlas", 
    name: "Cabin",
  }, 
  {
    id: "atlas:Cable", 
    tags: ["atlas", "cable"], 
    source: "atlas", 
    name: "Cable",
  }, 
  {
    id: "atlas:CableCharge", 
    tags: ["atlas", "cable", "charge"], 
    source: "atlas", 
    name: "CableCharge",
  }, 
  {
    id: "atlas:CableUsb", 
    tags: ["atlas", "cable", "usb"], 
    source: "atlas", 
    name: "CableUsb",
  }, 
  {
    id: "atlas:CakeSlice", 
    tags: ["atlas", "cake", "slice"], 
    source: "atlas", 
    name: "CakeSlice",
  }, 
  {
    id: "atlas:Calculator", 
    tags: ["atlas", "calculator"], 
    source: "atlas", 
    name: "Calculator",
  }, 
  {
    id: "atlas:Calendar", 
    tags: ["atlas", "calendar"], 
    source: "atlas", 
    name: "Calendar",
  }, 
  {
    id: "atlas:CalendarBell", 
    tags: ["atlas", "calendar", "bell"], 
    source: "atlas", 
    name: "CalendarBell",
  }, 
  {
    id: "atlas:CalendarDate", 
    tags: ["atlas", "calendar", "date"], 
    source: "atlas", 
    name: "CalendarDate",
  }, 
  {
    id: "atlas:CalendarDots", 
    tags: ["atlas", "calendar", "dots"], 
    source: "atlas", 
    name: "CalendarDots",
  }, 
  {
    id: "atlas:CalendarHome", 
    tags: ["atlas", "calendar", "home"], 
    source: "atlas", 
    name: "CalendarHome",
  }, 
  {
    id: "atlas:CalendarSchedule", 
    tags: ["atlas", "calendar", "schedule"], 
    source: "atlas", 
    name: "CalendarSchedule",
  }, 
  {
    id: "atlas:Call", 
    tags: ["atlas", "call"], 
    source: "atlas", 
    name: "Call",
  }, 
  {
    id: "atlas:CallArrowDownLeft", 
    tags: ["atlas", "call", "arrow", "down", "left"], 
    source: "atlas", 
    name: "CallArrowDownLeft",
  }, 
  {
    id: "atlas:CallArrowUpRight", 
    tags: ["atlas", "call", "arrow", "up", "right"], 
    source: "atlas", 
    name: "CallArrowUpRight",
  }, 
  {
    id: "atlas:CallDots", 
    tags: ["atlas", "call", "dots"], 
    source: "atlas", 
    name: "CallDots",
  }, 
  {
    id: "atlas:CallSlash", 
    tags: ["atlas", "call", "slash"], 
    source: "atlas", 
    name: "CallSlash",
  }, 
  {
    id: "atlas:CallXmark", 
    tags: ["atlas", "call", "xmark"], 
    source: "atlas", 
    name: "CallXmark",
  }, 
  {
    id: "atlas:CallerId", 
    tags: ["atlas", "caller", "id"], 
    source: "atlas", 
    name: "CallerId",
  }, 
  {
    id: "atlas:Camcorder", 
    tags: ["atlas", "camcorder"], 
    source: "atlas", 
    name: "Camcorder",
  }, 
  {
    id: "atlas:CamcorderBack", 
    tags: ["atlas", "camcorder", "back"], 
    source: "atlas", 
    name: "CamcorderBack",
  }, 
  {
    id: "atlas:CamelPose", 
    tags: ["atlas", "camel", "pose"], 
    source: "atlas", 
    name: "CamelPose",
  }, 
  {
    id: "atlas:Camera", 
    tags: ["atlas", "camera"], 
    source: "atlas", 
    name: "Camera",
  }, 
  {
    id: "atlas:CameraArrow", 
    tags: ["atlas", "camera", "arrow"], 
    source: "atlas", 
    name: "CameraArrow",
  }, 
  {
    id: "atlas:CameraDevice", 
    tags: ["atlas", "camera", "device"], 
    source: "atlas", 
    name: "CameraDevice",
  }, 
  {
    id: "atlas:CameraFilm", 
    tags: ["atlas", "camera", "film"], 
    source: "atlas", 
    name: "CameraFilm",
  }, 
  {
    id: "atlas:CameraLens", 
    tags: ["atlas", "camera", "lens"], 
    source: "atlas", 
    name: "CameraLens",
  }, 
  {
    id: "atlas:CameraPhoto", 
    tags: ["atlas", "camera", "photo"], 
    source: "atlas", 
    name: "CameraPhoto",
  }, 
  {
    id: "atlas:CameraPhotography", 
    tags: ["atlas", "camera", "photography"], 
    source: "atlas", 
    name: "CameraPhotography",
  }, 
  {
    id: "atlas:CameraStand", 
    tags: ["atlas", "camera", "stand"], 
    source: "atlas", 
    name: "CameraStand",
  }, 
  {
    id: "atlas:CameraWheels", 
    tags: ["atlas", "camera", "wheels"], 
    source: "atlas", 
    name: "CameraWheels",
  }, 
  {
    id: "atlas:CampTent", 
    tags: ["atlas", "camp", "tent"], 
    source: "atlas", 
    name: "CampTent",
  }, 
  {
    id: "atlas:Camper", 
    tags: ["atlas", "camper"], 
    source: "atlas", 
    name: "Camper",
  }, 
  {
    id: "atlas:CamperVehicle", 
    tags: ["atlas", "camper", "vehicle"], 
    source: "atlas", 
    name: "CamperVehicle",
  }, 
  {
    id: "atlas:Campfire", 
    tags: ["atlas", "campfire"], 
    source: "atlas", 
    name: "Campfire",
  }, 
  {
    id: "atlas:CampingTent", 
    tags: ["atlas", "camping", "tent"], 
    source: "atlas", 
    name: "CampingTent",
  }, 
  {
    id: "atlas:Candle", 
    tags: ["atlas", "candle"], 
    source: "atlas", 
    name: "Candle",
  }, 
  {
    id: "atlas:CandleHolder", 
    tags: ["atlas", "candle", "holder"], 
    source: "atlas", 
    name: "CandleHolder",
  }, 
  {
    id: "atlas:CandleLight", 
    tags: ["atlas", "candle", "light"], 
    source: "atlas", 
    name: "CandleLight",
  }, 
  {
    id: "atlas:CandleLines", 
    tags: ["atlas", "candle", "lines"], 
    source: "atlas", 
    name: "CandleLines",
  }, 
  {
    id: "atlas:CandleStick", 
    tags: ["atlas", "candle", "stick"], 
    source: "atlas", 
    name: "CandleStick",
  }, 
  {
    id: "atlas:Candles", 
    tags: ["atlas", "candles"], 
    source: "atlas", 
    name: "Candles",
  }, 
  {
    id: "atlas:Candy", 
    tags: ["atlas", "candy"], 
    source: "atlas", 
    name: "Candy",
  }, 
  {
    id: "atlas:CandyCane", 
    tags: ["atlas", "candy", "cane"], 
    source: "atlas", 
    name: "CandyCane",
  }, 
  {
    id: "atlas:Canoe", 
    tags: ["atlas", "canoe"], 
    source: "atlas", 
    name: "Canoe",
  }, 
  {
    id: "atlas:CapsuleMedicine", 
    tags: ["atlas", "capsule", "medicine"], 
    source: "atlas", 
    name: "CapsuleMedicine",
  }, 
  {
    id: "atlas:Car", 
    tags: ["atlas", "car"], 
    source: "atlas", 
    name: "Car",
  }, 
  {
    id: "atlas:CarFront", 
    tags: ["atlas", "car", "front"], 
    source: "atlas", 
    name: "CarFront",
  }, 
  {
    id: "atlas:CarGarage", 
    tags: ["atlas", "car", "garage"], 
    source: "atlas", 
    name: "CarGarage",
  }, 
  {
    id: "atlas:CarKey", 
    tags: ["atlas", "car", "key"], 
    source: "atlas", 
    name: "CarKey",
  }, 
  {
    id: "atlas:CarTransport", 
    tags: ["atlas", "car", "transport"], 
    source: "atlas", 
    name: "CarTransport",
  }, 
  {
    id: "atlas:CarVehicle", 
    tags: ["atlas", "car", "vehicle"], 
    source: "atlas", 
    name: "CarVehicle",
  }, 
  {
    id: "atlas:Caravan", 
    tags: ["atlas", "caravan"], 
    source: "atlas", 
    name: "Caravan",
  }, 
  {
    id: "atlas:CaravanWheels", 
    tags: ["atlas", "caravan", "wheels"], 
    source: "atlas", 
    name: "CaravanWheels",
  }, 
  {
    id: "atlas:Cardiogram", 
    tags: ["atlas", "cardiogram"], 
    source: "atlas", 
    name: "Cardiogram",
  }, 
  {
    id: "atlas:CargoTransport", 
    tags: ["atlas", "cargo", "transport"], 
    source: "atlas", 
    name: "CargoTransport",
  }, 
  {
    id: "atlas:Carrot", 
    tags: ["atlas", "carrot"], 
    source: "atlas", 
    name: "Carrot",
  }, 
  {
    id: "atlas:CarrotTurnipVegetable", 
    tags: ["atlas", "carrot", "turnip", "vegetable"], 
    source: "atlas", 
    name: "CarrotTurnipVegetable",
  }, 
  {
    id: "atlas:Cart", 
    tags: ["atlas", "cart"], 
    source: "atlas", 
    name: "Cart",
  }, 
  {
    id: "atlas:CashBills", 
    tags: ["atlas", "cash", "bills"], 
    source: "atlas", 
    name: "CashBills",
  }, 
  {
    id: "atlas:CashWithdraw", 
    tags: ["atlas", "cash", "withdraw"], 
    source: "atlas", 
    name: "CashWithdraw",
  }, 
  {
    id: "atlas:Cast", 
    tags: ["atlas", "cast"], 
    source: "atlas", 
    name: "Cast",
  }, 
  {
    id: "atlas:CatPose", 
    tags: ["atlas", "cat", "pose"], 
    source: "atlas", 
    name: "CatPose",
  }, 
  {
    id: "atlas:CcComment", 
    tags: ["atlas", "cc", "comment"], 
    source: "atlas", 
    name: "CcComment",
  }, 
  {
    id: "atlas:CcSquare", 
    tags: ["atlas", "cc", "square"], 
    source: "atlas", 
    name: "CcSquare",
  }, 
  {
    id: "atlas:CeilingLamp", 
    tags: ["atlas", "ceiling", "lamp"], 
    source: "atlas", 
    name: "CeilingLamp",
  }, 
  {
    id: "atlas:CeilingLight", 
    tags: ["atlas", "ceiling", "light"], 
    source: "atlas", 
    name: "CeilingLight",
  }, 
  {
    id: "atlas:CeilingLighting", 
    tags: ["atlas", "ceiling", "lighting"], 
    source: "atlas", 
    name: "CeilingLighting",
  }, 
  {
    id: "atlas:Celcius", 
    tags: ["atlas", "celcius"], 
    source: "atlas", 
    name: "Celcius",
  }, 
  {
    id: "atlas:Cells", 
    tags: ["atlas", "cells"], 
    source: "atlas", 
    name: "Cells",
  }, 
  {
    id: "atlas:CellsMonitor", 
    tags: ["atlas", "cells", "monitor"], 
    source: "atlas", 
    name: "CellsMonitor",
  }, 
  {
    id: "atlas:CementMixer", 
    tags: ["atlas", "cement", "mixer"], 
    source: "atlas", 
    name: "CementMixer",
  }, 
  {
    id: "atlas:CementSack", 
    tags: ["atlas", "cement", "sack"], 
    source: "atlas", 
    name: "CementSack",
  }, 
  {
    id: "atlas:CementTruck", 
    tags: ["atlas", "cement", "truck"], 
    source: "atlas", 
    name: "CementTruck",
  }, 
  {
    id: "atlas:Chain", 
    tags: ["atlas", "chain"], 
    source: "atlas", 
    name: "Chain",
  }, 
  {
    id: "atlas:ChainLink", 
    tags: ["atlas", "chain", "link"], 
    source: "atlas", 
    name: "ChainLink",
  }, 
  {
    id: "atlas:Chainsaw", 
    tags: ["atlas", "chainsaw"], 
    source: "atlas", 
    name: "Chainsaw",
  }, 
  {
    id: "atlas:ChairDining", 
    tags: ["atlas", "chair", "dining"], 
    source: "atlas", 
    name: "ChairDining",
  }, 
  {
    id: "atlas:Champagne", 
    tags: ["atlas", "champagne"], 
    source: "atlas", 
    name: "Champagne",
  }, 
  {
    id: "atlas:ChargingCable", 
    tags: ["atlas", "charging", "cable"], 
    source: "atlas", 
    name: "ChargingCable",
  }, 
  {
    id: "atlas:ChartPieGraph", 
    tags: ["atlas", "chart", "pie", "graph"], 
    source: "atlas", 
    name: "ChartPieGraph",
  }, 
  {
    id: "atlas:ChartPieGraphCircle", 
    tags: ["atlas", "chart", "pie", "graph", "circle"], 
    source: "atlas", 
    name: "ChartPieGraphCircle",
  }, 
  {
    id: "atlas:ChatConversation", 
    tags: ["atlas", "chat", "conversation"], 
    source: "atlas", 
    name: "ChatConversation",
  }, 
  {
    id: "atlas:ChatDots", 
    tags: ["atlas", "chat", "dots"], 
    source: "atlas", 
    name: "ChatDots",
  }, 
  {
    id: "atlas:ChatLines", 
    tags: ["atlas", "chat", "lines"], 
    source: "atlas", 
    name: "ChatLines",
  }, 
  {
    id: "atlas:Chats", 
    tags: ["atlas", "chats"], 
    source: "atlas", 
    name: "Chats",
  }, 
  {
    id: "atlas:ChatsDots", 
    tags: ["atlas", "chats", "dots"], 
    source: "atlas", 
    name: "ChatsDots",
  }, 
  {
    id: "atlas:ChatsLines", 
    tags: ["atlas", "chats", "lines"], 
    source: "atlas", 
    name: "ChatsLines",
  }, 
  {
    id: "atlas:CheckChat", 
    tags: ["atlas", "check", "chat"], 
    source: "atlas", 
    name: "CheckChat",
  }, 
  {
    id: "atlas:CheckCircle", 
    tags: ["atlas", "check", "circle"], 
    source: "atlas", 
    name: "CheckCircle",
  }, 
  {
    id: "atlas:CheckClipboard", 
    tags: ["atlas", "check", "clipboard"], 
    source: "atlas", 
    name: "CheckClipboard",
  }, 
  {
    id: "atlas:CheckComment", 
    tags: ["atlas", "check", "comment"], 
    source: "atlas", 
    name: "CheckComment",
  }, 
  {
    id: "atlas:CheckFile", 
    tags: ["atlas", "check", "file"], 
    source: "atlas", 
    name: "CheckFile",
  }, 
  {
    id: "atlas:CheckFolder", 
    tags: ["atlas", "check", "folder"], 
    source: "atlas", 
    name: "CheckFolder",
  }, 
  {
    id: "atlas:CheckListFile", 
    tags: ["atlas", "check", "list", "file"], 
    source: "atlas", 
    name: "CheckListFile",
  }, 
  {
    id: "atlas:CheckMessage", 
    tags: ["atlas", "check", "message"], 
    source: "atlas", 
    name: "CheckMessage",
  }, 
  {
    id: "atlas:CheckMessages", 
    tags: ["atlas", "check", "messages"], 
    source: "atlas", 
    name: "CheckMessages",
  }, 
  {
    id: "atlas:CheckPadlock", 
    tags: ["atlas", "check", "padlock"], 
    source: "atlas", 
    name: "CheckPadlock",
  }, 
  {
    id: "atlas:CheckPapertray", 
    tags: ["atlas", "check", "papertray"], 
    source: "atlas", 
    name: "CheckPapertray",
  }, 
  {
    id: "atlas:CheckShield", 
    tags: ["atlas", "check", "shield"], 
    source: "atlas", 
    name: "CheckShield",
  }, 
  {
    id: "atlas:CheckTicket", 
    tags: ["atlas", "check", "ticket"], 
    source: "atlas", 
    name: "CheckTicket",
  }, 
  {
    id: "atlas:CheckWebsite", 
    tags: ["atlas", "check", "website"], 
    source: "atlas", 
    name: "CheckWebsite",
  }, 
  {
    id: "atlas:CheckmarkGroupPeople", 
    tags: ["atlas", "checkmark", "group", "people"], 
    source: "atlas", 
    name: "CheckmarkGroupPeople",
  }, 
  {
    id: "atlas:CheckmarkHandshake", 
    tags: ["atlas", "checkmark", "handshake"], 
    source: "atlas", 
    name: "CheckmarkHandshake",
  }, 
  {
    id: "atlas:CheckmarkMeeting", 
    tags: ["atlas", "checkmark", "meeting"], 
    source: "atlas", 
    name: "CheckmarkMeeting",
  }, 
  {
    id: "atlas:Cheese", 
    tags: ["atlas", "cheese"], 
    source: "atlas", 
    name: "Cheese",
  }, 
  {
    id: "atlas:ChemicalContainer", 
    tags: ["atlas", "chemical", "container"], 
    source: "atlas", 
    name: "ChemicalContainer",
  }, 
  {
    id: "atlas:ChemicalLab", 
    tags: ["atlas", "chemical", "lab"], 
    source: "atlas", 
    name: "ChemicalLab",
  }, 
  {
    id: "atlas:ChemicalTestTube", 
    tags: ["atlas", "chemical", "test", "tube"], 
    source: "atlas", 
    name: "ChemicalTestTube",
  }, 
  {
    id: "atlas:ChemicalTube", 
    tags: ["atlas", "chemical", "tube"], 
    source: "atlas", 
    name: "ChemicalTube",
  }, 
  {
    id: "atlas:Cheque", 
    tags: ["atlas", "cheque"], 
    source: "atlas", 
    name: "Cheque",
  }, 
  {
    id: "atlas:ChessPiece", 
    tags: ["atlas", "chess", "piece"], 
    source: "atlas", 
    name: "ChessPiece",
  }, 
  {
    id: "atlas:ChessPieceTower", 
    tags: ["atlas", "chess", "piece", "tower"], 
    source: "atlas", 
    name: "ChessPieceTower",
  }, 
  {
    id: "atlas:ChickenLeg", 
    tags: ["atlas", "chicken", "leg"], 
    source: "atlas", 
    name: "ChickenLeg",
  }, 
  {
    id: "atlas:Chimney", 
    tags: ["atlas", "chimney"], 
    source: "atlas", 
    name: "Chimney",
  }, 
  {
    id: "atlas:ChipComputer", 
    tags: ["atlas", "chip", "computer"], 
    source: "atlas", 
    name: "ChipComputer",
  }, 
  {
    id: "atlas:ChipMemory", 
    tags: ["atlas", "chip", "memory"], 
    source: "atlas", 
    name: "ChipMemory",
  }, 
  {
    id: "atlas:Chocolate", 
    tags: ["atlas", "chocolate"], 
    source: "atlas", 
    name: "Chocolate",
  }, 
  {
    id: "atlas:Chopper", 
    tags: ["atlas", "chopper"], 
    source: "atlas", 
    name: "Chopper",
  }, 
  {
    id: "atlas:ChristmasCard", 
    tags: ["atlas", "christmas", "card"], 
    source: "atlas", 
    name: "ChristmasCard",
  }, 
  {
    id: "atlas:ChristmasTree", 
    tags: ["atlas", "christmas", "tree"], 
    source: "atlas", 
    name: "ChristmasTree",
  }, 
  {
    id: "atlas:Church", 
    tags: ["atlas", "church"], 
    source: "atlas", 
    name: "Church",
  }, 
  {
    id: "atlas:ChurchBuilding", 
    tags: ["atlas", "church", "building"], 
    source: "atlas", 
    name: "ChurchBuilding",
  }, 
  {
    id: "atlas:ChurchLandmark", 
    tags: ["atlas", "church", "landmark"], 
    source: "atlas", 
    name: "ChurchLandmark",
  }, 
  {
    id: "atlas:ChurchReligion", 
    tags: ["atlas", "church", "religion"], 
    source: "atlas", 
    name: "ChurchReligion",
  }, 
  {
    id: "atlas:Cinema", 
    tags: ["atlas", "cinema"], 
    source: "atlas", 
    name: "Cinema",
  }, 
  {
    id: "atlas:CinemaChair", 
    tags: ["atlas", "cinema", "chair"], 
    source: "atlas", 
    name: "CinemaChair",
  }, 
  {
    id: "atlas:CircleArrowDown", 
    tags: ["atlas", "circle", "arrow", "down"], 
    source: "atlas", 
    name: "CircleArrowDown",
  }, 
  {
    id: "atlas:CircleArrowDownLeft", 
    tags: ["atlas", "circle", "arrow", "down", "left"], 
    source: "atlas", 
    name: "CircleArrowDownLeft",
  }, 
  {
    id: "atlas:CircleArrowDownRight", 
    tags: ["atlas", "circle", "arrow", "down", "right"], 
    source: "atlas", 
    name: "CircleArrowDownRight",
  }, 
  {
    id: "atlas:CircleArrowLeft", 
    tags: ["atlas", "circle", "arrow", "left"], 
    source: "atlas", 
    name: "CircleArrowLeft",
  }, 
  {
    id: "atlas:CircleArrowRight", 
    tags: ["atlas", "circle", "arrow", "right"], 
    source: "atlas", 
    name: "CircleArrowRight",
  }, 
  {
    id: "atlas:CircleArrowUp", 
    tags: ["atlas", "circle", "arrow", "up"], 
    source: "atlas", 
    name: "CircleArrowUp",
  }, 
  {
    id: "atlas:CircleArrowUpLeft", 
    tags: ["atlas", "circle", "arrow", "up", "left"], 
    source: "atlas", 
    name: "CircleArrowUpLeft",
  }, 
  {
    id: "atlas:CircleArrowUpRight", 
    tags: ["atlas", "circle", "arrow", "up", "right"], 
    source: "atlas", 
    name: "CircleArrowUpRight",
  }, 
  {
    id: "atlas:CircleArrowsLeftRight", 
    tags: ["atlas", "circle", "arrows", "left", "right"], 
    source: "atlas", 
    name: "CircleArrowsLeftRight",
  }, 
  {
    id: "atlas:CircleGroupPeople", 
    tags: ["atlas", "circle", "group", "people"], 
    source: "atlas", 
    name: "CircleGroupPeople",
  }, 
  {
    id: "atlas:CircleNetworkAccount", 
    tags: ["atlas", "circle", "network", "account"], 
    source: "atlas", 
    name: "CircleNetworkAccount",
  }, 
  {
    id: "atlas:CirclePieChart", 
    tags: ["atlas", "circle", "pie", "chart"], 
    source: "atlas", 
    name: "CirclePieChart",
  }, 
  {
    id: "atlas:CirclesOverlap", 
    tags: ["atlas", "circles", "overlap"], 
    source: "atlas", 
    name: "CirclesOverlap",
  }, 
  {
    id: "atlas:Clamp", 
    tags: ["atlas", "clamp"], 
    source: "atlas", 
    name: "Clamp",
  }, 
  {
    id: "atlas:Click", 
    tags: ["atlas", "click"], 
    source: "atlas", 
    name: "Click",
  }, 
  {
    id: "atlas:ClickBait", 
    tags: ["atlas", "click", "bait"], 
    source: "atlas", 
    name: "ClickBait",
  }, 
  {
    id: "atlas:ClickSelect", 
    tags: ["atlas", "click", "select"], 
    source: "atlas", 
    name: "ClickSelect",
  }, 
  {
    id: "atlas:ClickbaitWindow", 
    tags: ["atlas", "clickbait", "window"], 
    source: "atlas", 
    name: "ClickbaitWindow",
  }, 
  {
    id: "atlas:ClimbStairsUser", 
    tags: ["atlas", "climb", "stairs", "user"], 
    source: "atlas", 
    name: "ClimbStairsUser",
  }, 
  {
    id: "atlas:ClimbingBars", 
    tags: ["atlas", "climbing", "bars"], 
    source: "atlas", 
    name: "ClimbingBars",
  }, 
  {
    id: "atlas:Clip", 
    tags: ["atlas", "clip"], 
    source: "atlas", 
    name: "Clip",
  }, 
  {
    id: "atlas:Clipboard", 
    tags: ["atlas", "clipboard"], 
    source: "atlas", 
    name: "Clipboard",
  }, 
  {
    id: "atlas:ClipboardImage", 
    tags: ["atlas", "clipboard", "image"], 
    source: "atlas", 
    name: "ClipboardImage",
  }, 
  {
    id: "atlas:ClipboardInfo", 
    tags: ["atlas", "clipboard", "info"], 
    source: "atlas", 
    name: "ClipboardInfo",
  }, 
  {
    id: "atlas:ClipboardLineChart", 
    tags: ["atlas", "clipboard", "line", "chart"], 
    source: "atlas", 
    name: "ClipboardLineChart",
  }, 
  {
    id: "atlas:ClipboardLinesDocument", 
    tags: ["atlas", "clipboard", "lines", "document"], 
    source: "atlas", 
    name: "ClipboardLinesDocument",
  }, 
  {
    id: "atlas:ClipboardRefresh", 
    tags: ["atlas", "clipboard", "refresh"], 
    source: "atlas", 
    name: "ClipboardRefresh",
  }, 
  {
    id: "atlas:ClipboardSearch", 
    tags: ["atlas", "clipboard", "search"], 
    source: "atlas", 
    name: "ClipboardSearch",
  }, 
  {
    id: "atlas:ClipboardSettings", 
    tags: ["atlas", "clipboard", "settings"], 
    source: "atlas", 
    name: "ClipboardSettings",
  }, 
  {
    id: "atlas:ClipboardShare", 
    tags: ["atlas", "clipboard", "share"], 
    source: "atlas", 
    name: "ClipboardShare",
  }, 
  {
    id: "atlas:ClipboardShield", 
    tags: ["atlas", "clipboard", "shield"], 
    source: "atlas", 
    name: "ClipboardShield",
  }, 
  {
    id: "atlas:ClipboardSound", 
    tags: ["atlas", "clipboard", "sound"], 
    source: "atlas", 
    name: "ClipboardSound",
  }, 
  {
    id: "atlas:ClipboardTestTube", 
    tags: ["atlas", "clipboard", "test", "tube"], 
    source: "atlas", 
    name: "ClipboardTestTube",
  }, 
  {
    id: "atlas:ClipboardVideo", 
    tags: ["atlas", "clipboard", "video"], 
    source: "atlas", 
    name: "ClipboardVideo",
  }, 
  {
    id: "atlas:Clipchart", 
    tags: ["atlas", "clipchart"], 
    source: "atlas", 
    name: "Clipchart",
  }, 
  {
    id: "atlas:Cloche", 
    tags: ["atlas", "cloche"], 
    source: "atlas", 
    name: "Cloche",
  }, 
  {
    id: "atlas:ClocheCover", 
    tags: ["atlas", "cloche", "cover"], 
    source: "atlas", 
    name: "ClocheCover",
  }, 
  {
    id: "atlas:ClocheFoodCover", 
    tags: ["atlas", "cloche", "food", "cover"], 
    source: "atlas", 
    name: "ClocheFoodCover",
  }, 
  {
    id: "atlas:ClocheFoodMeal", 
    tags: ["atlas", "cloche", "food", "meal"], 
    source: "atlas", 
    name: "ClocheFoodMeal",
  }, 
  {
    id: "atlas:Clock", 
    tags: ["atlas", "clock"], 
    source: "atlas", 
    name: "Clock",
  }, 
  {
    id: "atlas:ClockTime", 
    tags: ["atlas", "clock", "time"], 
    source: "atlas", 
    name: "ClockTime",
  }, 
  {
    id: "atlas:ClosedBottle", 
    tags: ["atlas", "closed", "bottle"], 
    source: "atlas", 
    name: "ClosedBottle",
  }, 
  {
    id: "atlas:ClosedTestTube", 
    tags: ["atlas", "closed", "test", "tube"], 
    source: "atlas", 
    name: "ClosedTestTube",
  }, 
  {
    id: "atlas:Closet", 
    tags: ["atlas", "closet"], 
    source: "atlas", 
    name: "Closet",
  }, 
  {
    id: "atlas:Closets", 
    tags: ["atlas", "closets"], 
    source: "atlas", 
    name: "Closets",
  }, 
  {
    id: "atlas:ClothingHanger", 
    tags: ["atlas", "clothing", "hanger"], 
    source: "atlas", 
    name: "ClothingHanger",
  }, 
  {
    id: "atlas:Cloud", 
    tags: ["atlas", "cloud"], 
    source: "atlas", 
    name: "Cloud",
  }, 
  {
    id: "atlas:CloudArrows", 
    tags: ["atlas", "cloud", "arrows"], 
    source: "atlas", 
    name: "CloudArrows",
  }, 
  {
    id: "atlas:CloudBlock", 
    tags: ["atlas", "cloud", "block"], 
    source: "atlas", 
    name: "CloudBlock",
  }, 
  {
    id: "atlas:CloudDatabase", 
    tags: ["atlas", "cloud", "database"], 
    source: "atlas", 
    name: "CloudDatabase",
  }, 
  {
    id: "atlas:CloudFolder", 
    tags: ["atlas", "cloud", "folder"], 
    source: "atlas", 
    name: "CloudFolder",
  }, 
  {
    id: "atlas:CloudLock", 
    tags: ["atlas", "cloud", "lock"], 
    source: "atlas", 
    name: "CloudLock",
  }, 
  {
    id: "atlas:CloudNetwork", 
    tags: ["atlas", "cloud", "network"], 
    source: "atlas", 
    name: "CloudNetwork",
  }, 
  {
    id: "atlas:CloudSettings", 
    tags: ["atlas", "cloud", "settings"], 
    source: "atlas", 
    name: "CloudSettings",
  }, 
  {
    id: "atlas:CloudTransfer", 
    tags: ["atlas", "cloud", "transfer"], 
    source: "atlas", 
    name: "CloudTransfer",
  }, 
  {
    id: "atlas:Clouds", 
    tags: ["atlas", "clouds"], 
    source: "atlas", 
    name: "Clouds",
  }, 
  {
    id: "atlas:Cloudy", 
    tags: ["atlas", "cloudy"], 
    source: "atlas", 
    name: "Cloudy",
  }, 
  {
    id: "atlas:CloudyNight", 
    tags: ["atlas", "cloudy", "night"], 
    source: "atlas", 
    name: "CloudyNight",
  }, 
  {
    id: "atlas:CnTower", 
    tags: ["atlas", "cn", "tower"], 
    source: "atlas", 
    name: "CnTower",
  }, 
  {
    id: "atlas:CoconutCocktail", 
    tags: ["atlas", "coconut", "cocktail"], 
    source: "atlas", 
    name: "CoconutCocktail",
  }, 
  {
    id: "atlas:Coding", 
    tags: ["atlas", "coding"], 
    source: "atlas", 
    name: "Coding",
  }, 
  {
    id: "atlas:CodingFile", 
    tags: ["atlas", "coding", "file"], 
    source: "atlas", 
    name: "CodingFile",
  }, 
  {
    id: "atlas:CodingWebsite", 
    tags: ["atlas", "coding", "website"], 
    source: "atlas", 
    name: "CodingWebsite",
  }, 
  {
    id: "atlas:CoffeeDrink", 
    tags: ["atlas", "coffee", "drink"], 
    source: "atlas", 
    name: "CoffeeDrink",
  }, 
  {
    id: "atlas:CoffeeMaker", 
    tags: ["atlas", "coffee", "maker"], 
    source: "atlas", 
    name: "CoffeeMaker",
  }, 
  {
    id: "atlas:CogwheelGroupPeople", 
    tags: ["atlas", "cogwheel", "group", "people"], 
    source: "atlas", 
    name: "CogwheelGroupPeople",
  }, 
  {
    id: "atlas:CogwheelSettingsAccount", 
    tags: ["atlas", "cogwheel", "settings", "account"], 
    source: "atlas", 
    name: "CogwheelSettingsAccount",
  }, 
  {
    id: "atlas:CogwheelSettingsPeople", 
    tags: ["atlas", "cogwheel", "settings", "people"], 
    source: "atlas", 
    name: "CogwheelSettingsPeople",
  }, 
  {
    id: "atlas:CoinExchange", 
    tags: ["atlas", "coin", "exchange"], 
    source: "atlas", 
    name: "CoinExchange",
  }, 
  {
    id: "atlas:CoinPurse", 
    tags: ["atlas", "coin", "purse"], 
    source: "atlas", 
    name: "CoinPurse",
  }, 
  {
    id: "atlas:CoinStack", 
    tags: ["atlas", "coin", "stack"], 
    source: "atlas", 
    name: "CoinStack",
  }, 
  {
    id: "atlas:Coins", 
    tags: ["atlas", "coins"], 
    source: "atlas", 
    name: "Coins",
  }, 
  {
    id: "atlas:ColdSnow", 
    tags: ["atlas", "cold", "snow"], 
    source: "atlas", 
    name: "ColdSnow",
  }, 
  {
    id: "atlas:ColdSnowflake", 
    tags: ["atlas", "cold", "snowflake"], 
    source: "atlas", 
    name: "ColdSnowflake",
  }, 
  {
    id: "atlas:ColdTemperature", 
    tags: ["atlas", "cold", "temperature"], 
    source: "atlas", 
    name: "ColdTemperature",
  }, 
  {
    id: "atlas:ColdTemperatureThermometer", 
    tags: ["atlas", "cold", "temperature", "thermometer"], 
    source: "atlas", 
    name: "ColdTemperatureThermometer",
  }, 
  {
    id: "atlas:ColdWinter", 
    tags: ["atlas", "cold", "winter"], 
    source: "atlas", 
    name: "ColdWinter",
  }, 
  {
    id: "atlas:Color", 
    tags: ["atlas", "color"], 
    source: "atlas", 
    name: "Color",
  }, 
  {
    id: "atlas:ColorSwatches", 
    tags: ["atlas", "color", "swatches"], 
    source: "atlas", 
    name: "ColorSwatches",
  }, 
  {
    id: "atlas:Colosseum", 
    tags: ["atlas", "colosseum"], 
    source: "atlas", 
    name: "Colosseum",
  }, 
  {
    id: "atlas:ColumnLayout", 
    tags: ["atlas", "column", "layout"], 
    source: "atlas", 
    name: "ColumnLayout",
  }, 
  {
    id: "atlas:CombineArrowUp", 
    tags: ["atlas", "combine", "arrow", "up"], 
    source: "atlas", 
    name: "CombineArrowUp",
  }, 
  {
    id: "atlas:Comment", 
    tags: ["atlas", "comment"], 
    source: "atlas", 
    name: "Comment",
  }, 
  {
    id: "atlas:CommentBlank", 
    tags: ["atlas", "comment", "blank"], 
    source: "atlas", 
    name: "CommentBlank",
  }, 
  {
    id: "atlas:CommentCaptions", 
    tags: ["atlas", "comment", "captions"], 
    source: "atlas", 
    name: "CommentCaptions",
  }, 
  {
    id: "atlas:CommentDots", 
    tags: ["atlas", "comment", "dots"], 
    source: "atlas", 
    name: "CommentDots",
  }, 
  {
    id: "atlas:Compass", 
    tags: ["atlas", "compass"], 
    source: "atlas", 
    name: "Compass",
  }, 
  {
    id: "atlas:CompassGeometry", 
    tags: ["atlas", "compass", "geometry"], 
    source: "atlas", 
    name: "CompassGeometry",
  }, 
  {
    id: "atlas:CompassPointers", 
    tags: ["atlas", "compass", "pointers"], 
    source: "atlas", 
    name: "CompassPointers",
  }, 
  {
    id: "atlas:CompassTool", 
    tags: ["atlas", "compass", "tool"], 
    source: "atlas", 
    name: "CompassTool",
  }, 
  {
    id: "atlas:ComputerChip", 
    tags: ["atlas", "computer", "chip"], 
    source: "atlas", 
    name: "ComputerChip",
  }, 
  {
    id: "atlas:ComputerMemory", 
    tags: ["atlas", "computer", "memory"], 
    source: "atlas", 
    name: "ComputerMemory",
  }, 
  {
    id: "atlas:ComputerMonitor", 
    tags: ["atlas", "computer", "monitor"], 
    source: "atlas", 
    name: "ComputerMonitor",
  }, 
  {
    id: "atlas:ComputerScreen", 
    tags: ["atlas", "computer", "screen"], 
    source: "atlas", 
    name: "ComputerScreen",
  }, 
  {
    id: "atlas:Concierge", 
    tags: ["atlas", "concierge"], 
    source: "atlas", 
    name: "Concierge",
  }, 
  {
    id: "atlas:Condom", 
    tags: ["atlas", "condom"], 
    source: "atlas", 
    name: "Condom",
  }, 
  {
    id: "atlas:ConnectedTestTubes", 
    tags: ["atlas", "connected", "test", "tubes"], 
    source: "atlas", 
    name: "ConnectedTestTubes",
  }, 
  {
    id: "atlas:Connection", 
    tags: ["atlas", "connection"], 
    source: "atlas", 
    name: "Connection",
  }, 
  {
    id: "atlas:ConstructionCrane", 
    tags: ["atlas", "construction", "crane"], 
    source: "atlas", 
    name: "ConstructionCrane",
  }, 
  {
    id: "atlas:ConstructionHouse", 
    tags: ["atlas", "construction", "house"], 
    source: "atlas", 
    name: "ConstructionHouse",
  }, 
  {
    id: "atlas:ConstructionSaw", 
    tags: ["atlas", "construction", "saw"], 
    source: "atlas", 
    name: "ConstructionSaw",
  }, 
  {
    id: "atlas:ConstructionTool", 
    tags: ["atlas", "construction", "tool"], 
    source: "atlas", 
    name: "ConstructionTool",
  }, 
  {
    id: "atlas:ConstructionTools", 
    tags: ["atlas", "construction", "tools"], 
    source: "atlas", 
    name: "ConstructionTools",
  }, 
  {
    id: "atlas:ConstructionTransport", 
    tags: ["atlas", "construction", "transport"], 
    source: "atlas", 
    name: "ConstructionTransport",
  }, 
  {
    id: "atlas:ConstructionTruck", 
    tags: ["atlas", "construction", "truck"], 
    source: "atlas", 
    name: "ConstructionTruck",
  }, 
  {
    id: "atlas:ConstructionWorker", 
    tags: ["atlas", "construction", "worker"], 
    source: "atlas", 
    name: "ConstructionWorker",
  }, 
  {
    id: "atlas:ContactMobile", 
    tags: ["atlas", "contact", "mobile"], 
    source: "atlas", 
    name: "ContactMobile",
  }, 
  {
    id: "atlas:Contract", 
    tags: ["atlas", "contract"], 
    source: "atlas", 
    name: "Contract",
  }, 
  {
    id: "atlas:Controller", 
    tags: ["atlas", "controller"], 
    source: "atlas", 
    name: "Controller",
  }, 
  {
    id: "atlas:Conversation", 
    tags: ["atlas", "conversation"], 
    source: "atlas", 
    name: "Conversation",
  }, 
  {
    id: "atlas:ConversationChat", 
    tags: ["atlas", "conversation", "chat"], 
    source: "atlas", 
    name: "ConversationChat",
  }, 
  {
    id: "atlas:Cookie", 
    tags: ["atlas", "cookie"], 
    source: "atlas", 
    name: "Cookie",
  }, 
  {
    id: "atlas:CookingStation", 
    tags: ["atlas", "cooking", "station"], 
    source: "atlas", 
    name: "CookingStation",
  }, 
  {
    id: "atlas:Corn", 
    tags: ["atlas", "corn"], 
    source: "atlas", 
    name: "Corn",
  }, 
  {
    id: "atlas:CornSeeds", 
    tags: ["atlas", "corn", "seeds"], 
    source: "atlas", 
    name: "CornSeeds",
  }, 
  {
    id: "atlas:CornStarch", 
    tags: ["atlas", "corn", "starch"], 
    source: "atlas", 
    name: "CornStarch",
  }, 
  {
    id: "atlas:Cornucopia", 
    tags: ["atlas", "cornucopia"], 
    source: "atlas", 
    name: "Cornucopia",
  }, 
  {
    id: "atlas:Couch", 
    tags: ["atlas", "couch"], 
    source: "atlas", 
    name: "Couch",
  }, 
  {
    id: "atlas:CouchFurniture", 
    tags: ["atlas", "couch", "furniture"], 
    source: "atlas", 
    name: "CouchFurniture",
  }, 
  {
    id: "atlas:Count1", 
    tags: ["atlas", "count"], 
    source: "atlas", 
    name: "Count1",
  }, 
  {
    id: "atlas:CountFinger", 
    tags: ["atlas", "count", "finger"], 
    source: "atlas", 
    name: "CountFinger",
  }, 
  {
    id: "atlas:Countdown2", 
    tags: ["atlas", "countdown"], 
    source: "atlas", 
    name: "Countdown2",
  }, 
  {
    id: "atlas:Countdown3", 
    tags: ["atlas", "countdown"], 
    source: "atlas", 
    name: "Countdown3",
  }, 
  {
    id: "atlas:CowPose", 
    tags: ["atlas", "cow", "pose"], 
    source: "atlas", 
    name: "CowPose",
  }, 
  {
    id: "atlas:Cpu", 
    tags: ["atlas", "cpu"], 
    source: "atlas", 
    name: "Cpu",
  }, 
  {
    id: "atlas:CranePipe", 
    tags: ["atlas", "crane", "pipe"], 
    source: "atlas", 
    name: "CranePipe",
  }, 
  {
    id: "atlas:CranePose", 
    tags: ["atlas", "crane", "pose"], 
    source: "atlas", 
    name: "CranePose",
  }, 
  {
    id: "atlas:CraneTruck", 
    tags: ["atlas", "crane", "truck"], 
    source: "atlas", 
    name: "CraneTruck",
  }, 
  {
    id: "atlas:CrankScrewdriver", 
    tags: ["atlas", "crank", "screwdriver"], 
    source: "atlas", 
    name: "CrankScrewdriver",
  }, 
  {
    id: "atlas:CreditCard", 
    tags: ["atlas", "credit", "card"], 
    source: "atlas", 
    name: "CreditCard",
  }, 
  {
    id: "atlas:CreditCardPadlock", 
    tags: ["atlas", "credit", "card", "padlock"], 
    source: "atlas", 
    name: "CreditCardPadlock",
  }, 
  {
    id: "atlas:CreditCardShield", 
    tags: ["atlas", "credit", "card", "shield"], 
    source: "atlas", 
    name: "CreditCardShield",
  }, 
  {
    id: "atlas:Croissant", 
    tags: ["atlas", "croissant"], 
    source: "atlas", 
    name: "Croissant",
  }, 
  {
    id: "atlas:Crop", 
    tags: ["atlas", "crop"], 
    source: "atlas", 
    name: "Crop",
  }, 
  {
    id: "atlas:CropPathfinder", 
    tags: ["atlas", "crop", "pathfinder"], 
    source: "atlas", 
    name: "CropPathfinder",
  }, 
  {
    id: "atlas:Cross", 
    tags: ["atlas", "cross"], 
    source: "atlas", 
    name: "Cross",
  }, 
  {
    id: "atlas:Crosshairs", 
    tags: ["atlas", "crosshairs"], 
    source: "atlas", 
    name: "Crosshairs",
  }, 
  {
    id: "atlas:CrosshairsTargetDollar", 
    tags: ["atlas", "crosshairs", "target", "dollar"], 
    source: "atlas", 
    name: "CrosshairsTargetDollar",
  }, 
  {
    id: "atlas:CrosshairsTargetStar", 
    tags: ["atlas", "crosshairs", "target", "star"], 
    source: "atlas", 
    name: "CrosshairsTargetStar",
  }, 
  {
    id: "atlas:CrossoverArrows", 
    tags: ["atlas", "crossover", "arrows"], 
    source: "atlas", 
    name: "CrossoverArrows",
  }, 
  {
    id: "atlas:Crosswinds", 
    tags: ["atlas", "crosswinds"], 
    source: "atlas", 
    name: "Crosswinds",
  }, 
  {
    id: "atlas:CrownAchievement", 
    tags: ["atlas", "crown", "achievement"], 
    source: "atlas", 
    name: "CrownAchievement",
  }, 
  {
    id: "atlas:CrownWinner", 
    tags: ["atlas", "crown", "winner"], 
    source: "atlas", 
    name: "CrownWinner",
  }, 
  {
    id: "atlas:CruiseShip", 
    tags: ["atlas", "cruise", "ship"], 
    source: "atlas", 
    name: "CruiseShip",
  }, 
  {
    id: "atlas:Crutches", 
    tags: ["atlas", "crutches"], 
    source: "atlas", 
    name: "Crutches",
  }, 
  {
    id: "atlas:CubeBox3D", 
    tags: ["atlas", "cube", "box"], 
    source: "atlas", 
    name: "CubeBox3D",
  }, 
  {
    id: "atlas:CupMeasurement", 
    tags: ["atlas", "cup", "measurement"], 
    source: "atlas", 
    name: "CupMeasurement",
  }, 
  {
    id: "atlas:CupStraw", 
    tags: ["atlas", "cup", "straw"], 
    source: "atlas", 
    name: "CupStraw",
  }, 
  {
    id: "atlas:Cupboard", 
    tags: ["atlas", "cupboard"], 
    source: "atlas", 
    name: "Cupboard",
  }, 
  {
    id: "atlas:CupboardDrawers", 
    tags: ["atlas", "cupboard", "drawers"], 
    source: "atlas", 
    name: "CupboardDrawers",
  }, 
  {
    id: "atlas:CupboardTwoDoors", 
    tags: ["atlas", "cupboard", "two", "doors"], 
    source: "atlas", 
    name: "CupboardTwoDoors",
  }, 
  {
    id: "atlas:Cupcake", 
    tags: ["atlas", "cupcake"], 
    source: "atlas", 
    name: "Cupcake",
  }, 
  {
    id: "atlas:CupcakePastry", 
    tags: ["atlas", "cupcake", "pastry"], 
    source: "atlas", 
    name: "CupcakePastry",
  }, 
  {
    id: "atlas:CurrencyExchange", 
    tags: ["atlas", "currency", "exchange"], 
    source: "atlas", 
    name: "CurrencyExchange",
  }, 
  {
    id: "atlas:CurveArrowDown", 
    tags: ["atlas", "curve", "arrow", "down"], 
    source: "atlas", 
    name: "CurveArrowDown",
  }, 
  {
    id: "atlas:CurveArrowLeft", 
    tags: ["atlas", "curve", "arrow", "left"], 
    source: "atlas", 
    name: "CurveArrowLeft",
  }, 
  {
    id: "atlas:CurveArrowRight", 
    tags: ["atlas", "curve", "arrow", "right"], 
    source: "atlas", 
    name: "CurveArrowRight",
  }, 
  {
    id: "atlas:CurveArrowUp", 
    tags: ["atlas", "curve", "arrow", "up"], 
    source: "atlas", 
    name: "CurveArrowUp",
  }, 
  {
    id: "atlas:CurveArrowsMeet", 
    tags: ["atlas", "curve", "arrows", "meet"], 
    source: "atlas", 
    name: "CurveArrowsMeet",
  }, 
  {
    id: "atlas:CurveDoubleArrowDown", 
    tags: ["atlas", "curve", "double", "arrow", "down"], 
    source: "atlas", 
    name: "CurveDoubleArrowDown",
  }, 
  {
    id: "atlas:CurveDoubleArrowLeft", 
    tags: ["atlas", "curve", "double", "arrow", "left"], 
    source: "atlas", 
    name: "CurveDoubleArrowLeft",
  }, 
  {
    id: "atlas:CurveDoubleArrowRight", 
    tags: ["atlas", "curve", "double", "arrow", "right"], 
    source: "atlas", 
    name: "CurveDoubleArrowRight",
  }, 
  {
    id: "atlas:CurveDoubleArrowUp", 
    tags: ["atlas", "curve", "double", "arrow", "up"], 
    source: "atlas", 
    name: "CurveDoubleArrowUp",
  }, 
  {
    id: "atlas:CurveLeftArrowUp", 
    tags: ["atlas", "curve", "left", "arrow", "up"], 
    source: "atlas", 
    name: "CurveLeftArrowUp",
  }, 
  {
    id: "atlas:CurveRightArrowUp", 
    tags: ["atlas", "curve", "right", "arrow", "up"], 
    source: "atlas", 
    name: "CurveRightArrowUp",
  }, 
  {
    id: "atlas:Curved2D", 
    tags: ["atlas", "curved"], 
    source: "atlas", 
    name: "Curved2D",
  }, 
  {
    id: "atlas:Curved3D", 
    tags: ["atlas", "curved"], 
    source: "atlas", 
    name: "Curved3D",
  }, 
  {
    id: "atlas:Curved4D", 
    tags: ["atlas", "curved"], 
    source: "atlas", 
    name: "Curved4D",
  }, 
  {
    id: "atlas:Curved4K", 
    tags: ["atlas", "curved"], 
    source: "atlas", 
    name: "Curved4K",
  }, 
  {
    id: "atlas:CurvedHd", 
    tags: ["atlas", "curved", "hd"], 
    source: "atlas", 
    name: "CurvedHd",
  }, 
  {
    id: "atlas:CurvedTestTube", 
    tags: ["atlas", "curved", "test", "tube"], 
    source: "atlas", 
    name: "CurvedTestTube",
  }, 
  {
    id: "atlas:CurvedTv", 
    tags: ["atlas", "curved", "tv"], 
    source: "atlas", 
    name: "CurvedTv",
  }, 
  {
    id: "atlas:CurvingArrowsDown", 
    tags: ["atlas", "curving", "arrows", "down"], 
    source: "atlas", 
    name: "CurvingArrowsDown",
  }, 
  {
    id: "atlas:CurvingArrowsLeft", 
    tags: ["atlas", "curving", "arrows", "left"], 
    source: "atlas", 
    name: "CurvingArrowsLeft",
  }, 
  {
    id: "atlas:CurvingArrowsRight", 
    tags: ["atlas", "curving", "arrows", "right"], 
    source: "atlas", 
    name: "CurvingArrowsRight",
  }, 
  {
    id: "atlas:CurvingArrowsUp", 
    tags: ["atlas", "curving", "arrows", "up"], 
    source: "atlas", 
    name: "CurvingArrowsUp",
  }, 
  {
    id: "atlas:CustomerService", 
    tags: ["atlas", "customer", "service"], 
    source: "atlas", 
    name: "CustomerService",
  }, 
  {
    id: "atlas:CustomerServiceAgent", 
    tags: ["atlas", "customer", "service", "agent"], 
    source: "atlas", 
    name: "CustomerServiceAgent",
  }, 
  {
    id: "atlas:CutFilm", 
    tags: ["atlas", "cut", "film"], 
    source: "atlas", 
    name: "CutFilm",
  }, 
  {
    id: "atlas:Cycling", 
    tags: ["atlas", "cycling"], 
    source: "atlas", 
    name: "Cycling",
  }, 
  {
    id: "atlas:Danger", 
    tags: ["atlas", "danger"], 
    source: "atlas", 
    name: "Danger",
  }, 
  {
    id: "atlas:Dart", 
    tags: ["atlas", "dart"], 
    source: "atlas", 
    name: "Dart",
  }, 
  {
    id: "atlas:DashCloud", 
    tags: ["atlas", "dash", "cloud"], 
    source: "atlas", 
    name: "DashCloud",
  }, 
  {
    id: "atlas:DashboardPerformance", 
    tags: ["atlas", "dashboard", "performance"], 
    source: "atlas", 
    name: "DashboardPerformance",
  }, 
  {
    id: "atlas:DayCloudy", 
    tags: ["atlas", "day", "cloudy"], 
    source: "atlas", 
    name: "DayCloudy",
  }, 
  {
    id: "atlas:DecreaseArrowDown", 
    tags: ["atlas", "decrease", "arrow", "down"], 
    source: "atlas", 
    name: "DecreaseArrowDown",
  }, 
  {
    id: "atlas:Deed", 
    tags: ["atlas", "deed"], 
    source: "atlas", 
    name: "Deed",
  }, 
  {
    id: "atlas:Deer", 
    tags: ["atlas", "deer"], 
    source: "atlas", 
    name: "Deer",
  }, 
  {
    id: "atlas:DeliveryTruck", 
    tags: ["atlas", "delivery", "truck"], 
    source: "atlas", 
    name: "DeliveryTruck",
  }, 
  {
    id: "atlas:DentalPlus", 
    tags: ["atlas", "dental", "plus"], 
    source: "atlas", 
    name: "DentalPlus",
  }, 
  {
    id: "atlas:Desk", 
    tags: ["atlas", "desk"], 
    source: "atlas", 
    name: "Desk",
  }, 
  {
    id: "atlas:DeskLamp", 
    tags: ["atlas", "desk", "lamp"], 
    source: "atlas", 
    name: "DeskLamp",
  }, 
  {
    id: "atlas:DeskLampLight", 
    tags: ["atlas", "desk", "lamp", "light"], 
    source: "atlas", 
    name: "DeskLampLight",
  }, 
  {
    id: "atlas:DesktopComputer2D", 
    tags: ["atlas", "desktop", "computer"], 
    source: "atlas", 
    name: "DesktopComputer2D",
  }, 
  {
    id: "atlas:DesktopComputer3D", 
    tags: ["atlas", "desktop", "computer"], 
    source: "atlas", 
    name: "DesktopComputer3D",
  }, 
  {
    id: "atlas:DesktopComputer4D", 
    tags: ["atlas", "desktop", "computer"], 
    source: "atlas", 
    name: "DesktopComputer4D",
  }, 
  {
    id: "atlas:DesktopComputer4K", 
    tags: ["atlas", "desktop", "computer"], 
    source: "atlas", 
    name: "DesktopComputer4K",
  }, 
  {
    id: "atlas:Dessert", 
    tags: ["atlas", "dessert"], 
    source: "atlas", 
    name: "Dessert",
  }, 
  {
    id: "atlas:DestinationRoute", 
    tags: ["atlas", "destination", "route"], 
    source: "atlas", 
    name: "DestinationRoute",
  }, 
  {
    id: "atlas:DevilHeart", 
    tags: ["atlas", "devil", "heart"], 
    source: "atlas", 
    name: "DevilHeart",
  }, 
  {
    id: "atlas:Diagram", 
    tags: ["atlas", "diagram"], 
    source: "atlas", 
    name: "Diagram",
  }, 
  {
    id: "atlas:Dial", 
    tags: ["atlas", "dial"], 
    source: "atlas", 
    name: "Dial",
  }, 
  {
    id: "atlas:DialLow", 
    tags: ["atlas", "dial", "low"], 
    source: "atlas", 
    name: "DialLow",
  }, 
  {
    id: "atlas:DiamondBanner", 
    tags: ["atlas", "diamond", "banner"], 
    source: "atlas", 
    name: "DiamondBanner",
  }, 
  {
    id: "atlas:DiamondRing", 
    tags: ["atlas", "diamond", "ring"], 
    source: "atlas", 
    name: "DiamondRing",
  }, 
  {
    id: "atlas:DietCalendar", 
    tags: ["atlas", "diet", "calendar"], 
    source: "atlas", 
    name: "DietCalendar",
  }, 
  {
    id: "atlas:DigitalThermometer", 
    tags: ["atlas", "digital", "thermometer"], 
    source: "atlas", 
    name: "DigitalThermometer",
  }, 
  {
    id: "atlas:DimensionSquare", 
    tags: ["atlas", "dimension", "square"], 
    source: "atlas", 
    name: "DimensionSquare",
  }, 
  {
    id: "atlas:DimensionalPerson", 
    tags: ["atlas", "dimensional", "person"], 
    source: "atlas", 
    name: "DimensionalPerson",
  }, 
  {
    id: "atlas:DimensionalView", 
    tags: ["atlas", "dimensional", "view"], 
    source: "atlas", 
    name: "DimensionalView",
  }, 
  {
    id: "atlas:DimensionalVr", 
    tags: ["atlas", "dimensional", "vr"], 
    source: "atlas", 
    name: "DimensionalVr",
  }, 
  {
    id: "atlas:DiningChair", 
    tags: ["atlas", "dining", "chair"], 
    source: "atlas", 
    name: "DiningChair",
  }, 
  {
    id: "atlas:DiningRoom", 
    tags: ["atlas", "dining", "room"], 
    source: "atlas", 
    name: "DiningRoom",
  }, 
  {
    id: "atlas:DiningRoomChair", 
    tags: ["atlas", "dining", "room", "chair"], 
    source: "atlas", 
    name: "DiningRoomChair",
  }, 
  {
    id: "atlas:DiningRoomTable", 
    tags: ["atlas", "dining", "room", "table"], 
    source: "atlas", 
    name: "DiningRoomTable",
  }, 
  {
    id: "atlas:DiningTable", 
    tags: ["atlas", "dining", "table"], 
    source: "atlas", 
    name: "DiningTable",
  }, 
  {
    id: "atlas:DiningTablePlates", 
    tags: ["atlas", "dining", "table", "plates"], 
    source: "atlas", 
    name: "DiningTablePlates",
  }, 
  {
    id: "atlas:DiplomaCertificate", 
    tags: ["atlas", "diploma", "certificate"], 
    source: "atlas", 
    name: "DiplomaCertificate",
  }, 
  {
    id: "atlas:DirectionPost", 
    tags: ["atlas", "direction", "post"], 
    source: "atlas", 
    name: "DirectionPost",
  }, 
  {
    id: "atlas:DirectionsPost", 
    tags: ["atlas", "directions", "post"], 
    source: "atlas", 
    name: "DirectionsPost",
  }, 
  {
    id: "atlas:DiscountTag", 
    tags: ["atlas", "discount", "tag"], 
    source: "atlas", 
    name: "DiscountTag",
  }, 
  {
    id: "atlas:DiskReader", 
    tags: ["atlas", "disk", "reader"], 
    source: "atlas", 
    name: "DiskReader",
  }, 
  {
    id: "atlas:Dna", 
    tags: ["atlas", "dna"], 
    source: "atlas", 
    name: "Dna",
  }, 
  {
    id: "atlas:DnaGenetics", 
    tags: ["atlas", "dna", "genetics"], 
    source: "atlas", 
    name: "DnaGenetics",
  }, 
  {
    id: "atlas:DnaScience", 
    tags: ["atlas", "dna", "science"], 
    source: "atlas", 
    name: "DnaScience",
  }, 
  {
    id: "atlas:Document", 
    tags: ["atlas", "document"], 
    source: "atlas", 
    name: "Document",
  }, 
  {
    id: "atlas:Documents", 
    tags: ["atlas", "documents"], 
    source: "atlas", 
    name: "Documents",
  }, 
  {
    id: "atlas:DollarBill", 
    tags: ["atlas", "dollar", "bill"], 
    source: "atlas", 
    name: "DollarBill",
  }, 
  {
    id: "atlas:DollarChat", 
    tags: ["atlas", "dollar", "chat"], 
    source: "atlas", 
    name: "DollarChat",
  }, 
  {
    id: "atlas:DollarClipboard", 
    tags: ["atlas", "dollar", "clipboard"], 
    source: "atlas", 
    name: "DollarClipboard",
  }, 
  {
    id: "atlas:DollarClipboardFile", 
    tags: ["atlas", "dollar", "clipboard", "file"], 
    source: "atlas", 
    name: "DollarClipboardFile",
  }, 
  {
    id: "atlas:DollarFile", 
    tags: ["atlas", "dollar", "file"], 
    source: "atlas", 
    name: "DollarFile",
  }, 
  {
    id: "atlas:DollarFolder", 
    tags: ["atlas", "dollar", "folder"], 
    source: "atlas", 
    name: "DollarFolder",
  }, 
  {
    id: "atlas:DollarHandshake", 
    tags: ["atlas", "dollar", "handshake"], 
    source: "atlas", 
    name: "DollarHandshake",
  }, 
  {
    id: "atlas:DollarMeeting", 
    tags: ["atlas", "dollar", "meeting"], 
    source: "atlas", 
    name: "DollarMeeting",
  }, 
  {
    id: "atlas:DollarMessage", 
    tags: ["atlas", "dollar", "message"], 
    source: "atlas", 
    name: "DollarMessage",
  }, 
  {
    id: "atlas:DollarMonitor", 
    tags: ["atlas", "dollar", "monitor"], 
    source: "atlas", 
    name: "DollarMonitor",
  }, 
  {
    id: "atlas:DollarPaper", 
    tags: ["atlas", "dollar", "paper"], 
    source: "atlas", 
    name: "DollarPaper",
  }, 
  {
    id: "atlas:DollarSign", 
    tags: ["atlas", "dollar", "sign"], 
    source: "atlas", 
    name: "DollarSign",
  }, 
  {
    id: "atlas:DollarSignCircle", 
    tags: ["atlas", "dollar", "sign", "circle"], 
    source: "atlas", 
    name: "DollarSignCircle",
  }, 
  {
    id: "atlas:DollarSignMoney", 
    tags: ["atlas", "dollar", "sign", "money"], 
    source: "atlas", 
    name: "DollarSignMoney",
  }, 
  {
    id: "atlas:DollarSuitcase", 
    tags: ["atlas", "dollar", "suitcase"], 
    source: "atlas", 
    name: "DollarSuitcase",
  }, 
  {
    id: "atlas:DollarTransferAccount", 
    tags: ["atlas", "dollar", "transfer", "account"], 
    source: "atlas", 
    name: "DollarTransferAccount",
  }, 
  {
    id: "atlas:Donut", 
    tags: ["atlas", "donut"], 
    source: "atlas", 
    name: "Donut",
  }, 
  {
    id: "atlas:Door", 
    tags: ["atlas", "door"], 
    source: "atlas", 
    name: "Door",
  }, 
  {
    id: "atlas:DoorLock", 
    tags: ["atlas", "door", "lock"], 
    source: "atlas", 
    name: "DoorLock",
  }, 
  {
    id: "atlas:DotArrowLeftRight", 
    tags: ["atlas", "dot", "arrow", "left", "right"], 
    source: "atlas", 
    name: "DotArrowLeftRight",
  }, 
  {
    id: "atlas:DotArrowUpDown", 
    tags: ["atlas", "dot", "arrow", "up", "down"], 
    source: "atlas", 
    name: "DotArrowUpDown",
  }, 
  {
    id: "atlas:DotsArrowRotate", 
    tags: ["atlas", "dots", "arrow", "rotate"], 
    source: "atlas", 
    name: "DotsArrowRotate",
  }, 
  {
    id: "atlas:DotsClipboard", 
    tags: ["atlas", "dots", "clipboard"], 
    source: "atlas", 
    name: "DotsClipboard",
  }, 
  {
    id: "atlas:DotsComment", 
    tags: ["atlas", "dots", "comment"], 
    source: "atlas", 
    name: "DotsComment",
  }, 
  {
    id: "atlas:DotsFile", 
    tags: ["atlas", "dots", "file"], 
    source: "atlas", 
    name: "DotsFile",
  }, 
  {
    id: "atlas:DotsFolder", 
    tags: ["atlas", "dots", "folder"], 
    source: "atlas", 
    name: "DotsFolder",
  }, 
  {
    id: "atlas:DotsHorizontal", 
    tags: ["atlas", "dots", "horizontal"], 
    source: "atlas", 
    name: "DotsHorizontal",
  }, 
  {
    id: "atlas:DotsVertical", 
    tags: ["atlas", "dots", "vertical"], 
    source: "atlas", 
    name: "DotsVertical",
  }, 
  {
    id: "atlas:DoubleArrowDown", 
    tags: ["atlas", "double", "arrow", "down"], 
    source: "atlas", 
    name: "DoubleArrowDown",
  }, 
  {
    id: "atlas:DoubleArrowDownCircle", 
    tags: ["atlas", "double", "arrow", "down", "circle"], 
    source: "atlas", 
    name: "DoubleArrowDownCircle",
  }, 
  {
    id: "atlas:DoubleArrowDownLeft", 
    tags: ["atlas", "double", "arrow", "down", "left"], 
    source: "atlas", 
    name: "DoubleArrowDownLeft",
  }, 
  {
    id: "atlas:DoubleArrowDownLeftCircle", 
    tags: ["atlas", "double", "arrow", "down", "left", "circle"], 
    source: "atlas", 
    name: "DoubleArrowDownLeftCircle",
  }, 
  {
    id: "atlas:DoubleArrowDownLine", 
    tags: ["atlas", "double", "arrow", "down", "line"], 
    source: "atlas", 
    name: "DoubleArrowDownLine",
  }, 
  {
    id: "atlas:DoubleArrowDownRight", 
    tags: ["atlas", "double", "arrow", "down", "right"], 
    source: "atlas", 
    name: "DoubleArrowDownRight",
  }, 
  {
    id: "atlas:DoubleArrowDownRightCircle", 
    tags: ["atlas", "double", "arrow", "down", "right", "circle"], 
    source: "atlas", 
    name: "DoubleArrowDownRightCircle",
  }, 
  {
    id: "atlas:DoubleArrowLeft", 
    tags: ["atlas", "double", "arrow", "left"], 
    source: "atlas", 
    name: "DoubleArrowLeft",
  }, 
  {
    id: "atlas:DoubleArrowLeftCircle", 
    tags: ["atlas", "double", "arrow", "left", "circle"], 
    source: "atlas", 
    name: "DoubleArrowLeftCircle",
  }, 
  {
    id: "atlas:DoubleArrowMoveUp", 
    tags: ["atlas", "double", "arrow", "move", "up"], 
    source: "atlas", 
    name: "DoubleArrowMoveUp",
  }, 
  {
    id: "atlas:DoubleArrowRight", 
    tags: ["atlas", "double", "arrow", "right"], 
    source: "atlas", 
    name: "DoubleArrowRight",
  }, 
  {
    id: "atlas:DoubleArrowRightCircle", 
    tags: ["atlas", "double", "arrow", "right", "circle"], 
    source: "atlas", 
    name: "DoubleArrowRightCircle",
  }, 
  {
    id: "atlas:DoubleArrowUp", 
    tags: ["atlas", "double", "arrow", "up"], 
    source: "atlas", 
    name: "DoubleArrowUp",
  }, 
  {
    id: "atlas:DoubleArrowUpCircle", 
    tags: ["atlas", "double", "arrow", "up", "circle"], 
    source: "atlas", 
    name: "DoubleArrowUpCircle",
  }, 
  {
    id: "atlas:DoubleArrowUpLeft", 
    tags: ["atlas", "double", "arrow", "up", "left"], 
    source: "atlas", 
    name: "DoubleArrowUpLeft",
  }, 
  {
    id: "atlas:DoubleArrowUpLeftCircle", 
    tags: ["atlas", "double", "arrow", "up", "left", "circle"], 
    source: "atlas", 
    name: "DoubleArrowUpLeftCircle",
  }, 
  {
    id: "atlas:DoubleArrowUpLine", 
    tags: ["atlas", "double", "arrow", "up", "line"], 
    source: "atlas", 
    name: "DoubleArrowUpLine",
  }, 
  {
    id: "atlas:DoubleArrowUpRight", 
    tags: ["atlas", "double", "arrow", "up", "right"], 
    source: "atlas", 
    name: "DoubleArrowUpRight",
  }, 
  {
    id: "atlas:DoubleArrowUpRightCircle", 
    tags: ["atlas", "double", "arrow", "up", "right", "circle"], 
    source: "atlas", 
    name: "DoubleArrowUpRightCircle",
  }, 
  {
    id: "atlas:DoubleBed", 
    tags: ["atlas", "double", "bed"], 
    source: "atlas", 
    name: "DoubleBed",
  }, 
  {
    id: "atlas:DoubleBedSleep", 
    tags: ["atlas", "double", "bed", "sleep"], 
    source: "atlas", 
    name: "DoubleBedSleep",
  }, 
  {
    id: "atlas:DoubleClick", 
    tags: ["atlas", "double", "click"], 
    source: "atlas", 
    name: "DoubleClick",
  }, 
  {
    id: "atlas:DoubleDeckerBus", 
    tags: ["atlas", "double", "decker", "bus"], 
    source: "atlas", 
    name: "DoubleDeckerBus",
  }, 
  {
    id: "atlas:DoubleDoors", 
    tags: ["atlas", "double", "doors"], 
    source: "atlas", 
    name: "DoubleDoors",
  }, 
  {
    id: "atlas:DoubleFinger", 
    tags: ["atlas", "double", "finger"], 
    source: "atlas", 
    name: "DoubleFinger",
  }, 
  {
    id: "atlas:DoubleParagraph", 
    tags: ["atlas", "double", "paragraph"], 
    source: "atlas", 
    name: "DoubleParagraph",
  }, 
  {
    id: "atlas:DoublePress", 
    tags: ["atlas", "double", "press"], 
    source: "atlas", 
    name: "DoublePress",
  }, 
  {
    id: "atlas:DoubleTouch", 
    tags: ["atlas", "double", "touch"], 
    source: "atlas", 
    name: "DoubleTouch",
  }, 
  {
    id: "atlas:DoubleTouchFinger", 
    tags: ["atlas", "double", "touch", "finger"], 
    source: "atlas", 
    name: "DoubleTouchFinger",
  }, 
  {
    id: "atlas:Dove", 
    tags: ["atlas", "dove"], 
    source: "atlas", 
    name: "Dove",
  }, 
  {
    id: "atlas:DownLeftArrows", 
    tags: ["atlas", "down", "left", "arrows"], 
    source: "atlas", 
    name: "DownLeftArrows",
  }, 
  {
    id: "atlas:DownMove", 
    tags: ["atlas", "down", "move"], 
    source: "atlas", 
    name: "DownMove",
  }, 
  {
    id: "atlas:DownOrientation", 
    tags: ["atlas", "down", "orientation"], 
    source: "atlas", 
    name: "DownOrientation",
  }, 
  {
    id: "atlas:DownRightArrows", 
    tags: ["atlas", "down", "right", "arrows"], 
    source: "atlas", 
    name: "DownRightArrows",
  }, 
  {
    id: "atlas:DownloadArrowDown", 
    tags: ["atlas", "download", "arrow", "down"], 
    source: "atlas", 
    name: "DownloadArrowDown",
  }, 
  {
    id: "atlas:Downstairs", 
    tags: ["atlas", "downstairs"], 
    source: "atlas", 
    name: "Downstairs",
  }, 
  {
    id: "atlas:DownwardEscalator", 
    tags: ["atlas", "downward", "escalator"], 
    source: "atlas", 
    name: "DownwardEscalator",
  }, 
  {
    id: "atlas:DownwardFacingDog", 
    tags: ["atlas", "downward", "facing", "dog"], 
    source: "atlas", 
    name: "DownwardFacingDog",
  }, 
  {
    id: "atlas:DragDown", 
    tags: ["atlas", "drag", "down"], 
    source: "atlas", 
    name: "DragDown",
  }, 
  {
    id: "atlas:DragLeft", 
    tags: ["atlas", "drag", "left"], 
    source: "atlas", 
    name: "DragLeft",
  }, 
  {
    id: "atlas:DragRight", 
    tags: ["atlas", "drag", "right"], 
    source: "atlas", 
    name: "DragRight",
  }, 
  {
    id: "atlas:DragUp", 
    tags: ["atlas", "drag", "up"], 
    source: "atlas", 
    name: "DragUp",
  }, 
  {
    id: "atlas:Draw", 
    tags: ["atlas", "draw"], 
    source: "atlas", 
    name: "Draw",
  }, 
  {
    id: "atlas:DrawLine", 
    tags: ["atlas", "draw", "line"], 
    source: "atlas", 
    name: "DrawLine",
  }, 
  {
    id: "atlas:DrawersCupboard", 
    tags: ["atlas", "drawers", "cupboard"], 
    source: "atlas", 
    name: "DrawersCupboard",
  }, 
  {
    id: "atlas:DrawersEndTable", 
    tags: ["atlas", "drawers", "end", "table"], 
    source: "atlas", 
    name: "DrawersEndTable",
  }, 
  {
    id: "atlas:DrawersTable", 
    tags: ["atlas", "drawers", "table"], 
    source: "atlas", 
    name: "DrawersTable",
  }, 
  {
    id: "atlas:DrawingTablet", 
    tags: ["atlas", "drawing", "tablet"], 
    source: "atlas", 
    name: "DrawingTablet",
  }, 
  {
    id: "atlas:Dribble", 
    tags: ["atlas", "dribble"], 
    source: "atlas", 
    name: "Dribble",
  }, 
  {
    id: "atlas:DrillElectric", 
    tags: ["atlas", "drill", "electric"], 
    source: "atlas", 
    name: "DrillElectric",
  }, 
  {
    id: "atlas:Drone", 
    tags: ["atlas", "drone"], 
    source: "atlas", 
    name: "Drone",
  }, 
  {
    id: "atlas:DroneTech", 
    tags: ["atlas", "drone", "tech"], 
    source: "atlas", 
    name: "DroneTech",
  }, 
  {
    id: "atlas:Dropbox", 
    tags: ["atlas", "dropbox"], 
    source: "atlas", 
    name: "Dropbox",
  }, 
  {
    id: "atlas:Dropper", 
    tags: ["atlas", "dropper"], 
    source: "atlas", 
    name: "Dropper",
  }, 
  {
    id: "atlas:Drugs", 
    tags: ["atlas", "drugs"], 
    source: "atlas", 
    name: "Drugs",
  }, 
  {
    id: "atlas:Dumbbell", 
    tags: ["atlas", "dumbbell"], 
    source: "atlas", 
    name: "Dumbbell",
  }, 
  {
    id: "atlas:DumbbellGym", 
    tags: ["atlas", "dumbbell", "gym"], 
    source: "atlas", 
    name: "DumbbellGym",
  }, 
  {
    id: "atlas:DuplicateWebsite", 
    tags: ["atlas", "duplicate", "website"], 
    source: "atlas", 
    name: "DuplicateWebsite",
  }, 
  {
    id: "atlas:Dvd", 
    tags: ["atlas", "dvd"], 
    source: "atlas", 
    name: "Dvd",
  }, 
  {
    id: "atlas:Ear", 
    tags: ["atlas", "ear"], 
    source: "atlas", 
    name: "Ear",
  }, 
  {
    id: "atlas:EarDropsBottle", 
    tags: ["atlas", "ear", "drops", "bottle"], 
    source: "atlas", 
    name: "EarDropsBottle",
  }, 
  {
    id: "atlas:EarMuffs", 
    tags: ["atlas", "ear", "muffs"], 
    source: "atlas", 
    name: "EarMuffs",
  }, 
  {
    id: "atlas:Earphones", 
    tags: ["atlas", "earphones"], 
    source: "atlas", 
    name: "Earphones",
  }, 
  {
    id: "atlas:EarthStatue", 
    tags: ["atlas", "earth", "statue"], 
    source: "atlas", 
    name: "EarthStatue",
  }, 
  {
    id: "atlas:EasterIsland", 
    tags: ["atlas", "easter", "island"], 
    source: "atlas", 
    name: "EasterIsland",
  }, 
  {
    id: "atlas:Ecology", 
    tags: ["atlas", "ecology"], 
    source: "atlas", 
    name: "Ecology",
  }, 
  {
    id: "atlas:Education", 
    tags: ["atlas", "education"], 
    source: "atlas", 
    name: "Education",
  }, 
  {
    id: "atlas:Egg", 
    tags: ["atlas", "egg"], 
    source: "atlas", 
    name: "Egg",
  }, 
  {
    id: "atlas:EiffelTower", 
    tags: ["atlas", "eiffel", "tower"], 
    source: "atlas", 
    name: "EiffelTower",
  }, 
  {
    id: "atlas:EiffelTowerParis", 
    tags: ["atlas", "eiffel", "tower", "paris"], 
    source: "atlas", 
    name: "EiffelTowerParis",
  }, 
  {
    id: "atlas:EightBallBilliard", 
    tags: ["atlas", "eight", "ball", "billiard"], 
    source: "atlas", 
    name: "EightBallBilliard",
  }, 
  {
    id: "atlas:ElectricBatteryCharge", 
    tags: ["atlas", "electric", "battery", "charge"], 
    source: "atlas", 
    name: "ElectricBatteryCharge",
  }, 
  {
    id: "atlas:ElectricCar", 
    tags: ["atlas", "electric", "car"], 
    source: "atlas", 
    name: "ElectricCar",
  }, 
  {
    id: "atlas:ElectricCharge", 
    tags: ["atlas", "electric", "charge"], 
    source: "atlas", 
    name: "ElectricCharge",
  }, 
  {
    id: "atlas:ElectricDrill", 
    tags: ["atlas", "electric", "drill"], 
    source: "atlas", 
    name: "ElectricDrill",
  }, 
  {
    id: "atlas:ElectricLightbulb", 
    tags: ["atlas", "electric", "lightbulb"], 
    source: "atlas", 
    name: "ElectricLightbulb",
  }, 
  {
    id: "atlas:ElectricSander", 
    tags: ["atlas", "electric", "sander"], 
    source: "atlas", 
    name: "ElectricSander",
  }, 
  {
    id: "atlas:ElectricSaw", 
    tags: ["atlas", "electric", "saw"], 
    source: "atlas", 
    name: "ElectricSaw",
  }, 
  {
    id: "atlas:ElectricStorm", 
    tags: ["atlas", "electric", "storm"], 
    source: "atlas", 
    name: "ElectricStorm",
  }, 
  {
    id: "atlas:ElectricThought", 
    tags: ["atlas", "electric", "thought"], 
    source: "atlas", 
    name: "ElectricThought",
  }, 
  {
    id: "atlas:Electricity", 
    tags: ["atlas", "electricity"], 
    source: "atlas", 
    name: "Electricity",
  }, 
  {
    id: "atlas:ElectricityCable", 
    tags: ["atlas", "electricity", "cable"], 
    source: "atlas", 
    name: "ElectricityCable",
  }, 
  {
    id: "atlas:ElectricityHome", 
    tags: ["atlas", "electricity", "home"], 
    source: "atlas", 
    name: "ElectricityHome",
  }, 
  {
    id: "atlas:ElectricityMagnifyingGlass", 
    tags: ["atlas", "electricity", "magnifying", "glass"], 
    source: "atlas", 
    name: "ElectricityMagnifyingGlass",
  }, 
  {
    id: "atlas:ElectricitySocket", 
    tags: ["atlas", "electricity", "socket"], 
    source: "atlas", 
    name: "ElectricitySocket",
  }, 
  {
    id: "atlas:ElectricitySocketCircle", 
    tags: ["atlas", "electricity", "socket", "circle"], 
    source: "atlas", 
    name: "ElectricitySocketCircle",
  }, 
  {
    id: "atlas:ElectricitySquare", 
    tags: ["atlas", "electricity", "square"], 
    source: "atlas", 
    name: "ElectricitySquare",
  }, 
  {
    id: "atlas:ElementsHorizontal", 
    tags: ["atlas", "elements", "horizontal"], 
    source: "atlas", 
    name: "ElementsHorizontal",
  }, 
  {
    id: "atlas:ElementsVertical", 
    tags: ["atlas", "elements", "vertical"], 
    source: "atlas", 
    name: "ElementsVertical",
  }, 
  {
    id: "atlas:Elevator", 
    tags: ["atlas", "elevator"], 
    source: "atlas", 
    name: "Elevator",
  }, 
  {
    id: "atlas:ElevatorUpDown", 
    tags: ["atlas", "elevator", "up", "down"], 
    source: "atlas", 
    name: "ElevatorUpDown",
  }, 
  {
    id: "atlas:Elf", 
    tags: ["atlas", "elf"], 
    source: "atlas", 
    name: "Elf",
  }, 
  {
    id: "atlas:Email", 
    tags: ["atlas", "email"], 
    source: "atlas", 
    name: "Email",
  }, 
  {
    id: "atlas:EmergencySiren", 
    tags: ["atlas", "emergency", "siren"], 
    source: "atlas", 
    name: "EmergencySiren",
  }, 
  {
    id: "atlas:EndTable", 
    tags: ["atlas", "end", "table"], 
    source: "atlas", 
    name: "EndTable",
  }, 
  {
    id: "atlas:EndTableCupboard", 
    tags: ["atlas", "end", "table", "cupboard"], 
    source: "atlas", 
    name: "EndTableCupboard",
  }, 
  {
    id: "atlas:EndTableDrawer", 
    tags: ["atlas", "end", "table", "drawer"], 
    source: "atlas", 
    name: "EndTableDrawer",
  }, 
  {
    id: "atlas:EndTableDrawers", 
    tags: ["atlas", "end", "table", "drawers"], 
    source: "atlas", 
    name: "EndTableDrawers",
  }, 
  {
    id: "atlas:EndTableLamp", 
    tags: ["atlas", "end", "table", "lamp"], 
    source: "atlas", 
    name: "EndTableLamp",
  }, 
  {
    id: "atlas:EnergyBottle", 
    tags: ["atlas", "energy", "bottle"], 
    source: "atlas", 
    name: "EnergyBottle",
  }, 
  {
    id: "atlas:EnergyCan", 
    tags: ["atlas", "energy", "can"], 
    source: "atlas", 
    name: "EnergyCan",
  }, 
  {
    id: "atlas:EnergyDrink", 
    tags: ["atlas", "energy", "drink"], 
    source: "atlas", 
    name: "EnergyDrink",
  }, 
  {
    id: "atlas:EnergyPill", 
    tags: ["atlas", "energy", "pill"], 
    source: "atlas", 
    name: "EnergyPill",
  }, 
  {
    id: "atlas:EngagementRing", 
    tags: ["atlas", "engagement", "ring"], 
    source: "atlas", 
    name: "EngagementRing",
  }, 
  {
    id: "atlas:Entrance", 
    tags: ["atlas", "entrance"], 
    source: "atlas", 
    name: "Entrance",
  }, 
  {
    id: "atlas:Envelope", 
    tags: ["atlas", "envelope"], 
    source: "atlas", 
    name: "Envelope",
  }, 
  {
    id: "atlas:EnvelopeArrowRight", 
    tags: ["atlas", "envelope", "arrow", "right"], 
    source: "atlas", 
    name: "EnvelopeArrowRight",
  }, 
  {
    id: "atlas:EnvelopeCheck", 
    tags: ["atlas", "envelope", "check"], 
    source: "atlas", 
    name: "EnvelopeCheck",
  }, 
  {
    id: "atlas:EnvelopeLine", 
    tags: ["atlas", "envelope", "line"], 
    source: "atlas", 
    name: "EnvelopeLine",
  }, 
  {
    id: "atlas:EnvelopeLines", 
    tags: ["atlas", "envelope", "lines"], 
    source: "atlas", 
    name: "EnvelopeLines",
  }, 
  {
    id: "atlas:EnvelopeMinus", 
    tags: ["atlas", "envelope", "minus"], 
    source: "atlas", 
    name: "EnvelopeMinus",
  }, 
  {
    id: "atlas:EnvelopePaper", 
    tags: ["atlas", "envelope", "paper"], 
    source: "atlas", 
    name: "EnvelopePaper",
  }, 
  {
    id: "atlas:EnvelopePaperEmail", 
    tags: ["atlas", "envelope", "paper", "email"], 
    source: "atlas", 
    name: "EnvelopePaperEmail",
  }, 
  {
    id: "atlas:EnvelopeQuestion", 
    tags: ["atlas", "envelope", "question"], 
    source: "atlas", 
    name: "EnvelopeQuestion",
  }, 
  {
    id: "atlas:EnvelopeXmark", 
    tags: ["atlas", "envelope", "xmark"], 
    source: "atlas", 
    name: "EnvelopeXmark",
  }, 
  {
    id: "atlas:EnvelopesLines", 
    tags: ["atlas", "envelopes", "lines"], 
    source: "atlas", 
    name: "EnvelopesLines",
  }, 
  {
    id: "atlas:Eraser", 
    tags: ["atlas", "eraser"], 
    source: "atlas", 
    name: "Eraser",
  }, 
  {
    id: "atlas:EthernetPort", 
    tags: ["atlas", "ethernet", "port"], 
    source: "atlas", 
    name: "EthernetPort",
  }, 
  {
    id: "atlas:EuroCircle", 
    tags: ["atlas", "euro", "circle"], 
    source: "atlas", 
    name: "EuroCircle",
  }, 
  {
    id: "atlas:EuroSign", 
    tags: ["atlas", "euro", "sign"], 
    source: "atlas", 
    name: "EuroSign",
  }, 
  {
    id: "atlas:EuropeanPlug", 
    tags: ["atlas", "european", "plug"], 
    source: "atlas", 
    name: "EuropeanPlug",
  }, 
  {
    id: "atlas:EuropeanSocket", 
    tags: ["atlas", "european", "socket"], 
    source: "atlas", 
    name: "EuropeanSocket",
  }, 
  {
    id: "atlas:EvenScale", 
    tags: ["atlas", "even", "scale"], 
    source: "atlas", 
    name: "EvenScale",
  }, 
  {
    id: "atlas:ExclamationChat", 
    tags: ["atlas", "exclamation", "chat"], 
    source: "atlas", 
    name: "ExclamationChat",
  }, 
  {
    id: "atlas:ExclamationClipboard", 
    tags: ["atlas", "exclamation", "clipboard"], 
    source: "atlas", 
    name: "ExclamationClipboard",
  }, 
  {
    id: "atlas:ExclamationDocument", 
    tags: ["atlas", "exclamation", "document"], 
    source: "atlas", 
    name: "ExclamationDocument",
  }, 
  {
    id: "atlas:ExclamationFile", 
    tags: ["atlas", "exclamation", "file"], 
    source: "atlas", 
    name: "ExclamationFile",
  }, 
  {
    id: "atlas:ExclamationFolder", 
    tags: ["atlas", "exclamation", "folder"], 
    source: "atlas", 
    name: "ExclamationFolder",
  }, 
  {
    id: "atlas:ExclamationLaptop", 
    tags: ["atlas", "exclamation", "laptop"], 
    source: "atlas", 
    name: "ExclamationLaptop",
  }, 
  {
    id: "atlas:ExclamationMessage", 
    tags: ["atlas", "exclamation", "message"], 
    source: "atlas", 
    name: "ExclamationMessage",
  }, 
  {
    id: "atlas:ExclamationMessageAlert", 
    tags: ["atlas", "exclamation", "message", "alert"], 
    source: "atlas", 
    name: "ExclamationMessageAlert",
  }, 
  {
    id: "atlas:ExclamationMobile", 
    tags: ["atlas", "exclamation", "mobile"], 
    source: "atlas", 
    name: "ExclamationMobile",
  }, 
  {
    id: "atlas:ExclamationMonitor", 
    tags: ["atlas", "exclamation", "monitor"], 
    source: "atlas", 
    name: "ExclamationMonitor",
  }, 
  {
    id: "atlas:ExclamationTriangle", 
    tags: ["atlas", "exclamation", "triangle"], 
    source: "atlas", 
    name: "ExclamationTriangle",
  }, 
  {
    id: "atlas:ExclamationUsbStick", 
    tags: ["atlas", "exclamation", "usb", "stick"], 
    source: "atlas", 
    name: "ExclamationUsbStick",
  }, 
  {
    id: "atlas:ExclamationWebsite", 
    tags: ["atlas", "exclamation", "website"], 
    source: "atlas", 
    name: "ExclamationWebsite",
  }, 
  {
    id: "atlas:ExerciseBike", 
    tags: ["atlas", "exercise", "bike"], 
    source: "atlas", 
    name: "ExerciseBike",
  }, 
  {
    id: "atlas:Exit", 
    tags: ["atlas", "exit"], 
    source: "atlas", 
    name: "Exit",
  }, 
  {
    id: "atlas:ExitSign", 
    tags: ["atlas", "exit", "sign"], 
    source: "atlas", 
    name: "ExitSign",
  }, 
  {
    id: "atlas:ExportArrowRight", 
    tags: ["atlas", "export", "arrow", "right"], 
    source: "atlas", 
    name: "ExportArrowRight",
  }, 
  {
    id: "atlas:ExportArrowUpRight", 
    tags: ["atlas", "export", "arrow", "up", "right"], 
    source: "atlas", 
    name: "ExportArrowUpRight",
  }, 
  {
    id: "atlas:ExtendedStandPose", 
    tags: ["atlas", "extended", "stand", "pose"], 
    source: "atlas", 
    name: "ExtendedStandPose",
  }, 
  {
    id: "atlas:Extender", 
    tags: ["atlas", "extender"], 
    source: "atlas", 
    name: "Extender",
  }, 
  {
    id: "atlas:Eye", 
    tags: ["atlas", "eye"], 
    source: "atlas", 
    name: "Eye",
  }, 
  {
    id: "atlas:EyeArrows", 
    tags: ["atlas", "eye", "arrows"], 
    source: "atlas", 
    name: "EyeArrows",
  }, 
  {
    id: "atlas:EyeDrops", 
    tags: ["atlas", "eye", "drops"], 
    source: "atlas", 
    name: "EyeDrops",
  }, 
  {
    id: "atlas:EyeMinus", 
    tags: ["atlas", "eye", "minus"], 
    source: "atlas", 
    name: "EyeMinus",
  }, 
  {
    id: "atlas:EyePlus", 
    tags: ["atlas", "eye", "plus"], 
    source: "atlas", 
    name: "EyePlus",
  }, 
  {
    id: "atlas:Eyedropper", 
    tags: ["atlas", "eyedropper"], 
    source: "atlas", 
    name: "Eyedropper",
  }, 
  {
    id: "atlas:EyedropperTool", 
    tags: ["atlas", "eyedropper", "tool"], 
    source: "atlas", 
    name: "EyedropperTool",
  }, 
  {
    id: "atlas:FaceMask", 
    tags: ["atlas", "face", "mask"], 
    source: "atlas", 
    name: "FaceMask",
  }, 
  {
    id: "atlas:FaceMaskPlus", 
    tags: ["atlas", "face", "mask", "plus"], 
    source: "atlas", 
    name: "FaceMaskPlus",
  }, 
  {
    id: "atlas:Facebook", 
    tags: ["atlas", "facebook"], 
    source: "atlas", 
    name: "Facebook",
  }, 
  {
    id: "atlas:Fahrenheit", 
    tags: ["atlas", "fahrenheit"], 
    source: "atlas", 
    name: "Fahrenheit",
  }, 
  {
    id: "atlas:FarmingTractor", 
    tags: ["atlas", "farming", "tractor"], 
    source: "atlas", 
    name: "FarmingTractor",
  }, 
  {
    id: "atlas:FastCar", 
    tags: ["atlas", "fast", "car"], 
    source: "atlas", 
    name: "FastCar",
  }, 
  {
    id: "atlas:FastEnvelope", 
    tags: ["atlas", "fast", "envelope"], 
    source: "atlas", 
    name: "FastEnvelope",
  }, 
  {
    id: "atlas:FastForward", 
    tags: ["atlas", "fast", "forward"], 
    source: "atlas", 
    name: "FastForward",
  }, 
  {
    id: "atlas:Faucet", 
    tags: ["atlas", "faucet"], 
    source: "atlas", 
    name: "Faucet",
  }, 
  {
    id: "atlas:FavouriteGlasses", 
    tags: ["atlas", "favourite", "glasses"], 
    source: "atlas", 
    name: "FavouriteGlasses",
  }, 
  {
    id: "atlas:FeatherInk", 
    tags: ["atlas", "feather", "ink"], 
    source: "atlas", 
    name: "FeatherInk",
  }, 
  {
    id: "atlas:Feedly", 
    tags: ["atlas", "feedly"], 
    source: "atlas", 
    name: "Feedly",
  }, 
  {
    id: "atlas:Female", 
    tags: ["atlas", "female"], 
    source: "atlas", 
    name: "Female",
  }, 
  {
    id: "atlas:FemaleGender", 
    tags: ["atlas", "female", "gender"], 
    source: "atlas", 
    name: "FemaleGender",
  }, 
  {
    id: "atlas:FemaleRelationship", 
    tags: ["atlas", "female", "relationship"], 
    source: "atlas", 
    name: "FemaleRelationship",
  }, 
  {
    id: "atlas:FemaleRomance", 
    tags: ["atlas", "female", "romance"], 
    source: "atlas", 
    name: "FemaleRomance",
  }, 
  {
    id: "atlas:Fence", 
    tags: ["atlas", "fence"], 
    source: "atlas", 
    name: "Fence",
  }, 
  {
    id: "atlas:FencingSwords", 
    tags: ["atlas", "fencing", "swords"], 
    source: "atlas", 
    name: "FencingSwords",
  }, 
  {
    id: "atlas:File", 
    tags: ["atlas", "file"], 
    source: "atlas", 
    name: "File",
  }, 
  {
    id: "atlas:FileArrowUp", 
    tags: ["atlas", "file", "arrow", "up"], 
    source: "atlas", 
    name: "FileArrowUp",
  }, 
  {
    id: "atlas:FileAudio", 
    tags: ["atlas", "file", "audio"], 
    source: "atlas", 
    name: "FileAudio",
  }, 
  {
    id: "atlas:FileImage", 
    tags: ["atlas", "file", "image"], 
    source: "atlas", 
    name: "FileImage",
  }, 
  {
    id: "atlas:FileInfo", 
    tags: ["atlas", "file", "info"], 
    source: "atlas", 
    name: "FileInfo",
  }, 
  {
    id: "atlas:FileLine", 
    tags: ["atlas", "file", "line"], 
    source: "atlas", 
    name: "FileLine",
  }, 
  {
    id: "atlas:FileRefresh", 
    tags: ["atlas", "file", "refresh"], 
    source: "atlas", 
    name: "FileRefresh",
  }, 
  {
    id: "atlas:FileSearch", 
    tags: ["atlas", "file", "search"], 
    source: "atlas", 
    name: "FileSearch",
  }, 
  {
    id: "atlas:FileSettings", 
    tags: ["atlas", "file", "settings"], 
    source: "atlas", 
    name: "FileSettings",
  }, 
  {
    id: "atlas:FileShare", 
    tags: ["atlas", "file", "share"], 
    source: "atlas", 
    name: "FileShare",
  }, 
  {
    id: "atlas:FileShield", 
    tags: ["atlas", "file", "shield"], 
    source: "atlas", 
    name: "FileShield",
  }, 
  {
    id: "atlas:FileSound", 
    tags: ["atlas", "file", "sound"], 
    source: "atlas", 
    name: "FileSound",
  }, 
  {
    id: "atlas:FileVideo", 
    tags: ["atlas", "file", "video"], 
    source: "atlas", 
    name: "FileVideo",
  }, 
  {
    id: "atlas:FilingCabinet", 
    tags: ["atlas", "filing", "cabinet"], 
    source: "atlas", 
    name: "FilingCabinet",
  }, 
  {
    id: "atlas:FilmLight", 
    tags: ["atlas", "film", "light"], 
    source: "atlas", 
    name: "FilmLight",
  }, 
  {
    id: "atlas:FilmMusic", 
    tags: ["atlas", "film", "music"], 
    source: "atlas", 
    name: "FilmMusic",
  }, 
  {
    id: "atlas:FilmPlay", 
    tags: ["atlas", "film", "play"], 
    source: "atlas", 
    name: "FilmPlay",
  }, 
  {
    id: "atlas:Filter", 
    tags: ["atlas", "filter"], 
    source: "atlas", 
    name: "Filter",
  }, 
  {
    id: "atlas:Fingerprint", 
    tags: ["atlas", "fingerprint"], 
    source: "atlas", 
    name: "Fingerprint",
  }, 
  {
    id: "atlas:Fire", 
    tags: ["atlas", "fire"], 
    source: "atlas", 
    name: "Fire",
  }, 
  {
    id: "atlas:FireAlarm", 
    tags: ["atlas", "fire", "alarm"], 
    source: "atlas", 
    name: "FireAlarm",
  }, 
  {
    id: "atlas:FireExtinguisher", 
    tags: ["atlas", "fire", "extinguisher"], 
    source: "atlas", 
    name: "FireExtinguisher",
  }, 
  {
    id: "atlas:FireTestTube", 
    tags: ["atlas", "fire", "test", "tube"], 
    source: "atlas", 
    name: "FireTestTube",
  }, 
  {
    id: "atlas:FireTower", 
    tags: ["atlas", "fire", "tower"], 
    source: "atlas", 
    name: "FireTower",
  }, 
  {
    id: "atlas:FireTriangle", 
    tags: ["atlas", "fire", "triangle"], 
    source: "atlas", 
    name: "FireTriangle",
  }, 
  {
    id: "atlas:FireWood", 
    tags: ["atlas", "fire", "wood"], 
    source: "atlas", 
    name: "FireWood",
  }, 
  {
    id: "atlas:Fireplace", 
    tags: ["atlas", "fireplace"], 
    source: "atlas", 
    name: "Fireplace",
  }, 
  {
    id: "atlas:FireplaceHeat", 
    tags: ["atlas", "fireplace", "heat"], 
    source: "atlas", 
    name: "FireplaceHeat",
  }, 
  {
    id: "atlas:FireplaceHeating", 
    tags: ["atlas", "fireplace", "heating"], 
    source: "atlas", 
    name: "FireplaceHeating",
  }, 
  {
    id: "atlas:Firewall", 
    tags: ["atlas", "firewall"], 
    source: "atlas", 
    name: "Firewall",
  }, 
  {
    id: "atlas:FirstAidBox", 
    tags: ["atlas", "first", "aid", "box"], 
    source: "atlas", 
    name: "FirstAidBox",
  }, 
  {
    id: "atlas:FishHook", 
    tags: ["atlas", "fish", "hook"], 
    source: "atlas", 
    name: "FishHook",
  }, 
  {
    id: "atlas:Fist", 
    tags: ["atlas", "fist"], 
    source: "atlas", 
    name: "Fist",
  }, 
  {
    id: "atlas:FitnessBall", 
    tags: ["atlas", "fitness", "ball"], 
    source: "atlas", 
    name: "FitnessBall",
  }, 
  {
    id: "atlas:Flag", 
    tags: ["atlas", "flag"], 
    source: "atlas", 
    name: "Flag",
  }, 
  {
    id: "atlas:FlagAchievement", 
    tags: ["atlas", "flag", "achievement"], 
    source: "atlas", 
    name: "FlagAchievement",
  }, 
  {
    id: "atlas:FlagMountain", 
    tags: ["atlas", "flag", "mountain"], 
    source: "atlas", 
    name: "FlagMountain",
  }, 
  {
    id: "atlas:FlagMountainTop", 
    tags: ["atlas", "flag", "mountain", "top"], 
    source: "atlas", 
    name: "FlagMountainTop",
  }, 
  {
    id: "atlas:FlagStairsPeople", 
    tags: ["atlas", "flag", "stairs", "people"], 
    source: "atlas", 
    name: "FlagStairsPeople",
  }, 
  {
    id: "atlas:Flame", 
    tags: ["atlas", "flame"], 
    source: "atlas", 
    name: "Flame",
  }, 
  {
    id: "atlas:Flashlight", 
    tags: ["atlas", "flashlight"], 
    source: "atlas", 
    name: "Flashlight",
  }, 
  {
    id: "atlas:FlatScrewdriver", 
    tags: ["atlas", "flat", "screwdriver"], 
    source: "atlas", 
    name: "FlatScrewdriver",
  }, 
  {
    id: "atlas:Flickr", 
    tags: ["atlas", "flickr"], 
    source: "atlas", 
    name: "Flickr",
  }, 
  {
    id: "atlas:FlightDate", 
    tags: ["atlas", "flight", "date"], 
    source: "atlas", 
    name: "FlightDate",
  }, 
  {
    id: "atlas:FlightDocument", 
    tags: ["atlas", "flight", "document"], 
    source: "atlas", 
    name: "FlightDocument",
  }, 
  {
    id: "atlas:Flippers", 
    tags: ["atlas", "flippers"], 
    source: "atlas", 
    name: "Flippers",
  }, 
  {
    id: "atlas:FloppyDisk", 
    tags: ["atlas", "floppy", "disk"], 
    source: "atlas", 
    name: "FloppyDisk",
  }, 
  {
    id: "atlas:FloppyDiskSave", 
    tags: ["atlas", "floppy", "disk", "save"], 
    source: "atlas", 
    name: "FloppyDiskSave",
  }, 
  {
    id: "atlas:Floral", 
    tags: ["atlas", "floral"], 
    source: "atlas", 
    name: "Floral",
  }, 
  {
    id: "atlas:FlourBag", 
    tags: ["atlas", "flour", "bag"], 
    source: "atlas", 
    name: "FlourBag",
  }, 
  {
    id: "atlas:Flower", 
    tags: ["atlas", "flower"], 
    source: "atlas", 
    name: "Flower",
  }, 
  {
    id: "atlas:FoldChair", 
    tags: ["atlas", "fold", "chair"], 
    source: "atlas", 
    name: "FoldChair",
  }, 
  {
    id: "atlas:FoldableChair", 
    tags: ["atlas", "foldable", "chair"], 
    source: "atlas", 
    name: "FoldableChair",
  }, 
  {
    id: "atlas:Folder", 
    tags: ["atlas", "folder"], 
    source: "atlas", 
    name: "Folder",
  }, 
  {
    id: "atlas:FolderArchive", 
    tags: ["atlas", "folder", "archive"], 
    source: "atlas", 
    name: "FolderArchive",
  }, 
  {
    id: "atlas:FolderArrowDown", 
    tags: ["atlas", "folder", "arrow", "down"], 
    source: "atlas", 
    name: "FolderArrowDown",
  }, 
  {
    id: "atlas:FolderArrowUp", 
    tags: ["atlas", "folder", "arrow", "up"], 
    source: "atlas", 
    name: "FolderArrowUp",
  }, 
  {
    id: "atlas:FolderBlock", 
    tags: ["atlas", "folder", "block"], 
    source: "atlas", 
    name: "FolderBlock",
  }, 
  {
    id: "atlas:FolderBroken", 
    tags: ["atlas", "folder", "broken"], 
    source: "atlas", 
    name: "FolderBroken",
  }, 
  {
    id: "atlas:FolderCheck", 
    tags: ["atlas", "folder", "check"], 
    source: "atlas", 
    name: "FolderCheck",
  }, 
  {
    id: "atlas:FolderDollar", 
    tags: ["atlas", "folder", "dollar"], 
    source: "atlas", 
    name: "FolderDollar",
  }, 
  {
    id: "atlas:FolderDots", 
    tags: ["atlas", "folder", "dots"], 
    source: "atlas", 
    name: "FolderDots",
  }, 
  {
    id: "atlas:FolderGraph", 
    tags: ["atlas", "folder", "graph"], 
    source: "atlas", 
    name: "FolderGraph",
  }, 
  {
    id: "atlas:FolderHeart", 
    tags: ["atlas", "folder", "heart"], 
    source: "atlas", 
    name: "FolderHeart",
  }, 
  {
    id: "atlas:FolderImage", 
    tags: ["atlas", "folder", "image"], 
    source: "atlas", 
    name: "FolderImage",
  }, 
  {
    id: "atlas:FolderInfo", 
    tags: ["atlas", "folder", "info"], 
    source: "atlas", 
    name: "FolderInfo",
  }, 
  {
    id: "atlas:FolderLine", 
    tags: ["atlas", "folder", "line"], 
    source: "atlas", 
    name: "FolderLine",
  }, 
  {
    id: "atlas:FolderList", 
    tags: ["atlas", "folder", "list"], 
    source: "atlas", 
    name: "FolderList",
  }, 
  {
    id: "atlas:FolderLock", 
    tags: ["atlas", "folder", "lock"], 
    source: "atlas", 
    name: "FolderLock",
  }, 
  {
    id: "atlas:FolderMinus", 
    tags: ["atlas", "folder", "minus"], 
    source: "atlas", 
    name: "FolderMinus",
  }, 
  {
    id: "atlas:FolderMusic", 
    tags: ["atlas", "folder", "music"], 
    source: "atlas", 
    name: "FolderMusic",
  }, 
  {
    id: "atlas:FolderPadlock", 
    tags: ["atlas", "folder", "padlock"], 
    source: "atlas", 
    name: "FolderPadlock",
  }, 
  {
    id: "atlas:FolderPlay", 
    tags: ["atlas", "folder", "play"], 
    source: "atlas", 
    name: "FolderPlay",
  }, 
  {
    id: "atlas:FolderPlus", 
    tags: ["atlas", "folder", "plus"], 
    source: "atlas", 
    name: "FolderPlus",
  }, 
  {
    id: "atlas:FolderQuestion", 
    tags: ["atlas", "folder", "question"], 
    source: "atlas", 
    name: "FolderQuestion",
  }, 
  {
    id: "atlas:FolderSearch", 
    tags: ["atlas", "folder", "search"], 
    source: "atlas", 
    name: "FolderSearch",
  }, 
  {
    id: "atlas:FolderSettings", 
    tags: ["atlas", "folder", "settings"], 
    source: "atlas", 
    name: "FolderSettings",
  }, 
  {
    id: "atlas:FolderShareNetwork", 
    tags: ["atlas", "folder", "share", "network"], 
    source: "atlas", 
    name: "FolderShareNetwork",
  }, 
  {
    id: "atlas:FolderSharePadlock", 
    tags: ["atlas", "folder", "share", "padlock"], 
    source: "atlas", 
    name: "FolderSharePadlock",
  }, 
  {
    id: "atlas:FolderSharing", 
    tags: ["atlas", "folder", "sharing"], 
    source: "atlas", 
    name: "FolderSharing",
  }, 
  {
    id: "atlas:FolderShield", 
    tags: ["atlas", "folder", "shield"], 
    source: "atlas", 
    name: "FolderShield",
  }, 
  {
    id: "atlas:FolderSound", 
    tags: ["atlas", "folder", "sound"], 
    source: "atlas", 
    name: "FolderSound",
  }, 
  {
    id: "atlas:FolderStar", 
    tags: ["atlas", "folder", "star"], 
    source: "atlas", 
    name: "FolderStar",
  }, 
  {
    id: "atlas:FolderText", 
    tags: ["atlas", "folder", "text"], 
    source: "atlas", 
    name: "FolderText",
  }, 
  {
    id: "atlas:FolderTransfer", 
    tags: ["atlas", "folder", "transfer"], 
    source: "atlas", 
    name: "FolderTransfer",
  }, 
  {
    id: "atlas:FolderUp", 
    tags: ["atlas", "folder", "up"], 
    source: "atlas", 
    name: "FolderUp",
  }, 
  {
    id: "atlas:FolderUser", 
    tags: ["atlas", "folder", "user"], 
    source: "atlas", 
    name: "FolderUser",
  }, 
  {
    id: "atlas:FolderVideo", 
    tags: ["atlas", "folder", "video"], 
    source: "atlas", 
    name: "FolderVideo",
  }, 
  {
    id: "atlas:FolderVoice", 
    tags: ["atlas", "folder", "voice"], 
    source: "atlas", 
    name: "FolderVoice",
  }, 
  {
    id: "atlas:FolderWifi", 
    tags: ["atlas", "folder", "wifi"], 
    source: "atlas", 
    name: "FolderWifi",
  }, 
  {
    id: "atlas:FolderXmark", 
    tags: ["atlas", "folder", "xmark"], 
    source: "atlas", 
    name: "FolderXmark",
  }, 
  {
    id: "atlas:Folders", 
    tags: ["atlas", "folders"], 
    source: "atlas", 
    name: "Folders",
  }, 
  {
    id: "atlas:FoodStore", 
    tags: ["atlas", "food", "store"], 
    source: "atlas", 
    name: "FoodStore",
  }, 
  {
    id: "atlas:Foot", 
    tags: ["atlas", "foot"], 
    source: "atlas", 
    name: "Foot",
  }, 
  {
    id: "atlas:FootballBall", 
    tags: ["atlas", "football", "ball"], 
    source: "atlas", 
    name: "FootballBall",
  }, 
  {
    id: "atlas:FootballHelmet", 
    tags: ["atlas", "football", "helmet"], 
    source: "atlas", 
    name: "FootballHelmet",
  }, 
  {
    id: "atlas:FootballSoccerBall", 
    tags: ["atlas", "football", "soccer", "ball"], 
    source: "atlas", 
    name: "FootballSoccerBall",
  }, 
  {
    id: "atlas:FootballSoccerSneakers", 
    tags: ["atlas", "football", "soccer", "sneakers"], 
    source: "atlas", 
    name: "FootballSoccerSneakers",
  }, 
  {
    id: "atlas:ForbiddenCity", 
    tags: ["atlas", "forbidden", "city"], 
    source: "atlas", 
    name: "ForbiddenCity",
  }, 
  {
    id: "atlas:Forklift", 
    tags: ["atlas", "forklift"], 
    source: "atlas", 
    name: "Forklift",
  }, 
  {
    id: "atlas:ForkliftWarehouseVehicle", 
    tags: ["atlas", "forklift", "warehouse", "vehicle"], 
    source: "atlas", 
    name: "ForkliftWarehouseVehicle",
  }, 
  {
    id: "atlas:FormatFile", 
    tags: ["atlas", "format", "file"], 
    source: "atlas", 
    name: "FormatFile",
  }, 
  {
    id: "atlas:ForumSurveyCheckmarkXmark", 
    tags: ["atlas", "forum", "survey", "checkmark", "xmark"], 
    source: "atlas", 
    name: "ForumSurveyCheckmarkXmark",
  }, 
  {
    id: "atlas:ForumSurveyPerson", 
    tags: ["atlas", "forum", "survey", "person"], 
    source: "atlas", 
    name: "ForumSurveyPerson",
  }, 
  {
    id: "atlas:FourFinger", 
    tags: ["atlas", "four", "finger"], 
    source: "atlas", 
    name: "FourFinger",
  }, 
  {
    id: "atlas:Frame360", 
    tags: ["atlas", "frame"], 
    source: "atlas", 
    name: "Frame360",
  }, 
  {
    id: "atlas:Freeze", 
    tags: ["atlas", "freeze"], 
    source: "atlas", 
    name: "Freeze",
  }, 
  {
    id: "atlas:FrenchFries", 
    tags: ["atlas", "french", "fries"], 
    source: "atlas", 
    name: "FrenchFries",
  }, 
  {
    id: "atlas:FreshBread", 
    tags: ["atlas", "fresh", "bread"], 
    source: "atlas", 
    name: "FreshBread",
  }, 
  {
    id: "atlas:Fridge", 
    tags: ["atlas", "fridge"], 
    source: "atlas", 
    name: "Fridge",
  }, 
  {
    id: "atlas:Friendship", 
    tags: ["atlas", "friendship"], 
    source: "atlas", 
    name: "Friendship",
  }, 
  {
    id: "atlas:Frog", 
    tags: ["atlas", "frog"], 
    source: "atlas", 
    name: "Frog",
  }, 
  {
    id: "atlas:FrontDesk", 
    tags: ["atlas", "front", "desk"], 
    source: "atlas", 
    name: "FrontDesk",
  }, 
  {
    id: "atlas:FrontDeskTableMeeting", 
    tags: ["atlas", "front", "desk", "table", "meeting"], 
    source: "atlas", 
    name: "FrontDeskTableMeeting",
  }, 
  {
    id: "atlas:FrontVrVisual", 
    tags: ["atlas", "front", "vr", "visual"], 
    source: "atlas", 
    name: "FrontVrVisual",
  }, 
  {
    id: "atlas:Funnel", 
    tags: ["atlas", "funnel"], 
    source: "atlas", 
    name: "Funnel",
  }, 
  {
    id: "atlas:FunnelSort", 
    tags: ["atlas", "funnel", "sort"], 
    source: "atlas", 
    name: "FunnelSort",
  }, 
  {
    id: "atlas:Furnace", 
    tags: ["atlas", "furnace"], 
    source: "atlas", 
    name: "Furnace",
  }, 
  {
    id: "atlas:GamePlan", 
    tags: ["atlas", "game", "plan"], 
    source: "atlas", 
    name: "GamePlan",
  }, 
  {
    id: "atlas:Gamepad", 
    tags: ["atlas", "gamepad"], 
    source: "atlas", 
    name: "Gamepad",
  }, 
  {
    id: "atlas:Gasoline", 
    tags: ["atlas", "gasoline"], 
    source: "atlas", 
    name: "Gasoline",
  }, 
  {
    id: "atlas:GateLandmark", 
    tags: ["atlas", "gate", "landmark"], 
    source: "atlas", 
    name: "GateLandmark",
  }, 
  {
    id: "atlas:Gear", 
    tags: ["atlas", "gear"], 
    source: "atlas", 
    name: "Gear",
  }, 
  {
    id: "atlas:GearWebsite", 
    tags: ["atlas", "gear", "website"], 
    source: "atlas", 
    name: "GearWebsite",
  }, 
  {
    id: "atlas:Geography", 
    tags: ["atlas", "geography"], 
    source: "atlas", 
    name: "Geography",
  }, 
  {
    id: "atlas:GiftBox", 
    tags: ["atlas", "gift", "box"], 
    source: "atlas", 
    name: "GiftBox",
  }, 
  {
    id: "atlas:GiftSquare", 
    tags: ["atlas", "gift", "square"], 
    source: "atlas", 
    name: "GiftSquare",
  }, 
  {
    id: "atlas:Gifts", 
    tags: ["atlas", "gifts"], 
    source: "atlas", 
    name: "Gifts",
  }, 
  {
    id: "atlas:GingerbreadMan", 
    tags: ["atlas", "gingerbread", "man"], 
    source: "atlas", 
    name: "GingerbreadMan",
  }, 
  {
    id: "atlas:Glasses", 
    tags: ["atlas", "glasses"], 
    source: "atlas", 
    name: "Glasses",
  }, 
  {
    id: "atlas:Glasses3D", 
    tags: ["atlas", "glasses"], 
    source: "atlas", 
    name: "Glasses3D",
  }, 
  {
    id: "atlas:GlassesHelmet", 
    tags: ["atlas", "glasses", "helmet"], 
    source: "atlas", 
    name: "GlassesHelmet",
  }, 
  {
    id: "atlas:GlassesMask", 
    tags: ["atlas", "glasses", "mask"], 
    source: "atlas", 
    name: "GlassesMask",
  }, 
  {
    id: "atlas:GlassesVirtualReality", 
    tags: ["atlas", "glasses", "virtual", "reality"], 
    source: "atlas", 
    name: "GlassesVirtualReality",
  }, 
  {
    id: "atlas:GlassesVision", 
    tags: ["atlas", "glasses", "vision"], 
    source: "atlas", 
    name: "GlassesVision",
  }, 
  {
    id: "atlas:GlazedDonut", 
    tags: ["atlas", "glazed", "donut"], 
    source: "atlas", 
    name: "GlazedDonut",
  }, 
  {
    id: "atlas:GlobalMegaphone", 
    tags: ["atlas", "global", "megaphone"], 
    source: "atlas", 
    name: "GlobalMegaphone",
  }, 
  {
    id: "atlas:GlobalMonitor", 
    tags: ["atlas", "global", "monitor"], 
    source: "atlas", 
    name: "GlobalMonitor",
  }, 
  {
    id: "atlas:GlobalPadlock", 
    tags: ["atlas", "global", "padlock"], 
    source: "atlas", 
    name: "GlobalPadlock",
  }, 
  {
    id: "atlas:GlobalWarming", 
    tags: ["atlas", "global", "warming"], 
    source: "atlas", 
    name: "GlobalWarming",
  }, 
  {
    id: "atlas:GlobePlant", 
    tags: ["atlas", "globe", "plant"], 
    source: "atlas", 
    name: "GlobePlant",
  }, 
  {
    id: "atlas:GlobeWarming", 
    tags: ["atlas", "globe", "warming"], 
    source: "atlas", 
    name: "GlobeWarming",
  }, 
  {
    id: "atlas:Glove", 
    tags: ["atlas", "glove"], 
    source: "atlas", 
    name: "Glove",
  }, 
  {
    id: "atlas:Gloves", 
    tags: ["atlas", "gloves"], 
    source: "atlas", 
    name: "Gloves",
  }, 
  {
    id: "atlas:GoddessSquatPose", 
    tags: ["atlas", "goddess", "squat", "pose"], 
    source: "atlas", 
    name: "GoddessSquatPose",
  }, 
  {
    id: "atlas:GoldenGateBridge", 
    tags: ["atlas", "golden", "gate", "bridge"], 
    source: "atlas", 
    name: "GoldenGateBridge",
  }, 
  {
    id: "atlas:GolfCart", 
    tags: ["atlas", "golf", "cart"], 
    source: "atlas", 
    name: "GolfCart",
  }, 
  {
    id: "atlas:GolfClub", 
    tags: ["atlas", "golf", "club"], 
    source: "atlas", 
    name: "GolfClub",
  }, 
  {
    id: "atlas:Gondola", 
    tags: ["atlas", "gondola"], 
    source: "atlas", 
    name: "Gondola",
  }, 
  {
    id: "atlas:GoogleDrive", 
    tags: ["atlas", "google", "drive"], 
    source: "atlas", 
    name: "GoogleDrive",
  }, 
  {
    id: "atlas:GooglePlus", 
    tags: ["atlas", "google", "plus"], 
    source: "atlas", 
    name: "GooglePlus",
  }, 
  {
    id: "atlas:GovernmentBuilding", 
    tags: ["atlas", "government", "building"], 
    source: "atlas", 
    name: "GovernmentBuilding",
  }, 
  {
    id: "atlas:Graduate", 
    tags: ["atlas", "graduate"], 
    source: "atlas", 
    name: "Graduate",
  }, 
  {
    id: "atlas:Graduation", 
    tags: ["atlas", "graduation"], 
    source: "atlas", 
    name: "Graduation",
  }, 
  {
    id: "atlas:Grapes", 
    tags: ["atlas", "grapes"], 
    source: "atlas", 
    name: "Grapes",
  }, 
  {
    id: "atlas:GraphAccountCircle", 
    tags: ["atlas", "graph", "account", "circle"], 
    source: "atlas", 
    name: "GraphAccountCircle",
  }, 
  {
    id: "atlas:GraphArrows", 
    tags: ["atlas", "graph", "arrows"], 
    source: "atlas", 
    name: "GraphArrows",
  }, 
  {
    id: "atlas:GraphChart", 
    tags: ["atlas", "graph", "chart"], 
    source: "atlas", 
    name: "GraphChart",
  }, 
  {
    id: "atlas:GraphChat", 
    tags: ["atlas", "graph", "chat"], 
    source: "atlas", 
    name: "GraphChat",
  }, 
  {
    id: "atlas:GraphDocument", 
    tags: ["atlas", "graph", "document"], 
    source: "atlas", 
    name: "GraphDocument",
  }, 
  {
    id: "atlas:GraphFile", 
    tags: ["atlas", "graph", "file"], 
    source: "atlas", 
    name: "GraphFile",
  }, 
  {
    id: "atlas:GraphLinesClipboard", 
    tags: ["atlas", "graph", "lines", "clipboard"], 
    source: "atlas", 
    name: "GraphLinesClipboard",
  }, 
  {
    id: "atlas:GraphLinesFolder", 
    tags: ["atlas", "graph", "lines", "folder"], 
    source: "atlas", 
    name: "GraphLinesFolder",
  }, 
  {
    id: "atlas:GraphMessage", 
    tags: ["atlas", "graph", "message"], 
    source: "atlas", 
    name: "GraphMessage",
  }, 
  {
    id: "atlas:GreatBuddha", 
    tags: ["atlas", "great", "buddha"], 
    source: "atlas", 
    name: "GreatBuddha",
  }, 
  {
    id: "atlas:GreatWall", 
    tags: ["atlas", "great", "wall"], 
    source: "atlas", 
    name: "GreatWall",
  }, 
  {
    id: "atlas:GreekChurch", 
    tags: ["atlas", "greek", "church"], 
    source: "atlas", 
    name: "GreekChurch",
  }, 
  {
    id: "atlas:GreenBattery", 
    tags: ["atlas", "green", "battery"], 
    source: "atlas", 
    name: "GreenBattery",
  }, 
  {
    id: "atlas:GreenBook", 
    tags: ["atlas", "green", "book"], 
    source: "atlas", 
    name: "GreenBook",
  }, 
  {
    id: "atlas:GreenCan", 
    tags: ["atlas", "green", "can"], 
    source: "atlas", 
    name: "GreenCan",
  }, 
  {
    id: "atlas:GreenCar", 
    tags: ["atlas", "green", "car"], 
    source: "atlas", 
    name: "GreenCar",
  }, 
  {
    id: "atlas:GreenCharge", 
    tags: ["atlas", "green", "charge"], 
    source: "atlas", 
    name: "GreenCharge",
  }, 
  {
    id: "atlas:GreenContainer", 
    tags: ["atlas", "green", "container"], 
    source: "atlas", 
    name: "GreenContainer",
  }, 
  {
    id: "atlas:GreenFactory", 
    tags: ["atlas", "green", "factory"], 
    source: "atlas", 
    name: "GreenFactory",
  }, 
  {
    id: "atlas:GreenGas", 
    tags: ["atlas", "green", "gas"], 
    source: "atlas", 
    name: "GreenGas",
  }, 
  {
    id: "atlas:GreenHouse", 
    tags: ["atlas", "green", "house"], 
    source: "atlas", 
    name: "GreenHouse",
  }, 
  {
    id: "atlas:GreenLightbulb", 
    tags: ["atlas", "green", "lightbulb"], 
    source: "atlas", 
    name: "GreenLightbulb",
  }, 
  {
    id: "atlas:GreenTestTube", 
    tags: ["atlas", "green", "test", "tube"], 
    source: "atlas", 
    name: "GreenTestTube",
  }, 
  {
    id: "atlas:GreenThought", 
    tags: ["atlas", "green", "thought"], 
    source: "atlas", 
    name: "GreenThought",
  }, 
  {
    id: "atlas:GreenWater", 
    tags: ["atlas", "green", "water"], 
    source: "atlas", 
    name: "GreenWater",
  }, 
  {
    id: "atlas:GreetingTwoPeople", 
    tags: ["atlas", "greeting", "two", "people"], 
    source: "atlas", 
    name: "GreetingTwoPeople",
  }, 
  {
    id: "atlas:Grid", 
    tags: ["atlas", "grid"], 
    source: "atlas", 
    name: "Grid",
  }, 
  {
    id: "atlas:GripEquipment", 
    tags: ["atlas", "grip", "equipment"], 
    source: "atlas", 
    name: "GripEquipment",
  }, 
  {
    id: "atlas:GroupPeopleArrowUp", 
    tags: ["atlas", "group", "people", "arrow", "up"], 
    source: "atlas", 
    name: "GroupPeopleArrowUp",
  }, 
  {
    id: "atlas:GroupPeopleConfirmCheckmark", 
    tags: ["atlas", "group", "people", "confirm", "checkmark"], 
    source: "atlas", 
    name: "GroupPeopleConfirmCheckmark",
  }, 
  {
    id: "atlas:GroupPeopleStar", 
    tags: ["atlas", "group", "people", "star"], 
    source: "atlas", 
    name: "GroupPeopleStar",
  }, 
  {
    id: "atlas:GroupProjectPresentation", 
    tags: ["atlas", "group", "project", "presentation"], 
    source: "atlas", 
    name: "GroupProjectPresentation",
  }, 
  {
    id: "atlas:GroupTeam", 
    tags: ["atlas", "group", "team"], 
    source: "atlas", 
    name: "GroupTeam",
  }, 
  {
    id: "atlas:GroupTeamCollective", 
    tags: ["atlas", "group", "team", "collective"], 
    source: "atlas", 
    name: "GroupTeamCollective",
  }, 
  {
    id: "atlas:GroupTeamNetworkConnect", 
    tags: ["atlas", "group", "team", "network", "connect"], 
    source: "atlas", 
    name: "GroupTeamNetworkConnect",
  }, 
  {
    id: "atlas:GroupTripleArrows", 
    tags: ["atlas", "group", "triple", "arrows"], 
    source: "atlas", 
    name: "GroupTripleArrows",
  }, 
  {
    id: "atlas:Gym", 
    tags: ["atlas", "gym"], 
    source: "atlas", 
    name: "Gym",
  }, 
  {
    id: "atlas:GymBag", 
    tags: ["atlas", "gym", "bag"], 
    source: "atlas", 
    name: "GymBag",
  }, 
  {
    id: "atlas:GymWeights", 
    tags: ["atlas", "gym", "weights"], 
    source: "atlas", 
    name: "GymWeights",
  }, 
  {
    id: "atlas:GymnasticsOlympics", 
    tags: ["atlas", "gymnastics", "olympics"], 
    source: "atlas", 
    name: "GymnasticsOlympics",
  }, 
  {
    id: "atlas:GymnasticsRings", 
    tags: ["atlas", "gymnastics", "rings"], 
    source: "atlas", 
    name: "GymnasticsRings",
  }, 
  {
    id: "atlas:Hail", 
    tags: ["atlas", "hail"], 
    source: "atlas", 
    name: "Hail",
  }, 
  {
    id: "atlas:HairDryer", 
    tags: ["atlas", "hair", "dryer"], 
    source: "atlas", 
    name: "HairDryer",
  }, 
  {
    id: "atlas:HalfMoonPose", 
    tags: ["atlas", "half", "moon", "pose"], 
    source: "atlas", 
    name: "HalfMoonPose",
  }, 
  {
    id: "atlas:Hamburger", 
    tags: ["atlas", "hamburger"], 
    source: "atlas", 
    name: "Hamburger",
  }, 
  {
    id: "atlas:Hammer", 
    tags: ["atlas", "hammer"], 
    source: "atlas", 
    name: "Hammer",
  }, 
  {
    id: "atlas:HammerNail", 
    tags: ["atlas", "hammer", "nail"], 
    source: "atlas", 
    name: "HammerNail",
  }, 
  {
    id: "atlas:HammerTool", 
    tags: ["atlas", "hammer", "tool"], 
    source: "atlas", 
    name: "HammerTool",
  }, 
  {
    id: "atlas:HandGestureAccount", 
    tags: ["atlas", "hand", "gesture", "account"], 
    source: "atlas", 
    name: "HandGestureAccount",
  }, 
  {
    id: "atlas:HandGestureFlag", 
    tags: ["atlas", "hand", "gesture", "flag"], 
    source: "atlas", 
    name: "HandGestureFlag",
  }, 
  {
    id: "atlas:HandHoldingGlobe", 
    tags: ["atlas", "hand", "holding", "globe"], 
    source: "atlas", 
    name: "HandHoldingGlobe",
  }, 
  {
    id: "atlas:HandHoldingPlant", 
    tags: ["atlas", "hand", "holding", "plant"], 
    source: "atlas", 
    name: "HandHoldingPlant",
  }, 
  {
    id: "atlas:HandHoldingSeedling", 
    tags: ["atlas", "hand", "holding", "seedling"], 
    source: "atlas", 
    name: "HandHoldingSeedling",
  }, 
  {
    id: "atlas:HandHoldingWater", 
    tags: ["atlas", "hand", "holding", "water"], 
    source: "atlas", 
    name: "HandHoldingWater",
  }, 
  {
    id: "atlas:HandKey", 
    tags: ["atlas", "hand", "key"], 
    source: "atlas", 
    name: "HandKey",
  }, 
  {
    id: "atlas:HandballBall", 
    tags: ["atlas", "handball", "ball"], 
    source: "atlas", 
    name: "HandballBall",
  }, 
  {
    id: "atlas:HandsGestureDiamond", 
    tags: ["atlas", "hands", "gesture", "diamond"], 
    source: "atlas", 
    name: "HandsGestureDiamond",
  }, 
  {
    id: "atlas:HandsGestureStar", 
    tags: ["atlas", "hands", "gesture", "star"], 
    source: "atlas", 
    name: "HandsGestureStar",
  }, 
  {
    id: "atlas:HandshakeAgreementDeal", 
    tags: ["atlas", "handshake", "agreement", "deal"], 
    source: "atlas", 
    name: "HandshakeAgreementDeal",
  }, 
  {
    id: "atlas:HandshakeHandGesture", 
    tags: ["atlas", "handshake", "hand", "gesture"], 
    source: "atlas", 
    name: "HandshakeHandGesture",
  }, 
  {
    id: "atlas:HandstandPose", 
    tags: ["atlas", "handstand", "pose"], 
    source: "atlas", 
    name: "HandstandPose",
  }, 
  {
    id: "atlas:HangingFrame", 
    tags: ["atlas", "hanging", "frame"], 
    source: "atlas", 
    name: "HangingFrame",
  }, 
  {
    id: "atlas:HangingPresentation", 
    tags: ["atlas", "hanging", "presentation"], 
    source: "atlas", 
    name: "HangingPresentation",
  }, 
  {
    id: "atlas:HangingSignDollar", 
    tags: ["atlas", "hanging", "sign", "dollar"], 
    source: "atlas", 
    name: "HangingSignDollar",
  }, 
  {
    id: "atlas:HangingSignStar", 
    tags: ["atlas", "hanging", "sign", "star"], 
    source: "atlas", 
    name: "HangingSignStar",
  }, 
  {
    id: "atlas:Hangout", 
    tags: ["atlas", "hangout"], 
    source: "atlas", 
    name: "Hangout",
  }, 
  {
    id: "atlas:HardDisk", 
    tags: ["atlas", "hard", "disk"], 
    source: "atlas", 
    name: "HardDisk",
  }, 
  {
    id: "atlas:Hardware", 
    tags: ["atlas", "hardware"], 
    source: "atlas", 
    name: "Hardware",
  }, 
  {
    id: "atlas:Hat", 
    tags: ["atlas", "hat"], 
    source: "atlas", 
    name: "Hat",
  }, 
  {
    id: "atlas:HatFashion", 
    tags: ["atlas", "hat", "fashion"], 
    source: "atlas", 
    name: "HatFashion",
  }, 
  {
    id: "atlas:HatSanta", 
    tags: ["atlas", "hat", "santa"], 
    source: "atlas", 
    name: "HatSanta",
  }, 
  {
    id: "atlas:HdDesktop", 
    tags: ["atlas", "hd", "desktop"], 
    source: "atlas", 
    name: "HdDesktop",
  }, 
  {
    id: "atlas:HeadGear", 
    tags: ["atlas", "head", "gear"], 
    source: "atlas", 
    name: "HeadGear",
  }, 
  {
    id: "atlas:Headphones", 
    tags: ["atlas", "headphones"], 
    source: "atlas", 
    name: "Headphones",
  }, 
  {
    id: "atlas:HeadstandPose", 
    tags: ["atlas", "headstand", "pose"], 
    source: "atlas", 
    name: "HeadstandPose",
  }, 
  {
    id: "atlas:Heart", 
    tags: ["atlas", "heart"], 
    source: "atlas", 
    name: "Heart",
  }, 
  {
    id: "atlas:HeartArrow", 
    tags: ["atlas", "heart", "arrow"], 
    source: "atlas", 
    name: "HeartArrow",
  }, 
  {
    id: "atlas:HeartBalloon", 
    tags: ["atlas", "heart", "balloon"], 
    source: "atlas", 
    name: "HeartBalloon",
  }, 
  {
    id: "atlas:HeartBed", 
    tags: ["atlas", "heart", "bed"], 
    source: "atlas", 
    name: "HeartBed",
  }, 
  {
    id: "atlas:HeartBook", 
    tags: ["atlas", "heart", "book"], 
    source: "atlas", 
    name: "HeartBook",
  }, 
  {
    id: "atlas:HeartBow", 
    tags: ["atlas", "heart", "bow"], 
    source: "atlas", 
    name: "HeartBow",
  }, 
  {
    id: "atlas:HeartBox", 
    tags: ["atlas", "heart", "box"], 
    source: "atlas", 
    name: "HeartBox",
  }, 
  {
    id: "atlas:HeartCalendar", 
    tags: ["atlas", "heart", "calendar"], 
    source: "atlas", 
    name: "HeartCalendar",
  }, 
  {
    id: "atlas:HeartCandle", 
    tags: ["atlas", "heart", "candle"], 
    source: "atlas", 
    name: "HeartCandle",
  }, 
  {
    id: "atlas:HeartCandles", 
    tags: ["atlas", "heart", "candles"], 
    source: "atlas", 
    name: "HeartCandles",
  }, 
  {
    id: "atlas:HeartCard", 
    tags: ["atlas", "heart", "card"], 
    source: "atlas", 
    name: "HeartCard",
  }, 
  {
    id: "atlas:HeartChat", 
    tags: ["atlas", "heart", "chat"], 
    source: "atlas", 
    name: "HeartChat",
  }, 
  {
    id: "atlas:HeartChats", 
    tags: ["atlas", "heart", "chats"], 
    source: "atlas", 
    name: "HeartChats",
  }, 
  {
    id: "atlas:HeartChemistry", 
    tags: ["atlas", "heart", "chemistry"], 
    source: "atlas", 
    name: "HeartChemistry",
  }, 
  {
    id: "atlas:HeartClipboard", 
    tags: ["atlas", "heart", "clipboard"], 
    source: "atlas", 
    name: "HeartClipboard",
  }, 
  {
    id: "atlas:HeartComment", 
    tags: ["atlas", "heart", "comment"], 
    source: "atlas", 
    name: "HeartComment",
  }, 
  {
    id: "atlas:HeartCommentGroup", 
    tags: ["atlas", "heart", "comment", "group"], 
    source: "atlas", 
    name: "HeartCommentGroup",
  }, 
  {
    id: "atlas:HeartEarth", 
    tags: ["atlas", "heart", "earth"], 
    source: "atlas", 
    name: "HeartEarth",
  }, 
  {
    id: "atlas:HeartEnvelope", 
    tags: ["atlas", "heart", "envelope"], 
    source: "atlas", 
    name: "HeartEnvelope",
  }, 
  {
    id: "atlas:HeartFile", 
    tags: ["atlas", "heart", "file"], 
    source: "atlas", 
    name: "HeartFile",
  }, 
  {
    id: "atlas:HeartFolder", 
    tags: ["atlas", "heart", "folder"], 
    source: "atlas", 
    name: "HeartFolder",
  }, 
  {
    id: "atlas:HeartGlasses", 
    tags: ["atlas", "heart", "glasses"], 
    source: "atlas", 
    name: "HeartGlasses",
  }, 
  {
    id: "atlas:HeartHandGesture", 
    tags: ["atlas", "heart", "hand", "gesture"], 
    source: "atlas", 
    name: "HeartHandGesture",
  }, 
  {
    id: "atlas:HeartHome", 
    tags: ["atlas", "heart", "home"], 
    source: "atlas", 
    name: "HeartHome",
  }, 
  {
    id: "atlas:HeartKey", 
    tags: ["atlas", "heart", "key"], 
    source: "atlas", 
    name: "HeartKey",
  }, 
  {
    id: "atlas:HeartLockKey", 
    tags: ["atlas", "heart", "lock", "key"], 
    source: "atlas", 
    name: "HeartLockKey",
  }, 
  {
    id: "atlas:HeartLoveYou", 
    tags: ["atlas", "heart", "love", "you"], 
    source: "atlas", 
    name: "HeartLoveYou",
  }, 
  {
    id: "atlas:HeartMail", 
    tags: ["atlas", "heart", "mail"], 
    source: "atlas", 
    name: "HeartMail",
  }, 
  {
    id: "atlas:HeartMessage", 
    tags: ["atlas", "heart", "message"], 
    source: "atlas", 
    name: "HeartMessage",
  }, 
  {
    id: "atlas:HeartMobile", 
    tags: ["atlas", "heart", "mobile"], 
    source: "atlas", 
    name: "HeartMobile",
  }, 
  {
    id: "atlas:HeartMonitor", 
    tags: ["atlas", "heart", "monitor"], 
    source: "atlas", 
    name: "HeartMonitor",
  }, 
  {
    id: "atlas:HeartMug", 
    tags: ["atlas", "heart", "mug"], 
    source: "atlas", 
    name: "HeartMug",
  }, 
  {
    id: "atlas:HeartMusic", 
    tags: ["atlas", "heart", "music"], 
    source: "atlas", 
    name: "HeartMusic",
  }, 
  {
    id: "atlas:HeartPadlock", 
    tags: ["atlas", "heart", "padlock"], 
    source: "atlas", 
    name: "HeartPadlock",
  }, 
  {
    id: "atlas:HeartPaper", 
    tags: ["atlas", "heart", "paper"], 
    source: "atlas", 
    name: "HeartPaper",
  }, 
  {
    id: "atlas:HeartPen", 
    tags: ["atlas", "heart", "pen"], 
    source: "atlas", 
    name: "HeartPen",
  }, 
  {
    id: "atlas:HeartPerfume", 
    tags: ["atlas", "heart", "perfume"], 
    source: "atlas", 
    name: "HeartPerfume",
  }, 
  {
    id: "atlas:HeartPin", 
    tags: ["atlas", "heart", "pin"], 
    source: "atlas", 
    name: "HeartPin",
  }, 
  {
    id: "atlas:HeartPlant", 
    tags: ["atlas", "heart", "plant"], 
    source: "atlas", 
    name: "HeartPlant",
  }, 
  {
    id: "atlas:HeartRate", 
    tags: ["atlas", "heart", "rate"], 
    source: "atlas", 
    name: "HeartRate",
  }, 
  {
    id: "atlas:HeartRateClipboard", 
    tags: ["atlas", "heart", "rate", "clipboard"], 
    source: "atlas", 
    name: "HeartRateClipboard",
  }, 
  {
    id: "atlas:HeartRoomService", 
    tags: ["atlas", "heart", "room", "service"], 
    source: "atlas", 
    name: "HeartRoomService",
  }, 
  {
    id: "atlas:HeartShirt", 
    tags: ["atlas", "heart", "shirt"], 
    source: "atlas", 
    name: "HeartShirt",
  }, 
  {
    id: "atlas:HeartSuitcase", 
    tags: ["atlas", "heart", "suitcase"], 
    source: "atlas", 
    name: "HeartSuitcase",
  }, 
  {
    id: "atlas:HeartTicket", 
    tags: ["atlas", "heart", "ticket"], 
    source: "atlas", 
    name: "HeartTicket",
  }, 
  {
    id: "atlas:HeartUnreadEnvelope", 
    tags: ["atlas", "heart", "unread", "envelope"], 
    source: "atlas", 
    name: "HeartUnreadEnvelope",
  }, 
  {
    id: "atlas:HeartVideo", 
    tags: ["atlas", "heart", "video"], 
    source: "atlas", 
    name: "HeartVideo",
  }, 
  {
    id: "atlas:HeartWater", 
    tags: ["atlas", "heart", "water"], 
    source: "atlas", 
    name: "HeartWater",
  }, 
  {
    id: "atlas:HeartrateMonitor", 
    tags: ["atlas", "heartrate", "monitor"], 
    source: "atlas", 
    name: "HeartrateMonitor",
  }, 
  {
    id: "atlas:Hearts", 
    tags: ["atlas", "hearts"], 
    source: "atlas", 
    name: "Hearts",
  }, 
  {
    id: "atlas:HeatingFurnace", 
    tags: ["atlas", "heating", "furnace"], 
    source: "atlas", 
    name: "HeatingFurnace",
  }, 
  {
    id: "atlas:HeavyRain", 
    tags: ["atlas", "heavy", "rain"], 
    source: "atlas", 
    name: "HeavyRain",
  }, 
  {
    id: "atlas:HeavyWeights", 
    tags: ["atlas", "heavy", "weights"], 
    source: "atlas", 
    name: "HeavyWeights",
  }, 
  {
    id: "atlas:Helicopter", 
    tags: ["atlas", "helicopter"], 
    source: "atlas", 
    name: "Helicopter",
  }, 
  {
    id: "atlas:HelicopterTravel", 
    tags: ["atlas", "helicopter", "travel"], 
    source: "atlas", 
    name: "HelicopterTravel",
  }, 
  {
    id: "atlas:Helmet", 
    tags: ["atlas", "helmet"], 
    source: "atlas", 
    name: "Helmet",
  }, 
  {
    id: "atlas:HerbMix", 
    tags: ["atlas", "herb", "mix"], 
    source: "atlas", 
    name: "HerbMix",
  }, 
  {
    id: "atlas:HerbalMixPlus", 
    tags: ["atlas", "herbal", "mix", "plus"], 
    source: "atlas", 
    name: "HerbalMixPlus",
  }, 
  {
    id: "atlas:Hierarchy", 
    tags: ["atlas", "hierarchy"], 
    source: "atlas", 
    name: "Hierarchy",
  }, 
  {
    id: "atlas:HierarchyAccountUser", 
    tags: ["atlas", "hierarchy", "account", "user"], 
    source: "atlas", 
    name: "HierarchyAccountUser",
  }, 
  {
    id: "atlas:HierarchyCircle", 
    tags: ["atlas", "hierarchy", "circle"], 
    source: "atlas", 
    name: "HierarchyCircle",
  }, 
  {
    id: "atlas:HighFive", 
    tags: ["atlas", "high", "five"], 
    source: "atlas", 
    name: "HighFive",
  }, 
  {
    id: "atlas:HighVolume", 
    tags: ["atlas", "high", "volume"], 
    source: "atlas", 
    name: "HighVolume",
  }, 
  {
    id: "atlas:HockeyStick", 
    tags: ["atlas", "hockey", "stick"], 
    source: "atlas", 
    name: "HockeyStick",
  }, 
  {
    id: "atlas:Hold", 
    tags: ["atlas", "hold"], 
    source: "atlas", 
    name: "Hold",
  }, 
  {
    id: "atlas:Home", 
    tags: ["atlas", "home"], 
    source: "atlas", 
    name: "Home",
  }, 
  {
    id: "atlas:HomeLayout", 
    tags: ["atlas", "home", "layout"], 
    source: "atlas", 
    name: "HomeLayout",
  }, 
  {
    id: "atlas:HomeMessage", 
    tags: ["atlas", "home", "message"], 
    source: "atlas", 
    name: "HomeMessage",
  }, 
  {
    id: "atlas:HomePaper", 
    tags: ["atlas", "home", "paper"], 
    source: "atlas", 
    name: "HomePaper",
  }, 
  {
    id: "atlas:HomePin", 
    tags: ["atlas", "home", "pin"], 
    source: "atlas", 
    name: "HomePin",
  }, 
  {
    id: "atlas:HomeWindow", 
    tags: ["atlas", "home", "window"], 
    source: "atlas", 
    name: "HomeWindow",
  }, 
  {
    id: "atlas:HoneyJar", 
    tags: ["atlas", "honey", "jar"], 
    source: "atlas", 
    name: "HoneyJar",
  }, 
  {
    id: "atlas:HorizontalCenter", 
    tags: ["atlas", "horizontal", "center"], 
    source: "atlas", 
    name: "HorizontalCenter",
  }, 
  {
    id: "atlas:HorizontalSlidersDots", 
    tags: ["atlas", "horizontal", "sliders", "dots"], 
    source: "atlas", 
    name: "HorizontalSlidersDots",
  }, 
  {
    id: "atlas:HorizontalSlidersLines", 
    tags: ["atlas", "horizontal", "sliders", "lines"], 
    source: "atlas", 
    name: "HorizontalSlidersLines",
  }, 
  {
    id: "atlas:HospitalBuilding", 
    tags: ["atlas", "hospital", "building"], 
    source: "atlas", 
    name: "HospitalBuilding",
  }, 
  {
    id: "atlas:HospitalSign", 
    tags: ["atlas", "hospital", "sign"], 
    source: "atlas", 
    name: "HospitalSign",
  }, 
  {
    id: "atlas:HotAirBalloon", 
    tags: ["atlas", "hot", "air", "balloon"], 
    source: "atlas", 
    name: "HotAirBalloon",
  }, 
  {
    id: "atlas:HotCocoa", 
    tags: ["atlas", "hot", "cocoa"], 
    source: "atlas", 
    name: "HotCocoa",
  }, 
  {
    id: "atlas:HotDrink", 
    tags: ["atlas", "hot", "drink"], 
    source: "atlas", 
    name: "HotDrink",
  }, 
  {
    id: "atlas:HotDrinkMug", 
    tags: ["atlas", "hot", "drink", "mug"], 
    source: "atlas", 
    name: "HotDrinkMug",
  }, 
  {
    id: "atlas:HotFlame", 
    tags: ["atlas", "hot", "flame"], 
    source: "atlas", 
    name: "HotFlame",
  }, 
  {
    id: "atlas:HotFood", 
    tags: ["atlas", "hot", "food"], 
    source: "atlas", 
    name: "HotFood",
  }, 
  {
    id: "atlas:HotSeat", 
    tags: ["atlas", "hot", "seat"], 
    source: "atlas", 
    name: "HotSeat",
  }, 
  {
    id: "atlas:HotStoneMassage", 
    tags: ["atlas", "hot", "stone", "massage"], 
    source: "atlas", 
    name: "HotStoneMassage",
  }, 
  {
    id: "atlas:HotTemperature", 
    tags: ["atlas", "hot", "temperature"], 
    source: "atlas", 
    name: "HotTemperature",
  }, 
  {
    id: "atlas:Hotdog", 
    tags: ["atlas", "hotdog"], 
    source: "atlas", 
    name: "Hotdog",
  }, 
  {
    id: "atlas:HotelConcierge", 
    tags: ["atlas", "hotel", "concierge"], 
    source: "atlas", 
    name: "HotelConcierge",
  }, 
  {
    id: "atlas:HotelLocation", 
    tags: ["atlas", "hotel", "location"], 
    source: "atlas", 
    name: "HotelLocation",
  }, 
  {
    id: "atlas:HotelMobile", 
    tags: ["atlas", "hotel", "mobile"], 
    source: "atlas", 
    name: "HotelMobile",
  }, 
  {
    id: "atlas:House", 
    tags: ["atlas", "house"], 
    source: "atlas", 
    name: "House",
  }, 
  {
    id: "atlas:HouseDocument", 
    tags: ["atlas", "house", "document"], 
    source: "atlas", 
    name: "HouseDocument",
  }, 
  {
    id: "atlas:HouseHand", 
    tags: ["atlas", "house", "hand"], 
    source: "atlas", 
    name: "HouseHand",
  }, 
  {
    id: "atlas:HouseHome", 
    tags: ["atlas", "house", "home"], 
    source: "atlas", 
    name: "HouseHome",
  }, 
  {
    id: "atlas:HouseKey", 
    tags: ["atlas", "house", "key"], 
    source: "atlas", 
    name: "HouseKey",
  }, 
  {
    id: "atlas:HouseLine", 
    tags: ["atlas", "house", "line"], 
    source: "atlas", 
    name: "HouseLine",
  }, 
  {
    id: "atlas:HouseMedal", 
    tags: ["atlas", "house", "medal"], 
    source: "atlas", 
    name: "HouseMedal",
  }, 
  {
    id: "atlas:HouseMessage", 
    tags: ["atlas", "house", "message"], 
    source: "atlas", 
    name: "HouseMessage",
  }, 
  {
    id: "atlas:HouseMoney", 
    tags: ["atlas", "house", "money"], 
    source: "atlas", 
    name: "HouseMoney",
  }, 
  {
    id: "atlas:HousePaper", 
    tags: ["atlas", "house", "paper"], 
    source: "atlas", 
    name: "HousePaper",
  }, 
  {
    id: "atlas:HousePin", 
    tags: ["atlas", "house", "pin"], 
    source: "atlas", 
    name: "HousePin",
  }, 
  {
    id: "atlas:HousePinLocation", 
    tags: ["atlas", "house", "pin", "location"], 
    source: "atlas", 
    name: "HousePinLocation",
  }, 
  {
    id: "atlas:HouseRealEstate", 
    tags: ["atlas", "house", "real", "estate"], 
    source: "atlas", 
    name: "HouseRealEstate",
  }, 
  {
    id: "atlas:HouseShield", 
    tags: ["atlas", "house", "shield"], 
    source: "atlas", 
    name: "HouseShield",
  }, 
  {
    id: "atlas:HouseThermometer", 
    tags: ["atlas", "house", "thermometer"], 
    source: "atlas", 
    name: "HouseThermometer",
  }, 
  {
    id: "atlas:Houses", 
    tags: ["atlas", "houses"], 
    source: "atlas", 
    name: "Houses",
  }, 
  {
    id: "atlas:Hut", 
    tags: ["atlas", "hut"], 
    source: "atlas", 
    name: "Hut",
  }, 
  {
    id: "atlas:IceCream", 
    tags: ["atlas", "ice", "cream"], 
    source: "atlas", 
    name: "IceCream",
  }, 
  {
    id: "atlas:IceCreamCone", 
    tags: ["atlas", "ice", "cream", "cone"], 
    source: "atlas", 
    name: "IceCreamCone",
  }, 
  {
    id: "atlas:IceCreamStick", 
    tags: ["atlas", "ice", "cream", "stick"], 
    source: "atlas", 
    name: "IceCreamStick",
  }, 
  {
    id: "atlas:IceCreamStickFood", 
    tags: ["atlas", "ice", "cream", "stick", "food"], 
    source: "atlas", 
    name: "IceCreamStickFood",
  }, 
  {
    id: "atlas:IceCreams", 
    tags: ["atlas", "ice", "creams"], 
    source: "atlas", 
    name: "IceCreams",
  }, 
  {
    id: "atlas:IceSkate", 
    tags: ["atlas", "ice", "skate"], 
    source: "atlas", 
    name: "IceSkate",
  }, 
  {
    id: "atlas:IdCard", 
    tags: ["atlas", "id", "card"], 
    source: "atlas", 
    name: "IdCard",
  }, 
  {
    id: "atlas:IdentificationCard", 
    tags: ["atlas", "identification", "card"], 
    source: "atlas", 
    name: "IdentificationCard",
  }, 
  {
    id: "atlas:Igloo", 
    tags: ["atlas", "igloo"], 
    source: "atlas", 
    name: "Igloo",
  }, 
  {
    id: "atlas:Image", 
    tags: ["atlas", "image"], 
    source: "atlas", 
    name: "Image",
  }, 
  {
    id: "atlas:ImageChat", 
    tags: ["atlas", "image", "chat"], 
    source: "atlas", 
    name: "ImageChat",
  }, 
  {
    id: "atlas:ImageGallery", 
    tags: ["atlas", "image", "gallery"], 
    source: "atlas", 
    name: "ImageGallery",
  }, 
  {
    id: "atlas:ImageMessage", 
    tags: ["atlas", "image", "message"], 
    source: "atlas", 
    name: "ImageMessage",
  }, 
  {
    id: "atlas:ImportArrowDown", 
    tags: ["atlas", "import", "arrow", "down"], 
    source: "atlas", 
    name: "ImportArrowDown",
  }, 
  {
    id: "atlas:ImportArrowDownLeft", 
    tags: ["atlas", "import", "arrow", "down", "left"], 
    source: "atlas", 
    name: "ImportArrowDownLeft",
  }, 
  {
    id: "atlas:ImportArrowLeft", 
    tags: ["atlas", "import", "arrow", "left"], 
    source: "atlas", 
    name: "ImportArrowLeft",
  }, 
  {
    id: "atlas:InboxMailbox", 
    tags: ["atlas", "inbox", "mailbox"], 
    source: "atlas", 
    name: "InboxMailbox",
  }, 
  {
    id: "atlas:Incognito", 
    tags: ["atlas", "incognito"], 
    source: "atlas", 
    name: "Incognito",
  }, 
  {
    id: "atlas:IncognitoWindow", 
    tags: ["atlas", "incognito", "window"], 
    source: "atlas", 
    name: "IncognitoWindow",
  }, 
  {
    id: "atlas:IncreaseArrowUp", 
    tags: ["atlas", "increase", "arrow", "up"], 
    source: "atlas", 
    name: "IncreaseArrowUp",
  }, 
  {
    id: "atlas:IncreaseVolume", 
    tags: ["atlas", "increase", "volume"], 
    source: "atlas", 
    name: "IncreaseVolume",
  }, 
  {
    id: "atlas:IndentLeft", 
    tags: ["atlas", "indent", "left"], 
    source: "atlas", 
    name: "IndentLeft",
  }, 
  {
    id: "atlas:IndentRight", 
    tags: ["atlas", "indent", "right"], 
    source: "atlas", 
    name: "IndentRight",
  }, 
  {
    id: "atlas:IndonesiaBuilding", 
    tags: ["atlas", "indonesia", "building"], 
    source: "atlas", 
    name: "IndonesiaBuilding",
  }, 
  {
    id: "atlas:IndonesiaTower", 
    tags: ["atlas", "indonesia", "tower"], 
    source: "atlas", 
    name: "IndonesiaTower",
  }, 
  {
    id: "atlas:InfoChat", 
    tags: ["atlas", "info", "chat"], 
    source: "atlas", 
    name: "InfoChat",
  }, 
  {
    id: "atlas:InfoCircle", 
    tags: ["atlas", "info", "circle"], 
    source: "atlas", 
    name: "InfoCircle",
  }, 
  {
    id: "atlas:InfoMessage", 
    tags: ["atlas", "info", "message"], 
    source: "atlas", 
    name: "InfoMessage",
  }, 
  {
    id: "atlas:InkBottle", 
    tags: ["atlas", "ink", "bottle"], 
    source: "atlas", 
    name: "InkBottle",
  }, 
  {
    id: "atlas:InkPen", 
    tags: ["atlas", "ink", "pen"], 
    source: "atlas", 
    name: "InkPen",
  }, 
  {
    id: "atlas:Instagram", 
    tags: ["atlas", "instagram"], 
    source: "atlas", 
    name: "Instagram",
  }, 
  {
    id: "atlas:InternationalPeopleGroup", 
    tags: ["atlas", "international", "people", "group"], 
    source: "atlas", 
    name: "InternationalPeopleGroup",
  }, 
  {
    id: "atlas:Interset", 
    tags: ["atlas", "interset"], 
    source: "atlas", 
    name: "Interset",
  }, 
  {
    id: "atlas:Intestine", 
    tags: ["atlas", "intestine"], 
    source: "atlas", 
    name: "Intestine",
  }, 
  {
    id: "atlas:Italic", 
    tags: ["atlas", "italic"], 
    source: "atlas", 
    name: "Italic",
  }, 
  {
    id: "atlas:JamJar", 
    tags: ["atlas", "jam", "jar"], 
    source: "atlas", 
    name: "JamJar",
  }, 
  {
    id: "atlas:Jar", 
    tags: ["atlas", "jar"], 
    source: "atlas", 
    name: "Jar",
  }, 
  {
    id: "atlas:JarHeart", 
    tags: ["atlas", "jar", "heart"], 
    source: "atlas", 
    name: "JarHeart",
  }, 
  {
    id: "atlas:Jeep", 
    tags: ["atlas", "jeep"], 
    source: "atlas", 
    name: "Jeep",
  }, 
  {
    id: "atlas:Jersey", 
    tags: ["atlas", "jersey"], 
    source: "atlas", 
    name: "Jersey",
  }, 
  {
    id: "atlas:JerseyUniform", 
    tags: ["atlas", "jersey", "uniform"], 
    source: "atlas", 
    name: "JerseyUniform",
  }, 
  {
    id: "atlas:JesusBrazil", 
    tags: ["atlas", "jesus", "brazil"], 
    source: "atlas", 
    name: "JesusBrazil",
  }, 
  {
    id: "atlas:Jug", 
    tags: ["atlas", "jug"], 
    source: "atlas", 
    name: "Jug",
  }, 
  {
    id: "atlas:JumpRope", 
    tags: ["atlas", "jump", "rope"], 
    source: "atlas", 
    name: "JumpRope",
  }, 
  {
    id: "atlas:Jumper", 
    tags: ["atlas", "jumper"], 
    source: "atlas", 
    name: "Jumper",
  }, 
  {
    id: "atlas:Justify", 
    tags: ["atlas", "justify"], 
    source: "atlas", 
    name: "Justify",
  }, 
  {
    id: "atlas:JustifyAll", 
    tags: ["atlas", "justify", "all"], 
    source: "atlas", 
    name: "JustifyAll",
  }, 
  {
    id: "atlas:JustifyCenter", 
    tags: ["atlas", "justify", "center"], 
    source: "atlas", 
    name: "JustifyCenter",
  }, 
  {
    id: "atlas:JustifyLeft", 
    tags: ["atlas", "justify", "left"], 
    source: "atlas", 
    name: "JustifyLeft",
  }, 
  {
    id: "atlas:JustifyRight", 
    tags: ["atlas", "justify", "right"], 
    source: "atlas", 
    name: "JustifyRight",
  }, 
  {
    id: "atlas:Kabab", 
    tags: ["atlas", "kabab"], 
    source: "atlas", 
    name: "Kabab",
  }, 
  {
    id: "atlas:Key", 
    tags: ["atlas", "key"], 
    source: "atlas", 
    name: "Key",
  }, 
  {
    id: "atlas:KeyMonitor", 
    tags: ["atlas", "key", "monitor"], 
    source: "atlas", 
    name: "KeyMonitor",
  }, 
  {
    id: "atlas:KeyWebsite", 
    tags: ["atlas", "key", "website"], 
    source: "atlas", 
    name: "KeyWebsite",
  }, 
  {
    id: "atlas:Keyboard", 
    tags: ["atlas", "keyboard"], 
    source: "atlas", 
    name: "Keyboard",
  }, 
  {
    id: "atlas:KeyboardPointerUp", 
    tags: ["atlas", "keyboard", "pointer", "up"], 
    source: "atlas", 
    name: "KeyboardPointerUp",
  }, 
  {
    id: "atlas:KeyboardTyping", 
    tags: ["atlas", "keyboard", "typing"], 
    source: "atlas", 
    name: "KeyboardTyping",
  }, 
  {
    id: "atlas:Keycard", 
    tags: ["atlas", "keycard"], 
    source: "atlas", 
    name: "Keycard",
  }, 
  {
    id: "atlas:Keys", 
    tags: ["atlas", "keys"], 
    source: "atlas", 
    name: "Keys",
  }, 
  {
    id: "atlas:KgWeight", 
    tags: ["atlas", "kg", "weight"], 
    source: "atlas", 
    name: "KgWeight",
  }, 
  {
    id: "atlas:KidScooter", 
    tags: ["atlas", "kid", "scooter"], 
    source: "atlas", 
    name: "KidScooter",
  }, 
  {
    id: "atlas:Kidneys", 
    tags: ["atlas", "kidneys"], 
    source: "atlas", 
    name: "Kidneys",
  }, 
  {
    id: "atlas:LabAppliance", 
    tags: ["atlas", "lab", "appliance"], 
    source: "atlas", 
    name: "LabAppliance",
  }, 
  {
    id: "atlas:LabCoat", 
    tags: ["atlas", "lab", "coat"], 
    source: "atlas", 
    name: "LabCoat",
  }, 
  {
    id: "atlas:LabTestTube", 
    tags: ["atlas", "lab", "test", "tube"], 
    source: "atlas", 
    name: "LabTestTube",
  }, 
  {
    id: "atlas:LabToolCurve", 
    tags: ["atlas", "lab", "tool", "curve"], 
    source: "atlas", 
    name: "LabToolCurve",
  }, 
  {
    id: "atlas:LaboratoryList", 
    tags: ["atlas", "laboratory", "list"], 
    source: "atlas", 
    name: "LaboratoryList",
  }, 
  {
    id: "atlas:LaboratoryTestTube", 
    tags: ["atlas", "laboratory", "test", "tube"], 
    source: "atlas", 
    name: "LaboratoryTestTube",
  }, 
  {
    id: "atlas:LaboratoryTool", 
    tags: ["atlas", "laboratory", "tool"], 
    source: "atlas", 
    name: "LaboratoryTool",
  }, 
  {
    id: "atlas:Ladder", 
    tags: ["atlas", "ladder"], 
    source: "atlas", 
    name: "Ladder",
  }, 
  {
    id: "atlas:LadderAccountUp", 
    tags: ["atlas", "ladder", "account", "up"], 
    source: "atlas", 
    name: "LadderAccountUp",
  }, 
  {
    id: "atlas:LadderStar", 
    tags: ["atlas", "ladder", "star"], 
    source: "atlas", 
    name: "LadderStar",
  }, 
  {
    id: "atlas:LadderTool", 
    tags: ["atlas", "ladder", "tool"], 
    source: "atlas", 
    name: "LadderTool",
  }, 
  {
    id: "atlas:LadderTruck", 
    tags: ["atlas", "ladder", "truck"], 
    source: "atlas", 
    name: "LadderTruck",
  }, 
  {
    id: "atlas:LadyLiberty", 
    tags: ["atlas", "lady", "liberty"], 
    source: "atlas", 
    name: "LadyLiberty",
  }, 
  {
    id: "atlas:Lamp", 
    tags: ["atlas", "lamp"], 
    source: "atlas", 
    name: "Lamp",
  }, 
  {
    id: "atlas:LandmarkChurch", 
    tags: ["atlas", "landmark", "church"], 
    source: "atlas", 
    name: "LandmarkChurch",
  }, 
  {
    id: "atlas:Landscape", 
    tags: ["atlas", "landscape"], 
    source: "atlas", 
    name: "Landscape",
  }, 
  {
    id: "atlas:LanguageTranslation", 
    tags: ["atlas", "language", "translation"], 
    source: "atlas", 
    name: "LanguageTranslation",
  }, 
  {
    id: "atlas:Lantern", 
    tags: ["atlas", "lantern"], 
    source: "atlas", 
    name: "Lantern",
  }, 
  {
    id: "atlas:LanternFireLight", 
    tags: ["atlas", "lantern", "fire", "light"], 
    source: "atlas", 
    name: "LanternFireLight",
  }, 
  {
    id: "atlas:Laptop", 
    tags: ["atlas", "laptop"], 
    source: "atlas", 
    name: "Laptop",
  }, 
  {
    id: "atlas:LaptopLine", 
    tags: ["atlas", "laptop", "line"], 
    source: "atlas", 
    name: "LaptopLine",
  }, 
  {
    id: "atlas:LaptopLocation", 
    tags: ["atlas", "laptop", "location"], 
    source: "atlas", 
    name: "LaptopLocation",
  }, 
  {
    id: "atlas:LaptopScreen", 
    tags: ["atlas", "laptop", "screen"], 
    source: "atlas", 
    name: "LaptopScreen",
  }, 
  {
    id: "atlas:LargeBus", 
    tags: ["atlas", "large", "bus"], 
    source: "atlas", 
    name: "LargeBus",
  }, 
  {
    id: "atlas:LaunchRocket", 
    tags: ["atlas", "launch", "rocket"], 
    source: "atlas", 
    name: "LaunchRocket",
  }, 
  {
    id: "atlas:LaundryService", 
    tags: ["atlas", "laundry", "service"], 
    source: "atlas", 
    name: "LaundryService",
  }, 
  {
    id: "atlas:Layers", 
    tags: ["atlas", "layers"], 
    source: "atlas", 
    name: "Layers",
  }, 
  {
    id: "atlas:LayoutHalf", 
    tags: ["atlas", "layout", "half"], 
    source: "atlas", 
    name: "LayoutHalf",
  }, 
  {
    id: "atlas:LayoutHalfVertical", 
    tags: ["atlas", "layout", "half", "vertical"], 
    source: "atlas", 
    name: "LayoutHalfVertical",
  }, 
  {
    id: "atlas:LayoutThree", 
    tags: ["atlas", "layout", "three"], 
    source: "atlas", 
    name: "LayoutThree",
  }, 
  {
    id: "atlas:LayoutVertical", 
    tags: ["atlas", "layout", "vertical"], 
    source: "atlas", 
    name: "LayoutVertical",
  }, 
  {
    id: "atlas:Leaf", 
    tags: ["atlas", "leaf"], 
    source: "atlas", 
    name: "Leaf",
  }, 
  {
    id: "atlas:LeafGlobe", 
    tags: ["atlas", "leaf", "globe"], 
    source: "atlas", 
    name: "LeafGlobe",
  }, 
  {
    id: "atlas:LeafMagnifyingGlass", 
    tags: ["atlas", "leaf", "magnifying", "glass"], 
    source: "atlas", 
    name: "LeafMagnifyingGlass",
  }, 
  {
    id: "atlas:LeafMaple", 
    tags: ["atlas", "leaf", "maple"], 
    source: "atlas", 
    name: "LeafMaple",
  }, 
  {
    id: "atlas:LeafPeach", 
    tags: ["atlas", "leaf", "peach"], 
    source: "atlas", 
    name: "LeafPeach",
  }, 
  {
    id: "atlas:LeafShield", 
    tags: ["atlas", "leaf", "shield"], 
    source: "atlas", 
    name: "LeafShield",
  }, 
  {
    id: "atlas:LeafTag", 
    tags: ["atlas", "leaf", "tag"], 
    source: "atlas", 
    name: "LeafTag",
  }, 
  {
    id: "atlas:LeaningTower", 
    tags: ["atlas", "leaning", "tower"], 
    source: "atlas", 
    name: "LeaningTower",
  }, 
  {
    id: "atlas:LeftOrientation", 
    tags: ["atlas", "left", "orientation"], 
    source: "atlas", 
    name: "LeftOrientation",
  }, 
  {
    id: "atlas:LeftRightMove", 
    tags: ["atlas", "left", "right", "move"], 
    source: "atlas", 
    name: "LeftRightMove",
  }, 
  {
    id: "atlas:LeftRightVr", 
    tags: ["atlas", "left", "right", "vr"], 
    source: "atlas", 
    name: "LeftRightVr",
  }, 
  {
    id: "atlas:LegRaisePose", 
    tags: ["atlas", "leg", "raise", "pose"], 
    source: "atlas", 
    name: "LegRaisePose",
  }, 
  {
    id: "atlas:LegStretchSittingPose", 
    tags: ["atlas", "leg", "stretch", "sitting", "pose"], 
    source: "atlas", 
    name: "LegStretchSittingPose",
  }, 
  {
    id: "atlas:LevelTool", 
    tags: ["atlas", "level", "tool"], 
    source: "atlas", 
    name: "LevelTool",
  }, 
  {
    id: "atlas:Library", 
    tags: ["atlas", "library"], 
    source: "atlas", 
    name: "Library",
  }, 
  {
    id: "atlas:LifePreserver", 
    tags: ["atlas", "life", "preserver"], 
    source: "atlas", 
    name: "LifePreserver",
  }, 
  {
    id: "atlas:LifeRing", 
    tags: ["atlas", "life", "ring"], 
    source: "atlas", 
    name: "LifeRing",
  }, 
  {
    id: "atlas:LiftingBars", 
    tags: ["atlas", "lifting", "bars"], 
    source: "atlas", 
    name: "LiftingBars",
  }, 
  {
    id: "atlas:LiftingWeight", 
    tags: ["atlas", "lifting", "weight"], 
    source: "atlas", 
    name: "LiftingWeight",
  }, 
  {
    id: "atlas:Light", 
    tags: ["atlas", "light"], 
    source: "atlas", 
    name: "Light",
  }, 
  {
    id: "atlas:LightCandle", 
    tags: ["atlas", "light", "candle"], 
    source: "atlas", 
    name: "LightCandle",
  }, 
  {
    id: "atlas:LightbulbIdeaPerson", 
    tags: ["atlas", "lightbulb", "idea", "person"], 
    source: "atlas", 
    name: "LightbulbIdeaPerson",
  }, 
  {
    id: "atlas:LightbulbMeeting", 
    tags: ["atlas", "lightbulb", "meeting"], 
    source: "atlas", 
    name: "LightbulbMeeting",
  }, 
  {
    id: "atlas:LighteningCloud", 
    tags: ["atlas", "lightening", "cloud"], 
    source: "atlas", 
    name: "LighteningCloud",
  }, 
  {
    id: "atlas:LighteningCloudRain", 
    tags: ["atlas", "lightening", "cloud", "rain"], 
    source: "atlas", 
    name: "LighteningCloudRain",
  }, 
  {
    id: "atlas:LighteningDay", 
    tags: ["atlas", "lightening", "day"], 
    source: "atlas", 
    name: "LighteningDay",
  }, 
  {
    id: "atlas:LighteningStormCloud", 
    tags: ["atlas", "lightening", "storm", "cloud"], 
    source: "atlas", 
    name: "LighteningStormCloud",
  }, 
  {
    id: "atlas:Lighting", 
    tags: ["atlas", "lighting"], 
    source: "atlas", 
    name: "Lighting",
  }, 
  {
    id: "atlas:LikeThumbsUpSticker", 
    tags: ["atlas", "like", "thumbs", "up", "sticker"], 
    source: "atlas", 
    name: "LikeThumbsUpSticker",
  }, 
  {
    id: "atlas:LineBone", 
    tags: ["atlas", "line", "bone"], 
    source: "atlas", 
    name: "LineBone",
  }, 
  {
    id: "atlas:LineLaptop", 
    tags: ["atlas", "line", "laptop"], 
    source: "atlas", 
    name: "LineLaptop",
  }, 
  {
    id: "atlas:LineMobile", 
    tags: ["atlas", "line", "mobile"], 
    source: "atlas", 
    name: "LineMobile",
  }, 
  {
    id: "atlas:LineMonitor", 
    tags: ["atlas", "line", "monitor"], 
    source: "atlas", 
    name: "LineMonitor",
  }, 
  {
    id: "atlas:LinePresentation", 
    tags: ["atlas", "line", "presentation"], 
    source: "atlas", 
    name: "LinePresentation",
  }, 
  {
    id: "atlas:LineSegment", 
    tags: ["atlas", "line", "segment"], 
    source: "atlas", 
    name: "LineSegment",
  }, 
  {
    id: "atlas:LineWebsite", 
    tags: ["atlas", "line", "website"], 
    source: "atlas", 
    name: "LineWebsite",
  }, 
  {
    id: "atlas:LinesChart", 
    tags: ["atlas", "lines", "chart"], 
    source: "atlas", 
    name: "LinesChart",
  }, 
  {
    id: "atlas:LinesClipboard", 
    tags: ["atlas", "lines", "clipboard"], 
    source: "atlas", 
    name: "LinesClipboard",
  }, 
  {
    id: "atlas:LinesFile", 
    tags: ["atlas", "lines", "file"], 
    source: "atlas", 
    name: "LinesFile",
  }, 
  {
    id: "atlas:LinesFolder", 
    tags: ["atlas", "lines", "folder"], 
    source: "atlas", 
    name: "LinesFolder",
  }, 
  {
    id: "atlas:LinesGraphClipboard", 
    tags: ["atlas", "lines", "graph", "clipboard"], 
    source: "atlas", 
    name: "LinesGraphClipboard",
  }, 
  {
    id: "atlas:LinesGraphFile", 
    tags: ["atlas", "lines", "graph", "file"], 
    source: "atlas", 
    name: "LinesGraphFile",
  }, 
  {
    id: "atlas:LinesHome", 
    tags: ["atlas", "lines", "home"], 
    source: "atlas", 
    name: "LinesHome",
  }, 
  {
    id: "atlas:Link", 
    tags: ["atlas", "link"], 
    source: "atlas", 
    name: "Link",
  }, 
  {
    id: "atlas:LinkChain", 
    tags: ["atlas", "link", "chain"], 
    source: "atlas", 
    name: "LinkChain",
  }, 
  {
    id: "atlas:LinkSelect", 
    tags: ["atlas", "link", "select"], 
    source: "atlas", 
    name: "LinkSelect",
  }, 
  {
    id: "atlas:Linkedin", 
    tags: ["atlas", "linkedin"], 
    source: "atlas", 
    name: "Linkedin",
  }, 
  {
    id: "atlas:Lips", 
    tags: ["atlas", "lips"], 
    source: "atlas", 
    name: "Lips",
  }, 
  {
    id: "atlas:LiquidBottle", 
    tags: ["atlas", "liquid", "bottle"], 
    source: "atlas", 
    name: "LiquidBottle",
  }, 
  {
    id: "atlas:LiquidDrop", 
    tags: ["atlas", "liquid", "drop"], 
    source: "atlas", 
    name: "LiquidDrop",
  }, 
  {
    id: "atlas:LiquidMedicineBag", 
    tags: ["atlas", "liquid", "medicine", "bag"], 
    source: "atlas", 
    name: "LiquidMedicineBag",
  }, 
  {
    id: "atlas:LiquidTransport", 
    tags: ["atlas", "liquid", "transport"], 
    source: "atlas", 
    name: "LiquidTransport",
  }, 
  {
    id: "atlas:LiquidTransportation", 
    tags: ["atlas", "liquid", "transportation"], 
    source: "atlas", 
    name: "LiquidTransportation",
  }, 
  {
    id: "atlas:List", 
    tags: ["atlas", "list"], 
    source: "atlas", 
    name: "List",
  }, 
  {
    id: "atlas:ListChat", 
    tags: ["atlas", "list", "chat"], 
    source: "atlas", 
    name: "ListChat",
  }, 
  {
    id: "atlas:ListClipboard", 
    tags: ["atlas", "list", "clipboard"], 
    source: "atlas", 
    name: "ListClipboard",
  }, 
  {
    id: "atlas:ListFile", 
    tags: ["atlas", "list", "file"], 
    source: "atlas", 
    name: "ListFile",
  }, 
  {
    id: "atlas:ListFolder", 
    tags: ["atlas", "list", "folder"], 
    source: "atlas", 
    name: "ListFolder",
  }, 
  {
    id: "atlas:ListMessage", 
    tags: ["atlas", "list", "message"], 
    source: "atlas", 
    name: "ListMessage",
  }, 
  {
    id: "atlas:ListReceipt", 
    tags: ["atlas", "list", "receipt"], 
    source: "atlas", 
    name: "ListReceipt",
  }, 
  {
    id: "atlas:ListRight", 
    tags: ["atlas", "list", "right"], 
    source: "atlas", 
    name: "ListRight",
  }, 
  {
    id: "atlas:LitMatch", 
    tags: ["atlas", "lit", "match"], 
    source: "atlas", 
    name: "LitMatch",
  }, 
  {
    id: "atlas:Liver", 
    tags: ["atlas", "liver"], 
    source: "atlas", 
    name: "Liver",
  }, 
  {
    id: "atlas:LivingRoomChair", 
    tags: ["atlas", "living", "room", "chair"], 
    source: "atlas", 
    name: "LivingRoomChair",
  }, 
  {
    id: "atlas:LivingRoomCouch", 
    tags: ["atlas", "living", "room", "couch"], 
    source: "atlas", 
    name: "LivingRoomCouch",
  }, 
  {
    id: "atlas:LivingroomFireplace", 
    tags: ["atlas", "livingroom", "fireplace"], 
    source: "atlas", 
    name: "LivingroomFireplace",
  }, 
  {
    id: "atlas:Location", 
    tags: ["atlas", "location"], 
    source: "atlas", 
    name: "Location",
  }, 
  {
    id: "atlas:LocationGlasses", 
    tags: ["atlas", "location", "glasses"], 
    source: "atlas", 
    name: "LocationGlasses",
  }, 
  {
    id: "atlas:LockChat", 
    tags: ["atlas", "lock", "chat"], 
    source: "atlas", 
    name: "LockChat",
  }, 
  {
    id: "atlas:LockClipboard", 
    tags: ["atlas", "lock", "clipboard"], 
    source: "atlas", 
    name: "LockClipboard",
  }, 
  {
    id: "atlas:LockEnvelope", 
    tags: ["atlas", "lock", "envelope"], 
    source: "atlas", 
    name: "LockEnvelope",
  }, 
  {
    id: "atlas:LockFile", 
    tags: ["atlas", "lock", "file"], 
    source: "atlas", 
    name: "LockFile",
  }, 
  {
    id: "atlas:LockFolder", 
    tags: ["atlas", "lock", "folder"], 
    source: "atlas", 
    name: "LockFolder",
  }, 
  {
    id: "atlas:LockKeyhole", 
    tags: ["atlas", "lock", "keyhole"], 
    source: "atlas", 
    name: "LockKeyhole",
  }, 
  {
    id: "atlas:LockMessage", 
    tags: ["atlas", "lock", "message"], 
    source: "atlas", 
    name: "LockMessage",
  }, 
  {
    id: "atlas:LockWebsite", 
    tags: ["atlas", "lock", "website"], 
    source: "atlas", 
    name: "LockWebsite",
  }, 
  {
    id: "atlas:Lockers", 
    tags: ["atlas", "lockers"], 
    source: "atlas", 
    name: "Lockers",
  }, 
  {
    id: "atlas:LockersStorage", 
    tags: ["atlas", "lockers", "storage"], 
    source: "atlas", 
    name: "LockersStorage",
  }, 
  {
    id: "atlas:LocustPose", 
    tags: ["atlas", "locust", "pose"], 
    source: "atlas", 
    name: "LocustPose",
  }, 
  {
    id: "atlas:Logo", 
    tags: ["atlas", "logo"], 
    source: "atlas", 
    name: "Logo",
  }, 
  {
    id: "atlas:LogoSocial", 
    tags: ["atlas", "logo", "social"], 
    source: "atlas", 
    name: "LogoSocial",
  }, 
  {
    id: "atlas:Lollipop", 
    tags: ["atlas", "lollipop"], 
    source: "atlas", 
    name: "Lollipop",
  }, 
  {
    id: "atlas:LondonEye", 
    tags: ["atlas", "london", "eye"], 
    source: "atlas", 
    name: "LondonEye",
  }, 
  {
    id: "atlas:LoopArrow", 
    tags: ["atlas", "loop", "arrow"], 
    source: "atlas", 
    name: "LoopArrow",
  }, 
  {
    id: "atlas:LordOfDancePose", 
    tags: ["atlas", "lord", "of", "dance", "pose"], 
    source: "atlas", 
    name: "LordOfDancePose",
  }, 
  {
    id: "atlas:Lorry", 
    tags: ["atlas", "lorry"], 
    source: "atlas", 
    name: "Lorry",
  }, 
  {
    id: "atlas:Lotion", 
    tags: ["atlas", "lotion"], 
    source: "atlas", 
    name: "Lotion",
  }, 
  {
    id: "atlas:LotionPlusBottle", 
    tags: ["atlas", "lotion", "plus", "bottle"], 
    source: "atlas", 
    name: "LotionPlusBottle",
  }, 
  {
    id: "atlas:Louvre", 
    tags: ["atlas", "louvre"], 
    source: "atlas", 
    name: "Louvre",
  }, 
  {
    id: "atlas:LoveEnvelope", 
    tags: ["atlas", "love", "envelope"], 
    source: "atlas", 
    name: "LoveEnvelope",
  }, 
  {
    id: "atlas:LoveMessage", 
    tags: ["atlas", "love", "message"], 
    source: "atlas", 
    name: "LoveMessage",
  }, 
  {
    id: "atlas:LowThermometer", 
    tags: ["atlas", "low", "thermometer"], 
    source: "atlas", 
    name: "LowThermometer",
  }, 
  {
    id: "atlas:LowVolume", 
    tags: ["atlas", "low", "volume"], 
    source: "atlas", 
    name: "LowVolume",
  }, 
  {
    id: "atlas:LowerVolume", 
    tags: ["atlas", "lower", "volume"], 
    source: "atlas", 
    name: "LowerVolume",
  }, 
  {
    id: "atlas:Luggage", 
    tags: ["atlas", "luggage"], 
    source: "atlas", 
    name: "Luggage",
  }, 
  {
    id: "atlas:LuggageTrolley", 
    tags: ["atlas", "luggage", "trolley"], 
    source: "atlas", 
    name: "LuggageTrolley",
  }, 
  {
    id: "atlas:LungePose", 
    tags: ["atlas", "lunge", "pose"], 
    source: "atlas", 
    name: "LungePose",
  }, 
  {
    id: "atlas:Lungs", 
    tags: ["atlas", "lungs"], 
    source: "atlas", 
    name: "Lungs",
  }, 
  {
    id: "atlas:MagicWand", 
    tags: ["atlas", "magic", "wand"], 
    source: "atlas", 
    name: "MagicWand",
  }, 
  {
    id: "atlas:MagicWandSparkles", 
    tags: ["atlas", "magic", "wand", "sparkles"], 
    source: "atlas", 
    name: "MagicWandSparkles",
  }, 
  {
    id: "atlas:Magnet", 
    tags: ["atlas", "magnet"], 
    source: "atlas", 
    name: "Magnet",
  }, 
  {
    id: "atlas:MagnetUsers", 
    tags: ["atlas", "magnet", "users"], 
    source: "atlas", 
    name: "MagnetUsers",
  }, 
  {
    id: "atlas:MagnifierSearchAccount", 
    tags: ["atlas", "magnifier", "search", "account"], 
    source: "atlas", 
    name: "MagnifierSearchAccount",
  }, 
  {
    id: "atlas:MagnifyingGlass", 
    tags: ["atlas", "magnifying", "glass"], 
    source: "atlas", 
    name: "MagnifyingGlass",
  }, 
  {
    id: "atlas:MagnifyingGlassBarChart", 
    tags: ["atlas", "magnifying", "glass", "bar", "chart"], 
    source: "atlas", 
    name: "MagnifyingGlassBarChart",
  }, 
  {
    id: "atlas:MagnifyingGlassBug", 
    tags: ["atlas", "magnifying", "glass", "bug"], 
    source: "atlas", 
    name: "MagnifyingGlassBug",
  }, 
  {
    id: "atlas:MagnifyingGlassHeart", 
    tags: ["atlas", "magnifying", "glass", "heart"], 
    source: "atlas", 
    name: "MagnifyingGlassHeart",
  }, 
  {
    id: "atlas:MagnifyingGlassHouse", 
    tags: ["atlas", "magnifying", "glass", "house"], 
    source: "atlas", 
    name: "MagnifyingGlassHouse",
  }, 
  {
    id: "atlas:MagnifyingGlassMinus", 
    tags: ["atlas", "magnifying", "glass", "minus"], 
    source: "atlas", 
    name: "MagnifyingGlassMinus",
  }, 
  {
    id: "atlas:MagnifyingGlassMoney", 
    tags: ["atlas", "magnifying", "glass", "money"], 
    source: "atlas", 
    name: "MagnifyingGlassMoney",
  }, 
  {
    id: "atlas:MagnifyingGlassPlus", 
    tags: ["atlas", "magnifying", "glass", "plus"], 
    source: "atlas", 
    name: "MagnifyingGlassPlus",
  }, 
  {
    id: "atlas:MagnifyingGlassTestTube", 
    tags: ["atlas", "magnifying", "glass", "test", "tube"], 
    source: "atlas", 
    name: "MagnifyingGlassTestTube",
  }, 
  {
    id: "atlas:MagnifyingGlassUser", 
    tags: ["atlas", "magnifying", "glass", "user"], 
    source: "atlas", 
    name: "MagnifyingGlassUser",
  }, 
  {
    id: "atlas:MagnifyingGlassWebsite", 
    tags: ["atlas", "magnifying", "glass", "website"], 
    source: "atlas", 
    name: "MagnifyingGlassWebsite",
  }, 
  {
    id: "atlas:Mail", 
    tags: ["atlas", "mail"], 
    source: "atlas", 
    name: "Mail",
  }, 
  {
    id: "atlas:Mailbox", 
    tags: ["atlas", "mailbox"], 
    source: "atlas", 
    name: "Mailbox",
  }, 
  {
    id: "atlas:Male", 
    tags: ["atlas", "male"], 
    source: "atlas", 
    name: "Male",
  }, 
  {
    id: "atlas:MaleFemale", 
    tags: ["atlas", "male", "female"], 
    source: "atlas", 
    name: "MaleFemale",
  }, 
  {
    id: "atlas:MaleFemaleRomance", 
    tags: ["atlas", "male", "female", "romance"], 
    source: "atlas", 
    name: "MaleFemaleRomance",
  }, 
  {
    id: "atlas:MaleGender", 
    tags: ["atlas", "male", "gender"], 
    source: "atlas", 
    name: "MaleGender",
  }, 
  {
    id: "atlas:MaleRelationship", 
    tags: ["atlas", "male", "relationship"], 
    source: "atlas", 
    name: "MaleRelationship",
  }, 
  {
    id: "atlas:MaleRomance", 
    tags: ["atlas", "male", "romance"], 
    source: "atlas", 
    name: "MaleRomance",
  }, 
  {
    id: "atlas:MaleTorso", 
    tags: ["atlas", "male", "torso"], 
    source: "atlas", 
    name: "MaleTorso",
  }, 
  {
    id: "atlas:ManWomanRestroom", 
    tags: ["atlas", "man", "woman", "restroom"], 
    source: "atlas", 
    name: "ManWomanRestroom",
  }, 
  {
    id: "atlas:ManagerMeeting", 
    tags: ["atlas", "manager", "meeting"], 
    source: "atlas", 
    name: "ManagerMeeting",
  }, 
  {
    id: "atlas:ManualWrench", 
    tags: ["atlas", "manual", "wrench"], 
    source: "atlas", 
    name: "ManualWrench",
  }, 
  {
    id: "atlas:Map", 
    tags: ["atlas", "map"], 
    source: "atlas", 
    name: "Map",
  }, 
  {
    id: "atlas:MapNavigation", 
    tags: ["atlas", "map", "navigation"], 
    source: "atlas", 
    name: "MapNavigation",
  }, 
  {
    id: "atlas:MapleLeaf", 
    tags: ["atlas", "maple", "leaf"], 
    source: "atlas", 
    name: "MapleLeaf",
  }, 
  {
    id: "atlas:Marriage", 
    tags: ["atlas", "marriage"], 
    source: "atlas", 
    name: "Marriage",
  }, 
  {
    id: "atlas:MartialArtsUniform", 
    tags: ["atlas", "martial", "arts", "uniform"], 
    source: "atlas", 
    name: "MartialArtsUniform",
  }, 
  {
    id: "atlas:Martini", 
    tags: ["atlas", "martini"], 
    source: "atlas", 
    name: "Martini",
  }, 
  {
    id: "atlas:MartiniStraw", 
    tags: ["atlas", "martini", "straw"], 
    source: "atlas", 
    name: "MartiniStraw",
  }, 
  {
    id: "atlas:MartiniStrawLime", 
    tags: ["atlas", "martini", "straw", "lime"], 
    source: "atlas", 
    name: "MartiniStrawLime",
  }, 
  {
    id: "atlas:Math", 
    tags: ["atlas", "math"], 
    source: "atlas", 
    name: "Math",
  }, 
  {
    id: "atlas:MealPlan", 
    tags: ["atlas", "meal", "plan"], 
    source: "atlas", 
    name: "MealPlan",
  }, 
  {
    id: "atlas:MealRestaurant", 
    tags: ["atlas", "meal", "restaurant"], 
    source: "atlas", 
    name: "MealRestaurant",
  }, 
  {
    id: "atlas:MeasureElectricity", 
    tags: ["atlas", "measure", "electricity"], 
    source: "atlas", 
    name: "MeasureElectricity",
  }, 
  {
    id: "atlas:MeasureTool", 
    tags: ["atlas", "measure", "tool"], 
    source: "atlas", 
    name: "MeasureTool",
  }, 
  {
    id: "atlas:MeasureTube", 
    tags: ["atlas", "measure", "tube"], 
    source: "atlas", 
    name: "MeasureTube",
  }, 
  {
    id: "atlas:MeasurementTape", 
    tags: ["atlas", "measurement", "tape"], 
    source: "atlas", 
    name: "MeasurementTape",
  }, 
  {
    id: "atlas:MeasuringCup", 
    tags: ["atlas", "measuring", "cup"], 
    source: "atlas", 
    name: "MeasuringCup",
  }, 
  {
    id: "atlas:MeasuringTape", 
    tags: ["atlas", "measuring", "tape"], 
    source: "atlas", 
    name: "MeasuringTape",
  }, 
  {
    id: "atlas:MedVolume", 
    tags: ["atlas", "med", "volume"], 
    source: "atlas", 
    name: "MedVolume",
  }, 
  {
    id: "atlas:Medal", 
    tags: ["atlas", "medal"], 
    source: "atlas", 
    name: "Medal",
  }, 
  {
    id: "atlas:MedalAchievement", 
    tags: ["atlas", "medal", "achievement"], 
    source: "atlas", 
    name: "MedalAchievement",
  }, 
  {
    id: "atlas:MedalBadgeAward", 
    tags: ["atlas", "medal", "badge", "award"], 
    source: "atlas", 
    name: "MedalBadgeAward",
  }, 
  {
    id: "atlas:Media", 
    tags: ["atlas", "media"], 
    source: "atlas", 
    name: "Media",
  }, 
  {
    id: "atlas:MedicalCenter", 
    tags: ["atlas", "medical", "center"], 
    source: "atlas", 
    name: "MedicalCenter",
  }, 
  {
    id: "atlas:MedicalDrip", 
    tags: ["atlas", "medical", "drip"], 
    source: "atlas", 
    name: "MedicalDrip",
  }, 
  {
    id: "atlas:MedicationBottle", 
    tags: ["atlas", "medication", "bottle"], 
    source: "atlas", 
    name: "MedicationBottle",
  }, 
  {
    id: "atlas:MedicineBag", 
    tags: ["atlas", "medicine", "bag"], 
    source: "atlas", 
    name: "MedicineBag",
  }, 
  {
    id: "atlas:MedicineBottle", 
    tags: ["atlas", "medicine", "bottle"], 
    source: "atlas", 
    name: "MedicineBottle",
  }, 
  {
    id: "atlas:MediumThermometer", 
    tags: ["atlas", "medium", "thermometer"], 
    source: "atlas", 
    name: "MediumThermometer",
  }, 
  {
    id: "atlas:MeetingArrowUp", 
    tags: ["atlas", "meeting", "arrow", "up"], 
    source: "atlas", 
    name: "MeetingArrowUp",
  }, 
  {
    id: "atlas:MeetingArrows", 
    tags: ["atlas", "meeting", "arrows"], 
    source: "atlas", 
    name: "MeetingArrows",
  }, 
  {
    id: "atlas:Megaphone", 
    tags: ["atlas", "megaphone"], 
    source: "atlas", 
    name: "Megaphone",
  }, 
  {
    id: "atlas:MegaphoneMessage", 
    tags: ["atlas", "megaphone", "message"], 
    source: "atlas", 
    name: "MegaphoneMessage",
  }, 
  {
    id: "atlas:MegaphoneMonitor", 
    tags: ["atlas", "megaphone", "monitor"], 
    source: "atlas", 
    name: "MegaphoneMonitor",
  }, 
  {
    id: "atlas:Mekka", 
    tags: ["atlas", "mekka"], 
    source: "atlas", 
    name: "Mekka",
  }, 
  {
    id: "atlas:Memo", 
    tags: ["atlas", "memo"], 
    source: "atlas", 
    name: "Memo",
  }, 
  {
    id: "atlas:MemoryCard", 
    tags: ["atlas", "memory", "card"], 
    source: "atlas", 
    name: "MemoryCard",
  }, 
  {
    id: "atlas:MemoryComputer", 
    tags: ["atlas", "memory", "computer"], 
    source: "atlas", 
    name: "MemoryComputer",
  }, 
  {
    id: "atlas:MemoryRam", 
    tags: ["atlas", "memory", "ram"], 
    source: "atlas", 
    name: "MemoryRam",
  }, 
  {
    id: "atlas:MemoryStick", 
    tags: ["atlas", "memory", "stick"], 
    source: "atlas", 
    name: "MemoryStick",
  }, 
  {
    id: "atlas:MenuSquare", 
    tags: ["atlas", "menu", "square"], 
    source: "atlas", 
    name: "MenuSquare",
  }, 
  {
    id: "atlas:MergeElements", 
    tags: ["atlas", "merge", "elements"], 
    source: "atlas", 
    name: "MergeElements",
  }, 
  {
    id: "atlas:Mesh", 
    tags: ["atlas", "mesh"], 
    source: "atlas", 
    name: "Mesh",
  }, 
  {
    id: "atlas:Message", 
    tags: ["atlas", "message"], 
    source: "atlas", 
    name: "Message",
  }, 
  {
    id: "atlas:MessageGift", 
    tags: ["atlas", "message", "gift"], 
    source: "atlas", 
    name: "MessageGift",
  }, 
  {
    id: "atlas:MessageLines", 
    tags: ["atlas", "message", "lines"], 
    source: "atlas", 
    name: "MessageLines",
  }, 
  {
    id: "atlas:MessageText", 
    tags: ["atlas", "message", "text"], 
    source: "atlas", 
    name: "MessageText",
  }, 
  {
    id: "atlas:Messages", 
    tags: ["atlas", "messages"], 
    source: "atlas", 
    name: "Messages",
  }, 
  {
    id: "atlas:MessagesBlank", 
    tags: ["atlas", "messages", "blank"], 
    source: "atlas", 
    name: "MessagesBlank",
  }, 
  {
    id: "atlas:MessagesDots", 
    tags: ["atlas", "messages", "dots"], 
    source: "atlas", 
    name: "MessagesDots",
  }, 
  {
    id: "atlas:MessagesText", 
    tags: ["atlas", "messages", "text"], 
    source: "atlas", 
    name: "MessagesText",
  }, 
  {
    id: "atlas:MessagingLines", 
    tags: ["atlas", "messaging", "lines"], 
    source: "atlas", 
    name: "MessagingLines",
  }, 
  {
    id: "atlas:Messenger", 
    tags: ["atlas", "messenger"], 
    source: "atlas", 
    name: "Messenger",
  }, 
  {
    id: "atlas:Mic", 
    tags: ["atlas", "mic"], 
    source: "atlas", 
    name: "Mic",
  }, 
  {
    id: "atlas:MicroUsb", 
    tags: ["atlas", "micro", "usb"], 
    source: "atlas", 
    name: "MicroUsb",
  }, 
  {
    id: "atlas:Microchip", 
    tags: ["atlas", "microchip"], 
    source: "atlas", 
    name: "Microchip",
  }, 
  {
    id: "atlas:Microphone", 
    tags: ["atlas", "microphone"], 
    source: "atlas", 
    name: "Microphone",
  }, 
  {
    id: "atlas:Microscope", 
    tags: ["atlas", "microscope"], 
    source: "atlas", 
    name: "Microscope",
  }, 
  {
    id: "atlas:MicroscopeMedical", 
    tags: ["atlas", "microscope", "medical"], 
    source: "atlas", 
    name: "MicroscopeMedical",
  }, 
  {
    id: "atlas:MicroscopeView", 
    tags: ["atlas", "microscope", "view"], 
    source: "atlas", 
    name: "MicroscopeView",
  }, 
  {
    id: "atlas:Microwave", 
    tags: ["atlas", "microwave"], 
    source: "atlas", 
    name: "Microwave",
  }, 
  {
    id: "atlas:MiddleFinger", 
    tags: ["atlas", "middle", "finger"], 
    source: "atlas", 
    name: "MiddleFinger",
  }, 
  {
    id: "atlas:MiddleFingerGesture", 
    tags: ["atlas", "middle", "finger", "gesture"], 
    source: "atlas", 
    name: "MiddleFingerGesture",
  }, 
  {
    id: "atlas:MinimizeArrowUpDown", 
    tags: ["atlas", "minimize", "arrow", "up", "down"], 
    source: "atlas", 
    name: "MinimizeArrowUpDown",
  }, 
  {
    id: "atlas:MinusChat", 
    tags: ["atlas", "minus", "chat"], 
    source: "atlas", 
    name: "MinusChat",
  }, 
  {
    id: "atlas:MinusChats", 
    tags: ["atlas", "minus", "chats"], 
    source: "atlas", 
    name: "MinusChats",
  }, 
  {
    id: "atlas:MinusCircle", 
    tags: ["atlas", "minus", "circle"], 
    source: "atlas", 
    name: "MinusCircle",
  }, 
  {
    id: "atlas:MinusComment", 
    tags: ["atlas", "minus", "comment"], 
    source: "atlas", 
    name: "MinusComment",
  }, 
  {
    id: "atlas:MinusFolder", 
    tags: ["atlas", "minus", "folder"], 
    source: "atlas", 
    name: "MinusFolder",
  }, 
  {
    id: "atlas:MinusMessage", 
    tags: ["atlas", "minus", "message"], 
    source: "atlas", 
    name: "MinusMessage",
  }, 
  {
    id: "atlas:MinusWebsite", 
    tags: ["atlas", "minus", "website"], 
    source: "atlas", 
    name: "MinusWebsite",
  }, 
  {
    id: "atlas:Mirror", 
    tags: ["atlas", "mirror"], 
    source: "atlas", 
    name: "Mirror",
  }, 
  {
    id: "atlas:MirrorSink", 
    tags: ["atlas", "mirror", "sink"], 
    source: "atlas", 
    name: "MirrorSink",
  }, 
  {
    id: "atlas:MistyCloud", 
    tags: ["atlas", "misty", "cloud"], 
    source: "atlas", 
    name: "MistyCloud",
  }, 
  {
    id: "atlas:MixChemicals", 
    tags: ["atlas", "mix", "chemicals"], 
    source: "atlas", 
    name: "MixChemicals",
  }, 
  {
    id: "atlas:Mixture", 
    tags: ["atlas", "mixture"], 
    source: "atlas", 
    name: "Mixture",
  }, 
  {
    id: "atlas:Mobile", 
    tags: ["atlas", "mobile"], 
    source: "atlas", 
    name: "Mobile",
  }, 
  {
    id: "atlas:MobileHeart", 
    tags: ["atlas", "mobile", "heart"], 
    source: "atlas", 
    name: "MobileHeart",
  }, 
  {
    id: "atlas:MobileHorizontal", 
    tags: ["atlas", "mobile", "horizontal"], 
    source: "atlas", 
    name: "MobileHorizontal",
  }, 
  {
    id: "atlas:MobileHouse", 
    tags: ["atlas", "mobile", "house"], 
    source: "atlas", 
    name: "MobileHouse",
  }, 
  {
    id: "atlas:MobileMessage", 
    tags: ["atlas", "mobile", "message"], 
    source: "atlas", 
    name: "MobileMessage",
  }, 
  {
    id: "atlas:MobileMoney", 
    tags: ["atlas", "mobile", "money"], 
    source: "atlas", 
    name: "MobileMoney",
  }, 
  {
    id: "atlas:MobilePen", 
    tags: ["atlas", "mobile", "pen"], 
    source: "atlas", 
    name: "MobilePen",
  }, 
  {
    id: "atlas:MobilePortrait", 
    tags: ["atlas", "mobile", "portrait"], 
    source: "atlas", 
    name: "MobilePortrait",
  }, 
  {
    id: "atlas:Molecule", 
    tags: ["atlas", "molecule"], 
    source: "atlas", 
    name: "Molecule",
  }, 
  {
    id: "atlas:MoneyAccounts", 
    tags: ["atlas", "money", "accounts"], 
    source: "atlas", 
    name: "MoneyAccounts",
  }, 
  {
    id: "atlas:MoneyArrowDown", 
    tags: ["atlas", "money", "arrow", "down"], 
    source: "atlas", 
    name: "MoneyArrowDown",
  }, 
  {
    id: "atlas:MoneyArrowUp", 
    tags: ["atlas", "money", "arrow", "up"], 
    source: "atlas", 
    name: "MoneyArrowUp",
  }, 
  {
    id: "atlas:MoneyBagDollar", 
    tags: ["atlas", "money", "bag", "dollar"], 
    source: "atlas", 
    name: "MoneyBagDollar",
  }, 
  {
    id: "atlas:MoneyBarChart", 
    tags: ["atlas", "money", "bar", "chart"], 
    source: "atlas", 
    name: "MoneyBarChart",
  }, 
  {
    id: "atlas:MoneyBill", 
    tags: ["atlas", "money", "bill"], 
    source: "atlas", 
    name: "MoneyBill",
  }, 
  {
    id: "atlas:MoneyDecrease", 
    tags: ["atlas", "money", "decrease"], 
    source: "atlas", 
    name: "MoneyDecrease",
  }, 
  {
    id: "atlas:MoneyDonation", 
    tags: ["atlas", "money", "donation"], 
    source: "atlas", 
    name: "MoneyDonation",
  }, 
  {
    id: "atlas:MoneyHome", 
    tags: ["atlas", "money", "home"], 
    source: "atlas", 
    name: "MoneyHome",
  }, 
  {
    id: "atlas:MoneyIncrease", 
    tags: ["atlas", "money", "increase"], 
    source: "atlas", 
    name: "MoneyIncrease",
  }, 
  {
    id: "atlas:MoneyMobileShield", 
    tags: ["atlas", "money", "mobile", "shield"], 
    source: "atlas", 
    name: "MoneyMobileShield",
  }, 
  {
    id: "atlas:MoneyPadlock", 
    tags: ["atlas", "money", "padlock"], 
    source: "atlas", 
    name: "MoneyPadlock",
  }, 
  {
    id: "atlas:MoneyPieChart", 
    tags: ["atlas", "money", "pie", "chart"], 
    source: "atlas", 
    name: "MoneyPieChart",
  }, 
  {
    id: "atlas:MoneyPinLocation", 
    tags: ["atlas", "money", "pin", "location"], 
    source: "atlas", 
    name: "MoneyPinLocation",
  }, 
  {
    id: "atlas:MoneyStack", 
    tags: ["atlas", "money", "stack"], 
    source: "atlas", 
    name: "MoneyStack",
  }, 
  {
    id: "atlas:MoneyTarget", 
    tags: ["atlas", "money", "target"], 
    source: "atlas", 
    name: "MoneyTarget",
  }, 
  {
    id: "atlas:MoneyUserArrows", 
    tags: ["atlas", "money", "user", "arrows"], 
    source: "atlas", 
    name: "MoneyUserArrows",
  }, 
  {
    id: "atlas:MoneyWebsite", 
    tags: ["atlas", "money", "website"], 
    source: "atlas", 
    name: "MoneyWebsite",
  }, 
  {
    id: "atlas:MonsterTruck", 
    tags: ["atlas", "monster", "truck"], 
    source: "atlas", 
    name: "MonsterTruck",
  }, 
  {
    id: "atlas:Moon", 
    tags: ["atlas", "moon"], 
    source: "atlas", 
    name: "Moon",
  }, 
  {
    id: "atlas:Motorcycle", 
    tags: ["atlas", "motorcycle"], 
    source: "atlas", 
    name: "Motorcycle",
  }, 
  {
    id: "atlas:MotorcycleVehicle", 
    tags: ["atlas", "motorcycle", "vehicle"], 
    source: "atlas", 
    name: "MotorcycleVehicle",
  }, 
  {
    id: "atlas:MountFuji", 
    tags: ["atlas", "mount", "fuji"], 
    source: "atlas", 
    name: "MountFuji",
  }, 
  {
    id: "atlas:Mountain", 
    tags: ["atlas", "mountain"], 
    source: "atlas", 
    name: "Mountain",
  }, 
  {
    id: "atlas:MountainSide", 
    tags: ["atlas", "mountain", "side"], 
    source: "atlas", 
    name: "MountainSide",
  }, 
  {
    id: "atlas:MountainTop", 
    tags: ["atlas", "mountain", "top"], 
    source: "atlas", 
    name: "MountainTop",
  }, 
  {
    id: "atlas:Mouse", 
    tags: ["atlas", "mouse"], 
    source: "atlas", 
    name: "Mouse",
  }, 
  {
    id: "atlas:MouseAnimal", 
    tags: ["atlas", "mouse", "animal"], 
    source: "atlas", 
    name: "MouseAnimal",
  }, 
  {
    id: "atlas:MousePointerUp", 
    tags: ["atlas", "mouse", "pointer", "up"], 
    source: "atlas", 
    name: "MousePointerUp",
  }, 
  {
    id: "atlas:Move", 
    tags: ["atlas", "move"], 
    source: "atlas", 
    name: "Move",
  }, 
  {
    id: "atlas:MoveArrowLeftRight", 
    tags: ["atlas", "move", "arrow", "left", "right"], 
    source: "atlas", 
    name: "MoveArrowLeftRight",
  }, 
  {
    id: "atlas:MoveArrows", 
    tags: ["atlas", "move", "arrows"], 
    source: "atlas", 
    name: "MoveArrows",
  }, 
  {
    id: "atlas:MoveDown", 
    tags: ["atlas", "move", "down"], 
    source: "atlas", 
    name: "MoveDown",
  }, 
  {
    id: "atlas:MoveDownUpArrows", 
    tags: ["atlas", "move", "down", "up", "arrows"], 
    source: "atlas", 
    name: "MoveDownUpArrows",
  }, 
  {
    id: "atlas:MoveLeft", 
    tags: ["atlas", "move", "left"], 
    source: "atlas", 
    name: "MoveLeft",
  }, 
  {
    id: "atlas:MoveLeftRight", 
    tags: ["atlas", "move", "left", "right"], 
    source: "atlas", 
    name: "MoveLeftRight",
  }, 
  {
    id: "atlas:MoveLineArrowsLeftRight", 
    tags: ["atlas", "move", "line", "arrows", "left", "right"], 
    source: "atlas", 
    name: "MoveLineArrowsLeftRight",
  }, 
  {
    id: "atlas:MoveLineArrowsUpDown", 
    tags: ["atlas", "move", "line", "arrows", "up", "down"], 
    source: "atlas", 
    name: "MoveLineArrowsUpDown",
  }, 
  {
    id: "atlas:MoveRight", 
    tags: ["atlas", "move", "right"], 
    source: "atlas", 
    name: "MoveRight",
  }, 
  {
    id: "atlas:MoveUp", 
    tags: ["atlas", "move", "up"], 
    source: "atlas", 
    name: "MoveUp",
  }, 
  {
    id: "atlas:MoveUpDown", 
    tags: ["atlas", "move", "up", "down"], 
    source: "atlas", 
    name: "MoveUpDown",
  }, 
  {
    id: "atlas:MoveUpDownArrows", 
    tags: ["atlas", "move", "up", "down", "arrows"], 
    source: "atlas", 
    name: "MoveUpDownArrows",
  }, 
  {
    id: "atlas:MovementArrowsLeftRight", 
    tags: ["atlas", "movement", "arrows", "left", "right"], 
    source: "atlas", 
    name: "MovementArrowsLeftRight",
  }, 
  {
    id: "atlas:MovementArrowsUpDown", 
    tags: ["atlas", "movement", "arrows", "up", "down"], 
    source: "atlas", 
    name: "MovementArrowsUpDown",
  }, 
  {
    id: "atlas:Movie", 
    tags: ["atlas", "movie"], 
    source: "atlas", 
    name: "Movie",
  }, 
  {
    id: "atlas:MovieCamera", 
    tags: ["atlas", "movie", "camera"], 
    source: "atlas", 
    name: "MovieCamera",
  }, 
  {
    id: "atlas:MovieFilm", 
    tags: ["atlas", "movie", "film"], 
    source: "atlas", 
    name: "MovieFilm",
  }, 
  {
    id: "atlas:MovieTicket", 
    tags: ["atlas", "movie", "ticket"], 
    source: "atlas", 
    name: "MovieTicket",
  }, 
  {
    id: "atlas:MovieTrophy", 
    tags: ["atlas", "movie", "trophy"], 
    source: "atlas", 
    name: "MovieTrophy",
  }, 
  {
    id: "atlas:Mp3Player", 
    tags: ["atlas", "mp", "player"], 
    source: "atlas", 
    name: "Mp3Player",
  }, 
  {
    id: "atlas:Mri", 
    tags: ["atlas", "mri"], 
    source: "atlas", 
    name: "Mri",
  }, 
  {
    id: "atlas:MultipleArrowsUp", 
    tags: ["atlas", "multiple", "arrows", "up"], 
    source: "atlas", 
    name: "MultipleArrowsUp",
  }, 
  {
    id: "atlas:MultipleTestTube", 
    tags: ["atlas", "multiple", "test", "tube"], 
    source: "atlas", 
    name: "MultipleTestTube",
  }, 
  {
    id: "atlas:MuscleArmFitness", 
    tags: ["atlas", "muscle", "arm", "fitness"], 
    source: "atlas", 
    name: "MuscleArmFitness",
  }, 
  {
    id: "atlas:MuscleGain", 
    tags: ["atlas", "muscle", "gain"], 
    source: "atlas", 
    name: "MuscleGain",
  }, 
  {
    id: "atlas:Mushroom", 
    tags: ["atlas", "mushroom"], 
    source: "atlas", 
    name: "Mushroom",
  }, 
  {
    id: "atlas:MushroomCircles", 
    tags: ["atlas", "mushroom", "circles"], 
    source: "atlas", 
    name: "MushroomCircles",
  }, 
  {
    id: "atlas:MusicAlbum", 
    tags: ["atlas", "music", "album"], 
    source: "atlas", 
    name: "MusicAlbum",
  }, 
  {
    id: "atlas:MusicArchive", 
    tags: ["atlas", "music", "archive"], 
    source: "atlas", 
    name: "MusicArchive",
  }, 
  {
    id: "atlas:MusicChat", 
    tags: ["atlas", "music", "chat"], 
    source: "atlas", 
    name: "MusicChat",
  }, 
  {
    id: "atlas:MusicClipboard", 
    tags: ["atlas", "music", "clipboard"], 
    source: "atlas", 
    name: "MusicClipboard",
  }, 
  {
    id: "atlas:MusicFile", 
    tags: ["atlas", "music", "file"], 
    source: "atlas", 
    name: "MusicFile",
  }, 
  {
    id: "atlas:MusicFilm", 
    tags: ["atlas", "music", "film"], 
    source: "atlas", 
    name: "MusicFilm",
  }, 
  {
    id: "atlas:MusicFolder", 
    tags: ["atlas", "music", "folder"], 
    source: "atlas", 
    name: "MusicFolder",
  }, 
  {
    id: "atlas:MusicMessage", 
    tags: ["atlas", "music", "message"], 
    source: "atlas", 
    name: "MusicMessage",
  }, 
  {
    id: "atlas:MusicNote", 
    tags: ["atlas", "music", "note"], 
    source: "atlas", 
    name: "MusicNote",
  }, 
  {
    id: "atlas:MusicNoteCircle", 
    tags: ["atlas", "music", "note", "circle"], 
    source: "atlas", 
    name: "MusicNoteCircle",
  }, 
  {
    id: "atlas:MusicNoteFile", 
    tags: ["atlas", "music", "note", "file"], 
    source: "atlas", 
    name: "MusicNoteFile",
  }, 
  {
    id: "atlas:MusicNotes", 
    tags: ["atlas", "music", "notes"], 
    source: "atlas", 
    name: "MusicNotes",
  }, 
  {
    id: "atlas:MusicPlayer", 
    tags: ["atlas", "music", "player"], 
    source: "atlas", 
    name: "MusicPlayer",
  }, 
  {
    id: "atlas:Mute", 
    tags: ["atlas", "mute"], 
    source: "atlas", 
    name: "Mute",
  }, 
  {
    id: "atlas:MuteVolume", 
    tags: ["atlas", "mute", "volume"], 
    source: "atlas", 
    name: "MuteVolume",
  }, 
  {
    id: "atlas:Nail", 
    tags: ["atlas", "nail"], 
    source: "atlas", 
    name: "Nail",
  }, 
  {
    id: "atlas:NailTool", 
    tags: ["atlas", "nail", "tool"], 
    source: "atlas", 
    name: "NailTool",
  }, 
  {
    id: "atlas:NativeAmericanWoman", 
    tags: ["atlas", "native", "american", "woman"], 
    source: "atlas", 
    name: "NativeAmericanWoman",
  }, 
  {
    id: "atlas:NavigateArrowRightLeft", 
    tags: ["atlas", "navigate", "arrow", "right", "left"], 
    source: "atlas", 
    name: "NavigateArrowRightLeft",
  }, 
  {
    id: "atlas:NavigateArrowUpDown", 
    tags: ["atlas", "navigate", "arrow", "up", "down"], 
    source: "atlas", 
    name: "NavigateArrowUpDown",
  }, 
  {
    id: "atlas:NavigateRouteArrowUp", 
    tags: ["atlas", "navigate", "route", "arrow", "up"], 
    source: "atlas", 
    name: "NavigateRouteArrowUp",
  }, 
  {
    id: "atlas:Network", 
    tags: ["atlas", "network"], 
    source: "atlas", 
    name: "Network",
  }, 
  {
    id: "atlas:NetworkSignal", 
    tags: ["atlas", "network", "signal"], 
    source: "atlas", 
    name: "NetworkSignal",
  }, 
  {
    id: "atlas:NetworkSocial", 
    tags: ["atlas", "network", "social"], 
    source: "atlas", 
    name: "NetworkSocial",
  }, 
  {
    id: "atlas:NetworkingAccount", 
    tags: ["atlas", "networking", "account"], 
    source: "atlas", 
    name: "NetworkingAccount",
  }, 
  {
    id: "atlas:NewHouse", 
    tags: ["atlas", "new", "house"], 
    source: "atlas", 
    name: "NewHouse",
  }, 
  {
    id: "atlas:Newspaper", 
    tags: ["atlas", "newspaper"], 
    source: "atlas", 
    name: "Newspaper",
  }, 
  {
    id: "atlas:NewspaperArticle", 
    tags: ["atlas", "newspaper", "article"], 
    source: "atlas", 
    name: "NewspaperArticle",
  }, 
  {
    id: "atlas:NewspaperNewsletter", 
    tags: ["atlas", "newspaper", "newsletter"], 
    source: "atlas", 
    name: "NewspaperNewsletter",
  }, 
  {
    id: "atlas:Next", 
    tags: ["atlas", "next"], 
    source: "atlas", 
    name: "Next",
  }, 
  {
    id: "atlas:NightCloudy", 
    tags: ["atlas", "night", "cloudy"], 
    source: "atlas", 
    name: "NightCloudy",
  }, 
  {
    id: "atlas:NoSmoking", 
    tags: ["atlas", "no", "smoking"], 
    source: "atlas", 
    name: "NoSmoking",
  }, 
  {
    id: "atlas:Noodles", 
    tags: ["atlas", "noodles"], 
    source: "atlas", 
    name: "Noodles",
  }, 
  {
    id: "atlas:Nose", 
    tags: ["atlas", "nose"], 
    source: "atlas", 
    name: "Nose",
  }, 
  {
    id: "atlas:Notebook", 
    tags: ["atlas", "notebook"], 
    source: "atlas", 
    name: "Notebook",
  }, 
  {
    id: "atlas:NotreDame", 
    tags: ["atlas", "notre", "dame"], 
    source: "atlas", 
    name: "NotreDame",
  }, 
  {
    id: "atlas:Nurse", 
    tags: ["atlas", "nurse"], 
    source: "atlas", 
    name: "Nurse",
  }, 
  {
    id: "atlas:Oculus", 
    tags: ["atlas", "oculus"], 
    source: "atlas", 
    name: "Oculus",
  }, 
  {
    id: "atlas:OfficeBriefcase", 
    tags: ["atlas", "office", "briefcase"], 
    source: "atlas", 
    name: "OfficeBriefcase",
  }, 
  {
    id: "atlas:OfficeChair", 
    tags: ["atlas", "office", "chair"], 
    source: "atlas", 
    name: "OfficeChair",
  }, 
  {
    id: "atlas:OfficePhone", 
    tags: ["atlas", "office", "phone"], 
    source: "atlas", 
    name: "OfficePhone",
  }, 
  {
    id: "atlas:OfficeSuitcase", 
    tags: ["atlas", "office", "suitcase"], 
    source: "atlas", 
    name: "OfficeSuitcase",
  }, 
  {
    id: "atlas:OneFinger", 
    tags: ["atlas", "one", "finger"], 
    source: "atlas", 
    name: "OneFinger",
  }, 
  {
    id: "atlas:OpenBook", 
    tags: ["atlas", "open", "book"], 
    source: "atlas", 
    name: "OpenBook",
  }, 
  {
    id: "atlas:OpenCarTrunk", 
    tags: ["atlas", "open", "car", "trunk"], 
    source: "atlas", 
    name: "OpenCarTrunk",
  }, 
  {
    id: "atlas:OpenEnvelope", 
    tags: ["atlas", "open", "envelope"], 
    source: "atlas", 
    name: "OpenEnvelope",
  }, 
  {
    id: "atlas:OpenRoofCar", 
    tags: ["atlas", "open", "roof", "car"], 
    source: "atlas", 
    name: "OpenRoofCar",
  }, 
  {
    id: "atlas:OperaHouse", 
    tags: ["atlas", "opera", "house"], 
    source: "atlas", 
    name: "OperaHouse",
  }, 
  {
    id: "atlas:OrganismMagnifyingGlass", 
    tags: ["atlas", "organism", "magnifying", "glass"], 
    source: "atlas", 
    name: "OrganismMagnifyingGlass",
  }, 
  {
    id: "atlas:OrientationCenter", 
    tags: ["atlas", "orientation", "center"], 
    source: "atlas", 
    name: "OrientationCenter",
  }, 
  {
    id: "atlas:OrientationDown", 
    tags: ["atlas", "orientation", "down"], 
    source: "atlas", 
    name: "OrientationDown",
  }, 
  {
    id: "atlas:OrientationLeft", 
    tags: ["atlas", "orientation", "left"], 
    source: "atlas", 
    name: "OrientationLeft",
  }, 
  {
    id: "atlas:OrientationMiddle", 
    tags: ["atlas", "orientation", "middle"], 
    source: "atlas", 
    name: "OrientationMiddle",
  }, 
  {
    id: "atlas:OrientationRight", 
    tags: ["atlas", "orientation", "right"], 
    source: "atlas", 
    name: "OrientationRight",
  }, 
  {
    id: "atlas:OrientationUp", 
    tags: ["atlas", "orientation", "up"], 
    source: "atlas", 
    name: "OrientationUp",
  }, 
  {
    id: "atlas:Ornament", 
    tags: ["atlas", "ornament"], 
    source: "atlas", 
    name: "Ornament",
  }, 
  {
    id: "atlas:OrnamentLines", 
    tags: ["atlas", "ornament", "lines"], 
    source: "atlas", 
    name: "OrnamentLines",
  }, 
  {
    id: "atlas:OrnamentStar", 
    tags: ["atlas", "ornament", "star"], 
    source: "atlas", 
    name: "OrnamentStar",
  }, 
  {
    id: "atlas:Oven", 
    tags: ["atlas", "oven"], 
    source: "atlas", 
    name: "Oven",
  }, 
  {
    id: "atlas:OverheadCloud", 
    tags: ["atlas", "overhead", "cloud"], 
    source: "atlas", 
    name: "OverheadCloud",
  }, 
  {
    id: "atlas:OverlapArrowUp", 
    tags: ["atlas", "overlap", "arrow", "up"], 
    source: "atlas", 
    name: "OverlapArrowUp",
  }, 
  {
    id: "atlas:OverlapLeftArrow", 
    tags: ["atlas", "overlap", "left", "arrow"], 
    source: "atlas", 
    name: "OverlapLeftArrow",
  }, 
  {
    id: "atlas:OverlapRightArrow", 
    tags: ["atlas", "overlap", "right", "arrow"], 
    source: "atlas", 
    name: "OverlapRightArrow",
  }, 
  {
    id: "atlas:OverlapShapes", 
    tags: ["atlas", "overlap", "shapes"], 
    source: "atlas", 
    name: "OverlapShapes",
  }, 
  {
    id: "atlas:OverlapUpArrows", 
    tags: ["atlas", "overlap", "up", "arrows"], 
    source: "atlas", 
    name: "OverlapUpArrows",
  }, 
  {
    id: "atlas:Owl", 
    tags: ["atlas", "owl"], 
    source: "atlas", 
    name: "Owl",
  }, 
  {
    id: "atlas:Oxygen", 
    tags: ["atlas", "oxygen"], 
    source: "atlas", 
    name: "Oxygen",
  }, 
  {
    id: "atlas:P", 
    tags: ["atlas"], 
    source: "atlas", 
    name: "P",
  }, 
  {
    id: "atlas:Package", 
    tags: ["atlas", "package"], 
    source: "atlas", 
    name: "Package",
  }, 
  {
    id: "atlas:PackageArrowsUser", 
    tags: ["atlas", "package", "arrows", "user"], 
    source: "atlas", 
    name: "PackageArrowsUser",
  }, 
  {
    id: "atlas:Padlock", 
    tags: ["atlas", "padlock"], 
    source: "atlas", 
    name: "Padlock",
  }, 
  {
    id: "atlas:PadlockDots", 
    tags: ["atlas", "padlock", "dots"], 
    source: "atlas", 
    name: "PadlockDots",
  }, 
  {
    id: "atlas:PadlockHouse", 
    tags: ["atlas", "padlock", "house"], 
    source: "atlas", 
    name: "PadlockHouse",
  }, 
  {
    id: "atlas:PadlockLaptop", 
    tags: ["atlas", "padlock", "laptop"], 
    source: "atlas", 
    name: "PadlockLaptop",
  }, 
  {
    id: "atlas:PadlockMonitor", 
    tags: ["atlas", "padlock", "monitor"], 
    source: "atlas", 
    name: "PadlockMonitor",
  }, 
  {
    id: "atlas:PadlockUser", 
    tags: ["atlas", "padlock", "user"], 
    source: "atlas", 
    name: "PadlockUser",
  }, 
  {
    id: "atlas:Pages", 
    tags: ["atlas", "pages"], 
    source: "atlas", 
    name: "Pages",
  }, 
  {
    id: "atlas:PaintBrushTool", 
    tags: ["atlas", "paint", "brush", "tool"], 
    source: "atlas", 
    name: "PaintBrushTool",
  }, 
  {
    id: "atlas:PaintBucket", 
    tags: ["atlas", "paint", "bucket"], 
    source: "atlas", 
    name: "PaintBucket",
  }, 
  {
    id: "atlas:PaintBucketTool", 
    tags: ["atlas", "paint", "bucket", "tool"], 
    source: "atlas", 
    name: "PaintBucketTool",
  }, 
  {
    id: "atlas:Paintbrush", 
    tags: ["atlas", "paintbrush"], 
    source: "atlas", 
    name: "Paintbrush",
  }, 
  {
    id: "atlas:PaintbrushPaintTool", 
    tags: ["atlas", "paintbrush", "paint", "tool"], 
    source: "atlas", 
    name: "PaintbrushPaintTool",
  }, 
  {
    id: "atlas:Pancake", 
    tags: ["atlas", "pancake"], 
    source: "atlas", 
    name: "Pancake",
  }, 
  {
    id: "atlas:PaperAirplane", 
    tags: ["atlas", "paper", "airplane"], 
    source: "atlas", 
    name: "PaperAirplane",
  }, 
  {
    id: "atlas:PaperStar", 
    tags: ["atlas", "paper", "star"], 
    source: "atlas", 
    name: "PaperStar",
  }, 
  {
    id: "atlas:Paperclip", 
    tags: ["atlas", "paperclip"], 
    source: "atlas", 
    name: "Paperclip",
  }, 
  {
    id: "atlas:PaperclipAttachment", 
    tags: ["atlas", "paperclip", "attachment"], 
    source: "atlas", 
    name: "PaperclipAttachment",
  }, 
  {
    id: "atlas:Papers", 
    tags: ["atlas", "papers"], 
    source: "atlas", 
    name: "Papers",
  }, 
  {
    id: "atlas:PapersLines", 
    tags: ["atlas", "papers", "lines"], 
    source: "atlas", 
    name: "PapersLines",
  }, 
  {
    id: "atlas:Papertray", 
    tags: ["atlas", "papertray"], 
    source: "atlas", 
    name: "Papertray",
  }, 
  {
    id: "atlas:PapertrayLines", 
    tags: ["atlas", "papertray", "lines"], 
    source: "atlas", 
    name: "PapertrayLines",
  }, 
  {
    id: "atlas:ParamedicSign", 
    tags: ["atlas", "paramedic", "sign"], 
    source: "atlas", 
    name: "ParamedicSign",
  }, 
  {
    id: "atlas:Park", 
    tags: ["atlas", "park"], 
    source: "atlas", 
    name: "Park",
  }, 
  {
    id: "atlas:PartlyCloudy", 
    tags: ["atlas", "partly", "cloudy"], 
    source: "atlas", 
    name: "PartlyCloudy",
  }, 
  {
    id: "atlas:PartlyCloudyRain", 
    tags: ["atlas", "partly", "cloudy", "rain"], 
    source: "atlas", 
    name: "PartlyCloudyRain",
  }, 
  {
    id: "atlas:Passcode", 
    tags: ["atlas", "passcode"], 
    source: "atlas", 
    name: "Passcode",
  }, 
  {
    id: "atlas:Passport", 
    tags: ["atlas", "passport"], 
    source: "atlas", 
    name: "Passport",
  }, 
  {
    id: "atlas:Path", 
    tags: ["atlas", "path"], 
    source: "atlas", 
    name: "Path",
  }, 
  {
    id: "atlas:PatternSecurity", 
    tags: ["atlas", "pattern", "security"], 
    source: "atlas", 
    name: "PatternSecurity",
  }, 
  {
    id: "atlas:Pause", 
    tags: ["atlas", "pause"], 
    source: "atlas", 
    name: "Pause",
  }, 
  {
    id: "atlas:PauseCall", 
    tags: ["atlas", "pause", "call"], 
    source: "atlas", 
    name: "PauseCall",
  }, 
  {
    id: "atlas:PauseCircle", 
    tags: ["atlas", "pause", "circle"], 
    source: "atlas", 
    name: "PauseCircle",
  }, 
  {
    id: "atlas:Paypal", 
    tags: ["atlas", "paypal"], 
    source: "atlas", 
    name: "Paypal",
  }, 
  {
    id: "atlas:Pc", 
    tags: ["atlas", "pc"], 
    source: "atlas", 
    name: "Pc",
  }, 
  {
    id: "atlas:Peace", 
    tags: ["atlas", "peace"], 
    source: "atlas", 
    name: "Peace",
  }, 
  {
    id: "atlas:Pear", 
    tags: ["atlas", "pear"], 
    source: "atlas", 
    name: "Pear",
  }, 
  {
    id: "atlas:PearOrganic", 
    tags: ["atlas", "pear", "organic"], 
    source: "atlas", 
    name: "PearOrganic",
  }, 
  {
    id: "atlas:PearlTower", 
    tags: ["atlas", "pearl", "tower"], 
    source: "atlas", 
    name: "PearlTower",
  }, 
  {
    id: "atlas:Pen", 
    tags: ["atlas", "pen"], 
    source: "atlas", 
    name: "Pen",
  }, 
  {
    id: "atlas:PenFilm", 
    tags: ["atlas", "pen", "film"], 
    source: "atlas", 
    name: "PenFilm",
  }, 
  {
    id: "atlas:Pencil", 
    tags: ["atlas", "pencil"], 
    source: "atlas", 
    name: "Pencil",
  }, 
  {
    id: "atlas:PencilBox", 
    tags: ["atlas", "pencil", "box"], 
    source: "atlas", 
    name: "PencilBox",
  }, 
  {
    id: "atlas:PencilCase", 
    tags: ["atlas", "pencil", "case"], 
    source: "atlas", 
    name: "PencilCase",
  }, 
  {
    id: "atlas:PencilChat", 
    tags: ["atlas", "pencil", "chat"], 
    source: "atlas", 
    name: "PencilChat",
  }, 
  {
    id: "atlas:PencilEdit", 
    tags: ["atlas", "pencil", "edit"], 
    source: "atlas", 
    name: "PencilEdit",
  }, 
  {
    id: "atlas:PencilEnvelope", 
    tags: ["atlas", "pencil", "envelope"], 
    source: "atlas", 
    name: "PencilEnvelope",
  }, 
  {
    id: "atlas:PencilMessage", 
    tags: ["atlas", "pencil", "message"], 
    source: "atlas", 
    name: "PencilMessage",
  }, 
  {
    id: "atlas:PencilPaper", 
    tags: ["atlas", "pencil", "paper"], 
    source: "atlas", 
    name: "PencilPaper",
  }, 
  {
    id: "atlas:PencilRuler", 
    tags: ["atlas", "pencil", "ruler"], 
    source: "atlas", 
    name: "PencilRuler",
  }, 
  {
    id: "atlas:Penguin", 
    tags: ["atlas", "penguin"], 
    source: "atlas", 
    name: "Penguin",
  }, 
  {
    id: "atlas:PenguinAnimal", 
    tags: ["atlas", "penguin", "animal"], 
    source: "atlas", 
    name: "PenguinAnimal",
  }, 
  {
    id: "atlas:PercentArrowDown", 
    tags: ["atlas", "percent", "arrow", "down"], 
    source: "atlas", 
    name: "PercentArrowDown",
  }, 
  {
    id: "atlas:PercentArrowUp", 
    tags: ["atlas", "percent", "arrow", "up"], 
    source: "atlas", 
    name: "PercentArrowUp",
  }, 
  {
    id: "atlas:PercentHouse", 
    tags: ["atlas", "percent", "house"], 
    source: "atlas", 
    name: "PercentHouse",
  }, 
  {
    id: "atlas:PercentShoppingBag", 
    tags: ["atlas", "percent", "shopping", "bag"], 
    source: "atlas", 
    name: "PercentShoppingBag",
  }, 
  {
    id: "atlas:PersonReceiveArrows", 
    tags: ["atlas", "person", "receive", "arrows"], 
    source: "atlas", 
    name: "PersonReceiveArrows",
  }, 
  {
    id: "atlas:PersonRotation", 
    tags: ["atlas", "person", "rotation"], 
    source: "atlas", 
    name: "PersonRotation",
  }, 
  {
    id: "atlas:PersonSkeleton", 
    tags: ["atlas", "person", "skeleton"], 
    source: "atlas", 
    name: "PersonSkeleton",
  }, 
  {
    id: "atlas:PersonTransferArrows", 
    tags: ["atlas", "person", "transfer", "arrows"], 
    source: "atlas", 
    name: "PersonTransferArrows",
  }, 
  {
    id: "atlas:PersonVirtualReality", 
    tags: ["atlas", "person", "virtual", "reality"], 
    source: "atlas", 
    name: "PersonVirtualReality",
  }, 
  {
    id: "atlas:PersonVrGlasses", 
    tags: ["atlas", "person", "vr", "glasses"], 
    source: "atlas", 
    name: "PersonVrGlasses",
  }, 
  {
    id: "atlas:PersonalArrowIncrease", 
    tags: ["atlas", "personal", "arrow", "increase"], 
    source: "atlas", 
    name: "PersonalArrowIncrease",
  }, 
  {
    id: "atlas:PersonalReceiveArrows", 
    tags: ["atlas", "personal", "receive", "arrows"], 
    source: "atlas", 
    name: "PersonalReceiveArrows",
  }, 
  {
    id: "atlas:PersonalTransferArrows", 
    tags: ["atlas", "personal", "transfer", "arrows"], 
    source: "atlas", 
    name: "PersonalTransferArrows",
  }, 
  {
    id: "atlas:PetronasTowers", 
    tags: ["atlas", "petronas", "towers"], 
    source: "atlas", 
    name: "PetronasTowers",
  }, 
  {
    id: "atlas:Pets", 
    tags: ["atlas", "pets"], 
    source: "atlas", 
    name: "Pets",
  }, 
  {
    id: "atlas:Phone", 
    tags: ["atlas", "phone"], 
    source: "atlas", 
    name: "Phone",
  }, 
  {
    id: "atlas:PhoneArrowRight", 
    tags: ["atlas", "phone", "arrow", "right"], 
    source: "atlas", 
    name: "PhoneArrowRight",
  }, 
  {
    id: "atlas:PhoneMissed", 
    tags: ["atlas", "phone", "missed"], 
    source: "atlas", 
    name: "PhoneMissed",
  }, 
  {
    id: "atlas:PhoneSocket", 
    tags: ["atlas", "phone", "socket"], 
    source: "atlas", 
    name: "PhoneSocket",
  }, 
  {
    id: "atlas:Phonebook", 
    tags: ["atlas", "phonebook"], 
    source: "atlas", 
    name: "Phonebook",
  }, 
  {
    id: "atlas:PhonebookContacts", 
    tags: ["atlas", "phonebook", "contacts"], 
    source: "atlas", 
    name: "PhonebookContacts",
  }, 
  {
    id: "atlas:PhotoCamera", 
    tags: ["atlas", "photo", "camera"], 
    source: "atlas", 
    name: "PhotoCamera",
  }, 
  {
    id: "atlas:Photographer", 
    tags: ["atlas", "photographer"], 
    source: "atlas", 
    name: "Photographer",
  }, 
  {
    id: "atlas:Photography", 
    tags: ["atlas", "photography"], 
    source: "atlas", 
    name: "Photography",
  }, 
  {
    id: "atlas:PickUpTruc", 
    tags: ["atlas", "pick", "up", "truc"], 
    source: "atlas", 
    name: "PickUpTruc",
  }, 
  {
    id: "atlas:PicnicBasket", 
    tags: ["atlas", "picnic", "basket"], 
    source: "atlas", 
    name: "PicnicBasket",
  }, 
  {
    id: "atlas:Pie", 
    tags: ["atlas", "pie"], 
    source: "atlas", 
    name: "Pie",
  }, 
  {
    id: "atlas:PieChart", 
    tags: ["atlas", "pie", "chart"], 
    source: "atlas", 
    name: "PieChart",
  }, 
  {
    id: "atlas:PieChartCircle", 
    tags: ["atlas", "pie", "chart", "circle"], 
    source: "atlas", 
    name: "PieChartCircle",
  }, 
  {
    id: "atlas:PieChartClipboard", 
    tags: ["atlas", "pie", "chart", "clipboard"], 
    source: "atlas", 
    name: "PieChartClipboard",
  }, 
  {
    id: "atlas:PieChartFile", 
    tags: ["atlas", "pie", "chart", "file"], 
    source: "atlas", 
    name: "PieChartFile",
  }, 
  {
    id: "atlas:PieGraph", 
    tags: ["atlas", "pie", "graph"], 
    source: "atlas", 
    name: "PieGraph",
  }, 
  {
    id: "atlas:PieSlice", 
    tags: ["atlas", "pie", "slice"], 
    source: "atlas", 
    name: "PieSlice",
  }, 
  {
    id: "atlas:PilgrimsHat", 
    tags: ["atlas", "pilgrims", "hat"], 
    source: "atlas", 
    name: "PilgrimsHat",
  }, 
  {
    id: "atlas:PillBottle", 
    tags: ["atlas", "pill", "bottle"], 
    source: "atlas", 
    name: "PillBottle",
  }, 
  {
    id: "atlas:Pillar", 
    tags: ["atlas", "pillar"], 
    source: "atlas", 
    name: "Pillar",
  }, 
  {
    id: "atlas:Pin", 
    tags: ["atlas", "pin"], 
    source: "atlas", 
    name: "Pin",
  }, 
  {
    id: "atlas:PinCodeSecurity", 
    tags: ["atlas", "pin", "code", "security"], 
    source: "atlas", 
    name: "PinCodeSecurity",
  }, 
  {
    id: "atlas:PinDestination", 
    tags: ["atlas", "pin", "destination"], 
    source: "atlas", 
    name: "PinDestination",
  }, 
  {
    id: "atlas:PineTree", 
    tags: ["atlas", "pine", "tree"], 
    source: "atlas", 
    name: "PineTree",
  }, 
  {
    id: "atlas:Pipe", 
    tags: ["atlas", "pipe"], 
    source: "atlas", 
    name: "Pipe",
  }, 
  {
    id: "atlas:Pipes", 
    tags: ["atlas", "pipes"], 
    source: "atlas", 
    name: "Pipes",
  }, 
  {
    id: "atlas:PipesIntersect", 
    tags: ["atlas", "pipes", "intersect"], 
    source: "atlas", 
    name: "PipesIntersect",
  }, 
  {
    id: "atlas:PirateShip", 
    tags: ["atlas", "pirate", "ship"], 
    source: "atlas", 
    name: "PirateShip",
  }, 
  {
    id: "atlas:Pizza", 
    tags: ["atlas", "pizza"], 
    source: "atlas", 
    name: "Pizza",
  }, 
  {
    id: "atlas:PizzaSlice", 
    tags: ["atlas", "pizza", "slice"], 
    source: "atlas", 
    name: "PizzaSlice",
  }, 
  {
    id: "atlas:Plane", 
    tags: ["atlas", "plane"], 
    source: "atlas", 
    name: "Plane",
  }, 
  {
    id: "atlas:PlaneTicket", 
    tags: ["atlas", "plane", "ticket"], 
    source: "atlas", 
    name: "PlaneTicket",
  }, 
  {
    id: "atlas:PlankPose", 
    tags: ["atlas", "plank", "pose"], 
    source: "atlas", 
    name: "PlankPose",
  }, 
  {
    id: "atlas:PlantCharge", 
    tags: ["atlas", "plant", "charge"], 
    source: "atlas", 
    name: "PlantCharge",
  }, 
  {
    id: "atlas:PlantCloud", 
    tags: ["atlas", "plant", "cloud"], 
    source: "atlas", 
    name: "PlantCloud",
  }, 
  {
    id: "atlas:PlantHeart", 
    tags: ["atlas", "plant", "heart"], 
    source: "atlas", 
    name: "PlantHeart",
  }, 
  {
    id: "atlas:PlantHouse", 
    tags: ["atlas", "plant", "house"], 
    source: "atlas", 
    name: "PlantHouse",
  }, 
  {
    id: "atlas:PlantHouseLeaves", 
    tags: ["atlas", "plant", "house", "leaves"], 
    source: "atlas", 
    name: "PlantHouseLeaves",
  }, 
  {
    id: "atlas:PlantTestTube", 
    tags: ["atlas", "plant", "test", "tube"], 
    source: "atlas", 
    name: "PlantTestTube",
  }, 
  {
    id: "atlas:Platform360", 
    tags: ["atlas", "platform"], 
    source: "atlas", 
    name: "Platform360",
  }, 
  {
    id: "atlas:Play", 
    tags: ["atlas", "play"], 
    source: "atlas", 
    name: "Play",
  }, 
  {
    id: "atlas:PlayAd", 
    tags: ["atlas", "play", "ad"], 
    source: "atlas", 
    name: "PlayAd",
  }, 
  {
    id: "atlas:PlayArea", 
    tags: ["atlas", "play", "area"], 
    source: "atlas", 
    name: "PlayArea",
  }, 
  {
    id: "atlas:PlayCalendar", 
    tags: ["atlas", "play", "calendar"], 
    source: "atlas", 
    name: "PlayCalendar",
  }, 
  {
    id: "atlas:PlayChat", 
    tags: ["atlas", "play", "chat"], 
    source: "atlas", 
    name: "PlayChat",
  }, 
  {
    id: "atlas:PlayCircle", 
    tags: ["atlas", "play", "circle"], 
    source: "atlas", 
    name: "PlayCircle",
  }, 
  {
    id: "atlas:PlayClip", 
    tags: ["atlas", "play", "clip"], 
    source: "atlas", 
    name: "PlayClip",
  }, 
  {
    id: "atlas:PlayClipboard", 
    tags: ["atlas", "play", "clipboard"], 
    source: "atlas", 
    name: "PlayClipboard",
  }, 
  {
    id: "atlas:PlayFile", 
    tags: ["atlas", "play", "file"], 
    source: "atlas", 
    name: "PlayFile",
  }, 
  {
    id: "atlas:PlayFilm", 
    tags: ["atlas", "play", "film"], 
    source: "atlas", 
    name: "PlayFilm",
  }, 
  {
    id: "atlas:PlayFolder", 
    tags: ["atlas", "play", "folder"], 
    source: "atlas", 
    name: "PlayFolder",
  }, 
  {
    id: "atlas:PlayMedia", 
    tags: ["atlas", "play", "media"], 
    source: "atlas", 
    name: "PlayMedia",
  }, 
  {
    id: "atlas:PlayMessage", 
    tags: ["atlas", "play", "message"], 
    source: "atlas", 
    name: "PlayMessage",
  }, 
  {
    id: "atlas:PlayMovie", 
    tags: ["atlas", "play", "movie"], 
    source: "atlas", 
    name: "PlayMovie",
  }, 
  {
    id: "atlas:PlayProjector", 
    tags: ["atlas", "play", "projector"], 
    source: "atlas", 
    name: "PlayProjector",
  }, 
  {
    id: "atlas:PlayTicket", 
    tags: ["atlas", "play", "ticket"], 
    source: "atlas", 
    name: "PlayTicket",
  }, 
  {
    id: "atlas:PlayVr", 
    tags: ["atlas", "play", "vr"], 
    source: "atlas", 
    name: "PlayVr",
  }, 
  {
    id: "atlas:PlayVrGlasses", 
    tags: ["atlas", "play", "vr", "glasses"], 
    source: "atlas", 
    name: "PlayVrGlasses",
  }, 
  {
    id: "atlas:Pliers", 
    tags: ["atlas", "pliers"], 
    source: "atlas", 
    name: "Pliers",
  }, 
  {
    id: "atlas:Plugin", 
    tags: ["atlas", "plugin"], 
    source: "atlas", 
    name: "Plugin",
  }, 
  {
    id: "atlas:Plus", 
    tags: ["atlas", "plus"], 
    source: "atlas", 
    name: "Plus",
  }, 
  {
    id: "atlas:PlusAccountMonitor", 
    tags: ["atlas", "plus", "account", "monitor"], 
    source: "atlas", 
    name: "PlusAccountMonitor",
  }, 
  {
    id: "atlas:PlusBed", 
    tags: ["atlas", "plus", "bed"], 
    source: "atlas", 
    name: "PlusBed",
  }, 
  {
    id: "atlas:PlusBottle", 
    tags: ["atlas", "plus", "bottle"], 
    source: "atlas", 
    name: "PlusBottle",
  }, 
  {
    id: "atlas:PlusCallCenter", 
    tags: ["atlas", "plus", "call", "center"], 
    source: "atlas", 
    name: "PlusCallCenter",
  }, 
  {
    id: "atlas:PlusCircle", 
    tags: ["atlas", "plus", "circle"], 
    source: "atlas", 
    name: "PlusCircle",
  }, 
  {
    id: "atlas:PlusClipboard", 
    tags: ["atlas", "plus", "clipboard"], 
    source: "atlas", 
    name: "PlusClipboard",
  }, 
  {
    id: "atlas:PlusClipboardAdd", 
    tags: ["atlas", "plus", "clipboard", "add"], 
    source: "atlas", 
    name: "PlusClipboardAdd",
  }, 
  {
    id: "atlas:PlusDocument", 
    tags: ["atlas", "plus", "document"], 
    source: "atlas", 
    name: "PlusDocument",
  }, 
  {
    id: "atlas:PlusDrip", 
    tags: ["atlas", "plus", "drip"], 
    source: "atlas", 
    name: "PlusDrip",
  }, 
  {
    id: "atlas:PlusEnvelope", 
    tags: ["atlas", "plus", "envelope"], 
    source: "atlas", 
    name: "PlusEnvelope",
  }, 
  {
    id: "atlas:PlusFile", 
    tags: ["atlas", "plus", "file"], 
    source: "atlas", 
    name: "PlusFile",
  }, 
  {
    id: "atlas:PlusFolderPaper", 
    tags: ["atlas", "plus", "folder", "paper"], 
    source: "atlas", 
    name: "PlusFolderPaper",
  }, 
  {
    id: "atlas:PlusHangingSign", 
    tags: ["atlas", "plus", "hanging", "sign"], 
    source: "atlas", 
    name: "PlusHangingSign",
  }, 
  {
    id: "atlas:PlusHeart", 
    tags: ["atlas", "plus", "heart"], 
    source: "atlas", 
    name: "PlusHeart",
  }, 
  {
    id: "atlas:PlusIdCard", 
    tags: ["atlas", "plus", "id", "card"], 
    source: "atlas", 
    name: "PlusIdCard",
  }, 
  {
    id: "atlas:PlusLiquidDrop", 
    tags: ["atlas", "plus", "liquid", "drop"], 
    source: "atlas", 
    name: "PlusLiquidDrop",
  }, 
  {
    id: "atlas:PlusPin", 
    tags: ["atlas", "plus", "pin"], 
    source: "atlas", 
    name: "PlusPin",
  }, 
  {
    id: "atlas:PlusShield", 
    tags: ["atlas", "plus", "shield"], 
    source: "atlas", 
    name: "PlusShield",
  }, 
  {
    id: "atlas:PlusTicket", 
    tags: ["atlas", "plus", "ticket"], 
    source: "atlas", 
    name: "PlusTicket",
  }, 
  {
    id: "atlas:PlusVrView", 
    tags: ["atlas", "plus", "vr", "view"], 
    source: "atlas", 
    name: "PlusVrView",
  }, 
  {
    id: "atlas:PlusWebsite", 
    tags: ["atlas", "plus", "website"], 
    source: "atlas", 
    name: "PlusWebsite",
  }, 
  {
    id: "atlas:PointLeft", 
    tags: ["atlas", "point", "left"], 
    source: "atlas", 
    name: "PointLeft",
  }, 
  {
    id: "atlas:PointRight", 
    tags: ["atlas", "point", "right"], 
    source: "atlas", 
    name: "PointRight",
  }, 
  {
    id: "atlas:PointUp", 
    tags: ["atlas", "point", "up"], 
    source: "atlas", 
    name: "PointUp",
  }, 
  {
    id: "atlas:PointerDown", 
    tags: ["atlas", "pointer", "down"], 
    source: "atlas", 
    name: "PointerDown",
  }, 
  {
    id: "atlas:Poison", 
    tags: ["atlas", "poison"], 
    source: "atlas", 
    name: "Poison",
  }, 
  {
    id: "atlas:PoliceCar", 
    tags: ["atlas", "police", "car"], 
    source: "atlas", 
    name: "PoliceCar",
  }, 
  {
    id: "atlas:PoolLadder", 
    tags: ["atlas", "pool", "ladder"], 
    source: "atlas", 
    name: "PoolLadder",
  }, 
  {
    id: "atlas:Popcorn", 
    tags: ["atlas", "popcorn"], 
    source: "atlas", 
    name: "Popcorn",
  }, 
  {
    id: "atlas:PopupMessage", 
    tags: ["atlas", "popup", "message"], 
    source: "atlas", 
    name: "PopupMessage",
  }, 
  {
    id: "atlas:Port", 
    tags: ["atlas", "port"], 
    source: "atlas", 
    name: "Port",
  }, 
  {
    id: "atlas:Postage", 
    tags: ["atlas", "postage"], 
    source: "atlas", 
    name: "Postage",
  }, 
  {
    id: "atlas:Postcard", 
    tags: ["atlas", "postcard"], 
    source: "atlas", 
    name: "Postcard",
  }, 
  {
    id: "atlas:PottedPlant", 
    tags: ["atlas", "potted", "plant"], 
    source: "atlas", 
    name: "PottedPlant",
  }, 
  {
    id: "atlas:PowerChip", 
    tags: ["atlas", "power", "chip"], 
    source: "atlas", 
    name: "PowerChip",
  }, 
  {
    id: "atlas:PowerHouse", 
    tags: ["atlas", "power", "house"], 
    source: "atlas", 
    name: "PowerHouse",
  }, 
  {
    id: "atlas:Prayer", 
    tags: ["atlas", "prayer"], 
    source: "atlas", 
    name: "Prayer",
  }, 
  {
    id: "atlas:Present", 
    tags: ["atlas", "present"], 
    source: "atlas", 
    name: "Present",
  }, 
  {
    id: "atlas:PresentBox", 
    tags: ["atlas", "present", "box"], 
    source: "atlas", 
    name: "PresentBox",
  }, 
  {
    id: "atlas:Presentation", 
    tags: ["atlas", "presentation"], 
    source: "atlas", 
    name: "Presentation",
  }, 
  {
    id: "atlas:PresentationLine", 
    tags: ["atlas", "presentation", "line"], 
    source: "atlas", 
    name: "PresentationLine",
  }, 
  {
    id: "atlas:PresentationPodiumConference", 
    tags: ["atlas", "presentation", "podium", "conference"], 
    source: "atlas", 
    name: "PresentationPodiumConference",
  }, 
  {
    id: "atlas:Press", 
    tags: ["atlas", "press"], 
    source: "atlas", 
    name: "Press",
  }, 
  {
    id: "atlas:Print", 
    tags: ["atlas", "print"], 
    source: "atlas", 
    name: "Print",
  }, 
  {
    id: "atlas:Printer", 
    tags: ["atlas", "printer"], 
    source: "atlas", 
    name: "Printer",
  }, 
  {
    id: "atlas:Programming", 
    tags: ["atlas", "programming"], 
    source: "atlas", 
    name: "Programming",
  }, 
  {
    id: "atlas:ProjectPresentation", 
    tags: ["atlas", "project", "presentation"], 
    source: "atlas", 
    name: "ProjectPresentation",
  }, 
  {
    id: "atlas:Projector", 
    tags: ["atlas", "projector"], 
    source: "atlas", 
    name: "Projector",
  }, 
  {
    id: "atlas:ProjectorDevice", 
    tags: ["atlas", "projector", "device"], 
    source: "atlas", 
    name: "ProjectorDevice",
  }, 
  {
    id: "atlas:ProtectPlant", 
    tags: ["atlas", "protect", "plant"], 
    source: "atlas", 
    name: "ProtectPlant",
  }, 
  {
    id: "atlas:Pumpkin", 
    tags: ["atlas", "pumpkin"], 
    source: "atlas", 
    name: "Pumpkin",
  }, 
  {
    id: "atlas:PunchingBag", 
    tags: ["atlas", "punching", "bag"], 
    source: "atlas", 
    name: "PunchingBag",
  }, 
  {
    id: "atlas:PunchingBall", 
    tags: ["atlas", "punching", "ball"], 
    source: "atlas", 
    name: "PunchingBall",
  }, 
  {
    id: "atlas:PuttyKnife", 
    tags: ["atlas", "putty", "knife"], 
    source: "atlas", 
    name: "PuttyKnife",
  }, 
  {
    id: "atlas:PuttyKnifeEquipment", 
    tags: ["atlas", "putty", "knife", "equipment"], 
    source: "atlas", 
    name: "PuttyKnifeEquipment",
  }, 
  {
    id: "atlas:PuttyKnifeTool", 
    tags: ["atlas", "putty", "knife", "tool"], 
    source: "atlas", 
    name: "PuttyKnifeTool",
  }, 
  {
    id: "atlas:Puzzle", 
    tags: ["atlas", "puzzle"], 
    source: "atlas", 
    name: "Puzzle",
  }, 
  {
    id: "atlas:PuzzlePiece", 
    tags: ["atlas", "puzzle", "piece"], 
    source: "atlas", 
    name: "PuzzlePiece",
  }, 
  {
    id: "atlas:Pyramid", 
    tags: ["atlas", "pyramid"], 
    source: "atlas", 
    name: "Pyramid",
  }, 
  {
    id: "atlas:QrCode", 
    tags: ["atlas", "qr", "code"], 
    source: "atlas", 
    name: "QrCode",
  }, 
  {
    id: "atlas:Question", 
    tags: ["atlas", "question"], 
    source: "atlas", 
    name: "Question",
  }, 
  {
    id: "atlas:QuestionChat", 
    tags: ["atlas", "question", "chat"], 
    source: "atlas", 
    name: "QuestionChat",
  }, 
  {
    id: "atlas:QuestionClipboard", 
    tags: ["atlas", "question", "clipboard"], 
    source: "atlas", 
    name: "QuestionClipboard",
  }, 
  {
    id: "atlas:QuestionFile", 
    tags: ["atlas", "question", "file"], 
    source: "atlas", 
    name: "QuestionFile",
  }, 
  {
    id: "atlas:QuestionFolder", 
    tags: ["atlas", "question", "folder"], 
    source: "atlas", 
    name: "QuestionFolder",
  }, 
  {
    id: "atlas:QuestionMessage", 
    tags: ["atlas", "question", "message"], 
    source: "atlas", 
    name: "QuestionMessage",
  }, 
  {
    id: "atlas:QuestionPadlock", 
    tags: ["atlas", "question", "padlock"], 
    source: "atlas", 
    name: "QuestionPadlock",
  }, 
  {
    id: "atlas:RaceFlag", 
    tags: ["atlas", "race", "flag"], 
    source: "atlas", 
    name: "RaceFlag",
  }, 
  {
    id: "atlas:RacingHelmet", 
    tags: ["atlas", "racing", "helmet"], 
    source: "atlas", 
    name: "RacingHelmet",
  }, 
  {
    id: "atlas:RackPadlock", 
    tags: ["atlas", "rack", "padlock"], 
    source: "atlas", 
    name: "RackPadlock",
  }, 
  {
    id: "atlas:Racket", 
    tags: ["atlas", "racket"], 
    source: "atlas", 
    name: "Racket",
  }, 
  {
    id: "atlas:Radio", 
    tags: ["atlas", "radio"], 
    source: "atlas", 
    name: "Radio",
  }, 
  {
    id: "atlas:Radioactive", 
    tags: ["atlas", "radioactive"], 
    source: "atlas", 
    name: "Radioactive",
  }, 
  {
    id: "atlas:Rain", 
    tags: ["atlas", "rain"], 
    source: "atlas", 
    name: "Rain",
  }, 
  {
    id: "atlas:RainCloud", 
    tags: ["atlas", "rain", "cloud"], 
    source: "atlas", 
    name: "RainCloud",
  }, 
  {
    id: "atlas:RainDropMoon", 
    tags: ["atlas", "rain", "drop", "moon"], 
    source: "atlas", 
    name: "RainDropMoon",
  }, 
  {
    id: "atlas:RainDropSun", 
    tags: ["atlas", "rain", "drop", "sun"], 
    source: "atlas", 
    name: "RainDropSun",
  }, 
  {
    id: "atlas:RainDrops", 
    tags: ["atlas", "rain", "drops"], 
    source: "atlas", 
    name: "RainDrops",
  }, 
  {
    id: "atlas:RainStorm", 
    tags: ["atlas", "rain", "storm"], 
    source: "atlas", 
    name: "RainStorm",
  }, 
  {
    id: "atlas:RainUmbrella", 
    tags: ["atlas", "rain", "umbrella"], 
    source: "atlas", 
    name: "RainUmbrella",
  }, 
  {
    id: "atlas:Rainbow", 
    tags: ["atlas", "rainbow"], 
    source: "atlas", 
    name: "Rainbow",
  }, 
  {
    id: "atlas:Raining", 
    tags: ["atlas", "raining"], 
    source: "atlas", 
    name: "Raining",
  }, 
  {
    id: "atlas:RainingDay", 
    tags: ["atlas", "raining", "day"], 
    source: "atlas", 
    name: "RainingDay",
  }, 
  {
    id: "atlas:RainingNight", 
    tags: ["atlas", "raining", "night"], 
    source: "atlas", 
    name: "RainingNight",
  }, 
  {
    id: "atlas:RaiseHandsPeople", 
    tags: ["atlas", "raise", "hands", "people"], 
    source: "atlas", 
    name: "RaiseHandsPeople",
  }, 
  {
    id: "atlas:RamMemory", 
    tags: ["atlas", "ram", "memory"], 
    source: "atlas", 
    name: "RamMemory",
  }, 
  {
    id: "atlas:RamStorage", 
    tags: ["atlas", "ram", "storage"], 
    source: "atlas", 
    name: "RamStorage",
  }, 
  {
    id: "atlas:RealEstateBuilding", 
    tags: ["atlas", "real", "estate", "building"], 
    source: "atlas", 
    name: "RealEstateBuilding",
  }, 
  {
    id: "atlas:ReceiptDollar", 
    tags: ["atlas", "receipt", "dollar"], 
    source: "atlas", 
    name: "ReceiptDollar",
  }, 
  {
    id: "atlas:ReceiptLines", 
    tags: ["atlas", "receipt", "lines"], 
    source: "atlas", 
    name: "ReceiptLines",
  }, 
  {
    id: "atlas:ReceiptList", 
    tags: ["atlas", "receipt", "list"], 
    source: "atlas", 
    name: "ReceiptList",
  }, 
  {
    id: "atlas:Record", 
    tags: ["atlas", "record"], 
    source: "atlas", 
    name: "Record",
  }, 
  {
    id: "atlas:RecordChat", 
    tags: ["atlas", "record", "chat"], 
    source: "atlas", 
    name: "RecordChat",
  }, 
  {
    id: "atlas:RecordCircle", 
    tags: ["atlas", "record", "circle"], 
    source: "atlas", 
    name: "RecordCircle",
  }, 
  {
    id: "atlas:RecordMessage", 
    tags: ["atlas", "record", "message"], 
    source: "atlas", 
    name: "RecordMessage",
  }, 
  {
    id: "atlas:RecordSquare", 
    tags: ["atlas", "record", "square"], 
    source: "atlas", 
    name: "RecordSquare",
  }, 
  {
    id: "atlas:RecycleArrows", 
    tags: ["atlas", "recycle", "arrows"], 
    source: "atlas", 
    name: "RecycleArrows",
  }, 
  {
    id: "atlas:RecycleArrowsRotate", 
    tags: ["atlas", "recycle", "arrows", "rotate"], 
    source: "atlas", 
    name: "RecycleArrowsRotate",
  }, 
  {
    id: "atlas:RecycleBag", 
    tags: ["atlas", "recycle", "bag"], 
    source: "atlas", 
    name: "RecycleBag",
  }, 
  {
    id: "atlas:RecycleContainer", 
    tags: ["atlas", "recycle", "container"], 
    source: "atlas", 
    name: "RecycleContainer",
  }, 
  {
    id: "atlas:RecycleElectricity", 
    tags: ["atlas", "recycle", "electricity"], 
    source: "atlas", 
    name: "RecycleElectricity",
  }, 
  {
    id: "atlas:RecycleShoppingBag", 
    tags: ["atlas", "recycle", "shopping", "bag"], 
    source: "atlas", 
    name: "RecycleShoppingBag",
  }, 
  {
    id: "atlas:RecycleTag", 
    tags: ["atlas", "recycle", "tag"], 
    source: "atlas", 
    name: "RecycleTag",
  }, 
  {
    id: "atlas:RecycleTrash", 
    tags: ["atlas", "recycle", "trash"], 
    source: "atlas", 
    name: "RecycleTrash",
  }, 
  {
    id: "atlas:RecycleWater", 
    tags: ["atlas", "recycle", "water"], 
    source: "atlas", 
    name: "RecycleWater",
  }, 
  {
    id: "atlas:RedCarpet", 
    tags: ["atlas", "red", "carpet"], 
    source: "atlas", 
    name: "RedCarpet",
  }, 
  {
    id: "atlas:Reddit", 
    tags: ["atlas", "reddit"], 
    source: "atlas", 
    name: "Reddit",
  }, 
  {
    id: "atlas:Referee", 
    tags: ["atlas", "referee"], 
    source: "atlas", 
    name: "Referee",
  }, 
  {
    id: "atlas:RefereeWhistle", 
    tags: ["atlas", "referee", "whistle"], 
    source: "atlas", 
    name: "RefereeWhistle",
  }, 
  {
    id: "atlas:ReflectionHorizontal", 
    tags: ["atlas", "reflection", "horizontal"], 
    source: "atlas", 
    name: "ReflectionHorizontal",
  }, 
  {
    id: "atlas:ReflectionVertical", 
    tags: ["atlas", "reflection", "vertical"], 
    source: "atlas", 
    name: "ReflectionVertical",
  }, 
  {
    id: "atlas:RefreshAccountArrows", 
    tags: ["atlas", "refresh", "account", "arrows"], 
    source: "atlas", 
    name: "RefreshAccountArrows",
  }, 
  {
    id: "atlas:RefreshChat", 
    tags: ["atlas", "refresh", "chat"], 
    source: "atlas", 
    name: "RefreshChat",
  }, 
  {
    id: "atlas:RefreshDimension", 
    tags: ["atlas", "refresh", "dimension"], 
    source: "atlas", 
    name: "RefreshDimension",
  }, 
  {
    id: "atlas:RefreshEnvelopeArrow", 
    tags: ["atlas", "refresh", "envelope", "arrow"], 
    source: "atlas", 
    name: "RefreshEnvelopeArrow",
  }, 
  {
    id: "atlas:RefreshMessage", 
    tags: ["atlas", "refresh", "message"], 
    source: "atlas", 
    name: "RefreshMessage",
  }, 
  {
    id: "atlas:RemoteControl", 
    tags: ["atlas", "remote", "control"], 
    source: "atlas", 
    name: "RemoteControl",
  }, 
  {
    id: "atlas:RemoteHomeWorking", 
    tags: ["atlas", "remote", "home", "working"], 
    source: "atlas", 
    name: "RemoteHomeWorking",
  }, 
  {
    id: "atlas:RemoteWorking", 
    tags: ["atlas", "remote", "working"], 
    source: "atlas", 
    name: "RemoteWorking",
  }, 
  {
    id: "atlas:RentHouse", 
    tags: ["atlas", "rent", "house"], 
    source: "atlas", 
    name: "RentHouse",
  }, 
  {
    id: "atlas:Replay", 
    tags: ["atlas", "replay"], 
    source: "atlas", 
    name: "Replay",
  }, 
  {
    id: "atlas:ReplayArrowLeftRight", 
    tags: ["atlas", "replay", "arrow", "left", "right"], 
    source: "atlas", 
    name: "ReplayArrowLeftRight",
  }, 
  {
    id: "atlas:ReplayArrows", 
    tags: ["atlas", "replay", "arrows"], 
    source: "atlas", 
    name: "ReplayArrows",
  }, 
  {
    id: "atlas:ReplayArrowsUpDown", 
    tags: ["atlas", "replay", "arrows", "up", "down"], 
    source: "atlas", 
    name: "ReplayArrowsUpDown",
  }, 
  {
    id: "atlas:ReplayUpDownArrows", 
    tags: ["atlas", "replay", "up", "down", "arrows"], 
    source: "atlas", 
    name: "ReplayUpDownArrows",
  }, 
  {
    id: "atlas:RestPose", 
    tags: ["atlas", "rest", "pose"], 
    source: "atlas", 
    name: "RestPose",
  }, 
  {
    id: "atlas:Restaurant", 
    tags: ["atlas", "restaurant"], 
    source: "atlas", 
    name: "Restaurant",
  }, 
  {
    id: "atlas:RestaurantForkKnife", 
    tags: ["atlas", "restaurant", "fork", "knife"], 
    source: "atlas", 
    name: "RestaurantForkKnife",
  }, 
  {
    id: "atlas:RewardStarTrophy", 
    tags: ["atlas", "reward", "star", "trophy"], 
    source: "atlas", 
    name: "RewardStarTrophy",
  }, 
  {
    id: "atlas:RibbonBow", 
    tags: ["atlas", "ribbon", "bow"], 
    source: "atlas", 
    name: "RibbonBow",
  }, 
  {
    id: "atlas:Ribs", 
    tags: ["atlas", "ribs"], 
    source: "atlas", 
    name: "Ribs",
  }, 
  {
    id: "atlas:RiceBowl", 
    tags: ["atlas", "rice", "bowl"], 
    source: "atlas", 
    name: "RiceBowl",
  }, 
  {
    id: "atlas:RightOrientation", 
    tags: ["atlas", "right", "orientation"], 
    source: "atlas", 
    name: "RightOrientation",
  }, 
  {
    id: "atlas:RightUpArrows", 
    tags: ["atlas", "right", "up", "arrows"], 
    source: "atlas", 
    name: "RightUpArrows",
  }, 
  {
    id: "atlas:RoadRouteArrowUp", 
    tags: ["atlas", "road", "route", "arrow", "up"], 
    source: "atlas", 
    name: "RoadRouteArrowUp",
  }, 
  {
    id: "atlas:RoadSign", 
    tags: ["atlas", "road", "sign"], 
    source: "atlas", 
    name: "RoadSign",
  }, 
  {
    id: "atlas:Rock", 
    tags: ["atlas", "rock"], 
    source: "atlas", 
    name: "Rock",
  }, 
  {
    id: "atlas:Rocker", 
    tags: ["atlas", "rocker"], 
    source: "atlas", 
    name: "Rocker",
  }, 
  {
    id: "atlas:Rocket", 
    tags: ["atlas", "rocket"], 
    source: "atlas", 
    name: "Rocket",
  }, 
  {
    id: "atlas:RocketLaunch", 
    tags: ["atlas", "rocket", "launch"], 
    source: "atlas", 
    name: "RocketLaunch",
  }, 
  {
    id: "atlas:RollGym", 
    tags: ["atlas", "roll", "gym"], 
    source: "atlas", 
    name: "RollGym",
  }, 
  {
    id: "atlas:RollerBrush", 
    tags: ["atlas", "roller", "brush"], 
    source: "atlas", 
    name: "RollerBrush",
  }, 
  {
    id: "atlas:RollerBrushTool", 
    tags: ["atlas", "roller", "brush", "tool"], 
    source: "atlas", 
    name: "RollerBrushTool",
  }, 
  {
    id: "atlas:RoomDivider", 
    tags: ["atlas", "room", "divider"], 
    source: "atlas", 
    name: "RoomDivider",
  }, 
  {
    id: "atlas:RoomKey", 
    tags: ["atlas", "room", "key"], 
    source: "atlas", 
    name: "RoomKey",
  }, 
  {
    id: "atlas:RoomService", 
    tags: ["atlas", "room", "service"], 
    source: "atlas", 
    name: "RoomService",
  }, 
  {
    id: "atlas:RoomServiceTrolley", 
    tags: ["atlas", "room", "service", "trolley"], 
    source: "atlas", 
    name: "RoomServiceTrolley",
  }, 
  {
    id: "atlas:Rose", 
    tags: ["atlas", "rose"], 
    source: "atlas", 
    name: "Rose",
  }, 
  {
    id: "atlas:RotateArrowRight", 
    tags: ["atlas", "rotate", "arrow", "right"], 
    source: "atlas", 
    name: "RotateArrowRight",
  }, 
  {
    id: "atlas:RotateDotsArrow", 
    tags: ["atlas", "rotate", "dots", "arrow"], 
    source: "atlas", 
    name: "RotateDotsArrow",
  }, 
  {
    id: "atlas:RotateLeft", 
    tags: ["atlas", "rotate", "left"], 
    source: "atlas", 
    name: "RotateLeft",
  }, 
  {
    id: "atlas:RotateRight", 
    tags: ["atlas", "rotate", "right"], 
    source: "atlas", 
    name: "RotateRight",
  }, 
  {
    id: "atlas:RotatingArrowLine", 
    tags: ["atlas", "rotating", "arrow", "line"], 
    source: "atlas", 
    name: "RotatingArrowLine",
  }, 
  {
    id: "atlas:RotatingArrowsRight", 
    tags: ["atlas", "rotating", "arrows", "right"], 
    source: "atlas", 
    name: "RotatingArrowsRight",
  }, 
  {
    id: "atlas:RotatingLineArrow", 
    tags: ["atlas", "rotating", "line", "arrow"], 
    source: "atlas", 
    name: "RotatingLineArrow",
  }, 
  {
    id: "atlas:RotationArrowRight", 
    tags: ["atlas", "rotation", "arrow", "right"], 
    source: "atlas", 
    name: "RotationArrowRight",
  }, 
  {
    id: "atlas:RotationArrows", 
    tags: ["atlas", "rotation", "arrows"], 
    source: "atlas", 
    name: "RotationArrows",
  }, 
  {
    id: "atlas:RoundArrowUp", 
    tags: ["atlas", "round", "arrow", "up"], 
    source: "atlas", 
    name: "RoundArrowUp",
  }, 
  {
    id: "atlas:RoundArrows", 
    tags: ["atlas", "round", "arrows"], 
    source: "atlas", 
    name: "RoundArrows",
  }, 
  {
    id: "atlas:RoundTableMeeting", 
    tags: ["atlas", "round", "table", "meeting"], 
    source: "atlas", 
    name: "RoundTableMeeting",
  }, 
  {
    id: "atlas:RoundTestTube", 
    tags: ["atlas", "round", "test", "tube"], 
    source: "atlas", 
    name: "RoundTestTube",
  }, 
  {
    id: "atlas:RoundaboutArrows", 
    tags: ["atlas", "roundabout", "arrows"], 
    source: "atlas", 
    name: "RoundaboutArrows",
  }, 
  {
    id: "atlas:RoundedWindow", 
    tags: ["atlas", "rounded", "window"], 
    source: "atlas", 
    name: "RoundedWindow",
  }, 
  {
    id: "atlas:Route", 
    tags: ["atlas", "route"], 
    source: "atlas", 
    name: "Route",
  }, 
  {
    id: "atlas:RouteDestination", 
    tags: ["atlas", "route", "destination"], 
    source: "atlas", 
    name: "RouteDestination",
  }, 
  {
    id: "atlas:RouteNavigateArrowUp", 
    tags: ["atlas", "route", "navigate", "arrow", "up"], 
    source: "atlas", 
    name: "RouteNavigateArrowUp",
  }, 
  {
    id: "atlas:Router", 
    tags: ["atlas", "router"], 
    source: "atlas", 
    name: "Router",
  }, 
  {
    id: "atlas:RouterSecurity", 
    tags: ["atlas", "router", "security"], 
    source: "atlas", 
    name: "RouterSecurity",
  }, 
  {
    id: "atlas:RssSquare", 
    tags: ["atlas", "rss", "square"], 
    source: "atlas", 
    name: "RssSquare",
  }, 
  {
    id: "atlas:Ruler", 
    tags: ["atlas", "ruler"], 
    source: "atlas", 
    name: "Ruler",
  }, 
  {
    id: "atlas:RulerCombined", 
    tags: ["atlas", "ruler", "combined"], 
    source: "atlas", 
    name: "RulerCombined",
  }, 
  {
    id: "atlas:RulerTool", 
    tags: ["atlas", "ruler", "tool"], 
    source: "atlas", 
    name: "RulerTool",
  }, 
  {
    id: "atlas:Rulers", 
    tags: ["atlas", "rulers"], 
    source: "atlas", 
    name: "Rulers",
  }, 
  {
    id: "atlas:Safe", 
    tags: ["atlas", "safe"], 
    source: "atlas", 
    name: "Safe",
  }, 
  {
    id: "atlas:SafetyGlasses", 
    tags: ["atlas", "safety", "glasses"], 
    source: "atlas", 
    name: "SafetyGlasses",
  }, 
  {
    id: "atlas:SafetyGlove", 
    tags: ["atlas", "safety", "glove"], 
    source: "atlas", 
    name: "SafetyGlove",
  }, 
  {
    id: "atlas:SafetyGoggles", 
    tags: ["atlas", "safety", "goggles"], 
    source: "atlas", 
    name: "SafetyGoggles",
  }, 
  {
    id: "atlas:SafetyVest", 
    tags: ["atlas", "safety", "vest"], 
    source: "atlas", 
    name: "SafetyVest",
  }, 
  {
    id: "atlas:SagradaFamilia", 
    tags: ["atlas", "sagrada", "familia"], 
    source: "atlas", 
    name: "SagradaFamilia",
  }, 
  {
    id: "atlas:SailBoat", 
    tags: ["atlas", "sail", "boat"], 
    source: "atlas", 
    name: "SailBoat",
  }, 
  {
    id: "atlas:SailingBoat", 
    tags: ["atlas", "sailing", "boat"], 
    source: "atlas", 
    name: "SailingBoat",
  }, 
  {
    id: "atlas:Sander", 
    tags: ["atlas", "sander"], 
    source: "atlas", 
    name: "Sander",
  }, 
  {
    id: "atlas:Sandwich", 
    tags: ["atlas", "sandwich"], 
    source: "atlas", 
    name: "Sandwich",
  }, 
  {
    id: "atlas:SanitizerBottle", 
    tags: ["atlas", "sanitizer", "bottle"], 
    source: "atlas", 
    name: "SanitizerBottle",
  }, 
  {
    id: "atlas:SantaBag", 
    tags: ["atlas", "santa", "bag"], 
    source: "atlas", 
    name: "SantaBag",
  }, 
  {
    id: "atlas:SantaClaus", 
    tags: ["atlas", "santa", "claus"], 
    source: "atlas", 
    name: "SantaClaus",
  }, 
  {
    id: "atlas:SantaHat", 
    tags: ["atlas", "santa", "hat"], 
    source: "atlas", 
    name: "SantaHat",
  }, 
  {
    id: "atlas:SantaSleigh", 
    tags: ["atlas", "santa", "sleigh"], 
    source: "atlas", 
    name: "SantaSleigh",
  }, 
  {
    id: "atlas:Satellite", 
    tags: ["atlas", "satellite"], 
    source: "atlas", 
    name: "Satellite",
  }, 
  {
    id: "atlas:SatelliteDish", 
    tags: ["atlas", "satellite", "dish"], 
    source: "atlas", 
    name: "SatelliteDish",
  }, 
  {
    id: "atlas:SatelliteSignal", 
    tags: ["atlas", "satellite", "signal"], 
    source: "atlas", 
    name: "SatelliteSignal",
  }, 
  {
    id: "atlas:Sauce", 
    tags: ["atlas", "sauce"], 
    source: "atlas", 
    name: "Sauce",
  }, 
  {
    id: "atlas:SauceBottle", 
    tags: ["atlas", "sauce", "bottle"], 
    source: "atlas", 
    name: "SauceBottle",
  }, 
  {
    id: "atlas:Sausage", 
    tags: ["atlas", "sausage"], 
    source: "atlas", 
    name: "Sausage",
  }, 
  {
    id: "atlas:Saw", 
    tags: ["atlas", "saw"], 
    source: "atlas", 
    name: "Saw",
  }, 
  {
    id: "atlas:SawBlade", 
    tags: ["atlas", "saw", "blade"], 
    source: "atlas", 
    name: "SawBlade",
  }, 
  {
    id: "atlas:Scale", 
    tags: ["atlas", "scale"], 
    source: "atlas", 
    name: "Scale",
  }, 
  {
    id: "atlas:ScaleWeigh", 
    tags: ["atlas", "scale", "weigh"], 
    source: "atlas", 
    name: "ScaleWeigh",
  }, 
  {
    id: "atlas:Scarf", 
    tags: ["atlas", "scarf"], 
    source: "atlas", 
    name: "Scarf",
  }, 
  {
    id: "atlas:ScarfFashion", 
    tags: ["atlas", "scarf", "fashion"], 
    source: "atlas", 
    name: "ScarfFashion",
  }, 
  {
    id: "atlas:SchoolBell", 
    tags: ["atlas", "school", "bell"], 
    source: "atlas", 
    name: "SchoolBell",
  }, 
  {
    id: "atlas:SchoolBus", 
    tags: ["atlas", "school", "bus"], 
    source: "atlas", 
    name: "SchoolBus",
  }, 
  {
    id: "atlas:SchoolChairDesk", 
    tags: ["atlas", "school", "chair", "desk"], 
    source: "atlas", 
    name: "SchoolChairDesk",
  }, 
  {
    id: "atlas:Science", 
    tags: ["atlas", "science"], 
    source: "atlas", 
    name: "Science",
  }, 
  {
    id: "atlas:ScienceAtoms", 
    tags: ["atlas", "science", "atoms"], 
    source: "atlas", 
    name: "ScienceAtoms",
  }, 
  {
    id: "atlas:ScienceBook", 
    tags: ["atlas", "science", "book"], 
    source: "atlas", 
    name: "ScienceBook",
  }, 
  {
    id: "atlas:Scienctific", 
    tags: ["atlas", "scienctific"], 
    source: "atlas", 
    name: "Scienctific",
  }, 
  {
    id: "atlas:ScientistMan", 
    tags: ["atlas", "scientist", "man"], 
    source: "atlas", 
    name: "ScientistMan",
  }, 
  {
    id: "atlas:ScientistWoman", 
    tags: ["atlas", "scientist", "woman"], 
    source: "atlas", 
    name: "ScientistWoman",
  }, 
  {
    id: "atlas:Scissor", 
    tags: ["atlas", "scissor"], 
    source: "atlas", 
    name: "Scissor",
  }, 
  {
    id: "atlas:ScissorPliers", 
    tags: ["atlas", "scissor", "pliers"], 
    source: "atlas", 
    name: "ScissorPliers",
  }, 
  {
    id: "atlas:Scissors", 
    tags: ["atlas", "scissors"], 
    source: "atlas", 
    name: "Scissors",
  }, 
  {
    id: "atlas:ScrewNail", 
    tags: ["atlas", "screw", "nail"], 
    source: "atlas", 
    name: "ScrewNail",
  }, 
  {
    id: "atlas:Screwdriver", 
    tags: ["atlas", "screwdriver"], 
    source: "atlas", 
    name: "Screwdriver",
  }, 
  {
    id: "atlas:Sea", 
    tags: ["atlas", "sea"], 
    source: "atlas", 
    name: "Sea",
  }, 
  {
    id: "atlas:SeaCabin", 
    tags: ["atlas", "sea", "cabin"], 
    source: "atlas", 
    name: "SeaCabin",
  }, 
  {
    id: "atlas:SearchAccountEmployee", 
    tags: ["atlas", "search", "account", "employee"], 
    source: "atlas", 
    name: "SearchAccountEmployee",
  }, 
  {
    id: "atlas:SearchChat", 
    tags: ["atlas", "search", "chat"], 
    source: "atlas", 
    name: "SearchChat",
  }, 
  {
    id: "atlas:SearchEnvelope", 
    tags: ["atlas", "search", "envelope"], 
    source: "atlas", 
    name: "SearchEnvelope",
  }, 
  {
    id: "atlas:SearchFlights", 
    tags: ["atlas", "search", "flights"], 
    source: "atlas", 
    name: "SearchFlights",
  }, 
  {
    id: "atlas:SearchMap", 
    tags: ["atlas", "search", "map"], 
    source: "atlas", 
    name: "SearchMap",
  }, 
  {
    id: "atlas:SearchMessage", 
    tags: ["atlas", "search", "message"], 
    source: "atlas", 
    name: "SearchMessage",
  }, 
  {
    id: "atlas:SearchVrGlasses", 
    tags: ["atlas", "search", "vr", "glasses"], 
    source: "atlas", 
    name: "SearchVrGlasses",
  }, 
  {
    id: "atlas:Seashell", 
    tags: ["atlas", "seashell"], 
    source: "atlas", 
    name: "Seashell",
  }, 
  {
    id: "atlas:SeatChair", 
    tags: ["atlas", "seat", "chair"], 
    source: "atlas", 
    name: "SeatChair",
  }, 
  {
    id: "atlas:SeatedForwardBendPose", 
    tags: ["atlas", "seated", "forward", "bend", "pose"], 
    source: "atlas", 
    name: "SeatedForwardBendPose",
  }, 
  {
    id: "atlas:SeatedPose", 
    tags: ["atlas", "seated", "pose"], 
    source: "atlas", 
    name: "SeatedPose",
  }, 
  {
    id: "atlas:SecurityCamera", 
    tags: ["atlas", "security", "camera"], 
    source: "atlas", 
    name: "SecurityCamera",
  }, 
  {
    id: "atlas:SecurityHelmet", 
    tags: ["atlas", "security", "helmet"], 
    source: "atlas", 
    name: "SecurityHelmet",
  }, 
  {
    id: "atlas:Segway", 
    tags: ["atlas", "segway"], 
    source: "atlas", 
    name: "Segway",
  }, 
  {
    id: "atlas:Sensor", 
    tags: ["atlas", "sensor"], 
    source: "atlas", 
    name: "Sensor",
  }, 
  {
    id: "atlas:Server", 
    tags: ["atlas", "server"], 
    source: "atlas", 
    name: "Server",
  }, 
  {
    id: "atlas:ServerCloud", 
    tags: ["atlas", "server", "cloud"], 
    source: "atlas", 
    name: "ServerCloud",
  }, 
  {
    id: "atlas:ServerConnect", 
    tags: ["atlas", "server", "connect"], 
    source: "atlas", 
    name: "ServerConnect",
  }, 
  {
    id: "atlas:ServerDatabase", 
    tags: ["atlas", "server", "database"], 
    source: "atlas", 
    name: "ServerDatabase",
  }, 
  {
    id: "atlas:ServerInterconnection", 
    tags: ["atlas", "server", "interconnection"], 
    source: "atlas", 
    name: "ServerInterconnection",
  }, 
  {
    id: "atlas:ServerShare", 
    tags: ["atlas", "server", "share"], 
    source: "atlas", 
    name: "ServerShare",
  }, 
  {
    id: "atlas:ServerShield", 
    tags: ["atlas", "server", "shield"], 
    source: "atlas", 
    name: "ServerShield",
  }, 
  {
    id: "atlas:ServiceBell", 
    tags: ["atlas", "service", "bell"], 
    source: "atlas", 
    name: "ServiceBell",
  }, 
  {
    id: "atlas:ServiceDesk", 
    tags: ["atlas", "service", "desk"], 
    source: "atlas", 
    name: "ServiceDesk",
  }, 
  {
    id: "atlas:SettingsChat", 
    tags: ["atlas", "settings", "chat"], 
    source: "atlas", 
    name: "SettingsChat",
  }, 
  {
    id: "atlas:SettingsLaptop", 
    tags: ["atlas", "settings", "laptop"], 
    source: "atlas", 
    name: "SettingsLaptop",
  }, 
  {
    id: "atlas:SettingsMessage", 
    tags: ["atlas", "settings", "message"], 
    source: "atlas", 
    name: "SettingsMessage",
  }, 
  {
    id: "atlas:SettingsMonitor", 
    tags: ["atlas", "settings", "monitor"], 
    source: "atlas", 
    name: "SettingsMonitor",
  }, 
  {
    id: "atlas:SettingsShield", 
    tags: ["atlas", "settings", "shield"], 
    source: "atlas", 
    name: "SettingsShield",
  }, 
  {
    id: "atlas:SettingsVrGlasses", 
    tags: ["atlas", "settings", "vr", "glasses"], 
    source: "atlas", 
    name: "SettingsVrGlasses",
  }, 
  {
    id: "atlas:Shape", 
    tags: ["atlas", "shape"], 
    source: "atlas", 
    name: "Shape",
  }, 
  {
    id: "atlas:Share", 
    tags: ["atlas", "share"], 
    source: "atlas", 
    name: "Share",
  }, 
  {
    id: "atlas:ShareChat", 
    tags: ["atlas", "share", "chat"], 
    source: "atlas", 
    name: "ShareChat",
  }, 
  {
    id: "atlas:ShareEnvelope", 
    tags: ["atlas", "share", "envelope"], 
    source: "atlas", 
    name: "ShareEnvelope",
  }, 
  {
    id: "atlas:ShareMessage", 
    tags: ["atlas", "share", "message"], 
    source: "atlas", 
    name: "ShareMessage",
  }, 
  {
    id: "atlas:ShareWebsite", 
    tags: ["atlas", "share", "website"], 
    source: "atlas", 
    name: "ShareWebsite",
  }, 
  {
    id: "atlas:Sharpener", 
    tags: ["atlas", "sharpener"], 
    source: "atlas", 
    name: "Sharpener",
  }, 
  {
    id: "atlas:Shelf", 
    tags: ["atlas", "shelf"], 
    source: "atlas", 
    name: "Shelf",
  }, 
  {
    id: "atlas:ShieldChat", 
    tags: ["atlas", "shield", "chat"], 
    source: "atlas", 
    name: "ShieldChat",
  }, 
  {
    id: "atlas:ShieldDocument", 
    tags: ["atlas", "shield", "document"], 
    source: "atlas", 
    name: "ShieldDocument",
  }, 
  {
    id: "atlas:ShieldEnvelope", 
    tags: ["atlas", "shield", "envelope"], 
    source: "atlas", 
    name: "ShieldEnvelope",
  }, 
  {
    id: "atlas:ShieldExclamation", 
    tags: ["atlas", "shield", "exclamation"], 
    source: "atlas", 
    name: "ShieldExclamation",
  }, 
  {
    id: "atlas:ShieldFile", 
    tags: ["atlas", "shield", "file"], 
    source: "atlas", 
    name: "ShieldFile",
  }, 
  {
    id: "atlas:ShieldKeyhole", 
    tags: ["atlas", "shield", "keyhole"], 
    source: "atlas", 
    name: "ShieldKeyhole",
  }, 
  {
    id: "atlas:ShieldLaptop", 
    tags: ["atlas", "shield", "laptop"], 
    source: "atlas", 
    name: "ShieldLaptop",
  }, 
  {
    id: "atlas:ShieldMessage", 
    tags: ["atlas", "shield", "message"], 
    source: "atlas", 
    name: "ShieldMessage",
  }, 
  {
    id: "atlas:ShieldMonitor", 
    tags: ["atlas", "shield", "monitor"], 
    source: "atlas", 
    name: "ShieldMonitor",
  }, 
  {
    id: "atlas:ShieldNetwork", 
    tags: ["atlas", "shield", "network"], 
    source: "atlas", 
    name: "ShieldNetwork",
  }, 
  {
    id: "atlas:ShieldServer", 
    tags: ["atlas", "shield", "server"], 
    source: "atlas", 
    name: "ShieldServer",
  }, 
  {
    id: "atlas:ShieldStarBanner", 
    tags: ["atlas", "shield", "star", "banner"], 
    source: "atlas", 
    name: "ShieldStarBanner",
  }, 
  {
    id: "atlas:ShieldStarWin", 
    tags: ["atlas", "shield", "star", "win"], 
    source: "atlas", 
    name: "ShieldStarWin",
  }, 
  {
    id: "atlas:ShieldWebsite", 
    tags: ["atlas", "shield", "website"], 
    source: "atlas", 
    name: "ShieldWebsite",
  }, 
  {
    id: "atlas:Ship", 
    tags: ["atlas", "ship"], 
    source: "atlas", 
    name: "Ship",
  }, 
  {
    id: "atlas:ShipCruise", 
    tags: ["atlas", "ship", "cruise"], 
    source: "atlas", 
    name: "ShipCruise",
  }, 
  {
    id: "atlas:ShippingPackage", 
    tags: ["atlas", "shipping", "package"], 
    source: "atlas", 
    name: "ShippingPackage",
  }, 
  {
    id: "atlas:Shop", 
    tags: ["atlas", "shop"], 
    source: "atlas", 
    name: "Shop",
  }, 
  {
    id: "atlas:ShopBag", 
    tags: ["atlas", "shop", "bag"], 
    source: "atlas", 
    name: "ShopBag",
  }, 
  {
    id: "atlas:ShopCart", 
    tags: ["atlas", "shop", "cart"], 
    source: "atlas", 
    name: "ShopCart",
  }, 
  {
    id: "atlas:ShoppingBag", 
    tags: ["atlas", "shopping", "bag"], 
    source: "atlas", 
    name: "ShoppingBag",
  }, 
  {
    id: "atlas:ShoppingBagRecycle", 
    tags: ["atlas", "shopping", "bag", "recycle"], 
    source: "atlas", 
    name: "ShoppingBagRecycle",
  }, 
  {
    id: "atlas:ShoppingBasket", 
    tags: ["atlas", "shopping", "basket"], 
    source: "atlas", 
    name: "ShoppingBasket",
  }, 
  {
    id: "atlas:ShoppingCart", 
    tags: ["atlas", "shopping", "cart"], 
    source: "atlas", 
    name: "ShoppingCart",
  }, 
  {
    id: "atlas:ShoppingCartHouse", 
    tags: ["atlas", "shopping", "cart", "house"], 
    source: "atlas", 
    name: "ShoppingCartHouse",
  }, 
  {
    id: "atlas:Shorts", 
    tags: ["atlas", "shorts"], 
    source: "atlas", 
    name: "Shorts",
  }, 
  {
    id: "atlas:Shovel", 
    tags: ["atlas", "shovel"], 
    source: "atlas", 
    name: "Shovel",
  }, 
  {
    id: "atlas:ShovelTool", 
    tags: ["atlas", "shovel", "tool"], 
    source: "atlas", 
    name: "ShovelTool",
  }, 
  {
    id: "atlas:Shower", 
    tags: ["atlas", "shower"], 
    source: "atlas", 
    name: "Shower",
  }, 
  {
    id: "atlas:ShowerBath", 
    tags: ["atlas", "shower", "bath"], 
    source: "atlas", 
    name: "ShowerBath",
  }, 
  {
    id: "atlas:ShowerBathroom", 
    tags: ["atlas", "shower", "bathroom"], 
    source: "atlas", 
    name: "ShowerBathroom",
  }, 
  {
    id: "atlas:ShowerCurtain", 
    tags: ["atlas", "shower", "curtain"], 
    source: "atlas", 
    name: "ShowerCurtain",
  }, 
  {
    id: "atlas:ShowerFacilities", 
    tags: ["atlas", "shower", "facilities"], 
    source: "atlas", 
    name: "ShowerFacilities",
  }, 
  {
    id: "atlas:Showerhead", 
    tags: ["atlas", "showerhead"], 
    source: "atlas", 
    name: "Showerhead",
  }, 
  {
    id: "atlas:ShredFile", 
    tags: ["atlas", "shred", "file"], 
    source: "atlas", 
    name: "ShredFile",
  }, 
  {
    id: "atlas:Shuffle", 
    tags: ["atlas", "shuffle"], 
    source: "atlas", 
    name: "Shuffle",
  }, 
  {
    id: "atlas:ShuttleSport", 
    tags: ["atlas", "shuttle", "sport"], 
    source: "atlas", 
    name: "ShuttleSport",
  }, 
  {
    id: "atlas:SideViewVr", 
    tags: ["atlas", "side", "view", "vr"], 
    source: "atlas", 
    name: "SideViewVr",
  }, 
  {
    id: "atlas:SignDollar", 
    tags: ["atlas", "sign", "dollar"], 
    source: "atlas", 
    name: "SignDollar",
  }, 
  {
    id: "atlas:SignYen", 
    tags: ["atlas", "sign", "yen"], 
    source: "atlas", 
    name: "SignYen",
  }, 
  {
    id: "atlas:SignYenCircle", 
    tags: ["atlas", "sign", "yen", "circle"], 
    source: "atlas", 
    name: "SignYenCircle",
  }, 
  {
    id: "atlas:Signal", 
    tags: ["atlas", "signal"], 
    source: "atlas", 
    name: "Signal",
  }, 
  {
    id: "atlas:SignalChat", 
    tags: ["atlas", "signal", "chat"], 
    source: "atlas", 
    name: "SignalChat",
  }, 
  {
    id: "atlas:SignalMessage", 
    tags: ["atlas", "signal", "message"], 
    source: "atlas", 
    name: "SignalMessage",
  }, 
  {
    id: "atlas:Signature", 
    tags: ["atlas", "signature"], 
    source: "atlas", 
    name: "Signature",
  }, 
  {
    id: "atlas:SingleBed", 
    tags: ["atlas", "single", "bed"], 
    source: "atlas", 
    name: "SingleBed",
  }, 
  {
    id: "atlas:Sink", 
    tags: ["atlas", "sink"], 
    source: "atlas", 
    name: "Sink",
  }, 
  {
    id: "atlas:Siren", 
    tags: ["atlas", "siren"], 
    source: "atlas", 
    name: "Siren",
  }, 
  {
    id: "atlas:SitUpsPose", 
    tags: ["atlas", "sit", "ups", "pose"], 
    source: "atlas", 
    name: "SitUpsPose",
  }, 
  {
    id: "atlas:SittingArmRaisePose", 
    tags: ["atlas", "sitting", "arm", "raise", "pose"], 
    source: "atlas", 
    name: "SittingArmRaisePose",
  }, 
  {
    id: "atlas:SizeText", 
    tags: ["atlas", "size", "text"], 
    source: "atlas", 
    name: "SizeText",
  }, 
  {
    id: "atlas:Skateboard", 
    tags: ["atlas", "skateboard"], 
    source: "atlas", 
    name: "Skateboard",
  }, 
  {
    id: "atlas:SkatingSkate", 
    tags: ["atlas", "skating", "skate"], 
    source: "atlas", 
    name: "SkatingSkate",
  }, 
  {
    id: "atlas:Skeleton", 
    tags: ["atlas", "skeleton"], 
    source: "atlas", 
    name: "Skeleton",
  }, 
  {
    id: "atlas:Ski", 
    tags: ["atlas", "ski"], 
    source: "atlas", 
    name: "Ski",
  }, 
  {
    id: "atlas:SkiLift", 
    tags: ["atlas", "ski", "lift"], 
    source: "atlas", 
    name: "SkiLift",
  }, 
  {
    id: "atlas:SkiingSki", 
    tags: ["atlas", "skiing", "ski"], 
    source: "atlas", 
    name: "SkiingSki",
  }, 
  {
    id: "atlas:Skull", 
    tags: ["atlas", "skull"], 
    source: "atlas", 
    name: "Skull",
  }, 
  {
    id: "atlas:SkullDocument", 
    tags: ["atlas", "skull", "document"], 
    source: "atlas", 
    name: "SkullDocument",
  }, 
  {
    id: "atlas:SkullEnvelope", 
    tags: ["atlas", "skull", "envelope"], 
    source: "atlas", 
    name: "SkullEnvelope",
  }, 
  {
    id: "atlas:SkullLaptop", 
    tags: ["atlas", "skull", "laptop"], 
    source: "atlas", 
    name: "SkullLaptop",
  }, 
  {
    id: "atlas:SkullMessage", 
    tags: ["atlas", "skull", "message"], 
    source: "atlas", 
    name: "SkullMessage",
  }, 
  {
    id: "atlas:SkullMonitor", 
    tags: ["atlas", "skull", "monitor"], 
    source: "atlas", 
    name: "SkullMonitor",
  }, 
  {
    id: "atlas:Skype", 
    tags: ["atlas", "skype"], 
    source: "atlas", 
    name: "Skype",
  }, 
  {
    id: "atlas:SleepingBag", 
    tags: ["atlas", "sleeping", "bag"], 
    source: "atlas", 
    name: "SleepingBag",
  }, 
  {
    id: "atlas:Sleigh", 
    tags: ["atlas", "sleigh"], 
    source: "atlas", 
    name: "Sleigh",
  }, 
  {
    id: "atlas:Sliders", 
    tags: ["atlas", "sliders"], 
    source: "atlas", 
    name: "Sliders",
  }, 
  {
    id: "atlas:SlidersLines", 
    tags: ["atlas", "sliders", "lines"], 
    source: "atlas", 
    name: "SlidersLines",
  }, 
  {
    id: "atlas:SlidersUp", 
    tags: ["atlas", "sliders", "up"], 
    source: "atlas", 
    name: "SlidersUp",
  }, 
  {
    id: "atlas:SlidersUpLines", 
    tags: ["atlas", "sliders", "up", "lines"], 
    source: "atlas", 
    name: "SlidersUpLines",
  }, 
  {
    id: "atlas:Slippers", 
    tags: ["atlas", "slippers"], 
    source: "atlas", 
    name: "Slippers",
  }, 
  {
    id: "atlas:SmartphoneCharging", 
    tags: ["atlas", "smartphone", "charging"], 
    source: "atlas", 
    name: "SmartphoneCharging",
  }, 
  {
    id: "atlas:SmartphoneLocation", 
    tags: ["atlas", "smartphone", "location"], 
    source: "atlas", 
    name: "SmartphoneLocation",
  }, 
  {
    id: "atlas:SmartphoneLocationPin", 
    tags: ["atlas", "smartphone", "location", "pin"], 
    source: "atlas", 
    name: "SmartphoneLocationPin",
  }, 
  {
    id: "atlas:SmartphonePlay", 
    tags: ["atlas", "smartphone", "play"], 
    source: "atlas", 
    name: "SmartphonePlay",
  }, 
  {
    id: "atlas:SmartphoneRotation", 
    tags: ["atlas", "smartphone", "rotation"], 
    source: "atlas", 
    name: "SmartphoneRotation",
  }, 
  {
    id: "atlas:SmartphoneVirtualReality", 
    tags: ["atlas", "smartphone", "virtual", "reality"], 
    source: "atlas", 
    name: "SmartphoneVirtualReality",
  }, 
  {
    id: "atlas:Smartwatch", 
    tags: ["atlas", "smartwatch"], 
    source: "atlas", 
    name: "Smartwatch",
  }, 
  {
    id: "atlas:SmartwatchWireless", 
    tags: ["atlas", "smartwatch", "wireless"], 
    source: "atlas", 
    name: "SmartwatchWireless",
  }, 
  {
    id: "atlas:Snack", 
    tags: ["atlas", "snack"], 
    source: "atlas", 
    name: "Snack",
  }, 
  {
    id: "atlas:Snapchat", 
    tags: ["atlas", "snapchat"], 
    source: "atlas", 
    name: "Snapchat",
  }, 
  {
    id: "atlas:SneakersFootwareShoe", 
    tags: ["atlas", "sneakers", "footware", "shoe"], 
    source: "atlas", 
    name: "SneakersFootwareShoe",
  }, 
  {
    id: "atlas:Snorkling", 
    tags: ["atlas", "snorkling"], 
    source: "atlas", 
    name: "Snorkling",
  }, 
  {
    id: "atlas:SnowBoot", 
    tags: ["atlas", "snow", "boot"], 
    source: "atlas", 
    name: "SnowBoot",
  }, 
  {
    id: "atlas:SnowCap", 
    tags: ["atlas", "snow", "cap"], 
    source: "atlas", 
    name: "SnowCap",
  }, 
  {
    id: "atlas:SnowCloud", 
    tags: ["atlas", "snow", "cloud"], 
    source: "atlas", 
    name: "SnowCloud",
  }, 
  {
    id: "atlas:SnowGlobeDecoration", 
    tags: ["atlas", "snow", "globe", "decoration"], 
    source: "atlas", 
    name: "SnowGlobeDecoration",
  }, 
  {
    id: "atlas:SnowGloves", 
    tags: ["atlas", "snow", "gloves"], 
    source: "atlas", 
    name: "SnowGloves",
  }, 
  {
    id: "atlas:SnowGoggles", 
    tags: ["atlas", "snow", "goggles"], 
    source: "atlas", 
    name: "SnowGoggles",
  }, 
  {
    id: "atlas:SnowHat", 
    tags: ["atlas", "snow", "hat"], 
    source: "atlas", 
    name: "SnowHat",
  }, 
  {
    id: "atlas:SnowSkate", 
    tags: ["atlas", "snow", "skate"], 
    source: "atlas", 
    name: "SnowSkate",
  }, 
  {
    id: "atlas:SnowSki", 
    tags: ["atlas", "snow", "ski"], 
    source: "atlas", 
    name: "SnowSki",
  }, 
  {
    id: "atlas:Snowboard", 
    tags: ["atlas", "snowboard"], 
    source: "atlas", 
    name: "Snowboard",
  }, 
  {
    id: "atlas:SnowflakeDecor", 
    tags: ["atlas", "snowflake", "decor"], 
    source: "atlas", 
    name: "SnowflakeDecor",
  }, 
  {
    id: "atlas:SnowflakeDecoration", 
    tags: ["atlas", "snowflake", "decoration"], 
    source: "atlas", 
    name: "SnowflakeDecoration",
  }, 
  {
    id: "atlas:Snowglobe", 
    tags: ["atlas", "snowglobe"], 
    source: "atlas", 
    name: "Snowglobe",
  }, 
  {
    id: "atlas:Snowing", 
    tags: ["atlas", "snowing"], 
    source: "atlas", 
    name: "Snowing",
  }, 
  {
    id: "atlas:SnowingSnowflakes", 
    tags: ["atlas", "snowing", "snowflakes"], 
    source: "atlas", 
    name: "SnowingSnowflakes",
  }, 
  {
    id: "atlas:Snowman", 
    tags: ["atlas", "snowman"], 
    source: "atlas", 
    name: "Snowman",
  }, 
  {
    id: "atlas:SnowmanHat", 
    tags: ["atlas", "snowman", "hat"], 
    source: "atlas", 
    name: "SnowmanHat",
  }, 
  {
    id: "atlas:SoccerFootballField", 
    tags: ["atlas", "soccer", "football", "field"], 
    source: "atlas", 
    name: "SoccerFootballField",
  }, 
  {
    id: "atlas:Social9Gag", 
    tags: ["atlas", "social", "gag"], 
    source: "atlas", 
    name: "Social9Gag",
  }, 
  {
    id: "atlas:SocialLogo", 
    tags: ["atlas", "social", "logo"], 
    source: "atlas", 
    name: "SocialLogo",
  }, 
  {
    id: "atlas:SocialMedia", 
    tags: ["atlas", "social", "media"], 
    source: "atlas", 
    name: "SocialMedia",
  }, 
  {
    id: "atlas:SocialNetwork", 
    tags: ["atlas", "social", "network"], 
    source: "atlas", 
    name: "SocialNetwork",
  }, 
  {
    id: "atlas:Sock", 
    tags: ["atlas", "sock"], 
    source: "atlas", 
    name: "Sock",
  }, 
  {
    id: "atlas:SocketElectricity", 
    tags: ["atlas", "socket", "electricity"], 
    source: "atlas", 
    name: "SocketElectricity",
  }, 
  {
    id: "atlas:SodaCan", 
    tags: ["atlas", "soda", "can"], 
    source: "atlas", 
    name: "SodaCan",
  }, 
  {
    id: "atlas:SodaDrink", 
    tags: ["atlas", "soda", "drink"], 
    source: "atlas", 
    name: "SodaDrink",
  }, 
  {
    id: "atlas:SolarHouse", 
    tags: ["atlas", "solar", "house"], 
    source: "atlas", 
    name: "SolarHouse",
  }, 
  {
    id: "atlas:SolarPanelCharge", 
    tags: ["atlas", "solar", "panel", "charge"], 
    source: "atlas", 
    name: "SolarPanelCharge",
  }, 
  {
    id: "atlas:SolarPanelSun", 
    tags: ["atlas", "solar", "panel", "sun"], 
    source: "atlas", 
    name: "SolarPanelSun",
  }, 
  {
    id: "atlas:SolarPower", 
    tags: ["atlas", "solar", "power"], 
    source: "atlas", 
    name: "SolarPower",
  }, 
  {
    id: "atlas:SoldHouse", 
    tags: ["atlas", "sold", "house"], 
    source: "atlas", 
    name: "SoldHouse",
  }, 
  {
    id: "atlas:Sound", 
    tags: ["atlas", "sound"], 
    source: "atlas", 
    name: "Sound",
  }, 
  {
    id: "atlas:SoundFile", 
    tags: ["atlas", "sound", "file"], 
    source: "atlas", 
    name: "SoundFile",
  }, 
  {
    id: "atlas:SoundLines", 
    tags: ["atlas", "sound", "lines"], 
    source: "atlas", 
    name: "SoundLines",
  }, 
  {
    id: "atlas:SoundProof", 
    tags: ["atlas", "sound", "proof"], 
    source: "atlas", 
    name: "SoundProof",
  }, 
  {
    id: "atlas:Soundcloud", 
    tags: ["atlas", "soundcloud"], 
    source: "atlas", 
    name: "Soundcloud",
  }, 
  {
    id: "atlas:SoupBowl", 
    tags: ["atlas", "soup", "bowl"], 
    source: "atlas", 
    name: "SoupBowl",
  }, 
  {
    id: "atlas:SpaceNeedle", 
    tags: ["atlas", "space", "needle"], 
    source: "atlas", 
    name: "SpaceNeedle",
  }, 
  {
    id: "atlas:SpatchulaTool", 
    tags: ["atlas", "spatchula", "tool"], 
    source: "atlas", 
    name: "SpatchulaTool",
  }, 
  {
    id: "atlas:Speaker", 
    tags: ["atlas", "speaker"], 
    source: "atlas", 
    name: "Speaker",
  }, 
  {
    id: "atlas:Speakers", 
    tags: ["atlas", "speakers"], 
    source: "atlas", 
    name: "Speakers",
  }, 
  {
    id: "atlas:Speech", 
    tags: ["atlas", "speech"], 
    source: "atlas", 
    name: "Speech",
  }, 
  {
    id: "atlas:SpeechPersonPodium", 
    tags: ["atlas", "speech", "person", "podium"], 
    source: "atlas", 
    name: "SpeechPersonPodium",
  }, 
  {
    id: "atlas:SpeechPodium", 
    tags: ["atlas", "speech", "podium"], 
    source: "atlas", 
    name: "SpeechPodium",
  }, 
  {
    id: "atlas:SpeedBoat", 
    tags: ["atlas", "speed", "boat"], 
    source: "atlas", 
    name: "SpeedBoat",
  }, 
  {
    id: "atlas:SpeedTrain", 
    tags: ["atlas", "speed", "train"], 
    source: "atlas", 
    name: "SpeedTrain",
  }, 
  {
    id: "atlas:Sperm", 
    tags: ["atlas", "sperm"], 
    source: "atlas", 
    name: "Sperm",
  }, 
  {
    id: "atlas:Sphinx", 
    tags: ["atlas", "sphinx"], 
    source: "atlas", 
    name: "Sphinx",
  }, 
  {
    id: "atlas:Spine", 
    tags: ["atlas", "spine"], 
    source: "atlas", 
    name: "Spine",
  }, 
  {
    id: "atlas:Spiral", 
    tags: ["atlas", "spiral"], 
    source: "atlas", 
    name: "Spiral",
  }, 
  {
    id: "atlas:SpiralArrowUp", 
    tags: ["atlas", "spiral", "arrow", "up"], 
    source: "atlas", 
    name: "SpiralArrowUp",
  }, 
  {
    id: "atlas:SplitArrowUpLeftRight", 
    tags: ["atlas", "split", "arrow", "up", "left", "right"], 
    source: "atlas", 
    name: "SplitArrowUpLeftRight",
  }, 
  {
    id: "atlas:SplitArrowUpRight", 
    tags: ["atlas", "split", "arrow", "up", "right"], 
    source: "atlas", 
    name: "SplitArrowUpRight",
  }, 
  {
    id: "atlas:SplitArrows", 
    tags: ["atlas", "split", "arrows"], 
    source: "atlas", 
    name: "SplitArrows",
  }, 
  {
    id: "atlas:SplitArrowsLeftUp", 
    tags: ["atlas", "split", "arrows", "left", "up"], 
    source: "atlas", 
    name: "SplitArrowsLeftUp",
  }, 
  {
    id: "atlas:SplitArrowsUpwards", 
    tags: ["atlas", "split", "arrows", "upwards"], 
    source: "atlas", 
    name: "SplitArrowsUpwards",
  }, 
  {
    id: "atlas:SplitFile", 
    tags: ["atlas", "split", "file"], 
    source: "atlas", 
    name: "SplitFile",
  }, 
  {
    id: "atlas:SportBike", 
    tags: ["atlas", "sport", "bike"], 
    source: "atlas", 
    name: "SportBike",
  }, 
  {
    id: "atlas:SportsCar", 
    tags: ["atlas", "sports", "car"], 
    source: "atlas", 
    name: "SportsCar",
  }, 
  {
    id: "atlas:SportsShoe", 
    tags: ["atlas", "sports", "shoe"], 
    source: "atlas", 
    name: "SportsShoe",
  }, 
  {
    id: "atlas:Spotify", 
    tags: ["atlas", "spotify"], 
    source: "atlas", 
    name: "Spotify",
  }, 
  {
    id: "atlas:SquareCenter", 
    tags: ["atlas", "square", "center"], 
    source: "atlas", 
    name: "SquareCenter",
  }, 
  {
    id: "atlas:SquareLeft", 
    tags: ["atlas", "square", "left"], 
    source: "atlas", 
    name: "SquareLeft",
  }, 
  {
    id: "atlas:SquareMirror", 
    tags: ["atlas", "square", "mirror"], 
    source: "atlas", 
    name: "SquareMirror",
  }, 
  {
    id: "atlas:SquareRight", 
    tags: ["atlas", "square", "right"], 
    source: "atlas", 
    name: "SquareRight",
  }, 
  {
    id: "atlas:SquatPose", 
    tags: ["atlas", "squat", "pose"], 
    source: "atlas", 
    name: "SquatPose",
  }, 
  {
    id: "atlas:SquatYogaPose", 
    tags: ["atlas", "squat", "yoga", "pose"], 
    source: "atlas", 
    name: "SquatYogaPose",
  }, 
  {
    id: "atlas:StBasi", 
    tags: ["atlas", "st", "basi"], 
    source: "atlas", 
    name: "StBasi",
  }, 
  {
    id: "atlas:Stairs", 
    tags: ["atlas", "stairs"], 
    source: "atlas", 
    name: "Stairs",
  }, 
  {
    id: "atlas:StairsFlag", 
    tags: ["atlas", "stairs", "flag"], 
    source: "atlas", 
    name: "StairsFlag",
  }, 
  {
    id: "atlas:StairsUpDown", 
    tags: ["atlas", "stairs", "up", "down"], 
    source: "atlas", 
    name: "StairsUpDown",
  }, 
  {
    id: "atlas:Stamp", 
    tags: ["atlas", "stamp"], 
    source: "atlas", 
    name: "Stamp",
  }, 
  {
    id: "atlas:StandCamera", 
    tags: ["atlas", "stand", "camera"], 
    source: "atlas", 
    name: "StandCamera",
  }, 
  {
    id: "atlas:StandingClock", 
    tags: ["atlas", "standing", "clock"], 
    source: "atlas", 
    name: "StandingClock",
  }, 
  {
    id: "atlas:StandingForwardBendPose", 
    tags: ["atlas", "standing", "forward", "bend", "pose"], 
    source: "atlas", 
    name: "StandingForwardBendPose",
  }, 
  {
    id: "atlas:StandingStretch", 
    tags: ["atlas", "standing", "stretch"], 
    source: "atlas", 
    name: "StandingStretch",
  }, 
  {
    id: "atlas:Stapler", 
    tags: ["atlas", "stapler"], 
    source: "atlas", 
    name: "Stapler",
  }, 
  {
    id: "atlas:Star", 
    tags: ["atlas", "star"], 
    source: "atlas", 
    name: "Star",
  }, 
  {
    id: "atlas:StarAward", 
    tags: ["atlas", "star", "award"], 
    source: "atlas", 
    name: "StarAward",
  }, 
  {
    id: "atlas:StarAwardBelt", 
    tags: ["atlas", "star", "award", "belt"], 
    source: "atlas", 
    name: "StarAwardBelt",
  }, 
  {
    id: "atlas:StarBadgeAward", 
    tags: ["atlas", "star", "badge", "award"], 
    source: "atlas", 
    name: "StarBadgeAward",
  }, 
  {
    id: "atlas:StarBanner", 
    tags: ["atlas", "star", "banner"], 
    source: "atlas", 
    name: "StarBanner",
  }, 
  {
    id: "atlas:StarBookmark", 
    tags: ["atlas", "star", "bookmark"], 
    source: "atlas", 
    name: "StarBookmark",
  }, 
  {
    id: "atlas:StarChat", 
    tags: ["atlas", "star", "chat"], 
    source: "atlas", 
    name: "StarChat",
  }, 
  {
    id: "atlas:StarClipboard", 
    tags: ["atlas", "star", "clipboard"], 
    source: "atlas", 
    name: "StarClipboard",
  }, 
  {
    id: "atlas:StarComment", 
    tags: ["atlas", "star", "comment"], 
    source: "atlas", 
    name: "StarComment",
  }, 
  {
    id: "atlas:StarCommentRating", 
    tags: ["atlas", "star", "comment", "rating"], 
    source: "atlas", 
    name: "StarCommentRating",
  }, 
  {
    id: "atlas:StarDecor", 
    tags: ["atlas", "star", "decor"], 
    source: "atlas", 
    name: "StarDecor",
  }, 
  {
    id: "atlas:StarDecoration", 
    tags: ["atlas", "star", "decoration"], 
    source: "atlas", 
    name: "StarDecoration",
  }, 
  {
    id: "atlas:StarDocumentFrame", 
    tags: ["atlas", "star", "document", "frame"], 
    source: "atlas", 
    name: "StarDocumentFrame",
  }, 
  {
    id: "atlas:StarEnvelope", 
    tags: ["atlas", "star", "envelope"], 
    source: "atlas", 
    name: "StarEnvelope",
  }, 
  {
    id: "atlas:StarFile", 
    tags: ["atlas", "star", "file"], 
    source: "atlas", 
    name: "StarFile",
  }, 
  {
    id: "atlas:StarFolder", 
    tags: ["atlas", "star", "folder"], 
    source: "atlas", 
    name: "StarFolder",
  }, 
  {
    id: "atlas:StarHandshake", 
    tags: ["atlas", "star", "handshake"], 
    source: "atlas", 
    name: "StarHandshake",
  }, 
  {
    id: "atlas:StarLightbulb", 
    tags: ["atlas", "star", "lightbulb"], 
    source: "atlas", 
    name: "StarLightbulb",
  }, 
  {
    id: "atlas:StarMedalAward", 
    tags: ["atlas", "star", "medal", "award"], 
    source: "atlas", 
    name: "StarMedalAward",
  }, 
  {
    id: "atlas:StarMessage", 
    tags: ["atlas", "star", "message"], 
    source: "atlas", 
    name: "StarMessage",
  }, 
  {
    id: "atlas:StarMessages", 
    tags: ["atlas", "star", "messages"], 
    source: "atlas", 
    name: "StarMessages",
  }, 
  {
    id: "atlas:StarOrnament", 
    tags: ["atlas", "star", "ornament"], 
    source: "atlas", 
    name: "StarOrnament",
  }, 
  {
    id: "atlas:StarRatingBanner", 
    tags: ["atlas", "star", "rating", "banner"], 
    source: "atlas", 
    name: "StarRatingBanner",
  }, 
  {
    id: "atlas:StarRatingSuitcase", 
    tags: ["atlas", "star", "rating", "suitcase"], 
    source: "atlas", 
    name: "StarRatingSuitcase",
  }, 
  {
    id: "atlas:StarSquare", 
    tags: ["atlas", "star", "square"], 
    source: "atlas", 
    name: "StarSquare",
  }, 
  {
    id: "atlas:StarTicket", 
    tags: ["atlas", "star", "ticket"], 
    source: "atlas", 
    name: "StarTicket",
  }, 
  {
    id: "atlas:StarTicketCoupon", 
    tags: ["atlas", "star", "ticket", "coupon"], 
    source: "atlas", 
    name: "StarTicketCoupon",
  }, 
  {
    id: "atlas:StarTopper", 
    tags: ["atlas", "star", "topper"], 
    source: "atlas", 
    name: "StarTopper",
  }, 
  {
    id: "atlas:StarTrophyAchievement", 
    tags: ["atlas", "star", "trophy", "achievement"], 
    source: "atlas", 
    name: "StarTrophyAchievement",
  }, 
  {
    id: "atlas:Statistics", 
    tags: ["atlas", "statistics"], 
    source: "atlas", 
    name: "Statistics",
  }, 
  {
    id: "atlas:SterlingCircle", 
    tags: ["atlas", "sterling", "circle"], 
    source: "atlas", 
    name: "SterlingCircle",
  }, 
  {
    id: "atlas:SterlingSign", 
    tags: ["atlas", "sterling", "sign"], 
    source: "atlas", 
    name: "SterlingSign",
  }, 
  {
    id: "atlas:Stethoscope", 
    tags: ["atlas", "stethoscope"], 
    source: "atlas", 
    name: "Stethoscope",
  }, 
  {
    id: "atlas:Stocking", 
    tags: ["atlas", "stocking"], 
    source: "atlas", 
    name: "Stocking",
  }, 
  {
    id: "atlas:Stockings", 
    tags: ["atlas", "stockings"], 
    source: "atlas", 
    name: "Stockings",
  }, 
  {
    id: "atlas:Stomach", 
    tags: ["atlas", "stomach"], 
    source: "atlas", 
    name: "Stomach",
  }, 
  {
    id: "atlas:Stonehedge", 
    tags: ["atlas", "stonehedge"], 
    source: "atlas", 
    name: "Stonehedge",
  }, 
  {
    id: "atlas:Stool", 
    tags: ["atlas", "stool"], 
    source: "atlas", 
    name: "Stool",
  }, 
  {
    id: "atlas:Stop", 
    tags: ["atlas", "stop"], 
    source: "atlas", 
    name: "Stop",
  }, 
  {
    id: "atlas:StopCircle", 
    tags: ["atlas", "stop", "circle"], 
    source: "atlas", 
    name: "StopCircle",
  }, 
  {
    id: "atlas:Stopwatch", 
    tags: ["atlas", "stopwatch"], 
    source: "atlas", 
    name: "Stopwatch",
  }, 
  {
    id: "atlas:Storage", 
    tags: ["atlas", "storage"], 
    source: "atlas", 
    name: "Storage",
  }, 
  {
    id: "atlas:StorageCard", 
    tags: ["atlas", "storage", "card"], 
    source: "atlas", 
    name: "StorageCard",
  }, 
  {
    id: "atlas:Store", 
    tags: ["atlas", "store"], 
    source: "atlas", 
    name: "Store",
  }, 
  {
    id: "atlas:StraightAnglePose", 
    tags: ["atlas", "straight", "angle", "pose"], 
    source: "atlas", 
    name: "StraightAnglePose",
  }, 
  {
    id: "atlas:Streaming", 
    tags: ["atlas", "streaming"], 
    source: "atlas", 
    name: "Streaming",
  }, 
  {
    id: "atlas:StreetCone", 
    tags: ["atlas", "street", "cone"], 
    source: "atlas", 
    name: "StreetCone",
  }, 
  {
    id: "atlas:StreetDrill", 
    tags: ["atlas", "street", "drill"], 
    source: "atlas", 
    name: "StreetDrill",
  }, 
  {
    id: "atlas:Strength", 
    tags: ["atlas", "strength"], 
    source: "atlas", 
    name: "Strength",
  }, 
  {
    id: "atlas:Stretcher", 
    tags: ["atlas", "stretcher"], 
    source: "atlas", 
    name: "Stretcher",
  }, 
  {
    id: "atlas:StringLights", 
    tags: ["atlas", "string", "lights"], 
    source: "atlas", 
    name: "StringLights",
  }, 
  {
    id: "atlas:StrongRain", 
    tags: ["atlas", "strong", "rain"], 
    source: "atlas", 
    name: "StrongRain",
  }, 
  {
    id: "atlas:StrongRainNight", 
    tags: ["atlas", "strong", "rain", "night"], 
    source: "atlas", 
    name: "StrongRainNight",
  }, 
  {
    id: "atlas:StrongRainingDay", 
    tags: ["atlas", "strong", "raining", "day"], 
    source: "atlas", 
    name: "StrongRainingDay",
  }, 
  {
    id: "atlas:StrongWind", 
    tags: ["atlas", "strong", "wind"], 
    source: "atlas", 
    name: "StrongWind",
  }, 
  {
    id: "atlas:StrongWindCloud", 
    tags: ["atlas", "strong", "wind", "cloud"], 
    source: "atlas", 
    name: "StrongWindCloud",
  }, 
  {
    id: "atlas:StrongWindCloudDay", 
    tags: ["atlas", "strong", "wind", "cloud", "day"], 
    source: "atlas", 
    name: "StrongWindCloudDay",
  }, 
  {
    id: "atlas:StrongWindCloudNight", 
    tags: ["atlas", "strong", "wind", "cloud", "night"], 
    source: "atlas", 
    name: "StrongWindCloudNight",
  }, 
  {
    id: "atlas:StrongWindHail", 
    tags: ["atlas", "strong", "wind", "hail"], 
    source: "atlas", 
    name: "StrongWindHail",
  }, 
  {
    id: "atlas:StrongWindRainCloud", 
    tags: ["atlas", "strong", "wind", "rain", "cloud"], 
    source: "atlas", 
    name: "StrongWindRainCloud",
  }, 
  {
    id: "atlas:StrongWindRainDrop", 
    tags: ["atlas", "strong", "wind", "rain", "drop"], 
    source: "atlas", 
    name: "StrongWindRainDrop",
  }, 
  {
    id: "atlas:Submarine", 
    tags: ["atlas", "submarine"], 
    source: "atlas", 
    name: "Submarine",
  }, 
  {
    id: "atlas:SubmarineTravel", 
    tags: ["atlas", "submarine", "travel"], 
    source: "atlas", 
    name: "SubmarineTravel",
  }, 
  {
    id: "atlas:Suitcase", 
    tags: ["atlas", "suitcase"], 
    source: "atlas", 
    name: "Suitcase",
  }, 
  {
    id: "atlas:SuitcaseLuggage", 
    tags: ["atlas", "suitcase", "luggage"], 
    source: "atlas", 
    name: "SuitcaseLuggage",
  }, 
  {
    id: "atlas:SuitcaseTransport", 
    tags: ["atlas", "suitcase", "transport"], 
    source: "atlas", 
    name: "SuitcaseTransport",
  }, 
  {
    id: "atlas:SunMoon", 
    tags: ["atlas", "sun", "moon"], 
    source: "atlas", 
    name: "SunMoon",
  }, 
  {
    id: "atlas:SunOversea", 
    tags: ["atlas", "sun", "oversea"], 
    source: "atlas", 
    name: "SunOversea",
  }, 
  {
    id: "atlas:Sunflower", 
    tags: ["atlas", "sunflower"], 
    source: "atlas", 
    name: "Sunflower",
  }, 
  {
    id: "atlas:Sunny", 
    tags: ["atlas", "sunny"], 
    source: "atlas", 
    name: "Sunny",
  }, 
  {
    id: "atlas:Sunrise", 
    tags: ["atlas", "sunrise"], 
    source: "atlas", 
    name: "Sunrise",
  }, 
  {
    id: "atlas:SunriseArrowUp", 
    tags: ["atlas", "sunrise", "arrow", "up"], 
    source: "atlas", 
    name: "SunriseArrowUp",
  }, 
  {
    id: "atlas:SunsetArrowDown", 
    tags: ["atlas", "sunset", "arrow", "down"], 
    source: "atlas", 
    name: "SunsetArrowDown",
  }, 
  {
    id: "atlas:Supplement", 
    tags: ["atlas", "supplement"], 
    source: "atlas", 
    name: "Supplement",
  }, 
  {
    id: "atlas:SupportRibbon", 
    tags: ["atlas", "support", "ribbon"], 
    source: "atlas", 
    name: "SupportRibbon",
  }, 
  {
    id: "atlas:Surfboard", 
    tags: ["atlas", "surfboard"], 
    source: "atlas", 
    name: "Surfboard",
  }, 
  {
    id: "atlas:SurfboardSurfboarding", 
    tags: ["atlas", "surfboard", "surfboarding"], 
    source: "atlas", 
    name: "SurfboardSurfboarding",
  }, 
  {
    id: "atlas:SurfingVan", 
    tags: ["atlas", "surfing", "van"], 
    source: "atlas", 
    name: "SurfingVan",
  }, 
  {
    id: "atlas:SushiRiceBall", 
    tags: ["atlas", "sushi", "rice", "ball"], 
    source: "atlas", 
    name: "SushiRiceBall",
  }, 
  {
    id: "atlas:SushiRoll", 
    tags: ["atlas", "sushi", "roll"], 
    source: "atlas", 
    name: "SushiRoll",
  }, 
  {
    id: "atlas:SwimShorts", 
    tags: ["atlas", "swim", "shorts"], 
    source: "atlas", 
    name: "SwimShorts",
  }, 
  {
    id: "atlas:SwimmingGogglesCap", 
    tags: ["atlas", "swimming", "goggles", "cap"], 
    source: "atlas", 
    name: "SwimmingGogglesCap",
  }, 
  {
    id: "atlas:SwimmingPool", 
    tags: ["atlas", "swimming", "pool"], 
    source: "atlas", 
    name: "SwimmingPool",
  }, 
  {
    id: "atlas:SwimmingPoolLadder", 
    tags: ["atlas", "swimming", "pool", "ladder"], 
    source: "atlas", 
    name: "SwimmingPoolLadder",
  }, 
  {
    id: "atlas:TableDining", 
    tags: ["atlas", "table", "dining"], 
    source: "atlas", 
    name: "TableDining",
  }, 
  {
    id: "atlas:TableDrawers", 
    tags: ["atlas", "table", "drawers"], 
    source: "atlas", 
    name: "TableDrawers",
  }, 
  {
    id: "atlas:TableMeet", 
    tags: ["atlas", "table", "meet"], 
    source: "atlas", 
    name: "TableMeet",
  }, 
  {
    id: "atlas:TableTennisPingPong", 
    tags: ["atlas", "table", "tennis", "ping", "pong"], 
    source: "atlas", 
    name: "TableTennisPingPong",
  }, 
  {
    id: "atlas:Tables", 
    tags: ["atlas", "tables"], 
    source: "atlas", 
    name: "Tables",
  }, 
  {
    id: "atlas:Tablet", 
    tags: ["atlas", "tablet"], 
    source: "atlas", 
    name: "Tablet",
  }, 
  {
    id: "atlas:TabletPen", 
    tags: ["atlas", "tablet", "pen"], 
    source: "atlas", 
    name: "TabletPen",
  }, 
  {
    id: "atlas:Taco", 
    tags: ["atlas", "taco"], 
    source: "atlas", 
    name: "Taco",
  }, 
  {
    id: "atlas:Tag", 
    tags: ["atlas", "tag"], 
    source: "atlas", 
    name: "Tag",
  }, 
  {
    id: "atlas:TajMahal", 
    tags: ["atlas", "taj", "mahal"], 
    source: "atlas", 
    name: "TajMahal",
  }, 
  {
    id: "atlas:Tank", 
    tags: ["atlas", "tank"], 
    source: "atlas", 
    name: "Tank",
  }, 
  {
    id: "atlas:Tape", 
    tags: ["atlas", "tape"], 
    source: "atlas", 
    name: "Tape",
  }, 
  {
    id: "atlas:TapeMeasure", 
    tags: ["atlas", "tape", "measure"], 
    source: "atlas", 
    name: "TapeMeasure",
  }, 
  {
    id: "atlas:Target", 
    tags: ["atlas", "target"], 
    source: "atlas", 
    name: "Target",
  }, 
  {
    id: "atlas:TargetArrowBullseye", 
    tags: ["atlas", "target", "arrow", "bullseye"], 
    source: "atlas", 
    name: "TargetArrowBullseye",
  }, 
  {
    id: "atlas:TargetBug", 
    tags: ["atlas", "target", "bug"], 
    source: "atlas", 
    name: "TargetBug",
  }, 
  {
    id: "atlas:TargetBullseye", 
    tags: ["atlas", "target", "bullseye"], 
    source: "atlas", 
    name: "TargetBullseye",
  }, 
  {
    id: "atlas:TargetCrosshairsAccount", 
    tags: ["atlas", "target", "crosshairs", "account"], 
    source: "atlas", 
    name: "TargetCrosshairsAccount",
  }, 
  {
    id: "atlas:TargetUser", 
    tags: ["atlas", "target", "user"], 
    source: "atlas", 
    name: "TargetUser",
  }, 
  {
    id: "atlas:Taxi", 
    tags: ["atlas", "taxi"], 
    source: "atlas", 
    name: "Taxi",
  }, 
  {
    id: "atlas:TaxiFront", 
    tags: ["atlas", "taxi", "front"], 
    source: "atlas", 
    name: "TaxiFront",
  }, 
  {
    id: "atlas:TaxiService", 
    tags: ["atlas", "taxi", "service"], 
    source: "atlas", 
    name: "TaxiService",
  }, 
  {
    id: "atlas:TeaCoffee", 
    tags: ["atlas", "tea", "coffee"], 
    source: "atlas", 
    name: "TeaCoffee",
  }, 
  {
    id: "atlas:TeaMug", 
    tags: ["atlas", "tea", "mug"], 
    source: "atlas", 
    name: "TeaMug",
  }, 
  {
    id: "atlas:TeacherDesk", 
    tags: ["atlas", "teacher", "desk"], 
    source: "atlas", 
    name: "TeacherDesk",
  }, 
  {
    id: "atlas:TeamGroup", 
    tags: ["atlas", "team", "group"], 
    source: "atlas", 
    name: "TeamGroup",
  }, 
  {
    id: "atlas:TeamLaptopRemoteWorking", 
    tags: ["atlas", "team", "laptop", "remote", "working"], 
    source: "atlas", 
    name: "TeamLaptopRemoteWorking",
  }, 
  {
    id: "atlas:TeamMeeting", 
    tags: ["atlas", "team", "meeting"], 
    source: "atlas", 
    name: "TeamMeeting",
  }, 
  {
    id: "atlas:Telephone", 
    tags: ["atlas", "telephone"], 
    source: "atlas", 
    name: "Telephone",
  }, 
  {
    id: "atlas:Telescope", 
    tags: ["atlas", "telescope"], 
    source: "atlas", 
    name: "Telescope",
  }, 
  {
    id: "atlas:Terrace", 
    tags: ["atlas", "terrace"], 
    source: "atlas", 
    name: "Terrace",
  }, 
  {
    id: "atlas:TerraceChair", 
    tags: ["atlas", "terrace", "chair"], 
    source: "atlas", 
    name: "TerraceChair",
  }, 
  {
    id: "atlas:TestChemical", 
    tags: ["atlas", "test", "chemical"], 
    source: "atlas", 
    name: "TestChemical",
  }, 
  {
    id: "atlas:TestTube", 
    tags: ["atlas", "test", "tube"], 
    source: "atlas", 
    name: "TestTube",
  }, 
  {
    id: "atlas:TestTubeContainer", 
    tags: ["atlas", "test", "tube", "container"], 
    source: "atlas", 
    name: "TestTubeContainer",
  }, 
  {
    id: "atlas:TestTubeExperiment", 
    tags: ["atlas", "test", "tube", "experiment"], 
    source: "atlas", 
    name: "TestTubeExperiment",
  }, 
  {
    id: "atlas:TestTubeLabs", 
    tags: ["atlas", "test", "tube", "labs"], 
    source: "atlas", 
    name: "TestTubeLabs",
  }, 
  {
    id: "atlas:TestTubeSettings", 
    tags: ["atlas", "test", "tube", "settings"], 
    source: "atlas", 
    name: "TestTubeSettings",
  }, 
  {
    id: "atlas:TestTubeStand", 
    tags: ["atlas", "test", "tube", "stand"], 
    source: "atlas", 
    name: "TestTubeStand",
  }, 
  {
    id: "atlas:TestTubeTransfer", 
    tags: ["atlas", "test", "tube", "transfer"], 
    source: "atlas", 
    name: "TestTubeTransfer",
  }, 
  {
    id: "atlas:TestTubes", 
    tags: ["atlas", "test", "tubes"], 
    source: "atlas", 
    name: "TestTubes",
  }, 
  {
    id: "atlas:TestTubesChemical", 
    tags: ["atlas", "test", "tubes", "chemical"], 
    source: "atlas", 
    name: "TestTubesChemical",
  }, 
  {
    id: "atlas:TestTubesLab", 
    tags: ["atlas", "test", "tubes", "lab"], 
    source: "atlas", 
    name: "TestTubesLab",
  }, 
  {
    id: "atlas:TestVial", 
    tags: ["atlas", "test", "vial"], 
    source: "atlas", 
    name: "TestVial",
  }, 
  {
    id: "atlas:Tetris", 
    tags: ["atlas", "tetris"], 
    source: "atlas", 
    name: "Tetris",
  }, 
  {
    id: "atlas:Text", 
    tags: ["atlas", "text"], 
    source: "atlas", 
    name: "Text",
  }, 
  {
    id: "atlas:TextDirectionLeft", 
    tags: ["atlas", "text", "direction", "left"], 
    source: "atlas", 
    name: "TextDirectionLeft",
  }, 
  {
    id: "atlas:TextDirectionRight", 
    tags: ["atlas", "text", "direction", "right"], 
    source: "atlas", 
    name: "TextDirectionRight",
  }, 
  {
    id: "atlas:TextSize", 
    tags: ["atlas", "text", "size"], 
    source: "atlas", 
    name: "TextSize",
  }, 
  {
    id: "atlas:Textbook", 
    tags: ["atlas", "textbook"], 
    source: "atlas", 
    name: "Textbook",
  }, 
  {
    id: "atlas:ThaiLandmark", 
    tags: ["atlas", "thai", "landmark"], 
    source: "atlas", 
    name: "ThaiLandmark",
  }, 
  {
    id: "atlas:Thermometer", 
    tags: ["atlas", "thermometer"], 
    source: "atlas", 
    name: "Thermometer",
  }, 
  {
    id: "atlas:ThermometerAlert", 
    tags: ["atlas", "thermometer", "alert"], 
    source: "atlas", 
    name: "ThermometerAlert",
  }, 
  {
    id: "atlas:ThermometerMeasureTemp", 
    tags: ["atlas", "thermometer", "measure", "temp"], 
    source: "atlas", 
    name: "ThermometerMeasureTemp",
  }, 
  {
    id: "atlas:ThermometerTemp", 
    tags: ["atlas", "thermometer", "temp"], 
    source: "atlas", 
    name: "ThermometerTemp",
  }, 
  {
    id: "atlas:ThreeFinger", 
    tags: ["atlas", "three", "finger"], 
    source: "atlas", 
    name: "ThreeFinger",
  }, 
  {
    id: "atlas:ThreeLine", 
    tags: ["atlas", "three", "line"], 
    source: "atlas", 
    name: "ThreeLine",
  }, 
  {
    id: "atlas:ThumbsDown", 
    tags: ["atlas", "thumbs", "down"], 
    source: "atlas", 
    name: "ThumbsDown",
  }, 
  {
    id: "atlas:ThumbsUp", 
    tags: ["atlas", "thumbs", "up"], 
    source: "atlas", 
    name: "ThumbsUp",
  }, 
  {
    id: "atlas:ThumbsUpLike", 
    tags: ["atlas", "thumbs", "up", "like"], 
    source: "atlas", 
    name: "ThumbsUpLike",
  }, 
  {
    id: "atlas:ThumbsUpLikeStar", 
    tags: ["atlas", "thumbs", "up", "like", "star"], 
    source: "atlas", 
    name: "ThumbsUpLikeStar",
  }, 
  {
    id: "atlas:ThumbsUpLikes", 
    tags: ["atlas", "thumbs", "up", "likes"], 
    source: "atlas", 
    name: "ThumbsUpLikes",
  }, 
  {
    id: "atlas:Ticket", 
    tags: ["atlas", "ticket"], 
    source: "atlas", 
    name: "Ticket",
  }, 
  {
    id: "atlas:TicketCheck", 
    tags: ["atlas", "ticket", "check"], 
    source: "atlas", 
    name: "TicketCheck",
  }, 
  {
    id: "atlas:TicketCoupon", 
    tags: ["atlas", "ticket", "coupon"], 
    source: "atlas", 
    name: "TicketCoupon",
  }, 
  {
    id: "atlas:TicketPlay", 
    tags: ["atlas", "ticket", "play"], 
    source: "atlas", 
    name: "TicketPlay",
  }, 
  {
    id: "atlas:TicketPlus", 
    tags: ["atlas", "ticket", "plus"], 
    source: "atlas", 
    name: "TicketPlus",
  }, 
  {
    id: "atlas:TicketStar", 
    tags: ["atlas", "ticket", "star"], 
    source: "atlas", 
    name: "TicketStar",
  }, 
  {
    id: "atlas:TicketXmark", 
    tags: ["atlas", "ticket", "xmark"], 
    source: "atlas", 
    name: "TicketXmark",
  }, 
  {
    id: "atlas:Tie", 
    tags: ["atlas", "tie"], 
    source: "atlas", 
    name: "Tie",
  }, 
  {
    id: "atlas:Tiktok", 
    tags: ["atlas", "tiktok"], 
    source: "atlas", 
    name: "Tiktok",
  }, 
  {
    id: "atlas:TimeMovie", 
    tags: ["atlas", "time", "movie"], 
    source: "atlas", 
    name: "TimeMovie",
  }, 
  {
    id: "atlas:Timer", 
    tags: ["atlas", "timer"], 
    source: "atlas", 
    name: "Timer",
  }, 
  {
    id: "atlas:TimerMovie", 
    tags: ["atlas", "timer", "movie"], 
    source: "atlas", 
    name: "TimerMovie",
  }, 
  {
    id: "atlas:TinCan", 
    tags: ["atlas", "tin", "can"], 
    source: "atlas", 
    name: "TinCan",
  }, 
  {
    id: "atlas:Tinder", 
    tags: ["atlas", "tinder"], 
    source: "atlas", 
    name: "Tinder",
  }, 
  {
    id: "atlas:ToastBread", 
    tags: ["atlas", "toast", "bread"], 
    source: "atlas", 
    name: "ToastBread",
  }, 
  {
    id: "atlas:ToastBreadLoaf", 
    tags: ["atlas", "toast", "bread", "loaf"], 
    source: "atlas", 
    name: "ToastBreadLoaf",
  }, 
  {
    id: "atlas:ToeTouchPose", 
    tags: ["atlas", "toe", "touch", "pose"], 
    source: "atlas", 
    name: "ToeTouchPose",
  }, 
  {
    id: "atlas:Toilet", 
    tags: ["atlas", "toilet"], 
    source: "atlas", 
    name: "Toilet",
  }, 
  {
    id: "atlas:ToiletBathroom", 
    tags: ["atlas", "toilet", "bathroom"], 
    source: "atlas", 
    name: "ToiletBathroom",
  }, 
  {
    id: "atlas:ToiletPaper", 
    tags: ["atlas", "toilet", "paper"], 
    source: "atlas", 
    name: "ToiletPaper",
  }, 
  {
    id: "atlas:Tongue", 
    tags: ["atlas", "tongue"], 
    source: "atlas", 
    name: "Tongue",
  }, 
  {
    id: "atlas:ToolNail", 
    tags: ["atlas", "tool", "nail"], 
    source: "atlas", 
    name: "ToolNail",
  }, 
  {
    id: "atlas:Toolbox", 
    tags: ["atlas", "toolbox"], 
    source: "atlas", 
    name: "Toolbox",
  }, 
  {
    id: "atlas:Tools", 
    tags: ["atlas", "tools"], 
    source: "atlas", 
    name: "Tools",
  }, 
  {
    id: "atlas:Tooth", 
    tags: ["atlas", "tooth"], 
    source: "atlas", 
    name: "Tooth",
  }, 
  {
    id: "atlas:ToothBrushPaste", 
    tags: ["atlas", "tooth", "brush", "paste"], 
    source: "atlas", 
    name: "ToothBrushPaste",
  }, 
  {
    id: "atlas:TopTower", 
    tags: ["atlas", "top", "tower"], 
    source: "atlas", 
    name: "TopTower",
  }, 
  {
    id: "atlas:TopVerticalLayout", 
    tags: ["atlas", "top", "vertical", "layout"], 
    source: "atlas", 
    name: "TopVerticalLayout",
  }, 
  {
    id: "atlas:Torch", 
    tags: ["atlas", "torch"], 
    source: "atlas", 
    name: "Torch",
  }, 
  {
    id: "atlas:Tornado", 
    tags: ["atlas", "tornado"], 
    source: "atlas", 
    name: "Tornado",
  }, 
  {
    id: "atlas:TornadoWeather", 
    tags: ["atlas", "tornado", "weather"], 
    source: "atlas", 
    name: "TornadoWeather",
  }, 
  {
    id: "atlas:TouchGesture", 
    tags: ["atlas", "touch", "gesture"], 
    source: "atlas", 
    name: "TouchGesture",
  }, 
  {
    id: "atlas:Towel", 
    tags: ["atlas", "towel"], 
    source: "atlas", 
    name: "Towel",
  }, 
  {
    id: "atlas:TowelRack", 
    tags: ["atlas", "towel", "rack"], 
    source: "atlas", 
    name: "TowelRack",
  }, 
  {
    id: "atlas:TowerBridge", 
    tags: ["atlas", "tower", "bridge"], 
    source: "atlas", 
    name: "TowerBridge",
  }, 
  {
    id: "atlas:TowerEiffel", 
    tags: ["atlas", "tower", "eiffel"], 
    source: "atlas", 
    name: "TowerEiffel",
  }, 
  {
    id: "atlas:TowerLandmark", 
    tags: ["atlas", "tower", "landmark"], 
    source: "atlas", 
    name: "TowerLandmark",
  }, 
  {
    id: "atlas:TowersLandmark", 
    tags: ["atlas", "towers", "landmark"], 
    source: "atlas", 
    name: "TowersLandmark",
  }, 
  {
    id: "atlas:Tractor", 
    tags: ["atlas", "tractor"], 
    source: "atlas", 
    name: "Tractor",
  }, 
  {
    id: "atlas:Train", 
    tags: ["atlas", "train"], 
    source: "atlas", 
    name: "Train",
  }, 
  {
    id: "atlas:TrainLocomotive", 
    tags: ["atlas", "train", "locomotive"], 
    source: "atlas", 
    name: "TrainLocomotive",
  }, 
  {
    id: "atlas:TrainTransport", 
    tags: ["atlas", "train", "transport"], 
    source: "atlas", 
    name: "TrainTransport",
  }, 
  {
    id: "atlas:TrainTransportation", 
    tags: ["atlas", "train", "transportation"], 
    source: "atlas", 
    name: "TrainTransportation",
  }, 
  {
    id: "atlas:TrainTravel", 
    tags: ["atlas", "train", "travel"], 
    source: "atlas", 
    name: "TrainTravel",
  }, 
  {
    id: "atlas:TrainTunnel", 
    tags: ["atlas", "train", "tunnel"], 
    source: "atlas", 
    name: "TrainTunnel",
  }, 
  {
    id: "atlas:Trainer", 
    tags: ["atlas", "trainer"], 
    source: "atlas", 
    name: "Trainer",
  }, 
  {
    id: "atlas:TramTransport", 
    tags: ["atlas", "tram", "transport"], 
    source: "atlas", 
    name: "TramTransport",
  }, 
  {
    id: "atlas:TransferArrowsLeft", 
    tags: ["atlas", "transfer", "arrows", "left"], 
    source: "atlas", 
    name: "TransferArrowsLeft",
  }, 
  {
    id: "atlas:TransferArrowsLeftRightGroup", 
    tags: ["atlas", "transfer", "arrows", "left", "right", "group"], 
    source: "atlas", 
    name: "TransferArrowsLeftRightGroup",
  }, 
  {
    id: "atlas:TransferArrowsRight", 
    tags: ["atlas", "transfer", "arrows", "right"], 
    source: "atlas", 
    name: "TransferArrowsRight",
  }, 
  {
    id: "atlas:TransferCloud", 
    tags: ["atlas", "transfer", "cloud"], 
    source: "atlas", 
    name: "TransferCloud",
  }, 
  {
    id: "atlas:TransferringAccounts", 
    tags: ["atlas", "transferring", "accounts"], 
    source: "atlas", 
    name: "TransferringAccounts",
  }, 
  {
    id: "atlas:TransportTruck", 
    tags: ["atlas", "transport", "truck"], 
    source: "atlas", 
    name: "TransportTruck",
  }, 
  {
    id: "atlas:Trash", 
    tags: ["atlas", "trash"], 
    source: "atlas", 
    name: "Trash",
  }, 
  {
    id: "atlas:TrashCan", 
    tags: ["atlas", "trash", "can"], 
    source: "atlas", 
    name: "TrashCan",
  }, 
  {
    id: "atlas:TravelBus", 
    tags: ["atlas", "travel", "bus"], 
    source: "atlas", 
    name: "TravelBus",
  }, 
  {
    id: "atlas:TravelCar", 
    tags: ["atlas", "travel", "car"], 
    source: "atlas", 
    name: "TravelCar",
  }, 
  {
    id: "atlas:TravelLuggage", 
    tags: ["atlas", "travel", "luggage"], 
    source: "atlas", 
    name: "TravelLuggage",
  }, 
  {
    id: "atlas:Treadmill", 
    tags: ["atlas", "treadmill"], 
    source: "atlas", 
    name: "Treadmill",
  }, 
  {
    id: "atlas:TreadmillRunning", 
    tags: ["atlas", "treadmill", "running"], 
    source: "atlas", 
    name: "TreadmillRunning",
  }, 
  {
    id: "atlas:Tree", 
    tags: ["atlas", "tree"], 
    source: "atlas", 
    name: "Tree",
  }, 
  {
    id: "atlas:TreeCalendar", 
    tags: ["atlas", "tree", "calendar"], 
    source: "atlas", 
    name: "TreeCalendar",
  }, 
  {
    id: "atlas:TreeLeafNature", 
    tags: ["atlas", "tree", "leaf", "nature"], 
    source: "atlas", 
    name: "TreeLeafNature",
  }, 
  {
    id: "atlas:TreeLight", 
    tags: ["atlas", "tree", "light"], 
    source: "atlas", 
    name: "TreeLight",
  }, 
  {
    id: "atlas:TreePose", 
    tags: ["atlas", "tree", "pose"], 
    source: "atlas", 
    name: "TreePose",
  }, 
  {
    id: "atlas:TreeSnowglobe", 
    tags: ["atlas", "tree", "snowglobe"], 
    source: "atlas", 
    name: "TreeSnowglobe",
  }, 
  {
    id: "atlas:TriangleExclamation", 
    tags: ["atlas", "triangle", "exclamation"], 
    source: "atlas", 
    name: "TriangleExclamation",
  }, 
  {
    id: "atlas:TrianglePose", 
    tags: ["atlas", "triangle", "pose"], 
    source: "atlas", 
    name: "TrianglePose",
  }, 
  {
    id: "atlas:TrimPathfinder", 
    tags: ["atlas", "trim", "pathfinder"], 
    source: "atlas", 
    name: "TrimPathfinder",
  }, 
  {
    id: "atlas:TripleArrows", 
    tags: ["atlas", "triple", "arrows"], 
    source: "atlas", 
    name: "TripleArrows",
  }, 
  {
    id: "atlas:TripleArrowsUp", 
    tags: ["atlas", "triple", "arrows", "up"], 
    source: "atlas", 
    name: "TripleArrowsUp",
  }, 
  {
    id: "atlas:TrophyStarReward", 
    tags: ["atlas", "trophy", "star", "reward"], 
    source: "atlas", 
    name: "TrophyStarReward",
  }, 
  {
    id: "atlas:TropicalHoliday", 
    tags: ["atlas", "tropical", "holiday"], 
    source: "atlas", 
    name: "TropicalHoliday",
  }, 
  {
    id: "atlas:Tty", 
    tags: ["atlas", "tty"], 
    source: "atlas", 
    name: "Tty",
  }, 
  {
    id: "atlas:Tumblr", 
    tags: ["atlas", "tumblr"], 
    source: "atlas", 
    name: "Tumblr",
  }, 
  {
    id: "atlas:Turkey", 
    tags: ["atlas", "turkey"], 
    source: "atlas", 
    name: "Turkey",
  }, 
  {
    id: "atlas:TurkeyDinner", 
    tags: ["atlas", "turkey", "dinner"], 
    source: "atlas", 
    name: "TurkeyDinner",
  }, 
  {
    id: "atlas:TurkeyLeg", 
    tags: ["atlas", "turkey", "leg"], 
    source: "atlas", 
    name: "TurkeyLeg",
  }, 
  {
    id: "atlas:Turnip", 
    tags: ["atlas", "turnip"], 
    source: "atlas", 
    name: "Turnip",
  }, 
  {
    id: "atlas:Tv", 
    tags: ["atlas", "tv"], 
    source: "atlas", 
    name: "Tv",
  }, 
  {
    id: "atlas:TwistPose", 
    tags: ["atlas", "twist", "pose"], 
    source: "atlas", 
    name: "TwistPose",
  }, 
  {
    id: "atlas:Twitch", 
    tags: ["atlas", "twitch"], 
    source: "atlas", 
    name: "Twitch",
  }, 
  {
    id: "atlas:Twitter", 
    tags: ["atlas", "twitter"], 
    source: "atlas", 
    name: "Twitter",
  }, 
  {
    id: "atlas:TwoFinger", 
    tags: ["atlas", "two", "finger"], 
    source: "atlas", 
    name: "TwoFinger",
  }, 
  {
    id: "atlas:TwoFingerPoint", 
    tags: ["atlas", "two", "finger", "point"], 
    source: "atlas", 
    name: "TwoFingerPoint",
  }, 
  {
    id: "atlas:TwoLine", 
    tags: ["atlas", "two", "line"], 
    source: "atlas", 
    name: "TwoLine",
  }, 
  {
    id: "atlas:TwoPeopleArrowUp", 
    tags: ["atlas", "two", "people", "arrow", "up"], 
    source: "atlas", 
    name: "TwoPeopleArrowUp",
  }, 
  {
    id: "atlas:TwoPeopleStar", 
    tags: ["atlas", "two", "people", "star"], 
    source: "atlas", 
    name: "TwoPeopleStar",
  }, 
  {
    id: "atlas:TwoPersonMeeting", 
    tags: ["atlas", "two", "person", "meeting"], 
    source: "atlas", 
    name: "TwoPersonMeeting",
  }, 
  {
    id: "atlas:Typewriter", 
    tags: ["atlas", "typewriter"], 
    source: "atlas", 
    name: "Typewriter",
  }, 
  {
    id: "atlas:UTurnArrowDown", 
    tags: ["atlas", "turn", "arrow", "down"], 
    source: "atlas", 
    name: "UTurnArrowDown",
  }, 
  {
    id: "atlas:UTurnArrowLeft", 
    tags: ["atlas", "turn", "arrow", "left"], 
    source: "atlas", 
    name: "UTurnArrowLeft",
  }, 
  {
    id: "atlas:UTurnArrowRight", 
    tags: ["atlas", "turn", "arrow", "right"], 
    source: "atlas", 
    name: "UTurnArrowRight",
  }, 
  {
    id: "atlas:UTurnArrowUp", 
    tags: ["atlas", "turn", "arrow", "up"], 
    source: "atlas", 
    name: "UTurnArrowUp",
  }, 
  {
    id: "atlas:Ufo", 
    tags: ["atlas", "ufo"], 
    source: "atlas", 
    name: "Ufo",
  }, 
  {
    id: "atlas:Umbrella", 
    tags: ["atlas", "umbrella"], 
    source: "atlas", 
    name: "Umbrella",
  }, 
  {
    id: "atlas:UmbrellaProtection", 
    tags: ["atlas", "umbrella", "protection"], 
    source: "atlas", 
    name: "UmbrellaProtection",
  }, 
  {
    id: "atlas:UmbrellaSafety", 
    tags: ["atlas", "umbrella", "safety"], 
    source: "atlas", 
    name: "UmbrellaSafety",
  }, 
  {
    id: "atlas:Underline", 
    tags: ["atlas", "underline"], 
    source: "atlas", 
    name: "Underline",
  }, 
  {
    id: "atlas:UniformJersey", 
    tags: ["atlas", "uniform", "jersey"], 
    source: "atlas", 
    name: "UniformJersey",
  }, 
  {
    id: "atlas:UnlockKeyhole", 
    tags: ["atlas", "unlock", "keyhole"], 
    source: "atlas", 
    name: "UnlockKeyhole",
  }, 
  {
    id: "atlas:Unlocked", 
    tags: ["atlas", "unlocked"], 
    source: "atlas", 
    name: "Unlocked",
  }, 
  {
    id: "atlas:UpArrow", 
    tags: ["atlas", "up", "arrow"], 
    source: "atlas", 
    name: "UpArrow",
  }, 
  {
    id: "atlas:UpArrowFromBracket", 
    tags: ["atlas", "up", "arrow", "from", "bracket"], 
    source: "atlas", 
    name: "UpArrowFromBracket",
  }, 
  {
    id: "atlas:UpDownMove", 
    tags: ["atlas", "up", "down", "move"], 
    source: "atlas", 
    name: "UpDownMove",
  }, 
  {
    id: "atlas:UpLeftArrow", 
    tags: ["atlas", "up", "left", "arrow"], 
    source: "atlas", 
    name: "UpLeftArrow",
  }, 
  {
    id: "atlas:UpLeftArrows", 
    tags: ["atlas", "up", "left", "arrows"], 
    source: "atlas", 
    name: "UpLeftArrows",
  }, 
  {
    id: "atlas:UpMove", 
    tags: ["atlas", "up", "move"], 
    source: "atlas", 
    name: "UpMove",
  }, 
  {
    id: "atlas:UpOrientation", 
    tags: ["atlas", "up", "orientation"], 
    source: "atlas", 
    name: "UpOrientation",
  }, 
  {
    id: "atlas:UpRightArrow", 
    tags: ["atlas", "up", "right", "arrow"], 
    source: "atlas", 
    name: "UpRightArrow",
  }, 
  {
    id: "atlas:UploadArrowTray", 
    tags: ["atlas", "upload", "arrow", "tray"], 
    source: "atlas", 
    name: "UploadArrowTray",
  }, 
  {
    id: "atlas:Upstairs", 
    tags: ["atlas", "upstairs"], 
    source: "atlas", 
    name: "Upstairs",
  }, 
  {
    id: "atlas:UpwardEscalator", 
    tags: ["atlas", "upward", "escalator"], 
    source: "atlas", 
    name: "UpwardEscalator",
  }, 
  {
    id: "atlas:UpwardFacingDogPose", 
    tags: ["atlas", "upward", "facing", "dog", "pose"], 
    source: "atlas", 
    name: "UpwardFacingDogPose",
  }, 
  {
    id: "atlas:Urinal", 
    tags: ["atlas", "urinal"], 
    source: "atlas", 
    name: "Urinal",
  }, 
  {
    id: "atlas:UsbCable", 
    tags: ["atlas", "usb", "cable"], 
    source: "atlas", 
    name: "UsbCable",
  }, 
  {
    id: "atlas:UsbPlug", 
    tags: ["atlas", "usb", "plug"], 
    source: "atlas", 
    name: "UsbPlug",
  }, 
  {
    id: "atlas:UsbPort", 
    tags: ["atlas", "usb", "port"], 
    source: "atlas", 
    name: "UsbPort",
  }, 
  {
    id: "atlas:UsbStick", 
    tags: ["atlas", "usb", "stick"], 
    source: "atlas", 
    name: "UsbStick",
  }, 
  {
    id: "atlas:User", 
    tags: ["atlas", "user"], 
    source: "atlas", 
    name: "User",
  }, 
  {
    id: "atlas:UserArrows", 
    tags: ["atlas", "user", "arrows"], 
    source: "atlas", 
    name: "UserArrows",
  }, 
  {
    id: "atlas:UserChat", 
    tags: ["atlas", "user", "chat"], 
    source: "atlas", 
    name: "UserChat",
  }, 
  {
    id: "atlas:UserChats", 
    tags: ["atlas", "user", "chats"], 
    source: "atlas", 
    name: "UserChats",
  }, 
  {
    id: "atlas:UserCheck", 
    tags: ["atlas", "user", "check"], 
    source: "atlas", 
    name: "UserCheck",
  }, 
  {
    id: "atlas:UserClipboard", 
    tags: ["atlas", "user", "clipboard"], 
    source: "atlas", 
    name: "UserClipboard",
  }, 
  {
    id: "atlas:UserComment", 
    tags: ["atlas", "user", "comment"], 
    source: "atlas", 
    name: "UserComment",
  }, 
  {
    id: "atlas:UserFile", 
    tags: ["atlas", "user", "file"], 
    source: "atlas", 
    name: "UserFile",
  }, 
  {
    id: "atlas:UserFolder", 
    tags: ["atlas", "user", "folder"], 
    source: "atlas", 
    name: "UserFolder",
  }, 
  {
    id: "atlas:UserGear", 
    tags: ["atlas", "user", "gear"], 
    source: "atlas", 
    name: "UserGear",
  }, 
  {
    id: "atlas:UserHierarchy", 
    tags: ["atlas", "user", "hierarchy"], 
    source: "atlas", 
    name: "UserHierarchy",
  }, 
  {
    id: "atlas:UserKey", 
    tags: ["atlas", "user", "key"], 
    source: "atlas", 
    name: "UserKey",
  }, 
  {
    id: "atlas:UserMessage", 
    tags: ["atlas", "user", "message"], 
    source: "atlas", 
    name: "UserMessage",
  }, 
  {
    id: "atlas:UserMinus", 
    tags: ["atlas", "user", "minus"], 
    source: "atlas", 
    name: "UserMinus",
  }, 
  {
    id: "atlas:UserPlus", 
    tags: ["atlas", "user", "plus"], 
    source: "atlas", 
    name: "UserPlus",
  }, 
  {
    id: "atlas:UserTarget", 
    tags: ["atlas", "user", "target"], 
    source: "atlas", 
    name: "UserTarget",
  }, 
  {
    id: "atlas:UserXmark", 
    tags: ["atlas", "user", "xmark"], 
    source: "atlas", 
    name: "UserXmark",
  }, 
  {
    id: "atlas:Users", 
    tags: ["atlas", "users"], 
    source: "atlas", 
    name: "Users",
  }, 
  {
    id: "atlas:UsersArrows", 
    tags: ["atlas", "users", "arrows"], 
    source: "atlas", 
    name: "UsersArrows",
  }, 
  {
    id: "atlas:UsersStairs", 
    tags: ["atlas", "users", "stairs"], 
    source: "atlas", 
    name: "UsersStairs",
  }, 
  {
    id: "atlas:Uterus", 
    tags: ["atlas", "uterus"], 
    source: "atlas", 
    name: "Uterus",
  }, 
  {
    id: "atlas:Vaccine", 
    tags: ["atlas", "vaccine"], 
    source: "atlas", 
    name: "Vaccine",
  }, 
  {
    id: "atlas:Van", 
    tags: ["atlas", "van"], 
    source: "atlas", 
    name: "Van",
  }, 
  {
    id: "atlas:VanCar", 
    tags: ["atlas", "van", "car"], 
    source: "atlas", 
    name: "VanCar",
  }, 
  {
    id: "atlas:VanTransportation", 
    tags: ["atlas", "van", "transportation"], 
    source: "atlas", 
    name: "VanTransportation",
  }, 
  {
    id: "atlas:VanTruck", 
    tags: ["atlas", "van", "truck"], 
    source: "atlas", 
    name: "VanTruck",
  }, 
  {
    id: "atlas:Vault", 
    tags: ["atlas", "vault"], 
    source: "atlas", 
    name: "Vault",
  }, 
  {
    id: "atlas:VerticalCenter", 
    tags: ["atlas", "vertical", "center"], 
    source: "atlas", 
    name: "VerticalCenter",
  }, 
  {
    id: "atlas:VerticalLayout", 
    tags: ["atlas", "vertical", "layout"], 
    source: "atlas", 
    name: "VerticalLayout",
  }, 
  {
    id: "atlas:VerticalLineChart", 
    tags: ["atlas", "vertical", "line", "chart"], 
    source: "atlas", 
    name: "VerticalLineChart",
  }, 
  {
    id: "atlas:VerticalSlidersDots", 
    tags: ["atlas", "vertical", "sliders", "dots"], 
    source: "atlas", 
    name: "VerticalSlidersDots",
  }, 
  {
    id: "atlas:VerticalSlidersLines", 
    tags: ["atlas", "vertical", "sliders", "lines"], 
    source: "atlas", 
    name: "VerticalSlidersLines",
  }, 
  {
    id: "atlas:Vespa", 
    tags: ["atlas", "vespa"], 
    source: "atlas", 
    name: "Vespa",
  }, 
  {
    id: "atlas:VespaFront", 
    tags: ["atlas", "vespa", "front"], 
    source: "atlas", 
    name: "VespaFront",
  }, 
  {
    id: "atlas:VialStand", 
    tags: ["atlas", "vial", "stand"], 
    source: "atlas", 
    name: "VialStand",
  }, 
  {
    id: "atlas:VialsStand", 
    tags: ["atlas", "vials", "stand"], 
    source: "atlas", 
    name: "VialsStand",
  }, 
  {
    id: "atlas:Viber", 
    tags: ["atlas", "viber"], 
    source: "atlas", 
    name: "Viber",
  }, 
  {
    id: "atlas:VideoCamera", 
    tags: ["atlas", "video", "camera"], 
    source: "atlas", 
    name: "VideoCamera",
  }, 
  {
    id: "atlas:VideoChat", 
    tags: ["atlas", "video", "chat"], 
    source: "atlas", 
    name: "VideoChat",
  }, 
  {
    id: "atlas:VideoClip", 
    tags: ["atlas", "video", "clip"], 
    source: "atlas", 
    name: "VideoClip",
  }, 
  {
    id: "atlas:VideoMessage", 
    tags: ["atlas", "video", "message"], 
    source: "atlas", 
    name: "VideoMessage",
  }, 
  {
    id: "atlas:VideoMonitor", 
    tags: ["atlas", "video", "monitor"], 
    source: "atlas", 
    name: "VideoMonitor",
  }, 
  {
    id: "atlas:VideoPlayerWebsite", 
    tags: ["atlas", "video", "player", "website"], 
    source: "atlas", 
    name: "VideoPlayerWebsite",
  }, 
  {
    id: "atlas:VideoRecorder", 
    tags: ["atlas", "video", "recorder"], 
    source: "atlas", 
    name: "VideoRecorder",
  }, 
  {
    id: "atlas:ViewArrow", 
    tags: ["atlas", "view", "arrow"], 
    source: "atlas", 
    name: "ViewArrow",
  }, 
  {
    id: "atlas:ViewMonitor", 
    tags: ["atlas", "view", "monitor"], 
    source: "atlas", 
    name: "ViewMonitor",
  }, 
  {
    id: "atlas:ViewPadlock", 
    tags: ["atlas", "view", "padlock"], 
    source: "atlas", 
    name: "ViewPadlock",
  }, 
  {
    id: "atlas:ViewVr", 
    tags: ["atlas", "view", "vr"], 
    source: "atlas", 
    name: "ViewVr",
  }, 
  {
    id: "atlas:ViewWindow", 
    tags: ["atlas", "view", "window"], 
    source: "atlas", 
    name: "ViewWindow",
  }, 
  {
    id: "atlas:Vimeo", 
    tags: ["atlas", "vimeo"], 
    source: "atlas", 
    name: "Vimeo",
  }, 
  {
    id: "atlas:VintageBike", 
    tags: ["atlas", "vintage", "bike"], 
    source: "atlas", 
    name: "VintageBike",
  }, 
  {
    id: "atlas:VirtualGlasses", 
    tags: ["atlas", "virtual", "glasses"], 
    source: "atlas", 
    name: "VirtualGlasses",
  }, 
  {
    id: "atlas:VirtualReality", 
    tags: ["atlas", "virtual", "reality"], 
    source: "atlas", 
    name: "VirtualReality",
  }, 
  {
    id: "atlas:VirtualRealityDimension", 
    tags: ["atlas", "virtual", "reality", "dimension"], 
    source: "atlas", 
    name: "VirtualRealityDimension",
  }, 
  {
    id: "atlas:VirtualRealityEye", 
    tags: ["atlas", "virtual", "reality", "eye"], 
    source: "atlas", 
    name: "VirtualRealityEye",
  }, 
  {
    id: "atlas:VirtualRealityGlasses", 
    tags: ["atlas", "virtual", "reality", "glasses"], 
    source: "atlas", 
    name: "VirtualRealityGlasses",
  }, 
  {
    id: "atlas:VirtualRealityImage", 
    tags: ["atlas", "virtual", "reality", "image"], 
    source: "atlas", 
    name: "VirtualRealityImage",
  }, 
  {
    id: "atlas:VirtualRealityPlay", 
    tags: ["atlas", "virtual", "reality", "play"], 
    source: "atlas", 
    name: "VirtualRealityPlay",
  }, 
  {
    id: "atlas:VirtualRealityView", 
    tags: ["atlas", "virtual", "reality", "view"], 
    source: "atlas", 
    name: "VirtualRealityView",
  }, 
  {
    id: "atlas:VirtualVrGlasses", 
    tags: ["atlas", "virtual", "vr", "glasses"], 
    source: "atlas", 
    name: "VirtualVrGlasses",
  }, 
  {
    id: "atlas:Virus", 
    tags: ["atlas", "virus"], 
    source: "atlas", 
    name: "Virus",
  }, 
  {
    id: "atlas:VirusMedical", 
    tags: ["atlas", "virus", "medical"], 
    source: "atlas", 
    name: "VirusMedical",
  }, 
  {
    id: "atlas:Vision", 
    tags: ["atlas", "vision"], 
    source: "atlas", 
    name: "Vision",
  }, 
  {
    id: "atlas:Vk", 
    tags: ["atlas", "vk"], 
    source: "atlas", 
    name: "Vk",
  }, 
  {
    id: "atlas:VoiceEnvelope", 
    tags: ["atlas", "voice", "envelope"], 
    source: "atlas", 
    name: "VoiceEnvelope",
  }, 
  {
    id: "atlas:VoiceFile", 
    tags: ["atlas", "voice", "file"], 
    source: "atlas", 
    name: "VoiceFile",
  }, 
  {
    id: "atlas:VoiceFolder", 
    tags: ["atlas", "voice", "folder"], 
    source: "atlas", 
    name: "VoiceFolder",
  }, 
  {
    id: "atlas:VolleyballBall", 
    tags: ["atlas", "volleyball", "ball"], 
    source: "atlas", 
    name: "VolleyballBall",
  }, 
  {
    id: "atlas:VolleyballNet", 
    tags: ["atlas", "volleyball", "net"], 
    source: "atlas", 
    name: "VolleyballNet",
  }, 
  {
    id: "atlas:Volume", 
    tags: ["atlas", "volume"], 
    source: "atlas", 
    name: "Volume",
  }, 
  {
    id: "atlas:VrArrows", 
    tags: ["atlas", "vr", "arrows"], 
    source: "atlas", 
    name: "VrArrows",
  }, 
  {
    id: "atlas:VrGlasses", 
    tags: ["atlas", "vr", "glasses"], 
    source: "atlas", 
    name: "VrGlasses",
  }, 
  {
    id: "atlas:VrGlassesScience", 
    tags: ["atlas", "vr", "glasses", "science"], 
    source: "atlas", 
    name: "VrGlassesScience",
  }, 
  {
    id: "atlas:VrGlassesSettings", 
    tags: ["atlas", "vr", "glasses", "settings"], 
    source: "atlas", 
    name: "VrGlassesSettings",
  }, 
  {
    id: "atlas:VrGlassesWifi", 
    tags: ["atlas", "vr", "glasses", "wifi"], 
    source: "atlas", 
    name: "VrGlassesWifi",
  }, 
  {
    id: "atlas:VrGoggles", 
    tags: ["atlas", "vr", "goggles"], 
    source: "atlas", 
    name: "VrGoggles",
  }, 
  {
    id: "atlas:VrSplit", 
    tags: ["atlas", "vr", "split"], 
    source: "atlas", 
    name: "VrSplit",
  }, 
  {
    id: "atlas:WalkieTalkie", 
    tags: ["atlas", "walkie", "talkie"], 
    source: "atlas", 
    name: "WalkieTalkie",
  }, 
  {
    id: "atlas:Wall", 
    tags: ["atlas", "wall"], 
    source: "atlas", 
    name: "Wall",
  }, 
  {
    id: "atlas:Wallet", 
    tags: ["atlas", "wallet"], 
    source: "atlas", 
    name: "Wallet",
  }, 
  {
    id: "atlas:WardrobeMirror", 
    tags: ["atlas", "wardrobe", "mirror"], 
    source: "atlas", 
    name: "WardrobeMirror",
  }, 
  {
    id: "atlas:Warning", 
    tags: ["atlas", "warning"], 
    source: "atlas", 
    name: "Warning",
  }, 
  {
    id: "atlas:WashingMachine", 
    tags: ["atlas", "washing", "machine"], 
    source: "atlas", 
    name: "WashingMachine",
  }, 
  {
    id: "atlas:WashingtonBuilding", 
    tags: ["atlas", "washington", "building"], 
    source: "atlas", 
    name: "WashingtonBuilding",
  }, 
  {
    id: "atlas:WashingtonMonument", 
    tags: ["atlas", "washington", "monument"], 
    source: "atlas", 
    name: "WashingtonMonument",
  }, 
  {
    id: "atlas:Water", 
    tags: ["atlas", "water"], 
    source: "atlas", 
    name: "Water",
  }, 
  {
    id: "atlas:WaterBoiler", 
    tags: ["atlas", "water", "boiler"], 
    source: "atlas", 
    name: "WaterBoiler",
  }, 
  {
    id: "atlas:WaterBottle", 
    tags: ["atlas", "water", "bottle"], 
    source: "atlas", 
    name: "WaterBottle",
  }, 
  {
    id: "atlas:WaterCan", 
    tags: ["atlas", "water", "can"], 
    source: "atlas", 
    name: "WaterCan",
  }, 
  {
    id: "atlas:WaterContainer", 
    tags: ["atlas", "water", "container"], 
    source: "atlas", 
    name: "WaterContainer",
  }, 
  {
    id: "atlas:WaterDrop", 
    tags: ["atlas", "water", "drop"], 
    source: "atlas", 
    name: "WaterDrop",
  }, 
  {
    id: "atlas:WaterGlass", 
    tags: ["atlas", "water", "glass"], 
    source: "atlas", 
    name: "WaterGlass",
  }, 
  {
    id: "atlas:WaterHeater", 
    tags: ["atlas", "water", "heater"], 
    source: "atlas", 
    name: "WaterHeater",
  }, 
  {
    id: "atlas:WaterLightbulb", 
    tags: ["atlas", "water", "lightbulb"], 
    source: "atlas", 
    name: "WaterLightbulb",
  }, 
  {
    id: "atlas:WaterLiquid", 
    tags: ["atlas", "water", "liquid"], 
    source: "atlas", 
    name: "WaterLiquid",
  }, 
  {
    id: "atlas:WaterRecycle", 
    tags: ["atlas", "water", "recycle"], 
    source: "atlas", 
    name: "WaterRecycle",
  }, 
  {
    id: "atlas:WaterScooter", 
    tags: ["atlas", "water", "scooter"], 
    source: "atlas", 
    name: "WaterScooter",
  }, 
  {
    id: "atlas:WaterTap", 
    tags: ["atlas", "water", "tap"], 
    source: "atlas", 
    name: "WaterTap",
  }, 
  {
    id: "atlas:Waveform", 
    tags: ["atlas", "waveform"], 
    source: "atlas", 
    name: "Waveform",
  }, 
  {
    id: "atlas:We", 
    tags: ["atlas", "we"], 
    source: "atlas", 
    name: "We",
  }, 
  {
    id: "atlas:Webcam", 
    tags: ["atlas", "webcam"], 
    source: "atlas", 
    name: "Webcam",
  }, 
  {
    id: "atlas:Website", 
    tags: ["atlas", "website"], 
    source: "atlas", 
    name: "Website",
  }, 
  {
    id: "atlas:WebsiteAd", 
    tags: ["atlas", "website", "ad"], 
    source: "atlas", 
    name: "WebsiteAd",
  }, 
  {
    id: "atlas:WebsiteClip", 
    tags: ["atlas", "website", "clip"], 
    source: "atlas", 
    name: "WebsiteClip",
  }, 
  {
    id: "atlas:Wechat", 
    tags: ["atlas", "wechat"], 
    source: "atlas", 
    name: "Wechat",
  }, 
  {
    id: "atlas:WeddingCake", 
    tags: ["atlas", "wedding", "cake"], 
    source: "atlas", 
    name: "WeddingCake",
  }, 
  {
    id: "atlas:WeightLifting", 
    tags: ["atlas", "weight", "lifting"], 
    source: "atlas", 
    name: "WeightLifting",
  }, 
  {
    id: "atlas:WeightLoss", 
    tags: ["atlas", "weight", "loss"], 
    source: "atlas", 
    name: "WeightLoss",
  }, 
  {
    id: "atlas:WeightScale", 
    tags: ["atlas", "weight", "scale"], 
    source: "atlas", 
    name: "WeightScale",
  }, 
  {
    id: "atlas:WeightScales", 
    tags: ["atlas", "weight", "scales"], 
    source: "atlas", 
    name: "WeightScales",
  }, 
  {
    id: "atlas:WeightsChair", 
    tags: ["atlas", "weights", "chair"], 
    source: "atlas", 
    name: "WeightsChair",
  }, 
  {
    id: "atlas:WeightsGym", 
    tags: ["atlas", "weights", "gym"], 
    source: "atlas", 
    name: "WeightsGym",
  }, 
  {
    id: "atlas:Whatsapp", 
    tags: ["atlas", "whatsapp"], 
    source: "atlas", 
    name: "Whatsapp",
  }, 
  {
    id: "atlas:Wheat", 
    tags: ["atlas", "wheat"], 
    source: "atlas", 
    name: "Wheat",
  }, 
  {
    id: "atlas:WheatHarvest", 
    tags: ["atlas", "wheat", "harvest"], 
    source: "atlas", 
    name: "WheatHarvest",
  }, 
  {
    id: "atlas:Wheelbarrow", 
    tags: ["atlas", "wheelbarrow"], 
    source: "atlas", 
    name: "Wheelbarrow",
  }, 
  {
    id: "atlas:WheelbarrowWheel", 
    tags: ["atlas", "wheelbarrow", "wheel"], 
    source: "atlas", 
    name: "WheelbarrowWheel",
  }, 
  {
    id: "atlas:Wheelchair", 
    tags: ["atlas", "wheelchair"], 
    source: "atlas", 
    name: "Wheelchair",
  }, 
  {
    id: "atlas:WhiteHouse", 
    tags: ["atlas", "white", "house"], 
    source: "atlas", 
    name: "WhiteHouse",
  }, 
  {
    id: "atlas:Whiteboard", 
    tags: ["atlas", "whiteboard"], 
    source: "atlas", 
    name: "Whiteboard",
  }, 
  {
    id: "atlas:Wifi", 
    tags: ["atlas", "wifi"], 
    source: "atlas", 
    name: "Wifi",
  }, 
  {
    id: "atlas:WifiCall", 
    tags: ["atlas", "wifi", "call"], 
    source: "atlas", 
    name: "WifiCall",
  }, 
  {
    id: "atlas:WifiChat", 
    tags: ["atlas", "wifi", "chat"], 
    source: "atlas", 
    name: "WifiChat",
  }, 
  {
    id: "atlas:WifiClipboard", 
    tags: ["atlas", "wifi", "clipboard"], 
    source: "atlas", 
    name: "WifiClipboard",
  }, 
  {
    id: "atlas:WifiDrawingTablet", 
    tags: ["atlas", "wifi", "drawing", "tablet"], 
    source: "atlas", 
    name: "WifiDrawingTablet",
  }, 
  {
    id: "atlas:WifiFile", 
    tags: ["atlas", "wifi", "file"], 
    source: "atlas", 
    name: "WifiFile",
  }, 
  {
    id: "atlas:WifiFolder", 
    tags: ["atlas", "wifi", "folder"], 
    source: "atlas", 
    name: "WifiFolder",
  }, 
  {
    id: "atlas:WifiHouse", 
    tags: ["atlas", "wifi", "house"], 
    source: "atlas", 
    name: "WifiHouse",
  }, 
  {
    id: "atlas:WifiInternet", 
    tags: ["atlas", "wifi", "internet"], 
    source: "atlas", 
    name: "WifiInternet",
  }, 
  {
    id: "atlas:WifiMessage", 
    tags: ["atlas", "wifi", "message"], 
    source: "atlas", 
    name: "WifiMessage",
  }, 
  {
    id: "atlas:WifiModem", 
    tags: ["atlas", "wifi", "modem"], 
    source: "atlas", 
    name: "WifiModem",
  }, 
  {
    id: "atlas:WifiMonitor", 
    tags: ["atlas", "wifi", "monitor"], 
    source: "atlas", 
    name: "WifiMonitor",
  }, 
  {
    id: "atlas:WifiVrGlasses", 
    tags: ["atlas", "wifi", "vr", "glasses"], 
    source: "atlas", 
    name: "WifiVrGlasses",
  }, 
  {
    id: "atlas:WindStrength", 
    tags: ["atlas", "wind", "strength"], 
    source: "atlas", 
    name: "WindStrength",
  }, 
  {
    id: "atlas:Windmil", 
    tags: ["atlas", "windmil"], 
    source: "atlas", 
    name: "Windmil",
  }, 
  {
    id: "atlas:Windmill", 
    tags: ["atlas", "windmill"], 
    source: "atlas", 
    name: "Windmill",
  }, 
  {
    id: "atlas:Window", 
    tags: ["atlas", "window"], 
    source: "atlas", 
    name: "Window",
  }, 
  {
    id: "atlas:WindowCurtains", 
    tags: ["atlas", "window", "curtains"], 
    source: "atlas", 
    name: "WindowCurtains",
  }, 
  {
    id: "atlas:WindowPadlock", 
    tags: ["atlas", "window", "padlock"], 
    source: "atlas", 
    name: "WindowPadlock",
  }, 
  {
    id: "atlas:WindowSeat", 
    tags: ["atlas", "window", "seat"], 
    source: "atlas", 
    name: "WindowSeat",
  }, 
  {
    id: "atlas:WindowShield", 
    tags: ["atlas", "window", "shield"], 
    source: "atlas", 
    name: "WindowShield",
  }, 
  {
    id: "atlas:WineBottle", 
    tags: ["atlas", "wine", "bottle"], 
    source: "atlas", 
    name: "WineBottle",
  }, 
  {
    id: "atlas:WineBottleGlass", 
    tags: ["atlas", "wine", "bottle", "glass"], 
    source: "atlas", 
    name: "WineBottleGlass",
  }, 
  {
    id: "atlas:WineBottleHeart", 
    tags: ["atlas", "wine", "bottle", "heart"], 
    source: "atlas", 
    name: "WineBottleHeart",
  }, 
  {
    id: "atlas:WineGlass", 
    tags: ["atlas", "wine", "glass"], 
    source: "atlas", 
    name: "WineGlass",
  }, 
  {
    id: "atlas:WineGlasses", 
    tags: ["atlas", "wine", "glasses"], 
    source: "atlas", 
    name: "WineGlasses",
  }, 
  {
    id: "atlas:WingsBadgeStar", 
    tags: ["atlas", "wings", "badge", "star"], 
    source: "atlas", 
    name: "WingsBadgeStar",
  }, 
  {
    id: "atlas:WinnerAccountBanner", 
    tags: ["atlas", "winner", "account", "banner"], 
    source: "atlas", 
    name: "WinnerAccountBanner",
  }, 
  {
    id: "atlas:WinnerPlace", 
    tags: ["atlas", "winner", "place"], 
    source: "atlas", 
    name: "WinnerPlace",
  }, 
  {
    id: "atlas:WinnerTrophy", 
    tags: ["atlas", "winner", "trophy"], 
    source: "atlas", 
    name: "WinnerTrophy",
  }, 
  {
    id: "atlas:WinningArrowUp", 
    tags: ["atlas", "winning", "arrow", "up"], 
    source: "atlas", 
    name: "WinningArrowUp",
  }, 
  {
    id: "atlas:WinningMedalAward", 
    tags: ["atlas", "winning", "medal", "award"], 
    source: "atlas", 
    name: "WinningMedalAward",
  }, 
  {
    id: "atlas:WinningPlacesPeople", 
    tags: ["atlas", "winning", "places", "people"], 
    source: "atlas", 
    name: "WinningPlacesPeople",
  }, 
  {
    id: "atlas:WinningStarPlace", 
    tags: ["atlas", "winning", "star", "place"], 
    source: "atlas", 
    name: "WinningStarPlace",
  }, 
  {
    id: "atlas:WinterCalendar", 
    tags: ["atlas", "winter", "calendar"], 
    source: "atlas", 
    name: "WinterCalendar",
  }, 
  {
    id: "atlas:WinterCold", 
    tags: ["atlas", "winter", "cold"], 
    source: "atlas", 
    name: "WinterCold",
  }, 
  {
    id: "atlas:WinterFreeze", 
    tags: ["atlas", "winter", "freeze"], 
    source: "atlas", 
    name: "WinterFreeze",
  }, 
  {
    id: "atlas:WinterHatFashion", 
    tags: ["atlas", "winter", "hat", "fashion"], 
    source: "atlas", 
    name: "WinterHatFashion",
  }, 
  {
    id: "atlas:WinterJacket", 
    tags: ["atlas", "winter", "jacket"], 
    source: "atlas", 
    name: "WinterJacket",
  }, 
  {
    id: "atlas:WinterJumper", 
    tags: ["atlas", "winter", "jumper"], 
    source: "atlas", 
    name: "WinterJumper",
  }, 
  {
    id: "atlas:WinterMessage", 
    tags: ["atlas", "winter", "message"], 
    source: "atlas", 
    name: "WinterMessage",
  }, 
  {
    id: "atlas:WinterScarf", 
    tags: ["atlas", "winter", "scarf"], 
    source: "atlas", 
    name: "WinterScarf",
  }, 
  {
    id: "atlas:WinterShoppingBag", 
    tags: ["atlas", "winter", "shopping", "bag"], 
    source: "atlas", 
    name: "WinterShoppingBag",
  }, 
  {
    id: "atlas:WinterShovel", 
    tags: ["atlas", "winter", "shovel"], 
    source: "atlas", 
    name: "WinterShovel",
  }, 
  {
    id: "atlas:WinterSleigh", 
    tags: ["atlas", "winter", "sleigh"], 
    source: "atlas", 
    name: "WinterSleigh",
  }, 
  {
    id: "atlas:WinterSnow", 
    tags: ["atlas", "winter", "snow"], 
    source: "atlas", 
    name: "WinterSnow",
  }, 
  {
    id: "atlas:WinterSnowCap", 
    tags: ["atlas", "winter", "snow", "cap"], 
    source: "atlas", 
    name: "WinterSnowCap",
  }, 
  {
    id: "atlas:WinterSnowflake", 
    tags: ["atlas", "winter", "snowflake"], 
    source: "atlas", 
    name: "WinterSnowflake",
  }, 
  {
    id: "atlas:WirelessKeyboard", 
    tags: ["atlas", "wireless", "keyboard"], 
    source: "atlas", 
    name: "WirelessKeyboard",
  }, 
  {
    id: "atlas:WirelessMouse", 
    tags: ["atlas", "wireless", "mouse"], 
    source: "atlas", 
    name: "WirelessMouse",
  }, 
  {
    id: "atlas:WirelessPadlock", 
    tags: ["atlas", "wireless", "padlock"], 
    source: "atlas", 
    name: "WirelessPadlock",
  }, 
  {
    id: "atlas:WirelessRouter", 
    tags: ["atlas", "wireless", "router"], 
    source: "atlas", 
    name: "WirelessRouter",
  }, 
  {
    id: "atlas:WirelessSmartwatch", 
    tags: ["atlas", "wireless", "smartwatch"], 
    source: "atlas", 
    name: "WirelessSmartwatch",
  }, 
  {
    id: "atlas:WishBone", 
    tags: ["atlas", "wish", "bone"], 
    source: "atlas", 
    name: "WishBone",
  }, 
  {
    id: "atlas:WithdrawDollarSign", 
    tags: ["atlas", "withdraw", "dollar", "sign"], 
    source: "atlas", 
    name: "WithdrawDollarSign",
  }, 
  {
    id: "atlas:WomanVrGlasses", 
    tags: ["atlas", "woman", "vr", "glasses"], 
    source: "atlas", 
    name: "WomanVrGlasses",
  }, 
  {
    id: "atlas:WoodLog", 
    tags: ["atlas", "wood", "log"], 
    source: "atlas", 
    name: "WoodLog",
  }, 
  {
    id: "atlas:Wordpress", 
    tags: ["atlas", "wordpress"], 
    source: "atlas", 
    name: "Wordpress",
  }, 
  {
    id: "atlas:WorkoutDay", 
    tags: ["atlas", "workout", "day"], 
    source: "atlas", 
    name: "WorkoutDay",
  }, 
  {
    id: "atlas:WorkoutList", 
    tags: ["atlas", "workout", "list"], 
    source: "atlas", 
    name: "WorkoutList",
  }, 
  {
    id: "atlas:WorkoutTop", 
    tags: ["atlas", "workout", "top"], 
    source: "atlas", 
    name: "WorkoutTop",
  }, 
  {
    id: "atlas:WorldLandmark", 
    tags: ["atlas", "world", "landmark"], 
    source: "atlas", 
    name: "WorldLandmark",
  }, 
  {
    id: "atlas:Wreath", 
    tags: ["atlas", "wreath"], 
    source: "atlas", 
    name: "Wreath",
  }, 
  {
    id: "atlas:WreathBell", 
    tags: ["atlas", "wreath", "bell"], 
    source: "atlas", 
    name: "WreathBell",
  }, 
  {
    id: "atlas:WreathBow", 
    tags: ["atlas", "wreath", "bow"], 
    source: "atlas", 
    name: "WreathBow",
  }, 
  {
    id: "atlas:Wrench", 
    tags: ["atlas", "wrench"], 
    source: "atlas", 
    name: "Wrench",
  }, 
  {
    id: "atlas:WrenchClamp", 
    tags: ["atlas", "wrench", "clamp"], 
    source: "atlas", 
    name: "WrenchClamp",
  }, 
  {
    id: "atlas:WrestlingGearHelmet", 
    tags: ["atlas", "wrestling", "gear", "helmet"], 
    source: "atlas", 
    name: "WrestlingGearHelmet",
  }, 
  {
    id: "atlas:WriteBook", 
    tags: ["atlas", "write", "book"], 
    source: "atlas", 
    name: "WriteBook",
  }, 
  {
    id: "atlas:WritePaper", 
    tags: ["atlas", "write", "paper"], 
    source: "atlas", 
    name: "WritePaper",
  }, 
  {
    id: "atlas:XRay", 
    tags: ["atlas", "ray"], 
    source: "atlas", 
    name: "XRay",
  }, 
  {
    id: "atlas:XmarkChat", 
    tags: ["atlas", "xmark", "chat"], 
    source: "atlas", 
    name: "XmarkChat",
  }, 
  {
    id: "atlas:XmarkChats", 
    tags: ["atlas", "xmark", "chats"], 
    source: "atlas", 
    name: "XmarkChats",
  }, 
  {
    id: "atlas:XmarkCircle", 
    tags: ["atlas", "xmark", "circle"], 
    source: "atlas", 
    name: "XmarkCircle",
  }, 
  {
    id: "atlas:XmarkClipboard", 
    tags: ["atlas", "xmark", "clipboard"], 
    source: "atlas", 
    name: "XmarkClipboard",
  }, 
  {
    id: "atlas:XmarkComment", 
    tags: ["atlas", "xmark", "comment"], 
    source: "atlas", 
    name: "XmarkComment",
  }, 
  {
    id: "atlas:XmarkFile", 
    tags: ["atlas", "xmark", "file"], 
    source: "atlas", 
    name: "XmarkFile",
  }, 
  {
    id: "atlas:XmarkFolder", 
    tags: ["atlas", "xmark", "folder"], 
    source: "atlas", 
    name: "XmarkFolder",
  }, 
  {
    id: "atlas:XmarkGroupPeople", 
    tags: ["atlas", "xmark", "group", "people"], 
    source: "atlas", 
    name: "XmarkGroupPeople",
  }, 
  {
    id: "atlas:XmarkGroupPeopleAccounts", 
    tags: ["atlas", "xmark", "group", "people", "accounts"], 
    source: "atlas", 
    name: "XmarkGroupPeopleAccounts",
  }, 
  {
    id: "atlas:XmarkHandshake", 
    tags: ["atlas", "xmark", "handshake"], 
    source: "atlas", 
    name: "XmarkHandshake",
  }, 
  {
    id: "atlas:XmarkMeeting", 
    tags: ["atlas", "xmark", "meeting"], 
    source: "atlas", 
    name: "XmarkMeeting",
  }, 
  {
    id: "atlas:XmarkMessage", 
    tags: ["atlas", "xmark", "message"], 
    source: "atlas", 
    name: "XmarkMessage",
  }, 
  {
    id: "atlas:XmarkPadlock", 
    tags: ["atlas", "xmark", "padlock"], 
    source: "atlas", 
    name: "XmarkPadlock",
  }, 
  {
    id: "atlas:XmarkPapertray", 
    tags: ["atlas", "xmark", "papertray"], 
    source: "atlas", 
    name: "XmarkPapertray",
  }, 
  {
    id: "atlas:XmarkShield", 
    tags: ["atlas", "xmark", "shield"], 
    source: "atlas", 
    name: "XmarkShield",
  }, 
  {
    id: "atlas:XmarkShieldServer", 
    tags: ["atlas", "xmark", "shield", "server"], 
    source: "atlas", 
    name: "XmarkShieldServer",
  }, 
  {
    id: "atlas:XmarkTestTube", 
    tags: ["atlas", "xmark", "test", "tube"], 
    source: "atlas", 
    name: "XmarkTestTube",
  }, 
  {
    id: "atlas:XmarkTicket", 
    tags: ["atlas", "xmark", "ticket"], 
    source: "atlas", 
    name: "XmarkTicket",
  }, 
  {
    id: "atlas:XmarkWebsite", 
    tags: ["atlas", "xmark", "website"], 
    source: "atlas", 
    name: "XmarkWebsite",
  }, 
  {
    id: "atlas:Yahoo", 
    tags: ["atlas", "yahoo"], 
    source: "atlas", 
    name: "Yahoo",
  }, 
  {
    id: "atlas:YenSign", 
    tags: ["atlas", "yen", "sign"], 
    source: "atlas", 
    name: "YenSign",
  }, 
  {
    id: "atlas:YenSignCircle", 
    tags: ["atlas", "yen", "sign", "circle"], 
    source: "atlas", 
    name: "YenSignCircle",
  }, 
  {
    id: "atlas:YogaMatt", 
    tags: ["atlas", "yoga", "matt"], 
    source: "atlas", 
    name: "YogaMatt",
  }, 
  {
    id: "atlas:YogaPose", 
    tags: ["atlas", "yoga", "pose"], 
    source: "atlas", 
    name: "YogaPose",
  }, 
  {
    id: "atlas:Youtube", 
    tags: ["atlas", "youtube"], 
    source: "atlas", 
    name: "Youtube",
  }, 
  {
    id: "atlas:Zeplin", 
    tags: ["atlas", "zeplin"], 
    source: "atlas", 
    name: "Zeplin",
  }, 
  {
    id: "atlas:ZipFile", 
    tags: ["atlas", "zip", "file"], 
    source: "atlas", 
    name: "ZipFile",
  }, 
  {
    id: "atlas:ZoomArrowOut", 
    tags: ["atlas", "zoom", "arrow", "out"], 
    source: "atlas", 
    name: "ZoomArrowOut",
  }, 
  {
    id: "atlas:ZoomIn", 
    tags: ["atlas", "zoom", "in"], 
    source: "atlas", 
    name: "ZoomIn",
  }, 
  {
    id: "atlas:ZoomOut", 
    tags: ["atlas", "zoom", "out"], 
    source: "atlas", 
    name: "ZoomOut",
  }, 
  {
    id: "atlas:ZoomOutArrows", 
    tags: ["atlas", "zoom", "out", "arrows"], 
    source: "atlas", 
    name: "ZoomOutArrows",
  }, 
  {
    id: "atlas:ZoomOutArrowsLeftRight", 
    tags: ["atlas", "zoom", "out", "arrows", "left", "right"], 
    source: "atlas", 
    name: "ZoomOutArrowsLeftRight",
  }, 
  {
    id: "phosphor:AcornIcon", 
    tags: ["phosphor", "acorn"], 
    source: "phosphor", 
    name: "AcornIcon",
  }, 
  {
    id: "phosphor:ActivityIcon", 
    tags: ["phosphor", "activity"], 
    source: "phosphor", 
    name: "ActivityIcon",
  }, 
  {
    id: "phosphor:AddressBookIcon", 
    tags: ["phosphor", "address", "book"], 
    source: "phosphor", 
    name: "AddressBookIcon",
  }, 
  {
    id: "phosphor:AddressBookTabsIcon", 
    tags: ["phosphor", "address", "book", "tabs"], 
    source: "phosphor", 
    name: "AddressBookTabsIcon",
  }, 
  {
    id: "phosphor:AirTrafficControlIcon", 
    tags: ["phosphor", "air", "traffic", "control"], 
    source: "phosphor", 
    name: "AirTrafficControlIcon",
  }, 
  {
    id: "phosphor:AirplaneIcon", 
    tags: ["phosphor", "airplane"], 
    source: "phosphor", 
    name: "AirplaneIcon",
  }, 
  {
    id: "phosphor:AirplaneInFlightIcon", 
    tags: ["phosphor", "airplane", "in", "flight"], 
    source: "phosphor", 
    name: "AirplaneInFlightIcon",
  }, 
  {
    id: "phosphor:AirplaneLandingIcon", 
    tags: ["phosphor", "airplane", "landing"], 
    source: "phosphor", 
    name: "AirplaneLandingIcon",
  }, 
  {
    id: "phosphor:AirplaneTakeoffIcon", 
    tags: ["phosphor", "airplane", "takeoff"], 
    source: "phosphor", 
    name: "AirplaneTakeoffIcon",
  }, 
  {
    id: "phosphor:AirplaneTaxiingIcon", 
    tags: ["phosphor", "airplane", "taxiing"], 
    source: "phosphor", 
    name: "AirplaneTaxiingIcon",
  }, 
  {
    id: "phosphor:AirplaneTiltIcon", 
    tags: ["phosphor", "airplane", "tilt"], 
    source: "phosphor", 
    name: "AirplaneTiltIcon",
  }, 
  {
    id: "phosphor:AirplayIcon", 
    tags: ["phosphor", "airplay"], 
    source: "phosphor", 
    name: "AirplayIcon",
  }, 
  {
    id: "phosphor:AlarmIcon", 
    tags: ["phosphor", "alarm"], 
    source: "phosphor", 
    name: "AlarmIcon",
  }, 
  {
    id: "phosphor:AlienIcon", 
    tags: ["phosphor", "alien"], 
    source: "phosphor", 
    name: "AlienIcon",
  }, 
  {
    id: "phosphor:AlignBottomIcon", 
    tags: ["phosphor", "align", "bottom"], 
    source: "phosphor", 
    name: "AlignBottomIcon",
  }, 
  {
    id: "phosphor:AlignBottomSimpleIcon", 
    tags: ["phosphor", "align", "bottom", "simple"], 
    source: "phosphor", 
    name: "AlignBottomSimpleIcon",
  }, 
  {
    id: "phosphor:AlignCenterHorizontalIcon", 
    tags: ["phosphor", "align", "center", "horizontal"], 
    source: "phosphor", 
    name: "AlignCenterHorizontalIcon",
  }, 
  {
    id: "phosphor:AlignCenterHorizontalSimpleIcon", 
    tags: ["phosphor", "align", "center", "horizontal", "simple"], 
    source: "phosphor", 
    name: "AlignCenterHorizontalSimpleIcon",
  }, 
  {
    id: "phosphor:AlignCenterVerticalIcon", 
    tags: ["phosphor", "align", "center", "vertical"], 
    source: "phosphor", 
    name: "AlignCenterVerticalIcon",
  }, 
  {
    id: "phosphor:AlignCenterVerticalSimpleIcon", 
    tags: ["phosphor", "align", "center", "vertical", "simple"], 
    source: "phosphor", 
    name: "AlignCenterVerticalSimpleIcon",
  }, 
  {
    id: "phosphor:AlignLeftIcon", 
    tags: ["phosphor", "align", "left"], 
    source: "phosphor", 
    name: "AlignLeftIcon",
  }, 
  {
    id: "phosphor:AlignLeftSimpleIcon", 
    tags: ["phosphor", "align", "left", "simple"], 
    source: "phosphor", 
    name: "AlignLeftSimpleIcon",
  }, 
  {
    id: "phosphor:AlignRightIcon", 
    tags: ["phosphor", "align", "right"], 
    source: "phosphor", 
    name: "AlignRightIcon",
  }, 
  {
    id: "phosphor:AlignRightSimpleIcon", 
    tags: ["phosphor", "align", "right", "simple"], 
    source: "phosphor", 
    name: "AlignRightSimpleIcon",
  }, 
  {
    id: "phosphor:AlignTopIcon", 
    tags: ["phosphor", "align", "top"], 
    source: "phosphor", 
    name: "AlignTopIcon",
  }, 
  {
    id: "phosphor:AlignTopSimpleIcon", 
    tags: ["phosphor", "align", "top", "simple"], 
    source: "phosphor", 
    name: "AlignTopSimpleIcon",
  }, 
  {
    id: "phosphor:AmazonLogoIcon", 
    tags: ["phosphor", "amazon", "logo"], 
    source: "phosphor", 
    name: "AmazonLogoIcon",
  }, 
  {
    id: "phosphor:AmbulanceIcon", 
    tags: ["phosphor", "ambulance"], 
    source: "phosphor", 
    name: "AmbulanceIcon",
  }, 
  {
    id: "phosphor:AnchorIcon", 
    tags: ["phosphor", "anchor"], 
    source: "phosphor", 
    name: "AnchorIcon",
  }, 
  {
    id: "phosphor:AnchorSimpleIcon", 
    tags: ["phosphor", "anchor", "simple"], 
    source: "phosphor", 
    name: "AnchorSimpleIcon",
  }, 
  {
    id: "phosphor:AndroidLogoIcon", 
    tags: ["phosphor", "android", "logo"], 
    source: "phosphor", 
    name: "AndroidLogoIcon",
  }, 
  {
    id: "phosphor:AngleIcon", 
    tags: ["phosphor", "angle"], 
    source: "phosphor", 
    name: "AngleIcon",
  }, 
  {
    id: "phosphor:AngularLogoIcon", 
    tags: ["phosphor", "angular", "logo"], 
    source: "phosphor", 
    name: "AngularLogoIcon",
  }, 
  {
    id: "phosphor:ApertureIcon", 
    tags: ["phosphor", "aperture"], 
    source: "phosphor", 
    name: "ApertureIcon",
  }, 
  {
    id: "phosphor:AppStoreLogoIcon", 
    tags: ["phosphor", "app", "store", "logo"], 
    source: "phosphor", 
    name: "AppStoreLogoIcon",
  }, 
  {
    id: "phosphor:AppWindowIcon", 
    tags: ["phosphor", "app", "window"], 
    source: "phosphor", 
    name: "AppWindowIcon",
  }, 
  {
    id: "phosphor:AppleLogoIcon", 
    tags: ["phosphor", "apple", "logo"], 
    source: "phosphor", 
    name: "AppleLogoIcon",
  }, 
  {
    id: "phosphor:ApplePodcastsLogoIcon", 
    tags: ["phosphor", "apple", "podcasts", "logo"], 
    source: "phosphor", 
    name: "ApplePodcastsLogoIcon",
  }, 
  {
    id: "phosphor:ApproximateEqualsIcon", 
    tags: ["phosphor", "approximate", "equals"], 
    source: "phosphor", 
    name: "ApproximateEqualsIcon",
  }, 
  {
    id: "phosphor:ArchiveBoxIcon", 
    tags: ["phosphor", "archive", "box"], 
    source: "phosphor", 
    name: "ArchiveBoxIcon",
  }, 
  {
    id: "phosphor:ArchiveIcon", 
    tags: ["phosphor", "archive"], 
    source: "phosphor", 
    name: "ArchiveIcon",
  }, 
  {
    id: "phosphor:ArchiveTrayIcon", 
    tags: ["phosphor", "archive", "tray"], 
    source: "phosphor", 
    name: "ArchiveTrayIcon",
  }, 
  {
    id: "phosphor:ArmchairIcon", 
    tags: ["phosphor", "armchair"], 
    source: "phosphor", 
    name: "ArmchairIcon",
  }, 
  {
    id: "phosphor:ArrowArcLeftIcon", 
    tags: ["phosphor", "arrow", "arc", "left"], 
    source: "phosphor", 
    name: "ArrowArcLeftIcon",
  }, 
  {
    id: "phosphor:ArrowArcRightIcon", 
    tags: ["phosphor", "arrow", "arc", "right"], 
    source: "phosphor", 
    name: "ArrowArcRightIcon",
  }, 
  {
    id: "phosphor:ArrowBendDoubleUpLeftIcon", 
    tags: ["phosphor", "arrow", "bend", "double", "up", "left"], 
    source: "phosphor", 
    name: "ArrowBendDoubleUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowBendDoubleUpRightIcon", 
    tags: ["phosphor", "arrow", "bend", "double", "up", "right"], 
    source: "phosphor", 
    name: "ArrowBendDoubleUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowBendDownLeftIcon", 
    tags: ["phosphor", "arrow", "bend", "down", "left"], 
    source: "phosphor", 
    name: "ArrowBendDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowBendDownRightIcon", 
    tags: ["phosphor", "arrow", "bend", "down", "right"], 
    source: "phosphor", 
    name: "ArrowBendDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowBendLeftDownIcon", 
    tags: ["phosphor", "arrow", "bend", "left", "down"], 
    source: "phosphor", 
    name: "ArrowBendLeftDownIcon",
  }, 
  {
    id: "phosphor:ArrowBendLeftUpIcon", 
    tags: ["phosphor", "arrow", "bend", "left", "up"], 
    source: "phosphor", 
    name: "ArrowBendLeftUpIcon",
  }, 
  {
    id: "phosphor:ArrowBendRightDownIcon", 
    tags: ["phosphor", "arrow", "bend", "right", "down"], 
    source: "phosphor", 
    name: "ArrowBendRightDownIcon",
  }, 
  {
    id: "phosphor:ArrowBendRightUpIcon", 
    tags: ["phosphor", "arrow", "bend", "right", "up"], 
    source: "phosphor", 
    name: "ArrowBendRightUpIcon",
  }, 
  {
    id: "phosphor:ArrowBendUpLeftIcon", 
    tags: ["phosphor", "arrow", "bend", "up", "left"], 
    source: "phosphor", 
    name: "ArrowBendUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowBendUpRightIcon", 
    tags: ["phosphor", "arrow", "bend", "up", "right"], 
    source: "phosphor", 
    name: "ArrowBendUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowCircleDownIcon", 
    tags: ["phosphor", "arrow", "circle", "down"], 
    source: "phosphor", 
    name: "ArrowCircleDownIcon",
  }, 
  {
    id: "phosphor:ArrowCircleDownLeftIcon", 
    tags: ["phosphor", "arrow", "circle", "down", "left"], 
    source: "phosphor", 
    name: "ArrowCircleDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowCircleDownRightIcon", 
    tags: ["phosphor", "arrow", "circle", "down", "right"], 
    source: "phosphor", 
    name: "ArrowCircleDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowCircleLeftIcon", 
    tags: ["phosphor", "arrow", "circle", "left"], 
    source: "phosphor", 
    name: "ArrowCircleLeftIcon",
  }, 
  {
    id: "phosphor:ArrowCircleRightIcon", 
    tags: ["phosphor", "arrow", "circle", "right"], 
    source: "phosphor", 
    name: "ArrowCircleRightIcon",
  }, 
  {
    id: "phosphor:ArrowCircleUpIcon", 
    tags: ["phosphor", "arrow", "circle", "up"], 
    source: "phosphor", 
    name: "ArrowCircleUpIcon",
  }, 
  {
    id: "phosphor:ArrowCircleUpLeftIcon", 
    tags: ["phosphor", "arrow", "circle", "up", "left"], 
    source: "phosphor", 
    name: "ArrowCircleUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowCircleUpRightIcon", 
    tags: ["phosphor", "arrow", "circle", "up", "right"], 
    source: "phosphor", 
    name: "ArrowCircleUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowClockwiseIcon", 
    tags: ["phosphor", "arrow", "clockwise"], 
    source: "phosphor", 
    name: "ArrowClockwiseIcon",
  }, 
  {
    id: "phosphor:ArrowCounterClockwiseIcon", 
    tags: ["phosphor", "arrow", "counter", "clockwise"], 
    source: "phosphor", 
    name: "ArrowCounterClockwiseIcon",
  }, 
  {
    id: "phosphor:ArrowDownIcon", 
    tags: ["phosphor", "arrow", "down"], 
    source: "phosphor", 
    name: "ArrowDownIcon",
  }, 
  {
    id: "phosphor:ArrowDownLeftIcon", 
    tags: ["phosphor", "arrow", "down", "left"], 
    source: "phosphor", 
    name: "ArrowDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowDownRightIcon", 
    tags: ["phosphor", "arrow", "down", "right"], 
    source: "phosphor", 
    name: "ArrowDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowElbowDownLeftIcon", 
    tags: ["phosphor", "arrow", "elbow", "down", "left"], 
    source: "phosphor", 
    name: "ArrowElbowDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowElbowDownRightIcon", 
    tags: ["phosphor", "arrow", "elbow", "down", "right"], 
    source: "phosphor", 
    name: "ArrowElbowDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowElbowLeftDownIcon", 
    tags: ["phosphor", "arrow", "elbow", "left", "down"], 
    source: "phosphor", 
    name: "ArrowElbowLeftDownIcon",
  }, 
  {
    id: "phosphor:ArrowElbowLeftIcon", 
    tags: ["phosphor", "arrow", "elbow", "left"], 
    source: "phosphor", 
    name: "ArrowElbowLeftIcon",
  }, 
  {
    id: "phosphor:ArrowElbowLeftUpIcon", 
    tags: ["phosphor", "arrow", "elbow", "left", "up"], 
    source: "phosphor", 
    name: "ArrowElbowLeftUpIcon",
  }, 
  {
    id: "phosphor:ArrowElbowRightDownIcon", 
    tags: ["phosphor", "arrow", "elbow", "right", "down"], 
    source: "phosphor", 
    name: "ArrowElbowRightDownIcon",
  }, 
  {
    id: "phosphor:ArrowElbowRightIcon", 
    tags: ["phosphor", "arrow", "elbow", "right"], 
    source: "phosphor", 
    name: "ArrowElbowRightIcon",
  }, 
  {
    id: "phosphor:ArrowElbowRightUpIcon", 
    tags: ["phosphor", "arrow", "elbow", "right", "up"], 
    source: "phosphor", 
    name: "ArrowElbowRightUpIcon",
  }, 
  {
    id: "phosphor:ArrowElbowUpLeftIcon", 
    tags: ["phosphor", "arrow", "elbow", "up", "left"], 
    source: "phosphor", 
    name: "ArrowElbowUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowElbowUpRightIcon", 
    tags: ["phosphor", "arrow", "elbow", "up", "right"], 
    source: "phosphor", 
    name: "ArrowElbowUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowFatDownIcon", 
    tags: ["phosphor", "arrow", "fat", "down"], 
    source: "phosphor", 
    name: "ArrowFatDownIcon",
  }, 
  {
    id: "phosphor:ArrowFatLeftIcon", 
    tags: ["phosphor", "arrow", "fat", "left"], 
    source: "phosphor", 
    name: "ArrowFatLeftIcon",
  }, 
  {
    id: "phosphor:ArrowFatLineDownIcon", 
    tags: ["phosphor", "arrow", "fat", "line", "down"], 
    source: "phosphor", 
    name: "ArrowFatLineDownIcon",
  }, 
  {
    id: "phosphor:ArrowFatLineLeftIcon", 
    tags: ["phosphor", "arrow", "fat", "line", "left"], 
    source: "phosphor", 
    name: "ArrowFatLineLeftIcon",
  }, 
  {
    id: "phosphor:ArrowFatLineRightIcon", 
    tags: ["phosphor", "arrow", "fat", "line", "right"], 
    source: "phosphor", 
    name: "ArrowFatLineRightIcon",
  }, 
  {
    id: "phosphor:ArrowFatLineUpIcon", 
    tags: ["phosphor", "arrow", "fat", "line", "up"], 
    source: "phosphor", 
    name: "ArrowFatLineUpIcon",
  }, 
  {
    id: "phosphor:ArrowFatLinesDownIcon", 
    tags: ["phosphor", "arrow", "fat", "lines", "down"], 
    source: "phosphor", 
    name: "ArrowFatLinesDownIcon",
  }, 
  {
    id: "phosphor:ArrowFatLinesLeftIcon", 
    tags: ["phosphor", "arrow", "fat", "lines", "left"], 
    source: "phosphor", 
    name: "ArrowFatLinesLeftIcon",
  }, 
  {
    id: "phosphor:ArrowFatLinesRightIcon", 
    tags: ["phosphor", "arrow", "fat", "lines", "right"], 
    source: "phosphor", 
    name: "ArrowFatLinesRightIcon",
  }, 
  {
    id: "phosphor:ArrowFatLinesUpIcon", 
    tags: ["phosphor", "arrow", "fat", "lines", "up"], 
    source: "phosphor", 
    name: "ArrowFatLinesUpIcon",
  }, 
  {
    id: "phosphor:ArrowFatRightIcon", 
    tags: ["phosphor", "arrow", "fat", "right"], 
    source: "phosphor", 
    name: "ArrowFatRightIcon",
  }, 
  {
    id: "phosphor:ArrowFatUpIcon", 
    tags: ["phosphor", "arrow", "fat", "up"], 
    source: "phosphor", 
    name: "ArrowFatUpIcon",
  }, 
  {
    id: "phosphor:ArrowLeftIcon", 
    tags: ["phosphor", "arrow", "left"], 
    source: "phosphor", 
    name: "ArrowLeftIcon",
  }, 
  {
    id: "phosphor:ArrowLineDownIcon", 
    tags: ["phosphor", "arrow", "line", "down"], 
    source: "phosphor", 
    name: "ArrowLineDownIcon",
  }, 
  {
    id: "phosphor:ArrowLineDownLeftIcon", 
    tags: ["phosphor", "arrow", "line", "down", "left"], 
    source: "phosphor", 
    name: "ArrowLineDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowLineDownRightIcon", 
    tags: ["phosphor", "arrow", "line", "down", "right"], 
    source: "phosphor", 
    name: "ArrowLineDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowLineLeftIcon", 
    tags: ["phosphor", "arrow", "line", "left"], 
    source: "phosphor", 
    name: "ArrowLineLeftIcon",
  }, 
  {
    id: "phosphor:ArrowLineRightIcon", 
    tags: ["phosphor", "arrow", "line", "right"], 
    source: "phosphor", 
    name: "ArrowLineRightIcon",
  }, 
  {
    id: "phosphor:ArrowLineUpIcon", 
    tags: ["phosphor", "arrow", "line", "up"], 
    source: "phosphor", 
    name: "ArrowLineUpIcon",
  }, 
  {
    id: "phosphor:ArrowLineUpLeftIcon", 
    tags: ["phosphor", "arrow", "line", "up", "left"], 
    source: "phosphor", 
    name: "ArrowLineUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowLineUpRightIcon", 
    tags: ["phosphor", "arrow", "line", "up", "right"], 
    source: "phosphor", 
    name: "ArrowLineUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowRightIcon", 
    tags: ["phosphor", "arrow", "right"], 
    source: "phosphor", 
    name: "ArrowRightIcon",
  }, 
  {
    id: "phosphor:ArrowSquareDownIcon", 
    tags: ["phosphor", "arrow", "square", "down"], 
    source: "phosphor", 
    name: "ArrowSquareDownIcon",
  }, 
  {
    id: "phosphor:ArrowSquareDownLeftIcon", 
    tags: ["phosphor", "arrow", "square", "down", "left"], 
    source: "phosphor", 
    name: "ArrowSquareDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowSquareDownRightIcon", 
    tags: ["phosphor", "arrow", "square", "down", "right"], 
    source: "phosphor", 
    name: "ArrowSquareDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowSquareInIcon", 
    tags: ["phosphor", "arrow", "square", "in"], 
    source: "phosphor", 
    name: "ArrowSquareInIcon",
  }, 
  {
    id: "phosphor:ArrowSquareLeftIcon", 
    tags: ["phosphor", "arrow", "square", "left"], 
    source: "phosphor", 
    name: "ArrowSquareLeftIcon",
  }, 
  {
    id: "phosphor:ArrowSquareOutIcon", 
    tags: ["phosphor", "arrow", "square", "out"], 
    source: "phosphor", 
    name: "ArrowSquareOutIcon",
  }, 
  {
    id: "phosphor:ArrowSquareRightIcon", 
    tags: ["phosphor", "arrow", "square", "right"], 
    source: "phosphor", 
    name: "ArrowSquareRightIcon",
  }, 
  {
    id: "phosphor:ArrowSquareUpIcon", 
    tags: ["phosphor", "arrow", "square", "up"], 
    source: "phosphor", 
    name: "ArrowSquareUpIcon",
  }, 
  {
    id: "phosphor:ArrowSquareUpLeftIcon", 
    tags: ["phosphor", "arrow", "square", "up", "left"], 
    source: "phosphor", 
    name: "ArrowSquareUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowSquareUpRightIcon", 
    tags: ["phosphor", "arrow", "square", "up", "right"], 
    source: "phosphor", 
    name: "ArrowSquareUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowUDownLeftIcon", 
    tags: ["phosphor", "arrow", "down", "left"], 
    source: "phosphor", 
    name: "ArrowUDownLeftIcon",
  }, 
  {
    id: "phosphor:ArrowUDownRightIcon", 
    tags: ["phosphor", "arrow", "down", "right"], 
    source: "phosphor", 
    name: "ArrowUDownRightIcon",
  }, 
  {
    id: "phosphor:ArrowULeftDownIcon", 
    tags: ["phosphor", "arrow", "left", "down"], 
    source: "phosphor", 
    name: "ArrowULeftDownIcon",
  }, 
  {
    id: "phosphor:ArrowULeftUpIcon", 
    tags: ["phosphor", "arrow", "left", "up"], 
    source: "phosphor", 
    name: "ArrowULeftUpIcon",
  }, 
  {
    id: "phosphor:ArrowURightDownIcon", 
    tags: ["phosphor", "arrow", "right", "down"], 
    source: "phosphor", 
    name: "ArrowURightDownIcon",
  }, 
  {
    id: "phosphor:ArrowURightUpIcon", 
    tags: ["phosphor", "arrow", "right", "up"], 
    source: "phosphor", 
    name: "ArrowURightUpIcon",
  }, 
  {
    id: "phosphor:ArrowUUpLeftIcon", 
    tags: ["phosphor", "arrow", "up", "left"], 
    source: "phosphor", 
    name: "ArrowUUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowUUpRightIcon", 
    tags: ["phosphor", "arrow", "up", "right"], 
    source: "phosphor", 
    name: "ArrowUUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowUpIcon", 
    tags: ["phosphor", "arrow", "up"], 
    source: "phosphor", 
    name: "ArrowUpIcon",
  }, 
  {
    id: "phosphor:ArrowUpLeftIcon", 
    tags: ["phosphor", "arrow", "up", "left"], 
    source: "phosphor", 
    name: "ArrowUpLeftIcon",
  }, 
  {
    id: "phosphor:ArrowUpRightIcon", 
    tags: ["phosphor", "arrow", "up", "right"], 
    source: "phosphor", 
    name: "ArrowUpRightIcon",
  }, 
  {
    id: "phosphor:ArrowsClockwiseIcon", 
    tags: ["phosphor", "arrows", "clockwise"], 
    source: "phosphor", 
    name: "ArrowsClockwiseIcon",
  }, 
  {
    id: "phosphor:ArrowsCounterClockwiseIcon", 
    tags: ["phosphor", "arrows", "counter", "clockwise"], 
    source: "phosphor", 
    name: "ArrowsCounterClockwiseIcon",
  }, 
  {
    id: "phosphor:ArrowsDownUpIcon", 
    tags: ["phosphor", "arrows", "down", "up"], 
    source: "phosphor", 
    name: "ArrowsDownUpIcon",
  }, 
  {
    id: "phosphor:ArrowsHorizontalIcon", 
    tags: ["phosphor", "arrows", "horizontal"], 
    source: "phosphor", 
    name: "ArrowsHorizontalIcon",
  }, 
  {
    id: "phosphor:ArrowsInCardinalIcon", 
    tags: ["phosphor", "arrows", "in", "cardinal"], 
    source: "phosphor", 
    name: "ArrowsInCardinalIcon",
  }, 
  {
    id: "phosphor:ArrowsInIcon", 
    tags: ["phosphor", "arrows", "in"], 
    source: "phosphor", 
    name: "ArrowsInIcon",
  }, 
  {
    id: "phosphor:ArrowsInLineHorizontalIcon", 
    tags: ["phosphor", "arrows", "in", "line", "horizontal"], 
    source: "phosphor", 
    name: "ArrowsInLineHorizontalIcon",
  }, 
  {
    id: "phosphor:ArrowsInLineVerticalIcon", 
    tags: ["phosphor", "arrows", "in", "line", "vertical"], 
    source: "phosphor", 
    name: "ArrowsInLineVerticalIcon",
  }, 
  {
    id: "phosphor:ArrowsInSimpleIcon", 
    tags: ["phosphor", "arrows", "in", "simple"], 
    source: "phosphor", 
    name: "ArrowsInSimpleIcon",
  }, 
  {
    id: "phosphor:ArrowsLeftRightIcon", 
    tags: ["phosphor", "arrows", "left", "right"], 
    source: "phosphor", 
    name: "ArrowsLeftRightIcon",
  }, 
  {
    id: "phosphor:ArrowsMergeIcon", 
    tags: ["phosphor", "arrows", "merge"], 
    source: "phosphor", 
    name: "ArrowsMergeIcon",
  }, 
  {
    id: "phosphor:ArrowsOutCardinalIcon", 
    tags: ["phosphor", "arrows", "out", "cardinal"], 
    source: "phosphor", 
    name: "ArrowsOutCardinalIcon",
  }, 
  {
    id: "phosphor:ArrowsOutIcon", 
    tags: ["phosphor", "arrows", "out"], 
    source: "phosphor", 
    name: "ArrowsOutIcon",
  }, 
  {
    id: "phosphor:ArrowsOutLineHorizontalIcon", 
    tags: ["phosphor", "arrows", "out", "line", "horizontal"], 
    source: "phosphor", 
    name: "ArrowsOutLineHorizontalIcon",
  }, 
  {
    id: "phosphor:ArrowsOutLineVerticalIcon", 
    tags: ["phosphor", "arrows", "out", "line", "vertical"], 
    source: "phosphor", 
    name: "ArrowsOutLineVerticalIcon",
  }, 
  {
    id: "phosphor:ArrowsOutSimpleIcon", 
    tags: ["phosphor", "arrows", "out", "simple"], 
    source: "phosphor", 
    name: "ArrowsOutSimpleIcon",
  }, 
  {
    id: "phosphor:ArrowsSplitIcon", 
    tags: ["phosphor", "arrows", "split"], 
    source: "phosphor", 
    name: "ArrowsSplitIcon",
  }, 
  {
    id: "phosphor:ArrowsVerticalIcon", 
    tags: ["phosphor", "arrows", "vertical"], 
    source: "phosphor", 
    name: "ArrowsVerticalIcon",
  }, 
  {
    id: "phosphor:ArticleIcon", 
    tags: ["phosphor", "article"], 
    source: "phosphor", 
    name: "ArticleIcon",
  }, 
  {
    id: "phosphor:ArticleMediumIcon", 
    tags: ["phosphor", "article", "medium"], 
    source: "phosphor", 
    name: "ArticleMediumIcon",
  }, 
  {
    id: "phosphor:ArticleNyTimesIcon", 
    tags: ["phosphor", "article", "ny", "times"], 
    source: "phosphor", 
    name: "ArticleNyTimesIcon",
  }, 
  {
    id: "phosphor:AsclepiusIcon", 
    tags: ["phosphor", "asclepius"], 
    source: "phosphor", 
    name: "AsclepiusIcon",
  }, 
  {
    id: "phosphor:AsteriskIcon", 
    tags: ["phosphor", "asterisk"], 
    source: "phosphor", 
    name: "AsteriskIcon",
  }, 
  {
    id: "phosphor:AsteriskSimpleIcon", 
    tags: ["phosphor", "asterisk", "simple"], 
    source: "phosphor", 
    name: "AsteriskSimpleIcon",
  }, 
  {
    id: "phosphor:AtIcon", 
    tags: ["phosphor", "at"], 
    source: "phosphor", 
    name: "AtIcon",
  }, 
  {
    id: "phosphor:AtomIcon", 
    tags: ["phosphor", "atom"], 
    source: "phosphor", 
    name: "AtomIcon",
  }, 
  {
    id: "phosphor:AvocadoIcon", 
    tags: ["phosphor", "avocado"], 
    source: "phosphor", 
    name: "AvocadoIcon",
  }, 
  {
    id: "phosphor:AxeIcon", 
    tags: ["phosphor", "axe"], 
    source: "phosphor", 
    name: "AxeIcon",
  }, 
  {
    id: "phosphor:BabyCarriageIcon", 
    tags: ["phosphor", "baby", "carriage"], 
    source: "phosphor", 
    name: "BabyCarriageIcon",
  }, 
  {
    id: "phosphor:BabyIcon", 
    tags: ["phosphor", "baby"], 
    source: "phosphor", 
    name: "BabyIcon",
  }, 
  {
    id: "phosphor:BackpackIcon", 
    tags: ["phosphor", "backpack"], 
    source: "phosphor", 
    name: "BackpackIcon",
  }, 
  {
    id: "phosphor:BackspaceIcon", 
    tags: ["phosphor", "backspace"], 
    source: "phosphor", 
    name: "BackspaceIcon",
  }, 
  {
    id: "phosphor:BagIcon", 
    tags: ["phosphor", "bag"], 
    source: "phosphor", 
    name: "BagIcon",
  }, 
  {
    id: "phosphor:BagSimpleIcon", 
    tags: ["phosphor", "bag", "simple"], 
    source: "phosphor", 
    name: "BagSimpleIcon",
  }, 
  {
    id: "phosphor:BalloonIcon", 
    tags: ["phosphor", "balloon"], 
    source: "phosphor", 
    name: "BalloonIcon",
  }, 
  {
    id: "phosphor:BandaidsIcon", 
    tags: ["phosphor", "bandaids"], 
    source: "phosphor", 
    name: "BandaidsIcon",
  }, 
  {
    id: "phosphor:BankIcon", 
    tags: ["phosphor", "bank"], 
    source: "phosphor", 
    name: "BankIcon",
  }, 
  {
    id: "phosphor:BarbellIcon", 
    tags: ["phosphor", "barbell"], 
    source: "phosphor", 
    name: "BarbellIcon",
  }, 
  {
    id: "phosphor:BarcodeIcon", 
    tags: ["phosphor", "barcode"], 
    source: "phosphor", 
    name: "BarcodeIcon",
  }, 
  {
    id: "phosphor:BarnIcon", 
    tags: ["phosphor", "barn"], 
    source: "phosphor", 
    name: "BarnIcon",
  }, 
  {
    id: "phosphor:BarricadeIcon", 
    tags: ["phosphor", "barricade"], 
    source: "phosphor", 
    name: "BarricadeIcon",
  }, 
  {
    id: "phosphor:BaseballCapIcon", 
    tags: ["phosphor", "baseball", "cap"], 
    source: "phosphor", 
    name: "BaseballCapIcon",
  }, 
  {
    id: "phosphor:BaseballHelmetIcon", 
    tags: ["phosphor", "baseball", "helmet"], 
    source: "phosphor", 
    name: "BaseballHelmetIcon",
  }, 
  {
    id: "phosphor:BaseballIcon", 
    tags: ["phosphor", "baseball"], 
    source: "phosphor", 
    name: "BaseballIcon",
  }, 
  {
    id: "phosphor:BasketIcon", 
    tags: ["phosphor", "basket"], 
    source: "phosphor", 
    name: "BasketIcon",
  }, 
  {
    id: "phosphor:BasketballIcon", 
    tags: ["phosphor", "basketball"], 
    source: "phosphor", 
    name: "BasketballIcon",
  }, 
  {
    id: "phosphor:BathtubIcon", 
    tags: ["phosphor", "bathtub"], 
    source: "phosphor", 
    name: "BathtubIcon",
  }, 
  {
    id: "phosphor:BatteryChargingIcon", 
    tags: ["phosphor", "battery", "charging"], 
    source: "phosphor", 
    name: "BatteryChargingIcon",
  }, 
  {
    id: "phosphor:BatteryChargingVerticalIcon", 
    tags: ["phosphor", "battery", "charging", "vertical"], 
    source: "phosphor", 
    name: "BatteryChargingVerticalIcon",
  }, 
  {
    id: "phosphor:BatteryEmptyIcon", 
    tags: ["phosphor", "battery", "empty"], 
    source: "phosphor", 
    name: "BatteryEmptyIcon",
  }, 
  {
    id: "phosphor:BatteryFullIcon", 
    tags: ["phosphor", "battery", "full"], 
    source: "phosphor", 
    name: "BatteryFullIcon",
  }, 
  {
    id: "phosphor:BatteryHighIcon", 
    tags: ["phosphor", "battery", "high"], 
    source: "phosphor", 
    name: "BatteryHighIcon",
  }, 
  {
    id: "phosphor:BatteryLowIcon", 
    tags: ["phosphor", "battery", "low"], 
    source: "phosphor", 
    name: "BatteryLowIcon",
  }, 
  {
    id: "phosphor:BatteryMediumIcon", 
    tags: ["phosphor", "battery", "medium"], 
    source: "phosphor", 
    name: "BatteryMediumIcon",
  }, 
  {
    id: "phosphor:BatteryPlusIcon", 
    tags: ["phosphor", "battery", "plus"], 
    source: "phosphor", 
    name: "BatteryPlusIcon",
  }, 
  {
    id: "phosphor:BatteryPlusVerticalIcon", 
    tags: ["phosphor", "battery", "plus", "vertical"], 
    source: "phosphor", 
    name: "BatteryPlusVerticalIcon",
  }, 
  {
    id: "phosphor:BatteryVerticalEmptyIcon", 
    tags: ["phosphor", "battery", "vertical", "empty"], 
    source: "phosphor", 
    name: "BatteryVerticalEmptyIcon",
  }, 
  {
    id: "phosphor:BatteryVerticalFullIcon", 
    tags: ["phosphor", "battery", "vertical", "full"], 
    source: "phosphor", 
    name: "BatteryVerticalFullIcon",
  }, 
  {
    id: "phosphor:BatteryVerticalHighIcon", 
    tags: ["phosphor", "battery", "vertical", "high"], 
    source: "phosphor", 
    name: "BatteryVerticalHighIcon",
  }, 
  {
    id: "phosphor:BatteryVerticalLowIcon", 
    tags: ["phosphor", "battery", "vertical", "low"], 
    source: "phosphor", 
    name: "BatteryVerticalLowIcon",
  }, 
  {
    id: "phosphor:BatteryVerticalMediumIcon", 
    tags: ["phosphor", "battery", "vertical", "medium"], 
    source: "phosphor", 
    name: "BatteryVerticalMediumIcon",
  }, 
  {
    id: "phosphor:BatteryWarningIcon", 
    tags: ["phosphor", "battery", "warning"], 
    source: "phosphor", 
    name: "BatteryWarningIcon",
  }, 
  {
    id: "phosphor:BatteryWarningVerticalIcon", 
    tags: ["phosphor", "battery", "warning", "vertical"], 
    source: "phosphor", 
    name: "BatteryWarningVerticalIcon",
  }, 
  {
    id: "phosphor:BeachBallIcon", 
    tags: ["phosphor", "beach", "ball"], 
    source: "phosphor", 
    name: "BeachBallIcon",
  }, 
  {
    id: "phosphor:BeanieIcon", 
    tags: ["phosphor", "beanie"], 
    source: "phosphor", 
    name: "BeanieIcon",
  }, 
  {
    id: "phosphor:BedIcon", 
    tags: ["phosphor", "bed"], 
    source: "phosphor", 
    name: "BedIcon",
  }, 
  {
    id: "phosphor:BeerBottleIcon", 
    tags: ["phosphor", "beer", "bottle"], 
    source: "phosphor", 
    name: "BeerBottleIcon",
  }, 
  {
    id: "phosphor:BeerSteinIcon", 
    tags: ["phosphor", "beer", "stein"], 
    source: "phosphor", 
    name: "BeerSteinIcon",
  }, 
  {
    id: "phosphor:BehanceLogoIcon", 
    tags: ["phosphor", "behance", "logo"], 
    source: "phosphor", 
    name: "BehanceLogoIcon",
  }, 
  {
    id: "phosphor:BellIcon", 
    tags: ["phosphor", "bell"], 
    source: "phosphor", 
    name: "BellIcon",
  }, 
  {
    id: "phosphor:BellRingingIcon", 
    tags: ["phosphor", "bell", "ringing"], 
    source: "phosphor", 
    name: "BellRingingIcon",
  }, 
  {
    id: "phosphor:BellSimpleIcon", 
    tags: ["phosphor", "bell", "simple"], 
    source: "phosphor", 
    name: "BellSimpleIcon",
  }, 
  {
    id: "phosphor:BellSimpleRingingIcon", 
    tags: ["phosphor", "bell", "simple", "ringing"], 
    source: "phosphor", 
    name: "BellSimpleRingingIcon",
  }, 
  {
    id: "phosphor:BellSimpleSlashIcon", 
    tags: ["phosphor", "bell", "simple", "slash"], 
    source: "phosphor", 
    name: "BellSimpleSlashIcon",
  }, 
  {
    id: "phosphor:BellSimpleZIcon", 
    tags: ["phosphor", "bell", "simple"], 
    source: "phosphor", 
    name: "BellSimpleZIcon",
  }, 
  {
    id: "phosphor:BellSlashIcon", 
    tags: ["phosphor", "bell", "slash"], 
    source: "phosphor", 
    name: "BellSlashIcon",
  }, 
  {
    id: "phosphor:BellZIcon", 
    tags: ["phosphor", "bell"], 
    source: "phosphor", 
    name: "BellZIcon",
  }, 
  {
    id: "phosphor:BeltIcon", 
    tags: ["phosphor", "belt"], 
    source: "phosphor", 
    name: "BeltIcon",
  }, 
  {
    id: "phosphor:BezierCurveIcon", 
    tags: ["phosphor", "bezier", "curve"], 
    source: "phosphor", 
    name: "BezierCurveIcon",
  }, 
  {
    id: "phosphor:BicycleIcon", 
    tags: ["phosphor", "bicycle"], 
    source: "phosphor", 
    name: "BicycleIcon",
  }, 
  {
    id: "phosphor:BinaryIcon", 
    tags: ["phosphor", "binary"], 
    source: "phosphor", 
    name: "BinaryIcon",
  }, 
  {
    id: "phosphor:BinocularsIcon", 
    tags: ["phosphor", "binoculars"], 
    source: "phosphor", 
    name: "BinocularsIcon",
  }, 
  {
    id: "phosphor:BiohazardIcon", 
    tags: ["phosphor", "biohazard"], 
    source: "phosphor", 
    name: "BiohazardIcon",
  }, 
  {
    id: "phosphor:BirdIcon", 
    tags: ["phosphor", "bird"], 
    source: "phosphor", 
    name: "BirdIcon",
  }, 
  {
    id: "phosphor:BlueprintIcon", 
    tags: ["phosphor", "blueprint"], 
    source: "phosphor", 
    name: "BlueprintIcon",
  }, 
  {
    id: "phosphor:BluetoothConnectedIcon", 
    tags: ["phosphor", "bluetooth", "connected"], 
    source: "phosphor", 
    name: "BluetoothConnectedIcon",
  }, 
  {
    id: "phosphor:BluetoothIcon", 
    tags: ["phosphor", "bluetooth"], 
    source: "phosphor", 
    name: "BluetoothIcon",
  }, 
  {
    id: "phosphor:BluetoothSlashIcon", 
    tags: ["phosphor", "bluetooth", "slash"], 
    source: "phosphor", 
    name: "BluetoothSlashIcon",
  }, 
  {
    id: "phosphor:BluetoothXIcon", 
    tags: ["phosphor", "bluetooth"], 
    source: "phosphor", 
    name: "BluetoothXIcon",
  }, 
  {
    id: "phosphor:BoatIcon", 
    tags: ["phosphor", "boat"], 
    source: "phosphor", 
    name: "BoatIcon",
  }, 
  {
    id: "phosphor:BombIcon", 
    tags: ["phosphor", "bomb"], 
    source: "phosphor", 
    name: "BombIcon",
  }, 
  {
    id: "phosphor:BoneIcon", 
    tags: ["phosphor", "bone"], 
    source: "phosphor", 
    name: "BoneIcon",
  }, 
  {
    id: "phosphor:BookBookmarkIcon", 
    tags: ["phosphor", "book", "bookmark"], 
    source: "phosphor", 
    name: "BookBookmarkIcon",
  }, 
  {
    id: "phosphor:BookIcon", 
    tags: ["phosphor", "book"], 
    source: "phosphor", 
    name: "BookIcon",
  }, 
  {
    id: "phosphor:BookOpenIcon", 
    tags: ["phosphor", "book", "open"], 
    source: "phosphor", 
    name: "BookOpenIcon",
  }, 
  {
    id: "phosphor:BookOpenTextIcon", 
    tags: ["phosphor", "book", "open", "text"], 
    source: "phosphor", 
    name: "BookOpenTextIcon",
  }, 
  {
    id: "phosphor:BookOpenUserIcon", 
    tags: ["phosphor", "book", "open", "user"], 
    source: "phosphor", 
    name: "BookOpenUserIcon",
  }, 
  {
    id: "phosphor:BookmarkIcon", 
    tags: ["phosphor", "bookmark"], 
    source: "phosphor", 
    name: "BookmarkIcon",
  }, 
  {
    id: "phosphor:BookmarkSimpleIcon", 
    tags: ["phosphor", "bookmark", "simple"], 
    source: "phosphor", 
    name: "BookmarkSimpleIcon",
  }, 
  {
    id: "phosphor:BookmarksIcon", 
    tags: ["phosphor", "bookmarks"], 
    source: "phosphor", 
    name: "BookmarksIcon",
  }, 
  {
    id: "phosphor:BookmarksSimpleIcon", 
    tags: ["phosphor", "bookmarks", "simple"], 
    source: "phosphor", 
    name: "BookmarksSimpleIcon",
  }, 
  {
    id: "phosphor:BooksIcon", 
    tags: ["phosphor", "books"], 
    source: "phosphor", 
    name: "BooksIcon",
  }, 
  {
    id: "phosphor:BootIcon", 
    tags: ["phosphor", "boot"], 
    source: "phosphor", 
    name: "BootIcon",
  }, 
  {
    id: "phosphor:BoulesIcon", 
    tags: ["phosphor", "boules"], 
    source: "phosphor", 
    name: "BoulesIcon",
  }, 
  {
    id: "phosphor:BoundingBoxIcon", 
    tags: ["phosphor", "bounding", "box"], 
    source: "phosphor", 
    name: "BoundingBoxIcon",
  }, 
  {
    id: "phosphor:BowlFoodIcon", 
    tags: ["phosphor", "bowl", "food"], 
    source: "phosphor", 
    name: "BowlFoodIcon",
  }, 
  {
    id: "phosphor:BowlSteamIcon", 
    tags: ["phosphor", "bowl", "steam"], 
    source: "phosphor", 
    name: "BowlSteamIcon",
  }, 
  {
    id: "phosphor:BowlingBallIcon", 
    tags: ["phosphor", "bowling", "ball"], 
    source: "phosphor", 
    name: "BowlingBallIcon",
  }, 
  {
    id: "phosphor:BoxArrowDownIcon", 
    tags: ["phosphor", "box", "arrow", "down"], 
    source: "phosphor", 
    name: "BoxArrowDownIcon",
  }, 
  {
    id: "phosphor:BoxArrowUpIcon", 
    tags: ["phosphor", "box", "arrow", "up"], 
    source: "phosphor", 
    name: "BoxArrowUpIcon",
  }, 
  {
    id: "phosphor:BoxingGloveIcon", 
    tags: ["phosphor", "boxing", "glove"], 
    source: "phosphor", 
    name: "BoxingGloveIcon",
  }, 
  {
    id: "phosphor:BracketsAngleIcon", 
    tags: ["phosphor", "brackets", "angle"], 
    source: "phosphor", 
    name: "BracketsAngleIcon",
  }, 
  {
    id: "phosphor:BracketsCurlyIcon", 
    tags: ["phosphor", "brackets", "curly"], 
    source: "phosphor", 
    name: "BracketsCurlyIcon",
  }, 
  {
    id: "phosphor:BracketsRoundIcon", 
    tags: ["phosphor", "brackets", "round"], 
    source: "phosphor", 
    name: "BracketsRoundIcon",
  }, 
  {
    id: "phosphor:BracketsSquareIcon", 
    tags: ["phosphor", "brackets", "square"], 
    source: "phosphor", 
    name: "BracketsSquareIcon",
  }, 
  {
    id: "phosphor:BrainIcon", 
    tags: ["phosphor", "brain"], 
    source: "phosphor", 
    name: "BrainIcon",
  }, 
  {
    id: "phosphor:BrandyIcon", 
    tags: ["phosphor", "brandy"], 
    source: "phosphor", 
    name: "BrandyIcon",
  }, 
  {
    id: "phosphor:BreadIcon", 
    tags: ["phosphor", "bread"], 
    source: "phosphor", 
    name: "BreadIcon",
  }, 
  {
    id: "phosphor:BridgeIcon", 
    tags: ["phosphor", "bridge"], 
    source: "phosphor", 
    name: "BridgeIcon",
  }, 
  {
    id: "phosphor:BriefcaseIcon", 
    tags: ["phosphor", "briefcase"], 
    source: "phosphor", 
    name: "BriefcaseIcon",
  }, 
  {
    id: "phosphor:BriefcaseMetalIcon", 
    tags: ["phosphor", "briefcase", "metal"], 
    source: "phosphor", 
    name: "BriefcaseMetalIcon",
  }, 
  {
    id: "phosphor:BroadcastIcon", 
    tags: ["phosphor", "broadcast"], 
    source: "phosphor", 
    name: "BroadcastIcon",
  }, 
  {
    id: "phosphor:BroomIcon", 
    tags: ["phosphor", "broom"], 
    source: "phosphor", 
    name: "BroomIcon",
  }, 
  {
    id: "phosphor:BrowserIcon", 
    tags: ["phosphor", "browser"], 
    source: "phosphor", 
    name: "BrowserIcon",
  }, 
  {
    id: "phosphor:BrowsersIcon", 
    tags: ["phosphor", "browsers"], 
    source: "phosphor", 
    name: "BrowsersIcon",
  }, 
  {
    id: "phosphor:BugBeetleIcon", 
    tags: ["phosphor", "bug", "beetle"], 
    source: "phosphor", 
    name: "BugBeetleIcon",
  }, 
  {
    id: "phosphor:BugDroidIcon", 
    tags: ["phosphor", "bug", "droid"], 
    source: "phosphor", 
    name: "BugDroidIcon",
  }, 
  {
    id: "phosphor:BugIcon", 
    tags: ["phosphor", "bug"], 
    source: "phosphor", 
    name: "BugIcon",
  }, 
  {
    id: "phosphor:BuildingApartmentIcon", 
    tags: ["phosphor", "building", "apartment"], 
    source: "phosphor", 
    name: "BuildingApartmentIcon",
  }, 
  {
    id: "phosphor:BuildingIcon", 
    tags: ["phosphor", "building"], 
    source: "phosphor", 
    name: "BuildingIcon",
  }, 
  {
    id: "phosphor:BuildingOfficeIcon", 
    tags: ["phosphor", "building", "office"], 
    source: "phosphor", 
    name: "BuildingOfficeIcon",
  }, 
  {
    id: "phosphor:BuildingsIcon", 
    tags: ["phosphor", "buildings"], 
    source: "phosphor", 
    name: "BuildingsIcon",
  }, 
  {
    id: "phosphor:BulldozerIcon", 
    tags: ["phosphor", "bulldozer"], 
    source: "phosphor", 
    name: "BulldozerIcon",
  }, 
  {
    id: "phosphor:BusIcon", 
    tags: ["phosphor", "bus"], 
    source: "phosphor", 
    name: "BusIcon",
  }, 
  {
    id: "phosphor:ButterflyIcon", 
    tags: ["phosphor", "butterfly"], 
    source: "phosphor", 
    name: "ButterflyIcon",
  }, 
  {
    id: "phosphor:CableCarIcon", 
    tags: ["phosphor", "cable", "car"], 
    source: "phosphor", 
    name: "CableCarIcon",
  }, 
  {
    id: "phosphor:CactusIcon", 
    tags: ["phosphor", "cactus"], 
    source: "phosphor", 
    name: "CactusIcon",
  }, 
  {
    id: "phosphor:CaduceusIcon", 
    tags: ["phosphor", "caduceus"], 
    source: "phosphor", 
    name: "CaduceusIcon",
  }, 
  {
    id: "phosphor:CakeIcon", 
    tags: ["phosphor", "cake"], 
    source: "phosphor", 
    name: "CakeIcon",
  }, 
  {
    id: "phosphor:CalculatorIcon", 
    tags: ["phosphor", "calculator"], 
    source: "phosphor", 
    name: "CalculatorIcon",
  }, 
  {
    id: "phosphor:CalendarBlankIcon", 
    tags: ["phosphor", "calendar", "blank"], 
    source: "phosphor", 
    name: "CalendarBlankIcon",
  }, 
  {
    id: "phosphor:CalendarCheckIcon", 
    tags: ["phosphor", "calendar", "check"], 
    source: "phosphor", 
    name: "CalendarCheckIcon",
  }, 
  {
    id: "phosphor:CalendarDotIcon", 
    tags: ["phosphor", "calendar", "dot"], 
    source: "phosphor", 
    name: "CalendarDotIcon",
  }, 
  {
    id: "phosphor:CalendarDotsIcon", 
    tags: ["phosphor", "calendar", "dots"], 
    source: "phosphor", 
    name: "CalendarDotsIcon",
  }, 
  {
    id: "phosphor:CalendarHeartIcon", 
    tags: ["phosphor", "calendar", "heart"], 
    source: "phosphor", 
    name: "CalendarHeartIcon",
  }, 
  {
    id: "phosphor:CalendarIcon", 
    tags: ["phosphor", "calendar"], 
    source: "phosphor", 
    name: "CalendarIcon",
  }, 
  {
    id: "phosphor:CalendarMinusIcon", 
    tags: ["phosphor", "calendar", "minus"], 
    source: "phosphor", 
    name: "CalendarMinusIcon",
  }, 
  {
    id: "phosphor:CalendarPlusIcon", 
    tags: ["phosphor", "calendar", "plus"], 
    source: "phosphor", 
    name: "CalendarPlusIcon",
  }, 
  {
    id: "phosphor:CalendarSlashIcon", 
    tags: ["phosphor", "calendar", "slash"], 
    source: "phosphor", 
    name: "CalendarSlashIcon",
  }, 
  {
    id: "phosphor:CalendarStarIcon", 
    tags: ["phosphor", "calendar", "star"], 
    source: "phosphor", 
    name: "CalendarStarIcon",
  }, 
  {
    id: "phosphor:CalendarXIcon", 
    tags: ["phosphor", "calendar"], 
    source: "phosphor", 
    name: "CalendarXIcon",
  }, 
  {
    id: "phosphor:CallBellIcon", 
    tags: ["phosphor", "call", "bell"], 
    source: "phosphor", 
    name: "CallBellIcon",
  }, 
  {
    id: "phosphor:CameraIcon", 
    tags: ["phosphor", "camera"], 
    source: "phosphor", 
    name: "CameraIcon",
  }, 
  {
    id: "phosphor:CameraPlusIcon", 
    tags: ["phosphor", "camera", "plus"], 
    source: "phosphor", 
    name: "CameraPlusIcon",
  }, 
  {
    id: "phosphor:CameraRotateIcon", 
    tags: ["phosphor", "camera", "rotate"], 
    source: "phosphor", 
    name: "CameraRotateIcon",
  }, 
  {
    id: "phosphor:CameraSlashIcon", 
    tags: ["phosphor", "camera", "slash"], 
    source: "phosphor", 
    name: "CameraSlashIcon",
  }, 
  {
    id: "phosphor:CampfireIcon", 
    tags: ["phosphor", "campfire"], 
    source: "phosphor", 
    name: "CampfireIcon",
  }, 
  {
    id: "phosphor:CarBatteryIcon", 
    tags: ["phosphor", "car", "battery"], 
    source: "phosphor", 
    name: "CarBatteryIcon",
  }, 
  {
    id: "phosphor:CarIcon", 
    tags: ["phosphor", "car"], 
    source: "phosphor", 
    name: "CarIcon",
  }, 
  {
    id: "phosphor:CarProfileIcon", 
    tags: ["phosphor", "car", "profile"], 
    source: "phosphor", 
    name: "CarProfileIcon",
  }, 
  {
    id: "phosphor:CarSimpleIcon", 
    tags: ["phosphor", "car", "simple"], 
    source: "phosphor", 
    name: "CarSimpleIcon",
  }, 
  {
    id: "phosphor:CardholderIcon", 
    tags: ["phosphor", "cardholder"], 
    source: "phosphor", 
    name: "CardholderIcon",
  }, 
  {
    id: "phosphor:CardsIcon", 
    tags: ["phosphor", "cards"], 
    source: "phosphor", 
    name: "CardsIcon",
  }, 
  {
    id: "phosphor:CardsThreeIcon", 
    tags: ["phosphor", "cards", "three"], 
    source: "phosphor", 
    name: "CardsThreeIcon",
  }, 
  {
    id: "phosphor:CaretCircleDoubleDownIcon", 
    tags: ["phosphor", "caret", "circle", "double", "down"], 
    source: "phosphor", 
    name: "CaretCircleDoubleDownIcon",
  }, 
  {
    id: "phosphor:CaretCircleDoubleLeftIcon", 
    tags: ["phosphor", "caret", "circle", "double", "left"], 
    source: "phosphor", 
    name: "CaretCircleDoubleLeftIcon",
  }, 
  {
    id: "phosphor:CaretCircleDoubleRightIcon", 
    tags: ["phosphor", "caret", "circle", "double", "right"], 
    source: "phosphor", 
    name: "CaretCircleDoubleRightIcon",
  }, 
  {
    id: "phosphor:CaretCircleDoubleUpIcon", 
    tags: ["phosphor", "caret", "circle", "double", "up"], 
    source: "phosphor", 
    name: "CaretCircleDoubleUpIcon",
  }, 
  {
    id: "phosphor:CaretCircleDownIcon", 
    tags: ["phosphor", "caret", "circle", "down"], 
    source: "phosphor", 
    name: "CaretCircleDownIcon",
  }, 
  {
    id: "phosphor:CaretCircleLeftIcon", 
    tags: ["phosphor", "caret", "circle", "left"], 
    source: "phosphor", 
    name: "CaretCircleLeftIcon",
  }, 
  {
    id: "phosphor:CaretCircleRightIcon", 
    tags: ["phosphor", "caret", "circle", "right"], 
    source: "phosphor", 
    name: "CaretCircleRightIcon",
  }, 
  {
    id: "phosphor:CaretCircleUpDownIcon", 
    tags: ["phosphor", "caret", "circle", "up", "down"], 
    source: "phosphor", 
    name: "CaretCircleUpDownIcon",
  }, 
  {
    id: "phosphor:CaretCircleUpIcon", 
    tags: ["phosphor", "caret", "circle", "up"], 
    source: "phosphor", 
    name: "CaretCircleUpIcon",
  }, 
  {
    id: "phosphor:CaretDoubleDownIcon", 
    tags: ["phosphor", "caret", "double", "down"], 
    source: "phosphor", 
    name: "CaretDoubleDownIcon",
  }, 
  {
    id: "phosphor:CaretDoubleLeftIcon", 
    tags: ["phosphor", "caret", "double", "left"], 
    source: "phosphor", 
    name: "CaretDoubleLeftIcon",
  }, 
  {
    id: "phosphor:CaretDoubleRightIcon", 
    tags: ["phosphor", "caret", "double", "right"], 
    source: "phosphor", 
    name: "CaretDoubleRightIcon",
  }, 
  {
    id: "phosphor:CaretDoubleUpIcon", 
    tags: ["phosphor", "caret", "double", "up"], 
    source: "phosphor", 
    name: "CaretDoubleUpIcon",
  }, 
  {
    id: "phosphor:CaretDownIcon", 
    tags: ["phosphor", "caret", "down"], 
    source: "phosphor", 
    name: "CaretDownIcon",
  }, 
  {
    id: "phosphor:CaretLeftIcon", 
    tags: ["phosphor", "caret", "left"], 
    source: "phosphor", 
    name: "CaretLeftIcon",
  }, 
  {
    id: "phosphor:CaretLineDownIcon", 
    tags: ["phosphor", "caret", "line", "down"], 
    source: "phosphor", 
    name: "CaretLineDownIcon",
  }, 
  {
    id: "phosphor:CaretLineLeftIcon", 
    tags: ["phosphor", "caret", "line", "left"], 
    source: "phosphor", 
    name: "CaretLineLeftIcon",
  }, 
  {
    id: "phosphor:CaretLineRightIcon", 
    tags: ["phosphor", "caret", "line", "right"], 
    source: "phosphor", 
    name: "CaretLineRightIcon",
  }, 
  {
    id: "phosphor:CaretLineUpIcon", 
    tags: ["phosphor", "caret", "line", "up"], 
    source: "phosphor", 
    name: "CaretLineUpIcon",
  }, 
  {
    id: "phosphor:CaretRightIcon", 
    tags: ["phosphor", "caret", "right"], 
    source: "phosphor", 
    name: "CaretRightIcon",
  }, 
  {
    id: "phosphor:CaretUpDownIcon", 
    tags: ["phosphor", "caret", "up", "down"], 
    source: "phosphor", 
    name: "CaretUpDownIcon",
  }, 
  {
    id: "phosphor:CaretUpIcon", 
    tags: ["phosphor", "caret", "up"], 
    source: "phosphor", 
    name: "CaretUpIcon",
  }, 
  {
    id: "phosphor:CarrotIcon", 
    tags: ["phosphor", "carrot"], 
    source: "phosphor", 
    name: "CarrotIcon",
  }, 
  {
    id: "phosphor:CashRegisterIcon", 
    tags: ["phosphor", "cash", "register"], 
    source: "phosphor", 
    name: "CashRegisterIcon",
  }, 
  {
    id: "phosphor:CassetteTapeIcon", 
    tags: ["phosphor", "cassette", "tape"], 
    source: "phosphor", 
    name: "CassetteTapeIcon",
  }, 
  {
    id: "phosphor:CastleTurretIcon", 
    tags: ["phosphor", "castle", "turret"], 
    source: "phosphor", 
    name: "CastleTurretIcon",
  }, 
  {
    id: "phosphor:CatIcon", 
    tags: ["phosphor", "cat"], 
    source: "phosphor", 
    name: "CatIcon",
  }, 
  {
    id: "phosphor:CellSignalFullIcon", 
    tags: ["phosphor", "cell", "signal", "full"], 
    source: "phosphor", 
    name: "CellSignalFullIcon",
  }, 
  {
    id: "phosphor:CellSignalHighIcon", 
    tags: ["phosphor", "cell", "signal", "high"], 
    source: "phosphor", 
    name: "CellSignalHighIcon",
  }, 
  {
    id: "phosphor:CellSignalLowIcon", 
    tags: ["phosphor", "cell", "signal", "low"], 
    source: "phosphor", 
    name: "CellSignalLowIcon",
  }, 
  {
    id: "phosphor:CellSignalMediumIcon", 
    tags: ["phosphor", "cell", "signal", "medium"], 
    source: "phosphor", 
    name: "CellSignalMediumIcon",
  }, 
  {
    id: "phosphor:CellSignalNoneIcon", 
    tags: ["phosphor", "cell", "signal", "none"], 
    source: "phosphor", 
    name: "CellSignalNoneIcon",
  }, 
  {
    id: "phosphor:CellSignalSlashIcon", 
    tags: ["phosphor", "cell", "signal", "slash"], 
    source: "phosphor", 
    name: "CellSignalSlashIcon",
  }, 
  {
    id: "phosphor:CellSignalXIcon", 
    tags: ["phosphor", "cell", "signal"], 
    source: "phosphor", 
    name: "CellSignalXIcon",
  }, 
  {
    id: "phosphor:CellTowerIcon", 
    tags: ["phosphor", "cell", "tower"], 
    source: "phosphor", 
    name: "CellTowerIcon",
  }, 
  {
    id: "phosphor:CertificateIcon", 
    tags: ["phosphor", "certificate"], 
    source: "phosphor", 
    name: "CertificateIcon",
  }, 
  {
    id: "phosphor:ChairIcon", 
    tags: ["phosphor", "chair"], 
    source: "phosphor", 
    name: "ChairIcon",
  }, 
  {
    id: "phosphor:ChalkboardIcon", 
    tags: ["phosphor", "chalkboard"], 
    source: "phosphor", 
    name: "ChalkboardIcon",
  }, 
  {
    id: "phosphor:ChalkboardSimpleIcon", 
    tags: ["phosphor", "chalkboard", "simple"], 
    source: "phosphor", 
    name: "ChalkboardSimpleIcon",
  }, 
  {
    id: "phosphor:ChalkboardTeacherIcon", 
    tags: ["phosphor", "chalkboard", "teacher"], 
    source: "phosphor", 
    name: "ChalkboardTeacherIcon",
  }, 
  {
    id: "phosphor:ChampagneIcon", 
    tags: ["phosphor", "champagne"], 
    source: "phosphor", 
    name: "ChampagneIcon",
  }, 
  {
    id: "phosphor:ChargingStationIcon", 
    tags: ["phosphor", "charging", "station"], 
    source: "phosphor", 
    name: "ChargingStationIcon",
  }, 
  {
    id: "phosphor:ChartBarHorizontalIcon", 
    tags: ["phosphor", "chart", "bar", "horizontal"], 
    source: "phosphor", 
    name: "ChartBarHorizontalIcon",
  }, 
  {
    id: "phosphor:ChartBarIcon", 
    tags: ["phosphor", "chart", "bar"], 
    source: "phosphor", 
    name: "ChartBarIcon",
  }, 
  {
    id: "phosphor:ChartDonutIcon", 
    tags: ["phosphor", "chart", "donut"], 
    source: "phosphor", 
    name: "ChartDonutIcon",
  }, 
  {
    id: "phosphor:ChartLineDownIcon", 
    tags: ["phosphor", "chart", "line", "down"], 
    source: "phosphor", 
    name: "ChartLineDownIcon",
  }, 
  {
    id: "phosphor:ChartLineIcon", 
    tags: ["phosphor", "chart", "line"], 
    source: "phosphor", 
    name: "ChartLineIcon",
  }, 
  {
    id: "phosphor:ChartLineUpIcon", 
    tags: ["phosphor", "chart", "line", "up"], 
    source: "phosphor", 
    name: "ChartLineUpIcon",
  }, 
  {
    id: "phosphor:ChartPieIcon", 
    tags: ["phosphor", "chart", "pie"], 
    source: "phosphor", 
    name: "ChartPieIcon",
  }, 
  {
    id: "phosphor:ChartPieSliceIcon", 
    tags: ["phosphor", "chart", "pie", "slice"], 
    source: "phosphor", 
    name: "ChartPieSliceIcon",
  }, 
  {
    id: "phosphor:ChartPolarIcon", 
    tags: ["phosphor", "chart", "polar"], 
    source: "phosphor", 
    name: "ChartPolarIcon",
  }, 
  {
    id: "phosphor:ChartScatterIcon", 
    tags: ["phosphor", "chart", "scatter"], 
    source: "phosphor", 
    name: "ChartScatterIcon",
  }, 
  {
    id: "phosphor:ChatCenteredDotsIcon", 
    tags: ["phosphor", "chat", "centered", "dots"], 
    source: "phosphor", 
    name: "ChatCenteredDotsIcon",
  }, 
  {
    id: "phosphor:ChatCenteredIcon", 
    tags: ["phosphor", "chat", "centered"], 
    source: "phosphor", 
    name: "ChatCenteredIcon",
  }, 
  {
    id: "phosphor:ChatCenteredSlashIcon", 
    tags: ["phosphor", "chat", "centered", "slash"], 
    source: "phosphor", 
    name: "ChatCenteredSlashIcon",
  }, 
  {
    id: "phosphor:ChatCenteredTextIcon", 
    tags: ["phosphor", "chat", "centered", "text"], 
    source: "phosphor", 
    name: "ChatCenteredTextIcon",
  }, 
  {
    id: "phosphor:ChatCircleDotsIcon", 
    tags: ["phosphor", "chat", "circle", "dots"], 
    source: "phosphor", 
    name: "ChatCircleDotsIcon",
  }, 
  {
    id: "phosphor:ChatCircleIcon", 
    tags: ["phosphor", "chat", "circle"], 
    source: "phosphor", 
    name: "ChatCircleIcon",
  }, 
  {
    id: "phosphor:ChatCircleSlashIcon", 
    tags: ["phosphor", "chat", "circle", "slash"], 
    source: "phosphor", 
    name: "ChatCircleSlashIcon",
  }, 
  {
    id: "phosphor:ChatCircleTextIcon", 
    tags: ["phosphor", "chat", "circle", "text"], 
    source: "phosphor", 
    name: "ChatCircleTextIcon",
  }, 
  {
    id: "phosphor:ChatDotsIcon", 
    tags: ["phosphor", "chat", "dots"], 
    source: "phosphor", 
    name: "ChatDotsIcon",
  }, 
  {
    id: "phosphor:ChatIcon", 
    tags: ["phosphor", "chat"], 
    source: "phosphor", 
    name: "ChatIcon",
  }, 
  {
    id: "phosphor:ChatSlashIcon", 
    tags: ["phosphor", "chat", "slash"], 
    source: "phosphor", 
    name: "ChatSlashIcon",
  }, 
  {
    id: "phosphor:ChatTeardropDotsIcon", 
    tags: ["phosphor", "chat", "teardrop", "dots"], 
    source: "phosphor", 
    name: "ChatTeardropDotsIcon",
  }, 
  {
    id: "phosphor:ChatTeardropIcon", 
    tags: ["phosphor", "chat", "teardrop"], 
    source: "phosphor", 
    name: "ChatTeardropIcon",
  }, 
  {
    id: "phosphor:ChatTeardropSlashIcon", 
    tags: ["phosphor", "chat", "teardrop", "slash"], 
    source: "phosphor", 
    name: "ChatTeardropSlashIcon",
  }, 
  {
    id: "phosphor:ChatTeardropTextIcon", 
    tags: ["phosphor", "chat", "teardrop", "text"], 
    source: "phosphor", 
    name: "ChatTeardropTextIcon",
  }, 
  {
    id: "phosphor:ChatTextIcon", 
    tags: ["phosphor", "chat", "text"], 
    source: "phosphor", 
    name: "ChatTextIcon",
  }, 
  {
    id: "phosphor:ChatsCircleIcon", 
    tags: ["phosphor", "chats", "circle"], 
    source: "phosphor", 
    name: "ChatsCircleIcon",
  }, 
  {
    id: "phosphor:ChatsIcon", 
    tags: ["phosphor", "chats"], 
    source: "phosphor", 
    name: "ChatsIcon",
  }, 
  {
    id: "phosphor:ChatsTeardropIcon", 
    tags: ["phosphor", "chats", "teardrop"], 
    source: "phosphor", 
    name: "ChatsTeardropIcon",
  }, 
  {
    id: "phosphor:CheckCircleIcon", 
    tags: ["phosphor", "check", "circle"], 
    source: "phosphor", 
    name: "CheckCircleIcon",
  }, 
  {
    id: "phosphor:CheckFatIcon", 
    tags: ["phosphor", "check", "fat"], 
    source: "phosphor", 
    name: "CheckFatIcon",
  }, 
  {
    id: "phosphor:CheckIcon", 
    tags: ["phosphor", "check"], 
    source: "phosphor", 
    name: "CheckIcon",
  }, 
  {
    id: "phosphor:CheckSquareIcon", 
    tags: ["phosphor", "check", "square"], 
    source: "phosphor", 
    name: "CheckSquareIcon",
  }, 
  {
    id: "phosphor:CheckSquareOffsetIcon", 
    tags: ["phosphor", "check", "square", "offset"], 
    source: "phosphor", 
    name: "CheckSquareOffsetIcon",
  }, 
  {
    id: "phosphor:CheckerboardIcon", 
    tags: ["phosphor", "checkerboard"], 
    source: "phosphor", 
    name: "CheckerboardIcon",
  }, 
  {
    id: "phosphor:ChecksIcon", 
    tags: ["phosphor", "checks"], 
    source: "phosphor", 
    name: "ChecksIcon",
  }, 
  {
    id: "phosphor:CheersIcon", 
    tags: ["phosphor", "cheers"], 
    source: "phosphor", 
    name: "CheersIcon",
  }, 
  {
    id: "phosphor:CheeseIcon", 
    tags: ["phosphor", "cheese"], 
    source: "phosphor", 
    name: "CheeseIcon",
  }, 
  {
    id: "phosphor:ChefHatIcon", 
    tags: ["phosphor", "chef", "hat"], 
    source: "phosphor", 
    name: "ChefHatIcon",
  }, 
  {
    id: "phosphor:CherriesIcon", 
    tags: ["phosphor", "cherries"], 
    source: "phosphor", 
    name: "CherriesIcon",
  }, 
  {
    id: "phosphor:ChurchIcon", 
    tags: ["phosphor", "church"], 
    source: "phosphor", 
    name: "ChurchIcon",
  }, 
  {
    id: "phosphor:CigaretteIcon", 
    tags: ["phosphor", "cigarette"], 
    source: "phosphor", 
    name: "CigaretteIcon",
  }, 
  {
    id: "phosphor:CigaretteSlashIcon", 
    tags: ["phosphor", "cigarette", "slash"], 
    source: "phosphor", 
    name: "CigaretteSlashIcon",
  }, 
  {
    id: "phosphor:CircleDashedIcon", 
    tags: ["phosphor", "circle", "dashed"], 
    source: "phosphor", 
    name: "CircleDashedIcon",
  }, 
  {
    id: "phosphor:CircleHalfIcon", 
    tags: ["phosphor", "circle", "half"], 
    source: "phosphor", 
    name: "CircleHalfIcon",
  }, 
  {
    id: "phosphor:CircleHalfTiltIcon", 
    tags: ["phosphor", "circle", "half", "tilt"], 
    source: "phosphor", 
    name: "CircleHalfTiltIcon",
  }, 
  {
    id: "phosphor:CircleIcon", 
    tags: ["phosphor", "circle"], 
    source: "phosphor", 
    name: "CircleIcon",
  }, 
  {
    id: "phosphor:CircleNotchIcon", 
    tags: ["phosphor", "circle", "notch"], 
    source: "phosphor", 
    name: "CircleNotchIcon",
  }, 
  {
    id: "phosphor:CircleWavyCheckIcon", 
    tags: ["phosphor", "circle", "wavy", "check"], 
    source: "phosphor", 
    name: "CircleWavyCheckIcon",
  }, 
  {
    id: "phosphor:CircleWavyIcon", 
    tags: ["phosphor", "circle", "wavy"], 
    source: "phosphor", 
    name: "CircleWavyIcon",
  }, 
  {
    id: "phosphor:CircleWavyQuestionIcon", 
    tags: ["phosphor", "circle", "wavy", "question"], 
    source: "phosphor", 
    name: "CircleWavyQuestionIcon",
  }, 
  {
    id: "phosphor:CircleWavyWarningIcon", 
    tags: ["phosphor", "circle", "wavy", "warning"], 
    source: "phosphor", 
    name: "CircleWavyWarningIcon",
  }, 
  {
    id: "phosphor:CirclesFourIcon", 
    tags: ["phosphor", "circles", "four"], 
    source: "phosphor", 
    name: "CirclesFourIcon",
  }, 
  {
    id: "phosphor:CirclesThreeIcon", 
    tags: ["phosphor", "circles", "three"], 
    source: "phosphor", 
    name: "CirclesThreeIcon",
  }, 
  {
    id: "phosphor:CirclesThreePlusIcon", 
    tags: ["phosphor", "circles", "three", "plus"], 
    source: "phosphor", 
    name: "CirclesThreePlusIcon",
  }, 
  {
    id: "phosphor:CircuitryIcon", 
    tags: ["phosphor", "circuitry"], 
    source: "phosphor", 
    name: "CircuitryIcon",
  }, 
  {
    id: "phosphor:CityIcon", 
    tags: ["phosphor", "city"], 
    source: "phosphor", 
    name: "CityIcon",
  }, 
  {
    id: "phosphor:ClipboardIcon", 
    tags: ["phosphor", "clipboard"], 
    source: "phosphor", 
    name: "ClipboardIcon",
  }, 
  {
    id: "phosphor:ClipboardTextIcon", 
    tags: ["phosphor", "clipboard", "text"], 
    source: "phosphor", 
    name: "ClipboardTextIcon",
  }, 
  {
    id: "phosphor:ClockAfternoonIcon", 
    tags: ["phosphor", "clock", "afternoon"], 
    source: "phosphor", 
    name: "ClockAfternoonIcon",
  }, 
  {
    id: "phosphor:ClockClockwiseIcon", 
    tags: ["phosphor", "clock", "clockwise"], 
    source: "phosphor", 
    name: "ClockClockwiseIcon",
  }, 
  {
    id: "phosphor:ClockCountdownIcon", 
    tags: ["phosphor", "clock", "countdown"], 
    source: "phosphor", 
    name: "ClockCountdownIcon",
  }, 
  {
    id: "phosphor:ClockCounterClockwiseIcon", 
    tags: ["phosphor", "clock", "counter", "clockwise"], 
    source: "phosphor", 
    name: "ClockCounterClockwiseIcon",
  }, 
  {
    id: "phosphor:ClockIcon", 
    tags: ["phosphor", "clock"], 
    source: "phosphor", 
    name: "ClockIcon",
  }, 
  {
    id: "phosphor:ClockUserIcon", 
    tags: ["phosphor", "clock", "user"], 
    source: "phosphor", 
    name: "ClockUserIcon",
  }, 
  {
    id: "phosphor:ClosedCaptioningIcon", 
    tags: ["phosphor", "closed", "captioning"], 
    source: "phosphor", 
    name: "ClosedCaptioningIcon",
  }, 
  {
    id: "phosphor:CloudArrowDownIcon", 
    tags: ["phosphor", "cloud", "arrow", "down"], 
    source: "phosphor", 
    name: "CloudArrowDownIcon",
  }, 
  {
    id: "phosphor:CloudArrowUpIcon", 
    tags: ["phosphor", "cloud", "arrow", "up"], 
    source: "phosphor", 
    name: "CloudArrowUpIcon",
  }, 
  {
    id: "phosphor:CloudCheckIcon", 
    tags: ["phosphor", "cloud", "check"], 
    source: "phosphor", 
    name: "CloudCheckIcon",
  }, 
  {
    id: "phosphor:CloudFogIcon", 
    tags: ["phosphor", "cloud", "fog"], 
    source: "phosphor", 
    name: "CloudFogIcon",
  }, 
  {
    id: "phosphor:CloudIcon", 
    tags: ["phosphor", "cloud"], 
    source: "phosphor", 
    name: "CloudIcon",
  }, 
  {
    id: "phosphor:CloudLightningIcon", 
    tags: ["phosphor", "cloud", "lightning"], 
    source: "phosphor", 
    name: "CloudLightningIcon",
  }, 
  {
    id: "phosphor:CloudMoonIcon", 
    tags: ["phosphor", "cloud", "moon"], 
    source: "phosphor", 
    name: "CloudMoonIcon",
  }, 
  {
    id: "phosphor:CloudRainIcon", 
    tags: ["phosphor", "cloud", "rain"], 
    source: "phosphor", 
    name: "CloudRainIcon",
  }, 
  {
    id: "phosphor:CloudSlashIcon", 
    tags: ["phosphor", "cloud", "slash"], 
    source: "phosphor", 
    name: "CloudSlashIcon",
  }, 
  {
    id: "phosphor:CloudSnowIcon", 
    tags: ["phosphor", "cloud", "snow"], 
    source: "phosphor", 
    name: "CloudSnowIcon",
  }, 
  {
    id: "phosphor:CloudSunIcon", 
    tags: ["phosphor", "cloud", "sun"], 
    source: "phosphor", 
    name: "CloudSunIcon",
  }, 
  {
    id: "phosphor:CloudWarningIcon", 
    tags: ["phosphor", "cloud", "warning"], 
    source: "phosphor", 
    name: "CloudWarningIcon",
  }, 
  {
    id: "phosphor:CloudXIcon", 
    tags: ["phosphor", "cloud"], 
    source: "phosphor", 
    name: "CloudXIcon",
  }, 
  {
    id: "phosphor:CloverIcon", 
    tags: ["phosphor", "clover"], 
    source: "phosphor", 
    name: "CloverIcon",
  }, 
  {
    id: "phosphor:ClubIcon", 
    tags: ["phosphor", "club"], 
    source: "phosphor", 
    name: "ClubIcon",
  }, 
  {
    id: "phosphor:CoatHangerIcon", 
    tags: ["phosphor", "coat", "hanger"], 
    source: "phosphor", 
    name: "CoatHangerIcon",
  }, 
  {
    id: "phosphor:CodaLogoIcon", 
    tags: ["phosphor", "coda", "logo"], 
    source: "phosphor", 
    name: "CodaLogoIcon",
  }, 
  {
    id: "phosphor:CodeBlockIcon", 
    tags: ["phosphor", "code", "block"], 
    source: "phosphor", 
    name: "CodeBlockIcon",
  }, 
  {
    id: "phosphor:CodeIcon", 
    tags: ["phosphor", "code"], 
    source: "phosphor", 
    name: "CodeIcon",
  }, 
  {
    id: "phosphor:CodeSimpleIcon", 
    tags: ["phosphor", "code", "simple"], 
    source: "phosphor", 
    name: "CodeSimpleIcon",
  }, 
  {
    id: "phosphor:CodepenLogoIcon", 
    tags: ["phosphor", "codepen", "logo"], 
    source: "phosphor", 
    name: "CodepenLogoIcon",
  }, 
  {
    id: "phosphor:CodesandboxLogoIcon", 
    tags: ["phosphor", "codesandbox", "logo"], 
    source: "phosphor", 
    name: "CodesandboxLogoIcon",
  }, 
  {
    id: "phosphor:CoffeeBeanIcon", 
    tags: ["phosphor", "coffee", "bean"], 
    source: "phosphor", 
    name: "CoffeeBeanIcon",
  }, 
  {
    id: "phosphor:CoffeeIcon", 
    tags: ["phosphor", "coffee"], 
    source: "phosphor", 
    name: "CoffeeIcon",
  }, 
  {
    id: "phosphor:CoinIcon", 
    tags: ["phosphor", "coin"], 
    source: "phosphor", 
    name: "CoinIcon",
  }, 
  {
    id: "phosphor:CoinVerticalIcon", 
    tags: ["phosphor", "coin", "vertical"], 
    source: "phosphor", 
    name: "CoinVerticalIcon",
  }, 
  {
    id: "phosphor:CoinsIcon", 
    tags: ["phosphor", "coins"], 
    source: "phosphor", 
    name: "CoinsIcon",
  }, 
  {
    id: "phosphor:ColumnsIcon", 
    tags: ["phosphor", "columns"], 
    source: "phosphor", 
    name: "ColumnsIcon",
  }, 
  {
    id: "phosphor:ColumnsPlusLeftIcon", 
    tags: ["phosphor", "columns", "plus", "left"], 
    source: "phosphor", 
    name: "ColumnsPlusLeftIcon",
  }, 
  {
    id: "phosphor:ColumnsPlusRightIcon", 
    tags: ["phosphor", "columns", "plus", "right"], 
    source: "phosphor", 
    name: "ColumnsPlusRightIcon",
  }, 
  {
    id: "phosphor:CommandIcon", 
    tags: ["phosphor", "command"], 
    source: "phosphor", 
    name: "CommandIcon",
  }, 
  {
    id: "phosphor:CompassIcon", 
    tags: ["phosphor", "compass"], 
    source: "phosphor", 
    name: "CompassIcon",
  }, 
  {
    id: "phosphor:CompassRoseIcon", 
    tags: ["phosphor", "compass", "rose"], 
    source: "phosphor", 
    name: "CompassRoseIcon",
  }, 
  {
    id: "phosphor:CompassToolIcon", 
    tags: ["phosphor", "compass", "tool"], 
    source: "phosphor", 
    name: "CompassToolIcon",
  }, 
  {
    id: "phosphor:ComputerTowerIcon", 
    tags: ["phosphor", "computer", "tower"], 
    source: "phosphor", 
    name: "ComputerTowerIcon",
  }, 
  {
    id: "phosphor:ConfettiIcon", 
    tags: ["phosphor", "confetti"], 
    source: "phosphor", 
    name: "ConfettiIcon",
  }, 
  {
    id: "phosphor:ContactlessPaymentIcon", 
    tags: ["phosphor", "contactless", "payment"], 
    source: "phosphor", 
    name: "ContactlessPaymentIcon",
  }, 
  {
    id: "phosphor:ControlIcon", 
    tags: ["phosphor", "control"], 
    source: "phosphor", 
    name: "ControlIcon",
  }, 
  {
    id: "phosphor:CookieIcon", 
    tags: ["phosphor", "cookie"], 
    source: "phosphor", 
    name: "CookieIcon",
  }, 
  {
    id: "phosphor:CookingPotIcon", 
    tags: ["phosphor", "cooking", "pot"], 
    source: "phosphor", 
    name: "CookingPotIcon",
  }, 
  {
    id: "phosphor:CopyIcon", 
    tags: ["phosphor", "copy"], 
    source: "phosphor", 
    name: "CopyIcon",
  }, 
  {
    id: "phosphor:CopySimpleIcon", 
    tags: ["phosphor", "copy", "simple"], 
    source: "phosphor", 
    name: "CopySimpleIcon",
  }, 
  {
    id: "phosphor:CopyleftIcon", 
    tags: ["phosphor", "copyleft"], 
    source: "phosphor", 
    name: "CopyleftIcon",
  }, 
  {
    id: "phosphor:CopyrightIcon", 
    tags: ["phosphor", "copyright"], 
    source: "phosphor", 
    name: "CopyrightIcon",
  }, 
  {
    id: "phosphor:CornersInIcon", 
    tags: ["phosphor", "corners", "in"], 
    source: "phosphor", 
    name: "CornersInIcon",
  }, 
  {
    id: "phosphor:CornersOutIcon", 
    tags: ["phosphor", "corners", "out"], 
    source: "phosphor", 
    name: "CornersOutIcon",
  }, 
  {
    id: "phosphor:CouchIcon", 
    tags: ["phosphor", "couch"], 
    source: "phosphor", 
    name: "CouchIcon",
  }, 
  {
    id: "phosphor:CourtBasketballIcon", 
    tags: ["phosphor", "court", "basketball"], 
    source: "phosphor", 
    name: "CourtBasketballIcon",
  }, 
  {
    id: "phosphor:CowIcon", 
    tags: ["phosphor", "cow"], 
    source: "phosphor", 
    name: "CowIcon",
  }, 
  {
    id: "phosphor:CowboyHatIcon", 
    tags: ["phosphor", "cowboy", "hat"], 
    source: "phosphor", 
    name: "CowboyHatIcon",
  }, 
  {
    id: "phosphor:CpuIcon", 
    tags: ["phosphor", "cpu"], 
    source: "phosphor", 
    name: "CpuIcon",
  }, 
  {
    id: "phosphor:CraneIcon", 
    tags: ["phosphor", "crane"], 
    source: "phosphor", 
    name: "CraneIcon",
  }, 
  {
    id: "phosphor:CraneTowerIcon", 
    tags: ["phosphor", "crane", "tower"], 
    source: "phosphor", 
    name: "CraneTowerIcon",
  }, 
  {
    id: "phosphor:CreditCardIcon", 
    tags: ["phosphor", "credit", "card"], 
    source: "phosphor", 
    name: "CreditCardIcon",
  }, 
  {
    id: "phosphor:CricketIcon", 
    tags: ["phosphor", "cricket"], 
    source: "phosphor", 
    name: "CricketIcon",
  }, 
  {
    id: "phosphor:CropIcon", 
    tags: ["phosphor", "crop"], 
    source: "phosphor", 
    name: "CropIcon",
  }, 
  {
    id: "phosphor:CrossIcon", 
    tags: ["phosphor", "cross"], 
    source: "phosphor", 
    name: "CrossIcon",
  }, 
  {
    id: "phosphor:CrosshairIcon", 
    tags: ["phosphor", "crosshair"], 
    source: "phosphor", 
    name: "CrosshairIcon",
  }, 
  {
    id: "phosphor:CrosshairSimpleIcon", 
    tags: ["phosphor", "crosshair", "simple"], 
    source: "phosphor", 
    name: "CrosshairSimpleIcon",
  }, 
  {
    id: "phosphor:CrownCrossIcon", 
    tags: ["phosphor", "crown", "cross"], 
    source: "phosphor", 
    name: "CrownCrossIcon",
  }, 
  {
    id: "phosphor:CrownIcon", 
    tags: ["phosphor", "crown"], 
    source: "phosphor", 
    name: "CrownIcon",
  }, 
  {
    id: "phosphor:CrownSimpleIcon", 
    tags: ["phosphor", "crown", "simple"], 
    source: "phosphor", 
    name: "CrownSimpleIcon",
  }, 
  {
    id: "phosphor:CubeFocusIcon", 
    tags: ["phosphor", "cube", "focus"], 
    source: "phosphor", 
    name: "CubeFocusIcon",
  }, 
  {
    id: "phosphor:CubeIcon", 
    tags: ["phosphor", "cube"], 
    source: "phosphor", 
    name: "CubeIcon",
  }, 
  {
    id: "phosphor:CubeTransparentIcon", 
    tags: ["phosphor", "cube", "transparent"], 
    source: "phosphor", 
    name: "CubeTransparentIcon",
  }, 
  {
    id: "phosphor:CurrencyBtcIcon", 
    tags: ["phosphor", "currency", "btc"], 
    source: "phosphor", 
    name: "CurrencyBtcIcon",
  }, 
  {
    id: "phosphor:CurrencyCircleDollarIcon", 
    tags: ["phosphor", "currency", "circle", "dollar"], 
    source: "phosphor", 
    name: "CurrencyCircleDollarIcon",
  }, 
  {
    id: "phosphor:CurrencyCnyIcon", 
    tags: ["phosphor", "currency", "cny"], 
    source: "phosphor", 
    name: "CurrencyCnyIcon",
  }, 
  {
    id: "phosphor:CurrencyDollarIcon", 
    tags: ["phosphor", "currency", "dollar"], 
    source: "phosphor", 
    name: "CurrencyDollarIcon",
  }, 
  {
    id: "phosphor:CurrencyDollarSimpleIcon", 
    tags: ["phosphor", "currency", "dollar", "simple"], 
    source: "phosphor", 
    name: "CurrencyDollarSimpleIcon",
  }, 
  {
    id: "phosphor:CurrencyEthIcon", 
    tags: ["phosphor", "currency", "eth"], 
    source: "phosphor", 
    name: "CurrencyEthIcon",
  }, 
  {
    id: "phosphor:CurrencyEurIcon", 
    tags: ["phosphor", "currency", "eur"], 
    source: "phosphor", 
    name: "CurrencyEurIcon",
  }, 
  {
    id: "phosphor:CurrencyGbpIcon", 
    tags: ["phosphor", "currency", "gbp"], 
    source: "phosphor", 
    name: "CurrencyGbpIcon",
  }, 
  {
    id: "phosphor:CurrencyInrIcon", 
    tags: ["phosphor", "currency", "inr"], 
    source: "phosphor", 
    name: "CurrencyInrIcon",
  }, 
  {
    id: "phosphor:CurrencyJpyIcon", 
    tags: ["phosphor", "currency", "jpy"], 
    source: "phosphor", 
    name: "CurrencyJpyIcon",
  }, 
  {
    id: "phosphor:CurrencyKrwIcon", 
    tags: ["phosphor", "currency", "krw"], 
    source: "phosphor", 
    name: "CurrencyKrwIcon",
  }, 
  {
    id: "phosphor:CurrencyKztIcon", 
    tags: ["phosphor", "currency", "kzt"], 
    source: "phosphor", 
    name: "CurrencyKztIcon",
  }, 
  {
    id: "phosphor:CurrencyNgnIcon", 
    tags: ["phosphor", "currency", "ngn"], 
    source: "phosphor", 
    name: "CurrencyNgnIcon",
  }, 
  {
    id: "phosphor:CurrencyRubIcon", 
    tags: ["phosphor", "currency", "rub"], 
    source: "phosphor", 
    name: "CurrencyRubIcon",
  }, 
  {
    id: "phosphor:CursorClickIcon", 
    tags: ["phosphor", "cursor", "click"], 
    source: "phosphor", 
    name: "CursorClickIcon",
  }, 
  {
    id: "phosphor:CursorIcon", 
    tags: ["phosphor", "cursor"], 
    source: "phosphor", 
    name: "CursorIcon",
  }, 
  {
    id: "phosphor:CursorTextIcon", 
    tags: ["phosphor", "cursor", "text"], 
    source: "phosphor", 
    name: "CursorTextIcon",
  }, 
  {
    id: "phosphor:CylinderIcon", 
    tags: ["phosphor", "cylinder"], 
    source: "phosphor", 
    name: "CylinderIcon",
  }, 
  {
    id: "phosphor:DatabaseIcon", 
    tags: ["phosphor", "database"], 
    source: "phosphor", 
    name: "DatabaseIcon",
  }, 
  {
    id: "phosphor:DeskIcon", 
    tags: ["phosphor", "desk"], 
    source: "phosphor", 
    name: "DeskIcon",
  }, 
  {
    id: "phosphor:DesktopIcon", 
    tags: ["phosphor", "desktop"], 
    source: "phosphor", 
    name: "DesktopIcon",
  }, 
  {
    id: "phosphor:DesktopTowerIcon", 
    tags: ["phosphor", "desktop", "tower"], 
    source: "phosphor", 
    name: "DesktopTowerIcon",
  }, 
  {
    id: "phosphor:DetectiveIcon", 
    tags: ["phosphor", "detective"], 
    source: "phosphor", 
    name: "DetectiveIcon",
  }, 
  {
    id: "phosphor:DevToLogoIcon", 
    tags: ["phosphor", "dev", "to", "logo"], 
    source: "phosphor", 
    name: "DevToLogoIcon",
  }, 
  {
    id: "phosphor:DeviceMobileCameraIcon", 
    tags: ["phosphor", "device", "mobile", "camera"], 
    source: "phosphor", 
    name: "DeviceMobileCameraIcon",
  }, 
  {
    id: "phosphor:DeviceMobileIcon", 
    tags: ["phosphor", "device", "mobile"], 
    source: "phosphor", 
    name: "DeviceMobileIcon",
  }, 
  {
    id: "phosphor:DeviceMobileSlashIcon", 
    tags: ["phosphor", "device", "mobile", "slash"], 
    source: "phosphor", 
    name: "DeviceMobileSlashIcon",
  }, 
  {
    id: "phosphor:DeviceMobileSpeakerIcon", 
    tags: ["phosphor", "device", "mobile", "speaker"], 
    source: "phosphor", 
    name: "DeviceMobileSpeakerIcon",
  }, 
  {
    id: "phosphor:DeviceRotateIcon", 
    tags: ["phosphor", "device", "rotate"], 
    source: "phosphor", 
    name: "DeviceRotateIcon",
  }, 
  {
    id: "phosphor:DeviceTabletCameraIcon", 
    tags: ["phosphor", "device", "tablet", "camera"], 
    source: "phosphor", 
    name: "DeviceTabletCameraIcon",
  }, 
  {
    id: "phosphor:DeviceTabletIcon", 
    tags: ["phosphor", "device", "tablet"], 
    source: "phosphor", 
    name: "DeviceTabletIcon",
  }, 
  {
    id: "phosphor:DeviceTabletSpeakerIcon", 
    tags: ["phosphor", "device", "tablet", "speaker"], 
    source: "phosphor", 
    name: "DeviceTabletSpeakerIcon",
  }, 
  {
    id: "phosphor:DevicesIcon", 
    tags: ["phosphor", "devices"], 
    source: "phosphor", 
    name: "DevicesIcon",
  }, 
  {
    id: "phosphor:DiamondIcon", 
    tags: ["phosphor", "diamond"], 
    source: "phosphor", 
    name: "DiamondIcon",
  }, 
  {
    id: "phosphor:DiamondsFourIcon", 
    tags: ["phosphor", "diamonds", "four"], 
    source: "phosphor", 
    name: "DiamondsFourIcon",
  }, 
  {
    id: "phosphor:DiceFiveIcon", 
    tags: ["phosphor", "dice", "five"], 
    source: "phosphor", 
    name: "DiceFiveIcon",
  }, 
  {
    id: "phosphor:DiceFourIcon", 
    tags: ["phosphor", "dice", "four"], 
    source: "phosphor", 
    name: "DiceFourIcon",
  }, 
  {
    id: "phosphor:DiceOneIcon", 
    tags: ["phosphor", "dice", "one"], 
    source: "phosphor", 
    name: "DiceOneIcon",
  }, 
  {
    id: "phosphor:DiceSixIcon", 
    tags: ["phosphor", "dice", "six"], 
    source: "phosphor", 
    name: "DiceSixIcon",
  }, 
  {
    id: "phosphor:DiceThreeIcon", 
    tags: ["phosphor", "dice", "three"], 
    source: "phosphor", 
    name: "DiceThreeIcon",
  }, 
  {
    id: "phosphor:DiceTwoIcon", 
    tags: ["phosphor", "dice", "two"], 
    source: "phosphor", 
    name: "DiceTwoIcon",
  }, 
  {
    id: "phosphor:DiscIcon", 
    tags: ["phosphor", "disc"], 
    source: "phosphor", 
    name: "DiscIcon",
  }, 
  {
    id: "phosphor:DiscoBallIcon", 
    tags: ["phosphor", "disco", "ball"], 
    source: "phosphor", 
    name: "DiscoBallIcon",
  }, 
  {
    id: "phosphor:DiscordLogoIcon", 
    tags: ["phosphor", "discord", "logo"], 
    source: "phosphor", 
    name: "DiscordLogoIcon",
  }, 
  {
    id: "phosphor:DivideIcon", 
    tags: ["phosphor", "divide"], 
    source: "phosphor", 
    name: "DivideIcon",
  }, 
  {
    id: "phosphor:DnaIcon", 
    tags: ["phosphor", "dna"], 
    source: "phosphor", 
    name: "DnaIcon",
  }, 
  {
    id: "phosphor:DogIcon", 
    tags: ["phosphor", "dog"], 
    source: "phosphor", 
    name: "DogIcon",
  }, 
  {
    id: "phosphor:DoorIcon", 
    tags: ["phosphor", "door"], 
    source: "phosphor", 
    name: "DoorIcon",
  }, 
  {
    id: "phosphor:DoorOpenIcon", 
    tags: ["phosphor", "door", "open"], 
    source: "phosphor", 
    name: "DoorOpenIcon",
  }, 
  {
    id: "phosphor:DotIcon", 
    tags: ["phosphor", "dot"], 
    source: "phosphor", 
    name: "DotIcon",
  }, 
  {
    id: "phosphor:DotOutlineIcon", 
    tags: ["phosphor", "dot", "outline"], 
    source: "phosphor", 
    name: "DotOutlineIcon",
  }, 
  {
    id: "phosphor:DotsNineIcon", 
    tags: ["phosphor", "dots", "nine"], 
    source: "phosphor", 
    name: "DotsNineIcon",
  }, 
  {
    id: "phosphor:DotsSixIcon", 
    tags: ["phosphor", "dots", "six"], 
    source: "phosphor", 
    name: "DotsSixIcon",
  }, 
  {
    id: "phosphor:DotsSixVerticalIcon", 
    tags: ["phosphor", "dots", "six", "vertical"], 
    source: "phosphor", 
    name: "DotsSixVerticalIcon",
  }, 
  {
    id: "phosphor:DotsThreeCircleIcon", 
    tags: ["phosphor", "dots", "three", "circle"], 
    source: "phosphor", 
    name: "DotsThreeCircleIcon",
  }, 
  {
    id: "phosphor:DotsThreeCircleVerticalIcon", 
    tags: ["phosphor", "dots", "three", "circle", "vertical"], 
    source: "phosphor", 
    name: "DotsThreeCircleVerticalIcon",
  }, 
  {
    id: "phosphor:DotsThreeIcon", 
    tags: ["phosphor", "dots", "three"], 
    source: "phosphor", 
    name: "DotsThreeIcon",
  }, 
  {
    id: "phosphor:DotsThreeOutlineIcon", 
    tags: ["phosphor", "dots", "three", "outline"], 
    source: "phosphor", 
    name: "DotsThreeOutlineIcon",
  }, 
  {
    id: "phosphor:DotsThreeOutlineVerticalIcon", 
    tags: ["phosphor", "dots", "three", "outline", "vertical"], 
    source: "phosphor", 
    name: "DotsThreeOutlineVerticalIcon",
  }, 
  {
    id: "phosphor:DotsThreeVerticalIcon", 
    tags: ["phosphor", "dots", "three", "vertical"], 
    source: "phosphor", 
    name: "DotsThreeVerticalIcon",
  }, 
  {
    id: "phosphor:DownloadIcon", 
    tags: ["phosphor", "download"], 
    source: "phosphor", 
    name: "DownloadIcon",
  }, 
  {
    id: "phosphor:DownloadSimpleIcon", 
    tags: ["phosphor", "download", "simple"], 
    source: "phosphor", 
    name: "DownloadSimpleIcon",
  }, 
  {
    id: "phosphor:DressIcon", 
    tags: ["phosphor", "dress"], 
    source: "phosphor", 
    name: "DressIcon",
  }, 
  {
    id: "phosphor:DresserIcon", 
    tags: ["phosphor", "dresser"], 
    source: "phosphor", 
    name: "DresserIcon",
  }, 
  {
    id: "phosphor:DribbbleLogoIcon", 
    tags: ["phosphor", "dribbble", "logo"], 
    source: "phosphor", 
    name: "DribbbleLogoIcon",
  }, 
  {
    id: "phosphor:DroneIcon", 
    tags: ["phosphor", "drone"], 
    source: "phosphor", 
    name: "DroneIcon",
  }, 
  {
    id: "phosphor:DropHalfBottomIcon", 
    tags: ["phosphor", "drop", "half", "bottom"], 
    source: "phosphor", 
    name: "DropHalfBottomIcon",
  }, 
  {
    id: "phosphor:DropHalfIcon", 
    tags: ["phosphor", "drop", "half"], 
    source: "phosphor", 
    name: "DropHalfIcon",
  }, 
  {
    id: "phosphor:DropIcon", 
    tags: ["phosphor", "drop"], 
    source: "phosphor", 
    name: "DropIcon",
  }, 
  {
    id: "phosphor:DropSimpleIcon", 
    tags: ["phosphor", "drop", "simple"], 
    source: "phosphor", 
    name: "DropSimpleIcon",
  }, 
  {
    id: "phosphor:DropSlashIcon", 
    tags: ["phosphor", "drop", "slash"], 
    source: "phosphor", 
    name: "DropSlashIcon",
  }, 
  {
    id: "phosphor:DropboxLogoIcon", 
    tags: ["phosphor", "dropbox", "logo"], 
    source: "phosphor", 
    name: "DropboxLogoIcon",
  }, 
  {
    id: "phosphor:EarIcon", 
    tags: ["phosphor", "ear"], 
    source: "phosphor", 
    name: "EarIcon",
  }, 
  {
    id: "phosphor:EarSlashIcon", 
    tags: ["phosphor", "ear", "slash"], 
    source: "phosphor", 
    name: "EarSlashIcon",
  }, 
  {
    id: "phosphor:EggCrackIcon", 
    tags: ["phosphor", "egg", "crack"], 
    source: "phosphor", 
    name: "EggCrackIcon",
  }, 
  {
    id: "phosphor:EggIcon", 
    tags: ["phosphor", "egg"], 
    source: "phosphor", 
    name: "EggIcon",
  }, 
  {
    id: "phosphor:EjectIcon", 
    tags: ["phosphor", "eject"], 
    source: "phosphor", 
    name: "EjectIcon",
  }, 
  {
    id: "phosphor:EjectSimpleIcon", 
    tags: ["phosphor", "eject", "simple"], 
    source: "phosphor", 
    name: "EjectSimpleIcon",
  }, 
  {
    id: "phosphor:ElevatorIcon", 
    tags: ["phosphor", "elevator"], 
    source: "phosphor", 
    name: "ElevatorIcon",
  }, 
  {
    id: "phosphor:EmptyIcon", 
    tags: ["phosphor", "empty"], 
    source: "phosphor", 
    name: "EmptyIcon",
  }, 
  {
    id: "phosphor:EngineIcon", 
    tags: ["phosphor", "engine"], 
    source: "phosphor", 
    name: "EngineIcon",
  }, 
  {
    id: "phosphor:EnvelopeIcon", 
    tags: ["phosphor", "envelope"], 
    source: "phosphor", 
    name: "EnvelopeIcon",
  }, 
  {
    id: "phosphor:EnvelopeOpenIcon", 
    tags: ["phosphor", "envelope", "open"], 
    source: "phosphor", 
    name: "EnvelopeOpenIcon",
  }, 
  {
    id: "phosphor:EnvelopeSimpleIcon", 
    tags: ["phosphor", "envelope", "simple"], 
    source: "phosphor", 
    name: "EnvelopeSimpleIcon",
  }, 
  {
    id: "phosphor:EnvelopeSimpleOpenIcon", 
    tags: ["phosphor", "envelope", "simple", "open"], 
    source: "phosphor", 
    name: "EnvelopeSimpleOpenIcon",
  }, 
  {
    id: "phosphor:EqualizerIcon", 
    tags: ["phosphor", "equalizer"], 
    source: "phosphor", 
    name: "EqualizerIcon",
  }, 
  {
    id: "phosphor:EqualsIcon", 
    tags: ["phosphor", "equals"], 
    source: "phosphor", 
    name: "EqualsIcon",
  }, 
  {
    id: "phosphor:EraserIcon", 
    tags: ["phosphor", "eraser"], 
    source: "phosphor", 
    name: "EraserIcon",
  }, 
  {
    id: "phosphor:EscalatorDownIcon", 
    tags: ["phosphor", "escalator", "down"], 
    source: "phosphor", 
    name: "EscalatorDownIcon",
  }, 
  {
    id: "phosphor:EscalatorUpIcon", 
    tags: ["phosphor", "escalator", "up"], 
    source: "phosphor", 
    name: "EscalatorUpIcon",
  }, 
  {
    id: "phosphor:ExamIcon", 
    tags: ["phosphor", "exam"], 
    source: "phosphor", 
    name: "ExamIcon",
  }, 
  {
    id: "phosphor:ExclamationMarkIcon", 
    tags: ["phosphor", "exclamation", "mark"], 
    source: "phosphor", 
    name: "ExclamationMarkIcon",
  }, 
  {
    id: "phosphor:ExcludeIcon", 
    tags: ["phosphor", "exclude"], 
    source: "phosphor", 
    name: "ExcludeIcon",
  }, 
  {
    id: "phosphor:ExcludeSquareIcon", 
    tags: ["phosphor", "exclude", "square"], 
    source: "phosphor", 
    name: "ExcludeSquareIcon",
  }, 
  {
    id: "phosphor:ExportIcon", 
    tags: ["phosphor", "export"], 
    source: "phosphor", 
    name: "ExportIcon",
  }, 
  {
    id: "phosphor:EyeClosedIcon", 
    tags: ["phosphor", "eye", "closed"], 
    source: "phosphor", 
    name: "EyeClosedIcon",
  }, 
  {
    id: "phosphor:EyeIcon", 
    tags: ["phosphor", "eye"], 
    source: "phosphor", 
    name: "EyeIcon",
  }, 
  {
    id: "phosphor:EyeSlashIcon", 
    tags: ["phosphor", "eye", "slash"], 
    source: "phosphor", 
    name: "EyeSlashIcon",
  }, 
  {
    id: "phosphor:EyedropperIcon", 
    tags: ["phosphor", "eyedropper"], 
    source: "phosphor", 
    name: "EyedropperIcon",
  }, 
  {
    id: "phosphor:EyedropperSampleIcon", 
    tags: ["phosphor", "eyedropper", "sample"], 
    source: "phosphor", 
    name: "EyedropperSampleIcon",
  }, 
  {
    id: "phosphor:EyeglassesIcon", 
    tags: ["phosphor", "eyeglasses"], 
    source: "phosphor", 
    name: "EyeglassesIcon",
  }, 
  {
    id: "phosphor:EyesIcon", 
    tags: ["phosphor", "eyes"], 
    source: "phosphor", 
    name: "EyesIcon",
  }, 
  {
    id: "phosphor:FaceMaskIcon", 
    tags: ["phosphor", "face", "mask"], 
    source: "phosphor", 
    name: "FaceMaskIcon",
  }, 
  {
    id: "phosphor:FacebookLogoIcon", 
    tags: ["phosphor", "facebook", "logo"], 
    source: "phosphor", 
    name: "FacebookLogoIcon",
  }, 
  {
    id: "phosphor:FactoryIcon", 
    tags: ["phosphor", "factory"], 
    source: "phosphor", 
    name: "FactoryIcon",
  }, 
  {
    id: "phosphor:FadersHorizontalIcon", 
    tags: ["phosphor", "faders", "horizontal"], 
    source: "phosphor", 
    name: "FadersHorizontalIcon",
  }, 
  {
    id: "phosphor:FadersIcon", 
    tags: ["phosphor", "faders"], 
    source: "phosphor", 
    name: "FadersIcon",
  }, 
  {
    id: "phosphor:FalloutShelterIcon", 
    tags: ["phosphor", "fallout", "shelter"], 
    source: "phosphor", 
    name: "FalloutShelterIcon",
  }, 
  {
    id: "phosphor:FanIcon", 
    tags: ["phosphor", "fan"], 
    source: "phosphor", 
    name: "FanIcon",
  }, 
  {
    id: "phosphor:FarmIcon", 
    tags: ["phosphor", "farm"], 
    source: "phosphor", 
    name: "FarmIcon",
  }, 
  {
    id: "phosphor:FastForwardCircleIcon", 
    tags: ["phosphor", "fast", "forward", "circle"], 
    source: "phosphor", 
    name: "FastForwardCircleIcon",
  }, 
  {
    id: "phosphor:FastForwardIcon", 
    tags: ["phosphor", "fast", "forward"], 
    source: "phosphor", 
    name: "FastForwardIcon",
  }, 
  {
    id: "phosphor:FeatherIcon", 
    tags: ["phosphor", "feather"], 
    source: "phosphor", 
    name: "FeatherIcon",
  }, 
  {
    id: "phosphor:FediverseLogoIcon", 
    tags: ["phosphor", "fediverse", "logo"], 
    source: "phosphor", 
    name: "FediverseLogoIcon",
  }, 
  {
    id: "phosphor:FigmaLogoIcon", 
    tags: ["phosphor", "figma", "logo"], 
    source: "phosphor", 
    name: "FigmaLogoIcon",
  }, 
  {
    id: "phosphor:FileArchiveIcon", 
    tags: ["phosphor", "file", "archive"], 
    source: "phosphor", 
    name: "FileArchiveIcon",
  }, 
  {
    id: "phosphor:FileArrowDownIcon", 
    tags: ["phosphor", "file", "arrow", "down"], 
    source: "phosphor", 
    name: "FileArrowDownIcon",
  }, 
  {
    id: "phosphor:FileArrowUpIcon", 
    tags: ["phosphor", "file", "arrow", "up"], 
    source: "phosphor", 
    name: "FileArrowUpIcon",
  }, 
  {
    id: "phosphor:FileAudioIcon", 
    tags: ["phosphor", "file", "audio"], 
    source: "phosphor", 
    name: "FileAudioIcon",
  }, 
  {
    id: "phosphor:FileCIcon", 
    tags: ["phosphor", "file"], 
    source: "phosphor", 
    name: "FileCIcon",
  }, 
  {
    id: "phosphor:FileCSharpIcon", 
    tags: ["phosphor", "file", "sharp"], 
    source: "phosphor", 
    name: "FileCSharpIcon",
  }, 
  {
    id: "phosphor:FileCloudIcon", 
    tags: ["phosphor", "file", "cloud"], 
    source: "phosphor", 
    name: "FileCloudIcon",
  }, 
  {
    id: "phosphor:FileCodeIcon", 
    tags: ["phosphor", "file", "code"], 
    source: "phosphor", 
    name: "FileCodeIcon",
  }, 
  {
    id: "phosphor:FileCppIcon", 
    tags: ["phosphor", "file", "cpp"], 
    source: "phosphor", 
    name: "FileCppIcon",
  }, 
  {
    id: "phosphor:FileCssIcon", 
    tags: ["phosphor", "file", "css"], 
    source: "phosphor", 
    name: "FileCssIcon",
  }, 
  {
    id: "phosphor:FileCsvIcon", 
    tags: ["phosphor", "file", "csv"], 
    source: "phosphor", 
    name: "FileCsvIcon",
  }, 
  {
    id: "phosphor:FileDashedIcon", 
    tags: ["phosphor", "file", "dashed"], 
    source: "phosphor", 
    name: "FileDashedIcon",
  }, 
  {
    id: "phosphor:FileDocIcon", 
    tags: ["phosphor", "file", "doc"], 
    source: "phosphor", 
    name: "FileDocIcon",
  }, 
  {
    id: "phosphor:FileDottedIcon", 
    tags: ["phosphor", "file", "dotted"], 
    source: "phosphor", 
    name: "FileDottedIcon",
  }, 
  {
    id: "phosphor:FileHtmlIcon", 
    tags: ["phosphor", "file", "html"], 
    source: "phosphor", 
    name: "FileHtmlIcon",
  }, 
  {
    id: "phosphor:FileIcon", 
    tags: ["phosphor", "file"], 
    source: "phosphor", 
    name: "FileIcon",
  }, 
  {
    id: "phosphor:FileImageIcon", 
    tags: ["phosphor", "file", "image"], 
    source: "phosphor", 
    name: "FileImageIcon",
  }, 
  {
    id: "phosphor:FileIniIcon", 
    tags: ["phosphor", "file", "ini"], 
    source: "phosphor", 
    name: "FileIniIcon",
  }, 
  {
    id: "phosphor:FileJpgIcon", 
    tags: ["phosphor", "file", "jpg"], 
    source: "phosphor", 
    name: "FileJpgIcon",
  }, 
  {
    id: "phosphor:FileJsIcon", 
    tags: ["phosphor", "file", "js"], 
    source: "phosphor", 
    name: "FileJsIcon",
  }, 
  {
    id: "phosphor:FileJsxIcon", 
    tags: ["phosphor", "file", "jsx"], 
    source: "phosphor", 
    name: "FileJsxIcon",
  }, 
  {
    id: "phosphor:FileLockIcon", 
    tags: ["phosphor", "file", "lock"], 
    source: "phosphor", 
    name: "FileLockIcon",
  }, 
  {
    id: "phosphor:FileMagnifyingGlassIcon", 
    tags: ["phosphor", "file", "magnifying", "glass"], 
    source: "phosphor", 
    name: "FileMagnifyingGlassIcon",
  }, 
  {
    id: "phosphor:FileMdIcon", 
    tags: ["phosphor", "file", "md"], 
    source: "phosphor", 
    name: "FileMdIcon",
  }, 
  {
    id: "phosphor:FileMinusIcon", 
    tags: ["phosphor", "file", "minus"], 
    source: "phosphor", 
    name: "FileMinusIcon",
  }, 
  {
    id: "phosphor:FilePdfIcon", 
    tags: ["phosphor", "file", "pdf"], 
    source: "phosphor", 
    name: "FilePdfIcon",
  }, 
  {
    id: "phosphor:FilePlusIcon", 
    tags: ["phosphor", "file", "plus"], 
    source: "phosphor", 
    name: "FilePlusIcon",
  }, 
  {
    id: "phosphor:FilePngIcon", 
    tags: ["phosphor", "file", "png"], 
    source: "phosphor", 
    name: "FilePngIcon",
  }, 
  {
    id: "phosphor:FilePptIcon", 
    tags: ["phosphor", "file", "ppt"], 
    source: "phosphor", 
    name: "FilePptIcon",
  }, 
  {
    id: "phosphor:FilePyIcon", 
    tags: ["phosphor", "file", "py"], 
    source: "phosphor", 
    name: "FilePyIcon",
  }, 
  {
    id: "phosphor:FileRsIcon", 
    tags: ["phosphor", "file", "rs"], 
    source: "phosphor", 
    name: "FileRsIcon",
  }, 
  {
    id: "phosphor:FileSearchIcon", 
    tags: ["phosphor", "file", "search"], 
    source: "phosphor", 
    name: "FileSearchIcon",
  }, 
  {
    id: "phosphor:FileSqlIcon", 
    tags: ["phosphor", "file", "sql"], 
    source: "phosphor", 
    name: "FileSqlIcon",
  }, 
  {
    id: "phosphor:FileSvgIcon", 
    tags: ["phosphor", "file", "svg"], 
    source: "phosphor", 
    name: "FileSvgIcon",
  }, 
  {
    id: "phosphor:FileTextIcon", 
    tags: ["phosphor", "file", "text"], 
    source: "phosphor", 
    name: "FileTextIcon",
  }, 
  {
    id: "phosphor:FileTsIcon", 
    tags: ["phosphor", "file", "ts"], 
    source: "phosphor", 
    name: "FileTsIcon",
  }, 
  {
    id: "phosphor:FileTsxIcon", 
    tags: ["phosphor", "file", "tsx"], 
    source: "phosphor", 
    name: "FileTsxIcon",
  }, 
  {
    id: "phosphor:FileTxtIcon", 
    tags: ["phosphor", "file", "txt"], 
    source: "phosphor", 
    name: "FileTxtIcon",
  }, 
  {
    id: "phosphor:FileVideoIcon", 
    tags: ["phosphor", "file", "video"], 
    source: "phosphor", 
    name: "FileVideoIcon",
  }, 
  {
    id: "phosphor:FileVueIcon", 
    tags: ["phosphor", "file", "vue"], 
    source: "phosphor", 
    name: "FileVueIcon",
  }, 
  {
    id: "phosphor:FileXIcon", 
    tags: ["phosphor", "file"], 
    source: "phosphor", 
    name: "FileXIcon",
  }, 
  {
    id: "phosphor:FileXlsIcon", 
    tags: ["phosphor", "file", "xls"], 
    source: "phosphor", 
    name: "FileXlsIcon",
  }, 
  {
    id: "phosphor:FileZipIcon", 
    tags: ["phosphor", "file", "zip"], 
    source: "phosphor", 
    name: "FileZipIcon",
  }, 
  {
    id: "phosphor:FilesIcon", 
    tags: ["phosphor", "files"], 
    source: "phosphor", 
    name: "FilesIcon",
  }, 
  {
    id: "phosphor:FilmReelIcon", 
    tags: ["phosphor", "film", "reel"], 
    source: "phosphor", 
    name: "FilmReelIcon",
  }, 
  {
    id: "phosphor:FilmScriptIcon", 
    tags: ["phosphor", "film", "script"], 
    source: "phosphor", 
    name: "FilmScriptIcon",
  }, 
  {
    id: "phosphor:FilmSlateIcon", 
    tags: ["phosphor", "film", "slate"], 
    source: "phosphor", 
    name: "FilmSlateIcon",
  }, 
  {
    id: "phosphor:FilmStripIcon", 
    tags: ["phosphor", "film", "strip"], 
    source: "phosphor", 
    name: "FilmStripIcon",
  }, 
  {
    id: "phosphor:FingerprintIcon", 
    tags: ["phosphor", "fingerprint"], 
    source: "phosphor", 
    name: "FingerprintIcon",
  }, 
  {
    id: "phosphor:FingerprintSimpleIcon", 
    tags: ["phosphor", "fingerprint", "simple"], 
    source: "phosphor", 
    name: "FingerprintSimpleIcon",
  }, 
  {
    id: "phosphor:FinnTheHumanIcon", 
    tags: ["phosphor", "finn", "the", "human"], 
    source: "phosphor", 
    name: "FinnTheHumanIcon",
  }, 
  {
    id: "phosphor:FireExtinguisherIcon", 
    tags: ["phosphor", "fire", "extinguisher"], 
    source: "phosphor", 
    name: "FireExtinguisherIcon",
  }, 
  {
    id: "phosphor:FireIcon", 
    tags: ["phosphor", "fire"], 
    source: "phosphor", 
    name: "FireIcon",
  }, 
  {
    id: "phosphor:FireSimpleIcon", 
    tags: ["phosphor", "fire", "simple"], 
    source: "phosphor", 
    name: "FireSimpleIcon",
  }, 
  {
    id: "phosphor:FireTruckIcon", 
    tags: ["phosphor", "fire", "truck"], 
    source: "phosphor", 
    name: "FireTruckIcon",
  }, 
  {
    id: "phosphor:FirstAidIcon", 
    tags: ["phosphor", "first", "aid"], 
    source: "phosphor", 
    name: "FirstAidIcon",
  }, 
  {
    id: "phosphor:FirstAidKitIcon", 
    tags: ["phosphor", "first", "aid", "kit"], 
    source: "phosphor", 
    name: "FirstAidKitIcon",
  }, 
  {
    id: "phosphor:FishIcon", 
    tags: ["phosphor", "fish"], 
    source: "phosphor", 
    name: "FishIcon",
  }, 
  {
    id: "phosphor:FishSimpleIcon", 
    tags: ["phosphor", "fish", "simple"], 
    source: "phosphor", 
    name: "FishSimpleIcon",
  }, 
  {
    id: "phosphor:FlagBannerFoldIcon", 
    tags: ["phosphor", "flag", "banner", "fold"], 
    source: "phosphor", 
    name: "FlagBannerFoldIcon",
  }, 
  {
    id: "phosphor:FlagBannerIcon", 
    tags: ["phosphor", "flag", "banner"], 
    source: "phosphor", 
    name: "FlagBannerIcon",
  }, 
  {
    id: "phosphor:FlagCheckeredIcon", 
    tags: ["phosphor", "flag", "checkered"], 
    source: "phosphor", 
    name: "FlagCheckeredIcon",
  }, 
  {
    id: "phosphor:FlagIcon", 
    tags: ["phosphor", "flag"], 
    source: "phosphor", 
    name: "FlagIcon",
  }, 
  {
    id: "phosphor:FlagPennantIcon", 
    tags: ["phosphor", "flag", "pennant"], 
    source: "phosphor", 
    name: "FlagPennantIcon",
  }, 
  {
    id: "phosphor:FlameIcon", 
    tags: ["phosphor", "flame"], 
    source: "phosphor", 
    name: "FlameIcon",
  }, 
  {
    id: "phosphor:FlashlightIcon", 
    tags: ["phosphor", "flashlight"], 
    source: "phosphor", 
    name: "FlashlightIcon",
  }, 
  {
    id: "phosphor:FlaskIcon", 
    tags: ["phosphor", "flask"], 
    source: "phosphor", 
    name: "FlaskIcon",
  }, 
  {
    id: "phosphor:FlipHorizontalIcon", 
    tags: ["phosphor", "flip", "horizontal"], 
    source: "phosphor", 
    name: "FlipHorizontalIcon",
  }, 
  {
    id: "phosphor:FlipVerticalIcon", 
    tags: ["phosphor", "flip", "vertical"], 
    source: "phosphor", 
    name: "FlipVerticalIcon",
  }, 
  {
    id: "phosphor:FloppyDiskBackIcon", 
    tags: ["phosphor", "floppy", "disk", "back"], 
    source: "phosphor", 
    name: "FloppyDiskBackIcon",
  }, 
  {
    id: "phosphor:FloppyDiskIcon", 
    tags: ["phosphor", "floppy", "disk"], 
    source: "phosphor", 
    name: "FloppyDiskIcon",
  }, 
  {
    id: "phosphor:FlowArrowIcon", 
    tags: ["phosphor", "flow", "arrow"], 
    source: "phosphor", 
    name: "FlowArrowIcon",
  }, 
  {
    id: "phosphor:FlowerIcon", 
    tags: ["phosphor", "flower"], 
    source: "phosphor", 
    name: "FlowerIcon",
  }, 
  {
    id: "phosphor:FlowerLotusIcon", 
    tags: ["phosphor", "flower", "lotus"], 
    source: "phosphor", 
    name: "FlowerLotusIcon",
  }, 
  {
    id: "phosphor:FlowerTulipIcon", 
    tags: ["phosphor", "flower", "tulip"], 
    source: "phosphor", 
    name: "FlowerTulipIcon",
  }, 
  {
    id: "phosphor:FlyingSaucerIcon", 
    tags: ["phosphor", "flying", "saucer"], 
    source: "phosphor", 
    name: "FlyingSaucerIcon",
  }, 
  {
    id: "phosphor:FolderDashedIcon", 
    tags: ["phosphor", "folder", "dashed"], 
    source: "phosphor", 
    name: "FolderDashedIcon",
  }, 
  {
    id: "phosphor:FolderDottedIcon", 
    tags: ["phosphor", "folder", "dotted"], 
    source: "phosphor", 
    name: "FolderDottedIcon",
  }, 
  {
    id: "phosphor:FolderIcon", 
    tags: ["phosphor", "folder"], 
    source: "phosphor", 
    name: "FolderIcon",
  }, 
  {
    id: "phosphor:FolderLockIcon", 
    tags: ["phosphor", "folder", "lock"], 
    source: "phosphor", 
    name: "FolderLockIcon",
  }, 
  {
    id: "phosphor:FolderMinusIcon", 
    tags: ["phosphor", "folder", "minus"], 
    source: "phosphor", 
    name: "FolderMinusIcon",
  }, 
  {
    id: "phosphor:FolderNotchIcon", 
    tags: ["phosphor", "folder", "notch"], 
    source: "phosphor", 
    name: "FolderNotchIcon",
  }, 
  {
    id: "phosphor:FolderNotchMinusIcon", 
    tags: ["phosphor", "folder", "notch", "minus"], 
    source: "phosphor", 
    name: "FolderNotchMinusIcon",
  }, 
  {
    id: "phosphor:FolderNotchOpenIcon", 
    tags: ["phosphor", "folder", "notch", "open"], 
    source: "phosphor", 
    name: "FolderNotchOpenIcon",
  }, 
  {
    id: "phosphor:FolderNotchPlusIcon", 
    tags: ["phosphor", "folder", "notch", "plus"], 
    source: "phosphor", 
    name: "FolderNotchPlusIcon",
  }, 
  {
    id: "phosphor:FolderOpenIcon", 
    tags: ["phosphor", "folder", "open"], 
    source: "phosphor", 
    name: "FolderOpenIcon",
  }, 
  {
    id: "phosphor:FolderPlusIcon", 
    tags: ["phosphor", "folder", "plus"], 
    source: "phosphor", 
    name: "FolderPlusIcon",
  }, 
  {
    id: "phosphor:FolderSimpleDashedIcon", 
    tags: ["phosphor", "folder", "simple", "dashed"], 
    source: "phosphor", 
    name: "FolderSimpleDashedIcon",
  }, 
  {
    id: "phosphor:FolderSimpleDottedIcon", 
    tags: ["phosphor", "folder", "simple", "dotted"], 
    source: "phosphor", 
    name: "FolderSimpleDottedIcon",
  }, 
  {
    id: "phosphor:FolderSimpleIcon", 
    tags: ["phosphor", "folder", "simple"], 
    source: "phosphor", 
    name: "FolderSimpleIcon",
  }, 
  {
    id: "phosphor:FolderSimpleLockIcon", 
    tags: ["phosphor", "folder", "simple", "lock"], 
    source: "phosphor", 
    name: "FolderSimpleLockIcon",
  }, 
  {
    id: "phosphor:FolderSimpleMinusIcon", 
    tags: ["phosphor", "folder", "simple", "minus"], 
    source: "phosphor", 
    name: "FolderSimpleMinusIcon",
  }, 
  {
    id: "phosphor:FolderSimplePlusIcon", 
    tags: ["phosphor", "folder", "simple", "plus"], 
    source: "phosphor", 
    name: "FolderSimplePlusIcon",
  }, 
  {
    id: "phosphor:FolderSimpleStarIcon", 
    tags: ["phosphor", "folder", "simple", "star"], 
    source: "phosphor", 
    name: "FolderSimpleStarIcon",
  }, 
  {
    id: "phosphor:FolderSimpleUserIcon", 
    tags: ["phosphor", "folder", "simple", "user"], 
    source: "phosphor", 
    name: "FolderSimpleUserIcon",
  }, 
  {
    id: "phosphor:FolderStarIcon", 
    tags: ["phosphor", "folder", "star"], 
    source: "phosphor", 
    name: "FolderStarIcon",
  }, 
  {
    id: "phosphor:FolderUserIcon", 
    tags: ["phosphor", "folder", "user"], 
    source: "phosphor", 
    name: "FolderUserIcon",
  }, 
  {
    id: "phosphor:FoldersIcon", 
    tags: ["phosphor", "folders"], 
    source: "phosphor", 
    name: "FoldersIcon",
  }, 
  {
    id: "phosphor:FootballHelmetIcon", 
    tags: ["phosphor", "football", "helmet"], 
    source: "phosphor", 
    name: "FootballHelmetIcon",
  }, 
  {
    id: "phosphor:FootballIcon", 
    tags: ["phosphor", "football"], 
    source: "phosphor", 
    name: "FootballIcon",
  }, 
  {
    id: "phosphor:FootprintsIcon", 
    tags: ["phosphor", "footprints"], 
    source: "phosphor", 
    name: "FootprintsIcon",
  }, 
  {
    id: "phosphor:ForkKnifeIcon", 
    tags: ["phosphor", "fork", "knife"], 
    source: "phosphor", 
    name: "ForkKnifeIcon",
  }, 
  {
    id: "phosphor:FourKIcon", 
    tags: ["phosphor", "four"], 
    source: "phosphor", 
    name: "FourKIcon",
  }, 
  {
    id: "phosphor:FrameCornersIcon", 
    tags: ["phosphor", "frame", "corners"], 
    source: "phosphor", 
    name: "FrameCornersIcon",
  }, 
  {
    id: "phosphor:FramerLogoIcon", 
    tags: ["phosphor", "framer", "logo"], 
    source: "phosphor", 
    name: "FramerLogoIcon",
  }, 
  {
    id: "phosphor:FunctionIcon", 
    tags: ["phosphor", "function"], 
    source: "phosphor", 
    name: "FunctionIcon",
  }, 
  {
    id: "phosphor:FunnelIcon", 
    tags: ["phosphor", "funnel"], 
    source: "phosphor", 
    name: "FunnelIcon",
  }, 
  {
    id: "phosphor:FunnelSimpleIcon", 
    tags: ["phosphor", "funnel", "simple"], 
    source: "phosphor", 
    name: "FunnelSimpleIcon",
  }, 
  {
    id: "phosphor:FunnelSimpleXIcon", 
    tags: ["phosphor", "funnel", "simple"], 
    source: "phosphor", 
    name: "FunnelSimpleXIcon",
  }, 
  {
    id: "phosphor:FunnelXIcon", 
    tags: ["phosphor", "funnel"], 
    source: "phosphor", 
    name: "FunnelXIcon",
  }, 
  {
    id: "phosphor:GameControllerIcon", 
    tags: ["phosphor", "game", "controller"], 
    source: "phosphor", 
    name: "GameControllerIcon",
  }, 
  {
    id: "phosphor:GarageIcon", 
    tags: ["phosphor", "garage"], 
    source: "phosphor", 
    name: "GarageIcon",
  }, 
  {
    id: "phosphor:GasCanIcon", 
    tags: ["phosphor", "gas", "can"], 
    source: "phosphor", 
    name: "GasCanIcon",
  }, 
  {
    id: "phosphor:GasPumpIcon", 
    tags: ["phosphor", "gas", "pump"], 
    source: "phosphor", 
    name: "GasPumpIcon",
  }, 
  {
    id: "phosphor:GaugeIcon", 
    tags: ["phosphor", "gauge"], 
    source: "phosphor", 
    name: "GaugeIcon",
  }, 
  {
    id: "phosphor:GavelIcon", 
    tags: ["phosphor", "gavel"], 
    source: "phosphor", 
    name: "GavelIcon",
  }, 
  {
    id: "phosphor:GearFineIcon", 
    tags: ["phosphor", "gear", "fine"], 
    source: "phosphor", 
    name: "GearFineIcon",
  }, 
  {
    id: "phosphor:GearIcon", 
    tags: ["phosphor", "gear"], 
    source: "phosphor", 
    name: "GearIcon",
  }, 
  {
    id: "phosphor:GearSixIcon", 
    tags: ["phosphor", "gear", "six"], 
    source: "phosphor", 
    name: "GearSixIcon",
  }, 
  {
    id: "phosphor:GenderFemaleIcon", 
    tags: ["phosphor", "gender", "female"], 
    source: "phosphor", 
    name: "GenderFemaleIcon",
  }, 
  {
    id: "phosphor:GenderIntersexIcon", 
    tags: ["phosphor", "gender", "intersex"], 
    source: "phosphor", 
    name: "GenderIntersexIcon",
  }, 
  {
    id: "phosphor:GenderMaleIcon", 
    tags: ["phosphor", "gender", "male"], 
    source: "phosphor", 
    name: "GenderMaleIcon",
  }, 
  {
    id: "phosphor:GenderNeuterIcon", 
    tags: ["phosphor", "gender", "neuter"], 
    source: "phosphor", 
    name: "GenderNeuterIcon",
  }, 
  {
    id: "phosphor:GenderNonbinaryIcon", 
    tags: ["phosphor", "gender", "nonbinary"], 
    source: "phosphor", 
    name: "GenderNonbinaryIcon",
  }, 
  {
    id: "phosphor:GenderTransgenderIcon", 
    tags: ["phosphor", "gender", "transgender"], 
    source: "phosphor", 
    name: "GenderTransgenderIcon",
  }, 
  {
    id: "phosphor:GhostIcon", 
    tags: ["phosphor", "ghost"], 
    source: "phosphor", 
    name: "GhostIcon",
  }, 
  {
    id: "phosphor:GifIcon", 
    tags: ["phosphor", "gif"], 
    source: "phosphor", 
    name: "GifIcon",
  }, 
  {
    id: "phosphor:GiftIcon", 
    tags: ["phosphor", "gift"], 
    source: "phosphor", 
    name: "GiftIcon",
  }, 
  {
    id: "phosphor:GitBranchIcon", 
    tags: ["phosphor", "git", "branch"], 
    source: "phosphor", 
    name: "GitBranchIcon",
  }, 
  {
    id: "phosphor:GitCommitIcon", 
    tags: ["phosphor", "git", "commit"], 
    source: "phosphor", 
    name: "GitCommitIcon",
  }, 
  {
    id: "phosphor:GitDiffIcon", 
    tags: ["phosphor", "git", "diff"], 
    source: "phosphor", 
    name: "GitDiffIcon",
  }, 
  {
    id: "phosphor:GitForkIcon", 
    tags: ["phosphor", "git", "fork"], 
    source: "phosphor", 
    name: "GitForkIcon",
  }, 
  {
    id: "phosphor:GitMergeIcon", 
    tags: ["phosphor", "git", "merge"], 
    source: "phosphor", 
    name: "GitMergeIcon",
  }, 
  {
    id: "phosphor:GitPullRequestIcon", 
    tags: ["phosphor", "git", "pull", "request"], 
    source: "phosphor", 
    name: "GitPullRequestIcon",
  }, 
  {
    id: "phosphor:GithubLogoIcon", 
    tags: ["phosphor", "github", "logo"], 
    source: "phosphor", 
    name: "GithubLogoIcon",
  }, 
  {
    id: "phosphor:GitlabLogoIcon", 
    tags: ["phosphor", "gitlab", "logo"], 
    source: "phosphor", 
    name: "GitlabLogoIcon",
  }, 
  {
    id: "phosphor:GitlabLogoSimpleIcon", 
    tags: ["phosphor", "gitlab", "logo", "simple"], 
    source: "phosphor", 
    name: "GitlabLogoSimpleIcon",
  }, 
  {
    id: "phosphor:GlobeHemisphereEastIcon", 
    tags: ["phosphor", "globe", "hemisphere", "east"], 
    source: "phosphor", 
    name: "GlobeHemisphereEastIcon",
  }, 
  {
    id: "phosphor:GlobeHemisphereWestIcon", 
    tags: ["phosphor", "globe", "hemisphere", "west"], 
    source: "phosphor", 
    name: "GlobeHemisphereWestIcon",
  }, 
  {
    id: "phosphor:GlobeIcon", 
    tags: ["phosphor", "globe"], 
    source: "phosphor", 
    name: "GlobeIcon",
  }, 
  {
    id: "phosphor:GlobeSimpleIcon", 
    tags: ["phosphor", "globe", "simple"], 
    source: "phosphor", 
    name: "GlobeSimpleIcon",
  }, 
  {
    id: "phosphor:GlobeSimpleXIcon", 
    tags: ["phosphor", "globe", "simple"], 
    source: "phosphor", 
    name: "GlobeSimpleXIcon",
  }, 
  {
    id: "phosphor:GlobeStandIcon", 
    tags: ["phosphor", "globe", "stand"], 
    source: "phosphor", 
    name: "GlobeStandIcon",
  }, 
  {
    id: "phosphor:GlobeXIcon", 
    tags: ["phosphor", "globe"], 
    source: "phosphor", 
    name: "GlobeXIcon",
  }, 
  {
    id: "phosphor:GogglesIcon", 
    tags: ["phosphor", "goggles"], 
    source: "phosphor", 
    name: "GogglesIcon",
  }, 
  {
    id: "phosphor:GolfIcon", 
    tags: ["phosphor", "golf"], 
    source: "phosphor", 
    name: "GolfIcon",
  }, 
  {
    id: "phosphor:GoodreadsLogoIcon", 
    tags: ["phosphor", "goodreads", "logo"], 
    source: "phosphor", 
    name: "GoodreadsLogoIcon",
  }, 
  {
    id: "phosphor:GoogleCardboardLogoIcon", 
    tags: ["phosphor", "google", "cardboard", "logo"], 
    source: "phosphor", 
    name: "GoogleCardboardLogoIcon",
  }, 
  {
    id: "phosphor:GoogleChromeLogoIcon", 
    tags: ["phosphor", "google", "chrome", "logo"], 
    source: "phosphor", 
    name: "GoogleChromeLogoIcon",
  }, 
  {
    id: "phosphor:GoogleDriveLogoIcon", 
    tags: ["phosphor", "google", "drive", "logo"], 
    source: "phosphor", 
    name: "GoogleDriveLogoIcon",
  }, 
  {
    id: "phosphor:GoogleLogoIcon", 
    tags: ["phosphor", "google", "logo"], 
    source: "phosphor", 
    name: "GoogleLogoIcon",
  }, 
  {
    id: "phosphor:GooglePhotosLogoIcon", 
    tags: ["phosphor", "google", "photos", "logo"], 
    source: "phosphor", 
    name: "GooglePhotosLogoIcon",
  }, 
  {
    id: "phosphor:GooglePlayLogoIcon", 
    tags: ["phosphor", "google", "play", "logo"], 
    source: "phosphor", 
    name: "GooglePlayLogoIcon",
  }, 
  {
    id: "phosphor:GooglePodcastsLogoIcon", 
    tags: ["phosphor", "google", "podcasts", "logo"], 
    source: "phosphor", 
    name: "GooglePodcastsLogoIcon",
  }, 
  {
    id: "phosphor:GpsFixIcon", 
    tags: ["phosphor", "gps", "fix"], 
    source: "phosphor", 
    name: "GpsFixIcon",
  }, 
  {
    id: "phosphor:GpsIcon", 
    tags: ["phosphor", "gps"], 
    source: "phosphor", 
    name: "GpsIcon",
  }, 
  {
    id: "phosphor:GpsSlashIcon", 
    tags: ["phosphor", "gps", "slash"], 
    source: "phosphor", 
    name: "GpsSlashIcon",
  }, 
  {
    id: "phosphor:GradientIcon", 
    tags: ["phosphor", "gradient"], 
    source: "phosphor", 
    name: "GradientIcon",
  }, 
  {
    id: "phosphor:GraduationCapIcon", 
    tags: ["phosphor", "graduation", "cap"], 
    source: "phosphor", 
    name: "GraduationCapIcon",
  }, 
  {
    id: "phosphor:GrainsIcon", 
    tags: ["phosphor", "grains"], 
    source: "phosphor", 
    name: "GrainsIcon",
  }, 
  {
    id: "phosphor:GrainsSlashIcon", 
    tags: ["phosphor", "grains", "slash"], 
    source: "phosphor", 
    name: "GrainsSlashIcon",
  }, 
  {
    id: "phosphor:GraphIcon", 
    tags: ["phosphor", "graph"], 
    source: "phosphor", 
    name: "GraphIcon",
  }, 
  {
    id: "phosphor:GraphicsCardIcon", 
    tags: ["phosphor", "graphics", "card"], 
    source: "phosphor", 
    name: "GraphicsCardIcon",
  }, 
  {
    id: "phosphor:GreaterThanIcon", 
    tags: ["phosphor", "greater", "than"], 
    source: "phosphor", 
    name: "GreaterThanIcon",
  }, 
  {
    id: "phosphor:GreaterThanOrEqualIcon", 
    tags: ["phosphor", "greater", "than", "or", "equal"], 
    source: "phosphor", 
    name: "GreaterThanOrEqualIcon",
  }, 
  {
    id: "phosphor:GridFourIcon", 
    tags: ["phosphor", "grid", "four"], 
    source: "phosphor", 
    name: "GridFourIcon",
  }, 
  {
    id: "phosphor:GridNineIcon", 
    tags: ["phosphor", "grid", "nine"], 
    source: "phosphor", 
    name: "GridNineIcon",
  }, 
  {
    id: "phosphor:GuitarIcon", 
    tags: ["phosphor", "guitar"], 
    source: "phosphor", 
    name: "GuitarIcon",
  }, 
  {
    id: "phosphor:HairDryerIcon", 
    tags: ["phosphor", "hair", "dryer"], 
    source: "phosphor", 
    name: "HairDryerIcon",
  }, 
  {
    id: "phosphor:HamburgerIcon", 
    tags: ["phosphor", "hamburger"], 
    source: "phosphor", 
    name: "HamburgerIcon",
  }, 
  {
    id: "phosphor:HammerIcon", 
    tags: ["phosphor", "hammer"], 
    source: "phosphor", 
    name: "HammerIcon",
  }, 
  {
    id: "phosphor:HandArrowDownIcon", 
    tags: ["phosphor", "hand", "arrow", "down"], 
    source: "phosphor", 
    name: "HandArrowDownIcon",
  }, 
  {
    id: "phosphor:HandArrowUpIcon", 
    tags: ["phosphor", "hand", "arrow", "up"], 
    source: "phosphor", 
    name: "HandArrowUpIcon",
  }, 
  {
    id: "phosphor:HandCoinsIcon", 
    tags: ["phosphor", "hand", "coins"], 
    source: "phosphor", 
    name: "HandCoinsIcon",
  }, 
  {
    id: "phosphor:HandDepositIcon", 
    tags: ["phosphor", "hand", "deposit"], 
    source: "phosphor", 
    name: "HandDepositIcon",
  }, 
  {
    id: "phosphor:HandEyeIcon", 
    tags: ["phosphor", "hand", "eye"], 
    source: "phosphor", 
    name: "HandEyeIcon",
  }, 
  {
    id: "phosphor:HandFistIcon", 
    tags: ["phosphor", "hand", "fist"], 
    source: "phosphor", 
    name: "HandFistIcon",
  }, 
  {
    id: "phosphor:HandGrabbingIcon", 
    tags: ["phosphor", "hand", "grabbing"], 
    source: "phosphor", 
    name: "HandGrabbingIcon",
  }, 
  {
    id: "phosphor:HandHeartIcon", 
    tags: ["phosphor", "hand", "heart"], 
    source: "phosphor", 
    name: "HandHeartIcon",
  }, 
  {
    id: "phosphor:HandIcon", 
    tags: ["phosphor", "hand"], 
    source: "phosphor", 
    name: "HandIcon",
  }, 
  {
    id: "phosphor:HandPalmIcon", 
    tags: ["phosphor", "hand", "palm"], 
    source: "phosphor", 
    name: "HandPalmIcon",
  }, 
  {
    id: "phosphor:HandPeaceIcon", 
    tags: ["phosphor", "hand", "peace"], 
    source: "phosphor", 
    name: "HandPeaceIcon",
  }, 
  {
    id: "phosphor:HandPointingIcon", 
    tags: ["phosphor", "hand", "pointing"], 
    source: "phosphor", 
    name: "HandPointingIcon",
  }, 
  {
    id: "phosphor:HandSoapIcon", 
    tags: ["phosphor", "hand", "soap"], 
    source: "phosphor", 
    name: "HandSoapIcon",
  }, 
  {
    id: "phosphor:HandSwipeLeftIcon", 
    tags: ["phosphor", "hand", "swipe", "left"], 
    source: "phosphor", 
    name: "HandSwipeLeftIcon",
  }, 
  {
    id: "phosphor:HandSwipeRightIcon", 
    tags: ["phosphor", "hand", "swipe", "right"], 
    source: "phosphor", 
    name: "HandSwipeRightIcon",
  }, 
  {
    id: "phosphor:HandTapIcon", 
    tags: ["phosphor", "hand", "tap"], 
    source: "phosphor", 
    name: "HandTapIcon",
  }, 
  {
    id: "phosphor:HandWavingIcon", 
    tags: ["phosphor", "hand", "waving"], 
    source: "phosphor", 
    name: "HandWavingIcon",
  }, 
  {
    id: "phosphor:HandWithdrawIcon", 
    tags: ["phosphor", "hand", "withdraw"], 
    source: "phosphor", 
    name: "HandWithdrawIcon",
  }, 
  {
    id: "phosphor:HandbagIcon", 
    tags: ["phosphor", "handbag"], 
    source: "phosphor", 
    name: "HandbagIcon",
  }, 
  {
    id: "phosphor:HandbagSimpleIcon", 
    tags: ["phosphor", "handbag", "simple"], 
    source: "phosphor", 
    name: "HandbagSimpleIcon",
  }, 
  {
    id: "phosphor:HandsClappingIcon", 
    tags: ["phosphor", "hands", "clapping"], 
    source: "phosphor", 
    name: "HandsClappingIcon",
  }, 
  {
    id: "phosphor:HandsPrayingIcon", 
    tags: ["phosphor", "hands", "praying"], 
    source: "phosphor", 
    name: "HandsPrayingIcon",
  }, 
  {
    id: "phosphor:HandshakeIcon", 
    tags: ["phosphor", "handshake"], 
    source: "phosphor", 
    name: "HandshakeIcon",
  }, 
  {
    id: "phosphor:HardDriveIcon", 
    tags: ["phosphor", "hard", "drive"], 
    source: "phosphor", 
    name: "HardDriveIcon",
  }, 
  {
    id: "phosphor:HardDrivesIcon", 
    tags: ["phosphor", "hard", "drives"], 
    source: "phosphor", 
    name: "HardDrivesIcon",
  }, 
  {
    id: "phosphor:HardHatIcon", 
    tags: ["phosphor", "hard", "hat"], 
    source: "phosphor", 
    name: "HardHatIcon",
  }, 
  {
    id: "phosphor:HashIcon", 
    tags: ["phosphor", "hash"], 
    source: "phosphor", 
    name: "HashIcon",
  }, 
  {
    id: "phosphor:HashStraightIcon", 
    tags: ["phosphor", "hash", "straight"], 
    source: "phosphor", 
    name: "HashStraightIcon",
  }, 
  {
    id: "phosphor:HeadCircuitIcon", 
    tags: ["phosphor", "head", "circuit"], 
    source: "phosphor", 
    name: "HeadCircuitIcon",
  }, 
  {
    id: "phosphor:HeadlightsIcon", 
    tags: ["phosphor", "headlights"], 
    source: "phosphor", 
    name: "HeadlightsIcon",
  }, 
  {
    id: "phosphor:HeadphonesIcon", 
    tags: ["phosphor", "headphones"], 
    source: "phosphor", 
    name: "HeadphonesIcon",
  }, 
  {
    id: "phosphor:HeadsetIcon", 
    tags: ["phosphor", "headset"], 
    source: "phosphor", 
    name: "HeadsetIcon",
  }, 
  {
    id: "phosphor:HeartBreakIcon", 
    tags: ["phosphor", "heart", "break"], 
    source: "phosphor", 
    name: "HeartBreakIcon",
  }, 
  {
    id: "phosphor:HeartHalfIcon", 
    tags: ["phosphor", "heart", "half"], 
    source: "phosphor", 
    name: "HeartHalfIcon",
  }, 
  {
    id: "phosphor:HeartIcon", 
    tags: ["phosphor", "heart"], 
    source: "phosphor", 
    name: "HeartIcon",
  }, 
  {
    id: "phosphor:HeartStraightBreakIcon", 
    tags: ["phosphor", "heart", "straight", "break"], 
    source: "phosphor", 
    name: "HeartStraightBreakIcon",
  }, 
  {
    id: "phosphor:HeartStraightIcon", 
    tags: ["phosphor", "heart", "straight"], 
    source: "phosphor", 
    name: "HeartStraightIcon",
  }, 
  {
    id: "phosphor:HeartbeatIcon", 
    tags: ["phosphor", "heartbeat"], 
    source: "phosphor", 
    name: "HeartbeatIcon",
  }, 
  {
    id: "phosphor:HexagonIcon", 
    tags: ["phosphor", "hexagon"], 
    source: "phosphor", 
    name: "HexagonIcon",
  }, 
  {
    id: "phosphor:HighDefinitionIcon", 
    tags: ["phosphor", "high", "definition"], 
    source: "phosphor", 
    name: "HighDefinitionIcon",
  }, 
  {
    id: "phosphor:HighHeelIcon", 
    tags: ["phosphor", "high", "heel"], 
    source: "phosphor", 
    name: "HighHeelIcon",
  }, 
  {
    id: "phosphor:HighlighterCircleIcon", 
    tags: ["phosphor", "highlighter", "circle"], 
    source: "phosphor", 
    name: "HighlighterCircleIcon",
  }, 
  {
    id: "phosphor:HighlighterIcon", 
    tags: ["phosphor", "highlighter"], 
    source: "phosphor", 
    name: "HighlighterIcon",
  }, 
  {
    id: "phosphor:HockeyIcon", 
    tags: ["phosphor", "hockey"], 
    source: "phosphor", 
    name: "HockeyIcon",
  }, 
  {
    id: "phosphor:HoodieIcon", 
    tags: ["phosphor", "hoodie"], 
    source: "phosphor", 
    name: "HoodieIcon",
  }, 
  {
    id: "phosphor:HorseIcon", 
    tags: ["phosphor", "horse"], 
    source: "phosphor", 
    name: "HorseIcon",
  }, 
  {
    id: "phosphor:HospitalIcon", 
    tags: ["phosphor", "hospital"], 
    source: "phosphor", 
    name: "HospitalIcon",
  }, 
  {
    id: "phosphor:HourglassHighIcon", 
    tags: ["phosphor", "hourglass", "high"], 
    source: "phosphor", 
    name: "HourglassHighIcon",
  }, 
  {
    id: "phosphor:HourglassIcon", 
    tags: ["phosphor", "hourglass"], 
    source: "phosphor", 
    name: "HourglassIcon",
  }, 
  {
    id: "phosphor:HourglassLowIcon", 
    tags: ["phosphor", "hourglass", "low"], 
    source: "phosphor", 
    name: "HourglassLowIcon",
  }, 
  {
    id: "phosphor:HourglassMediumIcon", 
    tags: ["phosphor", "hourglass", "medium"], 
    source: "phosphor", 
    name: "HourglassMediumIcon",
  }, 
  {
    id: "phosphor:HourglassSimpleHighIcon", 
    tags: ["phosphor", "hourglass", "simple", "high"], 
    source: "phosphor", 
    name: "HourglassSimpleHighIcon",
  }, 
  {
    id: "phosphor:HourglassSimpleIcon", 
    tags: ["phosphor", "hourglass", "simple"], 
    source: "phosphor", 
    name: "HourglassSimpleIcon",
  }, 
  {
    id: "phosphor:HourglassSimpleLowIcon", 
    tags: ["phosphor", "hourglass", "simple", "low"], 
    source: "phosphor", 
    name: "HourglassSimpleLowIcon",
  }, 
  {
    id: "phosphor:HourglassSimpleMediumIcon", 
    tags: ["phosphor", "hourglass", "simple", "medium"], 
    source: "phosphor", 
    name: "HourglassSimpleMediumIcon",
  }, 
  {
    id: "phosphor:HouseIcon", 
    tags: ["phosphor", "house"], 
    source: "phosphor", 
    name: "HouseIcon",
  }, 
  {
    id: "phosphor:HouseLineIcon", 
    tags: ["phosphor", "house", "line"], 
    source: "phosphor", 
    name: "HouseLineIcon",
  }, 
  {
    id: "phosphor:HouseSimpleIcon", 
    tags: ["phosphor", "house", "simple"], 
    source: "phosphor", 
    name: "HouseSimpleIcon",
  }, 
  {
    id: "phosphor:HurricaneIcon", 
    tags: ["phosphor", "hurricane"], 
    source: "phosphor", 
    name: "HurricaneIcon",
  }, 
  {
    id: "phosphor:IceCreamIcon", 
    tags: ["phosphor", "ice", "cream"], 
    source: "phosphor", 
    name: "IceCreamIcon",
  }, 
  {
    id: "phosphor:IdentificationBadgeIcon", 
    tags: ["phosphor", "identification", "badge"], 
    source: "phosphor", 
    name: "IdentificationBadgeIcon",
  }, 
  {
    id: "phosphor:IdentificationCardIcon", 
    tags: ["phosphor", "identification", "card"], 
    source: "phosphor", 
    name: "IdentificationCardIcon",
  }, 
  {
    id: "phosphor:ImageBrokenIcon", 
    tags: ["phosphor", "image", "broken"], 
    source: "phosphor", 
    name: "ImageBrokenIcon",
  }, 
  {
    id: "phosphor:ImageIcon", 
    tags: ["phosphor", "image"], 
    source: "phosphor", 
    name: "ImageIcon",
  }, 
  {
    id: "phosphor:ImageSquareIcon", 
    tags: ["phosphor", "image", "square"], 
    source: "phosphor", 
    name: "ImageSquareIcon",
  }, 
  {
    id: "phosphor:ImagesIcon", 
    tags: ["phosphor", "images"], 
    source: "phosphor", 
    name: "ImagesIcon",
  }, 
  {
    id: "phosphor:ImagesSquareIcon", 
    tags: ["phosphor", "images", "square"], 
    source: "phosphor", 
    name: "ImagesSquareIcon",
  }, 
  {
    id: "phosphor:InfinityIcon", 
    tags: ["phosphor", "infinity"], 
    source: "phosphor", 
    name: "InfinityIcon",
  }, 
  {
    id: "phosphor:InfoIcon", 
    tags: ["phosphor", "info"], 
    source: "phosphor", 
    name: "InfoIcon",
  }, 
  {
    id: "phosphor:InstagramLogoIcon", 
    tags: ["phosphor", "instagram", "logo"], 
    source: "phosphor", 
    name: "InstagramLogoIcon",
  }, 
  {
    id: "phosphor:IntersectIcon", 
    tags: ["phosphor", "intersect"], 
    source: "phosphor", 
    name: "IntersectIcon",
  }, 
  {
    id: "phosphor:IntersectSquareIcon", 
    tags: ["phosphor", "intersect", "square"], 
    source: "phosphor", 
    name: "IntersectSquareIcon",
  }, 
  {
    id: "phosphor:IntersectThreeIcon", 
    tags: ["phosphor", "intersect", "three"], 
    source: "phosphor", 
    name: "IntersectThreeIcon",
  }, 
  {
    id: "phosphor:IntersectionIcon", 
    tags: ["phosphor", "intersection"], 
    source: "phosphor", 
    name: "IntersectionIcon",
  }, 
  {
    id: "phosphor:InvoiceIcon", 
    tags: ["phosphor", "invoice"], 
    source: "phosphor", 
    name: "InvoiceIcon",
  }, 
  {
    id: "phosphor:IslandIcon", 
    tags: ["phosphor", "island"], 
    source: "phosphor", 
    name: "IslandIcon",
  }, 
  {
    id: "phosphor:JarIcon", 
    tags: ["phosphor", "jar"], 
    source: "phosphor", 
    name: "JarIcon",
  }, 
  {
    id: "phosphor:JarLabelIcon", 
    tags: ["phosphor", "jar", "label"], 
    source: "phosphor", 
    name: "JarLabelIcon",
  }, 
  {
    id: "phosphor:JeepIcon", 
    tags: ["phosphor", "jeep"], 
    source: "phosphor", 
    name: "JeepIcon",
  }, 
  {
    id: "phosphor:JoystickIcon", 
    tags: ["phosphor", "joystick"], 
    source: "phosphor", 
    name: "JoystickIcon",
  }, 
  {
    id: "phosphor:KanbanIcon", 
    tags: ["phosphor", "kanban"], 
    source: "phosphor", 
    name: "KanbanIcon",
  }, 
  {
    id: "phosphor:KeyIcon", 
    tags: ["phosphor", "key"], 
    source: "phosphor", 
    name: "KeyIcon",
  }, 
  {
    id: "phosphor:KeyReturnIcon", 
    tags: ["phosphor", "key", "return"], 
    source: "phosphor", 
    name: "KeyReturnIcon",
  }, 
  {
    id: "phosphor:KeyboardIcon", 
    tags: ["phosphor", "keyboard"], 
    source: "phosphor", 
    name: "KeyboardIcon",
  }, 
  {
    id: "phosphor:KeyholeIcon", 
    tags: ["phosphor", "keyhole"], 
    source: "phosphor", 
    name: "KeyholeIcon",
  }, 
  {
    id: "phosphor:KnifeIcon", 
    tags: ["phosphor", "knife"], 
    source: "phosphor", 
    name: "KnifeIcon",
  }, 
  {
    id: "phosphor:LadderIcon", 
    tags: ["phosphor", "ladder"], 
    source: "phosphor", 
    name: "LadderIcon",
  }, 
  {
    id: "phosphor:LadderSimpleIcon", 
    tags: ["phosphor", "ladder", "simple"], 
    source: "phosphor", 
    name: "LadderSimpleIcon",
  }, 
  {
    id: "phosphor:LampIcon", 
    tags: ["phosphor", "lamp"], 
    source: "phosphor", 
    name: "LampIcon",
  }, 
  {
    id: "phosphor:LampPendantIcon", 
    tags: ["phosphor", "lamp", "pendant"], 
    source: "phosphor", 
    name: "LampPendantIcon",
  }, 
  {
    id: "phosphor:LaptopIcon", 
    tags: ["phosphor", "laptop"], 
    source: "phosphor", 
    name: "LaptopIcon",
  }, 
  {
    id: "phosphor:LassoIcon", 
    tags: ["phosphor", "lasso"], 
    source: "phosphor", 
    name: "LassoIcon",
  }, 
  {
    id: "phosphor:LastfmLogoIcon", 
    tags: ["phosphor", "lastfm", "logo"], 
    source: "phosphor", 
    name: "LastfmLogoIcon",
  }, 
  {
    id: "phosphor:LayoutIcon", 
    tags: ["phosphor", "layout"], 
    source: "phosphor", 
    name: "LayoutIcon",
  }, 
  {
    id: "phosphor:LeafIcon", 
    tags: ["phosphor", "leaf"], 
    source: "phosphor", 
    name: "LeafIcon",
  }, 
  {
    id: "phosphor:LecternIcon", 
    tags: ["phosphor", "lectern"], 
    source: "phosphor", 
    name: "LecternIcon",
  }, 
  {
    id: "phosphor:LegoIcon", 
    tags: ["phosphor", "lego"], 
    source: "phosphor", 
    name: "LegoIcon",
  }, 
  {
    id: "phosphor:LegoSmileyIcon", 
    tags: ["phosphor", "lego", "smiley"], 
    source: "phosphor", 
    name: "LegoSmileyIcon",
  }, 
  {
    id: "phosphor:LemniscateIcon", 
    tags: ["phosphor", "lemniscate"], 
    source: "phosphor", 
    name: "LemniscateIcon",
  }, 
  {
    id: "phosphor:LessThanIcon", 
    tags: ["phosphor", "less", "than"], 
    source: "phosphor", 
    name: "LessThanIcon",
  }, 
  {
    id: "phosphor:LessThanOrEqualIcon", 
    tags: ["phosphor", "less", "than", "or", "equal"], 
    source: "phosphor", 
    name: "LessThanOrEqualIcon",
  }, 
  {
    id: "phosphor:LetterCircleHIcon", 
    tags: ["phosphor", "letter", "circle"], 
    source: "phosphor", 
    name: "LetterCircleHIcon",
  }, 
  {
    id: "phosphor:LetterCirclePIcon", 
    tags: ["phosphor", "letter", "circle"], 
    source: "phosphor", 
    name: "LetterCirclePIcon",
  }, 
  {
    id: "phosphor:LetterCircleVIcon", 
    tags: ["phosphor", "letter", "circle"], 
    source: "phosphor", 
    name: "LetterCircleVIcon",
  }, 
  {
    id: "phosphor:LifebuoyIcon", 
    tags: ["phosphor", "lifebuoy"], 
    source: "phosphor", 
    name: "LifebuoyIcon",
  }, 
  {
    id: "phosphor:LightbulbFilamentIcon", 
    tags: ["phosphor", "lightbulb", "filament"], 
    source: "phosphor", 
    name: "LightbulbFilamentIcon",
  }, 
  {
    id: "phosphor:LightbulbIcon", 
    tags: ["phosphor", "lightbulb"], 
    source: "phosphor", 
    name: "LightbulbIcon",
  }, 
  {
    id: "phosphor:LighthouseIcon", 
    tags: ["phosphor", "lighthouse"], 
    source: "phosphor", 
    name: "LighthouseIcon",
  }, 
  {
    id: "phosphor:LightningAIcon", 
    tags: ["phosphor", "lightning"], 
    source: "phosphor", 
    name: "LightningAIcon",
  }, 
  {
    id: "phosphor:LightningIcon", 
    tags: ["phosphor", "lightning"], 
    source: "phosphor", 
    name: "LightningIcon",
  }, 
  {
    id: "phosphor:LightningSlashIcon", 
    tags: ["phosphor", "lightning", "slash"], 
    source: "phosphor", 
    name: "LightningSlashIcon",
  }, 
  {
    id: "phosphor:LineSegmentIcon", 
    tags: ["phosphor", "line", "segment"], 
    source: "phosphor", 
    name: "LineSegmentIcon",
  }, 
  {
    id: "phosphor:LineSegmentsIcon", 
    tags: ["phosphor", "line", "segments"], 
    source: "phosphor", 
    name: "LineSegmentsIcon",
  }, 
  {
    id: "phosphor:LineVerticalIcon", 
    tags: ["phosphor", "line", "vertical"], 
    source: "phosphor", 
    name: "LineVerticalIcon",
  }, 
  {
    id: "phosphor:LinkBreakIcon", 
    tags: ["phosphor", "link", "break"], 
    source: "phosphor", 
    name: "LinkBreakIcon",
  }, 
  {
    id: "phosphor:LinkIcon", 
    tags: ["phosphor", "link"], 
    source: "phosphor", 
    name: "LinkIcon",
  }, 
  {
    id: "phosphor:LinkSimpleBreakIcon", 
    tags: ["phosphor", "link", "simple", "break"], 
    source: "phosphor", 
    name: "LinkSimpleBreakIcon",
  }, 
  {
    id: "phosphor:LinkSimpleHorizontalBreakIcon", 
    tags: ["phosphor", "link", "simple", "horizontal", "break"], 
    source: "phosphor", 
    name: "LinkSimpleHorizontalBreakIcon",
  }, 
  {
    id: "phosphor:LinkSimpleHorizontalIcon", 
    tags: ["phosphor", "link", "simple", "horizontal"], 
    source: "phosphor", 
    name: "LinkSimpleHorizontalIcon",
  }, 
  {
    id: "phosphor:LinkSimpleIcon", 
    tags: ["phosphor", "link", "simple"], 
    source: "phosphor", 
    name: "LinkSimpleIcon",
  }, 
  {
    id: "phosphor:LinkedinLogoIcon", 
    tags: ["phosphor", "linkedin", "logo"], 
    source: "phosphor", 
    name: "LinkedinLogoIcon",
  }, 
  {
    id: "phosphor:LinktreeLogoIcon", 
    tags: ["phosphor", "linktree", "logo"], 
    source: "phosphor", 
    name: "LinktreeLogoIcon",
  }, 
  {
    id: "phosphor:LinuxLogoIcon", 
    tags: ["phosphor", "linux", "logo"], 
    source: "phosphor", 
    name: "LinuxLogoIcon",
  }, 
  {
    id: "phosphor:ListBulletsIcon", 
    tags: ["phosphor", "list", "bullets"], 
    source: "phosphor", 
    name: "ListBulletsIcon",
  }, 
  {
    id: "phosphor:ListChecksIcon", 
    tags: ["phosphor", "list", "checks"], 
    source: "phosphor", 
    name: "ListChecksIcon",
  }, 
  {
    id: "phosphor:ListDashesIcon", 
    tags: ["phosphor", "list", "dashes"], 
    source: "phosphor", 
    name: "ListDashesIcon",
  }, 
  {
    id: "phosphor:ListHeartIcon", 
    tags: ["phosphor", "list", "heart"], 
    source: "phosphor", 
    name: "ListHeartIcon",
  }, 
  {
    id: "phosphor:ListIcon", 
    tags: ["phosphor", "list"], 
    source: "phosphor", 
    name: "ListIcon",
  }, 
  {
    id: "phosphor:ListMagnifyingGlassIcon", 
    tags: ["phosphor", "list", "magnifying", "glass"], 
    source: "phosphor", 
    name: "ListMagnifyingGlassIcon",
  }, 
  {
    id: "phosphor:ListNumbersIcon", 
    tags: ["phosphor", "list", "numbers"], 
    source: "phosphor", 
    name: "ListNumbersIcon",
  }, 
  {
    id: "phosphor:ListPlusIcon", 
    tags: ["phosphor", "list", "plus"], 
    source: "phosphor", 
    name: "ListPlusIcon",
  }, 
  {
    id: "phosphor:ListStarIcon", 
    tags: ["phosphor", "list", "star"], 
    source: "phosphor", 
    name: "ListStarIcon",
  }, 
  {
    id: "phosphor:LockIcon", 
    tags: ["phosphor", "lock"], 
    source: "phosphor", 
    name: "LockIcon",
  }, 
  {
    id: "phosphor:LockKeyIcon", 
    tags: ["phosphor", "lock", "key"], 
    source: "phosphor", 
    name: "LockKeyIcon",
  }, 
  {
    id: "phosphor:LockKeyOpenIcon", 
    tags: ["phosphor", "lock", "key", "open"], 
    source: "phosphor", 
    name: "LockKeyOpenIcon",
  }, 
  {
    id: "phosphor:LockLaminatedIcon", 
    tags: ["phosphor", "lock", "laminated"], 
    source: "phosphor", 
    name: "LockLaminatedIcon",
  }, 
  {
    id: "phosphor:LockLaminatedOpenIcon", 
    tags: ["phosphor", "lock", "laminated", "open"], 
    source: "phosphor", 
    name: "LockLaminatedOpenIcon",
  }, 
  {
    id: "phosphor:LockOpenIcon", 
    tags: ["phosphor", "lock", "open"], 
    source: "phosphor", 
    name: "LockOpenIcon",
  }, 
  {
    id: "phosphor:LockSimpleIcon", 
    tags: ["phosphor", "lock", "simple"], 
    source: "phosphor", 
    name: "LockSimpleIcon",
  }, 
  {
    id: "phosphor:LockSimpleOpenIcon", 
    tags: ["phosphor", "lock", "simple", "open"], 
    source: "phosphor", 
    name: "LockSimpleOpenIcon",
  }, 
  {
    id: "phosphor:LockersIcon", 
    tags: ["phosphor", "lockers"], 
    source: "phosphor", 
    name: "LockersIcon",
  }, 
  {
    id: "phosphor:LogIcon", 
    tags: ["phosphor", "log"], 
    source: "phosphor", 
    name: "LogIcon",
  }, 
  {
    id: "phosphor:MagicWandIcon", 
    tags: ["phosphor", "magic", "wand"], 
    source: "phosphor", 
    name: "MagicWandIcon",
  }, 
  {
    id: "phosphor:MagnetIcon", 
    tags: ["phosphor", "magnet"], 
    source: "phosphor", 
    name: "MagnetIcon",
  }, 
  {
    id: "phosphor:MagnetStraightIcon", 
    tags: ["phosphor", "magnet", "straight"], 
    source: "phosphor", 
    name: "MagnetStraightIcon",
  }, 
  {
    id: "phosphor:MagnifyingGlassIcon", 
    tags: ["phosphor", "magnifying", "glass"], 
    source: "phosphor", 
    name: "MagnifyingGlassIcon",
  }, 
  {
    id: "phosphor:MagnifyingGlassMinusIcon", 
    tags: ["phosphor", "magnifying", "glass", "minus"], 
    source: "phosphor", 
    name: "MagnifyingGlassMinusIcon",
  }, 
  {
    id: "phosphor:MagnifyingGlassPlusIcon", 
    tags: ["phosphor", "magnifying", "glass", "plus"], 
    source: "phosphor", 
    name: "MagnifyingGlassPlusIcon",
  }, 
  {
    id: "phosphor:MailboxIcon", 
    tags: ["phosphor", "mailbox"], 
    source: "phosphor", 
    name: "MailboxIcon",
  }, 
  {
    id: "phosphor:MapPinAreaIcon", 
    tags: ["phosphor", "map", "pin", "area"], 
    source: "phosphor", 
    name: "MapPinAreaIcon",
  }, 
  {
    id: "phosphor:MapPinIcon", 
    tags: ["phosphor", "map", "pin"], 
    source: "phosphor", 
    name: "MapPinIcon",
  }, 
  {
    id: "phosphor:MapPinLineIcon", 
    tags: ["phosphor", "map", "pin", "line"], 
    source: "phosphor", 
    name: "MapPinLineIcon",
  }, 
  {
    id: "phosphor:MapPinPlusIcon", 
    tags: ["phosphor", "map", "pin", "plus"], 
    source: "phosphor", 
    name: "MapPinPlusIcon",
  }, 
  {
    id: "phosphor:MapPinSimpleAreaIcon", 
    tags: ["phosphor", "map", "pin", "simple", "area"], 
    source: "phosphor", 
    name: "MapPinSimpleAreaIcon",
  }, 
  {
    id: "phosphor:MapPinSimpleIcon", 
    tags: ["phosphor", "map", "pin", "simple"], 
    source: "phosphor", 
    name: "MapPinSimpleIcon",
  }, 
  {
    id: "phosphor:MapPinSimpleLineIcon", 
    tags: ["phosphor", "map", "pin", "simple", "line"], 
    source: "phosphor", 
    name: "MapPinSimpleLineIcon",
  }, 
  {
    id: "phosphor:MapTrifoldIcon", 
    tags: ["phosphor", "map", "trifold"], 
    source: "phosphor", 
    name: "MapTrifoldIcon",
  }, 
  {
    id: "phosphor:MarkdownLogoIcon", 
    tags: ["phosphor", "markdown", "logo"], 
    source: "phosphor", 
    name: "MarkdownLogoIcon",
  }, 
  {
    id: "phosphor:MarkerCircleIcon", 
    tags: ["phosphor", "marker", "circle"], 
    source: "phosphor", 
    name: "MarkerCircleIcon",
  }, 
  {
    id: "phosphor:MartiniIcon", 
    tags: ["phosphor", "martini"], 
    source: "phosphor", 
    name: "MartiniIcon",
  }, 
  {
    id: "phosphor:MaskHappyIcon", 
    tags: ["phosphor", "mask", "happy"], 
    source: "phosphor", 
    name: "MaskHappyIcon",
  }, 
  {
    id: "phosphor:MaskSadIcon", 
    tags: ["phosphor", "mask", "sad"], 
    source: "phosphor", 
    name: "MaskSadIcon",
  }, 
  {
    id: "phosphor:MastodonLogoIcon", 
    tags: ["phosphor", "mastodon", "logo"], 
    source: "phosphor", 
    name: "MastodonLogoIcon",
  }, 
  {
    id: "phosphor:MathOperationsIcon", 
    tags: ["phosphor", "math", "operations"], 
    source: "phosphor", 
    name: "MathOperationsIcon",
  }, 
  {
    id: "phosphor:MatrixLogoIcon", 
    tags: ["phosphor", "matrix", "logo"], 
    source: "phosphor", 
    name: "MatrixLogoIcon",
  }, 
  {
    id: "phosphor:MedalIcon", 
    tags: ["phosphor", "medal"], 
    source: "phosphor", 
    name: "MedalIcon",
  }, 
  {
    id: "phosphor:MedalMilitaryIcon", 
    tags: ["phosphor", "medal", "military"], 
    source: "phosphor", 
    name: "MedalMilitaryIcon",
  }, 
  {
    id: "phosphor:MediumLogoIcon", 
    tags: ["phosphor", "medium", "logo"], 
    source: "phosphor", 
    name: "MediumLogoIcon",
  }, 
  {
    id: "phosphor:MegaphoneIcon", 
    tags: ["phosphor", "megaphone"], 
    source: "phosphor", 
    name: "MegaphoneIcon",
  }, 
  {
    id: "phosphor:MegaphoneSimpleIcon", 
    tags: ["phosphor", "megaphone", "simple"], 
    source: "phosphor", 
    name: "MegaphoneSimpleIcon",
  }, 
  {
    id: "phosphor:MemberOfIcon", 
    tags: ["phosphor", "member", "of"], 
    source: "phosphor", 
    name: "MemberOfIcon",
  }, 
  {
    id: "phosphor:MemoryIcon", 
    tags: ["phosphor", "memory"], 
    source: "phosphor", 
    name: "MemoryIcon",
  }, 
  {
    id: "phosphor:MessengerLogoIcon", 
    tags: ["phosphor", "messenger", "logo"], 
    source: "phosphor", 
    name: "MessengerLogoIcon",
  }, 
  {
    id: "phosphor:MetaLogoIcon", 
    tags: ["phosphor", "meta", "logo"], 
    source: "phosphor", 
    name: "MetaLogoIcon",
  }, 
  {
    id: "phosphor:MeteorIcon", 
    tags: ["phosphor", "meteor"], 
    source: "phosphor", 
    name: "MeteorIcon",
  }, 
  {
    id: "phosphor:MetronomeIcon", 
    tags: ["phosphor", "metronome"], 
    source: "phosphor", 
    name: "MetronomeIcon",
  }, 
  {
    id: "phosphor:MicrophoneIcon", 
    tags: ["phosphor", "microphone"], 
    source: "phosphor", 
    name: "MicrophoneIcon",
  }, 
  {
    id: "phosphor:MicrophoneSlashIcon", 
    tags: ["phosphor", "microphone", "slash"], 
    source: "phosphor", 
    name: "MicrophoneSlashIcon",
  }, 
  {
    id: "phosphor:MicrophoneStageIcon", 
    tags: ["phosphor", "microphone", "stage"], 
    source: "phosphor", 
    name: "MicrophoneStageIcon",
  }, 
  {
    id: "phosphor:MicroscopeIcon", 
    tags: ["phosphor", "microscope"], 
    source: "phosphor", 
    name: "MicroscopeIcon",
  }, 
  {
    id: "phosphor:MicrosoftExcelLogoIcon", 
    tags: ["phosphor", "microsoft", "excel", "logo"], 
    source: "phosphor", 
    name: "MicrosoftExcelLogoIcon",
  }, 
  {
    id: "phosphor:MicrosoftOutlookLogoIcon", 
    tags: ["phosphor", "microsoft", "outlook", "logo"], 
    source: "phosphor", 
    name: "MicrosoftOutlookLogoIcon",
  }, 
  {
    id: "phosphor:MicrosoftPowerpointLogoIcon", 
    tags: ["phosphor", "microsoft", "powerpoint", "logo"], 
    source: "phosphor", 
    name: "MicrosoftPowerpointLogoIcon",
  }, 
  {
    id: "phosphor:MicrosoftTeamsLogoIcon", 
    tags: ["phosphor", "microsoft", "teams", "logo"], 
    source: "phosphor", 
    name: "MicrosoftTeamsLogoIcon",
  }, 
  {
    id: "phosphor:MicrosoftWordLogoIcon", 
    tags: ["phosphor", "microsoft", "word", "logo"], 
    source: "phosphor", 
    name: "MicrosoftWordLogoIcon",
  }, 
  {
    id: "phosphor:MinusCircleIcon", 
    tags: ["phosphor", "minus", "circle"], 
    source: "phosphor", 
    name: "MinusCircleIcon",
  }, 
  {
    id: "phosphor:MinusIcon", 
    tags: ["phosphor", "minus"], 
    source: "phosphor", 
    name: "MinusIcon",
  }, 
  {
    id: "phosphor:MinusSquareIcon", 
    tags: ["phosphor", "minus", "square"], 
    source: "phosphor", 
    name: "MinusSquareIcon",
  }, 
  {
    id: "phosphor:MoneyIcon", 
    tags: ["phosphor", "money"], 
    source: "phosphor", 
    name: "MoneyIcon",
  }, 
  {
    id: "phosphor:MoneyWavyIcon", 
    tags: ["phosphor", "money", "wavy"], 
    source: "phosphor", 
    name: "MoneyWavyIcon",
  }, 
  {
    id: "phosphor:MonitorArrowUpIcon", 
    tags: ["phosphor", "monitor", "arrow", "up"], 
    source: "phosphor", 
    name: "MonitorArrowUpIcon",
  }, 
  {
    id: "phosphor:MonitorIcon", 
    tags: ["phosphor", "monitor"], 
    source: "phosphor", 
    name: "MonitorIcon",
  }, 
  {
    id: "phosphor:MonitorPlayIcon", 
    tags: ["phosphor", "monitor", "play"], 
    source: "phosphor", 
    name: "MonitorPlayIcon",
  }, 
  {
    id: "phosphor:MoonIcon", 
    tags: ["phosphor", "moon"], 
    source: "phosphor", 
    name: "MoonIcon",
  }, 
  {
    id: "phosphor:MoonStarsIcon", 
    tags: ["phosphor", "moon", "stars"], 
    source: "phosphor", 
    name: "MoonStarsIcon",
  }, 
  {
    id: "phosphor:MopedFrontIcon", 
    tags: ["phosphor", "moped", "front"], 
    source: "phosphor", 
    name: "MopedFrontIcon",
  }, 
  {
    id: "phosphor:MopedIcon", 
    tags: ["phosphor", "moped"], 
    source: "phosphor", 
    name: "MopedIcon",
  }, 
  {
    id: "phosphor:MosqueIcon", 
    tags: ["phosphor", "mosque"], 
    source: "phosphor", 
    name: "MosqueIcon",
  }, 
  {
    id: "phosphor:MotorcycleIcon", 
    tags: ["phosphor", "motorcycle"], 
    source: "phosphor", 
    name: "MotorcycleIcon",
  }, 
  {
    id: "phosphor:MountainsIcon", 
    tags: ["phosphor", "mountains"], 
    source: "phosphor", 
    name: "MountainsIcon",
  }, 
  {
    id: "phosphor:MouseIcon", 
    tags: ["phosphor", "mouse"], 
    source: "phosphor", 
    name: "MouseIcon",
  }, 
  {
    id: "phosphor:MouseLeftClickIcon", 
    tags: ["phosphor", "mouse", "left", "click"], 
    source: "phosphor", 
    name: "MouseLeftClickIcon",
  }, 
  {
    id: "phosphor:MouseMiddleClickIcon", 
    tags: ["phosphor", "mouse", "middle", "click"], 
    source: "phosphor", 
    name: "MouseMiddleClickIcon",
  }, 
  {
    id: "phosphor:MouseRightClickIcon", 
    tags: ["phosphor", "mouse", "right", "click"], 
    source: "phosphor", 
    name: "MouseRightClickIcon",
  }, 
  {
    id: "phosphor:MouseScrollIcon", 
    tags: ["phosphor", "mouse", "scroll"], 
    source: "phosphor", 
    name: "MouseScrollIcon",
  }, 
  {
    id: "phosphor:MouseSimpleIcon", 
    tags: ["phosphor", "mouse", "simple"], 
    source: "phosphor", 
    name: "MouseSimpleIcon",
  }, 
  {
    id: "phosphor:MusicNoteIcon", 
    tags: ["phosphor", "music", "note"], 
    source: "phosphor", 
    name: "MusicNoteIcon",
  }, 
  {
    id: "phosphor:MusicNoteSimpleIcon", 
    tags: ["phosphor", "music", "note", "simple"], 
    source: "phosphor", 
    name: "MusicNoteSimpleIcon",
  }, 
  {
    id: "phosphor:MusicNotesIcon", 
    tags: ["phosphor", "music", "notes"], 
    source: "phosphor", 
    name: "MusicNotesIcon",
  }, 
  {
    id: "phosphor:MusicNotesMinusIcon", 
    tags: ["phosphor", "music", "notes", "minus"], 
    source: "phosphor", 
    name: "MusicNotesMinusIcon",
  }, 
  {
    id: "phosphor:MusicNotesPlusIcon", 
    tags: ["phosphor", "music", "notes", "plus"], 
    source: "phosphor", 
    name: "MusicNotesPlusIcon",
  }, 
  {
    id: "phosphor:MusicNotesSimpleIcon", 
    tags: ["phosphor", "music", "notes", "simple"], 
    source: "phosphor", 
    name: "MusicNotesSimpleIcon",
  }, 
  {
    id: "phosphor:NavigationArrowIcon", 
    tags: ["phosphor", "navigation", "arrow"], 
    source: "phosphor", 
    name: "NavigationArrowIcon",
  }, 
  {
    id: "phosphor:NeedleIcon", 
    tags: ["phosphor", "needle"], 
    source: "phosphor", 
    name: "NeedleIcon",
  }, 
  {
    id: "phosphor:NetworkIcon", 
    tags: ["phosphor", "network"], 
    source: "phosphor", 
    name: "NetworkIcon",
  }, 
  {
    id: "phosphor:NetworkSlashIcon", 
    tags: ["phosphor", "network", "slash"], 
    source: "phosphor", 
    name: "NetworkSlashIcon",
  }, 
  {
    id: "phosphor:NetworkXIcon", 
    tags: ["phosphor", "network"], 
    source: "phosphor", 
    name: "NetworkXIcon",
  }, 
  {
    id: "phosphor:NewspaperClippingIcon", 
    tags: ["phosphor", "newspaper", "clipping"], 
    source: "phosphor", 
    name: "NewspaperClippingIcon",
  }, 
  {
    id: "phosphor:NewspaperIcon", 
    tags: ["phosphor", "newspaper"], 
    source: "phosphor", 
    name: "NewspaperIcon",
  }, 
  {
    id: "phosphor:NotEqualsIcon", 
    tags: ["phosphor", "not", "equals"], 
    source: "phosphor", 
    name: "NotEqualsIcon",
  }, 
  {
    id: "phosphor:NotMemberOfIcon", 
    tags: ["phosphor", "not", "member", "of"], 
    source: "phosphor", 
    name: "NotMemberOfIcon",
  }, 
  {
    id: "phosphor:NotSubsetOfIcon", 
    tags: ["phosphor", "not", "subset", "of"], 
    source: "phosphor", 
    name: "NotSubsetOfIcon",
  }, 
  {
    id: "phosphor:NotSupersetOfIcon", 
    tags: ["phosphor", "not", "superset", "of"], 
    source: "phosphor", 
    name: "NotSupersetOfIcon",
  }, 
  {
    id: "phosphor:NotchesIcon", 
    tags: ["phosphor", "notches"], 
    source: "phosphor", 
    name: "NotchesIcon",
  }, 
  {
    id: "phosphor:NoteBlankIcon", 
    tags: ["phosphor", "note", "blank"], 
    source: "phosphor", 
    name: "NoteBlankIcon",
  }, 
  {
    id: "phosphor:NoteIcon", 
    tags: ["phosphor", "note"], 
    source: "phosphor", 
    name: "NoteIcon",
  }, 
  {
    id: "phosphor:NotePencilIcon", 
    tags: ["phosphor", "note", "pencil"], 
    source: "phosphor", 
    name: "NotePencilIcon",
  }, 
  {
    id: "phosphor:NotebookIcon", 
    tags: ["phosphor", "notebook"], 
    source: "phosphor", 
    name: "NotebookIcon",
  }, 
  {
    id: "phosphor:NotepadIcon", 
    tags: ["phosphor", "notepad"], 
    source: "phosphor", 
    name: "NotepadIcon",
  }, 
  {
    id: "phosphor:NotificationIcon", 
    tags: ["phosphor", "notification"], 
    source: "phosphor", 
    name: "NotificationIcon",
  }, 
  {
    id: "phosphor:NotionLogoIcon", 
    tags: ["phosphor", "notion", "logo"], 
    source: "phosphor", 
    name: "NotionLogoIcon",
  }, 
  {
    id: "phosphor:NuclearPlantIcon", 
    tags: ["phosphor", "nuclear", "plant"], 
    source: "phosphor", 
    name: "NuclearPlantIcon",
  }, 
  {
    id: "phosphor:NumberCircleEightIcon", 
    tags: ["phosphor", "number", "circle", "eight"], 
    source: "phosphor", 
    name: "NumberCircleEightIcon",
  }, 
  {
    id: "phosphor:NumberCircleFiveIcon", 
    tags: ["phosphor", "number", "circle", "five"], 
    source: "phosphor", 
    name: "NumberCircleFiveIcon",
  }, 
  {
    id: "phosphor:NumberCircleFourIcon", 
    tags: ["phosphor", "number", "circle", "four"], 
    source: "phosphor", 
    name: "NumberCircleFourIcon",
  }, 
  {
    id: "phosphor:NumberCircleNineIcon", 
    tags: ["phosphor", "number", "circle", "nine"], 
    source: "phosphor", 
    name: "NumberCircleNineIcon",
  }, 
  {
    id: "phosphor:NumberCircleOneIcon", 
    tags: ["phosphor", "number", "circle", "one"], 
    source: "phosphor", 
    name: "NumberCircleOneIcon",
  }, 
  {
    id: "phosphor:NumberCircleSevenIcon", 
    tags: ["phosphor", "number", "circle", "seven"], 
    source: "phosphor", 
    name: "NumberCircleSevenIcon",
  }, 
  {
    id: "phosphor:NumberCircleSixIcon", 
    tags: ["phosphor", "number", "circle", "six"], 
    source: "phosphor", 
    name: "NumberCircleSixIcon",
  }, 
  {
    id: "phosphor:NumberCircleThreeIcon", 
    tags: ["phosphor", "number", "circle", "three"], 
    source: "phosphor", 
    name: "NumberCircleThreeIcon",
  }, 
  {
    id: "phosphor:NumberCircleTwoIcon", 
    tags: ["phosphor", "number", "circle", "two"], 
    source: "phosphor", 
    name: "NumberCircleTwoIcon",
  }, 
  {
    id: "phosphor:NumberCircleZeroIcon", 
    tags: ["phosphor", "number", "circle", "zero"], 
    source: "phosphor", 
    name: "NumberCircleZeroIcon",
  }, 
  {
    id: "phosphor:NumberEightIcon", 
    tags: ["phosphor", "number", "eight"], 
    source: "phosphor", 
    name: "NumberEightIcon",
  }, 
  {
    id: "phosphor:NumberFiveIcon", 
    tags: ["phosphor", "number", "five"], 
    source: "phosphor", 
    name: "NumberFiveIcon",
  }, 
  {
    id: "phosphor:NumberFourIcon", 
    tags: ["phosphor", "number", "four"], 
    source: "phosphor", 
    name: "NumberFourIcon",
  }, 
  {
    id: "phosphor:NumberNineIcon", 
    tags: ["phosphor", "number", "nine"], 
    source: "phosphor", 
    name: "NumberNineIcon",
  }, 
  {
    id: "phosphor:NumberOneIcon", 
    tags: ["phosphor", "number", "one"], 
    source: "phosphor", 
    name: "NumberOneIcon",
  }, 
  {
    id: "phosphor:NumberSevenIcon", 
    tags: ["phosphor", "number", "seven"], 
    source: "phosphor", 
    name: "NumberSevenIcon",
  }, 
  {
    id: "phosphor:NumberSixIcon", 
    tags: ["phosphor", "number", "six"], 
    source: "phosphor", 
    name: "NumberSixIcon",
  }, 
  {
    id: "phosphor:NumberSquareEightIcon", 
    tags: ["phosphor", "number", "square", "eight"], 
    source: "phosphor", 
    name: "NumberSquareEightIcon",
  }, 
  {
    id: "phosphor:NumberSquareFiveIcon", 
    tags: ["phosphor", "number", "square", "five"], 
    source: "phosphor", 
    name: "NumberSquareFiveIcon",
  }, 
  {
    id: "phosphor:NumberSquareFourIcon", 
    tags: ["phosphor", "number", "square", "four"], 
    source: "phosphor", 
    name: "NumberSquareFourIcon",
  }, 
  {
    id: "phosphor:NumberSquareNineIcon", 
    tags: ["phosphor", "number", "square", "nine"], 
    source: "phosphor", 
    name: "NumberSquareNineIcon",
  }, 
  {
    id: "phosphor:NumberSquareOneIcon", 
    tags: ["phosphor", "number", "square", "one"], 
    source: "phosphor", 
    name: "NumberSquareOneIcon",
  }, 
  {
    id: "phosphor:NumberSquareSevenIcon", 
    tags: ["phosphor", "number", "square", "seven"], 
    source: "phosphor", 
    name: "NumberSquareSevenIcon",
  }, 
  {
    id: "phosphor:NumberSquareSixIcon", 
    tags: ["phosphor", "number", "square", "six"], 
    source: "phosphor", 
    name: "NumberSquareSixIcon",
  }, 
  {
    id: "phosphor:NumberSquareThreeIcon", 
    tags: ["phosphor", "number", "square", "three"], 
    source: "phosphor", 
    name: "NumberSquareThreeIcon",
  }, 
  {
    id: "phosphor:NumberSquareTwoIcon", 
    tags: ["phosphor", "number", "square", "two"], 
    source: "phosphor", 
    name: "NumberSquareTwoIcon",
  }, 
  {
    id: "phosphor:NumberSquareZeroIcon", 
    tags: ["phosphor", "number", "square", "zero"], 
    source: "phosphor", 
    name: "NumberSquareZeroIcon",
  }, 
  {
    id: "phosphor:NumberThreeIcon", 
    tags: ["phosphor", "number", "three"], 
    source: "phosphor", 
    name: "NumberThreeIcon",
  }, 
  {
    id: "phosphor:NumberTwoIcon", 
    tags: ["phosphor", "number", "two"], 
    source: "phosphor", 
    name: "NumberTwoIcon",
  }, 
  {
    id: "phosphor:NumberZeroIcon", 
    tags: ["phosphor", "number", "zero"], 
    source: "phosphor", 
    name: "NumberZeroIcon",
  }, 
  {
    id: "phosphor:NumpadIcon", 
    tags: ["phosphor", "numpad"], 
    source: "phosphor", 
    name: "NumpadIcon",
  }, 
  {
    id: "phosphor:NutIcon", 
    tags: ["phosphor", "nut"], 
    source: "phosphor", 
    name: "NutIcon",
  }, 
  {
    id: "phosphor:NyTimesLogoIcon", 
    tags: ["phosphor", "ny", "times", "logo"], 
    source: "phosphor", 
    name: "NyTimesLogoIcon",
  }, 
  {
    id: "phosphor:OctagonIcon", 
    tags: ["phosphor", "octagon"], 
    source: "phosphor", 
    name: "OctagonIcon",
  }, 
  {
    id: "phosphor:OfficeChairIcon", 
    tags: ["phosphor", "office", "chair"], 
    source: "phosphor", 
    name: "OfficeChairIcon",
  }, 
  {
    id: "phosphor:OnigiriIcon", 
    tags: ["phosphor", "onigiri"], 
    source: "phosphor", 
    name: "OnigiriIcon",
  }, 
  {
    id: "phosphor:OpenAiLogoIcon", 
    tags: ["phosphor", "open", "ai", "logo"], 
    source: "phosphor", 
    name: "OpenAiLogoIcon",
  }, 
  {
    id: "phosphor:OptionIcon", 
    tags: ["phosphor", "option"], 
    source: "phosphor", 
    name: "OptionIcon",
  }, 
  {
    id: "phosphor:OrangeIcon", 
    tags: ["phosphor", "orange"], 
    source: "phosphor", 
    name: "OrangeIcon",
  }, 
  {
    id: "phosphor:OrangeSliceIcon", 
    tags: ["phosphor", "orange", "slice"], 
    source: "phosphor", 
    name: "OrangeSliceIcon",
  }, 
  {
    id: "phosphor:OvenIcon", 
    tags: ["phosphor", "oven"], 
    source: "phosphor", 
    name: "OvenIcon",
  }, 
  {
    id: "phosphor:PackageIcon", 
    tags: ["phosphor", "package"], 
    source: "phosphor", 
    name: "PackageIcon",
  }, 
  {
    id: "phosphor:PaintBrushBroadIcon", 
    tags: ["phosphor", "paint", "brush", "broad"], 
    source: "phosphor", 
    name: "PaintBrushBroadIcon",
  }, 
  {
    id: "phosphor:PaintBrushHouseholdIcon", 
    tags: ["phosphor", "paint", "brush", "household"], 
    source: "phosphor", 
    name: "PaintBrushHouseholdIcon",
  }, 
  {
    id: "phosphor:PaintBrushIcon", 
    tags: ["phosphor", "paint", "brush"], 
    source: "phosphor", 
    name: "PaintBrushIcon",
  }, 
  {
    id: "phosphor:PaintBucketIcon", 
    tags: ["phosphor", "paint", "bucket"], 
    source: "phosphor", 
    name: "PaintBucketIcon",
  }, 
  {
    id: "phosphor:PaintRollerIcon", 
    tags: ["phosphor", "paint", "roller"], 
    source: "phosphor", 
    name: "PaintRollerIcon",
  }, 
  {
    id: "phosphor:PaletteIcon", 
    tags: ["phosphor", "palette"], 
    source: "phosphor", 
    name: "PaletteIcon",
  }, 
  {
    id: "phosphor:PanoramaIcon", 
    tags: ["phosphor", "panorama"], 
    source: "phosphor", 
    name: "PanoramaIcon",
  }, 
  {
    id: "phosphor:PantsIcon", 
    tags: ["phosphor", "pants"], 
    source: "phosphor", 
    name: "PantsIcon",
  }, 
  {
    id: "phosphor:PaperPlaneIcon", 
    tags: ["phosphor", "paper", "plane"], 
    source: "phosphor", 
    name: "PaperPlaneIcon",
  }, 
  {
    id: "phosphor:PaperPlaneRightIcon", 
    tags: ["phosphor", "paper", "plane", "right"], 
    source: "phosphor", 
    name: "PaperPlaneRightIcon",
  }, 
  {
    id: "phosphor:PaperPlaneTiltIcon", 
    tags: ["phosphor", "paper", "plane", "tilt"], 
    source: "phosphor", 
    name: "PaperPlaneTiltIcon",
  }, 
  {
    id: "phosphor:PaperclipHorizontalIcon", 
    tags: ["phosphor", "paperclip", "horizontal"], 
    source: "phosphor", 
    name: "PaperclipHorizontalIcon",
  }, 
  {
    id: "phosphor:PaperclipIcon", 
    tags: ["phosphor", "paperclip"], 
    source: "phosphor", 
    name: "PaperclipIcon",
  }, 
  {
    id: "phosphor:ParachuteIcon", 
    tags: ["phosphor", "parachute"], 
    source: "phosphor", 
    name: "ParachuteIcon",
  }, 
  {
    id: "phosphor:ParagraphIcon", 
    tags: ["phosphor", "paragraph"], 
    source: "phosphor", 
    name: "ParagraphIcon",
  }, 
  {
    id: "phosphor:ParallelogramIcon", 
    tags: ["phosphor", "parallelogram"], 
    source: "phosphor", 
    name: "ParallelogramIcon",
  }, 
  {
    id: "phosphor:ParkIcon", 
    tags: ["phosphor", "park"], 
    source: "phosphor", 
    name: "ParkIcon",
  }, 
  {
    id: "phosphor:PasswordIcon", 
    tags: ["phosphor", "password"], 
    source: "phosphor", 
    name: "PasswordIcon",
  }, 
  {
    id: "phosphor:PathIcon", 
    tags: ["phosphor", "path"], 
    source: "phosphor", 
    name: "PathIcon",
  }, 
  {
    id: "phosphor:PatreonLogoIcon", 
    tags: ["phosphor", "patreon", "logo"], 
    source: "phosphor", 
    name: "PatreonLogoIcon",
  }, 
  {
    id: "phosphor:PauseCircleIcon", 
    tags: ["phosphor", "pause", "circle"], 
    source: "phosphor", 
    name: "PauseCircleIcon",
  }, 
  {
    id: "phosphor:PauseIcon", 
    tags: ["phosphor", "pause"], 
    source: "phosphor", 
    name: "PauseIcon",
  }, 
  {
    id: "phosphor:PawPrintIcon", 
    tags: ["phosphor", "paw", "print"], 
    source: "phosphor", 
    name: "PawPrintIcon",
  }, 
  {
    id: "phosphor:PaypalLogoIcon", 
    tags: ["phosphor", "paypal", "logo"], 
    source: "phosphor", 
    name: "PaypalLogoIcon",
  }, 
  {
    id: "phosphor:PeaceIcon", 
    tags: ["phosphor", "peace"], 
    source: "phosphor", 
    name: "PeaceIcon",
  }, 
  {
    id: "phosphor:PenIcon", 
    tags: ["phosphor", "pen"], 
    source: "phosphor", 
    name: "PenIcon",
  }, 
  {
    id: "phosphor:PenNibIcon", 
    tags: ["phosphor", "pen", "nib"], 
    source: "phosphor", 
    name: "PenNibIcon",
  }, 
  {
    id: "phosphor:PenNibStraightIcon", 
    tags: ["phosphor", "pen", "nib", "straight"], 
    source: "phosphor", 
    name: "PenNibStraightIcon",
  }, 
  {
    id: "phosphor:PencilCircleIcon", 
    tags: ["phosphor", "pencil", "circle"], 
    source: "phosphor", 
    name: "PencilCircleIcon",
  }, 
  {
    id: "phosphor:PencilIcon", 
    tags: ["phosphor", "pencil"], 
    source: "phosphor", 
    name: "PencilIcon",
  }, 
  {
    id: "phosphor:PencilLineIcon", 
    tags: ["phosphor", "pencil", "line"], 
    source: "phosphor", 
    name: "PencilLineIcon",
  }, 
  {
    id: "phosphor:PencilRulerIcon", 
    tags: ["phosphor", "pencil", "ruler"], 
    source: "phosphor", 
    name: "PencilRulerIcon",
  }, 
  {
    id: "phosphor:PencilSimpleIcon", 
    tags: ["phosphor", "pencil", "simple"], 
    source: "phosphor", 
    name: "PencilSimpleIcon",
  }, 
  {
    id: "phosphor:PencilSimpleLineIcon", 
    tags: ["phosphor", "pencil", "simple", "line"], 
    source: "phosphor", 
    name: "PencilSimpleLineIcon",
  }, 
  {
    id: "phosphor:PencilSimpleSlashIcon", 
    tags: ["phosphor", "pencil", "simple", "slash"], 
    source: "phosphor", 
    name: "PencilSimpleSlashIcon",
  }, 
  {
    id: "phosphor:PencilSlashIcon", 
    tags: ["phosphor", "pencil", "slash"], 
    source: "phosphor", 
    name: "PencilSlashIcon",
  }, 
  {
    id: "phosphor:PentagonIcon", 
    tags: ["phosphor", "pentagon"], 
    source: "phosphor", 
    name: "PentagonIcon",
  }, 
  {
    id: "phosphor:PentagramIcon", 
    tags: ["phosphor", "pentagram"], 
    source: "phosphor", 
    name: "PentagramIcon",
  }, 
  {
    id: "phosphor:PepperIcon", 
    tags: ["phosphor", "pepper"], 
    source: "phosphor", 
    name: "PepperIcon",
  }, 
  {
    id: "phosphor:PercentIcon", 
    tags: ["phosphor", "percent"], 
    source: "phosphor", 
    name: "PercentIcon",
  }, 
  {
    id: "phosphor:PersonArmsSpreadIcon", 
    tags: ["phosphor", "person", "arms", "spread"], 
    source: "phosphor", 
    name: "PersonArmsSpreadIcon",
  }, 
  {
    id: "phosphor:PersonIcon", 
    tags: ["phosphor", "person"], 
    source: "phosphor", 
    name: "PersonIcon",
  }, 
  {
    id: "phosphor:PersonSimpleBikeIcon", 
    tags: ["phosphor", "person", "simple", "bike"], 
    source: "phosphor", 
    name: "PersonSimpleBikeIcon",
  }, 
  {
    id: "phosphor:PersonSimpleCircleIcon", 
    tags: ["phosphor", "person", "simple", "circle"], 
    source: "phosphor", 
    name: "PersonSimpleCircleIcon",
  }, 
  {
    id: "phosphor:PersonSimpleHikeIcon", 
    tags: ["phosphor", "person", "simple", "hike"], 
    source: "phosphor", 
    name: "PersonSimpleHikeIcon",
  }, 
  {
    id: "phosphor:PersonSimpleIcon", 
    tags: ["phosphor", "person", "simple"], 
    source: "phosphor", 
    name: "PersonSimpleIcon",
  }, 
  {
    id: "phosphor:PersonSimpleRunIcon", 
    tags: ["phosphor", "person", "simple", "run"], 
    source: "phosphor", 
    name: "PersonSimpleRunIcon",
  }, 
  {
    id: "phosphor:PersonSimpleSkiIcon", 
    tags: ["phosphor", "person", "simple", "ski"], 
    source: "phosphor", 
    name: "PersonSimpleSkiIcon",
  }, 
  {
    id: "phosphor:PersonSimpleSnowboardIcon", 
    tags: ["phosphor", "person", "simple", "snowboard"], 
    source: "phosphor", 
    name: "PersonSimpleSnowboardIcon",
  }, 
  {
    id: "phosphor:PersonSimpleSwimIcon", 
    tags: ["phosphor", "person", "simple", "swim"], 
    source: "phosphor", 
    name: "PersonSimpleSwimIcon",
  }, 
  {
    id: "phosphor:PersonSimpleTaiChiIcon", 
    tags: ["phosphor", "person", "simple", "tai", "chi"], 
    source: "phosphor", 
    name: "PersonSimpleTaiChiIcon",
  }, 
  {
    id: "phosphor:PersonSimpleThrowIcon", 
    tags: ["phosphor", "person", "simple", "throw"], 
    source: "phosphor", 
    name: "PersonSimpleThrowIcon",
  }, 
  {
    id: "phosphor:PersonSimpleWalkIcon", 
    tags: ["phosphor", "person", "simple", "walk"], 
    source: "phosphor", 
    name: "PersonSimpleWalkIcon",
  }, 
  {
    id: "phosphor:PerspectiveIcon", 
    tags: ["phosphor", "perspective"], 
    source: "phosphor", 
    name: "PerspectiveIcon",
  }, 
  {
    id: "phosphor:PhoneCallIcon", 
    tags: ["phosphor", "phone", "call"], 
    source: "phosphor", 
    name: "PhoneCallIcon",
  }, 
  {
    id: "phosphor:PhoneDisconnectIcon", 
    tags: ["phosphor", "phone", "disconnect"], 
    source: "phosphor", 
    name: "PhoneDisconnectIcon",
  }, 
  {
    id: "phosphor:PhoneIcon", 
    tags: ["phosphor", "phone"], 
    source: "phosphor", 
    name: "PhoneIcon",
  }, 
  {
    id: "phosphor:PhoneIncomingIcon", 
    tags: ["phosphor", "phone", "incoming"], 
    source: "phosphor", 
    name: "PhoneIncomingIcon",
  }, 
  {
    id: "phosphor:PhoneListIcon", 
    tags: ["phosphor", "phone", "list"], 
    source: "phosphor", 
    name: "PhoneListIcon",
  }, 
  {
    id: "phosphor:PhoneOutgoingIcon", 
    tags: ["phosphor", "phone", "outgoing"], 
    source: "phosphor", 
    name: "PhoneOutgoingIcon",
  }, 
  {
    id: "phosphor:PhonePauseIcon", 
    tags: ["phosphor", "phone", "pause"], 
    source: "phosphor", 
    name: "PhonePauseIcon",
  }, 
  {
    id: "phosphor:PhonePlusIcon", 
    tags: ["phosphor", "phone", "plus"], 
    source: "phosphor", 
    name: "PhonePlusIcon",
  }, 
  {
    id: "phosphor:PhoneSlashIcon", 
    tags: ["phosphor", "phone", "slash"], 
    source: "phosphor", 
    name: "PhoneSlashIcon",
  }, 
  {
    id: "phosphor:PhoneTransferIcon", 
    tags: ["phosphor", "phone", "transfer"], 
    source: "phosphor", 
    name: "PhoneTransferIcon",
  }, 
  {
    id: "phosphor:PhoneXIcon", 
    tags: ["phosphor", "phone"], 
    source: "phosphor", 
    name: "PhoneXIcon",
  }, 
  {
    id: "phosphor:PhosphorLogoIcon", 
    tags: ["phosphor", "phosphor", "logo"], 
    source: "phosphor", 
    name: "PhosphorLogoIcon",
  }, 
  {
    id: "phosphor:PiIcon", 
    tags: ["phosphor", "pi"], 
    source: "phosphor", 
    name: "PiIcon",
  }, 
  {
    id: "phosphor:PianoKeysIcon", 
    tags: ["phosphor", "piano", "keys"], 
    source: "phosphor", 
    name: "PianoKeysIcon",
  }, 
  {
    id: "phosphor:PicnicTableIcon", 
    tags: ["phosphor", "picnic", "table"], 
    source: "phosphor", 
    name: "PicnicTableIcon",
  }, 
  {
    id: "phosphor:PictureInPictureIcon", 
    tags: ["phosphor", "picture", "in", "picture"], 
    source: "phosphor", 
    name: "PictureInPictureIcon",
  }, 
  {
    id: "phosphor:PiggyBankIcon", 
    tags: ["phosphor", "piggy", "bank"], 
    source: "phosphor", 
    name: "PiggyBankIcon",
  }, 
  {
    id: "phosphor:PillIcon", 
    tags: ["phosphor", "pill"], 
    source: "phosphor", 
    name: "PillIcon",
  }, 
  {
    id: "phosphor:PingPongIcon", 
    tags: ["phosphor", "ping", "pong"], 
    source: "phosphor", 
    name: "PingPongIcon",
  }, 
  {
    id: "phosphor:PintGlassIcon", 
    tags: ["phosphor", "pint", "glass"], 
    source: "phosphor", 
    name: "PintGlassIcon",
  }, 
  {
    id: "phosphor:PinterestLogoIcon", 
    tags: ["phosphor", "pinterest", "logo"], 
    source: "phosphor", 
    name: "PinterestLogoIcon",
  }, 
  {
    id: "phosphor:PinwheelIcon", 
    tags: ["phosphor", "pinwheel"], 
    source: "phosphor", 
    name: "PinwheelIcon",
  }, 
  {
    id: "phosphor:PipeIcon", 
    tags: ["phosphor", "pipe"], 
    source: "phosphor", 
    name: "PipeIcon",
  }, 
  {
    id: "phosphor:PipeWrenchIcon", 
    tags: ["phosphor", "pipe", "wrench"], 
    source: "phosphor", 
    name: "PipeWrenchIcon",
  }, 
  {
    id: "phosphor:PixLogoIcon", 
    tags: ["phosphor", "pix", "logo"], 
    source: "phosphor", 
    name: "PixLogoIcon",
  }, 
  {
    id: "phosphor:PizzaIcon", 
    tags: ["phosphor", "pizza"], 
    source: "phosphor", 
    name: "PizzaIcon",
  }, 
  {
    id: "phosphor:PlaceholderIcon", 
    tags: ["phosphor", "placeholder"], 
    source: "phosphor", 
    name: "PlaceholderIcon",
  }, 
  {
    id: "phosphor:PlanetIcon", 
    tags: ["phosphor", "planet"], 
    source: "phosphor", 
    name: "PlanetIcon",
  }, 
  {
    id: "phosphor:PlantIcon", 
    tags: ["phosphor", "plant"], 
    source: "phosphor", 
    name: "PlantIcon",
  }, 
  {
    id: "phosphor:PlayCircleIcon", 
    tags: ["phosphor", "play", "circle"], 
    source: "phosphor", 
    name: "PlayCircleIcon",
  }, 
  {
    id: "phosphor:PlayIcon", 
    tags: ["phosphor", "play"], 
    source: "phosphor", 
    name: "PlayIcon",
  }, 
  {
    id: "phosphor:PlayPauseIcon", 
    tags: ["phosphor", "play", "pause"], 
    source: "phosphor", 
    name: "PlayPauseIcon",
  }, 
  {
    id: "phosphor:PlaylistIcon", 
    tags: ["phosphor", "playlist"], 
    source: "phosphor", 
    name: "PlaylistIcon",
  }, 
  {
    id: "phosphor:PlugChargingIcon", 
    tags: ["phosphor", "plug", "charging"], 
    source: "phosphor", 
    name: "PlugChargingIcon",
  }, 
  {
    id: "phosphor:PlugIcon", 
    tags: ["phosphor", "plug"], 
    source: "phosphor", 
    name: "PlugIcon",
  }, 
  {
    id: "phosphor:PlugsConnectedIcon", 
    tags: ["phosphor", "plugs", "connected"], 
    source: "phosphor", 
    name: "PlugsConnectedIcon",
  }, 
  {
    id: "phosphor:PlugsIcon", 
    tags: ["phosphor", "plugs"], 
    source: "phosphor", 
    name: "PlugsIcon",
  }, 
  {
    id: "phosphor:PlusCircleIcon", 
    tags: ["phosphor", "plus", "circle"], 
    source: "phosphor", 
    name: "PlusCircleIcon",
  }, 
  {
    id: "phosphor:PlusIcon", 
    tags: ["phosphor", "plus"], 
    source: "phosphor", 
    name: "PlusIcon",
  }, 
  {
    id: "phosphor:PlusMinusIcon", 
    tags: ["phosphor", "plus", "minus"], 
    source: "phosphor", 
    name: "PlusMinusIcon",
  }, 
  {
    id: "phosphor:PlusSquareIcon", 
    tags: ["phosphor", "plus", "square"], 
    source: "phosphor", 
    name: "PlusSquareIcon",
  }, 
  {
    id: "phosphor:PokerChipIcon", 
    tags: ["phosphor", "poker", "chip"], 
    source: "phosphor", 
    name: "PokerChipIcon",
  }, 
  {
    id: "phosphor:PoliceCarIcon", 
    tags: ["phosphor", "police", "car"], 
    source: "phosphor", 
    name: "PoliceCarIcon",
  }, 
  {
    id: "phosphor:PolygonIcon", 
    tags: ["phosphor", "polygon"], 
    source: "phosphor", 
    name: "PolygonIcon",
  }, 
  {
    id: "phosphor:PopcornIcon", 
    tags: ["phosphor", "popcorn"], 
    source: "phosphor", 
    name: "PopcornIcon",
  }, 
  {
    id: "phosphor:PopsicleIcon", 
    tags: ["phosphor", "popsicle"], 
    source: "phosphor", 
    name: "PopsicleIcon",
  }, 
  {
    id: "phosphor:PottedPlantIcon", 
    tags: ["phosphor", "potted", "plant"], 
    source: "phosphor", 
    name: "PottedPlantIcon",
  }, 
  {
    id: "phosphor:PowerIcon", 
    tags: ["phosphor", "power"], 
    source: "phosphor", 
    name: "PowerIcon",
  }, 
  {
    id: "phosphor:PrescriptionIcon", 
    tags: ["phosphor", "prescription"], 
    source: "phosphor", 
    name: "PrescriptionIcon",
  }, 
  {
    id: "phosphor:PresentationChartIcon", 
    tags: ["phosphor", "presentation", "chart"], 
    source: "phosphor", 
    name: "PresentationChartIcon",
  }, 
  {
    id: "phosphor:PresentationIcon", 
    tags: ["phosphor", "presentation"], 
    source: "phosphor", 
    name: "PresentationIcon",
  }, 
  {
    id: "phosphor:PrinterIcon", 
    tags: ["phosphor", "printer"], 
    source: "phosphor", 
    name: "PrinterIcon",
  }, 
  {
    id: "phosphor:ProhibitIcon", 
    tags: ["phosphor", "prohibit"], 
    source: "phosphor", 
    name: "ProhibitIcon",
  }, 
  {
    id: "phosphor:ProhibitInsetIcon", 
    tags: ["phosphor", "prohibit", "inset"], 
    source: "phosphor", 
    name: "ProhibitInsetIcon",
  }, 
  {
    id: "phosphor:ProjectorScreenChartIcon", 
    tags: ["phosphor", "projector", "screen", "chart"], 
    source: "phosphor", 
    name: "ProjectorScreenChartIcon",
  }, 
  {
    id: "phosphor:ProjectorScreenIcon", 
    tags: ["phosphor", "projector", "screen"], 
    source: "phosphor", 
    name: "ProjectorScreenIcon",
  }, 
  {
    id: "phosphor:PulseIcon", 
    tags: ["phosphor", "pulse"], 
    source: "phosphor", 
    name: "PulseIcon",
  }, 
  {
    id: "phosphor:PushPinIcon", 
    tags: ["phosphor", "push", "pin"], 
    source: "phosphor", 
    name: "PushPinIcon",
  }, 
  {
    id: "phosphor:PushPinSimpleIcon", 
    tags: ["phosphor", "push", "pin", "simple"], 
    source: "phosphor", 
    name: "PushPinSimpleIcon",
  }, 
  {
    id: "phosphor:PushPinSimpleSlashIcon", 
    tags: ["phosphor", "push", "pin", "simple", "slash"], 
    source: "phosphor", 
    name: "PushPinSimpleSlashIcon",
  }, 
  {
    id: "phosphor:PushPinSlashIcon", 
    tags: ["phosphor", "push", "pin", "slash"], 
    source: "phosphor", 
    name: "PushPinSlashIcon",
  }, 
  {
    id: "phosphor:PuzzlePieceIcon", 
    tags: ["phosphor", "puzzle", "piece"], 
    source: "phosphor", 
    name: "PuzzlePieceIcon",
  }, 
  {
    id: "phosphor:QrCodeIcon", 
    tags: ["phosphor", "qr", "code"], 
    source: "phosphor", 
    name: "QrCodeIcon",
  }, 
  {
    id: "phosphor:QuestionIcon", 
    tags: ["phosphor", "question"], 
    source: "phosphor", 
    name: "QuestionIcon",
  }, 
  {
    id: "phosphor:QuestionMarkIcon", 
    tags: ["phosphor", "question", "mark"], 
    source: "phosphor", 
    name: "QuestionMarkIcon",
  }, 
  {
    id: "phosphor:QueueIcon", 
    tags: ["phosphor", "queue"], 
    source: "phosphor", 
    name: "QueueIcon",
  }, 
  {
    id: "phosphor:QuotesIcon", 
    tags: ["phosphor", "quotes"], 
    source: "phosphor", 
    name: "QuotesIcon",
  }, 
  {
    id: "phosphor:RabbitIcon", 
    tags: ["phosphor", "rabbit"], 
    source: "phosphor", 
    name: "RabbitIcon",
  }, 
  {
    id: "phosphor:RacquetIcon", 
    tags: ["phosphor", "racquet"], 
    source: "phosphor", 
    name: "RacquetIcon",
  }, 
  {
    id: "phosphor:RadicalIcon", 
    tags: ["phosphor", "radical"], 
    source: "phosphor", 
    name: "RadicalIcon",
  }, 
  {
    id: "phosphor:RadioButtonIcon", 
    tags: ["phosphor", "radio", "button"], 
    source: "phosphor", 
    name: "RadioButtonIcon",
  }, 
  {
    id: "phosphor:RadioIcon", 
    tags: ["phosphor", "radio"], 
    source: "phosphor", 
    name: "RadioIcon",
  }, 
  {
    id: "phosphor:RadioactiveIcon", 
    tags: ["phosphor", "radioactive"], 
    source: "phosphor", 
    name: "RadioactiveIcon",
  }, 
  {
    id: "phosphor:RainbowCloudIcon", 
    tags: ["phosphor", "rainbow", "cloud"], 
    source: "phosphor", 
    name: "RainbowCloudIcon",
  }, 
  {
    id: "phosphor:RainbowIcon", 
    tags: ["phosphor", "rainbow"], 
    source: "phosphor", 
    name: "RainbowIcon",
  }, 
  {
    id: "phosphor:RankingIcon", 
    tags: ["phosphor", "ranking"], 
    source: "phosphor", 
    name: "RankingIcon",
  }, 
  {
    id: "phosphor:ReadCvLogoIcon", 
    tags: ["phosphor", "read", "cv", "logo"], 
    source: "phosphor", 
    name: "ReadCvLogoIcon",
  }, 
  {
    id: "phosphor:ReceiptIcon", 
    tags: ["phosphor", "receipt"], 
    source: "phosphor", 
    name: "ReceiptIcon",
  }, 
  {
    id: "phosphor:ReceiptXIcon", 
    tags: ["phosphor", "receipt"], 
    source: "phosphor", 
    name: "ReceiptXIcon",
  }, 
  {
    id: "phosphor:RecordIcon", 
    tags: ["phosphor", "record"], 
    source: "phosphor", 
    name: "RecordIcon",
  }, 
  {
    id: "phosphor:RectangleDashedIcon", 
    tags: ["phosphor", "rectangle", "dashed"], 
    source: "phosphor", 
    name: "RectangleDashedIcon",
  }, 
  {
    id: "phosphor:RectangleIcon", 
    tags: ["phosphor", "rectangle"], 
    source: "phosphor", 
    name: "RectangleIcon",
  }, 
  {
    id: "phosphor:RecycleIcon", 
    tags: ["phosphor", "recycle"], 
    source: "phosphor", 
    name: "RecycleIcon",
  }, 
  {
    id: "phosphor:RedditLogoIcon", 
    tags: ["phosphor", "reddit", "logo"], 
    source: "phosphor", 
    name: "RedditLogoIcon",
  }, 
  {
    id: "phosphor:RepeatIcon", 
    tags: ["phosphor", "repeat"], 
    source: "phosphor", 
    name: "RepeatIcon",
  }, 
  {
    id: "phosphor:RepeatOnceIcon", 
    tags: ["phosphor", "repeat", "once"], 
    source: "phosphor", 
    name: "RepeatOnceIcon",
  }, 
  {
    id: "phosphor:ReplitLogoIcon", 
    tags: ["phosphor", "replit", "logo"], 
    source: "phosphor", 
    name: "ReplitLogoIcon",
  }, 
  {
    id: "phosphor:ResizeIcon", 
    tags: ["phosphor", "resize"], 
    source: "phosphor", 
    name: "ResizeIcon",
  }, 
  {
    id: "phosphor:RewindCircleIcon", 
    tags: ["phosphor", "rewind", "circle"], 
    source: "phosphor", 
    name: "RewindCircleIcon",
  }, 
  {
    id: "phosphor:RewindIcon", 
    tags: ["phosphor", "rewind"], 
    source: "phosphor", 
    name: "RewindIcon",
  }, 
  {
    id: "phosphor:RoadHorizonIcon", 
    tags: ["phosphor", "road", "horizon"], 
    source: "phosphor", 
    name: "RoadHorizonIcon",
  }, 
  {
    id: "phosphor:RobotIcon", 
    tags: ["phosphor", "robot"], 
    source: "phosphor", 
    name: "RobotIcon",
  }, 
  {
    id: "phosphor:RocketIcon", 
    tags: ["phosphor", "rocket"], 
    source: "phosphor", 
    name: "RocketIcon",
  }, 
  {
    id: "phosphor:RocketLaunchIcon", 
    tags: ["phosphor", "rocket", "launch"], 
    source: "phosphor", 
    name: "RocketLaunchIcon",
  }, 
  {
    id: "phosphor:RowsIcon", 
    tags: ["phosphor", "rows"], 
    source: "phosphor", 
    name: "RowsIcon",
  }, 
  {
    id: "phosphor:RowsPlusBottomIcon", 
    tags: ["phosphor", "rows", "plus", "bottom"], 
    source: "phosphor", 
    name: "RowsPlusBottomIcon",
  }, 
  {
    id: "phosphor:RowsPlusTopIcon", 
    tags: ["phosphor", "rows", "plus", "top"], 
    source: "phosphor", 
    name: "RowsPlusTopIcon",
  }, 
  {
    id: "phosphor:RssIcon", 
    tags: ["phosphor", "rss"], 
    source: "phosphor", 
    name: "RssIcon",
  }, 
  {
    id: "phosphor:RssSimpleIcon", 
    tags: ["phosphor", "rss", "simple"], 
    source: "phosphor", 
    name: "RssSimpleIcon",
  }, 
  {
    id: "phosphor:RugIcon", 
    tags: ["phosphor", "rug"], 
    source: "phosphor", 
    name: "RugIcon",
  }, 
  {
    id: "phosphor:RulerIcon", 
    tags: ["phosphor", "ruler"], 
    source: "phosphor", 
    name: "RulerIcon",
  }, 
  {
    id: "phosphor:SailboatIcon", 
    tags: ["phosphor", "sailboat"], 
    source: "phosphor", 
    name: "SailboatIcon",
  }, 
  {
    id: "phosphor:ScalesIcon", 
    tags: ["phosphor", "scales"], 
    source: "phosphor", 
    name: "ScalesIcon",
  }, 
  {
    id: "phosphor:ScanIcon", 
    tags: ["phosphor", "scan"], 
    source: "phosphor", 
    name: "ScanIcon",
  }, 
  {
    id: "phosphor:ScanSmileyIcon", 
    tags: ["phosphor", "scan", "smiley"], 
    source: "phosphor", 
    name: "ScanSmileyIcon",
  }, 
  {
    id: "phosphor:ScissorsIcon", 
    tags: ["phosphor", "scissors"], 
    source: "phosphor", 
    name: "ScissorsIcon",
  }, 
  {
    id: "phosphor:ScooterIcon", 
    tags: ["phosphor", "scooter"], 
    source: "phosphor", 
    name: "ScooterIcon",
  }, 
  {
    id: "phosphor:ScreencastIcon", 
    tags: ["phosphor", "screencast"], 
    source: "phosphor", 
    name: "ScreencastIcon",
  }, 
  {
    id: "phosphor:ScrewdriverIcon", 
    tags: ["phosphor", "screwdriver"], 
    source: "phosphor", 
    name: "ScrewdriverIcon",
  }, 
  {
    id: "phosphor:ScribbleIcon", 
    tags: ["phosphor", "scribble"], 
    source: "phosphor", 
    name: "ScribbleIcon",
  }, 
  {
    id: "phosphor:ScribbleLoopIcon", 
    tags: ["phosphor", "scribble", "loop"], 
    source: "phosphor", 
    name: "ScribbleLoopIcon",
  }, 
  {
    id: "phosphor:ScrollIcon", 
    tags: ["phosphor", "scroll"], 
    source: "phosphor", 
    name: "ScrollIcon",
  }, 
  {
    id: "phosphor:SealCheckIcon", 
    tags: ["phosphor", "seal", "check"], 
    source: "phosphor", 
    name: "SealCheckIcon",
  }, 
  {
    id: "phosphor:SealIcon", 
    tags: ["phosphor", "seal"], 
    source: "phosphor", 
    name: "SealIcon",
  }, 
  {
    id: "phosphor:SealPercentIcon", 
    tags: ["phosphor", "seal", "percent"], 
    source: "phosphor", 
    name: "SealPercentIcon",
  }, 
  {
    id: "phosphor:SealQuestionIcon", 
    tags: ["phosphor", "seal", "question"], 
    source: "phosphor", 
    name: "SealQuestionIcon",
  }, 
  {
    id: "phosphor:SealWarningIcon", 
    tags: ["phosphor", "seal", "warning"], 
    source: "phosphor", 
    name: "SealWarningIcon",
  }, 
  {
    id: "phosphor:SeatIcon", 
    tags: ["phosphor", "seat"], 
    source: "phosphor", 
    name: "SeatIcon",
  }, 
  {
    id: "phosphor:SeatbeltIcon", 
    tags: ["phosphor", "seatbelt"], 
    source: "phosphor", 
    name: "SeatbeltIcon",
  }, 
  {
    id: "phosphor:SecurityCameraIcon", 
    tags: ["phosphor", "security", "camera"], 
    source: "phosphor", 
    name: "SecurityCameraIcon",
  }, 
  {
    id: "phosphor:SelectionAllIcon", 
    tags: ["phosphor", "selection", "all"], 
    source: "phosphor", 
    name: "SelectionAllIcon",
  }, 
  {
    id: "phosphor:SelectionBackgroundIcon", 
    tags: ["phosphor", "selection", "background"], 
    source: "phosphor", 
    name: "SelectionBackgroundIcon",
  }, 
  {
    id: "phosphor:SelectionForegroundIcon", 
    tags: ["phosphor", "selection", "foreground"], 
    source: "phosphor", 
    name: "SelectionForegroundIcon",
  }, 
  {
    id: "phosphor:SelectionIcon", 
    tags: ["phosphor", "selection"], 
    source: "phosphor", 
    name: "SelectionIcon",
  }, 
  {
    id: "phosphor:SelectionInverseIcon", 
    tags: ["phosphor", "selection", "inverse"], 
    source: "phosphor", 
    name: "SelectionInverseIcon",
  }, 
  {
    id: "phosphor:SelectionPlusIcon", 
    tags: ["phosphor", "selection", "plus"], 
    source: "phosphor", 
    name: "SelectionPlusIcon",
  }, 
  {
    id: "phosphor:SelectionSlashIcon", 
    tags: ["phosphor", "selection", "slash"], 
    source: "phosphor", 
    name: "SelectionSlashIcon",
  }, 
  {
    id: "phosphor:ShapesIcon", 
    tags: ["phosphor", "shapes"], 
    source: "phosphor", 
    name: "ShapesIcon",
  }, 
  {
    id: "phosphor:ShareFatIcon", 
    tags: ["phosphor", "share", "fat"], 
    source: "phosphor", 
    name: "ShareFatIcon",
  }, 
  {
    id: "phosphor:ShareIcon", 
    tags: ["phosphor", "share"], 
    source: "phosphor", 
    name: "ShareIcon",
  }, 
  {
    id: "phosphor:ShareNetworkIcon", 
    tags: ["phosphor", "share", "network"], 
    source: "phosphor", 
    name: "ShareNetworkIcon",
  }, 
  {
    id: "phosphor:ShieldCheckIcon", 
    tags: ["phosphor", "shield", "check"], 
    source: "phosphor", 
    name: "ShieldCheckIcon",
  }, 
  {
    id: "phosphor:ShieldCheckeredIcon", 
    tags: ["phosphor", "shield", "checkered"], 
    source: "phosphor", 
    name: "ShieldCheckeredIcon",
  }, 
  {
    id: "phosphor:ShieldChevronIcon", 
    tags: ["phosphor", "shield", "chevron"], 
    source: "phosphor", 
    name: "ShieldChevronIcon",
  }, 
  {
    id: "phosphor:ShieldIcon", 
    tags: ["phosphor", "shield"], 
    source: "phosphor", 
    name: "ShieldIcon",
  }, 
  {
    id: "phosphor:ShieldPlusIcon", 
    tags: ["phosphor", "shield", "plus"], 
    source: "phosphor", 
    name: "ShieldPlusIcon",
  }, 
  {
    id: "phosphor:ShieldSlashIcon", 
    tags: ["phosphor", "shield", "slash"], 
    source: "phosphor", 
    name: "ShieldSlashIcon",
  }, 
  {
    id: "phosphor:ShieldStarIcon", 
    tags: ["phosphor", "shield", "star"], 
    source: "phosphor", 
    name: "ShieldStarIcon",
  }, 
  {
    id: "phosphor:ShieldWarningIcon", 
    tags: ["phosphor", "shield", "warning"], 
    source: "phosphor", 
    name: "ShieldWarningIcon",
  }, 
  {
    id: "phosphor:ShippingContainerIcon", 
    tags: ["phosphor", "shipping", "container"], 
    source: "phosphor", 
    name: "ShippingContainerIcon",
  }, 
  {
    id: "phosphor:ShirtFoldedIcon", 
    tags: ["phosphor", "shirt", "folded"], 
    source: "phosphor", 
    name: "ShirtFoldedIcon",
  }, 
  {
    id: "phosphor:ShootingStarIcon", 
    tags: ["phosphor", "shooting", "star"], 
    source: "phosphor", 
    name: "ShootingStarIcon",
  }, 
  {
    id: "phosphor:ShoppingBagIcon", 
    tags: ["phosphor", "shopping", "bag"], 
    source: "phosphor", 
    name: "ShoppingBagIcon",
  }, 
  {
    id: "phosphor:ShoppingBagOpenIcon", 
    tags: ["phosphor", "shopping", "bag", "open"], 
    source: "phosphor", 
    name: "ShoppingBagOpenIcon",
  }, 
  {
    id: "phosphor:ShoppingCartIcon", 
    tags: ["phosphor", "shopping", "cart"], 
    source: "phosphor", 
    name: "ShoppingCartIcon",
  }, 
  {
    id: "phosphor:ShoppingCartSimpleIcon", 
    tags: ["phosphor", "shopping", "cart", "simple"], 
    source: "phosphor", 
    name: "ShoppingCartSimpleIcon",
  }, 
  {
    id: "phosphor:ShovelIcon", 
    tags: ["phosphor", "shovel"], 
    source: "phosphor", 
    name: "ShovelIcon",
  }, 
  {
    id: "phosphor:ShowerIcon", 
    tags: ["phosphor", "shower"], 
    source: "phosphor", 
    name: "ShowerIcon",
  }, 
  {
    id: "phosphor:ShrimpIcon", 
    tags: ["phosphor", "shrimp"], 
    source: "phosphor", 
    name: "ShrimpIcon",
  }, 
  {
    id: "phosphor:ShuffleAngularIcon", 
    tags: ["phosphor", "shuffle", "angular"], 
    source: "phosphor", 
    name: "ShuffleAngularIcon",
  }, 
  {
    id: "phosphor:ShuffleIcon", 
    tags: ["phosphor", "shuffle"], 
    source: "phosphor", 
    name: "ShuffleIcon",
  }, 
  {
    id: "phosphor:ShuffleSimpleIcon", 
    tags: ["phosphor", "shuffle", "simple"], 
    source: "phosphor", 
    name: "ShuffleSimpleIcon",
  }, 
  {
    id: "phosphor:SidebarIcon", 
    tags: ["phosphor", "sidebar"], 
    source: "phosphor", 
    name: "SidebarIcon",
  }, 
  {
    id: "phosphor:SidebarSimpleIcon", 
    tags: ["phosphor", "sidebar", "simple"], 
    source: "phosphor", 
    name: "SidebarSimpleIcon",
  }, 
  {
    id: "phosphor:SigmaIcon", 
    tags: ["phosphor", "sigma"], 
    source: "phosphor", 
    name: "SigmaIcon",
  }, 
  {
    id: "phosphor:SignInIcon", 
    tags: ["phosphor", "sign", "in"], 
    source: "phosphor", 
    name: "SignInIcon",
  }, 
  {
    id: "phosphor:SignOutIcon", 
    tags: ["phosphor", "sign", "out"], 
    source: "phosphor", 
    name: "SignOutIcon",
  }, 
  {
    id: "phosphor:SignatureIcon", 
    tags: ["phosphor", "signature"], 
    source: "phosphor", 
    name: "SignatureIcon",
  }, 
  {
    id: "phosphor:SignpostIcon", 
    tags: ["phosphor", "signpost"], 
    source: "phosphor", 
    name: "SignpostIcon",
  }, 
  {
    id: "phosphor:SimCardIcon", 
    tags: ["phosphor", "sim", "card"], 
    source: "phosphor", 
    name: "SimCardIcon",
  }, 
  {
    id: "phosphor:SirenIcon", 
    tags: ["phosphor", "siren"], 
    source: "phosphor", 
    name: "SirenIcon",
  }, 
  {
    id: "phosphor:SketchLogoIcon", 
    tags: ["phosphor", "sketch", "logo"], 
    source: "phosphor", 
    name: "SketchLogoIcon",
  }, 
  {
    id: "phosphor:SkipBackCircleIcon", 
    tags: ["phosphor", "skip", "back", "circle"], 
    source: "phosphor", 
    name: "SkipBackCircleIcon",
  }, 
  {
    id: "phosphor:SkipBackIcon", 
    tags: ["phosphor", "skip", "back"], 
    source: "phosphor", 
    name: "SkipBackIcon",
  }, 
  {
    id: "phosphor:SkipForwardCircleIcon", 
    tags: ["phosphor", "skip", "forward", "circle"], 
    source: "phosphor", 
    name: "SkipForwardCircleIcon",
  }, 
  {
    id: "phosphor:SkipForwardIcon", 
    tags: ["phosphor", "skip", "forward"], 
    source: "phosphor", 
    name: "SkipForwardIcon",
  }, 
  {
    id: "phosphor:SkullIcon", 
    tags: ["phosphor", "skull"], 
    source: "phosphor", 
    name: "SkullIcon",
  }, 
  {
    id: "phosphor:SkypeLogoIcon", 
    tags: ["phosphor", "skype", "logo"], 
    source: "phosphor", 
    name: "SkypeLogoIcon",
  }, 
  {
    id: "phosphor:SlackLogoIcon", 
    tags: ["phosphor", "slack", "logo"], 
    source: "phosphor", 
    name: "SlackLogoIcon",
  }, 
  {
    id: "phosphor:SlidersHorizontalIcon", 
    tags: ["phosphor", "sliders", "horizontal"], 
    source: "phosphor", 
    name: "SlidersHorizontalIcon",
  }, 
  {
    id: "phosphor:SlidersIcon", 
    tags: ["phosphor", "sliders"], 
    source: "phosphor", 
    name: "SlidersIcon",
  }, 
  {
    id: "phosphor:SlideshowIcon", 
    tags: ["phosphor", "slideshow"], 
    source: "phosphor", 
    name: "SlideshowIcon",
  }, 
  {
    id: "phosphor:SmileyAngryIcon", 
    tags: ["phosphor", "smiley", "angry"], 
    source: "phosphor", 
    name: "SmileyAngryIcon",
  }, 
  {
    id: "phosphor:SmileyBlankIcon", 
    tags: ["phosphor", "smiley", "blank"], 
    source: "phosphor", 
    name: "SmileyBlankIcon",
  }, 
  {
    id: "phosphor:SmileyIcon", 
    tags: ["phosphor", "smiley"], 
    source: "phosphor", 
    name: "SmileyIcon",
  }, 
  {
    id: "phosphor:SmileyMehIcon", 
    tags: ["phosphor", "smiley", "meh"], 
    source: "phosphor", 
    name: "SmileyMehIcon",
  }, 
  {
    id: "phosphor:SmileyMeltingIcon", 
    tags: ["phosphor", "smiley", "melting"], 
    source: "phosphor", 
    name: "SmileyMeltingIcon",
  }, 
  {
    id: "phosphor:SmileyNervousIcon", 
    tags: ["phosphor", "smiley", "nervous"], 
    source: "phosphor", 
    name: "SmileyNervousIcon",
  }, 
  {
    id: "phosphor:SmileySadIcon", 
    tags: ["phosphor", "smiley", "sad"], 
    source: "phosphor", 
    name: "SmileySadIcon",
  }, 
  {
    id: "phosphor:SmileyStickerIcon", 
    tags: ["phosphor", "smiley", "sticker"], 
    source: "phosphor", 
    name: "SmileyStickerIcon",
  }, 
  {
    id: "phosphor:SmileyWinkIcon", 
    tags: ["phosphor", "smiley", "wink"], 
    source: "phosphor", 
    name: "SmileyWinkIcon",
  }, 
  {
    id: "phosphor:SmileyXEyesIcon", 
    tags: ["phosphor", "smiley", "eyes"], 
    source: "phosphor", 
    name: "SmileyXEyesIcon",
  }, 
  {
    id: "phosphor:SnapchatLogoIcon", 
    tags: ["phosphor", "snapchat", "logo"], 
    source: "phosphor", 
    name: "SnapchatLogoIcon",
  }, 
  {
    id: "phosphor:SneakerIcon", 
    tags: ["phosphor", "sneaker"], 
    source: "phosphor", 
    name: "SneakerIcon",
  }, 
  {
    id: "phosphor:SneakerMoveIcon", 
    tags: ["phosphor", "sneaker", "move"], 
    source: "phosphor", 
    name: "SneakerMoveIcon",
  }, 
  {
    id: "phosphor:SnowflakeIcon", 
    tags: ["phosphor", "snowflake"], 
    source: "phosphor", 
    name: "SnowflakeIcon",
  }, 
  {
    id: "phosphor:SoccerBallIcon", 
    tags: ["phosphor", "soccer", "ball"], 
    source: "phosphor", 
    name: "SoccerBallIcon",
  }, 
  {
    id: "phosphor:SockIcon", 
    tags: ["phosphor", "sock"], 
    source: "phosphor", 
    name: "SockIcon",
  }, 
  {
    id: "phosphor:SolarPanelIcon", 
    tags: ["phosphor", "solar", "panel"], 
    source: "phosphor", 
    name: "SolarPanelIcon",
  }, 
  {
    id: "phosphor:SolarRoofIcon", 
    tags: ["phosphor", "solar", "roof"], 
    source: "phosphor", 
    name: "SolarRoofIcon",
  }, 
  {
    id: "phosphor:SortAscendingIcon", 
    tags: ["phosphor", "sort", "ascending"], 
    source: "phosphor", 
    name: "SortAscendingIcon",
  }, 
  {
    id: "phosphor:SortDescendingIcon", 
    tags: ["phosphor", "sort", "descending"], 
    source: "phosphor", 
    name: "SortDescendingIcon",
  }, 
  {
    id: "phosphor:SoundcloudLogoIcon", 
    tags: ["phosphor", "soundcloud", "logo"], 
    source: "phosphor", 
    name: "SoundcloudLogoIcon",
  }, 
  {
    id: "phosphor:SpadeIcon", 
    tags: ["phosphor", "spade"], 
    source: "phosphor", 
    name: "SpadeIcon",
  }, 
  {
    id: "phosphor:SparkleIcon", 
    tags: ["phosphor", "sparkle"], 
    source: "phosphor", 
    name: "SparkleIcon",
  }, 
  {
    id: "phosphor:SpeakerHifiIcon", 
    tags: ["phosphor", "speaker", "hifi"], 
    source: "phosphor", 
    name: "SpeakerHifiIcon",
  }, 
  {
    id: "phosphor:SpeakerHighIcon", 
    tags: ["phosphor", "speaker", "high"], 
    source: "phosphor", 
    name: "SpeakerHighIcon",
  }, 
  {
    id: "phosphor:SpeakerLowIcon", 
    tags: ["phosphor", "speaker", "low"], 
    source: "phosphor", 
    name: "SpeakerLowIcon",
  }, 
  {
    id: "phosphor:SpeakerNoneIcon", 
    tags: ["phosphor", "speaker", "none"], 
    source: "phosphor", 
    name: "SpeakerNoneIcon",
  }, 
  {
    id: "phosphor:SpeakerSimpleHighIcon", 
    tags: ["phosphor", "speaker", "simple", "high"], 
    source: "phosphor", 
    name: "SpeakerSimpleHighIcon",
  }, 
  {
    id: "phosphor:SpeakerSimpleLowIcon", 
    tags: ["phosphor", "speaker", "simple", "low"], 
    source: "phosphor", 
    name: "SpeakerSimpleLowIcon",
  }, 
  {
    id: "phosphor:SpeakerSimpleNoneIcon", 
    tags: ["phosphor", "speaker", "simple", "none"], 
    source: "phosphor", 
    name: "SpeakerSimpleNoneIcon",
  }, 
  {
    id: "phosphor:SpeakerSimpleSlashIcon", 
    tags: ["phosphor", "speaker", "simple", "slash"], 
    source: "phosphor", 
    name: "SpeakerSimpleSlashIcon",
  }, 
  {
    id: "phosphor:SpeakerSimpleXIcon", 
    tags: ["phosphor", "speaker", "simple"], 
    source: "phosphor", 
    name: "SpeakerSimpleXIcon",
  }, 
  {
    id: "phosphor:SpeakerSlashIcon", 
    tags: ["phosphor", "speaker", "slash"], 
    source: "phosphor", 
    name: "SpeakerSlashIcon",
  }, 
  {
    id: "phosphor:SpeakerXIcon", 
    tags: ["phosphor", "speaker"], 
    source: "phosphor", 
    name: "SpeakerXIcon",
  }, 
  {
    id: "phosphor:SpeedometerIcon", 
    tags: ["phosphor", "speedometer"], 
    source: "phosphor", 
    name: "SpeedometerIcon",
  }, 
  {
    id: "phosphor:SphereIcon", 
    tags: ["phosphor", "sphere"], 
    source: "phosphor", 
    name: "SphereIcon",
  }, 
  {
    id: "phosphor:SpinnerBallIcon", 
    tags: ["phosphor", "spinner", "ball"], 
    source: "phosphor", 
    name: "SpinnerBallIcon",
  }, 
  {
    id: "phosphor:SpinnerGapIcon", 
    tags: ["phosphor", "spinner", "gap"], 
    source: "phosphor", 
    name: "SpinnerGapIcon",
  }, 
  {
    id: "phosphor:SpinnerIcon", 
    tags: ["phosphor", "spinner"], 
    source: "phosphor", 
    name: "SpinnerIcon",
  }, 
  {
    id: "phosphor:SpiralIcon", 
    tags: ["phosphor", "spiral"], 
    source: "phosphor", 
    name: "SpiralIcon",
  }, 
  {
    id: "phosphor:SplitHorizontalIcon", 
    tags: ["phosphor", "split", "horizontal"], 
    source: "phosphor", 
    name: "SplitHorizontalIcon",
  }, 
  {
    id: "phosphor:SplitVerticalIcon", 
    tags: ["phosphor", "split", "vertical"], 
    source: "phosphor", 
    name: "SplitVerticalIcon",
  }, 
  {
    id: "phosphor:SpotifyLogoIcon", 
    tags: ["phosphor", "spotify", "logo"], 
    source: "phosphor", 
    name: "SpotifyLogoIcon",
  }, 
  {
    id: "phosphor:SprayBottleIcon", 
    tags: ["phosphor", "spray", "bottle"], 
    source: "phosphor", 
    name: "SprayBottleIcon",
  }, 
  {
    id: "phosphor:SquareHalfBottomIcon", 
    tags: ["phosphor", "square", "half", "bottom"], 
    source: "phosphor", 
    name: "SquareHalfBottomIcon",
  }, 
  {
    id: "phosphor:SquareHalfIcon", 
    tags: ["phosphor", "square", "half"], 
    source: "phosphor", 
    name: "SquareHalfIcon",
  }, 
  {
    id: "phosphor:SquareIcon", 
    tags: ["phosphor", "square"], 
    source: "phosphor", 
    name: "SquareIcon",
  }, 
  {
    id: "phosphor:SquareLogoIcon", 
    tags: ["phosphor", "square", "logo"], 
    source: "phosphor", 
    name: "SquareLogoIcon",
  }, 
  {
    id: "phosphor:SquareSplitHorizontalIcon", 
    tags: ["phosphor", "square", "split", "horizontal"], 
    source: "phosphor", 
    name: "SquareSplitHorizontalIcon",
  }, 
  {
    id: "phosphor:SquareSplitVerticalIcon", 
    tags: ["phosphor", "square", "split", "vertical"], 
    source: "phosphor", 
    name: "SquareSplitVerticalIcon",
  }, 
  {
    id: "phosphor:SquaresFourIcon", 
    tags: ["phosphor", "squares", "four"], 
    source: "phosphor", 
    name: "SquaresFourIcon",
  }, 
  {
    id: "phosphor:StackIcon", 
    tags: ["phosphor", "stack"], 
    source: "phosphor", 
    name: "StackIcon",
  }, 
  {
    id: "phosphor:StackMinusIcon", 
    tags: ["phosphor", "stack", "minus"], 
    source: "phosphor", 
    name: "StackMinusIcon",
  }, 
  {
    id: "phosphor:StackOverflowLogoIcon", 
    tags: ["phosphor", "stack", "overflow", "logo"], 
    source: "phosphor", 
    name: "StackOverflowLogoIcon",
  }, 
  {
    id: "phosphor:StackPlusIcon", 
    tags: ["phosphor", "stack", "plus"], 
    source: "phosphor", 
    name: "StackPlusIcon",
  }, 
  {
    id: "phosphor:StackSimpleIcon", 
    tags: ["phosphor", "stack", "simple"], 
    source: "phosphor", 
    name: "StackSimpleIcon",
  }, 
  {
    id: "phosphor:StairsIcon", 
    tags: ["phosphor", "stairs"], 
    source: "phosphor", 
    name: "StairsIcon",
  }, 
  {
    id: "phosphor:StampIcon", 
    tags: ["phosphor", "stamp"], 
    source: "phosphor", 
    name: "StampIcon",
  }, 
  {
    id: "phosphor:StandardDefinitionIcon", 
    tags: ["phosphor", "standard", "definition"], 
    source: "phosphor", 
    name: "StandardDefinitionIcon",
  }, 
  {
    id: "phosphor:StarAndCrescentIcon", 
    tags: ["phosphor", "star", "and", "crescent"], 
    source: "phosphor", 
    name: "StarAndCrescentIcon",
  }, 
  {
    id: "phosphor:StarFourIcon", 
    tags: ["phosphor", "star", "four"], 
    source: "phosphor", 
    name: "StarFourIcon",
  }, 
  {
    id: "phosphor:StarHalfIcon", 
    tags: ["phosphor", "star", "half"], 
    source: "phosphor", 
    name: "StarHalfIcon",
  }, 
  {
    id: "phosphor:StarIcon", 
    tags: ["phosphor", "star"], 
    source: "phosphor", 
    name: "StarIcon",
  }, 
  {
    id: "phosphor:StarOfDavidIcon", 
    tags: ["phosphor", "star", "of", "david"], 
    source: "phosphor", 
    name: "StarOfDavidIcon",
  }, 
  {
    id: "phosphor:SteamLogoIcon", 
    tags: ["phosphor", "steam", "logo"], 
    source: "phosphor", 
    name: "SteamLogoIcon",
  }, 
  {
    id: "phosphor:SteeringWheelIcon", 
    tags: ["phosphor", "steering", "wheel"], 
    source: "phosphor", 
    name: "SteeringWheelIcon",
  }, 
  {
    id: "phosphor:StepsIcon", 
    tags: ["phosphor", "steps"], 
    source: "phosphor", 
    name: "StepsIcon",
  }, 
  {
    id: "phosphor:StethoscopeIcon", 
    tags: ["phosphor", "stethoscope"], 
    source: "phosphor", 
    name: "StethoscopeIcon",
  }, 
  {
    id: "phosphor:StickerIcon", 
    tags: ["phosphor", "sticker"], 
    source: "phosphor", 
    name: "StickerIcon",
  }, 
  {
    id: "phosphor:StoolIcon", 
    tags: ["phosphor", "stool"], 
    source: "phosphor", 
    name: "StoolIcon",
  }, 
  {
    id: "phosphor:StopCircleIcon", 
    tags: ["phosphor", "stop", "circle"], 
    source: "phosphor", 
    name: "StopCircleIcon",
  }, 
  {
    id: "phosphor:StopIcon", 
    tags: ["phosphor", "stop"], 
    source: "phosphor", 
    name: "StopIcon",
  }, 
  {
    id: "phosphor:StorefrontIcon", 
    tags: ["phosphor", "storefront"], 
    source: "phosphor", 
    name: "StorefrontIcon",
  }, 
  {
    id: "phosphor:StrategyIcon", 
    tags: ["phosphor", "strategy"], 
    source: "phosphor", 
    name: "StrategyIcon",
  }, 
  {
    id: "phosphor:StripeLogoIcon", 
    tags: ["phosphor", "stripe", "logo"], 
    source: "phosphor", 
    name: "StripeLogoIcon",
  }, 
  {
    id: "phosphor:StudentIcon", 
    tags: ["phosphor", "student"], 
    source: "phosphor", 
    name: "StudentIcon",
  }, 
  {
    id: "phosphor:SubsetOfIcon", 
    tags: ["phosphor", "subset", "of"], 
    source: "phosphor", 
    name: "SubsetOfIcon",
  }, 
  {
    id: "phosphor:SubsetProperOfIcon", 
    tags: ["phosphor", "subset", "proper", "of"], 
    source: "phosphor", 
    name: "SubsetProperOfIcon",
  }, 
  {
    id: "phosphor:SubtitlesIcon", 
    tags: ["phosphor", "subtitles"], 
    source: "phosphor", 
    name: "SubtitlesIcon",
  }, 
  {
    id: "phosphor:SubtitlesSlashIcon", 
    tags: ["phosphor", "subtitles", "slash"], 
    source: "phosphor", 
    name: "SubtitlesSlashIcon",
  }, 
  {
    id: "phosphor:SubtractIcon", 
    tags: ["phosphor", "subtract"], 
    source: "phosphor", 
    name: "SubtractIcon",
  }, 
  {
    id: "phosphor:SubtractSquareIcon", 
    tags: ["phosphor", "subtract", "square"], 
    source: "phosphor", 
    name: "SubtractSquareIcon",
  }, 
  {
    id: "phosphor:SubwayIcon", 
    tags: ["phosphor", "subway"], 
    source: "phosphor", 
    name: "SubwayIcon",
  }, 
  {
    id: "phosphor:SuitcaseIcon", 
    tags: ["phosphor", "suitcase"], 
    source: "phosphor", 
    name: "SuitcaseIcon",
  }, 
  {
    id: "phosphor:SuitcaseRollingIcon", 
    tags: ["phosphor", "suitcase", "rolling"], 
    source: "phosphor", 
    name: "SuitcaseRollingIcon",
  }, 
  {
    id: "phosphor:SuitcaseSimpleIcon", 
    tags: ["phosphor", "suitcase", "simple"], 
    source: "phosphor", 
    name: "SuitcaseSimpleIcon",
  }, 
  {
    id: "phosphor:SunDimIcon", 
    tags: ["phosphor", "sun", "dim"], 
    source: "phosphor", 
    name: "SunDimIcon",
  }, 
  {
    id: "phosphor:SunHorizonIcon", 
    tags: ["phosphor", "sun", "horizon"], 
    source: "phosphor", 
    name: "SunHorizonIcon",
  }, 
  {
    id: "phosphor:SunIcon", 
    tags: ["phosphor", "sun"], 
    source: "phosphor", 
    name: "SunIcon",
  }, 
  {
    id: "phosphor:SunglassesIcon", 
    tags: ["phosphor", "sunglasses"], 
    source: "phosphor", 
    name: "SunglassesIcon",
  }, 
  {
    id: "phosphor:SupersetOfIcon", 
    tags: ["phosphor", "superset", "of"], 
    source: "phosphor", 
    name: "SupersetOfIcon",
  }, 
  {
    id: "phosphor:SupersetProperOfIcon", 
    tags: ["phosphor", "superset", "proper", "of"], 
    source: "phosphor", 
    name: "SupersetProperOfIcon",
  }, 
  {
    id: "phosphor:SwapIcon", 
    tags: ["phosphor", "swap"], 
    source: "phosphor", 
    name: "SwapIcon",
  }, 
  {
    id: "phosphor:SwatchesIcon", 
    tags: ["phosphor", "swatches"], 
    source: "phosphor", 
    name: "SwatchesIcon",
  }, 
  {
    id: "phosphor:SwimmingPoolIcon", 
    tags: ["phosphor", "swimming", "pool"], 
    source: "phosphor", 
    name: "SwimmingPoolIcon",
  }, 
  {
    id: "phosphor:SwordIcon", 
    tags: ["phosphor", "sword"], 
    source: "phosphor", 
    name: "SwordIcon",
  }, 
  {
    id: "phosphor:SynagogueIcon", 
    tags: ["phosphor", "synagogue"], 
    source: "phosphor", 
    name: "SynagogueIcon",
  }, 
  {
    id: "phosphor:SyringeIcon", 
    tags: ["phosphor", "syringe"], 
    source: "phosphor", 
    name: "SyringeIcon",
  }, 
  {
    id: "phosphor:TShirtIcon", 
    tags: ["phosphor", "shirt"], 
    source: "phosphor", 
    name: "TShirtIcon",
  }, 
  {
    id: "phosphor:TableIcon", 
    tags: ["phosphor", "table"], 
    source: "phosphor", 
    name: "TableIcon",
  }, 
  {
    id: "phosphor:TabsIcon", 
    tags: ["phosphor", "tabs"], 
    source: "phosphor", 
    name: "TabsIcon",
  }, 
  {
    id: "phosphor:TagChevronIcon", 
    tags: ["phosphor", "tag", "chevron"], 
    source: "phosphor", 
    name: "TagChevronIcon",
  }, 
  {
    id: "phosphor:TagIcon", 
    tags: ["phosphor", "tag"], 
    source: "phosphor", 
    name: "TagIcon",
  }, 
  {
    id: "phosphor:TagSimpleIcon", 
    tags: ["phosphor", "tag", "simple"], 
    source: "phosphor", 
    name: "TagSimpleIcon",
  }, 
  {
    id: "phosphor:TargetIcon", 
    tags: ["phosphor", "target"], 
    source: "phosphor", 
    name: "TargetIcon",
  }, 
  {
    id: "phosphor:TaxiIcon", 
    tags: ["phosphor", "taxi"], 
    source: "phosphor", 
    name: "TaxiIcon",
  }, 
  {
    id: "phosphor:TeaBagIcon", 
    tags: ["phosphor", "tea", "bag"], 
    source: "phosphor", 
    name: "TeaBagIcon",
  }, 
  {
    id: "phosphor:TelegramLogoIcon", 
    tags: ["phosphor", "telegram", "logo"], 
    source: "phosphor", 
    name: "TelegramLogoIcon",
  }, 
  {
    id: "phosphor:TelevisionIcon", 
    tags: ["phosphor", "television"], 
    source: "phosphor", 
    name: "TelevisionIcon",
  }, 
  {
    id: "phosphor:TelevisionSimpleIcon", 
    tags: ["phosphor", "television", "simple"], 
    source: "phosphor", 
    name: "TelevisionSimpleIcon",
  }, 
  {
    id: "phosphor:TennisBallIcon", 
    tags: ["phosphor", "tennis", "ball"], 
    source: "phosphor", 
    name: "TennisBallIcon",
  }, 
  {
    id: "phosphor:TentIcon", 
    tags: ["phosphor", "tent"], 
    source: "phosphor", 
    name: "TentIcon",
  }, 
  {
    id: "phosphor:TerminalIcon", 
    tags: ["phosphor", "terminal"], 
    source: "phosphor", 
    name: "TerminalIcon",
  }, 
  {
    id: "phosphor:TerminalWindowIcon", 
    tags: ["phosphor", "terminal", "window"], 
    source: "phosphor", 
    name: "TerminalWindowIcon",
  }, 
  {
    id: "phosphor:TestTubeIcon", 
    tags: ["phosphor", "test", "tube"], 
    source: "phosphor", 
    name: "TestTubeIcon",
  }, 
  {
    id: "phosphor:TextAUnderlineIcon", 
    tags: ["phosphor", "text", "underline"], 
    source: "phosphor", 
    name: "TextAUnderlineIcon",
  }, 
  {
    id: "phosphor:TextAaIcon", 
    tags: ["phosphor", "text", "aa"], 
    source: "phosphor", 
    name: "TextAaIcon",
  }, 
  {
    id: "phosphor:TextAlignCenterIcon", 
    tags: ["phosphor", "text", "align", "center"], 
    source: "phosphor", 
    name: "TextAlignCenterIcon",
  }, 
  {
    id: "phosphor:TextAlignJustifyIcon", 
    tags: ["phosphor", "text", "align", "justify"], 
    source: "phosphor", 
    name: "TextAlignJustifyIcon",
  }, 
  {
    id: "phosphor:TextAlignLeftIcon", 
    tags: ["phosphor", "text", "align", "left"], 
    source: "phosphor", 
    name: "TextAlignLeftIcon",
  }, 
  {
    id: "phosphor:TextAlignRightIcon", 
    tags: ["phosphor", "text", "align", "right"], 
    source: "phosphor", 
    name: "TextAlignRightIcon",
  }, 
  {
    id: "phosphor:TextBIcon", 
    tags: ["phosphor", "text"], 
    source: "phosphor", 
    name: "TextBIcon",
  }, 
  {
    id: "phosphor:TextBolderIcon", 
    tags: ["phosphor", "text", "bolder"], 
    source: "phosphor", 
    name: "TextBolderIcon",
  }, 
  {
    id: "phosphor:TextColumnsIcon", 
    tags: ["phosphor", "text", "columns"], 
    source: "phosphor", 
    name: "TextColumnsIcon",
  }, 
  {
    id: "phosphor:TextHFiveIcon", 
    tags: ["phosphor", "text", "five"], 
    source: "phosphor", 
    name: "TextHFiveIcon",
  }, 
  {
    id: "phosphor:TextHFourIcon", 
    tags: ["phosphor", "text", "four"], 
    source: "phosphor", 
    name: "TextHFourIcon",
  }, 
  {
    id: "phosphor:TextHIcon", 
    tags: ["phosphor", "text"], 
    source: "phosphor", 
    name: "TextHIcon",
  }, 
  {
    id: "phosphor:TextHOneIcon", 
    tags: ["phosphor", "text", "one"], 
    source: "phosphor", 
    name: "TextHOneIcon",
  }, 
  {
    id: "phosphor:TextHSixIcon", 
    tags: ["phosphor", "text", "six"], 
    source: "phosphor", 
    name: "TextHSixIcon",
  }, 
  {
    id: "phosphor:TextHThreeIcon", 
    tags: ["phosphor", "text", "three"], 
    source: "phosphor", 
    name: "TextHThreeIcon",
  }, 
  {
    id: "phosphor:TextHTwoIcon", 
    tags: ["phosphor", "text", "two"], 
    source: "phosphor", 
    name: "TextHTwoIcon",
  }, 
  {
    id: "phosphor:TextIndentIcon", 
    tags: ["phosphor", "text", "indent"], 
    source: "phosphor", 
    name: "TextIndentIcon",
  }, 
  {
    id: "phosphor:TextItalicIcon", 
    tags: ["phosphor", "text", "italic"], 
    source: "phosphor", 
    name: "TextItalicIcon",
  }, 
  {
    id: "phosphor:TextOutdentIcon", 
    tags: ["phosphor", "text", "outdent"], 
    source: "phosphor", 
    name: "TextOutdentIcon",
  }, 
  {
    id: "phosphor:TextStrikethroughIcon", 
    tags: ["phosphor", "text", "strikethrough"], 
    source: "phosphor", 
    name: "TextStrikethroughIcon",
  }, 
  {
    id: "phosphor:TextSubscriptIcon", 
    tags: ["phosphor", "text", "subscript"], 
    source: "phosphor", 
    name: "TextSubscriptIcon",
  }, 
  {
    id: "phosphor:TextSuperscriptIcon", 
    tags: ["phosphor", "text", "superscript"], 
    source: "phosphor", 
    name: "TextSuperscriptIcon",
  }, 
  {
    id: "phosphor:TextTIcon", 
    tags: ["phosphor", "text"], 
    source: "phosphor", 
    name: "TextTIcon",
  }, 
  {
    id: "phosphor:TextTSlashIcon", 
    tags: ["phosphor", "text", "slash"], 
    source: "phosphor", 
    name: "TextTSlashIcon",
  }, 
  {
    id: "phosphor:TextUnderlineIcon", 
    tags: ["phosphor", "text", "underline"], 
    source: "phosphor", 
    name: "TextUnderlineIcon",
  }, 
  {
    id: "phosphor:TextboxIcon", 
    tags: ["phosphor", "textbox"], 
    source: "phosphor", 
    name: "TextboxIcon",
  }, 
  {
    id: "phosphor:ThermometerColdIcon", 
    tags: ["phosphor", "thermometer", "cold"], 
    source: "phosphor", 
    name: "ThermometerColdIcon",
  }, 
  {
    id: "phosphor:ThermometerHotIcon", 
    tags: ["phosphor", "thermometer", "hot"], 
    source: "phosphor", 
    name: "ThermometerHotIcon",
  }, 
  {
    id: "phosphor:ThermometerIcon", 
    tags: ["phosphor", "thermometer"], 
    source: "phosphor", 
    name: "ThermometerIcon",
  }, 
  {
    id: "phosphor:ThermometerSimpleIcon", 
    tags: ["phosphor", "thermometer", "simple"], 
    source: "phosphor", 
    name: "ThermometerSimpleIcon",
  }, 
  {
    id: "phosphor:ThreadsLogoIcon", 
    tags: ["phosphor", "threads", "logo"], 
    source: "phosphor", 
    name: "ThreadsLogoIcon",
  }, 
  {
    id: "phosphor:ThreeDIcon", 
    tags: ["phosphor", "three"], 
    source: "phosphor", 
    name: "ThreeDIcon",
  }, 
  {
    id: "phosphor:ThumbsDownIcon", 
    tags: ["phosphor", "thumbs", "down"], 
    source: "phosphor", 
    name: "ThumbsDownIcon",
  }, 
  {
    id: "phosphor:ThumbsUpIcon", 
    tags: ["phosphor", "thumbs", "up"], 
    source: "phosphor", 
    name: "ThumbsUpIcon",
  }, 
  {
    id: "phosphor:TicketIcon", 
    tags: ["phosphor", "ticket"], 
    source: "phosphor", 
    name: "TicketIcon",
  }, 
  {
    id: "phosphor:TidalLogoIcon", 
    tags: ["phosphor", "tidal", "logo"], 
    source: "phosphor", 
    name: "TidalLogoIcon",
  }, 
  {
    id: "phosphor:TiktokLogoIcon", 
    tags: ["phosphor", "tiktok", "logo"], 
    source: "phosphor", 
    name: "TiktokLogoIcon",
  }, 
  {
    id: "phosphor:TildeIcon", 
    tags: ["phosphor", "tilde"], 
    source: "phosphor", 
    name: "TildeIcon",
  }, 
  {
    id: "phosphor:TimerIcon", 
    tags: ["phosphor", "timer"], 
    source: "phosphor", 
    name: "TimerIcon",
  }, 
  {
    id: "phosphor:TipJarIcon", 
    tags: ["phosphor", "tip", "jar"], 
    source: "phosphor", 
    name: "TipJarIcon",
  }, 
  {
    id: "phosphor:TipiIcon", 
    tags: ["phosphor", "tipi"], 
    source: "phosphor", 
    name: "TipiIcon",
  }, 
  {
    id: "phosphor:TireIcon", 
    tags: ["phosphor", "tire"], 
    source: "phosphor", 
    name: "TireIcon",
  }, 
  {
    id: "phosphor:ToggleLeftIcon", 
    tags: ["phosphor", "toggle", "left"], 
    source: "phosphor", 
    name: "ToggleLeftIcon",
  }, 
  {
    id: "phosphor:ToggleRightIcon", 
    tags: ["phosphor", "toggle", "right"], 
    source: "phosphor", 
    name: "ToggleRightIcon",
  }, 
  {
    id: "phosphor:ToiletIcon", 
    tags: ["phosphor", "toilet"], 
    source: "phosphor", 
    name: "ToiletIcon",
  }, 
  {
    id: "phosphor:ToiletPaperIcon", 
    tags: ["phosphor", "toilet", "paper"], 
    source: "phosphor", 
    name: "ToiletPaperIcon",
  }, 
  {
    id: "phosphor:ToolboxIcon", 
    tags: ["phosphor", "toolbox"], 
    source: "phosphor", 
    name: "ToolboxIcon",
  }, 
  {
    id: "phosphor:ToothIcon", 
    tags: ["phosphor", "tooth"], 
    source: "phosphor", 
    name: "ToothIcon",
  }, 
  {
    id: "phosphor:TornadoIcon", 
    tags: ["phosphor", "tornado"], 
    source: "phosphor", 
    name: "TornadoIcon",
  }, 
  {
    id: "phosphor:ToteIcon", 
    tags: ["phosphor", "tote"], 
    source: "phosphor", 
    name: "ToteIcon",
  }, 
  {
    id: "phosphor:ToteSimpleIcon", 
    tags: ["phosphor", "tote", "simple"], 
    source: "phosphor", 
    name: "ToteSimpleIcon",
  }, 
  {
    id: "phosphor:TowelIcon", 
    tags: ["phosphor", "towel"], 
    source: "phosphor", 
    name: "TowelIcon",
  }, 
  {
    id: "phosphor:TractorIcon", 
    tags: ["phosphor", "tractor"], 
    source: "phosphor", 
    name: "TractorIcon",
  }, 
  {
    id: "phosphor:TrademarkIcon", 
    tags: ["phosphor", "trademark"], 
    source: "phosphor", 
    name: "TrademarkIcon",
  }, 
  {
    id: "phosphor:TrademarkRegisteredIcon", 
    tags: ["phosphor", "trademark", "registered"], 
    source: "phosphor", 
    name: "TrademarkRegisteredIcon",
  }, 
  {
    id: "phosphor:TrafficConeIcon", 
    tags: ["phosphor", "traffic", "cone"], 
    source: "phosphor", 
    name: "TrafficConeIcon",
  }, 
  {
    id: "phosphor:TrafficSignIcon", 
    tags: ["phosphor", "traffic", "sign"], 
    source: "phosphor", 
    name: "TrafficSignIcon",
  }, 
  {
    id: "phosphor:TrafficSignalIcon", 
    tags: ["phosphor", "traffic", "signal"], 
    source: "phosphor", 
    name: "TrafficSignalIcon",
  }, 
  {
    id: "phosphor:TrainIcon", 
    tags: ["phosphor", "train"], 
    source: "phosphor", 
    name: "TrainIcon",
  }, 
  {
    id: "phosphor:TrainRegionalIcon", 
    tags: ["phosphor", "train", "regional"], 
    source: "phosphor", 
    name: "TrainRegionalIcon",
  }, 
  {
    id: "phosphor:TrainSimpleIcon", 
    tags: ["phosphor", "train", "simple"], 
    source: "phosphor", 
    name: "TrainSimpleIcon",
  }, 
  {
    id: "phosphor:TramIcon", 
    tags: ["phosphor", "tram"], 
    source: "phosphor", 
    name: "TramIcon",
  }, 
  {
    id: "phosphor:TranslateIcon", 
    tags: ["phosphor", "translate"], 
    source: "phosphor", 
    name: "TranslateIcon",
  }, 
  {
    id: "phosphor:TrashIcon", 
    tags: ["phosphor", "trash"], 
    source: "phosphor", 
    name: "TrashIcon",
  }, 
  {
    id: "phosphor:TrashSimpleIcon", 
    tags: ["phosphor", "trash", "simple"], 
    source: "phosphor", 
    name: "TrashSimpleIcon",
  }, 
  {
    id: "phosphor:TrayArrowDownIcon", 
    tags: ["phosphor", "tray", "arrow", "down"], 
    source: "phosphor", 
    name: "TrayArrowDownIcon",
  }, 
  {
    id: "phosphor:TrayArrowUpIcon", 
    tags: ["phosphor", "tray", "arrow", "up"], 
    source: "phosphor", 
    name: "TrayArrowUpIcon",
  }, 
  {
    id: "phosphor:TrayIcon", 
    tags: ["phosphor", "tray"], 
    source: "phosphor", 
    name: "TrayIcon",
  }, 
  {
    id: "phosphor:TreasureChestIcon", 
    tags: ["phosphor", "treasure", "chest"], 
    source: "phosphor", 
    name: "TreasureChestIcon",
  }, 
  {
    id: "phosphor:TreeEvergreenIcon", 
    tags: ["phosphor", "tree", "evergreen"], 
    source: "phosphor", 
    name: "TreeEvergreenIcon",
  }, 
  {
    id: "phosphor:TreeIcon", 
    tags: ["phosphor", "tree"], 
    source: "phosphor", 
    name: "TreeIcon",
  }, 
  {
    id: "phosphor:TreePalmIcon", 
    tags: ["phosphor", "tree", "palm"], 
    source: "phosphor", 
    name: "TreePalmIcon",
  }, 
  {
    id: "phosphor:TreeStructureIcon", 
    tags: ["phosphor", "tree", "structure"], 
    source: "phosphor", 
    name: "TreeStructureIcon",
  }, 
  {
    id: "phosphor:TreeViewIcon", 
    tags: ["phosphor", "tree", "view"], 
    source: "phosphor", 
    name: "TreeViewIcon",
  }, 
  {
    id: "phosphor:TrendDownIcon", 
    tags: ["phosphor", "trend", "down"], 
    source: "phosphor", 
    name: "TrendDownIcon",
  }, 
  {
    id: "phosphor:TrendUpIcon", 
    tags: ["phosphor", "trend", "up"], 
    source: "phosphor", 
    name: "TrendUpIcon",
  }, 
  {
    id: "phosphor:TriangleDashedIcon", 
    tags: ["phosphor", "triangle", "dashed"], 
    source: "phosphor", 
    name: "TriangleDashedIcon",
  }, 
  {
    id: "phosphor:TriangleIcon", 
    tags: ["phosphor", "triangle"], 
    source: "phosphor", 
    name: "TriangleIcon",
  }, 
  {
    id: "phosphor:TrolleyIcon", 
    tags: ["phosphor", "trolley"], 
    source: "phosphor", 
    name: "TrolleyIcon",
  }, 
  {
    id: "phosphor:TrolleySuitcaseIcon", 
    tags: ["phosphor", "trolley", "suitcase"], 
    source: "phosphor", 
    name: "TrolleySuitcaseIcon",
  }, 
  {
    id: "phosphor:TrophyIcon", 
    tags: ["phosphor", "trophy"], 
    source: "phosphor", 
    name: "TrophyIcon",
  }, 
  {
    id: "phosphor:TruckIcon", 
    tags: ["phosphor", "truck"], 
    source: "phosphor", 
    name: "TruckIcon",
  }, 
  {
    id: "phosphor:TruckTrailerIcon", 
    tags: ["phosphor", "truck", "trailer"], 
    source: "phosphor", 
    name: "TruckTrailerIcon",
  }, 
  {
    id: "phosphor:TumblrLogoIcon", 
    tags: ["phosphor", "tumblr", "logo"], 
    source: "phosphor", 
    name: "TumblrLogoIcon",
  }, 
  {
    id: "phosphor:TwitchLogoIcon", 
    tags: ["phosphor", "twitch", "logo"], 
    source: "phosphor", 
    name: "TwitchLogoIcon",
  }, 
  {
    id: "phosphor:TwitterLogoIcon", 
    tags: ["phosphor", "twitter", "logo"], 
    source: "phosphor", 
    name: "TwitterLogoIcon",
  }, 
  {
    id: "phosphor:UmbrellaIcon", 
    tags: ["phosphor", "umbrella"], 
    source: "phosphor", 
    name: "UmbrellaIcon",
  }, 
  {
    id: "phosphor:UmbrellaSimpleIcon", 
    tags: ["phosphor", "umbrella", "simple"], 
    source: "phosphor", 
    name: "UmbrellaSimpleIcon",
  }, 
  {
    id: "phosphor:UnionIcon", 
    tags: ["phosphor", "union"], 
    source: "phosphor", 
    name: "UnionIcon",
  }, 
  {
    id: "phosphor:UniteIcon", 
    tags: ["phosphor", "unite"], 
    source: "phosphor", 
    name: "UniteIcon",
  }, 
  {
    id: "phosphor:UniteSquareIcon", 
    tags: ["phosphor", "unite", "square"], 
    source: "phosphor", 
    name: "UniteSquareIcon",
  }, 
  {
    id: "phosphor:UploadIcon", 
    tags: ["phosphor", "upload"], 
    source: "phosphor", 
    name: "UploadIcon",
  }, 
  {
    id: "phosphor:UploadSimpleIcon", 
    tags: ["phosphor", "upload", "simple"], 
    source: "phosphor", 
    name: "UploadSimpleIcon",
  }, 
  {
    id: "phosphor:UsbIcon", 
    tags: ["phosphor", "usb"], 
    source: "phosphor", 
    name: "UsbIcon",
  }, 
  {
    id: "phosphor:UserCheckIcon", 
    tags: ["phosphor", "user", "check"], 
    source: "phosphor", 
    name: "UserCheckIcon",
  }, 
  {
    id: "phosphor:UserCircleCheckIcon", 
    tags: ["phosphor", "user", "circle", "check"], 
    source: "phosphor", 
    name: "UserCircleCheckIcon",
  }, 
  {
    id: "phosphor:UserCircleDashedIcon", 
    tags: ["phosphor", "user", "circle", "dashed"], 
    source: "phosphor", 
    name: "UserCircleDashedIcon",
  }, 
  {
    id: "phosphor:UserCircleGearIcon", 
    tags: ["phosphor", "user", "circle", "gear"], 
    source: "phosphor", 
    name: "UserCircleGearIcon",
  }, 
  {
    id: "phosphor:UserCircleIcon", 
    tags: ["phosphor", "user", "circle"], 
    source: "phosphor", 
    name: "UserCircleIcon",
  }, 
  {
    id: "phosphor:UserCircleMinusIcon", 
    tags: ["phosphor", "user", "circle", "minus"], 
    source: "phosphor", 
    name: "UserCircleMinusIcon",
  }, 
  {
    id: "phosphor:UserCirclePlusIcon", 
    tags: ["phosphor", "user", "circle", "plus"], 
    source: "phosphor", 
    name: "UserCirclePlusIcon",
  }, 
  {
    id: "phosphor:UserFocusIcon", 
    tags: ["phosphor", "user", "focus"], 
    source: "phosphor", 
    name: "UserFocusIcon",
  }, 
  {
    id: "phosphor:UserGearIcon", 
    tags: ["phosphor", "user", "gear"], 
    source: "phosphor", 
    name: "UserGearIcon",
  }, 
  {
    id: "phosphor:UserIcon", 
    tags: ["phosphor", "user"], 
    source: "phosphor", 
    name: "UserIcon",
  }, 
  {
    id: "phosphor:UserListIcon", 
    tags: ["phosphor", "user", "list"], 
    source: "phosphor", 
    name: "UserListIcon",
  }, 
  {
    id: "phosphor:UserMinusIcon", 
    tags: ["phosphor", "user", "minus"], 
    source: "phosphor", 
    name: "UserMinusIcon",
  }, 
  {
    id: "phosphor:UserPlusIcon", 
    tags: ["phosphor", "user", "plus"], 
    source: "phosphor", 
    name: "UserPlusIcon",
  }, 
  {
    id: "phosphor:UserRectangleIcon", 
    tags: ["phosphor", "user", "rectangle"], 
    source: "phosphor", 
    name: "UserRectangleIcon",
  }, 
  {
    id: "phosphor:UserSoundIcon", 
    tags: ["phosphor", "user", "sound"], 
    source: "phosphor", 
    name: "UserSoundIcon",
  }, 
  {
    id: "phosphor:UserSquareIcon", 
    tags: ["phosphor", "user", "square"], 
    source: "phosphor", 
    name: "UserSquareIcon",
  }, 
  {
    id: "phosphor:UserSwitchIcon", 
    tags: ["phosphor", "user", "switch"], 
    source: "phosphor", 
    name: "UserSwitchIcon",
  }, 
  {
    id: "phosphor:UsersFourIcon", 
    tags: ["phosphor", "users", "four"], 
    source: "phosphor", 
    name: "UsersFourIcon",
  }, 
  {
    id: "phosphor:UsersIcon", 
    tags: ["phosphor", "users"], 
    source: "phosphor", 
    name: "UsersIcon",
  }, 
  {
    id: "phosphor:UsersThreeIcon", 
    tags: ["phosphor", "users", "three"], 
    source: "phosphor", 
    name: "UsersThreeIcon",
  }, 
  {
    id: "phosphor:VanIcon", 
    tags: ["phosphor", "van"], 
    source: "phosphor", 
    name: "VanIcon",
  }, 
  {
    id: "phosphor:VaultIcon", 
    tags: ["phosphor", "vault"], 
    source: "phosphor", 
    name: "VaultIcon",
  }, 
  {
    id: "phosphor:VectorThreeIcon", 
    tags: ["phosphor", "vector", "three"], 
    source: "phosphor", 
    name: "VectorThreeIcon",
  }, 
  {
    id: "phosphor:VectorTwoIcon", 
    tags: ["phosphor", "vector", "two"], 
    source: "phosphor", 
    name: "VectorTwoIcon",
  }, 
  {
    id: "phosphor:VibrateIcon", 
    tags: ["phosphor", "vibrate"], 
    source: "phosphor", 
    name: "VibrateIcon",
  }, 
  {
    id: "phosphor:VideoCameraIcon", 
    tags: ["phosphor", "video", "camera"], 
    source: "phosphor", 
    name: "VideoCameraIcon",
  }, 
  {
    id: "phosphor:VideoCameraSlashIcon", 
    tags: ["phosphor", "video", "camera", "slash"], 
    source: "phosphor", 
    name: "VideoCameraSlashIcon",
  }, 
  {
    id: "phosphor:VideoConferenceIcon", 
    tags: ["phosphor", "video", "conference"], 
    source: "phosphor", 
    name: "VideoConferenceIcon",
  }, 
  {
    id: "phosphor:VideoIcon", 
    tags: ["phosphor", "video"], 
    source: "phosphor", 
    name: "VideoIcon",
  }, 
  {
    id: "phosphor:VignetteIcon", 
    tags: ["phosphor", "vignette"], 
    source: "phosphor", 
    name: "VignetteIcon",
  }, 
  {
    id: "phosphor:VinylRecordIcon", 
    tags: ["phosphor", "vinyl", "record"], 
    source: "phosphor", 
    name: "VinylRecordIcon",
  }, 
  {
    id: "phosphor:VirtualRealityIcon", 
    tags: ["phosphor", "virtual", "reality"], 
    source: "phosphor", 
    name: "VirtualRealityIcon",
  }, 
  {
    id: "phosphor:VirusIcon", 
    tags: ["phosphor", "virus"], 
    source: "phosphor", 
    name: "VirusIcon",
  }, 
  {
    id: "phosphor:VisorIcon", 
    tags: ["phosphor", "visor"], 
    source: "phosphor", 
    name: "VisorIcon",
  }, 
  {
    id: "phosphor:VoicemailIcon", 
    tags: ["phosphor", "voicemail"], 
    source: "phosphor", 
    name: "VoicemailIcon",
  }, 
  {
    id: "phosphor:VolleyballIcon", 
    tags: ["phosphor", "volleyball"], 
    source: "phosphor", 
    name: "VolleyballIcon",
  }, 
  {
    id: "phosphor:WallIcon", 
    tags: ["phosphor", "wall"], 
    source: "phosphor", 
    name: "WallIcon",
  }, 
  {
    id: "phosphor:WalletIcon", 
    tags: ["phosphor", "wallet"], 
    source: "phosphor", 
    name: "WalletIcon",
  }, 
  {
    id: "phosphor:WarehouseIcon", 
    tags: ["phosphor", "warehouse"], 
    source: "phosphor", 
    name: "WarehouseIcon",
  }, 
  {
    id: "phosphor:WarningCircleIcon", 
    tags: ["phosphor", "warning", "circle"], 
    source: "phosphor", 
    name: "WarningCircleIcon",
  }, 
  {
    id: "phosphor:WarningDiamondIcon", 
    tags: ["phosphor", "warning", "diamond"], 
    source: "phosphor", 
    name: "WarningDiamondIcon",
  }, 
  {
    id: "phosphor:WarningIcon", 
    tags: ["phosphor", "warning"], 
    source: "phosphor", 
    name: "WarningIcon",
  }, 
  {
    id: "phosphor:WarningOctagonIcon", 
    tags: ["phosphor", "warning", "octagon"], 
    source: "phosphor", 
    name: "WarningOctagonIcon",
  }, 
  {
    id: "phosphor:WashingMachineIcon", 
    tags: ["phosphor", "washing", "machine"], 
    source: "phosphor", 
    name: "WashingMachineIcon",
  }, 
  {
    id: "phosphor:WatchIcon", 
    tags: ["phosphor", "watch"], 
    source: "phosphor", 
    name: "WatchIcon",
  }, 
  {
    id: "phosphor:WaveSawtoothIcon", 
    tags: ["phosphor", "wave", "sawtooth"], 
    source: "phosphor", 
    name: "WaveSawtoothIcon",
  }, 
  {
    id: "phosphor:WaveSineIcon", 
    tags: ["phosphor", "wave", "sine"], 
    source: "phosphor", 
    name: "WaveSineIcon",
  }, 
  {
    id: "phosphor:WaveSquareIcon", 
    tags: ["phosphor", "wave", "square"], 
    source: "phosphor", 
    name: "WaveSquareIcon",
  }, 
  {
    id: "phosphor:WaveTriangleIcon", 
    tags: ["phosphor", "wave", "triangle"], 
    source: "phosphor", 
    name: "WaveTriangleIcon",
  }, 
  {
    id: "phosphor:WaveformIcon", 
    tags: ["phosphor", "waveform"], 
    source: "phosphor", 
    name: "WaveformIcon",
  }, 
  {
    id: "phosphor:WaveformSlashIcon", 
    tags: ["phosphor", "waveform", "slash"], 
    source: "phosphor", 
    name: "WaveformSlashIcon",
  }, 
  {
    id: "phosphor:WavesIcon", 
    tags: ["phosphor", "waves"], 
    source: "phosphor", 
    name: "WavesIcon",
  }, 
  {
    id: "phosphor:WebcamIcon", 
    tags: ["phosphor", "webcam"], 
    source: "phosphor", 
    name: "WebcamIcon",
  }, 
  {
    id: "phosphor:WebcamSlashIcon", 
    tags: ["phosphor", "webcam", "slash"], 
    source: "phosphor", 
    name: "WebcamSlashIcon",
  }, 
  {
    id: "phosphor:WebhooksLogoIcon", 
    tags: ["phosphor", "webhooks", "logo"], 
    source: "phosphor", 
    name: "WebhooksLogoIcon",
  }, 
  {
    id: "phosphor:WechatLogoIcon", 
    tags: ["phosphor", "wechat", "logo"], 
    source: "phosphor", 
    name: "WechatLogoIcon",
  }, 
  {
    id: "phosphor:WhatsappLogoIcon", 
    tags: ["phosphor", "whatsapp", "logo"], 
    source: "phosphor", 
    name: "WhatsappLogoIcon",
  }, 
  {
    id: "phosphor:WheelchairIcon", 
    tags: ["phosphor", "wheelchair"], 
    source: "phosphor", 
    name: "WheelchairIcon",
  }, 
  {
    id: "phosphor:WheelchairMotionIcon", 
    tags: ["phosphor", "wheelchair", "motion"], 
    source: "phosphor", 
    name: "WheelchairMotionIcon",
  }, 
  {
    id: "phosphor:WifiHighIcon", 
    tags: ["phosphor", "wifi", "high"], 
    source: "phosphor", 
    name: "WifiHighIcon",
  }, 
  {
    id: "phosphor:WifiLowIcon", 
    tags: ["phosphor", "wifi", "low"], 
    source: "phosphor", 
    name: "WifiLowIcon",
  }, 
  {
    id: "phosphor:WifiMediumIcon", 
    tags: ["phosphor", "wifi", "medium"], 
    source: "phosphor", 
    name: "WifiMediumIcon",
  }, 
  {
    id: "phosphor:WifiNoneIcon", 
    tags: ["phosphor", "wifi", "none"], 
    source: "phosphor", 
    name: "WifiNoneIcon",
  }, 
  {
    id: "phosphor:WifiSlashIcon", 
    tags: ["phosphor", "wifi", "slash"], 
    source: "phosphor", 
    name: "WifiSlashIcon",
  }, 
  {
    id: "phosphor:WifiXIcon", 
    tags: ["phosphor", "wifi"], 
    source: "phosphor", 
    name: "WifiXIcon",
  }, 
  {
    id: "phosphor:WindIcon", 
    tags: ["phosphor", "wind"], 
    source: "phosphor", 
    name: "WindIcon",
  }, 
  {
    id: "phosphor:WindmillIcon", 
    tags: ["phosphor", "windmill"], 
    source: "phosphor", 
    name: "WindmillIcon",
  }, 
  {
    id: "phosphor:WindowsLogoIcon", 
    tags: ["phosphor", "windows", "logo"], 
    source: "phosphor", 
    name: "WindowsLogoIcon",
  }, 
  {
    id: "phosphor:WineIcon", 
    tags: ["phosphor", "wine"], 
    source: "phosphor", 
    name: "WineIcon",
  }, 
  {
    id: "phosphor:WrenchIcon", 
    tags: ["phosphor", "wrench"], 
    source: "phosphor", 
    name: "WrenchIcon",
  }, 
  {
    id: "phosphor:XCircleIcon", 
    tags: ["phosphor", "circle"], 
    source: "phosphor", 
    name: "XCircleIcon",
  }, 
  {
    id: "phosphor:XIcon", 
    tags: ["phosphor"], 
    source: "phosphor", 
    name: "XIcon",
  }, 
  {
    id: "phosphor:XLogoIcon", 
    tags: ["phosphor", "logo"], 
    source: "phosphor", 
    name: "XLogoIcon",
  }, 
  {
    id: "phosphor:XSquareIcon", 
    tags: ["phosphor", "square"], 
    source: "phosphor", 
    name: "XSquareIcon",
  }, 
  {
    id: "phosphor:YarnIcon", 
    tags: ["phosphor", "yarn"], 
    source: "phosphor", 
    name: "YarnIcon",
  }, 
  {
    id: "phosphor:YinYangIcon", 
    tags: ["phosphor", "yin", "yang"], 
    source: "phosphor", 
    name: "YinYangIcon",
  }, 
  {
    id: "phosphor:YoutubeLogoIcon", 
    tags: ["phosphor", "youtube", "logo"], 
    source: "phosphor", 
    name: "YoutubeLogoIcon",
  }, 
  {
    id: "harvey:harveyZeroIcon", 
    icon: "zero", 
    tags: ["harvey", "zero"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyQuarterIcon", 
    icon: "quarter", 
    tags: ["harvey", "quarter"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyHalfIcon", 
    icon: "half", 
    tags: ["harvey", "half"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyThreeQuarterIcon", 
    icon: "threeQuarters", 
    tags: ["harvey", "three", "quarter"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyFullIcon", 
    icon: "full", 
    tags: ["harvey", "full"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyQuarterInvertedIcon", 
    icon: "quarterInverted", 
    tags: ["harvey", "quarter", "inverted"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyHalfInvertedIcon", 
    icon: "halfInverted", 
    tags: ["harvey", "half", "inverted"], 
    type: "harvey",
  }, 
  {
    id: "harvey:harveyThreeQuartersInvertedIcon", 
    icon: "threeQuartersInverted", 
    tags: ["harvey", "three", "quarters", "inverted"], 
    type: "harvey",
  }
]
;